export interface ISpecFields {
  id: number;
  type: string;
  name: string;
  description?: string;
  abbrName?: string;
  added?: string;
  addedEP?: string;
  updated?: string;
  updatedEP?: string;
  deprecated?: string;
  deprecatedEP?: string;
  baseCategory?: string;
  baseCategoryAbbrName?: string;
  unionDataType?: string;
  lengthId?: string;
  discriminatorId?: string;
}
const batch1: ISpecFields[] = [
  {
    abbrName: 'Acct',
    type: 'String',
    added: 'FIX.2.7',
    name: 'Account',
    id: 1,
    description:
      'Account mnemonic as agreed between buy and sell sides, e.g. broker and institution or investor/intermediary and fund manager.',
  },
  {
    abbrName: 'AdvId',
    type: 'String',
    added: 'FIX.2.7',
    name: 'AdvId',
    id: 2,
    description:
      'Unique identifier of advertisement message.\n\n(Prior to FIX 4.1 this field was of type int)',
  },
  {
    abbrName: 'AdvRefID',
    type: 'String',
    added: 'FIX.2.7',
    name: 'AdvRefID',
    id: 3,
    description:
      'Reference identifier used with CANCEL and REPLACE transaction types.\n\n(Prior to FIX 4.1 this field was of type int)',
  },
  {
    abbrName: 'AdvSide',
    type: 'AdvSideCodeSet',
    added: 'FIX.2.7',
    name: 'AdvSide',
    id: 4,
    description: "Broker's side of advertised trade",
  },
  {
    abbrName: 'AdvTransTyp',
    type: 'AdvTransTypeCodeSet',
    added: 'FIX.2.7',
    name: 'AdvTransType',
    id: 5,
    description: 'Identifies advertisement message transaction type',
  },
  {
    abbrName: 'AvgPx',
    type: 'Price',
    added: 'FIX.2.7',
    name: 'AvgPx',
    id: 6,
    description:
      'Calculated average price of all fills on this order.\n\nFor Fixed Income trades AvgPx is always expressed as percent-of-par, regardless of the PriceType (423) of LastPx (31). I.e., AvgPx will contain an average of percent-of-par values (see LastParPx (669)) for issues traded in Yield, Spread or Discount.',
  },
  {
    abbrName: 'BeginSeqNo',
    type: 'SeqNum',
    added: 'FIX.2.7',
    name: 'BeginSeqNo',
    id: 7,
    description: 'Message sequence number of first message in range to be resent',
  },
  {
    updated: 'FIX.Latest',
    type: 'BeginStringCodeSet',
    updatedEP: '270',
    added: 'FIX.2.7',
    name: 'BeginString',
    id: 8,
    abbrName: 'BeginString',
    description:
      'Identifies beginning of new message and session protocol version by means of a session profile identifier (see FIX Session Layer for details). ALWAYS FIRST FIELD IN MESSAGE. (Always unencrypted).',
  },
  {
    abbrName: 'BodyLength',
    type: 'Length',
    added: 'FIX.2.7',
    name: 'BodyLength',
    id: 9,
    description:
      'Message length, in bytes, forward to the CheckSum field. ALWAYS SECOND FIELD IN MESSAGE. (Always unencrypted)',
  },
  {
    abbrName: 'CheckSum',
    type: 'String',
    added: 'FIX.2.7',
    name: 'CheckSum',
    id: 10,
    description:
      'Three byte, simple checksum (see Volume 2: "Checksum Calculation" for description). ALWAYS LAST FIELD IN MESSAGE; i.e. serves, with the trailing <SOH>, as the end-of-message delimiter. Always defined as three characters. (Always unencrypted)',
  },
  {
    updated: 'FIX.Latest',
    type: 'String',
    baseCategoryAbbrName: 'ID',
    baseCategory: 'SingleGeneralOrderHandling',
    updatedEP: '282',
    added: 'FIX.2.7',
    name: 'ClOrdID',
    id: 11,
    abbrName: 'ClOrdID',
    description:
      'Unique identifier for Order as assigned by the buy-side (institution, broker, intermediary etc.) (identified by SenderCompID(49) or OnBehalfOfCompID(115) as appropriate). Uniqueness must be guaranteed within a single trading day. Firms, particularly those which electronically submit multi-day orders, trade globally or throughout market close periods, should ensure uniqueness across days, for example by embedding a date within the ClOrdID(11) field.',
  },
  {
    abbrName: 'Comm',
    type: 'Amt',
    added: 'FIX.2.7',
    name: 'Commission',
    id: 12,
    description:
      'Commission. Note if CommType (13) is percentage, Commission of 5% should be represented as .05.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'CommTypeCodeSet',
    updatedEP: '204',
    added: 'FIX.2.7',
    name: 'CommType',
    id: 13,
    abbrName: 'CommTyp',
    description:
      'Specifies the basis or unit used to calculate the total commission based on the rate.',
  },
  {
    abbrName: 'CumQty',
    type: 'Qty',
    added: 'FIX.2.7',
    name: 'CumQty',
    id: 14,
    description:
      'Total quantity (e.g. number of shares) filled.\n\n(Prior to FIX 4.2 this field was of type int)',
  },
  {
    updated: 'FIX.Latest',
    type: 'Currency',
    updatedEP: '273',
    added: 'FIX.2.7',
    name: 'Currency',
    id: 15,
    abbrName: 'Ccy',
    description:
      'Identifies currency used for price or quantity fields, depending on the asset class being traded. CurrencyCodeSource(2897) may be used to disambiguate the code source scheme used, and ISO 4217 is the default scheme if absent.\n\nAbsence of this field is interpreted as the default currency for the security as defined by the respective reference data. It is recommended that systems provide the currency value whenever possible.\n\nFor securities trading and digital assets traded securities-style, identifies the currency used to denote the price. Absence of this field is interpreted as the default for the security. For Foreign Exchange (FX) and digital assets traded FX-style, identifies the dealt currency used to denominate the quantity related field(s).',
  },
  {
    abbrName: 'EndSeqNo',
    type: 'SeqNum',
    added: 'FIX.2.7',
    name: 'EndSeqNo',
    id: 16,
    description:
      'Message sequence number of last message in range to be resent. If request is for a single message BeginSeqNo (7) = EndSeqNo. If request is for all messages subsequent to a particular message, EndSeqNo = "0" (representing infinity).',
  },
  {
    updated: 'FIX.5.0SP1',
    type: 'String',
    updatedEP: '95',
    added: 'FIX.2.7',
    name: 'ExecID',
    id: 17,
    abbrName: 'ExecID',
    description:
      'Unique identifier of execution message as assigned by sell-side (broker, exchange, ECN) (will be 0 (zero) for ExecType (150)=I (Order Status)).\n\nUniqueness must be guaranteed within a single trading day or the life of a multi-day order. Firms which accept multi-day orders should consider embedding a date within the ExecID field to assure uniqueness across days.\n\n(Prior to FIX 4.1 this field was of type int).',
  },
  {
    abbrName: 'ExecInst',
    type: 'ExecInstCodeSet',
    added: 'FIX.2.7',
    name: 'ExecInst',
    id: 18,
    description:
      'Instructions for order handling on exchange trading floor. If more than one instruction is applicable to an order, this field can contain multiple instructions separated by space. *** SOME VALUES HAVE BEEN REPLACED - See "Replaced Features and Supported Approach" *** (see Volume : "Glossary" for value definitions)',
  },
  {
    abbrName: 'ExecRefID',
    type: 'String',
    added: 'FIX.2.7',
    name: 'ExecRefID',
    id: 19,
    description:
      'Reference identifier used with Trade, Trade Cancel and Trade Correct execution types.\n\n(Prior to FIX 4.1 this field was of type int)',
  },
  {
    abbrName: 'HandlInst',
    type: 'HandlInstCodeSet',
    added: 'FIX.2.7',
    name: 'HandlInst',
    id: 21,
    description: 'Instructions for order handling on Broker trading floor',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'SecurityIDSourceCodeSet',
    unionDataType: 'Reserved100Plus',
    updatedEP: '161',
    added: 'FIX.2.7',
    name: 'SecurityIDSource',
    id: 22,
    abbrName: 'Src',
    description: 'Identifies class or source of the SecurityID(48) value.',
  },
  {
    type: 'String',
    baseCategoryAbbrName: 'ID',
    baseCategory: 'Indication',
    added: 'FIX.2.7',
    name: 'IOIID',
    id: 23,
    abbrName: 'IOIID',
    description:
      'Unique identifier of IOI message.\n\n(Prior to FIX 4.1 this field was of type int)',
  },
  {
    abbrName: 'QltyInd',
    type: 'IOIQltyIndCodeSet',
    added: 'FIX.2.7',
    name: 'IOIQltyInd',
    id: 25,
    description: 'Relative quality of indication',
  },
  {
    abbrName: 'RefID',
    type: 'String',
    added: 'FIX.2.7',
    name: 'IOIRefID',
    id: 26,
    description:
      'Reference identifier used with CANCEL and REPLACE, transaction types.\n\n(Prior to FIX 4.1 this field was of type int)',
  },
  {
    type: 'IOIQtyCodeSet',
    unionDataType: 'Qty',
    added: 'FIX.2.7',
    name: 'IOIQty',
    id: 27,
    abbrName: 'Qty',
    description: 'Quantity (e.g. number of shares) in numeric form or relative size.',
  },
  {
    abbrName: 'TransTyp',
    type: 'IOITransTypeCodeSet',
    added: 'FIX.2.7',
    name: 'IOITransType',
    id: 28,
    description: 'Identifies IOI message transaction type',
  },
  {
    abbrName: 'LastCpcty',
    type: 'LastCapacityCodeSet',
    added: 'FIX.2.7',
    name: 'LastCapacity',
    id: 29,
    description: 'Broker capacity in order execution',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'Exchange',
    updatedEP: '228',
    added: 'FIX.2.7',
    name: 'LastMkt',
    id: 30,
    abbrName: 'LastMkt',
    description:
      'Market of execution for last fill, or an indication of the market where an order was routed\n\nValid values:\n\nSee "Appendix 6-C"\n\nIn the context of ESMA RTS 1 Annex I, Table 3, Field 6 "Venue of Execution" it is required that the "venue where the transaction was executed" be identified using ISO 10383 (MIC). Additionally, ESMA requires the use of "MIC code \'XOFF\' for financial instruments admitted to trading or traded on a trading venue, where the transaction on that financial instrument is not executed on a trading venue, systematic internaliser or organized trading platform outside of the Union. Use \'SINT\' for financial instruments admitted to trading or traded on a trading venue, where the transaction is executed on a systematic internaliser."',
  },
  {
    abbrName: 'LastPx',
    type: 'Price',
    added: 'FIX.2.7',
    name: 'LastPx',
    id: 31,
    description: 'Price of this (last) fill.',
  },
  {
    abbrName: 'LastQty',
    type: 'Qty',
    added: 'FIX.2.7',
    name: 'LastQty',
    id: 32,
    description:
      'Quantity (e.g. shares) bought/sold on this (last) fill.\n\n(Prior to FIX 4.2 this field was of type int)',
  },
  {
    abbrName: 'NoLinesOfText',
    type: 'NumInGroup',
    added: 'FIX.2.7',
    name: 'NoLinesOfText',
    id: 33,
    description: 'Identifies number of lines of text body',
  },
  {
    abbrName: 'SeqNum',
    type: 'SeqNum',
    added: 'FIX.2.7',
    name: 'MsgSeqNum',
    id: 34,
    description: 'Integer message sequence number.',
  },
  {
    abbrName: 'MsgTyp',
    type: 'MsgTypeCodeSet',
    added: 'FIX.2.7',
    name: 'MsgType',
    id: 35,
    description:
      'Defines message type ALWAYS THIRD FIELD IN MESSAGE. (Always unencrypted)\n\nNote: A "U" as the first character in the MsgType field (i.e. U, U2, etc) indicates that the message format is privately defined between the sender and receiver.\n\n*** Note the use of lower case letters ***',
  },
  {
    abbrName: 'NewSeqNo',
    type: 'SeqNum',
    added: 'FIX.2.7',
    name: 'NewSeqNo',
    id: 36,
    description: 'New sequence number',
  },
  {
    abbrName: 'OrdID',
    type: 'String',
    added: 'FIX.2.7',
    name: 'OrderID',
    id: 37,
    description:
      'Unique identifier for Order as assigned by sell-side (broker, exchange, ECN). Uniqueness must be guaranteed within a single trading day. Firms which accept multi-day orders should consider embedding a date within the OrderID field to assure uniqueness across days.',
  },
  {
    abbrName: 'Qty',
    type: 'Qty',
    added: 'FIX.2.7',
    name: 'OrderQty',
    id: 38,
    description:
      'Quantity ordered. This represents the number of shares for equities or par, face or nominal value for FI instruments.\n\n(Prior to FIX 4.2 this field was of type int)',
  },
  {
    type: 'OrdStatusCodeSet',
    baseCategoryAbbrName: 'Stat',
    baseCategory: 'SingleGeneralOrderHandling',
    added: 'FIX.2.7',
    name: 'OrdStatus',
    id: 39,
    abbrName: 'OrdStat',
    description:
      'Identifies current status of order. *** SOME VALUES HAVE BEEN REPLACED - See "Replaced Features and Supported Approach" *** (see Volume : "Glossary" for value definitions)',
  },
  {
    type: 'OrdTypeCodeSet',
    baseCategoryAbbrName: 'Typ',
    baseCategory: 'SingleGeneralOrderHandling',
    added: 'FIX.2.7',
    name: 'OrdType',
    id: 40,
    abbrName: 'OrdTyp',
    description:
      'Order type. *** SOME VALUES ARE NO LONGER USED - See "Deprecated (Phased-out) Features and Supported Approach" *** (see Volume : "Glossary" for value definitions)',
  },
  {
    type: 'String',
    baseCategoryAbbrName: 'OrigID',
    baseCategory: 'SingleGeneralOrderHandling',
    added: 'FIX.2.7',
    name: 'OrigClOrdID',
    id: 41,
    abbrName: 'OrigClOrdID',
    description:
      'ClOrdID (11) of the previous order (NOT the initial order of the day) as assigned by the institution, used to identify the previous order in cancel and cancel/replace requests.',
  },
  {
    abbrName: 'OrigTm',
    type: 'UTCTimestamp',
    added: 'FIX.2.7',
    name: 'OrigTime',
    id: 42,
    description:
      'Time of message origination (always expressed in UTC (Universal Time Coordinated, also known as "GMT"))',
  },
  {
    abbrName: 'PosDup',
    type: 'PossDupFlagCodeSet',
    added: 'FIX.2.7',
    name: 'PossDupFlag',
    id: 43,
    description: 'Indicates possible retransmission of message with this sequence number',
  },
  {
    abbrName: 'Px',
    type: 'Price',
    added: 'FIX.2.7',
    name: 'Price',
    id: 44,
    description: 'Price per unit of quantity (e.g. per share)',
  },
  {
    abbrName: 'RefSeqNum',
    type: 'SeqNum',
    added: 'FIX.2.7',
    name: 'RefSeqNum',
    id: 45,
    description: 'Reference message sequence number',
  },
  {
    abbrName: 'ID',
    type: 'String',
    added: 'FIX.2.7',
    name: 'SecurityID',
    id: 48,
    discriminatorId: '22',
    description:
      'Security identifier value of SecurityIDSource (22) type (e.g. CUSIP, SEDOL, ISIN, etc). Requires SecurityIDSource.',
  },
  {
    abbrName: 'SID',
    type: 'String',
    added: 'FIX.2.7',
    name: 'SenderCompID',
    id: 49,
    description: 'Assigned value used to identify firm sending message.',
  },
  {
    abbrName: 'SSub',
    type: 'String',
    added: 'FIX.2.7',
    name: 'SenderSubID',
    id: 50,
    description:
      'Assigned value used to identify specific message originator (desk, trader, etc.)',
  },
  {
    abbrName: 'Snt',
    type: 'UTCTimestamp',
    added: 'FIX.2.7',
    name: 'SendingTime',
    id: 52,
    description:
      'Time of message transmission (always expressed in UTC (Universal Time Coordinated, also known as "GMT")',
  },
  {
    abbrName: 'Qty',
    type: 'Qty',
    added: 'FIX.2.7',
    name: 'Quantity',
    id: 53,
    description:
      'Overall/total quantity (e.g. number of shares)\n\n(Prior to FIX 4.2 this field was of type int)',
  },
  {
    abbrName: 'Side',
    type: 'SideCodeSet',
    added: 'FIX.2.7',
    name: 'Side',
    id: 54,
    description: 'Side of order (see Volume : "Glossary" for value definitions)',
  },
  {
    abbrName: 'Sym',
    type: 'String',
    added: 'FIX.2.7',
    name: 'Symbol',
    id: 55,
    description:
      'Ticker symbol. Common, "human understood" representation of the security. SecurityID (48) value can be specified if no symbol exists (e.g. non-exchange traded Collective Investment Vehicles)\n\nUse "[N/A]" for products which do not have a symbol.',
  },
  {
    abbrName: 'TID',
    type: 'String',
    added: 'FIX.2.7',
    name: 'TargetCompID',
    id: 56,
    description: 'Assigned value used to identify receiving firm.',
  },
  {
    abbrName: 'TSub',
    type: 'String',
    added: 'FIX.2.7',
    name: 'TargetSubID',
    id: 57,
    description:
      'Assigned value used to identify specific individual or unit intended to receive message. "ADMIN" reserved for administrative messages not intended for a specific user.',
  },
  {
    abbrName: 'Txt',
    type: 'String',
    added: 'FIX.2.7',
    name: 'Text',
    id: 58,
    description:
      'Free format text string\n\n(Note: this field does not have a specified maximum length)',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'TimeInForceCodeSet',
    updatedEP: '253',
    added: 'FIX.2.7',
    name: 'TimeInForce',
    id: 59,
    abbrName: 'TmInForce',
    description:
      'Specifies how long the order remains in effect. Absence of this field is interpreted as DAY. NOTE not applicable to CIV Orders.',
  },
  {
    updated: 'FIX.5.0SP1',
    type: 'UTCTimestamp',
    updatedEP: '94',
    added: 'FIX.2.7',
    name: 'TransactTime',
    id: 60,
    abbrName: 'TxnTm',
    description:
      'Timestamp when the business transaction represented by the message occurred.',
  },
  {
    abbrName: 'Urgency',
    type: 'UrgencyCodeSet',
    added: 'FIX.2.7',
    name: 'Urgency',
    id: 61,
    description: 'Urgency flag',
  },
  {
    abbrName: 'ValidUntilTm',
    type: 'UTCTimestamp',
    added: 'FIX.2.7',
    name: 'ValidUntilTime',
    id: 62,
    description:
      'Indicates expiration time of indication message (always expressed in UTC (Universal Time Coordinated, also known as "GMT")',
  },
  {
    type: 'SettlTypeCodeSet',
    unionDataType: 'Tenor',
    added: 'FIX.2.7',
    name: 'SettlType',
    id: 63,
    abbrName: 'SettlTyp',
    description:
      'Indicates order settlement period. If present, SettlDate (64) overrides this field. If both SettlType (63) and SettDate (64) are omitted, the default for SettlType (63) is 0 (Regular)\n\nRegular is defined as the default settlement period for the particular security on the exchange of execution.\n\nIn Fixed Income the contents of this field may influence the instrument definition if the SecurityID (48) is ambiguous. In the US an active Treasury offering may be re-opened, and for a time one CUSIP will apply to both the current and "when-issued" securities. Supplying a value of "7" clarifies the instrument description; any other value or the absence of this field should cause the respondent to default to the active issue.\n\nAdditionally the following patterns may be uses as well as enum values\n\nDx = FX tenor expression for "days", e.g. "D5", where "x" is any integer > 0\n\nMx = FX tenor expression for "months", e.g. "M3", where "x" is any integer > 0\n\nWx = FX tenor expression for "weeks", e.g. "W13", where "x" is any integer > 0\n\nYx = FX tenor expression for "years", e.g. "Y1", where "x" is any integer > 0\n\nNoted that for FX the tenors expressed using Dx, Mx, Wx, and Yx values do not denote business days, but calendar days.',
  },
  {
    abbrName: 'SettlDt',
    type: 'LocalMktDate',
    added: 'FIX.2.7',
    name: 'SettlDate',
    id: 64,
    description:
      'Specific date of trade settlement (SettlementDate) in YYYYMMDD format.\n\nIf present, this field overrides SettlType (63). This field is required if the value of SettlType (63) is 6 (Future) or 8 (Sellers Option). This field must be omitted if the value of SettlType (63) is 7 (When and If Issued)\n\n(expressed in local time at place of settlement)',
  },
  {
    abbrName: 'Sfx',
    type: 'SymbolSfxCodeSet',
    added: 'FIX.2.7',
    name: 'SymbolSfx',
    id: 65,
    description:
      'Additional information about the security (e.g. preferred, warrants, etc.). Note also see SecurityType (167).\n\nAs defined in the NYSE Stock and bond Symbol Directory and in the AMEX Fitch Directory.',
  },
  {
    type: 'String',
    baseCategoryAbbrName: 'ID',
    baseCategory: 'ProgramTrading',
    added: 'FIX.2.7',
    name: 'ListID',
    id: 66,
    abbrName: 'ListID',
    description:
      'Unique identifier for list as assigned by institution, used to associate multiple individual orders. Uniqueness must be guaranteed within a single trading day. Firms which generate multi-day orders should consider embedding a date within the ListID field to assure uniqueness across days.',
  },
  {
    type: 'int',
    baseCategoryAbbrName: 'SeqNo',
    baseCategory: 'ProgramTrading',
    added: 'FIX.2.7',
    name: 'ListSeqNo',
    id: 67,
    abbrName: 'ListSeqNo',
    description:
      'Sequence of individual order within list (i.e. ListSeqNo of TotNoOrders (68), 2 of 25, 3 of 25, . . . )',
  },
  {
    abbrName: 'TotNoOrds',
    type: 'int',
    added: 'FIX.2.7',
    name: 'TotNoOrders',
    id: 68,
    description:
      'Total number of list order entries across all messages. Should be the sum of all NoOrders (73) in each message that has repeating list order entries related to the same ListID (66). Used to support fragmentation.\n\n(Prior to FIX 4.2 this field was named "ListNoOrds")',
  },
  {
    abbrName: 'ListExecInst',
    type: 'String',
    added: 'FIX.2.7',
    name: 'ListExecInst',
    id: 69,
    description:
      'Free format text message containing list handling and execution instructions.',
  },
  {
    type: 'String',
    baseCategoryAbbrName: 'ID',
    baseCategory: 'Allocation',
    added: 'FIX.2.7',
    name: 'AllocID',
    id: 70,
    abbrName: 'AllocID',
    description:
      'Unique identifier for allocation message.\n\n(Prior to FIX 4.1 this field was of type int)',
  },
  {
    abbrName: 'TransTyp',
    type: 'AllocTransTypeCodeSet',
    added: 'FIX.2.7',
    name: 'AllocTransType',
    id: 71,
    description:
      'Identifies allocation transaction type *** SOME VALUES HAVE BEEN REPLACED - See "Replaced Features and Supported Approach" ***',
  },
  {
    type: 'String',
    baseCategoryAbbrName: 'RefID',
    baseCategory: 'Allocation',
    added: 'FIX.2.7',
    name: 'RefAllocID',
    id: 72,
    abbrName: 'RefAllocID',
    description:
      'Reference identifier to be used with AllocTransType (71) = Replace or Cancel.\n\n(Prior to FIX 4.1 this field was of type int)',
  },
  {
    abbrName: 'NoOrds',
    type: 'NumInGroup',
    added: 'FIX.2.7',
    name: 'NoOrders',
    id: 73,
    description:
      'Indicates number of orders to be combined for average pricing and allocation.',
  },
  {
    abbrName: 'AvgPxPrcsn',
    type: 'int',
    added: 'FIX.2.7',
    name: 'AvgPxPrecision',
    id: 74,
    description:
      'Indicates number of decimal places to be used for average pricing. Absence of this field indicates that default precision arranged by the broker/institution is to be used.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'LocalMktDate',
    updatedEP: '190',
    added: 'FIX.2.7',
    name: 'TradeDate',
    id: 75,
    abbrName: 'TrdDt',
    description:
      'Indicates date of trading day. Absence of this field indicates current day (expressed in local time at place of trade).',
  },
  {
    abbrName: 'PosEfct',
    type: 'PositionEffectCodeSet',
    added: 'FIX.2.7',
    name: 'PositionEffect',
    id: 77,
    description:
      'Indicates whether the resulting position after a trade should be an opening position or closing position. Used for omnibus accounting - where accounts are held on a gross basis instead of being netted together.',
  },
  {
    abbrName: 'NoAllocs',
    type: 'NumInGroup',
    added: 'FIX.2.7',
    name: 'NoAllocs',
    id: 78,
    description: 'Number of repeating AllocAccount (79)/AllocPrice (366) entries.',
  },
  {
    abbrName: 'Acct',
    type: 'String',
    added: 'FIX.2.7',
    name: 'AllocAccount',
    id: 79,
    description: 'Sub-account mnemonic',
  },
  {
    abbrName: 'Qty',
    type: 'Qty',
    added: 'FIX.2.7',
    name: 'AllocQty',
    id: 80,
    description:
      'Quantity to be allocated to specific sub-account\n\n(Prior to FIX 4.2 this field was of type int)',
  },
  {
    abbrName: 'ProcCode',
    type: 'ProcessCodeCodeSet',
    added: 'FIX.2.7',
    name: 'ProcessCode',
    id: 81,
    description:
      'Processing code for sub-account. Absence of this field in AllocAccount (79) / AllocPrice (366) /AllocQty (80) / ProcessCode instance indicates regular trade.',
  },
  {
    abbrName: 'NoRpts',
    type: 'int',
    added: 'FIX.2.7',
    name: 'NoRpts',
    id: 82,
    description: 'Total number of reports within series.',
  },
  {
    abbrName: 'RptSeq',
    type: 'int',
    added: 'FIX.2.7',
    name: 'RptSeq',
    id: 83,
    description:
      'Sequence number of message within report series. Used to carry reporting sequence number of the fill as represented on the Trade Report Side.',
  },
  {
    abbrName: 'CxlQty',
    type: 'Qty',
    added: 'FIX.2.7',
    name: 'CxlQty',
    id: 84,
    description:
      'Total quantity canceled for this order.\n\n(Prior to FIX 4.2 this field was of type int)',
  },
  {
    abbrName: 'NoDlvyInst',
    type: 'NumInGroup',
    added: 'FIX.2.7',
    name: 'NoDlvyInst',
    id: 85,
    description:
      'Number of delivery instruction fields in repeating group.\n\nNote this field was removed in FIX 4.1 and reinstated in FIX 4.4.',
  },
  {
    type: 'AllocStatusCodeSet',
    baseCategoryAbbrName: 'Stat',
    baseCategory: 'Allocation',
    added: 'FIX.2.7',
    name: 'AllocStatus',
    id: 87,
    abbrName: 'Stat',
    description: 'Identifies status of allocation.',
  },
  {
    updated: 'FIX.5.0SP1',
    type: 'AllocRejCodeCodeSet',
    unionDataType: 'Reserved100Plus',
    updatedEP: '95',
    added: 'FIX.2.7',
    name: 'AllocRejCode',
    id: 88,
    abbrName: 'RejCode',
    description: 'Identifies reason for rejection.',
  },
  {
    type: 'data',
    deprecated: 'FIXT.1.1',
    added: 'FIX.2.7',
    name: 'Signature',
    id: 89,
    abbrName: 'Signature',
    lengthId: '93',
    description: 'Electronic signature',
  },
  {
    type: 'Length',
    deprecated: 'FIXT.1.1',
    added: 'FIX.2.7',
    name: 'SecureDataLen',
    id: 90,
    abbrName: 'SecureDataLen',
    description: 'Length of encrypted message',
  },
  {
    type: 'data',
    deprecated: 'FIXT.1.1',
    added: 'FIX.2.7',
    name: 'SecureData',
    id: 91,
    abbrName: 'SecureData',
    lengthId: '90',
    description: 'Actual encrypted data stream',
  },
  {
    type: 'Length',
    deprecated: 'FIXT.1.1',
    added: 'FIX.2.7',
    name: 'SignatureLength',
    id: 93,
    abbrName: 'SignatureLength',
    description: 'Number of bytes in signature field',
  },
  {
    abbrName: 'EmailTyp',
    type: 'EmailTypeCodeSet',
    added: 'FIX.2.7',
    name: 'EmailType',
    id: 94,
    description: 'Email message type.',
  },
  {
    abbrName: 'RawDataLength',
    type: 'Length',
    added: 'FIX.2.7',
    name: 'RawDataLength',
    id: 95,
    description: 'Number of bytes in raw data field.',
  },
  {
    abbrName: 'RawData',
    type: 'data',
    added: 'FIX.2.7',
    name: 'RawData',
    id: 96,
    lengthId: '95',
    description:
      'Unformatted raw data, can include bitmaps, word processor documents, etc.',
  },
  {
    abbrName: 'PosRsnd',
    type: 'PossResendCodeSet',
    added: 'FIX.2.7',
    name: 'PossResend',
    id: 97,
    description:
      'Indicates that message may contain information that has been sent under another sequence number.',
  },
  {
    abbrName: 'EncryptMethod',
    type: 'EncryptMethodCodeSet',
    added: 'FIX.2.7',
    name: 'EncryptMethod',
    id: 98,
    description: 'Method of encryption.',
  },
  {
    abbrName: 'StopPx',
    type: 'Price',
    added: 'FIX.2.7',
    name: 'StopPx',
    id: 99,
    description: 'Price per unit of quantity (e.g. per share)',
  },
  {
    abbrName: 'ExDest',
    type: 'Exchange',
    added: 'FIX.2.7',
    name: 'ExDestination',
    id: 100,
    description:
      'Execution destination as defined by institution when order is entered.\n\nValid values:\n\nSee "Appendix 6-C"',
  },
  {
    type: 'CxlRejReasonCodeSet',
    unionDataType: 'Reserved100Plus',
    added: 'FIX.2.7',
    name: 'CxlRejReason',
    id: 102,
    abbrName: 'CxlRejRsn',
    description: 'Code to identify reason for cancel rejection.',
  },
  {
    type: 'OrdRejReasonCodeSet',
    unionDataType: 'Reserved100Plus',
    added: 'FIX.2.7',
    name: 'OrdRejReason',
    id: 103,
    abbrName: 'RejRsn',
    description:
      'Code to identify reason for order rejection. Note: Values 3, 4, and 5 will be used when rejecting an order due to pre-allocation information errors.',
  },
  {
    abbrName: 'Qual',
    type: 'IOIQualifierCodeSet',
    added: 'FIX.3.0',
    name: 'IOIQualifier',
    id: 104,
    description:
      'Code to qualify IOI use. (see Volume : "Glossary" for value definitions)',
  },
  {
    abbrName: 'Issr',
    type: 'String',
    added: 'FIX.3.0',
    name: 'Issuer',
    id: 106,
    description:
      'Name of security issuer (e.g. International Business Machines, GNMA).\n\nsee also Volume 7: "PRODUCT: FIXED INCOME - Euro Issuer Values"',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    updatedEP: '232',
    added: 'FIX.3.0',
    name: 'SecurityDesc',
    id: 107,
    abbrName: 'Desc',
    description:
      'Can be used by the venue or one of the trading parties to provide a non-normative textual description for the financial instrument.',
  },
  {
    abbrName: 'HeartBtInt',
    type: 'int',
    added: 'FIX.3.0',
    name: 'HeartBtInt',
    id: 108,
    description: 'Heartbeat interval (seconds)',
  },
  {
    abbrName: 'MinQty',
    type: 'Qty',
    added: 'FIX.3.0',
    name: 'MinQty',
    id: 110,
    description:
      'Minimum quantity of an order to be executed.\n\n(Prior to FIX 4.2 this field was of type int)',
  },
  {
    type: 'Qty',
    deprecated: 'FIX.5.0',
    added: 'FIX.3.0',
    name: 'MaxFloor',
    id: 111,
    abbrName: 'MaxFloor',
    description:
      'The quantity to be displayed . Required for reserve orders. On orders specifies the qty to be displayed, on execution reports the currently displayed quantity.',
  },
  {
    abbrName: 'TestReqID',
    type: 'String',
    added: 'FIX.3.0',
    name: 'TestReqID',
    id: 112,
    description:
      'Identifier included in Test Request message to be returned in resulting Heartbeat',
  },
  {
    abbrName: 'RptToExch',
    type: 'ReportToExchCodeSet',
    added: 'FIX.3.0',
    name: 'ReportToExch',
    id: 113,
    description: 'Identifies party of trade responsible for exchange reporting.',
  },
  {
    abbrName: 'LocReqd',
    type: 'LocateReqdCodeSet',
    added: 'FIX.4.0',
    name: 'LocateReqd',
    id: 114,
    description:
      'Indicates whether the broker is to locate the stock in conjunction with a short sell order.',
  },
  {
    abbrName: 'OBID',
    type: 'String',
    added: 'FIX.4.0',
    name: 'OnBehalfOfCompID',
    id: 115,
    description:
      'Assigned value used to identify firm originating message if the message was delivered by a third party i.e. the third party firm identifier would be delivered in the SenderCompID field and the firm originating the message in this field.',
  },
  {
    abbrName: 'OBSub',
    type: 'String',
    added: 'FIX.4.0',
    name: 'OnBehalfOfSubID',
    id: 116,
    description:
      'Assigned value used to identify specific message originator (i.e. trader) if the message was delivered by a third party',
  },
  {
    abbrName: 'QID',
    type: 'String',
    added: 'FIX.4.0',
    name: 'QuoteID',
    id: 117,
    description: 'Unique identifier for quote',
  },
  {
    abbrName: 'NetMny',
    type: 'Amt',
    added: 'FIX.4.0',
    name: 'NetMoney',
    id: 118,
    description:
      'Total amount due as the result of the transaction (e.g. for Buy order - principal + commission + fees) reported in currency of execution.',
  },
  {
    abbrName: 'SettlCurrAmt',
    type: 'Amt',
    added: 'FIX.4.0',
    name: 'SettlCurrAmt',
    id: 119,
    description:
      'Total amount due expressed in settlement currency (includes the effect of the forex transaction)',
  },
  {
    abbrName: 'SettlCcy',
    type: 'Currency',
    added: 'FIX.4.0',
    name: 'SettlCurrency',
    id: 120,
    description: 'Currency code of settlement denomination.',
  },
  {
    abbrName: 'ForexReq',
    type: 'ForexReqCodeSet',
    added: 'FIX.4.0',
    name: 'ForexReq',
    id: 121,
    description:
      'Indicates request for forex accommodation trade to be executed along with security transaction.',
  },
  {
    abbrName: 'OrigSnt',
    type: 'UTCTimestamp',
    added: 'FIX.4.0',
    name: 'OrigSendingTime',
    id: 122,
    description:
      'Original time of message transmission (always expressed in UTC (Universal Time Coordinated, also known as "GMT") when transmitting orders as the result of a resend request.',
  },
  {
    abbrName: 'GapFillFlag',
    type: 'GapFillFlagCodeSet',
    added: 'FIX.4.0',
    name: 'GapFillFlag',
    id: 123,
    description:
      'Indicates that the Sequence Reset message is replacing administrative or application messages which will not be resent.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'NumInGroup',
    updatedEP: '118',
    added: 'FIX.4.0',
    name: 'NoExecs',
    id: 124,
    abbrName: 'NoExecs',
    description: 'Number of executions or trades.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'UTCTimestamp',
    updatedEP: '171',
    added: 'FIX.4.0',
    name: 'ExpireTime',
    id: 126,
    abbrName: 'ExpireTm',
    description:
      'Time/Date of order expiration (always expressed in UTC (Universal Time Coordinated, also known as "GMT")\n\nThe meaning of expiration is specific to the context where the field is used.\n\nFor orders, this is the expiration time of a Good Til Date TimeInForce.\n\nFor Quotes - this is the expiration of the quote.\n\nExpiration time is provided across the quote message dialog to control the length of time of the overall quoting process.\n\nFor collateral requests, this is the time by which collateral must be assigned.\n\nFor collateral assignments, this is the time by which a response to the assignment is expected.\n\nFor credit/risk limit checks, this is the time when the reserved credit limit will expire for the requested transaction.',
  },
  {
    abbrName: 'DkRsn',
    type: 'DKReasonCodeSet',
    added: 'FIX.4.0',
    name: 'DKReason',
    id: 127,
    description: 'Reason for execution rejection.',
  },
  {
    abbrName: 'D2ID',
    type: 'String',
    added: 'FIX.4.0',
    name: 'DeliverToCompID',
    id: 128,
    description:
      'Assigned value used to identify the firm targeted to receive the message if the message is delivered by a third party i.e. the third party firm identifier would be delivered in the TargetCompID (56) field and the ultimate receiver firm ID in this field.',
  },
  {
    abbrName: 'D2Sub',
    type: 'String',
    added: 'FIX.4.0',
    name: 'DeliverToSubID',
    id: 129,
    description:
      'Assigned value used to identify specific message recipient (i.e. trader) if the message is delivered by a third party',
  },
  {
    abbrName: 'NatFlag',
    type: 'IOINaturalFlagCodeSet',
    added: 'FIX.4.0',
    name: 'IOINaturalFlag',
    id: 130,
    description:
      'Indicates that IOI is the result of an existing agency order or a facilitation position resulting from an agency order, not from principal trading or order solicitation activity.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    updatedEP: '143',
    added: 'FIX.4.0',
    name: 'QuoteReqID',
    id: 131,
    abbrName: 'ReqID',
    description: 'Unique identifier for a QuoteRequest(35=R).',
  },
  {
    abbrName: 'BidPx',
    type: 'Price',
    added: 'FIX.4.0',
    name: 'BidPx',
    id: 132,
    description: 'Bid price/rate',
  },
  {
    abbrName: 'OfrPx',
    type: 'Price',
    added: 'FIX.4.0',
    name: 'OfferPx',
    id: 133,
    description: 'Offer price/rate',
  },
  {
    abbrName: 'BidSz',
    type: 'Qty',
    added: 'FIX.4.0',
    name: 'BidSize',
    id: 134,
    description: 'Quantity of bid\n\n(Prior to FIX 4.2 this field was of type int)',
  },
  {
    abbrName: 'OfrSz',
    type: 'Qty',
    added: 'FIX.4.0',
    name: 'OfferSize',
    id: 135,
    description: 'Quantity of offer\n\n(Prior to FIX 4.2 this field was of type int)',
  },
  {
    abbrName: 'NoMiscFees',
    type: 'NumInGroup',
    added: 'FIX.4.0',
    name: 'NoMiscFees',
    id: 136,
    description: 'Number of repeating groups of miscellaneous fees',
  },
  {
    abbrName: 'Amt',
    type: 'Amt',
    added: 'FIX.4.0',
    name: 'MiscFeeAmt',
    id: 137,
    description: 'Miscellaneous fee value',
  },
  {
    abbrName: 'Curr',
    type: 'Currency',
    added: 'FIX.4.0',
    name: 'MiscFeeCurr',
    id: 138,
    description: 'Currency of miscellaneous fee',
  },
  {
    abbrName: 'Typ',
    type: 'MiscFeeTypeCodeSet',
    added: 'FIX.4.0',
    name: 'MiscFeeType',
    id: 139,
    description: 'Indicates type of miscellaneous fee.',
  },
  {
    abbrName: 'PrevClsPx',
    type: 'Price',
    added: 'FIX.4.0',
    name: 'PrevClosePx',
    id: 140,
    description: 'Previous closing price of security.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'ResetSeqNumFlagCodeSet',
    updatedEP: '204',
    added: 'FIX.4.1',
    name: 'ResetSeqNumFlag',
    id: 141,
    abbrName: 'ResetSeqNumFlag',
    description:
      'Indicates that both sides of the FIX session should reset sequence numbers.',
  },
  {
    abbrName: 'SLoc',
    type: 'String',
    added: 'FIX.4.1',
    name: 'SenderLocationID',
    id: 142,
    description:
      "Assigned value used to identify specific message originator's location (i.e. geographic location and/or desk, trader)",
  },
  {
    abbrName: 'TLoc',
    type: 'String',
    added: 'FIX.4.1',
    name: 'TargetLocationID',
    id: 143,
    description:
      "Assigned value used to identify specific message destination's location (i.e. geographic location and/or desk, trader)",
  },
  {
    abbrName: 'OBLoc',
    type: 'String',
    added: 'FIX.4.1',
    name: 'OnBehalfOfLocationID',
    id: 144,
    description:
      "Assigned value used to identify specific message originator's location (i.e. geographic location and/or desk, trader) if the message was delivered by a third party",
  },
  {
    abbrName: 'D2Loc',
    type: 'String',
    added: 'FIX.4.1',
    name: 'DeliverToLocationID',
    id: 145,
    description:
      "Assigned value used to identify specific message recipient's location (i.e. geographic location and/or desk, trader) if the message was delivered by a third party",
  },
  {
    abbrName: 'NoReltdSym',
    type: 'NumInGroup',
    added: 'FIX.4.1',
    name: 'NoRelatedSym',
    id: 146,
    description: 'Specifies the number of repeating symbols specified.',
  },
  {
    abbrName: 'Subject',
    type: 'String',
    added: 'FIX.4.1',
    name: 'Subject',
    id: 147,
    description: 'The subject of an Email message',
  },
  {
    abbrName: 'Headline',
    type: 'String',
    added: 'FIX.4.1',
    name: 'Headline',
    id: 148,
    description: 'The headline of a News message',
  },
  {
    abbrName: 'URL',
    type: 'String',
    added: 'FIX.4.1',
    name: 'URLLink',
    id: 149,
    description:
      'A URI (Uniform Resource Identifier) or URL (Uniform Resource Locator) link to additional information (i.e. http://www.XYZ.com/research.html)\n\nSee "Appendix 6-B FIX Fields Based Upon Other Standards"',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'ExecTypeCodeSet',
    updatedEP: '131',
    added: 'FIX.4.1',
    name: 'ExecType',
    id: 150,
    abbrName: 'ExecTyp',
    description:
      'Describes the specific ExecutionRpt (e.g. Pending Cancel) while OrdStatus(39) will always identify the current order status (e.g. Partially Filled).',
  },
  {
    abbrName: 'LeavesQty',
    type: 'Qty',
    added: 'FIX.4.1',
    name: 'LeavesQty',
    id: 151,
    description:
      'Quantity open for further execution. If the OrdStatus (39) is Canceled, DoneForTheDay, Expired, Calculated, or Rejected (in which case the order is no longer active) then LeavesQty could be 0, otherwise LeavesQty = OrderQty (38) - CumQty (14).\n\n(Prior to FIX 4.2 this field was of type int)',
  },
  {
    abbrName: 'Cash',
    type: 'Qty',
    added: 'FIX.4.1',
    name: 'CashOrderQty',
    id: 152,
    description:
      'Specifies the approximate order quantity desired in total monetary units vs. as tradeable units (e.g. number of shares). The broker or fund manager (for CIV orders) would be responsible for converting and calculating a tradeable unit (e.g. share) quantity (OrderQty (38)) based upon this amount to be used for the actual order and subsequent messages.',
  },
  {
    abbrName: 'AvgPx',
    type: 'Price',
    added: 'FIX.4.1',
    name: 'AllocAvgPx',
    id: 153,
    description:
      'AvgPx (6) for a specific AllocAccount (79)\n\nFor Fixed Income this is always expressed as "percent of par" price type.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Amt',
    updatedEP: '282',
    added: 'FIX.4.1',
    name: 'AllocNetMoney',
    id: 154,
    abbrName: 'NetMny',
    description: 'NetMoney(118) for a specific AllocAccount(79).',
  },
  {
    updated: 'FIX.Latest',
    type: 'float',
    updatedEP: '282',
    added: 'FIX.4.1',
    name: 'SettlCurrFxRate',
    id: 155,
    abbrName: 'SettlCurrFxRt',
    description:
      'Foreign exchange rate used to compute SettlCurrAmt(119) from Currency(15) to SettlCurrency(120).',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'SettlCurrFxRateCalcCodeSet',
    updatedEP: '179',
    added: 'FIX.4.1',
    name: 'SettlCurrFxRateCalc',
    id: 156,
    abbrName: 'SettlCurrFxRtCalc',
    description:
      'Specifies whether or not SettlCurrFxRate (155) should be multiplied or divided.',
  },
  {
    abbrName: 'NumDaysInt',
    type: 'int',
    added: 'FIX.4.1',
    name: 'NumDaysInterest',
    id: 157,
    description:
      'Number of Days of Interest for convertible bonds and fixed income. Note value may be negative.',
  },
  {
    abbrName: 'AcrdIntRt',
    type: 'Percentage',
    added: 'FIX.4.1',
    name: 'AccruedInterestRate',
    id: 158,
    description:
      'The amount the buyer compensates the seller for the portion of the next coupon interest payment the seller has earned but will not receive from the issuer because the issuer will send the next coupon payment to the buyer. Accrued Interest Rate is the annualized Accrued Interest amount divided by the purchase price of the bond.',
  },
  {
    abbrName: 'AcrdIntAmt',
    type: 'Amt',
    added: 'FIX.4.1',
    name: 'AccruedInterestAmt',
    id: 159,
    description: 'Amount of Accrued Interest for convertible bonds and fixed income',
  },
  {
    abbrName: 'SettlInstMode',
    type: 'SettlInstModeCodeSet',
    added: 'FIX.4.1',
    name: 'SettlInstMode',
    id: 160,
    description:
      'Indicates mode used for Settlement Instructions message. *** SOME VALUES HAVE BEEN REPLACED - See "Replaced Features and Supported Approach" ***',
  },
  {
    abbrName: 'Txt',
    type: 'String',
    added: 'FIX.4.1',
    name: 'AllocText',
    id: 161,
    description: 'Free format text related to a specific AllocAccount (79).',
  },
  {
    abbrName: 'SettlInstID',
    type: 'String',
    added: 'FIX.4.1',
    name: 'SettlInstID',
    id: 162,
    description: 'Unique identifier for Settlement Instruction.',
  },
  {
    abbrName: 'SettlInstTransTyp',
    type: 'SettlInstTransTypeCodeSet',
    added: 'FIX.4.1',
    name: 'SettlInstTransType',
    id: 163,
    description: 'Settlement Instructions message transaction type',
  },
  {
    abbrName: 'EmailThreadID',
    type: 'String',
    added: 'FIX.4.1',
    name: 'EmailThreadID',
    id: 164,
    description: 'Unique identifier for an email thread (new and chain of replies)',
  },
  {
    abbrName: 'InstSrc',
    type: 'SettlInstSourceCodeSet',
    added: 'FIX.4.1',
    name: 'SettlInstSource',
    id: 165,
    description: 'Indicates source of Settlement Instructions',
  },
  {
    abbrName: 'SecTyp',
    type: 'SecurityTypeCodeSet',
    added: 'FIX.4.1',
    name: 'SecurityType',
    id: 167,
    description:
      'Indicates type of security. Security type enumerations are grouped by Product(460) field value. NOTE: Additional values may be used by mutual agreement of the counterparties.',
  },
  {
    abbrName: 'EfctvTm',
    type: 'UTCTimestamp',
    added: 'FIX.4.1',
    name: 'EffectiveTime',
    id: 168,
    description:
      'Time the details within the message should take effect (always expressed in UTC (Universal Time Coordinated, also known as "GMT")',
  },
  {
    abbrName: 'StandInstDbTyp',
    type: 'StandInstDbTypeCodeSet',
    added: 'FIX.4.1',
    name: 'StandInstDbType',
    id: 169,
    description: 'Identifies the Standing Instruction database used',
  },
  {
    abbrName: 'StandInstDbName',
    type: 'String',
    added: 'FIX.4.1',
    name: 'StandInstDbName',
    id: 170,
    description:
      "Name of the Standing Instruction database represented with StandInstDbType (169) (i.e. the Global Custodian's name).",
  },
  {
    abbrName: 'StandInstDbID',
    type: 'String',
    added: 'FIX.4.1',
    name: 'StandInstDbID',
    id: 171,
    description:
      'Unique identifier used on the Standing Instructions database for the Standing Instructions to be referenced.',
  },
  {
    abbrName: 'DlvryTyp',
    type: 'SettlDeliveryTypeCodeSet',
    added: 'FIX.4.1',
    name: 'SettlDeliveryType',
    id: 172,
    description: 'Identifies type of settlement',
  },
  {
    abbrName: 'BidSpotRt',
    type: 'Price',
    added: 'FIX.4.1',
    name: 'BidSpotRate',
    id: 188,
    description: 'Bid F/X spot rate.',
  },
  {
    abbrName: 'BidFwdPnts',
    type: 'PriceOffset',
    added: 'FIX.4.1',
    name: 'BidForwardPoints',
    id: 189,
    description: 'Bid F/X forward points added to spot rate. May be a negative value.',
  },
  {
    abbrName: 'OfrSpotRt',
    type: 'Price',
    added: 'FIX.4.1',
    name: 'OfferSpotRate',
    id: 190,
    description: 'Offer F/X spot rate.',
  },
  {
    abbrName: 'OfrFwdPnts',
    type: 'PriceOffset',
    added: 'FIX.4.1',
    name: 'OfferForwardPoints',
    id: 191,
    description: 'Offer F/X forward points added to spot rate. May be a negative value.',
  },
  {
    type: 'Qty',
    deprecated: 'FIX.5.0',
    added: 'FIX.4.1',
    name: 'OrderQty2',
    id: 192,
    abbrName: 'Qty2',
    description: 'OrderQty (38) of the future part of a F/X swap order.',
  },
  {
    type: 'LocalMktDate',
    deprecated: 'FIX.5.0',
    added: 'FIX.4.1',
    name: 'SettlDate2',
    id: 193,
    abbrName: 'SettlDt2',
    description: 'SettDate (64) of the future part of a F/X swap order.',
  },
  {
    abbrName: 'LastSpotRt',
    type: 'Price',
    added: 'FIX.4.1',
    name: 'LastSpotRate',
    id: 194,
    description: 'F/X spot rate.',
  },
  {
    updated: 'FIX.Latest',
    type: 'PriceOffset',
    updatedEP: '282',
    added: 'FIX.4.1',
    name: 'LastForwardPoints',
    id: 195,
    abbrName: 'LastFwdPnts',
    description:
      'F/X forward points added to LastSpotRate(194). May be a negative value. Expressed in decimal form. For example, 61.99 points is expressed and sent as 0.006199.',
  },
  {
    type: 'String',
    baseCategoryAbbrName: 'LinkID',
    baseCategory: 'Allocation',
    added: 'FIX.4.1',
    name: 'AllocLinkID',
    id: 196,
    abbrName: 'LinkID',
    description:
      'Can be used to link two different Allocation messages (each with unique AllocID (70)) together, i.e. for F/X "Netting" or "Swaps". Should be unique.',
  },
  {
    updated: 'FIX.Latest',
    type: 'AllocLinkTypeCodeSet',
    updatedEP: '282',
    added: 'FIX.4.1',
    name: 'AllocLinkType',
    id: 197,
    abbrName: 'LinkTyp',
    description:
      'Identifies the type of Allocation linkage when AllocLinkID(196) is used.',
  },
  {
    abbrName: 'OrdID2',
    type: 'String',
    added: 'FIX.4.1',
    name: 'SecondaryOrderID',
    id: 198,
    description:
      'Assigned by the party which accepts the order. Can be used to provide the OrderID (37) used by an exchange or executing system.',
  },
  {
    abbrName: 'NoIOIQuals',
    type: 'NumInGroup',
    added: 'FIX.4.1',
    name: 'NoIOIQualifiers',
    id: 199,
    description: 'Number of repeating groups of IOIQualifiers (04).',
  },
  {
    updated: 'FIX.Latest',
    type: 'MonthYear',
    updatedEP: '282',
    added: 'FIX.4.1',
    name: 'MaturityMonthYear',
    id: 200,
    abbrName: 'MMY',
    description:
      'Can be used with standardized derivatives vs. the MaturityDate (541) field. Month and Year of the maturity (used for standardized futures and options).\n\nFormat:\n\nYYYYMM (e.g. 199903)\n\nYYYYMMDD (e.g. 20030323)\n\nYYYYMMwN (e.g. 200303w) for week\n\nA specific date or can be appended to the MaturityMonthYear. For instance, if multiple standard products exist that mature in the same Year and Month, but actually mature at a different time, a value can be appended, such as "w" or "w2" to indicate week as opposed to week 2 expiration. Likewise, the date (0-3) can be appended to indicate a specific expiration (maturity date).',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PutOrCallCodeSet',
    updatedEP: '238',
    added: 'FIX.4.1',
    name: 'PutOrCall',
    id: 201,
    abbrName: 'PutCall',
    description:
      'Indicates whether an option contract is a put, call, chooser or undetermined.',
  },
  {
    abbrName: 'StrkPx',
    type: 'Price',
    added: 'FIX.4.1',
    name: 'StrikePrice',
    id: 202,
    description: 'Strike Price for an Option.',
  },
  {
    abbrName: 'Covered',
    type: 'CoveredOrUncoveredCodeSet',
    added: 'FIX.4.1',
    name: 'CoveredOrUncovered',
    id: 203,
    description: 'Used for derivative products, such as options',
  },
  {
    abbrName: 'OptAt',
    type: 'char',
    added: 'FIX.4.1',
    name: 'OptAttribute',
    id: 206,
    description:
      'Provided to support versioning of option contracts as a result of corporate actions or events. Use of this field is defined by counterparty agreement or market conventions.',
  },
  {
    abbrName: 'Exch',
    type: 'Exchange',
    added: 'FIX.4.1',
    name: 'SecurityExchange',
    id: 207,
    description:
      'Market used to help identify a security.\n\nValid values:\n\nSee "Appendix 6-C"',
  },
  {
    abbrName: 'NotifyBrkrOfCredit',
    type: 'NotifyBrokerOfCreditCodeSet',
    added: 'FIX.4.1',
    name: 'NotifyBrokerOfCredit',
    id: 208,
    description:
      'Indicates whether or not details should be communicated to BrokerOfCredit (i.e. step-in broker).',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'AllocHandlInstCodeSet',
    baseCategoryAbbrName: 'HndInst',
    baseCategory: 'SingleGeneralOrderHandling',
    updatedEP: '245',
    added: 'FIX.4.1',
    name: 'AllocHandlInst',
    id: 209,
    abbrName: 'HandlInst',
    description:
      'Indicates how the receiver (i.e. third party) of allocation information should handle/process the account details.',
  },
  {
    type: 'Qty',
    deprecated: 'FIX.5.0',
    added: 'FIX.4.1',
    name: 'MaxShow',
    id: 210,
    abbrName: 'MaxShow',
    description:
      'Maximum quantity (e.g. number of shares) within an order to be shown to other customers (i.e. sent via an IOI).\n\n(Prior to FIX 4.2 this field was of type int)',
  },
  {
    abbrName: 'OfstVal',
    type: 'float',
    added: 'FIX.4.1',
    name: 'PegOffsetValue',
    id: 211,
    description:
      'Amount (signed) added to the peg for a pegged order in the context of the PegOffsetType (836)\n\n(Prior to FIX 4.4 this field was of type PriceOffset)',
  },
  {
    abbrName: 'XmlDataLen',
    type: 'Length',
    added: 'FIX.4.2',
    name: 'XmlDataLen',
    id: 212,
    description: 'Length of the XmlData data block.',
  },
  {
    updated: 'FIX.Latest',
    type: 'XMLData',
    updatedEP: '271',
    added: 'FIX.4.2',
    name: 'XmlData',
    id: 213,
    abbrName: 'XmlData',
    lengthId: '212',
    description:
      'Actual XML data stream (e.g. FIXML). See appropriate XML reference (e.g. FIXML). Note: may contain embedded SOH characters.',
  },
  {
    abbrName: 'SettlInstRefID',
    type: 'String',
    added: 'FIX.4.2',
    name: 'SettlInstRefID',
    id: 214,
    description:
      'Reference identifier for the SettlInstID (162) with Cancel and Replace SettlInstTransType (163) transaction types.',
  },
  {
    abbrName: 'NoRtgIDs',
    type: 'NumInGroup',
    added: 'FIX.4.2',
    name: 'NoRoutingIDs',
    id: 215,
    description:
      'Number of repeating groups of RoutingID (217) and RoutingType (216) values.\n\nSee Volume 3: "Pre-Trade Message Targeting/Routing"',
  },
  {
    abbrName: 'RtgTyp',
    type: 'RoutingTypeCodeSet',
    added: 'FIX.4.2',
    name: 'RoutingType',
    id: 216,
    description: 'Indicates the type of RoutingID (217) specified.',
  },
  {
    abbrName: 'RtgID',
    type: 'String',
    added: 'FIX.4.2',
    name: 'RoutingID',
    id: 217,
    description: 'Assigned value used to identify a specific routing destination.',
  },
  {
    updated: 'FIX.Latest',
    type: 'PriceOffset',
    updatedEP: '282',
    added: 'FIX.4.2',
    name: 'Spread',
    id: 218,
    abbrName: 'Spread',
    description:
      'For Fixed Income. Either Swap Spread or Spread to Benchmark depending upon the order type.\n\nSpread to Benchmark: Basis points relative to a benchmark. To be expressed as count of basis points (vs. an absolute value). E.g. High Grade Corporate Bonds may express price as basis points relative to benchmark (the BenchmarkCurveName(221) field). Note: Basis points can be negative.\n\nSwap Spread: Target spread for a swap.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Currency',
    updatedEP: '273',
    added: 'FIX.4.2',
    name: 'BenchmarkCurveCurrency',
    id: 220,
    abbrName: 'Ccy',
    description:
      'Specifies currency used for benchmark curve.\n\nBenchmarkCurveCurrencyCodeSource(2950) may be used to disambiguate the code source scheme used, and ISO 4217 is the default scheme if absent.',
  },
  {
    abbrName: 'Name',
    type: 'BenchmarkCurveNameCodeSet',
    added: 'FIX.4.2',
    name: 'BenchmarkCurveName',
    id: 221,
    description:
      'Name of benchmark curve.\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    updatedEP: '187',
    added: 'FIX.4.2',
    name: 'BenchmarkCurvePoint',
    id: 222,
    abbrName: 'Point',
    description:
      'Point on benchmark curve. Free form values: e.g. "Y", "7Y", "INTERPOLATED".\n\nSample values:\n\nM = combination of a number between 1-12 and a "M" for month\n\nY = combination of number between 1-100 and a "Y" for year}\n\n10Y-OLD = see above, then add "-OLD" when appropriate\n\nINTERPOLATED = the point is mathematically derived\n\n2/2031 5 3/8 = the point is stated via a combination of maturity month / year and coupon\n\nSee Fixed Income-specific documentation at http://www.fixtradingcommunity.org for additional values.\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)',
  },
  {
    abbrName: 'CpnRt',
    type: 'Percentage',
    added: 'FIX.4.2',
    name: 'CouponRate',
    id: 223,
    description:
      "The rate of interest that, when multiplied by the principal, par value, or face value of a bond, provides the currency amount of the periodic interest payment. The coupon is always cited, along with maturity, in any quotation of a bond's price.",
  },
  {
    abbrName: 'CpnPmt',
    type: 'LocalMktDate',
    added: 'FIX.4.2',
    name: 'CouponPaymentDate',
    id: 224,
    description:
      'Date interest is to be paid. Used in identifying Corporate Bond issues.\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)\n\n(prior to FIX 4.4 field was of type UTCDate)',
  },
  {
    abbrName: 'Issued',
    type: 'LocalMktDate',
    added: 'FIX.4.2',
    name: 'IssueDate',
    id: 225,
    description:
      'The date on which a bond or stock offering is issued. It may or may not be the same as the effective date ("Dated Date") or the date on which interest begins to accrue ("Interest Accrual Date")\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)\n\n(prior to FIX 4.4 field was of type UTCDate)',
  },
  {
    type: 'int',
    deprecated: 'FIX.4.4',
    added: 'FIX.4.2',
    name: 'RepurchaseTerm',
    id: 226,
    abbrName: 'RepoTrm',
    description:
      'Number of business days before repurchase of a repo. (Note tag # was reserved in FIX 4.1, added in FIX 4.3)',
  },
  {
    type: 'Percentage',
    deprecated: 'FIX.4.4',
    added: 'FIX.4.2',
    name: 'RepurchaseRate',
    id: 227,
    abbrName: 'RepoRt',
    description:
      'Percent of par at which a Repo will be repaid. Represented as a percent, e.g. .9525 represents 95-/4 percent of par. (Note tag # was reserved in FIX 4.1, added in FIX 4.3)',
  },
  {
    abbrName: 'Fctr',
    type: 'float',
    added: 'FIX.4.2',
    name: 'Factor',
    id: 228,
    description:
      'For Fixed Income: Amorization Factor for deriving Current face from Original face for ABS or MBS securities, note the fraction may be greater than, equal to or less than . In TIPS securities this is the Inflation index.\n\nQty * Factor * Price = Gross Trade Amount\n\nFor Derivatives: Contract Value Factor by which price must be adjusted to determine the true nominal value of one futures/options contract.\n\n(Qty * Price) * Factor = Nominal Value\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)',
  },
  {
    abbrName: 'OrignDt',
    type: 'LocalMktDate',
    added: 'FIX.4.2',
    name: 'TradeOriginationDate',
    id: 229,
    description:
      'Used with Fixed Income for Muncipal New Issue Market. Agreement in principal between counter-parties prior to actual trade date.\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)\n\n(prior to FIX 4.4 field was of type UTCDate)',
  },
  {
    abbrName: 'ExDt',
    type: 'LocalMktDate',
    added: 'FIX.4.2',
    name: 'ExDate',
    id: 230,
    description:
      'The date when a distribution of interest is deducted from a securities assets or set aside for payment to bondholders. On the ex-date, the securities price drops by the amount of the distribution (plus or minus any market activity).\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)\n\n(prior to FIX 4.4 field was of type UTCDate)',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'float',
    updatedEP: '204',
    added: 'FIX.4.2',
    name: 'ContractMultiplier',
    id: 231,
    abbrName: 'Mult',
    description:
      'Specifies the ratio or multiply factor to convert from "nominal" units (e.g. contracts) to total units (e.g. shares) (e.g. 1.0, 100, 1000, etc). Applicable For Fixed Income, Convertible Bonds, Derivatives, etc.\n\nIn general quantities for all classes should be expressed in the basic unit of the instrument, e.g. shares for equities, nominal or par amount for bonds, currency for foreign exchange. When quantity is expressed in contracts, e.g. financing transactions and bond trade reporting, ContractMultiplier(231) should contain the number of units in one contract and can be omitted if the multiplier is the default amount for the instrument, i.e. 1,000 par of bonds, 1,000,000 par for financing transactions.',
  },
  {
    abbrName: 'NoStips',
    type: 'NumInGroup',
    added: 'FIX.4.2',
    name: 'NoStipulations',
    id: 232,
    description:
      'Number of stipulation entries\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3).',
  },
  {
    abbrName: 'Typ',
    type: 'StipulationTypeCodeSet',
    added: 'FIX.4.2',
    name: 'StipulationType',
    id: 233,
    description:
      'For Fixed Income.\n\nType of Stipulation.\n\nOther types may be used by mutual agreement of the counterparties.\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)',
  },
  {
    abbrName: 'Val',
    type: 'String',
    added: 'FIX.4.2',
    name: 'StipulationValue',
    id: 234,
    description:
      'For Fixed Income. Value of stipulation.\n\nThe expression can be an absolute single value or a combination of values and logical operators:\n\n< value\n\n> value\n\n<= value\n\n>= value\n\nvalue\n\nvalue - value2\n\nvalue OR value2\n\nvalue AND value2\n\nYES\n\nNO\n\nBargain conditions recognized by the London Stock Exchange - to be used when StipulationType is "BGNCON".\n\nCD = Special cum Dividend\n\nXD = Special ex Dividend\n\nCC = Special cum Coupon\n\nXC = Special ex Coupon\n\nCB = Special cum Bonus\n\nXB = Special ex Bonus\n\nCR = Special cum Rights\n\nXR = Special ex Rights\n\nCP = Special cum Capital Repayments\n\nXP = Special ex Capital Repayments\n\nCS = Cash Settlement\n\nSP = Special Price\n\nTR = Report for European Equity Market Securities in accordance with Chapter 8 of the Rules.\n\nGD = Guaranteed Delivery\n\nValues for StipulationType = "PXSOURCE":\n\nBB GENERIC\n\nBB FAIRVALUE\n\nBROKERTEC\n\nESPEED\n\nGOVPX\n\nHILLIARD FARBER\n\nICAP\n\nTRADEWEB\n\nTULLETT LIBERTY\n\nIf a particular side of the market is wanted append /BID /OFFER or /MID.\n\nplus appropriate combinations of the above and other expressions by mutual agreement of the counterparties.\n\nExamples: ">=60", ".25", "ORANGE OR CONTRACOSTA", etc.\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)',
  },
  {
    abbrName: 'Typ',
    type: 'YieldTypeCodeSet',
    added: 'FIX.4.2',
    name: 'YieldType',
    id: 235,
    description: 'Type of yield. (Note tag # was reserved in FIX 4.1, added in FIX 4.3)',
  },
  {
    abbrName: 'Yld',
    type: 'Percentage',
    added: 'FIX.4.2',
    name: 'Yield',
    id: 236,
    description:
      'Yield percentage.\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)',
  },
  {
    abbrName: 'TotTakedown',
    type: 'Amt',
    added: 'FIX.4.2',
    name: 'TotalTakedown',
    id: 237,
    description:
      "The price at which the securities are distributed to the different members of an underwriting group for the primary market in Municipals, total gross underwriter's spread.\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)",
  },
  {
    abbrName: 'Concession',
    type: 'Amt',
    added: 'FIX.4.2',
    name: 'Concession',
    id: 238,
    description:
      'Provides the reduction in price for the secondary market in Muncipals.\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    deprecated: 'FIX.4.4',
    updatedEP: '208',
    added: 'FIX.4.3',
    name: 'RepoCollateralSecurityType',
    id: 239,
    abbrName: 'RepoCollSecTyp',
    description:
      'Identifies the collateral used in the transaction.\n\nValid values: see SecurityType (167) field (Note tag # was reserved in FIX 4.1, added in FIX 4.3)',
  },
  {
    type: 'LocalMktDate',
    deprecated: 'FIX.4.4',
    added: 'FIX.4.2',
    name: 'RedemptionDate',
    id: 240,
    abbrName: 'Redeem',
    description:
      "Return of investor's principal in a security. Bond redemption can occur before maturity date.(Note tag # was reserved in FIX 4.1, added in FIX 4.3) (prior to FIX 4.4 field was of type UTCDate)",
  },
  {
    abbrName: 'CpnPmt',
    type: 'LocalMktDate',
    added: 'FIX.4.2',
    name: 'UnderlyingCouponPaymentDate',
    id: 241,
    description:
      "Underlying security's CouponPaymentDate.\n\nSee CouponPaymentDate (224) field for description\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)\n\n(prior to FIX 4.4 field was of type UTCDate)",
  },
  {
    abbrName: 'Issued',
    type: 'LocalMktDate',
    added: 'FIX.4.2',
    name: 'UnderlyingIssueDate',
    id: 242,
    description:
      "Underlying security's IssueDate.\n\nSee IssueDate (225) field for description\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)\n\n(prior to FIX 4.4 field was of type UTCDate)",
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    deprecated: 'FIX.4.4',
    updatedEP: '208',
    added: 'FIX.4.3',
    name: 'UnderlyingRepoCollateralSecurityType',
    id: 243,
    abbrName: 'RepoCollSecTyp',
    description:
      "Underlying security's RepoCollateralSecurityType. See RepoCollateralSecurityType (239) field for description.(Note tag # was reserved in FIX 4.1, added in FIX 4.3)",
  },
  {
    type: 'int',
    deprecated: 'FIX.4.4',
    added: 'FIX.4.2',
    name: 'UnderlyingRepurchaseTerm',
    id: 244,
    abbrName: 'RepoTrm',
    description:
      "Underlying security's RepurchaseTerm. See RepurchaseTerm (226) field for description (Note tag # was reserved in FIX 4.1, added in FIX 4.3)",
  },
  {
    type: 'Percentage',
    deprecated: 'FIX.4.4',
    added: 'FIX.4.2',
    name: 'UnderlyingRepurchaseRate',
    id: 245,
    abbrName: 'RepoRt',
    description:
      "Underlying security's RepurchaseRate. See RepurchaseRate (227) field for description (Note tag # was reserved in FIX 4.1, added in FIX 4.3)",
  },
  {
    abbrName: 'Fctr',
    type: 'float',
    added: 'FIX.4.2',
    name: 'UnderlyingFactor',
    id: 246,
    description:
      "Underlying security's Factor.\n\nSee Factor (228) field for description\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)",
  },
  {
    type: 'LocalMktDate',
    deprecated: 'FIX.4.4',
    added: 'FIX.4.2',
    name: 'UnderlyingRedemptionDate',
    id: 247,
    abbrName: 'Redeem',
    description:
      "Underlying security's RedemptionDate. See RedemptionDate (240) field for description (Note tag # was reserved in FIX 4.1, added in FIX 4.3) (prior to FIX 4.4 field was of type UTCDate)",
  },
  {
    abbrName: 'CpnPmt',
    type: 'LocalMktDate',
    added: 'FIX.4.2',
    name: 'LegCouponPaymentDate',
    id: 248,
    description:
      "Multileg instrument's individual leg security's CouponPaymentDate.\n\nSee CouponPaymentDate (224) field for description\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)\n\n(prior to FIX 4.4 field was of type UTCDate)",
  },
  {
    abbrName: 'Issued',
    type: 'LocalMktDate',
    added: 'FIX.4.2',
    name: 'LegIssueDate',
    id: 249,
    description:
      "Multileg instrument's individual leg security's IssueDate.\n\nSee IssueDate (225) field for description\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)\n\n(prior to FIX 4.4 field was of type UTCDate)",
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    deprecated: 'FIX.4.4',
    updatedEP: '208',
    added: 'FIX.4.3',
    name: 'LegRepoCollateralSecurityType',
    id: 250,
    abbrName: 'RepoCollSecTyp',
    description:
      "Multileg instrument's individual leg security's RepoCollateralSecurityType. See RepoCollateralSecurityType (239) field for description (Note tag # was reserved in FIX 4.1, added in FIX 4.3)",
  },
  {
    type: 'int',
    deprecated: 'FIX.4.4',
    added: 'FIX.4.2',
    name: 'LegRepurchaseTerm',
    id: 251,
    abbrName: 'RepoTrm',
    description:
      "Multileg instrument's individual leg security's RepurchaseTerm. See RepurchaseTerm (226) field for description (Note tag # was reserved in FIX 4.1, added in FIX 4.3)",
  },
  {
    type: 'Percentage',
    deprecated: 'FIX.4.4',
    added: 'FIX.4.2',
    name: 'LegRepurchaseRate',
    id: 252,
    abbrName: 'RepoRt',
    description:
      "Multileg instrument's individual leg security's RepurchaseRate. See RepurchaseRate (227) field for description (Note tag # was reserved in FIX 4.1, added in FIX 4.3)",
  },
  {
    abbrName: 'Fctr',
    type: 'float',
    added: 'FIX.4.2',
    name: 'LegFactor',
    id: 253,
    description:
      "Multileg instrument's individual leg security's Factor.\n\nSee Factor (228) field for description\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)",
  },
  {
    type: 'LocalMktDate',
    deprecated: 'FIX.4.4',
    added: 'FIX.4.2',
    name: 'LegRedemptionDate',
    id: 254,
    abbrName: 'Redeem',
    description:
      "Multileg instrument's individual leg security's RedemptionDate. See RedemptionDate (240) field for description (Note tag # was reserved in FIX 4.1, added in FIX 4.3) (prior to FIX 4.4 field was of type UTCDate)",
  },
  {
    abbrName: 'CrdRtg',
    type: 'String',
    added: 'FIX.4.2',
    name: 'CreditRating',
    id: 255,
    description:
      "An evaluation of a company's ability to repay obligations or its likelihood of not defaulting. These evaluation are provided by Credit Rating Agencies, i.e. S&P, Moody's.\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)",
  },
  {
    abbrName: 'CrdRtg',
    type: 'String',
    added: 'FIX.4.2',
    name: 'UnderlyingCreditRating',
    id: 256,
    description:
      "Underlying security's CreditRating.\n\nSee CreditRating (255) field for description\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)",
  },
  {
    abbrName: 'CrdRtg',
    type: 'String',
    added: 'FIX.4.2',
    name: 'LegCreditRating',
    id: 257,
    description:
      "Multileg instrument's individual leg security's CreditRating.\n\nSee CreditRating (255) field for description\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)",
  },
  {
    abbrName: 'TrddFlatSwitch',
    type: 'TradedFlatSwitchCodeSet',
    added: 'FIX.4.2',
    name: 'TradedFlatSwitch',
    id: 258,
    description:
      'Driver and part of trade in the event that the Security Master file was wrong at the point of entry(Note tag # was reserved in FIX 4.1, added in FIX 4.3)',
  },
  {
    abbrName: 'BasisFeatureDt',
    type: 'LocalMktDate',
    added: 'FIX.4.2',
    name: 'BasisFeatureDate',
    id: 259,
    description:
      'BasisFeatureDate allows requesting firms within fixed income the ability to request an alternative yield-to-worst, -maturity, -extended or other call. This flows through the confirm process.\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)\n\n(prior to FIX 4.4 field was of type UTCDate)',
  },
  {
    abbrName: 'BasisFeaturePx',
    type: 'Price',
    added: 'FIX.4.2',
    name: 'BasisFeaturePrice',
    id: 260,
    description:
      'Price for BasisFeatureDate.\n\nSee BasisFeatureDate (259)\n\n(Note tag # was reserved in FIX 4.1, added in FIX 4.3)',
  },
  {
    abbrName: 'ReqID',
    type: 'String',
    added: 'FIX.4.2',
    name: 'MDReqID',
    id: 262,
    description: 'Unique identifier for Market Data Request',
  },
  {
    abbrName: 'SubReqTyp',
    type: 'SubscriptionRequestTypeCodeSet',
    added: 'FIX.4.2',
    name: 'SubscriptionRequestType',
    id: 263,
    description: 'Subscription Request Type',
  },
  {
    abbrName: 'MktDepth',
    type: 'int',
    added: 'FIX.4.2',
    name: 'MarketDepth',
    id: 264,
    description:
      'Depth of market for Book Snapshot / Incremental updates\n\n0 - full book depth\n\n1 - top of book\n\n2 and above - book depth (number of levels)',
  },
  {
    abbrName: 'UpdtTyp',
    type: 'MDUpdateTypeCodeSet',
    added: 'FIX.4.2',
    name: 'MDUpdateType',
    id: 265,
    description: 'Specifies the type of Market Data update.',
  },
  {
    abbrName: 'AggBook',
    type: 'AggregatedBookCodeSet',
    added: 'FIX.4.2',
    name: 'AggregatedBook',
    id: 266,
    description:
      'Specifies whether or not book entries should be aggregated. (Not specified) = broker option',
  },
  {
    abbrName: 'NoMDEntryTyps',
    type: 'NumInGroup',
    added: 'FIX.4.2',
    name: 'NoMDEntryTypes',
    id: 267,
    description: 'Number of MDEntryType (269) fields requested.',
  },
  {
    abbrName: 'NoMDEntries',
    type: 'NumInGroup',
    added: 'FIX.4.2',
    name: 'NoMDEntries',
    id: 268,
    description: 'Number of entries in Market Data message.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'MDEntryTypeCodeSet',
    updatedEP: '174',
    added: 'FIX.4.2',
    name: 'MDEntryType',
    id: 269,
    abbrName: 'Typ',
    description: 'Type of market data entry.',
  },
  {
    abbrName: 'Px',
    type: 'Price',
    added: 'FIX.4.2',
    name: 'MDEntryPx',
    id: 270,
    description: 'Price of the Market Data Entry.',
  },
  {
    abbrName: 'Sz',
    type: 'Qty',
    added: 'FIX.4.2',
    name: 'MDEntrySize',
    id: 271,
    description: 'Quantity or volume represented by the Market Data Entry.',
  },
  {
    abbrName: 'Dt',
    type: 'UTCDateOnly',
    added: 'FIX.4.2',
    name: 'MDEntryDate',
    id: 272,
    description:
      'Date of Market Data Entry.\n\n(prior to FIX 4.4 field was of type UTCDate)',
  },
  {
    abbrName: 'Tm',
    type: 'UTCTimeOnly',
    added: 'FIX.4.2',
    name: 'MDEntryTime',
    id: 273,
    description: 'Time of Market Data Entry.',
  },
  {
    abbrName: 'TickDirctn',
    type: 'TickDirectionCodeSet',
    added: 'FIX.4.2',
    name: 'TickDirection',
    id: 274,
    description: 'Direction of the "tick".',
  },
  {
    type: 'Exchange',
    deprecated: 'FIX.5.0',
    added: 'FIX.4.2',
    name: 'MDMkt',
    id: 275,
    abbrName: 'Mkt',
    description: 'Market posting quote / trade.\n\nValid values:\n\nSee "Appendix 6-C"',
  },
  {
    abbrName: 'QCond',
    type: 'QuoteConditionCodeSet',
    added: 'FIX.4.2',
    name: 'QuoteCondition',
    id: 276,
    description: 'Space-delimited list of conditions describing a quote.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'TradeConditionCodeSet',
    updatedEP: '190',
    added: 'FIX.4.2',
    name: 'TradeCondition',
    id: 277,
    abbrName: 'TrdCond',
    description: 'Type of market data entry.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    baseCategoryAbbrName: 'ID',
    baseCategory: 'MarketData',
    updatedEP: '125',
    added: 'FIX.4.2',
    name: 'MDEntryID',
    id: 278,
    abbrName: 'MDID',
    description: 'Unique Market Data Entry identifier.',
  },
  {
    abbrName: 'UpdtAct',
    type: 'MDUpdateActionCodeSet',
    added: 'FIX.4.2',
    name: 'MDUpdateAction',
    id: 279,
    description: 'Type of Market Data update action.',
  },
  {
    abbrName: 'RefID',
    type: 'String',
    added: 'FIX.4.2',
    name: 'MDEntryRefID',
    id: 280,
    description: 'Refers to a previous MDEntryID (278).',
  },
  {
    abbrName: 'ReqRejResn',
    type: 'MDReqRejReasonCodeSet',
    added: 'FIX.4.2',
    name: 'MDReqRejReason',
    id: 281,
    description: 'Reason for the rejection of a Market Data request.',
  },
  {
    type: 'String',
    deprecated: 'FIX.5.0',
    added: 'FIX.4.2',
    name: 'MDEntryOriginator',
    id: 282,
    abbrName: 'Orig',
    description: 'Originator of a Market Data Entry',
  },
  {
    abbrName: 'LctnID',
    type: 'String',
    added: 'FIX.4.2',
    name: 'LocationID',
    id: 283,
    description: "Identification of a Market Maker's location",
  },
  {
    abbrName: 'DeskID',
    type: 'String',
    added: 'FIX.4.2',
    name: 'DeskID',
    id: 284,
    description: "Identification of a Market Maker's desk",
  },
  {
    abbrName: 'DelRsn',
    type: 'DeleteReasonCodeSet',
    added: 'FIX.4.2',
    name: 'DeleteReason',
    id: 285,
    description: 'Reason for deletion.',
  },
  {
    abbrName: 'OpenClsSettlFlag',
    type: 'OpenCloseSettlFlagCodeSet',
    added: 'FIX.4.2',
    name: 'OpenCloseSettlFlag',
    id: 286,
    description:
      'Flag that identifies a market data entry. (Prior to FIX 4.3 this field was of type char)',
  },
  {
    abbrName: 'SellerDays',
    type: 'int',
    added: 'FIX.4.2',
    name: 'SellerDays',
    id: 287,
    description:
      'Specifies the number of days that may elapse before delivery of the security',
  },
  {
    abbrName: 'Buyer',
    type: 'String',
    added: 'FIX.4.2',
    name: 'MDEntryBuyer',
    id: 288,
    description: 'Buying party in a trade',
  },
  {
    abbrName: 'Seller',
    type: 'String',
    added: 'FIX.4.2',
    name: 'MDEntrySeller',
    id: 289,
    description: 'Selling party in a trade',
  },
  {
    updated: 'FIX.Latest',
    type: 'int',
    updatedEP: '271',
    added: 'FIX.4.2',
    name: 'MDEntryPositionNo',
    id: 290,
    abbrName: 'PosNo',
    description:
      'Display position of a bid or offer, numbered from most competitive to least competitive, per market side, beginning with 1.',
  },
  {
    abbrName: 'FinclStat',
    type: 'FinancialStatusCodeSet',
    added: 'FIX.4.2',
    name: 'FinancialStatus',
    id: 291,
    description: "Identifies a firm's or a security's financial status",
  },
  {
    abbrName: 'CorpActn',
    type: 'CorporateActionCodeSet',
    added: 'FIX.4.2',
    name: 'CorporateAction',
    id: 292,
    description: 'Identifies the type of Corporate Action.',
  },
  {
    abbrName: 'DefBidSz',
    type: 'Qty',
    added: 'FIX.4.2',
    name: 'DefBidSize',
    id: 293,
    description: 'Default Bid Size.',
  },
  {
    abbrName: 'DefOfrSz',
    type: 'Qty',
    added: 'FIX.4.2',
    name: 'DefOfferSize',
    id: 294,
    description: 'Default Offer Size.',
  },
  {
    abbrName: 'NoQuotEntries',
    type: 'NumInGroup',
    added: 'FIX.4.2',
    name: 'NoQuoteEntries',
    id: 295,
    description: 'The number of quote entries for a QuoteSet.',
  },
  {
    abbrName: 'NoQuotSets',
    type: 'NumInGroup',
    added: 'FIX.4.2',
    name: 'NoQuoteSets',
    id: 296,
    description: 'The number of sets of quotes in the message.',
  },
  {
    abbrName: 'Stat',
    type: 'QuoteStatusCodeSet',
    added: 'FIX.4.2',
    name: 'QuoteStatus',
    id: 297,
    description: 'Identifies the status of the quote acknowledgement.',
  },
  {
    updated: 'FIX.5.0SP1',
    type: 'QuoteCancelTypeCodeSet',
    unionDataType: 'Reserved100Plus',
    updatedEP: '85',
    added: 'FIX.4.2',
    name: 'QuoteCancelType',
    id: 298,
    abbrName: 'CxlTyp',
    description: 'Identifies the type of quote cancel.',
  },
  {
    abbrName: 'EntryID',
    type: 'String',
    added: 'FIX.4.2',
    name: 'QuoteEntryID',
    id: 299,
    description:
      'Unique identifier for a quote. The QuoteEntryID stays with the quote as a static identifier even if the quote is updated.',
  },
  {
    type: 'QuoteRejectReasonCodeSet',
    unionDataType: 'Reserved100Plus',
    added: 'FIX.4.2',
    name: 'QuoteRejectReason',
    id: 300,
    abbrName: 'RejRsn',
    description: 'Reason Quote was rejected:',
  },
  {
    abbrName: 'RspLvl',
    type: 'QuoteResponseLevelCodeSet',
    added: 'FIX.4.2',
    name: 'QuoteResponseLevel',
    id: 301,
    description:
      'Level of Response requested from receiver of quote messages. A default value should be bilaterally agreed.',
  },
  {
    abbrName: 'SetID',
    type: 'String',
    added: 'FIX.4.2',
    name: 'QuoteSetID',
    id: 302,
    description: 'Unique id for the Quote Set.',
  },
  {
    abbrName: 'ReqTyp',
    type: 'QuoteRequestTypeCodeSet',
    added: 'FIX.4.2',
    name: 'QuoteRequestType',
    id: 303,
    description: 'Indicates the type of Quote Request being generated',
  },
  {
    updated: 'FIX.5.0SP1',
    type: 'int',
    updatedEP: '95',
    added: 'FIX.4.2',
    name: 'TotNoQuoteEntries',
    id: 304,
    abbrName: 'TotNoQuotEntries',
    description: 'Total number of quotes for the quote set.',
  },
  {
    updated: 'FIX.Latest',
    type: 'SecurityIDSourceCodeSet',
    unionDataType: 'Reserved100Plus',
    updatedEP: '271',
    added: 'FIX.4.2',
    name: 'UnderlyingSecurityIDSource',
    id: 305,
    abbrName: 'Src',
    description: 'Identifies class or source of the UnderlyingSecurityID(309) value.',
  },
  {
    updated: 'FIX.Latest',
    type: 'String',
    updatedEP: '282',
    added: 'FIX.4.2',
    name: 'UnderlyingIssuer',
    id: 306,
    abbrName: 'Issr',
    description:
      "Underlying security's Issuer.\n\nSee Issuer(106) field for description.",
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    updatedEP: '232',
    added: 'FIX.4.2',
    name: 'UnderlyingSecurityDesc',
    id: 307,
    abbrName: 'Desc',
    description:
      'Description of the underlying security.\n\nCan be used by the venue or one of the trading parties to provide an optional non-normative textual description of the financial instrument.',
  },
  {
    abbrName: 'Exch',
    type: 'Exchange',
    added: 'FIX.4.2',
    name: 'UnderlyingSecurityExchange',
    id: 308,
    description:
      "Underlying security's SecurityExchange. Can be used to identify the underlying security.\n\nValid values: see SecurityExchange (207)",
  },
  {
    abbrName: 'ID',
    type: 'String',
    added: 'FIX.4.2',
    name: 'UnderlyingSecurityID',
    id: 309,
    discriminatorId: '305',
    description:
      "Underlying security's SecurityID.\n\nSee SecurityID (48) field for description",
  },
  {
    abbrName: 'SecTyp',
    type: 'SecurityTypeCodeSet',
    added: 'FIX.4.2',
    name: 'UnderlyingSecurityType',
    id: 310,
    description:
      "Underlying security's SecurityType.\n\nValid values: see SecurityType (167) field\n\n(see below for details concerning this fields use in conjunction with SecurityType=REPO)\n\nThe following applies when used in conjunction with SecurityType=REPO\n\nRepresents the general or specific type of security that underlies a financing agreement\n\nValid values for SecurityType=REPO:\n\nIf bonds of a particular issuer or country are wanted in an Order or are in the basket of an Execution and the SecurityType is not granular enough, include the UnderlyingIssuer (306), UnderlyingCountryOfIssue (592), UnderlyingProgram, UnderlyingRegType and/or < UnderlyingStipulations > block e.g.:",
  },
  {
    abbrName: 'Sym',
    type: 'String',
    added: 'FIX.4.2',
    name: 'UnderlyingSymbol',
    id: 311,
    description: "Underlying security's Symbol.\n\nSee Symbol (55) field for description",
  },
  {
    abbrName: 'Sfx',
    type: 'SymbolSfxCodeSet',
    added: 'FIX.4.2',
    name: 'UnderlyingSymbolSfx',
    id: 312,
    description:
      "Underlying security's SymbolSfx.\n\nSee SymbolSfx (65) field for description",
  },
  {
    abbrName: 'MMY',
    type: 'MonthYear',
    added: 'FIX.4.2',
    name: 'UnderlyingMaturityMonthYear',
    id: 313,
    description:
      "Underlying security's MaturityMonthYear. Can be used with standardized derivatives vs. the UnderlyingMaturityDate (542) field.\n\nSee MaturityMonthYear (200) field for description",
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PutOrCallCodeSet',
    updatedEP: '238',
    added: 'FIX.4.2',
    name: 'UnderlyingPutOrCall',
    id: 315,
    abbrName: 'PutCall',
    description:
      'Indicates whether an underlying option contract is a put, call, chooser or undetermined.',
  },
  {
    abbrName: 'StrkPx',
    type: 'Price',
    added: 'FIX.4.2',
    name: 'UnderlyingStrikePrice',
    id: 316,
    description:
      "Underlying security's StrikePrice.\n\nSee StrikePrice (202) field for description",
  },
  {
    abbrName: 'OptA',
    type: 'char',
    added: 'FIX.4.2',
    name: 'UnderlyingOptAttribute',
    id: 317,
    description:
      "Underlying security's OptAttribute.\n\nSee OptAttribute (206) field for description",
  },
  {
    updated: 'FIX.Latest',
    type: 'Currency',
    updatedEP: '273',
    added: 'FIX.4.2',
    name: 'UnderlyingCurrency',
    id: 318,
    abbrName: 'Ccy',
    description: "Underlying security's currency.",
  },
  {
    abbrName: 'ReqID',
    type: 'String',
    added: 'FIX.4.2',
    name: 'SecurityReqID',
    id: 320,
    description: 'Unique ID of a Security Definition Request.',
  },
  {
    abbrName: 'ReqTyp',
    type: 'SecurityRequestTypeCodeSet',
    added: 'FIX.4.2',
    name: 'SecurityRequestType',
    id: 321,
    description: 'Type of Security Definition Request.',
  },
  {
    abbrName: 'RspID',
    type: 'String',
    added: 'FIX.4.2',
    name: 'SecurityResponseID',
    id: 322,
    description: 'Unique ID of a Security Definition message.',
  },
  {
    abbrName: 'RspTyp',
    type: 'SecurityResponseTypeCodeSet',
    added: 'FIX.4.2',
    name: 'SecurityResponseType',
    id: 323,
    description: 'Type of Security Definition message response.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    updatedEP: '106',
    added: 'FIX.4.2',
    name: 'SecurityStatusReqID',
    id: 324,
    abbrName: 'StatReqID',
    description:
      'Unique ID of a Security Status Request or a Security Mass Status Request message.',
  },
  {
    abbrName: 'Unsol',
    type: 'UnsolicitedIndicatorCodeSet',
    added: 'FIX.4.2',
    name: 'UnsolicitedIndicator',
    id: 325,
    description:
      'Indicates whether or not message is being sent as a result of a subscription request or not.',
  },
  {
    type: 'SecurityTradingStatusCodeSet',
    unionDataType: 'Reserved100Plus',
    added: 'FIX.4.2',
    name: 'SecurityTradingStatus',
    id: 326,
    abbrName: 'TrdgStat',
    description: 'Identifies the trading status applicable to the transaction.',
  },
  {
    updated: 'FIX.5.0SP1',
    type: 'HaltReasonCodeSet',
    unionDataType: 'Reserved100Plus',
    updatedEP: '86',
    added: 'FIX.4.2',
    name: 'HaltReason',
    id: 327,
    abbrName: 'HaltRsn',
    description: 'Denotes the reason for the Opening Delay or Trading Halt.',
  },
  {
    abbrName: 'InViewOfCmn',
    type: 'InViewOfCommonCodeSet',
    added: 'FIX.4.2',
    name: 'InViewOfCommon',
    id: 328,
    description:
      'Indicates whether or not the halt was due to Common Stock trading being halted.',
  },
  {
    abbrName: 'DueToReltd',
    type: 'DueToRelatedCodeSet',
    added: 'FIX.4.2',
    name: 'DueToRelated',
    id: 329,
    description:
      'Indicates whether or not the halt was due to the Related Security being halted.',
  },
  {
    abbrName: 'BuyVol',
    type: 'Qty',
    added: 'FIX.4.2',
    name: 'BuyVolume',
    id: 330,
    description: 'Quantity bought.',
  },
  {
    abbrName: 'SellVol',
    type: 'Qty',
    added: 'FIX.4.2',
    name: 'SellVolume',
    id: 331,
    description: 'Quantity sold.',
  },
  {
    abbrName: 'HighPx',
    type: 'Price',
    added: 'FIX.4.2',
    name: 'HighPx',
    id: 332,
    description:
      'Represents an indication of the high end of the price range for a security prior to the open or reopen',
  },
  {
    abbrName: 'LowPx',
    type: 'Price',
    added: 'FIX.4.2',
    name: 'LowPx',
    id: 333,
    description:
      'Represents an indication of the low end of the price range for a security prior to the open or reopen',
  },
  {
    abbrName: 'Adjmt',
    type: 'AdjustmentCodeSet',
    added: 'FIX.4.2',
    name: 'Adjustment',
    id: 334,
    description: 'Identifies the type of adjustment.',
  },
  {
    abbrName: 'ReqID',
    type: 'String',
    added: 'FIX.4.2',
    name: 'TradSesReqID',
    id: 335,
    description: 'Unique ID of a Trading Session Status message.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'TradingSessionIDCodeSet',
    unionDataType: 'Reserved100Plus',
    updatedEP: '190',
    added: 'FIX.4.2',
    name: 'TradingSessionID',
    id: 336,
    abbrName: 'SesID',
    description:
      'Identifier for a trading session.\n\nA trading session spans an extended period of time that can also be expressed informally in terms of the trading day. Usage is determined by market or counterparties.\n\nTo specify good for session where session spans more than one calendar day, use TimeInForce = 0 (Day) in conjunction with TradingSessionID(336).\n\nBilaterally agreed values of data type "String" that start with a character can be used for backward compatibility.',
  },
  {
    type: 'String',
    baseCategoryAbbrName: 'Trdr',
    baseCategory: 'SingleGeneralOrderHandling',
    added: 'FIX.4.2',
    name: 'ContraTrader',
    id: 337,
    abbrName: 'CntraTrdr',
    description: 'Identifies the trader (e.g. "badge number") of the ContraBroker.',
  },
  {
    abbrName: 'Method',
    type: 'TradSesMethodCodeSet',
    added: 'FIX.4.2',
    name: 'TradSesMethod',
    id: 338,
    description: 'Method of trading',
  },
  {
    abbrName: 'Mode',
    type: 'TradSesModeCodeSet',
    added: 'FIX.4.2',
    name: 'TradSesMode',
    id: 339,
    description: 'Trading Session Mode',
  },
  {
    type: 'TradSesStatusCodeSet',
    unionDataType: 'Reserved100Plus',
    added: 'FIX.4.2',
    name: 'TradSesStatus',
    id: 340,
    abbrName: 'Stat',
    description: 'State of the trading session.',
  },
  {
    abbrName: 'StartTm',
    type: 'UTCTimestamp',
    added: 'FIX.4.2',
    name: 'TradSesStartTime',
    id: 341,
    description: 'Starting time of the trading session',
  },
  {
    abbrName: 'OpenTm',
    type: 'UTCTimestamp',
    added: 'FIX.4.2',
    name: 'TradSesOpenTime',
    id: 342,
    description: 'Time of the opening of the trading session',
  },
  {
    abbrName: 'PreClsTm',
    type: 'UTCTimestamp',
    added: 'FIX.4.2',
    name: 'TradSesPreCloseTime',
    id: 343,
    description: 'Time of the pre-closed of the trading session',
  },
  {
    abbrName: 'ClsTm',
    type: 'UTCTimestamp',
    added: 'FIX.4.2',
    name: 'TradSesCloseTime',
    id: 344,
    description: 'Closing time of the trading session',
  },
  {
    abbrName: 'EndTm',
    type: 'UTCTimestamp',
    added: 'FIX.4.2',
    name: 'TradSesEndTime',
    id: 345,
    description: 'End time of the trading session',
  },
  {
    abbrName: 'NumOfOrds',
    type: 'int',
    added: 'FIX.4.2',
    name: 'NumberOfOrders',
    id: 346,
    description: 'Number of orders in the market.',
  },
  {
    abbrName: 'MsgEncd',
    type: 'String',
    added: 'FIX.4.2',
    name: 'MessageEncoding',
    id: 347,
    description:
      'Type of message encoding (non-ASCII (non-English) characters) used in a message\'s "Encoded" fields.',
  },
  {
    abbrName: 'EncIssrLen',
    type: 'Length',
    added: 'FIX.4.2',
    name: 'EncodedIssuerLen',
    id: 348,
    description:
      'Byte length of encoded (non-ASCII characters) EncodedIssuer (349) field.',
  },
  {
    abbrName: 'EncIssr',
    type: 'data',
    added: 'FIX.4.2',
    name: 'EncodedIssuer',
    id: 349,
    lengthId: '348',
    description:
      'Encoded (non-ASCII characters) representation of the Issuer field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the Issuer field.',
  },
  {
    abbrName: 'EncSecDescLen',
    type: 'Length',
    added: 'FIX.4.2',
    name: 'EncodedSecurityDescLen',
    id: 350,
    description:
      'Byte length of encoded (non-ASCII characters) EncodedSecurityDesc (351) field.',
  },
  {
    abbrName: 'EncSecDesc',
    type: 'data',
    added: 'FIX.4.2',
    name: 'EncodedSecurityDesc',
    id: 351,
    lengthId: '350',
    description:
      'Encoded (non-ASCII characters) representation of the SecurityDesc (107) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the SecurityDesc field.',
  },
  {
    abbrName: 'EncListExecInstLen',
    type: 'Length',
    added: 'FIX.4.2',
    name: 'EncodedListExecInstLen',
    id: 352,
    description:
      'Byte length of encoded (non-ASCII characters) EncodedListExecInst (353) field.',
  },
  {
    abbrName: 'EncListExecInst',
    type: 'data',
    added: 'FIX.4.2',
    name: 'EncodedListExecInst',
    id: 353,
    lengthId: '352',
    description:
      'Encoded (non-ASCII characters) representation of the ListExecInst (69) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the ListExecInst field.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'Length',
    updatedEP: '192',
    added: 'FIX.4.2',
    name: 'EncodedTextLen',
    id: 354,
    abbrName: 'EncTxtLen',
    description: 'Byte length of encoded (non-ASCII characters) EncodedText (355) field.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'data',
    updatedEP: '192',
    added: 'FIX.4.2',
    name: 'EncodedText',
    id: 355,
    abbrName: 'EncTxt',
    lengthId: '354',
    description:
      'Encoded (non-ASCII characters) representation of the Text (58) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the Text(58) field.',
  },
  {
    abbrName: 'EncSubjectLen',
    type: 'Length',
    added: 'FIX.4.2',
    name: 'EncodedSubjectLen',
    id: 356,
    description:
      'Byte length of encoded (non-ASCII characters) EncodedSubject (357) field.',
  },
  {
    abbrName: 'EncSubject',
    type: 'data',
    added: 'FIX.4.2',
    name: 'EncodedSubject',
    id: 357,
    lengthId: '356',
    description:
      'Encoded (non-ASCII characters) representation of the Subject (147) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the Subject field.',
  },
  {
    abbrName: 'EncHeadlineLen',
    type: 'Length',
    added: 'FIX.4.2',
    name: 'EncodedHeadlineLen',
    id: 358,
    description:
      'Byte length of encoded (non-ASCII characters) EncodedHeadline (359) field.',
  },
  {
    abbrName: 'EncHeadline',
    type: 'data',
    added: 'FIX.4.2',
    name: 'EncodedHeadline',
    id: 359,
    lengthId: '358',
    description:
      'Encoded (non-ASCII characters) representation of the Headline (148) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the Headline field.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'Length',
    updatedEP: '192',
    added: 'FIX.4.2',
    name: 'EncodedAllocTextLen',
    id: 360,
    abbrName: 'EncAllocTextLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedAllocText (361) field.',
  },
  {
    abbrName: 'EncAllocText',
    type: 'data',
    added: 'FIX.4.2',
    name: 'EncodedAllocText',
    id: 361,
    lengthId: '360',
    description:
      'Encoded (non-ASCII characters) representation of the AllocText (161) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the AllocText field.',
  },
  {
    abbrName: 'EncUndIssrLen',
    type: 'Length',
    added: 'FIX.4.2',
    name: 'EncodedUnderlyingIssuerLen',
    id: 362,
    description:
      'Byte length of encoded (non-ASCII characters) EncodedUnderlyingIssuer (363) field.',
  },
  {
    abbrName: 'EncUndIssr',
    type: 'data',
    added: 'FIX.4.2',
    name: 'EncodedUnderlyingIssuer',
    id: 363,
    lengthId: '362',
    description:
      'Encoded (non-ASCII characters) representation of the UnderlyingIssuer (306) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the UnderlyingIssuer field.',
  },
  {
    abbrName: 'EncUndSecDescLen',
    type: 'Length',
    added: 'FIX.4.2',
    name: 'EncodedUnderlyingSecurityDescLen',
    id: 364,
    description:
      'Byte length of encoded (non-ASCII characters) EncodedUnderlyingSecurityDesc (365) field.',
  },
  {
    abbrName: 'EncUndSecDesc',
    type: 'data',
    added: 'FIX.4.2',
    name: 'EncodedUnderlyingSecurityDesc',
    id: 365,
    lengthId: '364',
    description:
      'Encoded (non-ASCII characters) representation of the UnderlyingSecurityDesc (307) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the UnderlyingSecurityeDesc field.',
  },
  {
    abbrName: 'Px',
    type: 'Price',
    added: 'FIX.4.2',
    name: 'AllocPrice',
    id: 366,
    description:
      'Executed price for an AllocAccount (79) entry used when using "executed price" vs. "average price" allocations (e.g. Japan).',
  },
  {
    abbrName: 'ValidTil',
    type: 'UTCTimestamp',
    added: 'FIX.4.2',
    name: 'QuoteSetValidUntilTime',
    id: 367,
    description:
      'Indicates expiration time of this particular QuoteSet (always expressed in UTC (Universal Time Coordinated, also known as "GMT")',
  },
  {
    type: 'QuoteRejectReasonCodeSet',
    unionDataType: 'Reserved100Plus',
    added: 'FIX.4.2',
    name: 'QuoteEntryRejectReason',
    id: 368,
    abbrName: 'EntryRejRsn',
    description: 'Reason Quote Entry was rejected:',
  },
  {
    abbrName: 'LastMsgSeqNumProced',
    type: 'SeqNum',
    added: 'FIX.4.2',
    name: 'LastMsgSeqNumProcessed',
    id: 369,
    description:
      'The last MsgSeqNum (34) value received by the FIX engine and processed by downstream application, such as trading engine or order routing system. Can be specified on every message sent. Useful for detecting a backlog with a counterparty.',
  },
  {
    abbrName: 'RefTagID',
    type: 'int',
    added: 'FIX.4.2',
    name: 'RefTagID',
    id: 371,
    description: 'The tag number of the FIX field being referenced.',
  },
  {
    abbrName: 'RefMsgTyp',
    type: 'MsgTypeCodeSet',
    added: 'FIX.4.2',
    name: 'RefMsgType',
    id: 372,
    description: 'The MsgType (35) of the FIX message being referenced.',
  },
  {
    type: 'SessionRejectReasonCodeSet',
    unionDataType: 'Reserved100Plus',
    added: 'FIX.4.2',
    name: 'SessionRejectReason',
    id: 373,
    abbrName: 'SessRejRsn',
    description: 'Code to identify reason for a session-level Reject message.',
  },
  {
    abbrName: 'BidReqTransTyp',
    type: 'BidRequestTransTypeCodeSet',
    added: 'FIX.4.2',
    name: 'BidRequestTransType',
    id: 374,
    description: 'Identifies the Bid Request message type.',
  },
  {
    abbrName: 'CntraBrkr',
    type: 'String',
    added: 'FIX.4.2',
    name: 'ContraBroker',
    id: 375,
    description:
      'Identifies contra broker. Standard NASD market-maker mnemonic is preferred.',
  },
  {
    abbrName: 'ComplianceID',
    type: 'String',
    added: 'FIX.4.2',
    name: 'ComplianceID',
    id: 376,
    description:
      'ID used to represent this transaction for compliance purposes (e.g. OATS reporting).',
  },
  {
    abbrName: 'SolFlag',
    type: 'SolicitedFlagCodeSet',
    added: 'FIX.4.2',
    name: 'SolicitedFlag',
    id: 377,
    description: 'Indicates whether or not the order was solicited.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'ExecRestatementReasonCodeSet',
    unionDataType: 'Reserved100Plus',
    updatedEP: '195',
    added: 'FIX.4.2',
    name: 'ExecRestatementReason',
    id: 378,
    abbrName: 'ExecRstmtRsn',
    description:
      'The reason for restatement when an ExecutionReport(35=8) or TradeCaptureReport(35=AE) message is sent with ExecType(150) = D (Restated) or used when communicating an unsolicited cancel.',
  },
  {
    abbrName: 'BizRejRefID',
    type: 'String',
    added: 'FIX.4.2',
    name: 'BusinessRejectRefID',
    id: 379,
    description:
      'The value of the business-level "ID" field on the message being referenced.',
  },
  {
    abbrName: 'BizRejRsn',
    type: 'BusinessRejectReasonCodeSet',
    added: 'FIX.4.2',
    name: 'BusinessRejectReason',
    id: 380,
    description: 'Code to identify reason for a Business Message Reject message.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'Amt',
    updatedEP: '258',
    added: 'FIX.4.2',
    name: 'GrossTradeAmt',
    id: 381,
    abbrName: 'GrossTrdAmt',
    description:
      'Total amount traded expressed in units of currency - usually quantity * price. For FX Futures this is used to express the notional value of a fill when quantity fields are expressed in terms of contract size (i.e. quantity * price * contract size).',
  },
  {
    abbrName: 'NoCntraBrkrs',
    type: 'NumInGroup',
    added: 'FIX.4.2',
    name: 'NoContraBrokers',
    id: 382,
    description: 'The number of ContraBroker (375) entries.',
  },
  {
    abbrName: 'MaxMsgSz',
    type: 'Length',
    added: 'FIX.4.2',
    name: 'MaxMessageSize',
    id: 383,
    description: 'Maximum number of bytes supported for a single message.',
  },
  {
    abbrName: 'NoMsgTyps',
    type: 'NumInGroup',
    added: 'FIX.4.2',
    name: 'NoMsgTypes',
    id: 384,
    description: 'Number of MsgTypes (35) in repeating group.',
  },
  {
    updated: 'FIX.Latest',
    type: 'MsgDirectionCodeSet',
    updatedEP: '275',
    added: 'FIX.4.2',
    name: 'MsgDirection',
    id: 385,
    abbrName: 'MsgDirctn',
    description: 'Specifies the direction of the message.',
  },
  {
    abbrName: 'NoTrdgSesss',
    type: 'NumInGroup',
    added: 'FIX.4.2',
    name: 'NoTradingSessions',
    id: 386,
    description: 'Number of TradingSessionIDs (336) in repeating group.',
  },
  {
    abbrName: 'TotVolTrdd',
    type: 'Qty',
    added: 'FIX.4.2',
    name: 'TotalVolumeTraded',
    id: 387,
    description: 'Total volume (quantity) traded.',
  },
  {
    abbrName: 'DsctnInst',
    type: 'DiscretionInstCodeSet',
    added: 'FIX.4.2',
    name: 'DiscretionInst',
    id: 388,
    description:
      'Code to identify the price a DiscretionOffsetValue (389) is related to and should be mathematically added to.',
  },
  {
    abbrName: 'OfstValu',
    type: 'float',
    added: 'FIX.4.2',
    name: 'DiscretionOffsetValue',
    id: 389,
    description:
      'Amount (signed) added to the "related to" price specified via DiscretionInst (388), in the context of DiscretionOffsetType (842)\n\n(Prior to FIX 4.4 this field was of type PriceOffset)',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    updatedEP: '144',
    added: 'FIX.4.2',
    name: 'BidID',
    id: 390,
    abbrName: 'BidID',
    description:
      'For bid lists, unique identifier for BidResponse(35=I) as assigned by sell-side (broker, exchange, ECN). Uniqueness must be guaranteed within a single trading day.\n\nFor quotes, unique identifier for the bid side of the quote assigned by the quote issuer.',
  },
  {
    abbrName: 'ClBidID',
    type: 'String',
    added: 'FIX.4.2',
    name: 'ClientBidID',
    id: 391,
    description:
      'Unique identifier for a Bid Request as assigned by institution. Uniqueness must be guaranteed within a single trading day.',
  },
  {
    abbrName: 'ListName',
    type: 'String',
    added: 'FIX.4.2',
    name: 'ListName',
    id: 392,
    description: 'Descriptive name for list order.',
  },
  {
    abbrName: 'TotNoReltdSym',
    type: 'int',
    added: 'FIX.4.2',
    name: 'TotNoRelatedSym',
    id: 393,
    description:
      'Total number of securities.\n\n(Prior to FIX 4.4 this field was named TotalNumSecurities)',
  },
  {
    abbrName: 'BidTyp',
    type: 'BidTypeCodeSet',
    added: 'FIX.4.2',
    name: 'BidType',
    id: 394,
    description: 'Code to identify the type of Bid Request.',
  },
  {
    abbrName: 'NumTkts',
    type: 'int',
    added: 'FIX.4.2',
    name: 'NumTickets',
    id: 395,
    description: 'Total number of tickets.',
  },
  {
    abbrName: 'SideValu1',
    type: 'Amt',
    added: 'FIX.4.2',
    name: 'SideValue1',
    id: 396,
    description: 'Amounts in currency',
  },
  {
    abbrName: 'SideValu2',
    type: 'Amt',
    added: 'FIX.4.2',
    name: 'SideValue2',
    id: 397,
    description: 'Amounts in currency',
  },
  {
    abbrName: 'NoBidDescptrs',
    type: 'NumInGroup',
    added: 'FIX.4.2',
    name: 'NoBidDescriptors',
    id: 398,
    description: 'Number of BidDescriptor (400) entries.',
  },
  {
    abbrName: 'BidDescptrTyp',
    type: 'BidDescriptorTypeCodeSet',
    added: 'FIX.4.2',
    name: 'BidDescriptorType',
    id: 399,
    description: 'Code to identify the type of BidDescriptor (400).',
  },
  {
    abbrName: 'BidDescptr',
    type: 'String',
    added: 'FIX.4.2',
    name: 'BidDescriptor',
    id: 400,
    description:
      'BidDescriptor value. Usage depends upon BidDescriptorTyp (399).\n\nIf BidDescriptorType = 1\n\nIndustrials etc - Free text\n\nIf BidDescriptorType = 2\n\n"FR" etc - ISO Country Codes\n\nIf BidDescriptorType = 3\n\nFT00, FT250, STOX - Free text',
  },
  {
    abbrName: 'SideValuInd',
    type: 'SideValueIndCodeSet',
    added: 'FIX.4.2',
    name: 'SideValueInd',
    id: 401,
    description:
      'Code to identify which "SideValue" the value refers to. SideValue1 and SideValue2 are used as opposed to Buy or Sell so that the basket can be quoted either way as Buy or Sell.',
  },
  {
    abbrName: 'LqdtyPctLow',
    type: 'Percentage',
    added: 'FIX.4.2',
    name: 'LiquidityPctLow',
    id: 402,
    description:
      'Liquidity indicator or lower limit if TotalNumSecurities (393) > 1. Represented as a percentage.',
  },
  {
    abbrName: 'LqdtyPctHigh',
    type: 'Percentage',
    added: 'FIX.4.2',
    name: 'LiquidityPctHigh',
    id: 403,
    description:
      'Upper liquidity indicator if TotalNumSecurities (393) > 1. Represented as a percentage.',
  },
  {
    abbrName: 'LqdtyValu',
    type: 'Amt',
    added: 'FIX.4.2',
    name: 'LiquidityValue',
    id: 404,
    description:
      'Value between LiquidityPctLow (402) and LiquidityPctHigh (403) in Currency',
  },
  {
    abbrName: 'EFPTrkngErr',
    type: 'Percentage',
    added: 'FIX.4.2',
    name: 'EFPTrackingError',
    id: 405,
    description:
      'Eg Used in EFP trades 2% (EFP - Exchange for Physical ). Represented as a percentage.',
  },
  {
    abbrName: 'FairValu',
    type: 'Amt',
    added: 'FIX.4.2',
    name: 'FairValue',
    id: 406,
    description: 'Used in EFP trades',
  },
  {
    abbrName: 'OutsideNdxPct',
    type: 'Percentage',
    added: 'FIX.4.2',
    name: 'OutsideIndexPct',
    id: 407,
    description: 'Used in EFP trades. Represented as a percentage.',
  },
  {
    abbrName: 'ValuOfFuts',
    type: 'Amt',
    added: 'FIX.4.2',
    name: 'ValueOfFutures',
    id: 408,
    description: 'Used in EFP trades',
  },
  {
    abbrName: 'LqdtyIndTyp',
    type: 'LiquidityIndTypeCodeSet',
    added: 'FIX.4.2',
    name: 'LiquidityIndType',
    id: 409,
    description: 'Code to identify the type of liquidity indicator.',
  },
  {
    abbrName: 'WtAvgLqdty',
    type: 'Percentage',
    added: 'FIX.4.2',
    name: 'WtAverageLiquidity',
    id: 410,
    description:
      'Overall weighted average liquidity expressed as a % of average daily volume. Represented as a percentage.',
  },
  {
    abbrName: 'EFP',
    type: 'ExchangeForPhysicalCodeSet',
    added: 'FIX.4.2',
    name: 'ExchangeForPhysical',
    id: 411,
    description: 'Indicates whether or not to exchange for phsyical.',
  },
  {
    abbrName: 'OutMainCntryUNdx',
    type: 'Amt',
    added: 'FIX.4.2',
    name: 'OutMainCntryUIndex',
    id: 412,
    description: 'Value of stocks in Currency',
  },
  {
    type: 'Percentage',
    baseCategoryAbbrName: 'Pct',
    baseCategory: 'CrossOrders',
    added: 'FIX.4.2',
    name: 'CrossPercent',
    id: 413,
    abbrName: 'CrssPct',
    description:
      'Percentage of program that crosses in Currency. Represented as a percentage.',
  },
  {
    abbrName: 'ProgRptReqs',
    type: 'ProgRptReqsCodeSet',
    added: 'FIX.4.2',
    name: 'ProgRptReqs',
    id: 414,
    description: 'Code to identify the desired frequency of progress reports.',
  },
  {
    abbrName: 'ProgPeriodIntvl',
    type: 'int',
    added: 'FIX.4.2',
    name: 'ProgPeriodInterval',
    id: 415,
    description:
      "Time in minutes between each ListStatus report sent by SellSide. Zero means don't send status.",
  },
  {
    abbrName: 'IncTaxInd',
    type: 'IncTaxIndCodeSet',
    added: 'FIX.4.2',
    name: 'IncTaxInd',
    id: 416,
    description: 'Code to represent whether value is net (inclusive of tax) or gross.',
  },
  {
    abbrName: 'NumBidders',
    type: 'int',
    added: 'FIX.4.2',
    name: 'NumBidders',
    id: 417,
    description: 'Indicates the total number of bidders on the list',
  },
  {
    abbrName: 'BidTrdTyp',
    type: 'BidTradeTypeCodeSet',
    added: 'FIX.4.2',
    name: 'BidTradeType',
    id: 418,
    description:
      'Code to represent the type of trade.\n\n(Prior to FIX 4.4 this field was named "TradeType")',
  },
  {
    abbrName: 'BasisPxTyp',
    type: 'BasisPxTypeCodeSet',
    added: 'FIX.4.2',
    name: 'BasisPxType',
    id: 419,
    description: 'Code to represent the basis price type.',
  },
  {
    abbrName: 'NoBidComponents',
    type: 'NumInGroup',
    added: 'FIX.4.2',
    name: 'NoBidComponents',
    id: 420,
    description: 'Indicates the number of list entries.',
  },
  {
    abbrName: 'Ctry',
    type: 'Country',
    added: 'FIX.4.2',
    name: 'Country',
    id: 421,
    description: 'ISO Country Code in field',
  },
  {
    abbrName: 'TotNoStrks',
    type: 'int',
    added: 'FIX.4.2',
    name: 'TotNoStrikes',
    id: 422,
    description:
      'Total number of strike price entries across all messages. Should be the sum of all NoStrikes (428) in each message that has repeating strike price entries related to the same ListID (66). Used to support fragmentation.',
  },
  {
    updated: 'FIX.Latest',
    type: 'PriceTypeCodeSet',
    updatedEP: '271',
    added: 'FIX.4.2',
    name: 'PriceType',
    id: 423,
    abbrName: 'PxTyp',
    description: 'Code to represent the price type.\n\n',
  },
  {
    abbrName: 'DayOrdQty',
    type: 'Qty',
    added: 'FIX.4.2',
    name: 'DayOrderQty',
    id: 424,
    description:
      'For GT orders, the OrderQty (38) less all quantity (adjusted for stock splits) that traded on previous days. DayOrderQty (424) = OrderQty - (CumQty (14) - DayCumQty (425))',
  },
  {
    abbrName: 'DayCumQty',
    type: 'Qty',
    added: 'FIX.4.2',
    name: 'DayCumQty',
    id: 425,
    description: 'Quantity on a GT order that has traded today.',
  },
  {
    abbrName: 'DayAvgPx',
    type: 'Price',
    added: 'FIX.4.2',
    name: 'DayAvgPx',
    id: 426,
    description: 'The average price for quantity on a GT order that has traded today.',
  },
  {
    abbrName: 'GTBkngInst',
    type: 'GTBookingInstCodeSet',
    added: 'FIX.4.2',
    name: 'GTBookingInst',
    id: 427,
    description:
      'Code to identify whether to book out executions on a part-filled GT order on the day of execution or to accumulate.',
  },
  {
    abbrName: 'NoStrks',
    type: 'NumInGroup',
    added: 'FIX.4.2',
    name: 'NoStrikes',
    id: 428,
    description: 'Number of list strike price entries.',
  },
  {
    abbrName: 'ListStatTyp',
    type: 'ListStatusTypeCodeSet',
    added: 'FIX.4.2',
    name: 'ListStatusType',
    id: 429,
    description: 'Code to represent the status type.',
  },
  {
    abbrName: 'NetGrossInd',
    type: 'NetGrossIndCodeSet',
    added: 'FIX.4.2',
    name: 'NetGrossInd',
    id: 430,
    description: 'Code to represent whether value is net (inclusive of tax) or gross.',
  },
  {
    abbrName: 'ListOrdStat',
    type: 'ListOrderStatusCodeSet',
    added: 'FIX.4.2',
    name: 'ListOrderStatus',
    id: 431,
    description: 'Code to represent the status of a list order.',
  },
  {
    abbrName: 'ExpireDt',
    type: 'LocalMktDate',
    added: 'FIX.4.2',
    name: 'ExpireDate',
    id: 432,
    description:
      "Date of order expiration (last day the order can trade), always expressed in terms of the local market date. The time at which the order expires is determined by the local market's business practices",
  },
  {
    abbrName: 'ListExecInstTyp',
    type: 'ListExecInstTypeCodeSet',
    added: 'FIX.4.2',
    name: 'ListExecInstType',
    id: 433,
    description: 'Identifies the type of ListExecInst (69).',
  },
  {
    abbrName: 'CxlRejRspTo',
    type: 'CxlRejResponseToCodeSet',
    added: 'FIX.4.2',
    name: 'CxlRejResponseTo',
    id: 434,
    description: 'Identifies the type of request that a Cancel Reject is in response to.',
  },
  {
    abbrName: 'CpnRt',
    type: 'Percentage',
    added: 'FIX.4.2',
    name: 'UnderlyingCouponRate',
    id: 435,
    description:
      "Underlying security's CouponRate.\n\nSee CouponRate (223) field for description",
  },
  {
    abbrName: 'Mult',
    type: 'float',
    added: 'FIX.4.2',
    name: 'UnderlyingContractMultiplier',
    id: 436,
    description:
      "Underlying security's ContractMultiplier.\n\nSee ContractMultiplier (231) field for description",
  },
  {
    type: 'Qty',
    baseCategoryAbbrName: 'TrdQty',
    baseCategory: 'SingleGeneralOrderHandling',
    added: 'FIX.4.2',
    name: 'ContraTradeQty',
    id: 437,
    abbrName: 'CntraTrdQty',
    description: 'Quantity traded with the ContraBroker (375).',
  },
  {
    type: 'UTCTimestamp',
    baseCategoryAbbrName: 'TrdTm',
    baseCategory: 'SingleGeneralOrderHandling',
    added: 'FIX.4.2',
    name: 'ContraTradeTime',
    id: 438,
    abbrName: 'CntraTrdTm',
    description:
      'Identifes the time of the trade with the ContraBroker (375). (always expressed in UTC (Universal Time Coordinated, also known as "GMT")',
  },
  {
    abbrName: 'LqdtyNumSecurities',
    type: 'int',
    added: 'FIX.4.2',
    name: 'LiquidityNumSecurities',
    id: 441,
    description:
      'Number of Securites between LiquidityPctLow (402) and LiquidityPctHigh (403) in Currency.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'MultiLegReportingTypeCodeSet',
    updatedEP: '150',
    added: 'FIX.4.2',
    name: 'MultiLegReportingType',
    id: 442,
    abbrName: 'MLegRptTyp',
    description:
      'Used to indicate how the multi-legged security (e.g. option strategies, spreads, etc.) is being reported.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'UTCTimestamp',
    updatedEP: '226',
    added: 'FIX.4.2',
    name: 'StrikeTime',
    id: 443,
    abbrName: 'StrkTm',
    description:
      'The time at which current market prices are used to determine the value of a basket.\n\nIn negotiation workflows where a spread-to-benchmark price is negotiated, this is the pre-determined time at which the benchmark is to be spotted.',
  },
  {
    abbrName: 'ListStatText',
    type: 'String',
    added: 'FIX.4.2',
    name: 'ListStatusText',
    id: 444,
    description: 'Free format text string related to List Status.',
  },
  {
    abbrName: 'EncListStatTextLen',
    type: 'Length',
    added: 'FIX.4.2',
    name: 'EncodedListStatusTextLen',
    id: 445,
    description:
      'Byte length of encoded (non-ASCII characters) EncodedListStatusText (446) field.',
  },
  {
    abbrName: 'EncListStatText',
    type: 'data',
    added: 'FIX.4.2',
    name: 'EncodedListStatusText',
    id: 446,
    lengthId: '445',
    description:
      'Encoded (non-ASCII characters) representation of the ListStatusText (444) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the ListStatusText field.',
  },
  {
    abbrName: 'Src',
    type: 'PartyIDSourceCodeSet',
    added: 'FIX.4.3',
    name: 'PartyIDSource',
    id: 447,
    description:
      'Identifies class or source of the PartyID (448) value. Required if PartyID is specified. Note: applicable values depend upon PartyRole (452) specified.\n\nSee "Appendix 6-G - Use of <Parties> Component Block"',
  },
  {
    abbrName: 'ID',
    type: 'String',
    added: 'FIX.4.3',
    name: 'PartyID',
    id: 448,
    discriminatorId: '447',
    description:
      'Party identifier/code. See PartyIDSource (447) and PartyRole (452).\n\nSee "Appendix 6-G - Use of <Parties> Component Block"',
  },
  {
    abbrName: 'NetChgPrevDay',
    type: 'PriceOffset',
    added: 'FIX.4.3',
    name: 'NetChgPrevDay',
    id: 451,
    description: "Net change from previous day's closing price vs. last traded price.",
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PartyRoleCodeSet',
    updatedEP: '256',
    added: 'FIX.4.3',
    name: 'PartyRole',
    id: 452,
    abbrName: 'R',
    description: 'Identifies the type or role of the PartyID (448) specified.',
  },
  {
    abbrName: 'NoPtyIDs',
    type: 'NumInGroup',
    added: 'FIX.4.3',
    name: 'NoPartyIDs',
    id: 453,
    description:
      'Number of PartyID (448), PartyIDSource (447), and PartyRole (452) entries',
  },
  {
    abbrName: 'NoSecAltID',
    type: 'NumInGroup',
    added: 'FIX.4.3',
    name: 'NoSecurityAltID',
    id: 454,
    description: 'Number of SecurityAltID (455) entries.',
  },
  {
    abbrName: 'AltID',
    type: 'String',
    added: 'FIX.4.3',
    name: 'SecurityAltID',
    id: 455,
    discriminatorId: '456',
    description:
      'Alternate Security identifier value for this security of SecurityAltIDSource (456) type (e.g. CUSIP, SEDOL, ISIN, etc). Requires SecurityAltIDSource.',
  },
  {
    updated: 'FIX.Latest',
    type: 'SecurityIDSourceCodeSet',
    unionDataType: 'Reserved100Plus',
    updatedEP: '271',
    added: 'FIX.4.3',
    name: 'SecurityAltIDSource',
    id: 456,
    abbrName: 'AltIDSrc',
    description: 'Identifies class or source of the SecurityAltID(455) value.',
  },
  {
    abbrName: 'NoUndSecAltID',
    type: 'NumInGroup',
    added: 'FIX.4.3',
    name: 'NoUnderlyingSecurityAltID',
    id: 457,
    description: 'Number of UnderlyingSecurityAltID (458) entries.',
  },
  {
    abbrName: 'AltID',
    type: 'String',
    added: 'FIX.4.3',
    name: 'UnderlyingSecurityAltID',
    id: 458,
    discriminatorId: '459',
    description:
      'Alternate Security identifier value for this underlying security of UnderlyingSecurityAltIDSource (459) type (e.g. CUSIP, SEDOL, ISIN, etc). Requires UnderlyingSecurityAltIDSource.',
  },
  {
    updated: 'FIX.Latest',
    type: 'SecurityIDSourceCodeSet',
    unionDataType: 'Reserved100Plus',
    updatedEP: '271',
    added: 'FIX.4.3',
    name: 'UnderlyingSecurityAltIDSource',
    id: 459,
    abbrName: 'AltIDSrc',
    description:
      'Identifies class or source of the UnderlyingSecurityAltID(458) value.\n\nRequired if UnderlyingSecurityAltID is specified.',
  },
  {
    abbrName: 'Prod',
    type: 'ProductCodeSet',
    added: 'FIX.4.3',
    name: 'Product',
    id: 460,
    description:
      'Indicates the type of product the security is associated with. See also the CFICode (461) and SecurityType (167) fields.',
  },
  {
    abbrName: 'CFI',
    type: 'String',
    added: 'FIX.4.3',
    name: 'CFICode',
    id: 461,
    description:
      'Indicates the type of security using ISO 10962 standard, Classification of Financial Instruments (CFI code) values. ISO 10962 is maintained by ANNA (Association of National Numbering Agencies) acting as Registration Authority. See "Appendix 6-B FIX Fields Based Upon Other Standards". See also the Product (460) and SecurityType (167) fields. It is recommended that CFICode be used instead of SecurityType (167) for non-Fixed Income instruments.\n\nA subset of possible values applicable to FIX usage are identified in "Appendix 6-D CFICode Usage - ISO 10962 Classification of Financial Instruments (CFI code)"',
  },
  {
    abbrName: 'Prod',
    type: 'ProductCodeSet',
    added: 'FIX.4.3',
    name: 'UnderlyingProduct',
    id: 462,
    description: "Underlying security's Product.\n\nValid values: see Product(460) field",
  },
  {
    abbrName: 'CFI',
    type: 'String',
    added: 'FIX.4.3',
    name: 'UnderlyingCFICode',
    id: 463,
    description:
      "Underlying security's CFICode.\n\nValid values: see CFICode (461) field",
  },
  {
    abbrName: 'TestMsgInd',
    type: 'TestMessageIndicatorCodeSet',
    added: 'FIX.4.3',
    name: 'TestMessageIndicator',
    id: 464,
    description:
      'Indicates whether or not this FIX Session is a "test" vs. "production" connection. Useful for preventing "accidents".',
  },
  {
    abbrName: 'BkngRefID',
    type: 'String',
    added: 'FIX.4.3',
    name: 'BookingRefID',
    id: 466,
    description:
      'Common reference passed to a post-trade booking process (e.g. industry matching utility).',
  },
  {
    abbrName: 'IndAllocID',
    type: 'String',
    added: 'FIX.4.3',
    name: 'IndividualAllocID',
    id: 467,
    description:
      'Unique identifier for a specific NoAllocs (78) repeating group instance (e.g. for an AllocAccount).',
  },
  {
    abbrName: 'RndDir',
    type: 'RoundingDirectionCodeSet',
    added: 'FIX.4.3',
    name: 'RoundingDirection',
    id: 468,
    description:
      'Specifies which direction to round For CIV - indicates whether or not the quantity of shares/units is to be rounded and in which direction where CashOrdQty (152) or (for CIV only) OrderPercent (516) are specified on an order.\n\nThe default is for rounding to be at the discretion of the executing broker or fund manager.\n\ne.g. for an order specifying CashOrdQty or OrderPercent if the calculated number of shares/units was 325.76 and RoundingModulus (469) was 0 - "round down" would give 320 units, 1 - "round up" would give 330 units and "round to nearest" would give 320 units.',
  },
  {
    abbrName: 'RndMod',
    type: 'float',
    added: 'FIX.4.3',
    name: 'RoundingModulus',
    id: 469,
    description:
      'For CIV - a float value indicating the value to which rounding is required.\n\ni.e. 0 means round to a multiple of 0 units/shares; 0.5 means round to a multiple of 0.5 units/shares.\n\nThe default, if RoundingDirection (468) is specified without RoundingModulus, is to round to a whole unit/share.',
  },
  {
    abbrName: 'IssuCtry',
    type: 'Country',
    added: 'FIX.4.3',
    name: 'CountryOfIssue',
    id: 470,
    description:
      'ISO Country code of instrument issue (e.g. the country portion typically used in ISIN). Can be used in conjunction with non-ISIN SecurityID (48) (e.g. CUSIP for Municipal Bonds without ISIN) to provide uniqueness.',
  },
  {
    abbrName: 'StPrv',
    type: 'String',
    added: 'FIX.4.3',
    name: 'StateOrProvinceOfIssue',
    id: 471,
    description: 'A two-character state or province abbreviation.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    updatedEP: '192',
    added: 'FIX.4.3',
    name: 'LocaleOfIssue',
    id: 472,
    abbrName: 'Lcl',
    description:
      'Identifies the locale or region of issue.\n\nFor Municipal Security Issuers other than state or province. Refer to http://www.atmos.albany.edu/cgi/stagrep-cgi. Reference the IATA city codes for values. Note IATA (International Air Transport Association) maintains the codes at www.iata.org. For other securities the value may be a region of the issuer, e.g. North America.',
  },
  {
    abbrName: 'NoRegistDtls',
    type: 'NumInGroup',
    added: 'FIX.4.3',
    name: 'NoRegistDtls',
    id: 473,
    description:
      'The number of registration details on a Registration Instructions message',
  },
  {
    abbrName: 'MailingDtls',
    type: 'String',
    added: 'FIX.4.3',
    name: 'MailingDtls',
    id: 474,
    description:
      'Set of Correspondence address details, possibly including phone, fax, etc.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Country',
    updatedEP: '271',
    added: 'FIX.4.3',
    name: 'InvestorCountryOfResidence',
    id: 475,
    abbrName: 'InvestorCtryOfResidence',
    description:
      'The ISO 3166 Country code (2 character) identifying which country the beneficial investor is resident for tax purposes.',
  },
  {
    abbrName: 'PmtRef',
    type: 'String',
    added: 'FIX.4.3',
    name: 'PaymentRef',
    id: 476,
    description:
      '"Settlement Payment Reference" - A free format Payment reference to assist with reconciliation, e.g. a Client and/or Order ID number.',
  },
  {
    updated: 'FIX.Latest',
    type: 'DistribPaymentMethodCodeSet',
    unionDataType: 'Reserved1000Plus',
    updatedEP: '271',
    added: 'FIX.4.3',
    name: 'DistribPaymentMethod',
    id: 477,
    abbrName: 'DistribPmtMethod',
    description:
      'Identifies the payment method for a (fractional) distribution. Used for CIV.',
  },
  {
    abbrName: 'CshDistribCurr',
    type: 'Currency',
    added: 'FIX.4.3',
    name: 'CashDistribCurr',
    id: 478,
    description:
      'Specifies currency to be used for Cash Distributions see "Appendix 6-A Valid Currency Codes".',
  },
  {
    updated: 'FIX.Latest',
    type: 'Currency',
    updatedEP: '273',
    added: 'FIX.4.3',
    name: 'CommCurrency',
    id: 479,
    abbrName: 'Ccy',
    description:
      'Specifies currency to be used for Commission(12) if the commission currency is different from the deal currency.\n\nCommCurrencyCodeSource(2922) may be used to disambiguate the code source scheme used, and ISO 4217 is the default scheme if absent.',
  },
  {
    abbrName: 'CxllationRights',
    type: 'CancellationRightsCodeSet',
    added: 'FIX.4.3',
    name: 'CancellationRights',
    id: 480,
    description:
      'For CIV - A one character code identifying whether Cancellation rights/Cooling off period applies.',
  },
  {
    abbrName: 'MnyLaunderingStat',
    type: 'MoneyLaunderingStatusCodeSet',
    added: 'FIX.4.3',
    name: 'MoneyLaunderingStatus',
    id: 481,
    description: 'A one character code identifying Money laundering status.',
  },
  {
    abbrName: 'MailingInst',
    type: 'String',
    added: 'FIX.4.3',
    name: 'MailingInst',
    id: 482,
    description:
      'Free format text to specify mailing instruction requirements, e.g. "no third party mailings".',
  },
  {
    abbrName: 'TransBkdTm',
    type: 'UTCTimestamp',
    added: 'FIX.4.3',
    name: 'TransBkdTime',
    id: 483,
    description:
      'For CIV A date and time stamp to indicate the time a CIV order was booked by the fund manager.\n\nFor derivatives a date and time stamp to indicate when this order was booked with the agent prior to submission to the VMU. Indicates the time at which the order was finalized between the buyer and seller prior to submission.',
  },
  {
    abbrName: 'ExecPxTyp',
    type: 'ExecPriceTypeCodeSet',
    added: 'FIX.4.3',
    name: 'ExecPriceType',
    id: 484,
    description:
      'For CIV - Identifies how the execution price LastPx (31) was calculated from the fund unit/share price(s) calculated at the fund valuation point.',
  },
  {
    abbrName: 'ExecPxAdjment',
    type: 'float',
    added: 'FIX.4.3',
    name: 'ExecPriceAdjustment',
    id: 485,
    description:
      'For CIV the amount or percentage by which the fund unit/share price was adjusted, as indicated by ExecPriceType (484)',
  },
  {
    abbrName: 'DtOfBirth',
    type: 'LocalMktDate',
    added: 'FIX.4.3',
    name: 'DateOfBirth',
    id: 486,
    description:
      'The date of birth applicable to the individual, e.g. required to open some types of tax-exempt account.',
  },
  {
    abbrName: 'TransTyp',
    type: 'TradeReportTransTypeCodeSet',
    added: 'FIX.4.3',
    name: 'TradeReportTransType',
    id: 487,
    description:
      'Identifies Trade Report message transaction type\n\n(Prior to FIX 4.4 this field was of type char)',
  },
  {
    abbrName: 'CardHolderName',
    type: 'String',
    added: 'FIX.4.3',
    name: 'CardHolderName',
    id: 488,
    description:
      'The name of the payment card holder as specified on the card being used for payment.',
  },
  {
    abbrName: 'CardNum',
    type: 'String',
    added: 'FIX.4.3',
    name: 'CardNumber',
    id: 489,
    description:
      'The number of the payment card as specified on the card being used for payment.',
  },
  {
    abbrName: 'CardExpDt',
    type: 'LocalMktDate',
    added: 'FIX.4.3',
    name: 'CardExpDate',
    id: 490,
    description:
      'The expiry date of the payment card as specified on the card being used for payment.',
  },
  {
    abbrName: 'CardIssNum',
    type: 'String',
    added: 'FIX.4.3',
    name: 'CardIssNum',
    id: 491,
    description:
      'The issue number of the payment card as specified on the card being used for payment. This is only applicable to certain types of card.',
  },
  {
    updated: 'FIX.Latest',
    type: 'PaymentMethodCodeSet',
    unionDataType: 'Reserved1000Plus',
    updatedEP: '271',
    added: 'FIX.4.3',
    name: 'PaymentMethod',
    id: 492,
    abbrName: 'PmtMethod',
    description: 'Identifies the settlement payment method.',
  },
  {
    type: 'String',
    baseCategoryAbbrName: 'AcctTyp',
    baseCategory: 'RegistrationInstruction',
    added: 'FIX.4.3',
    name: 'RegistAcctType',
    id: 493,
    abbrName: 'AcctTyp',
    description:
      "For CIV - a fund manager-defined code identifying which of the fund manager's account types is required.",
  },
  {
    abbrName: 'Designation',
    type: 'String',
    added: 'FIX.4.3',
    name: 'Designation',
    id: 494,
    description:
      "Free format text defining the designation to be associated with a holding on the register. Used to identify assets of a specific underlying investor using a common registration, e.g. a broker's nominee or street name.",
  },
  {
    updated: 'FIX.Latest',
    type: 'TaxAdvantageTypeCodeSet',
    unionDataType: 'Reserved1000Plus',
    updatedEP: '271',
    added: 'FIX.4.3',
    name: 'TaxAdvantageType',
    id: 495,
    abbrName: 'TaxAdvantageTyp',
    description:
      'Identifies the type of tax exempt account in which purchases shares/units are to be held. Used for CIV.',
  },
  {
    type: 'String',
    baseCategoryAbbrName: 'Dtls',
    baseCategory: 'RegistrationInstruction',
    added: 'FIX.4.3',
    name: 'RegistRejReasonText',
    id: 496,
    abbrName: 'RejRsnTxt',
    description:
      'Text indicating reason(s) why a Registration Instruction has been rejected.',
  },
  {
    abbrName: 'FundRenewWaiv',
    type: 'FundRenewWaivCodeSet',
    added: 'FIX.4.3',
    name: 'FundRenewWaiv',
    id: 497,
    description:
      'A one character code identifying whether the Fund based renewal commission is to be waived.',
  },
  {
    abbrName: 'CshDistribAgentName',
    type: 'String',
    added: 'FIX.4.3',
    name: 'CashDistribAgentName',
    id: 498,
    description: 'Name of local agent bank if for cash distributions',
  },
  {
    abbrName: 'CshDistribAgentCode',
    type: 'String',
    added: 'FIX.4.3',
    name: 'CashDistribAgentCode',
    id: 499,
    description:
      'BIC (Bank Identification Code--Swift managed) code of agent bank for cash distributions',
  },
  {
    abbrName: 'CshDistribAgentAcctNum',
    type: 'String',
    added: 'FIX.4.3',
    name: 'CashDistribAgentAcctNumber',
    id: 500,
    description: 'Account number at agent bank for distributions.',
  },
  {
    abbrName: 'CshDistribPayRef',
    type: 'String',
    added: 'FIX.4.3',
    name: 'CashDistribPayRef',
    id: 501,
    description:
      'Free format Payment reference to assist with reconciliation of distributions.',
  },
  {
    abbrName: 'CshDistribAgentAcctName',
    type: 'String',
    added: 'FIX.4.3',
    name: 'CashDistribAgentAcctName',
    id: 502,
    description: 'Name of account at agent bank for distributions.',
  },
  {
    abbrName: 'CardStartDt',
    type: 'LocalMktDate',
    added: 'FIX.4.3',
    name: 'CardStartDate',
    id: 503,
    description:
      'The start date of the card as specified on the card being used for payment.',
  },
  {
    abbrName: 'PmtDt',
    type: 'LocalMktDate',
    added: 'FIX.4.3',
    name: 'PaymentDate',
    id: 504,
    description:
      'The date written on a cheque or date payment should be submitted to the relevant clearing system.',
  },
  {
    abbrName: 'PmtRemtrID',
    type: 'String',
    added: 'FIX.4.3',
    name: 'PaymentRemitterID',
    id: 505,
    description:
      'Identifies sender of a payment, e.g. the payment remitter or a customer reference number.',
  },
  {
    abbrName: 'RegStat',
    type: 'RegistStatusCodeSet',
    added: 'FIX.4.3',
    name: 'RegistStatus',
    id: 506,
    description:
      'Registration status as returned by the broker or (for CIV) the fund manager:',
  },
  {
    type: 'RegistRejReasonCodeCodeSet',
    baseCategoryAbbrName: 'RejRsnCd',
    baseCategory: 'RegistrationInstruction',
    unionDataType: 'Reserved100Plus',
    added: 'FIX.4.3',
    name: 'RegistRejReasonCode',
    id: 507,
    abbrName: 'RejRsnCd',
    description:
      'Reason(s) why Registration Instructions has been rejected.\n\nThe reason may be further amplified in the RegistRejReasonCode field.\n\nPossible values of reason code include:',
  },
  {
    updated: 'FIX.Latest',
    type: 'String',
    baseCategoryAbbrName: 'RefID',
    baseCategory: 'RegistrationInstruction',
    updatedEP: '282',
    added: 'FIX.4.3',
    name: 'RegistRefID',
    id: 508,
    abbrName: 'RefID',
    description:
      'Reference identifier for the RegistID(513) with Cancel and Replace RegistTransType(514) transaction types.',
  },
  {
    type: 'String',
    baseCategoryAbbrName: 'RejRsnTxt',
    baseCategory: 'RegistrationInstruction',
    added: 'FIX.4.3',
    name: 'RegistDtls',
    id: 509,
    abbrName: 'Dtls',
    description:
      'Set of Registration name and address details, possibly including phone, fax etc.',
  },
  {
    abbrName: 'NoDistribInsts',
    type: 'NumInGroup',
    added: 'FIX.4.3',
    name: 'NoDistribInsts',
    id: 510,
    description:
      'The number of Distribution Instructions on a Registration Instructions message',
  },
  {
    type: 'String',
    baseCategoryAbbrName: 'Email',
    baseCategory: 'RegistrationInstruction',
    added: 'FIX.4.3',
    name: 'RegistEmail',
    id: 511,
    abbrName: 'Email',
    description: 'Email address relating to Registration name and address details',
  },
  {
    abbrName: 'DistribPctage',
    type: 'Percentage',
    added: 'FIX.4.3',
    name: 'DistribPercentage',
    id: 512,
    description:
      'The amount of each distribution to go to this beneficiary, expressed as a percentage',
  },
  {
    type: 'String',
    baseCategoryAbbrName: 'ID',
    baseCategory: 'RegistrationInstruction',
    added: 'FIX.4.3',
    name: 'RegistID',
    id: 513,
    abbrName: 'RegistID',
    description:
      'Unique identifier of the registration details as assigned by institution or intermediary.',
  },
  {
    abbrName: 'TransTyp',
    type: 'RegistTransTypeCodeSet',
    added: 'FIX.4.3',
    name: 'RegistTransType',
    id: 514,
    description: 'Identifies Registration Instructions transaction type',
  },
  {
    abbrName: 'ExecValuationPoint',
    type: 'UTCTimestamp',
    added: 'FIX.4.3',
    name: 'ExecValuationPoint',
    id: 515,
    description:
      'For CIV - a date and time stamp to indicate the fund valuation point with respect to which a order was priced by the fund manager.',
  },
  {
    abbrName: 'Pct',
    type: 'Percentage',
    added: 'FIX.4.3',
    name: 'OrderPercent',
    id: 516,
    description:
      "For CIV specifies the approximate order quantity desired. For a CIV Sale it specifies percentage of investor's total holding to be sold. For a CIV switch/exchange it specifies percentage of investor's cash realised from sales to be re-invested. The executing broker, intermediary or fund manager is responsible for converting and calculating OrderQty (38) in shares/units for subsequent messages.",
  },
  {
    abbrName: 'OwnershipTyp',
    type: 'OwnershipTypeCodeSet',
    added: 'FIX.4.3',
    name: 'OwnershipType',
    id: 517,
    description: 'The relationship between Registration parties.',
  },
  {
    abbrName: 'NoContAmts',
    type: 'NumInGroup',
    added: 'FIX.4.3',
    name: 'NoContAmts',
    id: 518,
    description: 'The number of Contract Amount details on an Execution Report message',
  },
  {
    abbrName: 'ContAmtTyp',
    type: 'ContAmtTypeCodeSet',
    added: 'FIX.4.3',
    name: 'ContAmtType',
    id: 519,
    description:
      'Type of ContAmtValue (520).\n\nNOTE That Commission Amount / % in Contract Amounts is the commission actually charged, rather than the commission instructions given in Fields 2/3.',
  },
  {
    abbrName: 'ContAmtValu',
    type: 'float',
    added: 'FIX.4.3',
    name: 'ContAmtValue',
    id: 520,
    description:
      'Value of Contract Amount, e.g. a financial amount or percentage as indicated by ContAmtType (519).',
  },
  {
    abbrName: 'ContAmtCurr',
    type: 'Currency',
    added: 'FIX.4.3',
    name: 'ContAmtCurr',
    id: 521,
    description:
      'Specifies currency for the Contract amount if different from the Deal Currency - see "Appendix 6-A; Valid Currency Codes".',
  },
  {
    abbrName: 'OwnerTyp',
    type: 'OwnerTypeCodeSet',
    added: 'FIX.4.3',
    name: 'OwnerType',
    id: 522,
    description: 'Identifies the type of owner.',
  },
  {
    abbrName: 'ID',
    type: 'String',
    added: 'FIX.4.3',
    name: 'PartySubID',
    id: 523,
    description:
      'Sub-identifier (e.g. Clearing Account for PartyRole (452)=Clearing Firm, Locate ID # for PartyRole=Locate/Lending Firm, etc). Not required when using PartyID (448), PartyIDSource (447), and PartyRole.',
  },
  {
    abbrName: 'ID',
    type: 'String',
    added: 'FIX.4.3',
    name: 'NestedPartyID',
    id: 524,
    discriminatorId: '525',
    description:
      'PartyID value within a nested repeating group.\n\nSame values as PartyID (448)',
  },
  {
    abbrName: 'Src',
    type: 'PartyIDSourceCodeSet',
    added: 'FIX.4.3',
    name: 'NestedPartyIDSource',
    id: 525,
    description:
      'PartyIDSource value within a nested repeating group.\n\nSame values as PartyIDSource (447)',
  },
  {
    type: 'String',
    baseCategoryAbbrName: 'ID2',
    baseCategory: 'SingleGeneralOrderHandling',
    added: 'FIX.4.3',
    name: 'SecondaryClOrdID',
    id: 526,
    abbrName: 'ClOrdID2',
    description:
      'Assigned by the party which originates the order. Can be used to provide the ClOrdID (11) used by an exchange or executing system.',
  },
  {
    abbrName: 'ExecID2',
    type: 'String',
    added: 'FIX.4.3',
    name: 'SecondaryExecID',
    id: 527,
    description:
      'Assigned by the party which accepts the order. Can be used to provide the ExecID (17) used by an exchange or executing system.',
  },
  {
    abbrName: 'Cpcty',
    type: 'OrderCapacityCodeSet',
    added: 'FIX.4.3',
    name: 'OrderCapacity',
    id: 528,
    description:
      'Designates the capacity of the firm placing the order.\n\n(as of FIX 4.3, this field replaced Rule80A (tag 47) --used in conjunction with OrderRestrictions (529) field)\n\n(see Volume : "Glossary" for value definitions)',
  },
  {
    abbrName: 'Rstctions',
    type: 'OrderRestrictionsCodeSet',
    added: 'FIX.4.3',
    name: 'OrderRestrictions',
    id: 529,
    description:
      'Restrictions associated with an order. If more than one restriction is applicable to an order, this field can contain multiple instructions separated by space.',
  },
  {
    type: 'MassCancelRequestTypeCodeSet',
    baseCategoryAbbrName: 'ReqTyp',
    baseCategory: 'OrderMassHandling',
    added: 'FIX.4.3',
    name: 'MassCancelRequestType',
    id: 530,
    abbrName: 'MassCxlReqTyp',
    description: 'Specifies scope of Order Mass Cancel Request.',
  },
  {
    type: 'MassCancelResponseCodeSet',
    baseCategoryAbbrName: 'Rsp',
    baseCategory: 'OrderMassHandling',
    added: 'FIX.4.3',
    name: 'MassCancelResponse',
    id: 531,
    abbrName: 'MassCxlRsp',
    description:
      'Specifies the action taken by counterparty order handling system as a result of the Order Mass Cancel Request',
  },
  {
    type: 'MassCancelRejectReasonCodeSet',
    unionDataType: 'Reserved100Plus',
    added: 'FIX.4.3',
    name: 'MassCancelRejectReason',
    id: 532,
    abbrName: 'MassCxlRejRsn',
    description: 'Reason Order Mass Cancel Request was rejected',
  },
  {
    updated: 'FIX.5.0SP1',
    type: 'int',
    updatedEP: '95',
    added: 'FIX.4.3',
    name: 'TotalAffectedOrders',
    id: 533,
    abbrName: 'TotAffctdOrds',
    description:
      'Total number of orders affected by either the OrderMassActionRequest(MsgType=CA) or OrderMassCancelRequest(MsgType=Q).',
  },
  {
    updated: 'FIX.Latest',
    type: 'NumInGroup',
    updatedEP: '275',
    added: 'FIX.4.3',
    name: 'NoAffectedOrders',
    id: 534,
    abbrName: 'NoAffctdOrds',
    description: 'Number of affected orders in the repeating group of order ids.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    updatedEP: '131',
    added: 'FIX.4.3',
    name: 'AffectedOrderID',
    id: 535,
    abbrName: 'OrdID',
    description:
      'OrderID(37) of an order affected by a mass cancel or mass action request.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    updatedEP: '131',
    added: 'FIX.4.3',
    name: 'AffectedSecondaryOrderID',
    id: 536,
    abbrName: 'OrdID2',
    description:
      'SecondaryOrderID(198) of an order affected by a mass cancel or mass action request.',
  },
  {
    abbrName: 'Typ',
    type: 'QuoteTypeCodeSet',
    added: 'FIX.4.3',
    name: 'QuoteType',
    id: 537,
    description:
      'Identifies the type of quote.\n\nAn indicative quote is used to inform a counterparty of a market. An indicative quote does not result directly in a trade.\n\nA tradeable quote is submitted to a market and will result directly in a trade against other orders and quotes in a market.\n\nA restricted tradeable quote is submitted to a market and within a certain restriction (possibly based upon price or quantity) will automatically trade against orders. Order that do not comply with restrictions are sent to the quote issuer who can choose to accept or decline the order.\n\nA counter quote is used in the negotiation model. See Volume 7 - Product: Fixed Income for example usage.',
  },
  {
    abbrName: 'R',
    type: 'PartyRoleCodeSet',
    added: 'FIX.4.3',
    name: 'NestedPartyRole',
    id: 538,
    description:
      'PartyRole value within a nested repeating group.\n\nSame values as PartyRole (452)',
  },
  {
    abbrName: 'NoNstPtyIDs',
    type: 'NumInGroup',
    added: 'FIX.4.3',
    name: 'NoNestedPartyIDs',
    id: 539,
    description:
      'Number of NestedPartyID (524), NestedPartyIDSource (525), and NestedPartyRole (538) entries',
  },
  {
    type: 'Amt',
    deprecated: 'FIX.4.4',
    added: 'FIX.4.3',
    name: 'TotalAccruedInterestAmt',
    id: 540,
    abbrName: 'TotAcrdIntAmt',
    description:
      'Total Amount of Accrued Interest for convertible bonds and fixed income',
  },
  {
    abbrName: 'MatDt',
    type: 'LocalMktDate',
    added: 'FIX.4.3',
    name: 'MaturityDate',
    id: 541,
    description: 'Date of maturity.',
  },
  {
    abbrName: 'Mat',
    type: 'LocalMktDate',
    added: 'FIX.4.3',
    name: 'UnderlyingMaturityDate',
    id: 542,
    description:
      "Underlying security's maturity date.\n\nSee MaturityDate (541) field for description",
  },
  {
    abbrName: 'Rgstry',
    type: 'String',
    added: 'FIX.4.3',
    name: 'InstrRegistry',
    id: 543,
    description:
      'Values may include BIC for the depository or custodian who maintain ownership records, the ISO country code for the location of the record, or the value "ZZ" to specify physical ownership of the security (e.g. stock certificate).',
  },
  {
    abbrName: 'CshMgn',
    type: 'CashMarginCodeSet',
    added: 'FIX.4.3',
    name: 'CashMargin',
    id: 544,
    description:
      'Identifies whether an order is a margin order or a non-margin order. This is primarily used when sending orders to Japanese exchanges to indicate sell margin or buy to cover. The same tag could be assigned also by buy-side to indicate the intent to sell or buy margin and the sell-side to accept or reject (base on some validation criteria) the margin request.',
  },
  {
    abbrName: 'ID',
    type: 'String',
    added: 'FIX.4.3',
    name: 'NestedPartySubID',
    id: 545,
    description:
      'PartySubID value within a nested repeating group.\n\nSame values as PartySubID (523)',
  },
  {
    updated: 'FIX.5.0SP1',
    type: 'ScopeCodeSet',
    updatedEP: '95',
    added: 'FIX.4.3',
    name: 'Scope',
    id: 546,
    abbrName: 'Scope',
    description: 'Specifies the market scope of the market data.',
  },
  {
    abbrName: 'ImplctDel',
    type: 'MDImplicitDeleteCodeSet',
    added: 'FIX.4.3',
    name: 'MDImplicitDelete',
    id: 547,
    description:
      'Defines how a server handles distribution of a truncated book. Defaults to broker option.',
  },
  {
    type: 'String',
    baseCategoryAbbrName: 'ID',
    baseCategory: 'CrossOrders',
    added: 'FIX.4.3',
    name: 'CrossID',
    id: 548,
    abbrName: 'CrssID',
    description:
      'Identifier for a cross order. Must be unique during a given trading day. Recommend that firms use the order date as part of the CrossID for Good Till Cancel (GT) orders.',
  },
  {
    type: 'CrossTypeCodeSet',
    baseCategoryAbbrName: 'Typ',
    baseCategory: 'CrossOrders',
    added: 'FIX.4.3',
    name: 'CrossType',
    id: 549,
    abbrName: 'CrssTyp',
    description: 'Type of cross being submitted to a market',
  },
  {
    type: 'CrossPrioritizationCodeSet',
    baseCategoryAbbrName: 'Priorty',
    baseCategory: 'CrossOrders',
    added: 'FIX.4.3',
    name: 'CrossPrioritization',
    id: 550,
    abbrName: 'CrssPriortstn',
    description:
      'Indicates if one side or the other of a cross order should be prioritized.\n\nThe definition of prioritization is left to the market. In some markets prioritization means which side of the cross order is applied to the market first. In other markets - prioritization may mean that the prioritized side is fully executed (sometimes referred to as the side being protected).',
  },
  {
    type: 'String',
    baseCategoryAbbrName: 'OrigID',
    baseCategory: 'CrossOrders',
    added: 'FIX.4.3',
    name: 'OrigCrossID',
    id: 551,
    abbrName: 'OrigCrssID',
    description:
      'CrossID of the previous cross order (NOT the initial cross order of the day) as assigned by the institution, used to identify the previous cross order in Cross Cancel and Cross Cancel/Replace Requests.',
  },
  {
    abbrName: 'NoSides',
    type: 'NoSidesCodeSet',
    added: 'FIX.4.3',
    name: 'NoSides',
    id: 552,
    description: 'Number of Side repeating group instances.',
  },
  {
    abbrName: 'Username',
    type: 'String',
    added: 'FIX.4.3',
    name: 'Username',
    id: 553,
    description: 'Userid or username.',
  },
  {
    abbrName: 'Password',
    type: 'String',
    added: 'FIX.4.3',
    name: 'Password',
    id: 554,
    description: 'Password or passphrase.',
  },
  {
    abbrName: 'NoLegs',
    type: 'NumInGroup',
    added: 'FIX.4.3',
    name: 'NoLegs',
    id: 555,
    description: 'Number of InstrumentLeg repeating group instances.',
  },
  {
    abbrName: 'Ccy',
    type: 'Currency',
    added: 'FIX.4.3',
    name: 'LegCurrency',
    id: 556,
    description: "Currency associated with a particular Leg's quantity",
  },
  {
    updated: 'FIX.5.0SP1',
    type: 'int',
    updatedEP: '95',
    added: 'FIX.4.3',
    name: 'TotNoSecurityTypes',
    id: 557,
    abbrName: 'TotNoSecTyps',
    description:
      'Used to support fragmentation. Indicates total number of security types when multiple Security Type messages are used to return results.',
  },
  {
    abbrName: 'NoSecTyps',
    type: 'NumInGroup',
    added: 'FIX.4.3',
    name: 'NoSecurityTypes',
    id: 558,
    description: 'Number of Security Type repeating group instances.',
  },
  {
    abbrName: 'ListReqTyp',
    type: 'SecurityListRequestTypeCodeSet',
    added: 'FIX.4.3',
    name: 'SecurityListRequestType',
    id: 559,
    description: 'Identifies the type/criteria of Security List Request',
  },
  {
    abbrName: 'ReqRslt',
    type: 'SecurityRequestResultCodeSet',
    added: 'FIX.4.3',
    name: 'SecurityRequestResult',
    id: 560,
    description: 'The results returned to a Security Request message',
  },
  {
    abbrName: 'RndLot',
    type: 'Qty',
    added: 'FIX.4.3',
    name: 'RoundLot',
    id: 561,
    description: 'The trading lot size of a security',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'Qty',
    updatedEP: '130',
    added: 'FIX.4.3',
    name: 'MinTradeVol',
    id: 562,
    abbrName: 'MinTrdVol',
    description:
      'The minimum order quantity (as expressed by TradeVolType(1786)) that can be submitted for a security.',
  },
  {
    abbrName: 'MLEGRptTypReq',
    type: 'MultiLegRptTypeReqCodeSet',
    added: 'FIX.4.3',
    name: 'MultiLegRptTypeReq',
    id: 563,
    description:
      'Indicates the method of execution reporting requested by issuer of the order.',
  },
  {
    abbrName: 'PosEfct',
    type: 'PositionEffectCodeSet',
    added: 'FIX.4.3',
    name: 'LegPositionEffect',
    id: 564,
    description:
      'PositionEffect for leg of a multileg\n\nSee PositionEffect (77) field for description',
  },
  {
    abbrName: 'Cover',
    type: 'CoveredOrUncoveredCodeSet',
    added: 'FIX.4.3',
    name: 'LegCoveredOrUncovered',
    id: 565,
    description:
      'CoveredOrUncovered for leg of a multileg\n\nSee CoveredOrUncovered (203) field for description',
  },
  {
    abbrName: 'Px',
    type: 'Price',
    added: 'FIX.4.3',
    name: 'LegPrice',
    id: 566,
    description: 'Price for leg of a multileg\n\nSee Price (44) field for description',
  },
  {
    type: 'TradSesStatusRejReasonCodeSet',
    unionDataType: 'Reserved100Plus',
    added: 'FIX.4.3',
    name: 'TradSesStatusRejReason',
    id: 567,
    abbrName: 'StatRejRsn',
    description: 'Indicates the reason a Trading Session Status Request was rejected.',
  },
  {
    abbrName: 'ReqID',
    type: 'String',
    added: 'FIX.4.3',
    name: 'TradeRequestID',
    id: 568,
    description: 'Trade Capture Report Request ID',
  },
  {
    abbrName: 'ReqTyp',
    type: 'TradeRequestTypeCodeSet',
    added: 'FIX.4.3',
    name: 'TradeRequestType',
    id: 569,
    description: 'Type of Trade Capture Report.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PreviouslyReportedCodeSet',
    updatedEP: '229',
    added: 'FIX.4.3',
    name: 'PreviouslyReported',
    id: 570,
    abbrName: 'PrevlyRpted',
    description:
      'Indicates if the transaction was previously reported to the counterparty or market.',
  },
  {
    abbrName: 'RptID',
    type: 'String',
    added: 'FIX.4.3',
    name: 'TradeReportID',
    id: 571,
    description: 'Unique identifier of trade capture report',
  },
  {
    abbrName: 'RptRefID',
    type: 'String',
    added: 'FIX.4.3',
    name: 'TradeReportRefID',
    id: 572,
    description: 'Reference identifier used with CANCEL and REPLACE transaction types.',
  },
  {
    abbrName: 'MtchStat',
    type: 'MatchStatusCodeSet',
    added: 'FIX.4.3',
    name: 'MatchStatus',
    id: 573,
    description: 'The status of this trade with respect to matching or comparison.',
  },
  {
    abbrName: 'MtchTyp',
    type: 'MatchTypeCodeSet',
    added: 'FIX.4.3',
    name: 'MatchType',
    id: 574,
    description: 'The point in the matching process at which this trade was matched.',
  },
  {
    type: 'OddLotCodeSet',
    deprecated: 'FIX.5.0',
    added: 'FIX.4.3',
    name: 'OddLot',
    id: 575,
    abbrName: 'OddLot',
    description:
      'This trade is to be treated as an odd lot\n\nIf this field is not specified, the default will be "N"',
  },
  {
    abbrName: 'NoClrngInstrctns',
    type: 'NumInGroup',
    added: 'FIX.4.3',
    name: 'NoClearingInstructions',
    id: 576,
    description: 'Number of clearing instructions',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'ClearingInstructionCodeSet',
    unionDataType: 'Reserved4000Plus',
    updatedEP: '204',
    added: 'FIX.4.3',
    name: 'ClearingInstruction',
    id: 577,
    abbrName: 'ClrngInstrctn',
    description:
      'Eligibility of this trade for clearing and central counterparty processing.',
  },
  {
    abbrName: 'InptSrc',
    type: 'String',
    added: 'FIX.4.3',
    name: 'TradeInputSource',
    id: 578,
    description: 'Type of input device or system from which the trade was entered.',
  },
  {
    abbrName: 'InptDev',
    type: 'String',
    added: 'FIX.4.3',
    name: 'TradeInputDevice',
    id: 579,
    description:
      'Specific device number, terminal number or station where trade was entered',
  },
  {
    updated: 'FIX.Latest',
    type: 'NumInGroup',
    updatedEP: '275',
    added: 'FIX.4.3',
    name: 'NoDates',
    id: 580,
    abbrName: 'NoDts',
    description: 'Number of Date fields provided in date range',
  },
  {
    abbrName: 'AcctTyp',
    type: 'AccountTypeCodeSet',
    added: 'FIX.4.3',
    name: 'AccountType',
    id: 581,
    description: 'Type of account associated with an order',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'CustOrderCapacityCodeSet',
    updatedEP: '205',
    added: 'FIX.4.3',
    name: 'CustOrderCapacity',
    id: 582,
    abbrName: 'CustCpcty',
    description:
      'Capacity of customer placing the order.\n\nUsed by futures exchanges to indicate the CTICode (customer type indicator) as required by the US CFTC (Commodity Futures Trading Commission). May be used as required by other regulatory commissions for similar purposes.',
  },
  {
    type: 'String',
    baseCategoryAbbrName: 'LnkID',
    baseCategory: 'SingleGeneralOrderHandling',
    added: 'FIX.4.3',
    name: 'ClOrdLinkID',
    id: 583,
    abbrName: 'ClOrdLinkID',
    description:
      'Permits order originators to tie together groups of orders in which trades resulting from orders are associated for a specific purpose, for example the calculation of average execution price for a customer or to associate lists submitted to a broker as waves of a larger program trade.',
  },
  {
    type: 'String',
    baseCategoryAbbrName: 'ReqID',
    baseCategory: 'OrderMassHandling',
    added: 'FIX.4.3',
    name: 'MassStatusReqID',
    id: 584,
    abbrName: 'MassStatReqID',
    description:
      'Value assigned by issuer of Mass Status Request to uniquely identify the request',
  },
  {
    updated: 'FIX.Latest',
    type: 'MassStatusReqTypeCodeSet',
    baseCategoryAbbrName: 'ReqTyp',
    baseCategory: 'OrderMassHandling',
    unionDataType: 'Reserved100Plus',
    updatedEP: '271',
    added: 'FIX.4.3',
    name: 'MassStatusReqType',
    id: 585,
    abbrName: 'MassStatReqTyp',
    description: 'Specifies the type or scope of the mass order status request.',
  },
  {
    abbrName: 'OrigOrdModTm',
    type: 'UTCTimestamp',
    added: 'FIX.4.3',
    name: 'OrigOrdModTime',
    id: 586,
    description:
      'The most recent (or current) modification TransactTime (tag 60) reported on an Execution Report for the order. The OrigOrdModTime is provided as an optional field on Order Cancel Request and Order Cancel Replace Requests to identify that the state of the order has not changed since the request was issued. The use of this approach is not recommended.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'SettlTypeCodeSet',
    unionDataType: 'Tenor',
    updatedEP: '187',
    added: 'FIX.4.3',
    name: 'LegSettlType',
    id: 587,
    abbrName: 'SettlTyp',
    description:
      'Indicates order settlement period. If present, LegSettlDate (588) overrides this field. If both LegSettlType (587) and LegSettDate (588) are omitted, the default for LegSettlType (587) is 0 (Regular)\n\nRegular is defined as the default settlement period for the particular security on the exchange of execution.\n\nIn Fixed Income the contents of this field may influence the instrument definition if the LegSecurityID (602) is ambiguous. In the US an active Treasury offering may be re-opened, and for a time one CUSIP will apply to both the current and "when-issued" securities. Supplying a value of "7" clarifies the instrument description; any other value or the absence of this field should cause the respondent to default to the active issue.\n\nAdditionally the following patterns may be uses as well as enum values\n\nDx = FX tenor expression for "days", e.g. "D5", where "x" is any integer > 0\n\nMx = FX tenor expression for "months", e.g. "M3", where "x" is any integer > 0\n\nWx = FX tenor expression for "weeks", e.g. "W13", where "x" is any integer > 0\n\nYx = FX tenor expression for "years", e.g. "Y1", where "x" is any integer > 0.\n\nNote that for FX the tenors expressed using Dx, Mx, Wx, and Yx values do not denote business days, but calendar days.',
  },
  {
    abbrName: 'SettlDt',
    type: 'LocalMktDate',
    added: 'FIX.4.3',
    name: 'LegSettlDate',
    id: 588,
    description: 'Refer to description for SettlDate[64]',
  },
  {
    abbrName: 'DayBkngInst',
    type: 'DayBookingInstCodeSet',
    added: 'FIX.4.3',
    name: 'DayBookingInst',
    id: 589,
    description: 'Indicates whether or not automatic booking can occur.',
  },
  {
    abbrName: 'BkngUnit',
    type: 'BookingUnitCodeSet',
    added: 'FIX.4.3',
    name: 'BookingUnit',
    id: 590,
    description: 'Indicates what constitutes a bookable unit.',
  },
  {
    abbrName: 'PreallocMeth',
    type: 'PreallocMethodCodeSet',
    added: 'FIX.4.3',
    name: 'PreallocMethod',
    id: 591,
    description: 'Indicates the method of preallocation.',
  },
  {
    abbrName: 'Ctry',
    type: 'Country',
    added: 'FIX.4.3',
    name: 'UnderlyingCountryOfIssue',
    id: 592,
    description:
      "Underlying security's CountryOfIssue.\n\nSee CountryOfIssue (470) field for description",
  },
  {
    abbrName: 'StOrProvnc',
    type: 'String',
    added: 'FIX.4.3',
    name: 'UnderlyingStateOrProvinceOfIssue',
    id: 593,
    description:
      "Underlying security's StateOrProvinceOfIssue.\n\nSee StateOrProvinceOfIssue (471) field for description",
  },
  {
    abbrName: 'Lcl',
    type: 'String',
    added: 'FIX.4.3',
    name: 'UnderlyingLocaleOfIssue',
    id: 594,
    description:
      "Underlying security's LocaleOfIssue.\n\nSee LocaleOfIssue (472) field for description",
  },
  {
    abbrName: 'Rgstry',
    type: 'String',
    added: 'FIX.4.3',
    name: 'UnderlyingInstrRegistry',
    id: 595,
    description:
      "Underlying security's InstrRegistry.\n\nSee InstrRegistry (543) field for description",
  },
  {
    abbrName: 'Ctry',
    type: 'Country',
    added: 'FIX.4.3',
    name: 'LegCountryOfIssue',
    id: 596,
    description:
      "Multileg instrument's individual leg security's CountryOfIssue.\n\nSee CountryOfIssue (470) field for description",
  },
  {
    abbrName: 'StOrProvnc',
    type: 'String',
    added: 'FIX.4.3',
    name: 'LegStateOrProvinceOfIssue',
    id: 597,
    description:
      "Multileg instrument's individual leg security's StateOrProvinceOfIssue.\n\nSee StateOrProvinceOfIssue (471) field for description",
  },
  {
    abbrName: 'Lcl',
    type: 'String',
    added: 'FIX.4.3',
    name: 'LegLocaleOfIssue',
    id: 598,
    description:
      "Multileg instrument's individual leg security's LocaleOfIssue.\n\nSee LocaleOfIssue (472) field for description",
  },
  {
    abbrName: 'Rgstry',
    type: 'String',
    added: 'FIX.4.3',
    name: 'LegInstrRegistry',
    id: 599,
    description:
      "Multileg instrument's individual leg security's InstrRegistry.\n\nSee InstrRegistry (543) field for description",
  },
  {
    abbrName: 'Sym',
    type: 'String',
    added: 'FIX.4.3',
    name: 'LegSymbol',
    id: 600,
    description:
      "Multileg instrument's individual security's Symbol.\n\nSee Symbol (55) field for description",
  },
  {
    abbrName: 'Sfx',
    type: 'SymbolSfxCodeSet',
    added: 'FIX.4.3',
    name: 'LegSymbolSfx',
    id: 601,
    description:
      "Multileg instrument's individual security's SymbolSfx.\n\nSee SymbolSfx (65) field for description",
  },
  {
    abbrName: 'ID',
    type: 'String',
    added: 'FIX.4.3',
    name: 'LegSecurityID',
    id: 602,
    discriminatorId: '603',
    description:
      "Multileg instrument's individual security's SecurityID.\n\nSee SecurityID (48) field for description",
  },
  {
    updated: 'FIX.Latest',
    type: 'SecurityIDSourceCodeSet',
    unionDataType: 'Reserved100Plus',
    updatedEP: '265',
    added: 'FIX.4.3',
    name: 'LegSecurityIDSource',
    id: 603,
    abbrName: 'Src',
    description:
      "Multileg instrument's individual security's SecurityIDSource.\n\nSee SecurityIDSource (22) field for description",
  },
  {
    updated: 'FIX.Latest',
    type: 'NumInGroup',
    updatedEP: '275',
    added: 'FIX.4.3',
    name: 'NoLegSecurityAltID',
    id: 604,
    abbrName: 'NoLegSecAltID',
    description:
      "Multileg instrument's individual security's NoSecurityAltID.\n\nSee NoSecurityAltID (454) field for description",
  },
  {
    abbrName: 'SecAltID',
    type: 'String',
    added: 'FIX.4.3',
    name: 'LegSecurityAltID',
    id: 605,
    discriminatorId: '606',
    description:
      "Multileg instrument's individual security's SecurityAltID.\n\nSee SecurityAltID (455) field for description",
  },
  {
    updated: 'FIX.Latest',
    type: 'SecurityIDSourceCodeSet',
    unionDataType: 'Reserved100Plus',
    updatedEP: '271',
    added: 'FIX.4.3',
    name: 'LegSecurityAltIDSource',
    id: 606,
    abbrName: 'SecAltIDSrc',
    description:
      'Alternate identifier for individual leg security of a multileg instrument.\n\nSee SecurityAltIDSource(456) field for complete definition.',
  },
  {
    abbrName: 'Prod',
    type: 'ProductCodeSet',
    added: 'FIX.4.3',
    name: 'LegProduct',
    id: 607,
    description:
      "Multileg instrument's individual security's Product.\n\nSee Product (460) field for description",
  },
  {
    abbrName: 'CFI',
    type: 'String',
    added: 'FIX.4.3',
    name: 'LegCFICode',
    id: 608,
    description:
      "Multileg instrument's individual security's CFICode.\n\nSee CFICode (461) field for description",
  },
  {
    abbrName: 'SecTyp',
    type: 'SecurityTypeCodeSet',
    added: 'FIX.4.3',
    name: 'LegSecurityType',
    id: 609,
    description: 'Refer to definition of SecurityType(167)',
  },
  {
    abbrName: 'MMY',
    type: 'MonthYear',
    added: 'FIX.4.3',
    name: 'LegMaturityMonthYear',
    id: 610,
    description:
      "Multileg instrument's individual security's MaturityMonthYear.\n\nSee MaturityMonthYear (200) field for description",
  },
  {
    updated: 'FIX.Latest',
    type: 'LocalMktDate',
    updatedEP: '282',
    added: 'FIX.4.3',
    name: 'LegMaturityDate',
    id: 611,
    abbrName: 'Mat',
    description:
      "Multileg instrument's individual security's MaturityDate.\n\nSee MaturityDate(541) field for description.",
  },
  {
    abbrName: 'Strk',
    type: 'Price',
    added: 'FIX.4.3',
    name: 'LegStrikePrice',
    id: 612,
    description:
      "Multileg instrument's individual security's StrikePrice.\n\nSee StrikePrice (202) field for description",
  },
  {
    abbrName: 'OptA',
    type: 'char',
    added: 'FIX.4.3',
    name: 'LegOptAttribute',
    id: 613,
    description:
      "Multileg instrument's individual security's OptAttribute.\n\nSee OptAttribute (206) field for description",
  },
  {
    abbrName: 'Cmult',
    type: 'float',
    added: 'FIX.4.3',
    name: 'LegContractMultiplier',
    id: 614,
    description:
      "Multileg instrument's individual security's ContractMultiplier.\n\nSee ContractMultiplier (23) field for description",
  },
  {
    abbrName: 'CpnRt',
    type: 'Percentage',
    added: 'FIX.4.3',
    name: 'LegCouponRate',
    id: 615,
    description:
      "Multileg instrument's individual security's CouponRate.\n\nSee CouponRate (223) field for description",
  },
  {
    abbrName: 'Exch',
    type: 'Exchange',
    added: 'FIX.4.3',
    name: 'LegSecurityExchange',
    id: 616,
    description:
      "Multileg instrument's individual security's SecurityExchange.\n\nSee SecurityExchange (207) field for description",
  },
  {
    abbrName: 'Issr',
    type: 'String',
    added: 'FIX.4.3',
    name: 'LegIssuer',
    id: 617,
    description:
      "Multileg instrument's individual security's Issuer.\n\nSee Issuer (106) field for description",
  },
  {
    abbrName: 'EncLegIssrLen',
    type: 'Length',
    added: 'FIX.4.3',
    name: 'EncodedLegIssuerLen',
    id: 618,
    description:
      "Multileg instrument's individual security's EncodedIssuerLen.\n\nSee EncodedIssuerLen (348) field for description",
  },
  {
    abbrName: 'EncLegIssr',
    type: 'data',
    added: 'FIX.4.3',
    name: 'EncodedLegIssuer',
    id: 619,
    lengthId: '618',
    description:
      "Multileg instrument's individual security's EncodedIssuer.\n\nSee EncodedIssuer (349) field for description",
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    updatedEP: '232',
    added: 'FIX.4.3',
    name: 'LegSecurityDesc',
    id: 620,
    abbrName: 'Desc',
    description:
      'Description of a multileg instrument.\n\nCan be used by the venue or one of the trading parties to provide an optional non-normative textual description of the financial instrument.',
  },
  {
    abbrName: 'EncLegSecDescLen',
    type: 'Length',
    added: 'FIX.4.3',
    name: 'EncodedLegSecurityDescLen',
    id: 621,
    description:
      "Multileg instrument's individual security's EncodedSecurityDescLen.\n\nSee EncodedSecurityDescLen (350) field for description",
  },
  {
    abbrName: 'EncLegSecDesc',
    type: 'data',
    added: 'FIX.4.3',
    name: 'EncodedLegSecurityDesc',
    id: 622,
    lengthId: '621',
    description:
      "Multileg instrument's individual security's EncodedSecurityDesc.\n\nSee EncodedSecurityDesc (35) field for description",
  },
  {
    abbrName: 'RatioQty',
    type: 'float',
    added: 'FIX.4.3',
    name: 'LegRatioQty',
    id: 623,
    description:
      'The ratio of quantity for this individual leg relative to the entire multileg security.',
  },
  {
    abbrName: 'Side',
    type: 'SideCodeSet',
    added: 'FIX.4.3',
    name: 'LegSide',
    id: 624,
    description:
      'The side of this individual leg (multileg security).\n\nSee Side (54) field for description and values',
  },
  {
    type: 'TradingSessionSubIDCodeSet',
    unionDataType: 'Reserved100Plus',
    added: 'FIX.4.3',
    name: 'TradingSessionSubID',
    id: 625,
    abbrName: 'SesSub',
    description:
      'Optional market assigned sub identifier for a trading phase within a trading session. Usage is determined by market or counterparties. Used by US based futures markets to identify exchange specific execution time bracket codes as required by US market regulations. Bilaterally agreed values of data type "String" that start with a character can be used for backward compatibility',
  },
  {
    type: 'AllocTypeCodeSet',
    baseCategoryAbbrName: 'Typ',
    baseCategory: 'Allocation',
    added: 'FIX.4.3',
    name: 'AllocType',
    id: 626,
    abbrName: 'AllocType',
    description:
      'Describes the specific type or purpose of an Allocation message (i.e. "Buyside Calculated")\n\n(see Volume : "Glossary" for value definitions)\n\n*** SOME VALUES HAVE BEEN REPLACED - See "Replaced Features and Supported Approach" ***',
  },
  {
    abbrName: 'NoHops',
    type: 'NumInGroup',
    added: 'FIX.4.3',
    name: 'NoHops',
    id: 627,
    description: 'Number of HopCompID entries in repeating group.',
  },
  {
    abbrName: 'ID',
    type: 'String',
    added: 'FIX.4.3',
    name: 'HopCompID',
    id: 628,
    description:
      'Assigned value used to identify the third party firm which delivered a specific message either from the firm which originated the message or from another third party (if multiple "hops" are performed). It is recommended that this value be the SenderCompID (49) of the third party.\n\nApplicable when messages are communicated/re-distributed via third parties which function as service bureaus or "hubs". Only applicable if OnBehalfOfCompID (115) is being used.',
  },
  {
    abbrName: 'Snt',
    type: 'UTCTimestamp',
    added: 'FIX.4.3',
    name: 'HopSendingTime',
    id: 629,
    description:
      'Time that HopCompID (628) sent the message. It is recommended that this value be the SendingTime (52) of the message sent by the third party.\n\nApplicable when messages are communicated/re-distributed via third parties which function as service bureaus or "hubs". Only applicable if OnBehalfOfCompID (115) is being used.',
  },
  {
    abbrName: 'Ref',
    type: 'SeqNum',
    added: 'FIX.4.3',
    name: 'HopRefID',
    id: 630,
    description:
      'Reference identifier assigned by HopCompID (628) associated with the message sent. It is recommended that this value be the MsgSeqNum (34) of the message sent by the third party.\n\nApplicable when messages are communicated/re-distributed via third parties which function as service bureaus or "hubs". Only applicable if OnBehalfOfCompID (115) is being used.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'Price',
    updatedEP: '175',
    added: 'FIX.4.3',
    name: 'MidPx',
    id: 631,
    abbrName: 'MidPx',
    description:
      'Mid price/rate.\n\nFor OTC swaps this is the mid-market mark (for example, as defined by CFTC).\n\nFor uncleared OTC swaps, LegMidPx(2346) and the MidPx(631) fields are mutually exclusive.',
  },
  {
    abbrName: 'BidYld',
    type: 'Percentage',
    added: 'FIX.4.3',
    name: 'BidYield',
    id: 632,
    description: 'Bid yield',
  },
  {
    abbrName: 'MidYld',
    type: 'Percentage',
    added: 'FIX.4.3',
    name: 'MidYield',
    id: 633,
    description: 'Mid yield',
  },
  {
    abbrName: 'OfrYld',
    type: 'Percentage',
    added: 'FIX.4.3',
    name: 'OfferYield',
    id: 634,
    description: 'Offer yield',
  },
  {
    abbrName: 'ClrFeeInd',
    type: 'ClearingFeeIndicatorCodeSet',
    added: 'FIX.4.3',
    name: 'ClearingFeeIndicator',
    id: 635,
    description:
      'Indicates type of fee being assessed of the customer for trade executions at an exchange. Applicable for futures markets only at this time.\n\n(Values source CBOT, CME, NYBOT, and NYMEX):',
  },
  {
    abbrName: 'WorkingInd',
    type: 'WorkingIndicatorCodeSet',
    added: 'FIX.4.3',
    name: 'WorkingIndicator',
    id: 636,
    description:
      'Indicates if the order is currently being worked. Applicable only for OrdStatus = "New". For open outcry markets this indicates that the order is being worked in the crowd. For electronic markets it indicates that the order has transitioned from a contingent order to a market order.',
  },
  {
    abbrName: 'LastPx',
    type: 'Price',
    added: 'FIX.4.3',
    name: 'LegLastPx',
    id: 637,
    description:
      'Execution price assigned to a leg of a multileg instrument.\n\nSee LastPx (31) field for description and values',
  },
  {
    abbrName: 'PriInd',
    type: 'PriorityIndicatorCodeSet',
    added: 'FIX.4.3',
    name: 'PriorityIndicator',
    id: 638,
    description:
      'Indicates if a Cancel/Replace has caused an order to lose book priority.',
  },
  {
    abbrName: 'PxImprvmnt',
    type: 'PriceOffset',
    added: 'FIX.4.3',
    name: 'PriceImprovement',
    id: 639,
    description: 'Amount of price improvement.',
  },
  {
    type: 'Price',
    deprecated: 'FIX.5.0',
    added: 'FIX.4.3',
    name: 'Price2',
    id: 640,
    abbrName: 'Px2',
    description:
      'Price of the future part of a F/X swap order.\n\nSee Price (44) for description.',
  },
  {
    updated: 'FIX.Latest',
    type: 'PriceOffset',
    deprecated: 'FIX.5.0',
    updatedEP: '282',
    added: 'FIX.4.3',
    name: 'LastForwardPoints2',
    id: 641,
    abbrName: 'LastFwdPnts2',
    description:
      'F/X forward points of the future part of a F/X swap order added to LastSpotRate(194). May be a negative value.',
  },
  {
    type: 'PriceOffset',
    deprecated: 'FIX.5.0',
    added: 'FIX.4.3',
    name: 'BidForwardPoints2',
    id: 642,
    abbrName: 'BidFwdPnts2',
    description:
      'Bid F/X forward points of the future portion of a F/X swap quote added to spot rate. May be a negative value.',
  },
  {
    type: 'PriceOffset',
    deprecated: 'FIX.5.0',
    added: 'FIX.4.3',
    name: 'OfferForwardPoints2',
    id: 643,
    abbrName: 'OfrFwdPnts2',
    description:
      'Offer F/X forward points of the future portion of a F/X swap quote added to spot rate. May be a negative value.',
  },
  {
    abbrName: 'RFQReqID',
    type: 'String',
    added: 'FIX.4.3',
    name: 'RFQReqID',
    id: 644,
    description: 'RFQ Request ID - used to identify an RFQ Request.',
  },
  {
    abbrName: 'MktBidPx',
    type: 'Price',
    added: 'FIX.4.3',
    name: 'MktBidPx',
    id: 645,
    description: 'Used to indicate the best bid in a market',
  },
  {
    abbrName: 'MktOfrPx',
    type: 'Price',
    added: 'FIX.4.3',
    name: 'MktOfferPx',
    id: 646,
    description: 'Used to indicate the best offer in a market',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'Qty',
    updatedEP: '208',
    added: 'FIX.4.3',
    name: 'MinBidSize',
    id: 647,
    abbrName: 'MinBidSz',
    description: 'Used to indicate a minimum quantity for a bid.',
  },
  {
    abbrName: 'MinOfrSz',
    type: 'Qty',
    added: 'FIX.4.3',
    name: 'MinOfferSize',
    id: 648,
    description:
      'Used to indicate a minimum quantity for an offer. If this field is used the OfferSize (135) field is interpreted as the maximum offer size.',
  },
  {
    abbrName: 'StatReqID',
    type: 'String',
    added: 'FIX.4.3',
    name: 'QuoteStatusReqID',
    id: 649,
    description: 'Unique identifier for Quote Status Request.',
  },
  {
    abbrName: 'LegalCnfm',
    type: 'LegalConfirmCodeSet',
    added: 'FIX.4.3',
    name: 'LegalConfirm',
    id: 650,
    description:
      'Indicates that this message is to serve as the final and legal confirmation.',
  },
  {
    abbrName: 'UndLastPx',
    type: 'Price',
    added: 'FIX.4.3',
    name: 'UnderlyingLastPx',
    id: 651,
    description:
      'The calculated or traded price for the underlying instrument that corresponds to a derivative. Used for transactions that include the cash instrument and the derivative.',
  },
  {
    abbrName: 'UndLastQty',
    type: 'Qty',
    added: 'FIX.4.3',
    name: 'UnderlyingLastQty',
    id: 652,
    description:
      'The calculated or traded quantity for the underlying instrument that corresponds to a derivative. Used for transactions that include the cash instrument and the derivative.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    updatedEP: '131',
    added: 'FIX.4.3',
    name: 'LegRefID',
    id: 654,
    abbrName: 'RefID',
    description:
      'Unique identifier for a specific leg (uniqueness not defined as part of the FIX specification). LegRefID(654) be used to reference the value from LegID(1788).',
  },
  {
    type: 'String',
    baseCategoryAbbrName: 'LegRefID',
    baseCategory: 'SingleGeneralOrderHandling',
    added: 'FIX.4.3',
    name: 'ContraLegRefID',
    id: 655,
    abbrName: 'CntraLegRefID',
    description: 'Unique indicator for a specific leg for the ContraBroker (375).',
  },
  {
    abbrName: 'SettlCurrBidFxRt',
    type: 'float',
    added: 'FIX.4.3',
    name: 'SettlCurrBidFxRate',
    id: 656,
    description:
      'Foreign exchange rate used to compute the bid "SettlCurrAmt" (119) from Currency (15) to SettlCurrency (120)',
  },
  {
    abbrName: 'SettlCurrOfrFxRt',
    type: 'float',
    added: 'FIX.4.3',
    name: 'SettlCurrOfferFxRate',
    id: 657,
    description:
      'Foreign exchange rate used to compute the offer "SettlCurrAmt" (119) from Currency (15) to SettlCurrency (120)',
  },
  {
    type: 'QuoteRequestRejectReasonCodeSet',
    unionDataType: 'Reserved100Plus',
    added: 'FIX.4.3',
    name: 'QuoteRequestRejectReason',
    id: 658,
    abbrName: 'ReqRejRsn',
    description: 'Reason Quote was rejected:',
  },
  {
    abbrName: 'SideComplianceID',
    type: 'String',
    added: 'FIX.4.3',
    name: 'SideComplianceID',
    id: 659,
    description:
      'ID within repeating group of sides which is used to represent this transaction for compliance purposes (e.g. OATS reporting).',
  },
  {
    type: 'AcctIDSourceCodeSet',
    unionDataType: 'Reserved100Plus',
    added: 'FIX.4.4',
    name: 'AcctIDSource',
    id: 660,
    abbrName: 'AcctIDSrc',
    description:
      'Used to identify the source of the Account (1) code. This is especially useful if the account is a new account that the Respondent may not have setup yet in their system.',
  },
  {
    abbrName: 'ActIDSrc',
    type: 'AcctIDSourceCodeSet',
    added: 'FIX.4.4',
    name: 'AllocAcctIDSource',
    id: 661,
    description:
      'Used to identify the source of the AllocAccount (79) code.\n\nSee AcctIDSource (660) for valid values.',
  },
  {
    abbrName: 'Px',
    type: 'Price',
    added: 'FIX.4.4',
    name: 'BenchmarkPrice',
    id: 662,
    description: 'Specifies the price of the benchmark.',
  },
  {
    abbrName: 'PxTyp',
    type: 'PriceTypeCodeSet',
    added: 'FIX.4.4',
    name: 'BenchmarkPriceType',
    id: 663,
    description:
      'Identifies type of BenchmarkPrice (662).\n\nSee PriceType (423) for valid values.',
  },
  {
    abbrName: 'CnfmID',
    type: 'String',
    added: 'FIX.4.4',
    name: 'ConfirmID',
    id: 664,
    description: 'Message reference for Confirmation',
  },
  {
    abbrName: 'CnfmStat',
    type: 'ConfirmStatusCodeSet',
    added: 'FIX.4.4',
    name: 'ConfirmStatus',
    id: 665,
    description: 'Identifies the status of the Confirmation.',
  },
  {
    abbrName: 'CnfmTransTyp',
    type: 'ConfirmTransTypeCodeSet',
    added: 'FIX.4.4',
    name: 'ConfirmTransType',
    id: 666,
    description: 'Identifies the Confirmation transaction type.',
  },
  {
    abbrName: 'CSetMo',
    type: 'MonthYear',
    added: 'FIX.4.4',
    name: 'ContractSettlMonth',
    id: 667,
    description: 'Specifies when the contract (i.e. MBS/TBA) will settle.',
  },
  {
    abbrName: 'DlvryForm',
    type: 'DeliveryFormCodeSet',
    added: 'FIX.4.4',
    name: 'DeliveryForm',
    id: 668,
    description: 'Identifies the form of delivery.',
  },
  {
    abbrName: 'LastParPx',
    type: 'Price',
    added: 'FIX.4.4',
    name: 'LastParPx',
    id: 669,
    description:
      'Last price expressed in percent-of-par. Conditionally required for Fixed Income trades when LastPx (31) is expressed in Yield, Spread, Discount or any other type.\n\nUsage: Execution Report and Allocation Report repeating executions block (from sellside).',
  },
  {
    abbrName: 'NoLegAllocs',
    type: 'NumInGroup',
    added: 'FIX.4.4',
    name: 'NoLegAllocs',
    id: 670,
    description: 'Number of Allocations for the leg',
  },
  {
    abbrName: 'AllocAcct',
    type: 'String',
    added: 'FIX.4.4',
    name: 'LegAllocAccount',
    id: 671,
    description:
      'Allocation Account for the leg\n\nSee AllocAccount (79) for description and valid values.',
  },
  {
    abbrName: 'IndAllocID',
    type: 'String',
    added: 'FIX.4.4',
    name: 'LegIndividualAllocID',
    id: 672,
    description:
      'Reference for the individual allocation ticket\n\nSee IndividualAllocID (467) for description and valid values.',
  },
  {
    abbrName: 'AllocQty',
    type: 'Qty',
    added: 'FIX.4.4',
    name: 'LegAllocQty',
    id: 673,
    description:
      'Leg allocation quantity.\n\nSee AllocQty (80) for description and valid values.',
  },
  {
    updated: 'FIX.Latest',
    type: 'AcctIDSourceCodeSet',
    updatedEP: '271',
    added: 'FIX.4.4',
    name: 'LegAllocAcctIDSource',
    id: 674,
    abbrName: 'AllocAcctIDSrc',
    description: 'Identifies the source of the LegAllocAccount(671).',
  },
  {
    abbrName: 'SettlCcy',
    type: 'Currency',
    added: 'FIX.4.4',
    name: 'LegSettlCurrency',
    id: 675,
    description:
      'Identifies settlement currency for the Leg.\n\nSee SettlCurrency (20) for description and valid values',
  },
  {
    abbrName: 'Ccy',
    type: 'Currency',
    added: 'FIX.4.4',
    name: 'LegBenchmarkCurveCurrency',
    id: 676,
    description:
      'LegBenchmarkPrice (679) currency\n\nSee BenchmarkCurveCurrency (220) for description and valid values.',
  },
  {
    abbrName: 'Name',
    type: 'BenchmarkCurveNameCodeSet',
    added: 'FIX.4.4',
    name: 'LegBenchmarkCurveName',
    id: 677,
    description:
      'Name of the Leg Benchmark Curve.\n\nSee BenchmarkCurveName (22) for description and valid values.',
  },
  {
    abbrName: 'Point',
    type: 'String',
    added: 'FIX.4.4',
    name: 'LegBenchmarkCurvePoint',
    id: 678,
    description:
      'Identifies the point on the Leg Benchmark Curve.\n\nSee BenchmarkCurvePoint (222) for description and valid values.',
  },
  {
    abbrName: 'Px',
    type: 'Price',
    added: 'FIX.4.4',
    name: 'LegBenchmarkPrice',
    id: 679,
    description:
      'Used to identify the price of the benchmark security.\n\nSee BenchmarkPrice (662) for description and valid values.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PriceTypeCodeSet',
    updatedEP: '204',
    added: 'FIX.4.4',
    name: 'LegBenchmarkPriceType',
    id: 680,
    abbrName: 'PxTyp',
    description: 'The price type of the LegBenchmarkPrice(679).',
  },
  {
    abbrName: 'BidPx',
    type: 'Price',
    added: 'FIX.4.4',
    name: 'LegBidPx',
    id: 681,
    description:
      'Bid price of this leg.\n\nSee BidPx (32) for description and valid values.',
  },
  {
    type: 'IOIQtyCodeSet',
    unionDataType: 'Qty',
    added: 'FIX.4.4',
    name: 'LegIOIQty',
    id: 682,
    abbrName: 'IOIQty',
    description:
      'Leg-specific IOI quantity.\n\nSee IOIQty (27) for description and valid values',
  },
  {
    abbrName: 'NoLegStips',
    type: 'NumInGroup',
    added: 'FIX.4.4',
    name: 'NoLegStipulations',
    id: 683,
    description: 'Number of leg stipulation entries',
  },
  {
    abbrName: 'OfrPx',
    type: 'Price',
    added: 'FIX.4.4',
    name: 'LegOfferPx',
    id: 684,
    description:
      'Offer price of this leg.\n\nSee OfferPx (133) for description and valid values',
  },
  {
    abbrName: 'OrdQty',
    type: 'Qty',
    added: 'FIX.4.4',
    name: 'LegOrderQty',
    id: 685,
    description:
      'Quantity ordered of this leg.\n\nSee OrderQty (38) for description and valid values',
  },
  {
    abbrName: 'PxTyp',
    type: 'PriceTypeCodeSet',
    added: 'FIX.4.4',
    name: 'LegPriceType',
    id: 686,
    description:
      'The price type of the LegBidPx (681) and/or LegOfferPx (684).\n\nSee PriceType (423) for description and valid values',
  },
  {
    updated: 'FIX.Latest',
    type: 'Qty',
    deprecated: 'FIX.5.0SP1',
    updatedEP: '271',
    added: 'FIX.4.4',
    name: 'LegQty',
    id: 687,
    abbrName: 'Qty',
    description:
      'This field is deprecated and has been replaced by LegOrderQty(685). This field will likely be removed from the FIX standard in a future version.',
  },
  {
    abbrName: 'StipTyp',
    type: 'StipulationTypeCodeSet',
    added: 'FIX.4.4',
    name: 'LegStipulationType',
    id: 688,
    description:
      'For Fixed Income, type of Stipulation for this leg.\n\nSee StipulationType (233) for description and valid values',
  },
  {
    abbrName: 'StipVal',
    type: 'String',
    added: 'FIX.4.4',
    name: 'LegStipulationValue',
    id: 689,
    description:
      'For Fixed Income, value of stipulation.\n\nSee StipulationValue (234) for description and valid values',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'LegSwapTypeCodeSet',
    updatedEP: '131',
    added: 'FIX.4.4',
    name: 'LegSwapType',
    id: 690,
    abbrName: 'SwapTyp',
    description:
      'For Fixed Income, used instead of LegOrderQty(685) to requests the respondent to calculate the quantity based on the quantity on the opposite side of the swap.',
  },
  {
    abbrName: 'Pool',
    type: 'String',
    added: 'FIX.4.4',
    name: 'Pool',
    id: 691,
    description: 'For Fixed Income, identifies MBS / ABS pool.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'QuotePriceTypeCodeSet',
    updatedEP: '207',
    added: 'FIX.4.4',
    name: 'QuotePriceType',
    id: 692,
    abbrName: 'QuotPxTyp',
    description:
      'Code to represent price type requested in Quote.\n\nIf the Quote Request is for a Swap, values 1-8 apply to all legs.',
  },
  {
    abbrName: 'RspID',
    type: 'String',
    added: 'FIX.4.4',
    name: 'QuoteRespID',
    id: 693,
    description: 'Message reference for Quote Response',
  },
  {
    abbrName: 'RspTyp',
    type: 'QuoteRespTypeCodeSet',
    added: 'FIX.4.4',
    name: 'QuoteRespType',
    id: 694,
    description: 'Identifies the type of Quote Response.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'IOIQualifierCodeSet',
    updatedEP: '226',
    added: 'FIX.4.4',
    name: 'QuoteQualifier',
    id: 695,
    abbrName: 'Qual',
    description: 'Code to qualify Quote use and other aspects of price negotiation.',
  },
  {
    abbrName: 'RedDt',
    type: 'LocalMktDate',
    added: 'FIX.4.4',
    name: 'YieldRedemptionDate',
    id: 696,
    description:
      'Date to which the yield has been calculated (i.e. maturity, par call or current call, pre-refunded date).',
  },
  {
    abbrName: 'RedPx',
    type: 'Price',
    added: 'FIX.4.4',
    name: 'YieldRedemptionPrice',
    id: 697,
    description: 'Price to which the yield has been calculated.',
  },
  {
    abbrName: 'RedPxTyp',
    type: 'PriceTypeCodeSet',
    added: 'FIX.4.4',
    name: 'YieldRedemptionPriceType',
    id: 698,
    description:
      'The price type of the YieldRedemptionPrice (697)\n\nSee PriceType (423) for description and valid values.',
  },
  {
    abbrName: 'SecID',
    type: 'String',
    added: 'FIX.4.4',
    name: 'BenchmarkSecurityID',
    id: 699,
    discriminatorId: '761',
    description:
      'The identifier of the benchmark security, e.g. Treasury against Corporate bond.\n\nSee SecurityID (tag 48) for description and valid values.',
  },
  {
    abbrName: 'ReversalInd',
    type: 'Boolean',
    added: 'FIX.4.4',
    name: 'ReversalIndicator',
    id: 700,
    description: 'Indicates a trade that reverses a previous trade.',
  },
  {
    abbrName: 'CalcDt',
    type: 'LocalMktDate',
    added: 'FIX.4.4',
    name: 'YieldCalcDate',
    id: 701,
    description:
      'Include as needed to clarify yield irregularities associated with date, e.g. when it falls on a non-business day.',
  },
  {
    abbrName: 'NoPoss',
    type: 'NumInGroup',
    added: 'FIX.4.4',
    name: 'NoPositions',
    id: 702,
    description: 'Number of position entries.',
  },
  {
    abbrName: 'Typ',
    type: 'PosTypeCodeSet',
    added: 'FIX.4.4',
    name: 'PosType',
    id: 703,
    description: 'Used to identify the type of quantity that is being returned.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'Qty',
    updatedEP: '141',
    added: 'FIX.4.4',
    name: 'LongQty',
    id: 704,
    abbrName: 'Long',
    description: 'Long quantity.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'Qty',
    updatedEP: '141',
    added: 'FIX.4.4',
    name: 'ShortQty',
    id: 705,
    abbrName: 'Short',
    description: 'Short quantity.',
  },
  {
    abbrName: 'Stat',
    type: 'PosQtyStatusCodeSet',
    added: 'FIX.4.4',
    name: 'PosQtyStatus',
    id: 706,
    description: 'Status of this position.',
  },
  {
    abbrName: 'Typ',
    type: 'PosAmtTypeCodeSet',
    added: 'FIX.4.4',
    name: 'PosAmtType',
    id: 707,
    description: 'Type of Position amount',
  },
  {
    abbrName: 'Amt',
    type: 'Amt',
    added: 'FIX.4.4',
    name: 'PosAmt',
    id: 708,
    description: 'Position amount',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PosTransTypeCodeSet',
    updatedEP: '199',
    added: 'FIX.4.4',
    name: 'PosTransType',
    id: 709,
    abbrName: 'TxnTyp',
    description: 'Identifies the type of position transaction.',
  },
  {
    abbrName: 'ReqID',
    type: 'String',
    added: 'FIX.4.4',
    name: 'PosReqID',
    id: 710,
    description:
      'Unique identifier for the position maintenance request as assigned by the submitter',
  },
  {
    abbrName: 'NoUnds',
    type: 'NumInGroup',
    added: 'FIX.4.4',
    name: 'NoUnderlyings',
    id: 711,
    description: 'Number of underlying legs that make up the security.',
  },
  {
    abbrName: 'Actn',
    type: 'PosMaintActionCodeSet',
    added: 'FIX.4.4',
    name: 'PosMaintAction',
    id: 712,
    description: 'Maintenance Action to be performed.',
  },
  {
    type: 'String',
    baseCategoryAbbrName: 'OrigReqRefID',
    baseCategory: 'PositionMaintenance',
    added: 'FIX.4.4',
    name: 'OrigPosReqRefID',
    id: 713,
    abbrName: 'OrigPosReqRefID',
    description:
      'Reference to the PosReqID (710) of a previous maintenance request that is being replaced or canceled.',
  },
  {
    abbrName: 'RptRefID',
    type: 'String',
    added: 'FIX.4.4',
    name: 'PosMaintRptRefID',
    id: 714,
    description:
      'Reference to a PosMaintRptID (721) from a previous Position Maintenance Report that is being replaced or canceled.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'LocalMktDate',
    updatedEP: '150',
    added: 'FIX.4.4',
    name: 'ClearingBusinessDate',
    id: 715,
    abbrName: 'BizDt',
    description: 'The business date for which the trade is expected to be cleared.',
  },
  {
    abbrName: 'SetSesID',
    type: 'SettlSessIDCodeSet',
    added: 'FIX.4.4',
    name: 'SettlSessID',
    id: 716,
    description: 'Identifies a specific settlement session',
  },
  {
    abbrName: 'SetSesSub',
    type: 'String',
    added: 'FIX.4.4',
    name: 'SettlSessSubID',
    id: 717,
    description: 'SubID value associated with SettlSessID(716)',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'AdjustmentTypeCodeSet',
    updatedEP: '155',
    added: 'FIX.4.4',
    name: 'AdjustmentType',
    id: 718,
    abbrName: 'AdjTyp',
    description:
      'Type of adjustment to be applied. Used for Position Change Submission (PCS), Position Adjustment (PAJ), and Customer Gross Margin (CGM).',
  },
  {
    type: 'Boolean',
    baseCategoryAbbrName: 'InstrctnInd',
    baseCategory: 'SingleGeneralOrderHandling',
    added: 'FIX.4.4',
    name: 'ContraryInstructionIndicator',
    id: 719,
    abbrName: 'CntraryInstrctnInd',
    description:
      'Used to indicate when a contrary instruction for exercise or abandonment is being submitted',
  },
  {
    abbrName: 'PriorSpreadInd',
    type: 'Boolean',
    added: 'FIX.4.4',
    name: 'PriorSpreadIndicator',
    id: 720,
    description: "Indicates if requesting a rollover of prior day's spread submissions.",
  },
  {
    abbrName: 'RptID',
    type: 'String',
    added: 'FIX.4.4',
    name: 'PosMaintRptID',
    id: 721,
    description: 'Unique identifier for this position report',
  },
  {
    abbrName: 'Stat',
    type: 'PosMaintStatusCodeSet',
    added: 'FIX.4.4',
    name: 'PosMaintStatus',
    id: 722,
    description: 'Status of Position Maintenance Request',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PosMaintResultCodeSet',
    unionDataType: 'Reserved100Plus',
    updatedEP: '204',
    added: 'FIX.4.4',
    name: 'PosMaintResult',
    id: 723,
    abbrName: 'Rslt',
    description: 'Result of Position Maintenance Request.',
  },
  {
    abbrName: 'ReqTyp',
    type: 'PosReqTypeCodeSet',
    added: 'FIX.4.4',
    name: 'PosReqType',
    id: 724,
    description: 'Used to specify the type of position request being made.',
  },
  {
    updated: 'FIX.Latest',
    type: 'ResponseTransportTypeCodeSet',
    updatedEP: '282',
    added: 'FIX.4.4',
    name: 'ResponseTransportType',
    id: 725,
    abbrName: 'RspTransportTyp',
    description: 'Identifies how the response to the request should be transmitted.',
  },
  {
    abbrName: 'RspDest',
    type: 'String',
    added: 'FIX.4.4',
    name: 'ResponseDestination',
    id: 726,
    description:
      'URI (Uniform Resource Identifier) for details) or other pre-arranged value. Used in conjunction with ResponseTransportType (725) value of Out-of-Band to identify the out-of-band destination.\n\nSee "Appendix 6-B FIX Fields Based Upon Other Standards"',
  },
  {
    deprecatedEP: '102',
    type: 'int',
    deprecated: 'FIX.5.0SP2',
    added: 'FIX.4.4',
    name: 'TotalNumPosReports',
    id: 727,
    abbrName: 'TotRpts',
    description: 'Total number of Position Reports being returned.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PosReqResultCodeSet',
    unionDataType: 'Reserved100Plus',
    updatedEP: '204',
    added: 'FIX.4.4',
    name: 'PosReqResult',
    id: 728,
    abbrName: 'Rslt',
    description: 'Result of Request for Positions.',
  },
  {
    abbrName: 'Stat',
    type: 'PosReqStatusCodeSet',
    added: 'FIX.4.4',
    name: 'PosReqStatus',
    id: 729,
    description: 'Status of Request for Positions',
  },
  {
    abbrName: 'SetPx',
    type: 'Price',
    added: 'FIX.4.4',
    name: 'SettlPrice',
    id: 730,
    description: 'Settlement price',
  },
  {
    abbrName: 'SetPxTyp',
    type: 'SettlPriceTypeCodeSet',
    added: 'FIX.4.4',
    name: 'SettlPriceType',
    id: 731,
    description: 'Type of settlement price',
  },
  {
    abbrName: 'UndSetPx',
    type: 'Price',
    added: 'FIX.4.4',
    name: 'UnderlyingSettlPrice',
    id: 732,
    description:
      "Underlying security's SettlPrice.\n\nSee SettlPrice (730) field for description",
  },
  {
    abbrName: 'UndSetPxTyp',
    type: 'SettlPriceTypeCodeSet',
    added: 'FIX.4.4',
    name: 'UnderlyingSettlPriceType',
    id: 733,
    description:
      "Underlying security's SettlPriceType.\n\nSee SettlPriceType (731) field for description",
  },
  {
    abbrName: 'PriSetPx',
    type: 'Price',
    added: 'FIX.4.4',
    name: 'PriorSettlPrice',
    id: 734,
    description: 'Previous settlement price',
  },
  {
    abbrName: 'NoQuotQuals',
    type: 'NumInGroup',
    added: 'FIX.4.4',
    name: 'NoQuoteQualifiers',
    id: 735,
    description: 'Number of repeating groups of QuoteQualifiers (695).',
  },
  {
    abbrName: 'AllocSettlCcy',
    type: 'Currency',
    added: 'FIX.4.4',
    name: 'AllocSettlCurrency',
    id: 736,
    description:
      'Currency code of settlement denomination for a specific AllocAccount (79).',
  },
  {
    type: 'Amt',
    baseCategoryAbbrName: 'SettlCcyAmt',
    baseCategory: 'Allocation',
    added: 'FIX.4.4',
    name: 'AllocSettlCurrAmt',
    id: 737,
    abbrName: 'AllocSettlCurrAmt',
    description:
      'Total amount due expressed in settlement currency (includes the effect of the forex transaction) for a specific AllocAccount (79).',
  },
  {
    abbrName: 'IntAtMat',
    type: 'Amt',
    added: 'FIX.4.4',
    name: 'InterestAtMaturity',
    id: 738,
    description: 'Amount of interest (i.e. lump-sum) at maturity.',
  },
  {
    abbrName: 'Dated',
    type: 'LocalMktDate',
    added: 'FIX.4.4',
    name: 'LegDatedDate',
    id: 739,
    description:
      'The effective date of a new securities issue determined by its underwriters. Often but not always the same as the Issue Date and the Interest Accrual Date',
  },
  {
    abbrName: 'Pool',
    type: 'String',
    added: 'FIX.4.4',
    name: 'LegPool',
    id: 740,
    description:
      'For Fixed Income, identifies MBS / ABS pool for a specific leg of a multi-leg instrument.\n\nSee Pool (691) for description and valid values.',
  },
  {
    abbrName: 'IntAtMat',
    type: 'Amt',
    added: 'FIX.4.4',
    name: 'AllocInterestAtMaturity',
    id: 741,
    description: 'Amount of interest (i.e. lump-sum) at maturity at the account-level.',
  },
  {
    abbrName: 'AcrdIntAmt',
    type: 'Amt',
    added: 'FIX.4.4',
    name: 'AllocAccruedInterestAmt',
    id: 742,
    description:
      'Amount of Accrued Interest for convertible bonds and fixed income at the allocation-level.',
  },
  {
    abbrName: 'DlvDt',
    type: 'LocalMktDate',
    added: 'FIX.4.4',
    name: 'DeliveryDate',
    id: 743,
    description: 'Date of delivery.',
  },
  {
    abbrName: 'AsgnMeth',
    type: 'AssignmentMethodCodeSet',
    added: 'FIX.4.4',
    name: 'AssignmentMethod',
    id: 744,
    description:
      'Method by which short positions are assigned to an exercise notice during exercise and assignment processing',
  },
  {
    abbrName: 'Unit',
    type: 'Qty',
    added: 'FIX.4.4',
    name: 'AssignmentUnit',
    id: 745,
    description: 'Quantity Increment used in performing assignment.',
  },
  {
    abbrName: 'OpenInt',
    type: 'Amt',
    added: 'FIX.4.4',
    name: 'OpenInterest',
    id: 746,
    description: 'Open interest that was eligible for assignment.',
  },
  {
    abbrName: 'ExrMethod',
    type: 'ExerciseMethodCodeSet',
    added: 'FIX.4.4',
    name: 'ExerciseMethod',
    id: 747,
    description: 'Exercise Method used to in performing assignment.',
  },
  {
    abbrName: 'TotNumTrdRpts',
    type: 'int',
    added: 'FIX.4.4',
    name: 'TotNumTradeReports',
    id: 748,
    description: 'Total number of trade reports returned.',
  },
  {
    type: 'TradeRequestResultCodeSet',
    unionDataType: 'Reserved100Plus',
    added: 'FIX.4.4',
    name: 'TradeRequestResult',
    id: 749,
    abbrName: 'ReqRslt',
    description: 'Result of Trade Request',
  },
  {
    abbrName: 'ReqStat',
    type: 'TradeRequestStatusCodeSet',
    added: 'FIX.4.4',
    name: 'TradeRequestStatus',
    id: 750,
    description: 'Status of Trade Request.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'TradeReportRejectReasonCodeSet',
    unionDataType: 'Reserved100Plus',
    updatedEP: '107',
    added: 'FIX.4.4',
    name: 'TradeReportRejectReason',
    id: 751,
    abbrName: 'RejRsn',
    description:
      'Reason Trade Capture Request was rejected.\n\n100+ Reserved and available for bi-laterally agreed upon user-defined values.',
  },
  {
    abbrName: 'MLegRptTyp',
    type: 'SideMultiLegReportingTypeCodeSet',
    added: 'FIX.4.4',
    name: 'SideMultiLegReportingType',
    id: 752,
    description:
      'Used to indicate if the side being reported on Trade Capture Report represents a leg of a multileg instrument or a single security.',
  },
  {
    abbrName: 'NoPosAmt',
    type: 'NumInGroup',
    added: 'FIX.4.4',
    name: 'NoPosAmt',
    id: 753,
    description: 'Number of position amount entries.',
  },
  {
    abbrName: 'AutoAcceptInd',
    type: 'Boolean',
    added: 'FIX.4.4',
    name: 'AutoAcceptIndicator',
    id: 754,
    description:
      'Identifies whether or not an allocation has been automatically accepted on behalf of the Carry Firm by the Clearing House.',
  },
  {
    abbrName: 'RptID',
    type: 'String',
    added: 'FIX.4.4',
    name: 'AllocReportID',
    id: 755,
    description: 'Unique identifier for Allocation Report message.',
  },
  {
    abbrName: 'NoNst2PtyIDs',
    type: 'NumInGroup',
    added: 'FIX.4.4',
    name: 'NoNested2PartyIDs',
    id: 756,
    description:
      'Number of Nested2PartyID (757), Nested2PartyIDSource (758), and Nested2PartyRole (759) entries',
  },
  {
    abbrName: 'ID',
    type: 'String',
    added: 'FIX.4.4',
    name: 'Nested2PartyID',
    id: 757,
    discriminatorId: '758',
    description:
      'PartyID value within a "second instance" Nested repeating group.\n\nSame values as PartyID (448)',
  },
  {
    abbrName: 'Src',
    type: 'PartyIDSourceCodeSet',
    added: 'FIX.4.4',
    name: 'Nested2PartyIDSource',
    id: 758,
    description:
      'PartyIDSource value within a "second instance" Nested repeating group.\n\nSame values as PartyIDSource (447)',
  },
  {
    abbrName: 'R',
    type: 'PartyRoleCodeSet',
    added: 'FIX.4.4',
    name: 'Nested2PartyRole',
    id: 759,
    description:
      'PartyRole value within a "second instance" Nested repeating group.\n\nSame values as PartyRole (452)',
  },
  {
    abbrName: 'ID',
    type: 'String',
    added: 'FIX.4.4',
    name: 'Nested2PartySubID',
    id: 760,
    description:
      'PartySubID value within a "second instance" Nested repeating group.\n\nSame values as PartySubID (523)',
  },
  {
    updated: 'FIX.Latest',
    type: 'SecurityIDSourceCodeSet',
    unionDataType: 'Reserved100Plus',
    updatedEP: '271',
    added: 'FIX.4.4',
    name: 'BenchmarkSecurityIDSource',
    id: 761,
    abbrName: 'SecIDSrc',
    description:
      'Identifies class or source of the BenchmarkSecurityID(699) value.\n\nRequired if BenchmarkSecurityID is specified.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    updatedEP: '254',
    added: 'FIX.4.4',
    name: 'SecuritySubType',
    id: 762,
    abbrName: 'SubTyp',
    description:
      'Sub-type qualification/identification of the SecurityType. As an example for SecurityType(167)="REPO", the SecuritySubType="General Collateral" can be used to further specify the type of REPO.\n\nIf SecuritySubType is used, then SecurityType is required.\n\nFor SecurityType="MLEG" a name of the option or futures strategy name can be specified, such as "Calendar", "Vertical", "Butterfly".\n\nFor SecurityType(167)="OPT" the subclassification can be specified, such as "Asian".\n\nFor SecurityType(167)="SWAPTION" a value of "Straddle" is used to identify a straddle swaption.\n\nIn the context of EU SFTR reporting use the appropriate 4-character code noted in the regulations - "GENE" for general collateral or "SPEC" for specific collateral (without quote marks).',
  },
  {
    abbrName: 'SubTyp',
    type: 'String',
    added: 'FIX.4.4',
    name: 'UnderlyingSecuritySubType',
    id: 763,
    description:
      "Underlying security's SecuritySubType.\n\nSee SecuritySubType (762) field for description",
  },
  {
    abbrName: 'SecSubTyp',
    type: 'String',
    added: 'FIX.4.4',
    name: 'LegSecuritySubType',
    id: 764,
    description:
      'SecuritySubType of the leg instrument.\n\nSee SecuritySubType (762) field for description',
  },
  {
    abbrName: 'AOSPct',
    type: 'Percentage',
    added: 'FIX.4.4',
    name: 'AllowableOneSidednessPct',
    id: 765,
    description:
      'The maximum percentage that execution of one side of a program trade can exceed execution of the other.',
  },
  {
    abbrName: 'AOSValu',
    type: 'Amt',
    added: 'FIX.4.4',
    name: 'AllowableOneSidednessValue',
    id: 766,
    description:
      'The maximum amount that execution of one side of a program trade can exceed execution of the other.',
  },
  {
    abbrName: 'AOSCurr',
    type: 'Currency',
    added: 'FIX.4.4',
    name: 'AllowableOneSidednessCurr',
    id: 767,
    description:
      'The currency that AllowableOneSidednessValue (766) is expressed in if AllowableOneSidednessValue is used.',
  },
  {
    updated: 'FIX.Latest',
    type: 'NumInGroup',
    updatedEP: '291',
    added: 'FIX.4.4',
    name: 'NoTrdRegTimestamps',
    id: 768,
    abbrName: 'NoTrdRegTmstamps',
    description: 'Number of timestamp entries.',
  },
  {
    updated: 'FIX.Latest',
    type: 'UTCTimestamp',
    updatedEP: '291',
    added: 'FIX.4.4',
    name: 'TrdRegTimestamp',
    id: 769,
    abbrName: 'TS',
    description:
      'Traded / Regulatory timestamp value.\n\nUse to store time information required by government regulators or self-regulatory organizations (such as an exchange or clearing house).',
  },
  {
    updated: 'FIX.Latest',
    type: 'TrdRegTimestampTypeCodeSet',
    updatedEP: '291',
    added: 'FIX.4.4',
    name: 'TrdRegTimestampType',
    id: 770,
    abbrName: 'Typ',
    description:
      'Trading / Regulatory timestamp type.\n\nNote of applicability: Values are required in various regulatory environments: required for US futures markets to support computerized trade reconstruction, required by MiFID II / MiFIR for transaction reporting and publication, required by FINRA for reporting to the Consolidated Audit Trail (CAT), and required by SEC for recordkeeping requirements in the context of T+1.',
  },
  {
    updated: 'FIX.Latest',
    type: 'String',
    updatedEP: '291',
    added: 'FIX.4.4',
    name: 'TrdRegTimestampOrigin',
    id: 771,
    abbrName: 'Src',
    description:
      'Text which identifies the "origin" (i.e. system which was used to generate the timestamp) for the Traded / Regulatory timestamp value.',
  },
  {
    abbrName: 'CnfmRefID',
    type: 'String',
    added: 'FIX.4.4',
    name: 'ConfirmRefID',
    id: 772,
    description:
      'Reference identifier to be used with ConfirmTransType (666) = Replace or Cancel',
  },
  {
    abbrName: 'CnfmTyp',
    type: 'ConfirmTypeCodeSet',
    added: 'FIX.4.4',
    name: 'ConfirmType',
    id: 773,
    description: 'Identifies the type of Confirmation message being sent.',
  },
  {
    type: 'ConfirmRejReasonCodeSet',
    unionDataType: 'Reserved100Plus',
    added: 'FIX.4.4',
    name: 'ConfirmRejReason',
    id: 774,
    abbrName: 'CnfmRejRsn',
    description: 'Identifies the reason for rejecting a Confirmation.',
  },
  {
    abbrName: 'BkngTyp',
    type: 'BookingTypeCodeSet',
    added: 'FIX.4.4',
    name: 'BookingType',
    id: 775,
    description:
      'Method for booking out this order. Used when notifying a broker that an order to be settled by that broker is to be booked out as an OTC derivative (e.g. CFD or similar).',
  },
  {
    abbrName: 'IndAllocRejCode',
    type: 'AllocRejCodeCodeSet',
    added: 'FIX.4.4',
    name: 'IndividualAllocRejCode',
    id: 776,
    description:
      'Identified reason for rejecting an individual AllocAccount (79) detail.\n\nSame values as AllocRejCode (88)',
  },
  {
    abbrName: 'SettlInstMsgID',
    type: 'String',
    added: 'FIX.4.4',
    name: 'SettlInstMsgID',
    id: 777,
    description: 'Unique identifier for Settlement Instruction message.',
  },
  {
    abbrName: 'NoSettlInst',
    type: 'NumInGroup',
    added: 'FIX.4.4',
    name: 'NoSettlInst',
    id: 778,
    description: 'Number of settlement instructions within repeating group.',
  },
  {
    abbrName: 'LastUpdateTm',
    type: 'UTCTimestamp',
    added: 'FIX.4.4',
    name: 'LastUpdateTime',
    id: 779,
    description:
      'Timestamp of last update to data item (or creation if no updates made since creation).',
  },
  {
    abbrName: 'SettlInstTyp',
    type: 'AllocSettlInstTypeCodeSet',
    added: 'FIX.4.4',
    name: 'AllocSettlInstType',
    id: 780,
    description:
      'Used to indicate whether settlement instructions are provided on an allocation instruction message, and if not, how they are to be derived.',
  },
  {
    abbrName: 'NoSettlPtyIDs',
    type: 'NumInGroup',
    added: 'FIX.4.4',
    name: 'NoSettlPartyIDs',
    id: 781,
    description:
      'Number of SettlPartyID (782), SettlPartyIDSource (783), and SettlPartyRole (784) entries',
  },
  {
    abbrName: 'ID',
    type: 'String',
    added: 'FIX.4.4',
    name: 'SettlPartyID',
    id: 782,
    discriminatorId: '783',
    description:
      'PartyID value within a settlement parties component. Nested repeating group.\n\nSame values as PartyID (448)',
  },
  {
    abbrName: 'Src',
    type: 'PartyIDSourceCodeSet',
    added: 'FIX.4.4',
    name: 'SettlPartyIDSource',
    id: 783,
    description:
      'PartyIDSource value within a settlement parties component.\n\nSame values as PartyIDSource (447)',
  },
  {
    abbrName: 'R',
    type: 'PartyRoleCodeSet',
    added: 'FIX.4.4',
    name: 'SettlPartyRole',
    id: 784,
    description:
      'PartyRole value within a settlement parties component.\n\nSame values as PartyRole (452)',
  },
  {
    abbrName: 'ID',
    type: 'String',
    added: 'FIX.4.4',
    name: 'SettlPartySubID',
    id: 785,
    description:
      'PartySubID value within a settlement parties component.\n\nSame values as PartySubID (523)',
  },
  {
    abbrName: 'Typ',
    type: 'PartySubIDTypeCodeSet',
    added: 'FIX.4.4',
    name: 'SettlPartySubIDType',
    id: 786,
    description:
      'Type of SettlPartySubID (785) value.\n\nSame values as PartySubIDType (803)',
  },
  {
    abbrName: 'InstTyp',
    type: 'DlvyInstTypeCodeSet',
    added: 'FIX.4.4',
    name: 'DlvyInstType',
    id: 787,
    description:
      'Used to indicate whether a delivery instruction is used for securities or cash settlement.',
  },
  {
    abbrName: 'TrmTyp',
    type: 'TerminationTypeCodeSet',
    added: 'FIX.4.4',
    name: 'TerminationType',
    id: 788,
    description: 'Type of financing termination.',
  },
  {
    abbrName: 'NextExpectedMsgSeqNum',
    type: 'SeqNum',
    added: 'FIX.4.4',
    name: 'NextExpectedMsgSeqNum',
    id: 789,
    description: 'Next expected MsgSeqNum value to be received.',
  },
  {
    abbrName: 'StatReqID',
    type: 'String',
    added: 'FIX.4.4',
    name: 'OrdStatusReqID',
    id: 790,
    description:
      'Can be used to uniquely identify a specific Order Status Request message.',
  },
  {
    abbrName: 'SettlInstReqID',
    type: 'String',
    added: 'FIX.4.4',
    name: 'SettlInstReqID',
    id: 791,
    description: 'Unique ID of settlement instruction request message',
  },
  {
    type: 'SettlInstReqRejCodeCodeSet',
    unionDataType: 'Reserved100Plus',
    added: 'FIX.4.4',
    name: 'SettlInstReqRejCode',
    id: 792,
    abbrName: 'SettlInstReqRejCode',
    description:
      'Identifies reason for rejection (of a settlement instruction request message).',
  },
  {
    type: 'String',
    baseCategoryAbbrName: 'ID2',
    baseCategory: 'Allocation',
    added: 'FIX.4.4',
    name: 'SecondaryAllocID',
    id: 793,
    abbrName: 'AllocID2',
    description:
      'Secondary allocation identifier. Unlike the AllocID (70), this can be shared across a number of allocation instruction or allocation report messages, thereby making it possible to pass an identifier for an original allocation message on multiple messages (e.g. from one party to a second to a third, across cancel and replace messages etc.).',
  },
  {
    abbrName: 'RptTyp',
    type: 'AllocReportTypeCodeSet',
    added: 'FIX.4.4',
    name: 'AllocReportType',
    id: 794,
    description: 'Describes the specific type or purpose of an Allocation Report message',
  },
  {
    abbrName: 'RptRefID',
    type: 'String',
    added: 'FIX.4.4',
    name: 'AllocReportRefID',
    id: 795,
    description:
      'Reference identifier to be used with AllocTransType (7) = Replace or Cancel',
  },
  {
    type: 'AllocCancReplaceReasonCodeSet',
    baseCategoryAbbrName: 'CxlRplcRsn',
    baseCategory: 'Allocation',
    unionDataType: 'Reserved100Plus',
    added: 'FIX.4.4',
    name: 'AllocCancReplaceReason',
    id: 796,
    abbrName: 'CxlRplcRsn',
    description:
      'Reason for cancelling or replacing an Allocation Instruction or Allocation Report message',
  },
  {
    abbrName: 'CopyMsgInd',
    type: 'Boolean',
    added: 'FIX.4.4',
    name: 'CopyMsgIndicator',
    id: 797,
    description:
      'Indicates whether or not this message is a drop copy of another message.',
  },
  {
    abbrName: 'AcctTyp',
    type: 'AllocAccountTypeCodeSet',
    added: 'FIX.4.4',
    name: 'AllocAccountType',
    id: 798,
    description:
      'Type of account associated with a confirmation or other trade-level message',
  },
  {
    abbrName: 'AvgPx',
    type: 'Price',
    added: 'FIX.4.4',
    name: 'OrderAvgPx',
    id: 799,
    description: 'Average price for a specific order',
  },
  {
    abbrName: 'BkngQty',
    type: 'Qty',
    added: 'FIX.4.4',
    name: 'OrderBookingQty',
    id: 800,
    description:
      'Quantity of the order that is being booked out as part of an Allocation Instruction or Allocation Report message',
  },
  {
    abbrName: 'NoSettlPtySubIDs',
    type: 'NumInGroup',
    added: 'FIX.4.4',
    name: 'NoSettlPartySubIDs',
    id: 801,
    description: 'Number of SettlPartySubID (785) and SettlPartySubIDType (786) entries',
  },
  {
    abbrName: 'NoPtySubIDs',
    type: 'NumInGroup',
    added: 'FIX.4.4',
    name: 'NoPartySubIDs',
    id: 802,
    description: 'Number of PartySubID (523)and PartySubIDType (803) entries',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PartySubIDTypeCodeSet',
    unionDataType: 'Reserved4000Plus',
    updatedEP: '204',
    added: 'FIX.4.4',
    name: 'PartySubIDType',
    id: 803,
    abbrName: 'Typ',
    description: 'Type of PartySubID(523) value.',
  },
  {
    abbrName: 'NoNstPtySubIDs',
    type: 'NumInGroup',
    added: 'FIX.4.4',
    name: 'NoNestedPartySubIDs',
    id: 804,
    description:
      'Number of NestedPartySubID (545) and NestedPartySubIDType (805) entries',
  },
  {
    abbrName: 'Typ',
    type: 'PartySubIDTypeCodeSet',
    added: 'FIX.4.4',
    name: 'NestedPartySubIDType',
    id: 805,
    description:
      'Type of NestedPartySubID (545) value.\n\nSame values as PartySubIDType (803)',
  },
  {
    abbrName: 'NoNst2PtySubIDs',
    type: 'NumInGroup',
    added: 'FIX.4.4',
    name: 'NoNested2PartySubIDs',
    id: 806,
    description:
      'Number of Nested2PartySubID (760) and Nested2PartySubIDType (807) entries. Second instance of <NestedParties>.',
  },
  {
    abbrName: 'Typ',
    type: 'PartySubIDTypeCodeSet',
    added: 'FIX.4.4',
    name: 'Nested2PartySubIDType',
    id: 807,
    description:
      'Type of Nested2PartySubID (760) value. Second instance of <NestedParties>.\n\nSame values as PartySubIDType (803)',
  },
];

const batch2: ISpecFields[] = [
  {
    type: 'AllocIntermedReqTypeCodeSet',
    baseCategoryAbbrName: 'ImReqTyp',
    baseCategory: 'Allocation',
    added: 'FIX.4.4',
    name: 'AllocIntermedReqType',
    id: 808,
    abbrName: 'IntermedReqTyp',
    description:
      'Response to allocation to be communicated to a counterparty through an intermediary, i.e. clearing house. Used in conjunction with AllocType = "Request to Intermediary" and AllocReportType = "Request to Intermediary"',
  },
  {
    abbrName: 'Px',
    type: 'Price',
    added: 'FIX.4.4',
    name: 'UnderlyingPx',
    id: 810,
    description: 'Underlying price associate with a derivative instrument.',
  },
  {
    abbrName: 'PxDelta',
    type: 'float',
    added: 'FIX.4.4',
    name: 'PriceDelta',
    id: 811,
    description:
      'The rate of change in the price of a derivative with respect to the movement in the price of the underlying instrument(s) upon which the derivative instrument price is based.\n\nThis value is normally between -1.0 and 1.0.',
  },
  {
    abbrName: 'ApplQuMax',
    type: 'int',
    added: 'FIX.4.4',
    name: 'ApplQueueMax',
    id: 812,
    description:
      'Used to specify the maximum number of application messages that can be queued bedore a corrective action needs to take place to resolve the queuing issue.',
  },
  {
    abbrName: 'ApplQuDepth',
    type: 'int',
    added: 'FIX.4.4',
    name: 'ApplQueueDepth',
    id: 813,
    description:
      'Current number of application messages that were queued at the time that the message was created by the counterparty.',
  },
  {
    abbrName: 'ApplQuResolution',
    type: 'ApplQueueResolutionCodeSet',
    added: 'FIX.4.4',
    name: 'ApplQueueResolution',
    id: 814,
    description:
      'Resolution taken when ApplQueueDepth (813) exceeds ApplQueueMax (812) or system specified maximum queue size.',
  },
  {
    abbrName: 'ApplQuActn',
    type: 'ApplQueueActionCodeSet',
    added: 'FIX.4.4',
    name: 'ApplQueueAction',
    id: 815,
    description: 'Action to take to resolve an application message queue (backlog).',
  },
  {
    abbrName: 'NoAltMDSrc',
    type: 'NumInGroup',
    added: 'FIX.4.4',
    name: 'NoAltMDSource',
    id: 816,
    description: 'Number of alternative market data sources',
  },
  {
    abbrName: 'AltMDSrcID',
    type: 'String',
    added: 'FIX.4.4',
    name: 'AltMDSourceID',
    id: 817,
    description:
      'Session layer source for market data\n\n(For the standard FIX session layer, this would be the TargetCompID (56) where market data can be obtained).',
  },
  {
    type: 'String',
    baseCategoryAbbrName: 'RptID2',
    baseCategory: 'TradeCapture',
    deprecated: 'FIX.5.0',
    added: 'FIX.4.4',
    name: 'SecondaryTradeReportID',
    id: 818,
    abbrName: 'TrdRptID2',
    description:
      'Secondary trade report identifier - can be used to associate an additional identifier with a trade.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'AvgPxIndicatorCodeSet',
    updatedEP: '239',
    added: 'FIX.4.4',
    name: 'AvgPxIndicator',
    id: 819,
    abbrName: 'AvgPxInd',
    description: 'Average pricing indicator.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    baseCategoryAbbrName: 'LinkID',
    baseCategory: 'TradeCapture',
    updatedEP: '141',
    added: 'FIX.4.4',
    name: 'TradeLinkID',
    id: 820,
    abbrName: 'LinkID',
    description: 'Used to link a group of trades together.',
  },
  {
    abbrName: 'OrdInptDev',
    type: 'String',
    added: 'FIX.4.4',
    name: 'OrderInputDevice',
    id: 821,
    description:
      'Specific device number, terminal number or station where order was entered',
  },
  {
    abbrName: 'UndSesID',
    type: 'String',
    added: 'FIX.4.4',
    name: 'UnderlyingTradingSessionID',
    id: 822,
    description: 'Trading Session in which the underlying instrument trades',
  },
  {
    abbrName: 'UndSesSub',
    type: 'String',
    added: 'FIX.4.4',
    name: 'UnderlyingTradingSessionSubID',
    id: 823,
    description:
      'Trading Session sub identifier in which the underlying instrument trades',
  },
  {
    abbrName: 'TrdLegRefID',
    type: 'String',
    added: 'FIX.4.4',
    name: 'TradeLegRefID',
    id: 824,
    description:
      'Reference to the leg of a multileg instrument to which this trade refers',
  },
  {
    abbrName: 'ExchRule',
    type: 'String',
    added: 'FIX.4.4',
    name: 'ExchangeRule',
    id: 825,
    description:
      'Used to report any exchange rules that apply to this trade.\n\nPrimarily intended for US futures markets. Certain trading practices are permitted by the CFTC, such as large lot trading, block trading, all or none trades. If the rules are used, the exchanges are required to indicate these rules on the trade.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'TradeAllocIndicatorCodeSet',
    updatedEP: '141',
    added: 'FIX.4.4',
    name: 'TradeAllocIndicator',
    id: 826,
    abbrName: 'AllocInd',
    description: 'Identifies if, and how, the trade is to be allocated or split.',
  },
  {
    abbrName: 'ExpirationCycle',
    type: 'ExpirationCycleCodeSet',
    added: 'FIX.4.4',
    name: 'ExpirationCycle',
    id: 827,
    description:
      'Part of trading cycle when an instrument expires. Field is applicable for derivatives.',
  },
  {
    updated: 'FIX.Latest',
    type: 'TrdTypeCodeSet',
    unionDataType: 'Reserved1000Plus',
    updatedEP: '289',
    added: 'FIX.4.4',
    name: 'TrdType',
    id: 828,
    abbrName: 'TrdTyp',
    description:
      'Type of trade assigned to a trade. SecondaryTrdType(855) and TertiaryTrdType(2896) may be used in addition to TrdType(828) to assign up to three different trade types to a single trade.\n\nNote: several enumerations of this field duplicate the enumerations in TradePriceCondition(1839) field. These may be deprecated from TrdType(828) in the future. TradePriceCondition(1839) is preferred in messages that support it.',
  },
  {
    updated: 'FIX.Latest',
    type: 'TrdSubTypeCodeSet',
    unionDataType: 'Reserved1000Plus',
    updatedEP: '289',
    added: 'FIX.4.4',
    name: 'TrdSubType',
    id: 829,
    abbrName: 'TrdSubTyp',
    description: 'Further qualification to the trade type defined in TrdType(828).',
  },
  {
    abbrName: 'TrnsfrRsn',
    type: 'String',
    added: 'FIX.4.4',
    name: 'TransferReason',
    id: 830,
    description: 'Reason trade is being transferred',
  },
  {
    abbrName: 'TotNumAsgnRpts',
    type: 'int',
    added: 'FIX.4.4',
    name: 'TotNumAssignmentReports',
    id: 832,
    description: 'Total Number of Assignment Reports being returned to a firm',
  },
  {
    abbrName: 'RptID',
    type: 'String',
    added: 'FIX.4.4',
    name: 'AsgnRptID',
    id: 833,
    description: 'Unique identifier for the Assignment Report',
  },
  {
    abbrName: 'ThresholdAmt',
    type: 'PriceOffset',
    added: 'FIX.4.4',
    name: 'ThresholdAmount',
    id: 834,
    description: 'Amount that a position has to be in the money before it is exercised.',
  },
  {
    abbrName: 'MoveTyp',
    type: 'PegMoveTypeCodeSet',
    added: 'FIX.4.4',
    name: 'PegMoveType',
    id: 835,
    description: 'Describes whether peg is static or floats',
  },
  {
    abbrName: 'OfstTyp',
    type: 'PegOffsetTypeCodeSet',
    added: 'FIX.4.4',
    name: 'PegOffsetType',
    id: 836,
    description: 'Type of Peg Offset value',
  },
  {
    abbrName: 'LmtTyp',
    type: 'PegLimitTypeCodeSet',
    added: 'FIX.4.4',
    name: 'PegLimitType',
    id: 837,
    description: 'Type of Peg Limit',
  },
  {
    abbrName: 'RndDir',
    type: 'PegRoundDirectionCodeSet',
    added: 'FIX.4.4',
    name: 'PegRoundDirection',
    id: 838,
    description:
      'If the calculated peg price is not a valid tick price, specifies whether to round the price to be more or less aggressive',
  },
  {
    abbrName: 'PeggedPx',
    type: 'Price',
    added: 'FIX.4.4',
    name: 'PeggedPrice',
    id: 839,
    description: 'The price the order is currently pegged at',
  },
  {
    abbrName: 'Scope',
    type: 'PegScopeCodeSet',
    added: 'FIX.4.4',
    name: 'PegScope',
    id: 840,
    description: 'The scope of the peg',
  },
  {
    abbrName: 'MoveTyp',
    type: 'DiscretionMoveTypeCodeSet',
    added: 'FIX.4.4',
    name: 'DiscretionMoveType',
    id: 841,
    description: 'Describes whether discretionay price is static or floats',
  },
  {
    abbrName: 'OfstTyp',
    type: 'DiscretionOffsetTypeCodeSet',
    added: 'FIX.4.4',
    name: 'DiscretionOffsetType',
    id: 842,
    description: 'Type of Discretion Offset value',
  },
  {
    abbrName: 'LimitTyp',
    type: 'DiscretionLimitTypeCodeSet',
    added: 'FIX.4.4',
    name: 'DiscretionLimitType',
    id: 843,
    description: 'Type of Discretion Limit',
  },
  {
    abbrName: 'RndDir',
    type: 'DiscretionRoundDirectionCodeSet',
    added: 'FIX.4.4',
    name: 'DiscretionRoundDirection',
    id: 844,
    description:
      'If the calculated discretionary price is not a valid tick price, specifies whether to round the price to be more or less aggressive',
  },
  {
    abbrName: 'DsctnPx',
    type: 'Price',
    added: 'FIX.4.4',
    name: 'DiscretionPrice',
    id: 845,
    description: 'The current discretionary price of the order',
  },
  {
    abbrName: 'Scope',
    type: 'DiscretionScopeCodeSet',
    added: 'FIX.4.4',
    name: 'DiscretionScope',
    id: 846,
    description: 'The scope of the discretion',
  },
  {
    type: 'TargetStrategyCodeSet',
    unionDataType: 'Reserved1000Plus',
    added: 'FIX.4.4',
    name: 'TargetStrategy',
    id: 847,
    abbrName: 'TgtStrategy',
    description:
      'The target strategy of the order\n\n1000+ = Reserved and available for bi-laterally agreed upon user defined values',
  },
  {
    updated: 'FIX.Latest',
    type: 'String',
    deprecated: 'FIX.5.0',
    updatedEP: '282',
    added: 'FIX.4.4',
    name: 'TargetStrategyParameters',
    id: 848,
    abbrName: 'TgtStrategyParameters',
    description:
      'Field to allow further specification of the TargetStrategy - usage to be agreed between counterparties\n\nThe StrategyParametersGrp repeating group is used instead to convey target strategy parameters and values.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Percentage',
    deprecated: 'FIX.5.0',
    updatedEP: '282',
    added: 'FIX.4.4',
    name: 'ParticipationRate',
    id: 849,
    abbrName: 'ParticipationRt',
    description:
      'For a TargetStrategy=Participate order specifies the target particpation rate. For other order types this is a volume limit (i.e. do not be more than this percent of the market volume)\n\nThe StrategyParametersGrp repeating group is used instead to convey target strategy parameters and values.',
  },
  {
    abbrName: 'TgtStrategyPerformance',
    type: 'float',
    added: 'FIX.4.4',
    name: 'TargetStrategyPerformance',
    id: 850,
    description:
      'For communication of the performance of the order versus the target strategy',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'LastLiquidityIndCodeSet',
    updatedEP: '223',
    added: 'FIX.4.4',
    name: 'LastLiquidityInd',
    id: 851,
    abbrName: 'LastLqdtyInd',
    description:
      'Indicator to identify whether this fill was a result of a liquidity provider providing or liquidity taker taking the liquidity.',
  },
  {
    type: 'PublishTrdIndicatorCodeSet',
    deprecated: 'FIX.5.0',
    added: 'FIX.4.4',
    name: 'PublishTrdIndicator',
    id: 852,
    abbrName: 'PubTrdInd',
    description:
      'Indicates if a trade should be reported via a market reporting service.',
  },
  {
    abbrName: 'ShrtSaleRsn',
    type: 'ShortSaleReasonCodeSet',
    added: 'FIX.4.4',
    name: 'ShortSaleReason',
    id: 853,
    description: 'Reason for short sale.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'QtyTypeCodeSet',
    updatedEP: '107',
    added: 'FIX.4.4',
    name: 'QtyType',
    id: 854,
    abbrName: 'QtyTyp',
    description:
      'Type of quantity specified in quantity field. ContractMultiplier (tag 231) is required when QtyType = 1 (Contracts). UnitOfMeasure (tag 996) and TimeUnit (tag 997) are required when QtyType = 2 (Units of Measure per Time Unit).',
  },
  {
    updated: 'FIX.Latest',
    type: 'TrdTypeCodeSet',
    updatedEP: '268',
    added: 'FIX.4.4',
    name: 'SecondaryTrdType',
    id: 855,
    abbrName: 'TrdTyp2',
    description:
      'Type of trade assigned to a trade. Used in addition to TrdType(828). Must not be used when only one trade type needs to be assigned.',
  },
  {
    abbrName: 'RptTyp',
    type: 'TradeReportTypeCodeSet',
    added: 'FIX.4.4',
    name: 'TradeReportType',
    id: 856,
    description: 'Type of Trade Report',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'AllocNoOrdersTypeCodeSet',
    updatedEP: '118',
    added: 'FIX.4.4',
    name: 'AllocNoOrdersType',
    id: 857,
    abbrName: 'NoOrdsTyp',
    description:
      'Indicates how the orders being booked and allocated by an AllocationInstruction or AllocationReport message are identified, e.g. by explicit definition in the OrdAllocGrp or ExecAllocGrp components, or not identified explicitly.',
  },
  {
    abbrName: 'SharedComm',
    type: 'Amt',
    added: 'FIX.4.4',
    name: 'SharedCommission',
    id: 858,
    description:
      'Commission to be shared with a third party, e.g. as part of a directed brokerage commission sharing arrangement.',
  },
  {
    abbrName: 'CnfmReqID',
    type: 'String',
    added: 'FIX.4.4',
    name: 'ConfirmReqID',
    id: 859,
    description: 'Unique identifier for a Confirmation Request message',
  },
  {
    abbrName: 'AvgParPx',
    type: 'Price',
    added: 'FIX.4.4',
    name: 'AvgParPx',
    id: 860,
    description:
      'Used to express average price as percent of par (used where AvgPx field is expressed in some other way)',
  },
  {
    abbrName: 'RptedPx',
    type: 'Price',
    added: 'FIX.4.4',
    name: 'ReportedPx',
    id: 861,
    description:
      'Reported price (used to differentiate from AvgPx on a confirmation of a marked-up or marked-down principal trade)',
  },
  {
    abbrName: 'NoCapacities',
    type: 'NumInGroup',
    added: 'FIX.4.4',
    name: 'NoCapacities',
    id: 862,
    description: 'Number of repeating OrderCapacity entries.',
  },
  {
    abbrName: 'CpctyQty',
    type: 'Qty',
    added: 'FIX.4.4',
    name: 'OrderCapacityQty',
    id: 863,
    description:
      'Quantity executed under a specific OrderCapacity (e.g. quantity executed as agent, quantity executed as principal)',
  },
  {
    abbrName: 'NoEvents',
    type: 'NumInGroup',
    added: 'FIX.4.4',
    name: 'NoEvents',
    id: 864,
    description: 'Number of repeating EventType entries.',
  },
  {
    type: 'EventTypeCodeSet',
    unionDataType: 'Reserved100Plus',
    added: 'FIX.4.4',
    name: 'EventType',
    id: 865,
    abbrName: 'EventTyp',
    description: 'Code to represent the type of event',
  },
  {
    abbrName: 'Dt',
    type: 'LocalMktDate',
    added: 'FIX.4.4',
    name: 'EventDate',
    id: 866,
    description: 'Date of event',
  },
  {
    abbrName: 'Px',
    type: 'Price',
    added: 'FIX.4.4',
    name: 'EventPx',
    id: 867,
    description: 'Predetermined price of issue at event, if applicable',
  },
  {
    abbrName: 'Txt',
    type: 'String',
    added: 'FIX.4.4',
    name: 'EventText',
    id: 868,
    description: 'Comments related to the event.',
  },
  {
    abbrName: 'PctAtRisk',
    type: 'Percentage',
    added: 'FIX.4.4',
    name: 'PctAtRisk',
    id: 869,
    description: 'Percent at risk due to lowest possible call.',
  },
  {
    abbrName: 'NoInstrAttrib',
    type: 'NumInGroup',
    added: 'FIX.4.4',
    name: 'NoInstrAttrib',
    id: 870,
    description: 'Number of repeating InstrAttribType entries.',
  },
  {
    type: 'InstrAttribTypeCodeSet',
    unionDataType: 'Reserved100Plus',
    added: 'FIX.4.4',
    name: 'InstrAttribType',
    id: 871,
    abbrName: 'Typ',
    description: 'Code to represent the type of instrument attribute',
  },
  {
    updated: 'FIX.Latest',
    type: 'String',
    updatedEP: '271',
    added: 'FIX.4.4',
    name: 'InstrAttribValue',
    id: 872,
    abbrName: 'Val',
    description: 'Attribute value appropriate to the InstrAttribType (871) field.',
  },
  {
    abbrName: 'Dated',
    type: 'LocalMktDate',
    added: 'FIX.4.4',
    name: 'DatedDate',
    id: 873,
    description:
      'The effective date of a new securities issue determined by its underwriters. Often but not always the same as the Issue Date and the Interest Accrual Date',
  },
  {
    abbrName: 'IntAcrl',
    type: 'LocalMktDate',
    added: 'FIX.4.4',
    name: 'InterestAccrualDate',
    id: 874,
    description:
      'The start date used for calculating accrued interest on debt instruments which are being sold between interest payment dates. Often but not always the same as the Issue Date and the Dated Date',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'CPProgramCodeSet',
    unionDataType: 'Reserved100Plus',
    updatedEP: '201',
    added: 'FIX.4.4',
    name: 'CPProgram',
    id: 875,
    abbrName: 'CPPgm',
    description:
      'The program under which a commercial paper offering is exempt from SEC registration identified by the paragraph number(s) within the US Securities Act of 1933 or as identified below.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    updatedEP: '201',
    added: 'FIX.4.4',
    name: 'CPRegType',
    id: 876,
    abbrName: 'CPRegT',
    description:
      'The description of commercial paper registration or rule under which exempt commercial paper is offered. For example "144a", "Tax Exempt" or "REG. S".',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'CPProgramCodeSet',
    unionDataType: 'Reserved100Plus',
    updatedEP: '187',
    added: 'FIX.4.4',
    name: 'UnderlyingCPProgram',
    id: 877,
    abbrName: 'CPPgm',
    description: 'The program under which the underlying commercial paper is issued',
  },
  {
    abbrName: 'CPRegTyp',
    type: 'String',
    added: 'FIX.4.4',
    name: 'UnderlyingCPRegType',
    id: 878,
    description: 'The registration type of the underlying commercial paper issuance',
  },
  {
    abbrName: 'Qty',
    type: 'Qty',
    added: 'FIX.4.4',
    name: 'UnderlyingQty',
    id: 879,
    description: 'Unit amount of the underlying security (par, shares, currency, etc.)',
  },
  {
    updated: 'FIX.Latest',
    type: 'String',
    updatedEP: '279',
    added: 'FIX.4.4',
    name: 'TrdMatchID',
    id: 880,
    abbrName: 'MtchID',
    description:
      'Identifier assigned by a matching system to a match event that results in multiple executions or trades.',
  },
  {
    type: 'String',
    baseCategoryAbbrName: 'RptRefID2',
    baseCategory: 'TradeCapture',
    deprecated: 'FIX.5.0',
    added: 'FIX.4.4',
    name: 'SecondaryTradeReportRefID',
    id: 881,
    abbrName: 'TrdRptRefID2',
    description:
      'Used to refer to a previous SecondaryTradeReportRefID when amending the transaction (cancel, replace, release, or reversal).',
  },
  {
    abbrName: 'DirtPx',
    type: 'Price',
    added: 'FIX.4.4',
    name: 'UnderlyingDirtyPrice',
    id: 882,
    description:
      'Price (percent-of-par or per unit) of the underlying security or basket. "Dirty" means it includes accrued interest',
  },
  {
    abbrName: 'EndPx',
    type: 'Price',
    added: 'FIX.4.4',
    name: 'UnderlyingEndPrice',
    id: 883,
    description:
      'Price (percent-of-par or per unit) of the underlying security or basket at the end of the agreement.',
  },
  {
    abbrName: 'StartVal',
    type: 'Amt',
    added: 'FIX.4.4',
    name: 'UnderlyingStartValue',
    id: 884,
    description:
      'Currency value attributed to this collateral at the start of the agreement',
  },
  {
    abbrName: 'CurVal',
    type: 'Amt',
    added: 'FIX.4.4',
    name: 'UnderlyingCurrentValue',
    id: 885,
    description: 'Currency value currently attributed to this collateral',
  },
  {
    abbrName: 'EndVal',
    type: 'Amt',
    added: 'FIX.4.4',
    name: 'UnderlyingEndValue',
    id: 886,
    description:
      'Currency value attributed to this collateral at the end of the agreement',
  },
  {
    abbrName: 'NoUndStips',
    type: 'NumInGroup',
    added: 'FIX.4.4',
    name: 'NoUnderlyingStips',
    id: 887,
    description: 'Number of underlying stipulation entries',
  },
  {
    abbrName: 'Typ',
    type: 'StipulationTypeCodeSet',
    added: 'FIX.4.4',
    name: 'UnderlyingStipType',
    id: 888,
    description: 'Type of stipulation.\n\nSame values as StipulationType (233)',
  },
  {
    abbrName: 'Val',
    type: 'String',
    added: 'FIX.4.4',
    name: 'UnderlyingStipValue',
    id: 889,
    description: 'Value of stipulation.\n\nSame values as StipulationValue (234)',
  },
  {
    abbrName: 'MatNetMny',
    type: 'Amt',
    added: 'FIX.4.4',
    name: 'MaturityNetMoney',
    id: 890,
    description:
      'Net Money at maturity if Zero Coupon and maturity value is different from par value',
  },
  {
    abbrName: 'Basis',
    type: 'MiscFeeBasisCodeSet',
    added: 'FIX.4.4',
    name: 'MiscFeeBasis',
    id: 891,
    description: 'Defines the unit for a miscellaneous fee.',
  },
  {
    abbrName: 'TotNoAllocs',
    type: 'int',
    added: 'FIX.4.4',
    name: 'TotNoAllocs',
    id: 892,
    description:
      'Total number of NoAlloc entries across all messages. Should be the sum of all NoAllocs in each message that has repeating NoAlloc entries related to the same AllocID or AllocReportID. Used to support fragmentation.',
  },
  {
    abbrName: 'LastFragment',
    type: 'LastFragmentCodeSet',
    added: 'FIX.4.4',
    name: 'LastFragment',
    id: 893,
    description:
      'Indicates whether this message is the last in a sequence of messages for those messages that support fragmentation, such as Allocation Instruction, Mass Quote, Security List, Derivative Security List',
  },
  {
    abbrName: 'ReqID',
    type: 'String',
    added: 'FIX.4.4',
    name: 'CollReqID',
    id: 894,
    description: 'Collateral Request Identifier',
  },
  {
    abbrName: 'AsgnRsn',
    type: 'CollAsgnReasonCodeSet',
    added: 'FIX.4.4',
    name: 'CollAsgnReason',
    id: 895,
    description: 'Reason for Collateral Assignment',
  },
  {
    abbrName: 'Qual',
    type: 'CollInquiryQualifierCodeSet',
    added: 'FIX.4.4',
    name: 'CollInquiryQualifier',
    id: 896,
    description: 'Collateral inquiry qualifiers:',
  },
  {
    abbrName: 'NoTrds',
    type: 'NumInGroup',
    added: 'FIX.4.4',
    name: 'NoTrades',
    id: 897,
    description: 'Number of trades in repeating group.',
  },
  {
    abbrName: 'MgnRatio',
    type: 'Percentage',
    added: 'FIX.4.4',
    name: 'MarginRatio',
    id: 898,
    description:
      'The fraction of the cash consideration that must be collateralized, expressed as a percent. A MarginRatio of 02% indicates that the value of the collateral (after deducting for "haircut") must exceed the cash consideration by 2%.',
  },
  {
    abbrName: 'MgnExcess',
    type: 'Amt',
    added: 'FIX.4.4',
    name: 'MarginExcess',
    id: 899,
    description: 'Excess margin amount (deficit if value is negative)',
  },
  {
    abbrName: 'TotNetValu',
    type: 'Amt',
    added: 'FIX.4.4',
    name: 'TotalNetValue',
    id: 900,
    description:
      'TotalNetValue is determined as follows:\n\nAt the initial collateral assignment TotalNetValue is the sum of (UnderlyingStartValue * (1-haircut)).\n\nIn a collateral substitution TotalNetValue is the sum of (UnderlyingCurrentValue * (1-haircut)).\n\nFor listed derivatives clearing margin management, this is the collateral value which equals (Market value * haircut)',
  },
  {
    abbrName: 'CshOutstanding',
    type: 'Amt',
    added: 'FIX.4.4',
    name: 'CashOutstanding',
    id: 901,
    description: 'Starting consideration less repayments',
  },
  {
    abbrName: 'ID',
    type: 'String',
    added: 'FIX.4.4',
    name: 'CollAsgnID',
    id: 902,
    description: 'Collateral Assignment Identifier',
  },
  {
    abbrName: 'TransTyp',
    type: 'CollAsgnTransTypeCodeSet',
    added: 'FIX.4.4',
    name: 'CollAsgnTransType',
    id: 903,
    description: 'Collateral Assignment Transaction Type',
  },
  {
    abbrName: 'RespID',
    type: 'String',
    added: 'FIX.4.4',
    name: 'CollRespID',
    id: 904,
    description: 'Collateral Response Identifier',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'CollAsgnRespTypeCodeSet',
    updatedEP: '192',
    added: 'FIX.4.4',
    name: 'CollAsgnRespType',
    id: 905,
    abbrName: 'RespTyp',
    description: 'Type of collateral assignment response.',
  },
  {
    type: 'CollAsgnRejectReasonCodeSet',
    unionDataType: 'Reserved100Plus',
    added: 'FIX.4.4',
    name: 'CollAsgnRejectReason',
    id: 906,
    abbrName: 'RejRsn',
    description: 'Collateral Assignment Reject Reason',
  },
  {
    abbrName: 'RefID',
    type: 'String',
    added: 'FIX.4.4',
    name: 'CollAsgnRefID',
    id: 907,
    description: 'Collateral Assignment Identifier to which a transaction refers',
  },
  {
    abbrName: 'RptID',
    type: 'String',
    added: 'FIX.4.4',
    name: 'CollRptID',
    id: 908,
    description: 'Collateral Report Identifier',
  },
  {
    abbrName: 'ID',
    type: 'String',
    added: 'FIX.4.4',
    name: 'CollInquiryID',
    id: 909,
    description: 'Collateral Inquiry Identifier',
  },
  {
    abbrName: 'Stat',
    type: 'CollStatusCodeSet',
    added: 'FIX.4.4',
    name: 'CollStatus',
    id: 910,
    description: 'Collateral Status',
  },
  {
    updated: 'FIX.5.0SP1',
    type: 'int',
    updatedEP: '95',
    added: 'FIX.4.4',
    name: 'TotNumReports',
    id: 911,
    abbrName: 'TotNumRpts',
    description: 'Total number of reports returned in response to a request.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'LastRptRequestedCodeSet',
    updatedEP: '141',
    added: 'FIX.4.4',
    name: 'LastRptRequested',
    id: 912,
    abbrName: 'LastRptReqed',
    description:
      'Indicates whether this message is the last report message in response to a request message, e.g. OrderMassStatusRequest(35=AF), TradeCaptureReportRequest(35=AD).',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    updatedEP: '254',
    added: 'FIX.4.4',
    name: 'AgreementDesc',
    id: 913,
    abbrName: 'AgmtDesc',
    description:
      'The full name of the base standard agreement, annexes and amendments in place between the principals applicable to a financing transaction. See http://www.fpml.org/coding-scheme/master-agreement-type for derivative values.\n\nFor EU SFTR reporting use the appropriate 4-character code noted in the regulations. See SFTR ITS "Commission Implementing Regulation (EU) 2019/363" Annexes 1 to 2 for values. For other agreement type use OTHR and the name of the agreement concatenated with a hyphen, e.g. OTHR-<IndexName>.',
  },
  {
    abbrName: 'AgmtID',
    type: 'String',
    added: 'FIX.4.4',
    name: 'AgreementID',
    id: 914,
    description:
      'A common reference to the applicable standing agreement between the counterparties to a financing transaction.',
  },
  {
    abbrName: 'AgmtDt',
    type: 'LocalMktDate',
    added: 'FIX.4.4',
    name: 'AgreementDate',
    id: 915,
    description:
      'A reference to the date the underlying agreement specified by AgreementID and AgreementDesc was executed.',
  },
  {
    abbrName: 'StartDt',
    type: 'LocalMktDate',
    added: 'FIX.4.4',
    name: 'StartDate',
    id: 916,
    description:
      'Start date of a financing deal, i.e. the date the buyer pays the seller cash and takes control of the collateral',
  },
  {
    abbrName: 'EndDt',
    type: 'LocalMktDate',
    added: 'FIX.4.4',
    name: 'EndDate',
    id: 917,
    description:
      'End date of a financing deal, i.e. the date the seller reimburses the buyer and takes back control of the collateral',
  },
  {
    abbrName: 'AgmtCcy',
    type: 'Currency',
    added: 'FIX.4.4',
    name: 'AgreementCurrency',
    id: 918,
    description:
      'Contractual currency forming the basis of a financing agreement and associated transactions. Usually, but not always, the same as the trade currency.',
  },
  {
    abbrName: 'DlvryTyp',
    type: 'DeliveryTypeCodeSet',
    added: 'FIX.4.4',
    name: 'DeliveryType',
    id: 919,
    description: 'Identifies type of settlement',
  },
  {
    abbrName: 'EndAcrdIntAmt',
    type: 'Amt',
    added: 'FIX.4.4',
    name: 'EndAccruedInterestAmt',
    id: 920,
    description:
      'Accrued Interest Amount applicable to a financing transaction on the End Date.',
  },
  {
    abbrName: 'StartCsh',
    type: 'Amt',
    added: 'FIX.4.4',
    name: 'StartCash',
    id: 921,
    description:
      'Starting dirty cash consideration of a financing deal, i.e. paid to the seller on the Start Date.',
  },
  {
    abbrName: 'EndCsh',
    type: 'Amt',
    added: 'FIX.4.4',
    name: 'EndCash',
    id: 922,
    description:
      'Ending dirty cash consideration of a financing deal. i.e. reimbursed to the buyer on the End Date.',
  },
  {
    abbrName: 'UserReqID',
    type: 'String',
    added: 'FIX.4.4',
    name: 'UserRequestID',
    id: 923,
    description: 'Unique identifier for a User Request.',
  },
  {
    abbrName: 'UserReqTyp',
    type: 'UserRequestTypeCodeSet',
    added: 'FIX.4.4',
    name: 'UserRequestType',
    id: 924,
    description: 'Indicates the action required by a User Request Message',
  },
  {
    abbrName: 'NewPassword',
    type: 'String',
    added: 'FIX.4.4',
    name: 'NewPassword',
    id: 925,
    description: 'New Password or passphrase',
  },
  {
    abbrName: 'UserStat',
    type: 'UserStatusCodeSet',
    added: 'FIX.4.4',
    name: 'UserStatus',
    id: 926,
    description: 'Indicates the status of a user',
  },
  {
    abbrName: 'UserStatText',
    type: 'String',
    added: 'FIX.4.4',
    name: 'UserStatusText',
    id: 927,
    description: 'A text description associated with a user status.',
  },
  {
    abbrName: 'StatValu',
    type: 'StatusValueCodeSet',
    added: 'FIX.4.4',
    name: 'StatusValue',
    id: 928,
    description: 'Indicates the status of a network connection',
  },
  {
    abbrName: 'StatText',
    type: 'String',
    added: 'FIX.4.4',
    name: 'StatusText',
    id: 929,
    description: 'A text description associated with a network status.',
  },
  {
    abbrName: 'RefCompID',
    type: 'String',
    added: 'FIX.4.4',
    name: 'RefCompID',
    id: 930,
    description: 'Assigned value used to identify a firm.',
  },
  {
    abbrName: 'RefSubID',
    type: 'String',
    added: 'FIX.4.4',
    name: 'RefSubID',
    id: 931,
    description: 'Assigned value used to identify specific elements within a firm.',
  },
  {
    abbrName: 'NtwkRspID',
    type: 'String',
    added: 'FIX.4.4',
    name: 'NetworkResponseID',
    id: 932,
    description: 'Unique identifier for a network response.',
  },
  {
    abbrName: 'NtwkReqID',
    type: 'String',
    added: 'FIX.4.4',
    name: 'NetworkRequestID',
    id: 933,
    description: 'Unique identifier for a network resquest.',
  },
  {
    abbrName: 'LastNtwkRspID',
    type: 'String',
    added: 'FIX.4.4',
    name: 'LastNetworkResponseID',
    id: 934,
    description:
      'Identifier of the previous Network Response message sent to a counterparty, used to allow incremental updates.',
  },
  {
    abbrName: 'NtwkReqTyp',
    type: 'NetworkRequestTypeCodeSet',
    added: 'FIX.4.4',
    name: 'NetworkRequestType',
    id: 935,
    description:
      "Indicates the type and level of details required for a Network Status Request Message\n\nBoolean logic applies EG If you want to subscribe for changes to certain id's then UserRequestType =0 (8+2), Snapshot for certain ID's = 9 (8+1)",
  },
  {
    abbrName: 'NoCompIDs',
    type: 'NumInGroup',
    added: 'FIX.4.4',
    name: 'NoCompIDs',
    id: 936,
    description: 'Number of CompID entries in a repeating group.',
  },
  {
    abbrName: 'NtwkStatRspTyp',
    type: 'NetworkStatusResponseTypeCodeSet',
    added: 'FIX.4.4',
    name: 'NetworkStatusResponseType',
    id: 937,
    description: 'Indicates the type of Network Response Message.',
  },
  {
    abbrName: 'NoCollInqQual',
    type: 'NumInGroup',
    added: 'FIX.4.4',
    name: 'NoCollInquiryQualifier',
    id: 938,
    description: 'Number of CollInquiryQualifier entries in a repeating group.',
  },
  {
    abbrName: 'TrdRptStat',
    type: 'TrdRptStatusCodeSet',
    added: 'FIX.4.4',
    name: 'TrdRptStatus',
    id: 939,
    description: 'Trade Report Status',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'AffirmStatusCodeSet',
    updatedEP: '215',
    added: 'FIX.4.4',
    name: 'AffirmStatus',
    id: 940,
    abbrName: 'AffirmStat',
    description: 'Specifies the affirmation status of the confirmation.',
  },
  {
    abbrName: 'StrkCcy',
    type: 'Currency',
    added: 'FIX.4.4',
    name: 'UnderlyingStrikeCurrency',
    id: 941,
    description:
      'Currency in which the strike price of an underlying instrument is denominated',
  },
  {
    abbrName: 'StrkCcy',
    type: 'Currency',
    added: 'FIX.4.4',
    name: 'LegStrikeCurrency',
    id: 942,
    description:
      'Currency in which the strike price of a instrument leg of a multileg instrument is denominated',
  },
  {
    abbrName: 'TmBkt',
    type: 'String',
    added: 'FIX.4.4',
    name: 'TimeBracket',
    id: 943,
    description:
      'A code that represents a time interval in which a fill or trade occurred.\n\nRequired for US futures markets.',
  },
  {
    abbrName: 'Actn',
    type: 'CollActionCodeSet',
    added: 'FIX.4.4',
    name: 'CollAction',
    id: 944,
    description: 'Action proposed for an Underlying Instrument instance.',
  },
  {
    abbrName: 'Stat',
    type: 'CollInquiryStatusCodeSet',
    added: 'FIX.4.4',
    name: 'CollInquiryStatus',
    id: 945,
    description: 'Status of Collateral Inquiry',
  },
  {
    type: 'CollInquiryResultCodeSet',
    unionDataType: 'Reserved100Plus',
    added: 'FIX.4.4',
    name: 'CollInquiryResult',
    id: 946,
    abbrName: 'Rslt',
    description:
      'Result returned in response to Collateral Inquiry\n\n4000+ Reserved and available for bi-laterally agreed upon user-defined values',
  },
  {
    abbrName: 'StrkCcy',
    type: 'Currency',
    added: 'FIX.4.4',
    name: 'StrikeCurrency',
    id: 947,
    description: 'Currency in which the StrikePrice is denominated.',
  },
  {
    abbrName: 'NoNst3PtyIDs',
    type: 'NumInGroup',
    added: 'FIX.4.4',
    name: 'NoNested3PartyIDs',
    id: 948,
    description:
      'Number of Nested3PartyID (949), Nested3PartyIDSource (950), and Nested3PartyRole (95) entries',
  },
  {
    abbrName: 'ID',
    type: 'String',
    added: 'FIX.4.4',
    name: 'Nested3PartyID',
    id: 949,
    discriminatorId: '950',
    description:
      'PartyID value within a "third instance" Nested repeating group.\n\nSame values as PartyID (448)',
  },
  {
    abbrName: 'Src',
    type: 'PartyIDSourceCodeSet',
    added: 'FIX.4.4',
    name: 'Nested3PartyIDSource',
    id: 950,
    description:
      'PartyIDSource value within a "third instance" Nested repeating group.\n\nSame values as PartyIDSource (447)',
  },
  {
    abbrName: 'R',
    type: 'PartyRoleCodeSet',
    added: 'FIX.4.4',
    name: 'Nested3PartyRole',
    id: 951,
    description:
      'PartyRole value within a "third instance" Nested repeating group.\n\nSame values as PartyRole (452)',
  },
  {
    abbrName: 'NoNst3PtySubIDs',
    type: 'NumInGroup',
    added: 'FIX.4.4',
    name: 'NoNested3PartySubIDs',
    id: 952,
    description: 'Number of Nested3PartySubIDs (953) entries',
  },
  {
    abbrName: 'ID',
    type: 'String',
    added: 'FIX.4.4',
    name: 'Nested3PartySubID',
    id: 953,
    description:
      'PartySubID value within a "third instance" Nested repeating group.\n\nSame values as PartySubID (523)',
  },
  {
    abbrName: 'Typ',
    type: 'PartySubIDTypeCodeSet',
    added: 'FIX.4.4',
    name: 'Nested3PartySubIDType',
    id: 954,
    description:
      'PartySubIDType value within a "third instance" Nested repeating group.\n\nSame values as PartySubIDType (803)',
  },
  {
    abbrName: 'CSetMo',
    type: 'MonthYear',
    added: 'FIX.4.4',
    name: 'LegContractSettlMonth',
    id: 955,
    description: 'Specifies when the contract (i.e. MBS/TBA) will settle.',
  },
  {
    abbrName: 'IntAcrl',
    type: 'LocalMktDate',
    added: 'FIX.4.4',
    name: 'LegInterestAccrualDate',
    id: 956,
    description:
      'The start date used for calculating accrued interest on debt instruments which are being sold between interest payment dates. Often but not always the same as the Issue Date and the Dated Date',
  },
  {
    type: 'NumInGroup',
    addedEP: '2',
    added: 'FIX.4.4',
    name: 'NoStrategyParameters',
    id: 957,
    abbrName: 'NoStrtPrm',
    description: 'Indicates number of strategy parameters',
  },
  {
    type: 'String',
    addedEP: '2',
    added: 'FIX.4.4',
    name: 'StrategyParameterName',
    id: 958,
    abbrName: 'StrtPrmNme',
    description: 'Name of parameter',
  },
  {
    type: 'StrategyParameterTypeCodeSet',
    addedEP: '2',
    added: 'FIX.4.4',
    name: 'StrategyParameterType',
    id: 959,
    abbrName: 'StrtPrmTyp',
    description: 'Datatype of the parameter',
  },
  {
    type: 'String',
    addedEP: '2',
    added: 'FIX.4.4',
    name: 'StrategyParameterValue',
    id: 960,
    abbrName: 'StrtPrmVal',
    description: 'Value of the parameter',
  },
  {
    type: 'String',
    addedEP: '3',
    added: 'FIX.4.4',
    name: 'HostCrossID',
    id: 961,
    abbrName: 'HstCxID',
    description:
      'Host assigned entity ID that can be used to reference all components of a cross; sides + strategy + legs. Used as the primary key with which to refer to the Cross Order for cancellation and replace. The HostCrossID will also be used to link together components of the Cross Order. For example, each individual Execution Report associated with the order will carry HostCrossID in order to tie back to the original cross order.',
  },
  {
    type: 'UTCTimestamp',
    addedEP: '3',
    added: 'FIX.4.4',
    name: 'SideTimeInForce',
    id: 962,
    abbrName: 'SideTmFrc',
    description:
      'Indicates how long the order as specified in the side stays in effect. SideTimeInForce allows a two-sided cross order to specify order behavior separately for each side. Absence of this field indicates that TimeInForce should be referenced. SideTimeInForce will override TimeInForce if both are provided.',
  },
  {
    type: 'int',
    addedEP: '4',
    added: 'FIX.4.4',
    name: 'MDReportID',
    id: 963,
    abbrName: 'RptID',
    description: 'Unique identifier for the Market Data Report.',
  },
  {
    updated: 'FIX.5.0SP1',
    type: 'int',
    addedEP: '4',
    updatedEP: '87',
    added: 'FIX.4.4',
    name: 'SecurityReportID',
    id: 964,
    abbrName: 'RptID',
    description: 'Identifies a Security List message.',
  },
  {
    updated: 'FIX.Latest',
    type: 'SecurityStatusCodeSet',
    addedEP: '4',
    updatedEP: '271',
    added: 'FIX.4.4',
    name: 'SecurityStatus',
    id: 965,
    abbrName: 'Status',
    description: 'Indicates the current state of the instrument.',
  },
  {
    type: 'String',
    addedEP: '4',
    added: 'FIX.4.4',
    name: 'SettleOnOpenFlag',
    id: 966,
    abbrName: 'SettlOnOpenFlag',
    description: 'Indicator to determine if instrument is settle on open',
  },
  {
    type: 'float',
    addedEP: '4',
    added: 'FIX.4.4',
    name: 'StrikeMultiplier',
    id: 967,
    abbrName: 'StrkMult',
    description:
      'Used for derivatives. Multiplier applied to the strike price for the purpose of calculating the settlement value.',
  },
  {
    type: 'float',
    addedEP: '4',
    added: 'FIX.4.4',
    name: 'StrikeValue',
    id: 968,
    abbrName: 'StrkValu',
    description:
      'Used for derivatives. The number of shares/units for the financial instrument involved in the option trade.',
  },
  {
    type: 'float',
    addedEP: '4',
    added: 'FIX.4.4',
    name: 'MinPriceIncrement',
    id: 969,
    abbrName: 'MinPxIncr',
    description: 'Minimum price increase for a given exchange-traded Instrument',
  },
  {
    type: 'int',
    addedEP: '4',
    added: 'FIX.4.4',
    name: 'PositionLimit',
    id: 970,
    abbrName: 'PosLmt',
    description: 'Position Limit for a given exchange-traded product.',
  },
  {
    type: 'int',
    addedEP: '4',
    added: 'FIX.4.4',
    name: 'NTPositionLimit',
    id: 971,
    abbrName: 'NTPosLmt',
    description:
      'Position Limit in the near-term contract for a given exchange-traded product.',
  },
  {
    type: 'Percentage',
    addedEP: '4',
    added: 'FIX.4.4',
    name: 'UnderlyingAllocationPercent',
    id: 972,
    abbrName: 'AllocPct',
    description: 'Percent of the Strike Price that this underlying represents.',
  },
  {
    type: 'Amt',
    addedEP: '4',
    added: 'FIX.4.4',
    name: 'UnderlyingCashAmount',
    id: 973,
    abbrName: 'CashAmt',
    description: 'Cash amount associated with the underlying component.',
  },
  {
    updated: 'FIX.5.0SP1',
    type: 'UnderlyingCashTypeCodeSet',
    addedEP: '4',
    updatedEP: '95',
    added: 'FIX.4.4',
    name: 'UnderlyingCashType',
    id: 974,
    abbrName: 'CashTyp',
    description: 'Used for derivatives that deliver into cash underlying.',
  },
  {
    type: 'UnderlyingSettlementTypeCodeSet',
    addedEP: '4',
    added: 'FIX.4.4',
    name: 'UnderlyingSettlementType',
    id: 975,
    abbrName: 'SettlTyp',
    description: 'Indicates order settlement period for the underlying instrument.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '4',
    added: 'FIX.4.4',
    name: 'QuantityDate',
    id: 976,
    abbrName: 'QtyDt',
    description:
      'Date associated to the quantity that is being reported for the position.',
  },
  {
    type: 'String',
    addedEP: '4',
    added: 'FIX.4.4',
    name: 'ContIntRptID',
    id: 977,
    abbrName: 'RptID',
    description: 'Unique identifier for the Contrary Intention report',
  },
  {
    type: 'Boolean',
    addedEP: '4',
    added: 'FIX.4.4',
    name: 'LateIndicator',
    id: 978,
    abbrName: 'LateInd',
    description:
      'Indicates if the contrary intention was received after the exchange imposed cutoff time',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    addedEP: '4',
    updatedEP: '148',
    added: 'FIX.4.4',
    name: 'InputSource',
    id: 979,
    abbrName: 'InptSrc',
    description: 'Originating source of the request.',
  },
  {
    updated: 'FIX.Latest',
    type: 'SecurityUpdateActionCodeSet',
    addedEP: '4',
    updatedEP: '275',
    added: 'FIX.4.4',
    name: 'SecurityUpdateAction',
    id: 980,
    abbrName: 'UpdActn',
    description:
      'Specifies the action taken or to be taken for the specified instrument or list of instruments.',
  },
  {
    type: 'NumInGroup',
    addedEP: '4',
    added: 'FIX.4.4',
    name: 'NoExpiration',
    id: 981,
    abbrName: 'NoExpiration',
    description: 'Number of Expiration Qty entries',
  },
  {
    type: 'ExpirationQtyTypeCodeSet',
    addedEP: '4',
    added: 'FIX.4.4',
    name: 'ExpirationQtyType',
    id: 982,
    abbrName: 'ExpTyp',
    description: 'Expiration Quantity type',
  },
  {
    type: 'Qty',
    addedEP: '4',
    added: 'FIX.4.4',
    name: 'ExpQty',
    id: 983,
    abbrName: 'ExpQty',
    description: 'Expiration Quantity associated with the Expiration Type',
  },
  {
    type: 'NumInGroup',
    addedEP: '4',
    added: 'FIX.4.4',
    name: 'NoUnderlyingAmounts',
    id: 984,
    abbrName: 'NoUnderlyingAmounts',
    description:
      'Total number of occurrences of Amount to pay in order to receive the underlying instrument',
  },
  {
    type: 'Amt',
    addedEP: '4',
    added: 'FIX.4.4',
    name: 'UnderlyingPayAmount',
    id: 985,
    abbrName: 'PayAmt',
    description: 'Amount to pay in order to receive the underlying instrument',
  },
  {
    type: 'Amt',
    addedEP: '4',
    added: 'FIX.4.4',
    name: 'UnderlyingCollectAmount',
    id: 986,
    abbrName: 'ColAmt',
    description: 'Amount to collect in order to deliver the underlying instrument',
  },
  {
    type: 'LocalMktDate',
    addedEP: '4',
    added: 'FIX.4.4',
    name: 'UnderlyingSettlementDate',
    id: 987,
    abbrName: 'StlDt',
    description:
      'Date the underlying instrument will settle. Used for derivatives that deliver into more than one underlying instrument. Settlement dates can vary across underlying instruments.',
  },
  {
    type: 'String',
    addedEP: '4',
    added: 'FIX.4.4',
    name: 'UnderlyingSettlementStatus',
    id: 988,
    abbrName: 'SetStat',
    description:
      'Settlement status of the underlying instrument. Used for derivatives that deliver into more than one underlying instrument. Settlement can be delayed for an underlying instrument.',
  },
  {
    type: 'String',
    addedEP: '5',
    added: 'FIX.4.4',
    name: 'SecondaryIndividualAllocID',
    id: 989,
    abbrName: 'IndAllocID2',
    description:
      'Will allow the intermediary to specify an allocation ID generated by their system.',
  },
  {
    type: 'String',
    addedEP: '5',
    added: 'FIX.4.4',
    name: 'LegReportID',
    id: 990,
    abbrName: 'RptID',
    description: 'Additional attribute to store the Trade ID of the Leg.',
  },
  {
    type: 'Price',
    addedEP: '5',
    added: 'FIX.4.4',
    name: 'RndPx',
    id: 991,
    abbrName: 'RndPx',
    description: 'Specifies average price rounded to quoted precision.',
  },
  {
    type: 'IndividualAllocTypeCodeSet',
    addedEP: '5',
    added: 'FIX.4.4',
    name: 'IndividualAllocType',
    id: 992,
    abbrName: 'Typ',
    description:
      'Identifies whether the allocation is to be sub-allocated or allocated to a third party',
  },
  {
    type: 'String',
    addedEP: '5',
    added: 'FIX.4.4',
    name: 'AllocCustomerCapacity',
    id: 993,
    abbrName: 'CustCpcty',
    description: 'Capacity of customer in the allocation block.',
  },
  {
    type: 'String',
    addedEP: '5',
    added: 'FIX.4.4',
    name: 'TierCode',
    id: 994,
    abbrName: 'TierCD',
    description: 'The Tier the trade was matched by the clearing system.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'UnitOfMeasureCodeSet',
    addedEP: '5',
    updatedEP: '122',
    added: 'FIX.4.4',
    name: 'UnitOfMeasure',
    id: 996,
    abbrName: 'UOM',
    description:
      "The unit of measure of the underlying commodity upon which the contract is based. Two groups of units of measure enumerations are supported.\n\nFixed Magnitude UOMs are primarily used in energy derivatives and specify a magnitude (such as, MM, Kilo, M, etc.) and the dimension (such as, watt hours, BTU's) to produce standard fixed measures (such as MWh - Megawatt-hours, MMBtu - One million BTUs).\n\nThe second group, Variable Quantity UOMs, specifies the dimension as a single unit without a magnitude (or more accurately a magnitude of one) and uses the UnitOfMeasureQty(1147) field to define the quantity of units per contract. Variable Quantity UOMs are used for both commodities (such as lbs of lean cattle, bushels of corn, ounces of gold) and financial futures.\n\nExamples:\n\nFor lean cattle futures contracts, a UnitOfMeasure of 'lbs' with a UnitOfMeasureQty(1147) of 40,000, means each lean cattle futures contract represents 40,000 lbs of lean cattle.\n\nFor Eurodollars futures contracts, a UnitOfMeasure of Ccy with a UnitOfMeasureCurrency(1716) of USD and a UnitOfMeasureQty(1147) of 1,000,000, means a Eurodollar futures contract represents 1,000,000 USD.\n\nFor gold futures contracts, a UnitOfMeasure is oz_tr (Troy ounce) with a UnitOfMeasureQty(1147) of 1,000, means each gold futures contract represents 1,000 troy ounces of gold.",
  },
  {
    updated: 'FIX.Latest',
    type: 'TimeUnitCodeSet',
    addedEP: '5',
    updatedEP: '287',
    added: 'FIX.4.4',
    name: 'TimeUnit',
    id: 997,
    abbrName: 'TmUnit',
    description:
      'Unit of time associated with the contract.\n\nNOTE: Additional values may be used by mutual agreement of the counterparties.',
  },
  {
    updated: 'FIX.Latest',
    type: 'UnitOfMeasureCodeSet',
    addedEP: '5',
    updatedEP: '271',
    added: 'FIX.4.4',
    name: 'UnderlyingUnitOfMeasure',
    id: 998,
    abbrName: 'UOM',
    description:
      'Underlying unit of measure.\n\nSee UnitOfMeasure(996) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'UnitOfMeasureCodeSet',
    addedEP: '5',
    updatedEP: '271',
    added: 'FIX.4.4',
    name: 'LegUnitOfMeasure',
    id: 999,
    abbrName: 'UOM',
    description:
      'Multileg instrument unit of measure.\n\nSee UnitOfMeasure(996) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'TimeUnitCodeSet',
    addedEP: '5',
    updatedEP: '287',
    added: 'FIX.4.4',
    name: 'UnderlyingTimeUnit',
    id: 1000,
    abbrName: 'TmUnit',
    description: 'See TimeUnit(997) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'TimeUnitCodeSet',
    addedEP: '5',
    updatedEP: '287',
    added: 'FIX.4.4',
    name: 'LegTimeUnit',
    id: 1001,
    abbrName: 'TmUnit',
    description: 'See TimeUnit(997) for complete definition.',
  },
  {
    type: 'AllocMethodCodeSet',
    addedEP: '5',
    added: 'FIX.4.4',
    name: 'AllocMethod',
    id: 1002,
    abbrName: 'Meth',
    description: 'Specifies the method under which a trade quantity was allocated.',
  },
  {
    type: 'String',
    addedEP: '11',
    added: 'FIX.4.4',
    name: 'TradeID',
    id: 1003,
    abbrName: 'TrdID',
    description:
      'The unique ID assigned to the trade entity once it is received or matched by the exchange or central counterparty.',
  },
  {
    type: 'String',
    addedEP: '5',
    added: 'FIX.4.4',
    name: 'SideTradeReportID',
    id: 1005,
    abbrName: 'RptID',
    description: 'Used on a multi-sided trade to designate the ReportID',
  },
  {
    type: 'String',
    addedEP: '5',
    added: 'FIX.4.4',
    name: 'SideFillStationCd',
    id: 1006,
    abbrName: 'FillStationCd',
    description: 'Used on a multi-sided trade to convey order routing information',
  },
  {
    type: 'String',
    addedEP: '5',
    added: 'FIX.4.4',
    name: 'SideReasonCd',
    id: 1007,
    abbrName: 'RsnCD',
    description: 'Used on a multi-sided trade to convey reason for execution',
  },
  {
    updated: 'FIX.Latest',
    type: 'TrdSubTypeCodeSet',
    addedEP: '5',
    updatedEP: '271',
    added: 'FIX.4.4',
    name: 'SideTrdSubType',
    id: 1008,
    abbrName: 'TrdSubTyp',
    description:
      'Used on a multi-sided trade to specify the type of trade for a given side. Same values as TrdSubType (829).',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'Qty',
    addedEP: '5',
    updatedEP: '161',
    added: 'FIX.4.4',
    name: 'SideLastQty',
    id: 1009,
    abbrName: 'SideQty',
    description: 'Used to indicate the quantity on one side of a multi-sided trade.',
  },
  {
    type: 'String',
    addedEP: '5',
    added: 'FIX.4.4',
    name: 'MessageEventSource',
    id: 1011,
    abbrName: 'MsgEvtSrc',
    description:
      'Used to identify the event or source which gave rise to a message.\n\nValid values will be based on an exchange\'s implementation.\n\nExample values are:\n\n"MQM" (originated at Firm Back Office)\n\n"Clear" (originated in Clearing System)\n\n"Reg" (static data generated via Register request)',
  },
  {
    updated: 'FIX.Latest',
    type: 'UTCTimestamp',
    addedEP: '5',
    updatedEP: '291',
    added: 'FIX.4.4',
    name: 'SideTrdRegTimestamp',
    id: 1012,
    abbrName: 'TS',
    description:
      'Same as TrdRegTimestamp(769). Used in a multi-sided message to indicate relevant trade-side timestamp.',
  },
  {
    updated: 'FIX.Latest',
    type: 'TrdRegTimestampTypeCodeSet',
    addedEP: '5',
    updatedEP: '291',
    added: 'FIX.4.4',
    name: 'SideTrdRegTimestampType',
    id: 1013,
    abbrName: 'Typ',
    description:
      'Same as TrdRegTimeStampType(770). Used in a multi-sided message to indicate relevant trade-side timestamp type.',
  },
  {
    updated: 'FIX.Latest',
    type: 'String',
    addedEP: '5',
    updatedEP: '291',
    added: 'FIX.4.4',
    name: 'SideTrdRegTimestampSrc',
    id: 1014,
    abbrName: 'Src',
    description:
      'Same as TrdRegTimestampOrigin(771). Used in a multi-sided message to indicate relevant trade-side origin or source of timestamp.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'AsOfIndicatorCodeSet',
    addedEP: '5',
    updatedEP: '141',
    added: 'FIX.4.4',
    name: 'AsOfIndicator',
    id: 1015,
    abbrName: 'AsOfInd',
    description:
      'A trade that is being submitted for a trade date prior to the current trade or clearing date, e.g. in an open outcry market an out trade being submitted for the previous trading session or trading day.',
  },
  {
    updated: 'FIX.Latest',
    type: 'NumInGroup',
    addedEP: '5',
    updatedEP: '291',
    added: 'FIX.4.4',
    name: 'NoSideTrdRegTS',
    id: 1016,
    abbrName: 'NoSideTrdRegTS',
    description: 'Number of timestamp entries.',
  },
  {
    type: 'float',
    addedEP: '18',
    added: 'FIX.4.4',
    name: 'LegOptionRatio',
    id: 1017,
    abbrName: 'LegOptionRatio',
    description:
      'Expresses the risk of an option leg\n\nValue must be between -1 and 1.\n\nA Call Option will require a ratio value between 0 and 1\n\nA Put Option will require a ratio value between -1 and 0',
  },
  {
    type: 'NumInGroup',
    addedEP: '4',
    added: 'FIX.4.4',
    name: 'NoInstrumentParties',
    id: 1018,
    abbrName: 'NoInstrmntPty',
    description: 'Identifies the number of parties identified with an instrument',
  },
  {
    type: 'String',
    addedEP: '4',
    added: 'FIX.4.4',
    name: 'InstrumentPartyID',
    id: 1019,
    abbrName: 'ID',
    discriminatorId: '1050',
    description:
      'PartyID value within an instrument party repeating group. Same values as PartyID (448)',
  },
  {
    type: 'Qty',
    addedEP: '7',
    added: 'FIX.4.4',
    name: 'TradeVolume',
    id: 1020,
    abbrName: 'TrdVol',
    description: 'Used to report volume with a trade',
  },
  {
    type: 'MDBookTypeCodeSet',
    addedEP: '7',
    added: 'FIX.4.4',
    name: 'MDBookType',
    id: 1021,
    abbrName: 'MDBkTyp',
    description:
      'Describes the type of book for which the feed is intended. Used when multiple feeds are provided over the same connection',
  },
  {
    type: 'String',
    addedEP: '7',
    added: 'FIX.4.4',
    name: 'MDFeedType',
    id: 1022,
    abbrName: 'MDFeedTyp',
    description:
      'Describes a class of service for a given data feed, ie Regular and Market Maker, Bandwidth Intensive or Bandwidth Conservative',
  },
  {
    updated: 'FIX.Latest',
    type: 'int',
    addedEP: '7',
    updatedEP: '271',
    added: 'FIX.4.4',
    name: 'MDPriceLevel',
    id: 1023,
    abbrName: 'MDPxLvl',
    description:
      'Integer to convey the level of a bid or offer at a given price level. This is in contrast to MDEntryPositionNo(290) which is used to convey the position of an order within a price level.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'MDOriginTypeCodeSet',
    addedEP: '7',
    updatedEP: '216',
    added: 'FIX.4.4',
    name: 'MDOriginType',
    id: 1024,
    abbrName: 'MDOrigTyp',
    description: 'Used to describe the origin of the market data entry.',
  },
  {
    type: 'Price',
    addedEP: '7',
    added: 'FIX.4.4',
    name: 'FirstPx',
    id: 1025,
    abbrName: 'FirstPx',
    description: 'Indicates the first trade price of the day/session',
  },
  {
    type: 'float',
    addedEP: '7',
    added: 'FIX.4.4',
    name: 'MDEntrySpotRate',
    id: 1026,
    abbrName: 'MDEntrySpotRt',
    description: 'The spot rate for an FX entry',
  },
  {
    type: 'PriceOffset',
    addedEP: '7',
    added: 'FIX.4.4',
    name: 'MDEntryForwardPoints',
    id: 1027,
    abbrName: 'MDEntryFwdPnts',
    description:
      'Used for an F/X entry. The forward points to be added to or subtracted from the spot rate to get the "all-in" rate in MDEntryPx. Expressed in decimal form. For example, 61.99 points is expressed and sent as 0.006199',
  },
  {
    updated: 'FIX.Latest',
    type: 'Boolean',
    addedEP: '9',
    updatedEP: '264',
    added: 'FIX.4.4',
    name: 'ManualOrderIndicator',
    id: 1028,
    abbrName: 'ManOrdInd',
    description:
      'Indicates if an order, quote or trade was initially received manually (as opposed to electronically) or if it was entered manually (as opposed to entered by automated trading software).',
  },
  {
    updated: 'FIX.5.0SP1',
    type: 'Boolean',
    addedEP: '9',
    updatedEP: '95',
    added: 'FIX.4.4',
    name: 'CustDirectedOrder',
    id: 1029,
    abbrName: 'CustDrctdOrd',
    description:
      'Indicates if the customer directed this order to a specific execution venue "Y" or not "N".\n\nA default of "N" customer did not direct this order should be used in the case where the information is both missing and essential.',
  },
  {
    deprecatedEP: '135',
    updated: 'FIX.5.0SP2',
    type: 'String',
    deprecated: 'FIX.5.0SP2',
    addedEP: '9',
    updatedEP: '135',
    added: 'FIX.4.4',
    name: 'ReceivedDeptID',
    id: 1030,
    abbrName: 'RcvdDptID',
    description: 'Identifies the broker-dealer department that first took the order.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'CustOrderHandlingInstCodeSet',
    addedEP: '9',
    updatedEP: '135',
    added: 'FIX.4.4',
    name: 'CustOrderHandlingInst',
    id: 1031,
    abbrName: 'CustOrdHdlInst',
    description:
      'Codes that apply special information that the Broker / Dealer needs to report, as specified by the customer.\n\nNOTE: This field and its values have no bearing on the ExecInst and TimeInForce fields. These values should not be used instead of ExecInst or TimeInForce. This field and its values are intended for compliance reporting and/or billing purposes only.\n\nFor OrderHandlingInstSrc(1032) = 1 (FINRA OATS), valid values are (as of OATS Phase 3 as provided by FINRA. See also http://www.finra.org/Industry/Compliance/MarketTransparency/OATS/PhaseIII/index.htm for a complete list.\n\nFor OrderHandlingInstSrc(1032) = 2 (FIA Execution Source Code), only one enumeration value may be specified.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'OrderHandlingInstSourceCodeSet',
    addedEP: '9',
    updatedEP: '135',
    added: 'FIX.4.4',
    name: 'OrderHandlingInstSource',
    id: 1032,
    abbrName: 'OrdHndlInstSrc',
    description:
      'Identifies the class or source of the order handling instruction values.  Scope of this will apply to both CustOrderHandlingInst(1031) and DeskOrderHandlingInst(1035).\n\nConditionally required when CustOrderHandlingInst(1031) or DeskOrderHandlingInst(1035) is specified.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'DeskTypeCodeSet',
    addedEP: '9',
    updatedEP: '135',
    added: 'FIX.4.4',
    name: 'DeskType',
    id: 1033,
    abbrName: 'DskTyp',
    discriminatorId: '1034',
    description:
      'Identifies the type of Trading Desk.\n\nConditionally required when InformationBarrierID(1727) is specified for OATS.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'DeskTypeSourceCodeSet',
    addedEP: '9',
    updatedEP: '135',
    added: 'FIX.4.4',
    name: 'DeskTypeSource',
    id: 1034,
    abbrName: 'DskTypSrc',
    description:
      'Identifies the class or source of DeskType(1033) values. Conditionally required when DeskType(1033) is specified.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'CustOrderHandlingInstCodeSet',
    addedEP: '9',
    updatedEP: '135',
    added: 'FIX.4.4',
    name: 'DeskOrderHandlingInst',
    id: 1035,
    abbrName: 'DskOrdHndlInst',
    description:
      'Codes that apply special information that the broker-dealer needs to report.',
  },
  {
    type: 'ExecAckStatusCodeSet',
    addedEP: '10',
    added: 'FIX.4.4',
    name: 'ExecAckStatus',
    id: 1036,
    abbrName: 'ExecAckStat',
    description: 'The status of this execution acknowledgement message.',
  },
  {
    type: 'Amt',
    addedEP: '8',
    added: 'FIX.4.4',
    name: 'UnderlyingDeliveryAmount',
    id: 1037,
    abbrName: 'UndlyDlvAmt',
    description: 'Indicates the underlying position amount to be delivered',
  },
  {
    type: 'Amt',
    addedEP: '8',
    added: 'FIX.4.4',
    name: 'UnderlyingCapValue',
    id: 1038,
    abbrName: 'CapValu',
    description: 'Maximum notional value for a capped financial instrument',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'SettlMethodCodeSet',
    addedEP: '8',
    updatedEP: '169',
    added: 'FIX.4.4',
    name: 'UnderlyingSettlMethod',
    id: 1039,
    abbrName: 'SetMeth',
    description:
      'Settlement method for a contract or instrument. Additional values may be used with bilateral agreement.',
  },
  {
    type: 'String',
    addedEP: '11',
    added: 'FIX.4.4',
    name: 'SecondaryTradeID',
    id: 1040,
    abbrName: 'TrdID2',
    description:
      'Used to carry an internal trade entity ID which may or may not be reported to the firm',
  },
  {
    type: 'String',
    addedEP: '11',
    added: 'FIX.4.4',
    name: 'FirmTradeID',
    id: 1041,
    abbrName: 'FirmTrdID',
    description:
      'The ID assigned to a trade by the Firm to track a trade within the Firm system. This ID can be assigned either before or after submission to the exchange or central counterpary',
  },
  {
    type: 'String',
    addedEP: '11',
    added: 'FIX.4.4',
    name: 'SecondaryFirmTradeID',
    id: 1042,
    abbrName: 'FirmTrdID2',
    description:
      'Used to carry an internal firm assigned ID which may or may not be reported to the exchange or central counterpary',
  },
  {
    type: 'CollApplTypeCodeSet',
    addedEP: '12',
    added: 'FIX.4.4',
    name: 'CollApplType',
    id: 1043,
    abbrName: 'ApplTyp',
    description: 'conveys how the collateral should be/has been applied',
  },
  {
    type: 'Qty',
    addedEP: '12',
    added: 'FIX.4.4',
    name: 'UnderlyingAdjustedQuantity',
    id: 1044,
    abbrName: 'AdjQty',
    description:
      'Unit amount of the underlying security (shares) adjusted for pending corporate action not yet allocated.',
  },
  {
    type: 'float',
    addedEP: '12',
    added: 'FIX.4.4',
    name: 'UnderlyingFXRate',
    id: 1045,
    abbrName: 'FxRate',
    description:
      'Foreign exchange rate used to compute UnderlyingCurrentValue(885) (or market value) from UnderlyingCurrency(318) to Currency(15).',
  },
  {
    type: 'UnderlyingFXRateCalcCodeSet',
    addedEP: '12',
    added: 'FIX.4.4',
    name: 'UnderlyingFXRateCalc',
    id: 1046,
    abbrName: 'FxRateCalc',
    description:
      'Specifies whether the UnderlyingFxRate(1045) should be multiplied or divided.',
  },
  {
    type: 'AllocPositionEffectCodeSet',
    addedEP: '17',
    added: 'FIX.4.4',
    name: 'AllocPositionEffect',
    id: 1047,
    abbrName: 'AllocPosEfct',
    description:
      'Indicates whether the resulting position after a trade should be an opening position or closing position. Used for omnibus accounting - where accounts are held on a gross basis instead of being netted together.',
  },
  {
    updated: 'FIX.5.0SP1',
    type: 'DealingCapacityCodeSet',
    addedEP: '7',
    updatedEP: '95',
    added: 'FIX.4.4',
    name: 'DealingCapacity',
    id: 1048,
    abbrName: 'DealingCpcty',
    description: 'Identifies role of dealer; Agent, Principal, RisklessPrincipal',
  },
  {
    type: 'InstrmtAssignmentMethodCodeSet',
    addedEP: '4',
    added: 'FIX.4.4',
    name: 'InstrmtAssignmentMethod',
    id: 1049,
    abbrName: 'AsgnMeth',
    description: 'Method under which assignment was conducted',
  },
  {
    type: 'PartyIDSourceCodeSet',
    addedEP: '4',
    added: 'FIX.4.4',
    name: 'InstrumentPartyIDSource',
    id: 1050,
    abbrName: 'Src',
    description:
      'PartyIDSource value within an instrument partyrepeating group.\n\nSame values as PartyIDSource (447)',
  },
  {
    type: 'PartyRoleCodeSet',
    addedEP: '4',
    added: 'FIX.4.4',
    name: 'InstrumentPartyRole',
    id: 1051,
    abbrName: 'R',
    description:
      'PartyRole value within an instrument partyepeating group.\n\nSame values as PartyRole (452)',
  },
  {
    type: 'NumInGroup',
    addedEP: '4',
    added: 'FIX.4.4',
    name: 'NoInstrumentPartySubIDs',
    id: 1052,
    abbrName: 'NoInstrmntPtySubIDs',
    description:
      'Number of InstrumentPartySubID (1053) and InstrumentPartySubIDType (1054) entries',
  },
  {
    type: 'String',
    addedEP: '4',
    added: 'FIX.4.4',
    name: 'InstrumentPartySubID',
    id: 1053,
    abbrName: 'ID',
    description:
      'PartySubID value within an instrument party repeating group.\n\nSame values as PartySubID (523)',
  },
  {
    type: 'PartySubIDTypeCodeSet',
    addedEP: '4',
    added: 'FIX.4.4',
    name: 'InstrumentPartySubIDType',
    id: 1054,
    abbrName: 'Typ',
    description:
      'Type of InstrumentPartySubID (1053) value.\n\nSame values as PartySubIDType (803)',
  },
  {
    type: 'String',
    addedEP: '8',
    added: 'FIX.4.4',
    name: 'PositionCurrency',
    id: 1055,
    abbrName: 'Ccy',
    description: 'The Currency in which the position Amount is denominated',
  },
  {
    type: 'Qty',
    addedEP: '21',
    added: 'FIX.4.4',
    name: 'CalculatedCcyLastQty',
    id: 1056,
    abbrName: 'CalcCcyLastQty',
    description:
      'Used for the calculated quantity of the other side of the currency trade. Can be derived from LastQty and LastPx.',
  },
  {
    type: 'AggressorIndicatorCodeSet',
    addedEP: '21',
    added: 'FIX.4.4',
    name: 'AggressorIndicator',
    id: 1057,
    abbrName: 'AgrsrInd',
    description:
      'Used to identify whether the order initiator is an aggressor or not in the trade.',
  },
  {
    type: 'NumInGroup',
    addedEP: '8',
    added: 'FIX.4.4',
    name: 'NoUndlyInstrumentParties',
    id: 1058,
    abbrName: 'NoInstrmntPty',
    description:
      'Identifies the number of parties identified with an underlying instrument',
  },
  {
    updated: 'FIX.5.0SP1',
    type: 'String',
    addedEP: '8',
    updatedEP: '95',
    added: 'FIX.4.4',
    name: 'UnderlyingInstrumentPartyID',
    id: 1059,
    abbrName: 'ID',
    discriminatorId: '1060',
    description:
      'PartyID value within an underlying instrument party repeating group.\n\nSame values as PartyID (448)',
  },
  {
    updated: 'FIX.5.0SP1',
    type: 'PartyIDSourceCodeSet',
    addedEP: '8',
    updatedEP: '95',
    added: 'FIX.4.4',
    name: 'UnderlyingInstrumentPartyIDSource',
    id: 1060,
    abbrName: 'Src',
    description:
      'PartyIDSource value within an underlying instrument partyrepeating group.\n\nSame values as PartyIDSource (447)',
  },
  {
    updated: 'FIX.5.0SP1',
    type: 'PartyRoleCodeSet',
    addedEP: '8',
    updatedEP: '95',
    added: 'FIX.4.4',
    name: 'UnderlyingInstrumentPartyRole',
    id: 1061,
    abbrName: 'R',
    description:
      'PartyRole value within an underlying instrument partyepeating group.\n\nSame values as PartyRole (452)',
  },
  {
    type: 'NumInGroup',
    addedEP: '8',
    added: 'FIX.4.4',
    name: 'NoUndlyInstrumentPartySubIDs',
    id: 1062,
    abbrName: 'NoInstrmntPtySubIDs',
    description:
      'Number of Underlying InstrumentPartySubID (1053) and InstrumentPartySubIDType (1054) entries',
  },
  {
    updated: 'FIX.5.0SP1',
    type: 'String',
    addedEP: '8',
    updatedEP: '95',
    added: 'FIX.4.4',
    name: 'UnderlyingInstrumentPartySubID',
    id: 1063,
    abbrName: 'ID',
    description:
      'PartySubID value within an underlying instrument party repeating group.\n\nSame values as PartySubID (523)',
  },
  {
    updated: 'FIX.5.0SP1',
    type: 'PartySubIDTypeCodeSet',
    addedEP: '8',
    updatedEP: '95',
    added: 'FIX.4.4',
    name: 'UnderlyingInstrumentPartySubIDType',
    id: 1064,
    abbrName: 'Typ',
    description:
      'Type of underlying InstrumentPartySubID (1053) value.\n\nSame values as PartySubIDType (803)',
  },
  {
    type: 'PriceOffset',
    addedEP: '21',
    added: 'FIX.4.4',
    name: 'BidSwapPoints',
    id: 1065,
    abbrName: 'BidSwapPnts',
    description:
      'The bid FX Swap points for an FX Swap. It is the "far bid forward points - near offer forward point". Value can be negative. Expressed in decimal form. For example, 61.99 points is expressed and sent as 0.006199',
  },
  {
    type: 'PriceOffset',
    addedEP: '21',
    added: 'FIX.4.4',
    name: 'OfferSwapPoints',
    id: 1066,
    abbrName: 'OfrSwapPnts',
    description:
      'The offer FX Swap points for an FX Swap. It is the "far offer forward points - near bid forward points". Value can be negative. Expressed in decimal form. For example, 61.99 points is expressed and sent as 0.006199',
  },
  {
    type: 'PriceOffset',
    addedEP: '21',
    added: 'FIX.4.4',
    name: 'LegBidForwardPoints',
    id: 1067,
    abbrName: 'LegBidFwdPnts',
    description:
      'The bid FX forward points for the leg of an FX Swap. Value can be negative. Expressed in decimal form. For example, 61.99 points is expressed and sent as 0.006199',
  },
  {
    type: 'PriceOffset',
    addedEP: '21',
    added: 'FIX.4.4',
    name: 'LegOfferForwardPoints',
    id: 1068,
    abbrName: 'LegOfrFwdPnts',
    description:
      'The offer FX forward points for the leg of an FX Swap. Value can be negative. Expressed in decimal form. For example, 61.99 points is expressed and sent as 0.006199',
  },
  {
    type: 'PriceOffset',
    addedEP: '21',
    added: 'FIX.4.4',
    name: 'SwapPoints',
    id: 1069,
    abbrName: 'SwapPnts',
    description:
      "For FX Swap, this is used to express the differential between the far leg's bid/offer and the near leg's bid/offer. Value can be negative. Expressed in decimal form. For example, 61.99 points is expressed and sent as 0.006199",
  },
  {
    type: 'MDQuoteTypeCodeSet',
    addedEP: '7',
    added: 'FIX.4.4',
    name: 'MDQuoteType',
    id: 1070,
    abbrName: 'MDQteTyp',
    description: 'Identifies market data quote type.',
  },
  {
    type: 'PriceOffset',
    addedEP: '21',
    added: 'FIX.4.4',
    name: 'LastSwapPoints',
    id: 1071,
    abbrName: 'LastSwapPnts',
    description:
      "For FX Swap, this is used to express the last market event for the differential between the far leg's bid/offer and the near leg's bid/offer in a fill or partial fill. Value can be negative. Expressed in decimal form. For example, 61.99 points is expressed and sent as 0.006199",
  },
  {
    type: 'Amt',
    addedEP: '25',
    added: 'FIX.4.4',
    name: 'SideGrossTradeAmt',
    id: 1072,
    abbrName: 'SideGrossTradeAmt',
    description:
      'The gross trade amount for this side of the trade. See also GrossTradeAmt (381) for additional definition.',
  },
  {
    type: 'PriceOffset',
    addedEP: '21',
    added: 'FIX.4.4',
    name: 'LegLastForwardPoints',
    id: 1073,
    abbrName: 'LegLastFwdPnts',
    description:
      "The forward points for this leg's fill event. Value can be negative. Expressed in decimal form. For example, 61.99 points is expressed and sent as 0.006199",
  },
  {
    type: 'Qty',
    addedEP: '21',
    added: 'FIX.4.4',
    name: 'LegCalculatedCcyLastQty',
    id: 1074,
    abbrName: 'LegCalcCcyLastQty',
    description:
      'Used for the calculated quantity of the other side of the currency for this leg. Can be derived from LegQty and LegLastPx.',
  },
  {
    type: 'Amt',
    addedEP: '21',
    added: 'FIX.4.4',
    name: 'LegGrossTradeAmt',
    id: 1075,
    abbrName: 'LegGrossTrdAmt',
    description:
      'The gross trade amount of the leg. For FX Futures this is used to express the notional value of a fill when LegLastQty and other quantity fields are express in terms of contract size.',
  },
  {
    type: 'TZTimeOnly',
    addedEP: '21',
    added: 'FIX.4.4',
    name: 'MaturityTime',
    id: 1079,
    abbrName: 'MatTm',
    description:
      "Time of security's maturity expressed in local time with offset to UTC specified",
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    addedEP: '22',
    updatedEP: '171',
    added: 'FIX.4.4',
    name: 'RefOrderID',
    id: 1080,
    abbrName: 'RefOrdID',
    discriminatorId: '1081',
    description:
      'The ID reference to the order being hit or taken.\n\nFor pre-trade credit/risk limit check process, this is the reference to the placed order, quote request or quote for the credit/risk limit check.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'RefOrderIDSourceCodeSet',
    addedEP: '22',
    updatedEP: '253',
    added: 'FIX.4.4',
    name: 'RefOrderIDSource',
    id: 1081,
    abbrName: 'RefOrdIDSrc',
    description:
      'Used to specify the source for the identifier in RefOrderID(1080). This can be an identifier provided in order depth market data when hitting (taking) a specific order or to identify what type of order or quote reference is being provided when seeking credit limit check. In the context of US CAT this can be used to identify related orders and quotes which are parent, previous, or manual orders or quotes. Previous relates to orders changing their unique system assigned order identifier.',
  },
  {
    type: 'Qty',
    addedEP: '22',
    added: 'FIX.4.4',
    name: 'SecondaryDisplayQty',
    id: 1082,
    abbrName: 'SecDspQty',
    description:
      'Used for reserve orders when DisplayQty applies to the primary execution market (e.g.an ECN) and another quantity is to be shown at other markets (e.g. the exchange). On orders specifies the qty to be displayed, on execution reports the currently displayed quantity.',
  },
  {
    type: 'DisplayWhenCodeSet',
    addedEP: '22',
    added: 'FIX.4.4',
    name: 'DisplayWhen',
    id: 1083,
    abbrName: 'DspWhn',
    description: 'Instructs when to refresh DisplayQty (1138).',
  },
  {
    type: 'DisplayMethodCodeSet',
    addedEP: '22',
    added: 'FIX.4.4',
    name: 'DisplayMethod',
    id: 1084,
    abbrName: 'DspMthd',
    description:
      'Defines what value to use in DisplayQty (1138). If not specified the default DisplayMethod is "1"',
  },
  {
    type: 'Qty',
    addedEP: '22',
    added: 'FIX.4.4',
    name: 'DisplayLowQty',
    id: 1085,
    abbrName: 'DsplLwQty',
    description:
      'Defines the lower quantity limit to a randomized refresh of DisplayQty.',
  },
  {
    type: 'Qty',
    addedEP: '22',
    added: 'FIX.4.4',
    name: 'DisplayHighQty',
    id: 1086,
    abbrName: 'DisplayHighQty',
    description:
      'Defines the upper quantity limit to a randomized refresh of DisplayQty.',
  },
  {
    type: 'Qty',
    addedEP: '22',
    added: 'FIX.4.4',
    name: 'DisplayMinIncr',
    id: 1087,
    abbrName: 'DspMinIncr',
    description:
      'Defines the minimum increment to be used when calculating a random refresh of DisplayQty. A user specifies this when he wants a larger increment than the standard provided by the market (e.g. the round lot size).',
  },
  {
    type: 'Qty',
    addedEP: '22',
    added: 'FIX.4.4',
    name: 'RefreshQty',
    id: 1088,
    abbrName: 'RfrshQty',
    description: 'Defines the quantity used to refresh DisplayQty.',
  },
  {
    type: 'Qty',
    addedEP: '22',
    added: 'FIX.4.4',
    name: 'MatchIncrement',
    id: 1089,
    abbrName: 'MtchInc',
    description:
      'Allows orders to specify a minimum quantity that applies to every execution (one execution could be for multiple counter-orders). The order may still fill against smaller orders, but the cumulative quantity of the execution must be in multiples of the MatchIncrement.',
  },
  {
    type: 'int',
    addedEP: '22',
    added: 'FIX.4.4',
    name: 'MaxPriceLevels',
    id: 1090,
    abbrName: 'MxPxLvls',
    description:
      'Allows an order to specify a maximum number of price levels to trade through. Only valid for aggressive orders and during continuous (autoexecution) trading sessions. Property lost when order is put on book. A partially filled order is assigned last trade price as limit price. Non-filled order behaves as ordinary Market or Limit.',
  },
  {
    type: 'Boolean',
    addedEP: '22',
    added: 'FIX.4.4',
    name: 'PreTradeAnonymity',
    id: 1091,
    abbrName: 'PrTrdAnon',
    description:
      'Allows trader to explicitly request anonymity or disclosure in pre-trade market data feeds. Anonymity is relevant in markets where counterparties are regularly disclosed in order depth feeds. Disclosure is relevant when counterparties are not normally visible.',
  },
  {
    type: 'PriceProtectionScopeCodeSet',
    addedEP: '22',
    added: 'FIX.4.4',
    name: 'PriceProtectionScope',
    id: 1092,
    abbrName: 'PxPrtScp',
    description:
      'Defines the type of price protection the customer requires on their order.',
  },
  {
    type: 'LotTypeCodeSet',
    addedEP: '22',
    added: 'FIX.4.4',
    name: 'LotType',
    id: 1093,
    abbrName: 'LotTyp',
    description: 'Defines the lot type assigned to the order.',
  },
  {
    type: 'PegPriceTypeCodeSet',
    addedEP: '22',
    added: 'FIX.4.4',
    name: 'PegPriceType',
    id: 1094,
    abbrName: 'PegPxTyp',
    description: 'Defines the type of peg.',
  },
  {
    type: 'Price',
    addedEP: '22',
    added: 'FIX.4.4',
    name: 'PeggedRefPrice',
    id: 1095,
    abbrName: 'PggdRefPx',
    description:
      'The value of the reference price that the order is pegged to. PeggedRefPrice + PegOffsetValue (211) = PeggedPrice (839) unless the limit price (44, Price) is breached. The values may not be exact due to rounding.',
  },
  {
    updated: 'FIX.Latest',
    type: 'SecurityIDSourceCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '22',
    updatedEP: '265',
    added: 'FIX.4.4',
    name: 'PegSecurityIDSource',
    id: 1096,
    abbrName: 'PegSecurityIDSource',
    description:
      'Defines the identity of the security off whose prices the order will peg. Same values as SecurityIDSource (22)',
  },
  {
    type: 'String',
    addedEP: '22',
    added: 'FIX.4.4',
    name: 'PegSecurityID',
    id: 1097,
    abbrName: 'PegSecID',
    discriminatorId: '1096',
    description:
      'Defines the identity of the security off whose prices the order will peg.',
  },
  {
    type: 'String',
    addedEP: '22',
    added: 'FIX.4.4',
    name: 'PegSymbol',
    id: 1098,
    abbrName: 'PgSymbl',
    description:
      "Defines the common, 'human understood' representation of the security off whose prices the order will Peg.",
  },
  {
    type: 'String',
    addedEP: '22',
    added: 'FIX.4.4',
    name: 'PegSecurityDesc',
    id: 1099,
    abbrName: 'PegSecDesc',
    description:
      'Security description of the security off whose prices the order will Peg.',
  },
  {
    type: 'TriggerTypeCodeSet',
    addedEP: '-1',
    added: 'FIX.5.0',
    name: 'TriggerType',
    id: 1100,
    abbrName: 'TrgrTyp',
    description:
      'Defines when the trigger will hit, i.e. the action specified by the trigger instructions will come into effect.',
  },
  {
    type: 'TriggerActionCodeSet',
    addedEP: '-1',
    added: 'FIX.5.0',
    name: 'TriggerAction',
    id: 1101,
    abbrName: 'TrgrActn',
    description: 'Defines the type of action to take when the trigger hits.',
  },
  {
    type: 'Price',
    addedEP: '-1',
    added: 'FIX.5.0',
    name: 'TriggerPrice',
    id: 1102,
    abbrName: 'TrgrPx',
    description: 'The price at which the trigger should hit.',
  },
  {
    type: 'String',
    addedEP: '-1',
    added: 'FIX.5.0',
    name: 'TriggerSymbol',
    id: 1103,
    abbrName: 'TrgrSym',
    description:
      "Defines the common, 'human understood' representation of the security whose prices will be tracked by the trigger logic.",
  },
  {
    type: 'String',
    addedEP: '-1',
    added: 'FIX.5.0',
    name: 'TriggerSecurityID',
    id: 1104,
    abbrName: 'TrgrSecID',
    discriminatorId: '1105',
    description:
      'Defines the identity of the security whose prices will be tracked by the trigger logic.',
  },
  {
    updated: 'FIX.Latest',
    type: 'SecurityIDSourceCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '-1',
    updatedEP: '265',
    added: 'FIX.5.0',
    name: 'TriggerSecurityIDSource',
    id: 1105,
    abbrName: 'TrgrSecIDSrc',
    description:
      'Defines the identity of the security whose prices will be tracked by the trigger logic. Same values as SecurityIDSource (22).',
  },
  {
    type: 'String',
    addedEP: '-1',
    added: 'FIX.5.0',
    name: 'TriggerSecurityDesc',
    id: 1106,
    abbrName: 'TrgrSecDesc',
    description:
      'Defines the security description of the security whose prices will be tracked by the trigger logic.',
  },
  {
    type: 'TriggerPriceTypeCodeSet',
    addedEP: '-1',
    added: 'FIX.5.0',
    name: 'TriggerPriceType',
    id: 1107,
    abbrName: 'TrgrPxTyp',
    description: 'The type of price that the trigger is compared to.',
  },
  {
    type: 'TriggerPriceTypeScopeCodeSet',
    addedEP: '-1',
    added: 'FIX.5.0',
    name: 'TriggerPriceTypeScope',
    id: 1108,
    abbrName: 'TrgrPxTypScp',
    description:
      'Defines the type of price protection the customer requires on their order.',
  },
  {
    type: 'TriggerPriceDirectionCodeSet',
    addedEP: '-1',
    added: 'FIX.5.0',
    name: 'TriggerPriceDirection',
    id: 1109,
    abbrName: 'TrgrPxDir',
    description: 'The side from which the trigger price is reached.',
  },
  {
    type: 'Price',
    addedEP: '-1',
    added: 'FIX.5.0',
    name: 'TriggerNewPrice',
    id: 1110,
    abbrName: 'TrgrNewPx',
    description:
      'The Price that the order should have after the trigger has hit. Could be applicable for any trigger type, but must be specified for Trigger Type 1.',
  },
  {
    type: 'TriggerOrderTypeCodeSet',
    addedEP: '-1',
    added: 'FIX.5.0',
    name: 'TriggerOrderType',
    id: 1111,
    abbrName: 'TrgrOrdTyp',
    description:
      'The OrdType the order should have after the trigger has hit. Required to express orders that change from Limit to Market. Other values from OrdType (40) may be used if appropriate and bilaterally agreed upon.',
  },
  {
    type: 'Qty',
    addedEP: '-1',
    added: 'FIX.5.0',
    name: 'TriggerNewQty',
    id: 1112,
    abbrName: 'TrgrNewQty',
    description: 'The Quantity the order should have after the trigger has hit.',
  },
  {
    updated: 'FIX.Latest',
    type: 'TradingSessionIDCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '-1',
    updatedEP: '282',
    added: 'FIX.5.0',
    name: 'TriggerTradingSessionID',
    id: 1113,
    abbrName: 'TrgrTrdSessID',
    description: 'Defines the trading session at which the order will be activated.',
  },
  {
    updated: 'FIX.Latest',
    type: 'TradingSessionSubIDCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '-1',
    updatedEP: '282',
    added: 'FIX.5.0',
    name: 'TriggerTradingSessionSubID',
    id: 1114,
    abbrName: 'TrgrTrdSessSubID',
    description:
      'Defines the subordinate trading session at which the order will be activated.',
  },
  {
    type: 'OrderCategoryCodeSet',
    addedEP: '22',
    added: 'FIX.4.4',
    name: 'OrderCategory',
    id: 1115,
    abbrName: 'OrdCat',
    description: 'Defines the type of interest behind a trade (fill or partial fill).',
  },
  {
    type: 'NumInGroup',
    addedEP: '22',
    added: 'FIX.4.4',
    name: 'NoRootPartyIDs',
    id: 1116,
    abbrName: 'NoRootPartyIDs',
    description:
      'Number of RootPartyID (1117), RootPartyIDSource (1118), and RootPartyRole (1119) entries',
  },
  {
    type: 'String',
    addedEP: '22',
    added: 'FIX.4.4',
    name: 'RootPartyID',
    id: 1117,
    abbrName: 'ID',
    discriminatorId: '1118',
    description:
      'PartyID value within a root parties component. Same values as PartyID (448)',
  },
  {
    type: 'PartyIDSourceCodeSet',
    addedEP: '22',
    added: 'FIX.4.4',
    name: 'RootPartyIDSource',
    id: 1118,
    abbrName: 'Src',
    description:
      'PartyIDSource value within a root parties component. Same values as PartyIDSource (447)',
  },
  {
    type: 'PartyRoleCodeSet',
    addedEP: '22',
    added: 'FIX.4.4',
    name: 'RootPartyRole',
    id: 1119,
    abbrName: 'R',
    description:
      'PartyRole value within a root parties component. Same values as PartyRole (452)',
  },
  {
    type: 'NumInGroup',
    addedEP: '22',
    added: 'FIX.4.4',
    name: 'NoRootPartySubIDs',
    id: 1120,
    abbrName: 'NoRootPartySubIDs',
    description: 'Number of RootPartySubID (1121) and RootPartySubIDType (1122) entries',
  },
  {
    type: 'String',
    addedEP: '22',
    added: 'FIX.4.4',
    name: 'RootPartySubID',
    id: 1121,
    abbrName: 'ID',
    description:
      'PartySubID value within a root parties component. Same values as PartySubID (523)',
  },
  {
    type: 'PartySubIDTypeCodeSet',
    addedEP: '22',
    added: 'FIX.4.4',
    name: 'RootPartySubIDType',
    id: 1122,
    abbrName: 'Typ',
    description:
      'Type of RootPartySubID (1121) value. Same values as PartySubIDType (803)',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'TradeHandlingInstrCodeSet',
    addedEP: '23',
    updatedEP: '136',
    added: 'FIX.4.4',
    name: 'TradeHandlingInstr',
    id: 1123,
    abbrName: 'TrdHandlInst',
    description:
      'Specified how the TradeCaptureReport(35=AE) should be handled by the respondent.',
  },
  {
    type: 'TradeHandlingInstrCodeSet',
    addedEP: '23',
    added: 'FIX.4.4',
    name: 'OrigTradeHandlingInstr',
    id: 1124,
    abbrName: 'OrigTrdHandlInst',
    description:
      'Optionally used with TradeHandlingInstr = 0 to relay the trade handling instruction used when reporting the trade to the marketplace. Same values as TradeHandlingInstr (1123)',
  },
  {
    type: 'LocalMktDate',
    addedEP: '23',
    added: 'FIX.4.4',
    name: 'OrigTradeDate',
    id: 1125,
    abbrName: 'OrigTrdDt',
    description:
      'Used to preserve original trade date when original trade is being referenced in a subsequent trade transaction such as a transfer',
  },
  {
    type: 'String',
    addedEP: '23',
    added: 'FIX.4.4',
    name: 'OrigTradeID',
    id: 1126,
    abbrName: 'OrigTrdID',
    description:
      'Used to preserve original trade id when original trade is being referenced in a subsequent trade transaction such as a transfer',
  },
  {
    type: 'String',
    addedEP: '23',
    added: 'FIX.4.4',
    name: 'OrigSecondaryTradeID',
    id: 1127,
    abbrName: 'OrignTrdID2',
    description:
      'Used to preserve original secondary trade id when original trade is being referenced in a subsequent trade transaction such as a transfer',
  },
  {
    updated: 'FIX.Latest',
    type: 'ApplVerIDCodeSet',
    addedEP: '16',
    updatedEP: '270',
    added: 'FIX.4.4',
    name: 'ApplVerID',
    id: 1128,
    abbrName: 'ApplVerID',
    description:
      'Specifies the application layer version being applied at the message level.',
  },
  {
    type: 'String',
    addedEP: '16',
    added: 'FIX.4.4',
    name: 'CstmApplVerID',
    id: 1129,
    abbrName: 'CstmApplVerID',
    description:
      'Specifies a custom extension to a message being applied at the message level. Enumerated field',
  },
  {
    type: 'ApplVerIDCodeSet',
    addedEP: '16',
    added: 'FIX.4.4',
    name: 'RefApplVerID',
    id: 1130,
    abbrName: 'RefApplVerID',
    description:
      'Specifies the service pack release being applied to a message at the session level. Enumerated field with values assigned at time of service pack release. Uses same values as ApplVerID',
  },
  {
    type: 'String',
    addedEP: '16',
    added: 'FIX.4.4',
    name: 'RefCstmApplVerID',
    id: 1131,
    abbrName: 'RefCstmApplVerID',
    description:
      'Specifies a custom extension to a message being applied at the session level.',
  },
  {
    type: 'TZTimestamp',
    addedEP: '26',
    added: 'FIX.4.4',
    name: 'TZTransactTime',
    id: 1132,
    abbrName: 'TZTransactTime',
    description:
      'Transact time in the local date-time stamp with a TZ offset to UTC identified',
  },
  {
    type: 'ExDestinationIDSourceCodeSet',
    addedEP: '26',
    added: 'FIX.4.4',
    name: 'ExDestinationIDSource',
    id: 1133,
    abbrName: 'ExDestIDSrc',
    description: 'The ID source of ExDestination',
  },
  {
    type: 'Boolean',
    addedEP: '26',
    added: 'FIX.4.4',
    name: 'ReportedPxDiff',
    id: 1134,
    abbrName: 'ReportedPxDiff',
    description:
      'Indicates that the reported price that is different from the market price. The price difference should be stated by using field 828 TrdType and, if required, field 829 TrdSubType',
  },
  {
    type: 'String',
    addedEP: '26',
    added: 'FIX.4.4',
    name: 'RptSys',
    id: 1135,
    abbrName: 'RptSys',
    description: 'Indicates the system or medium on which the report has been published',
  },
  {
    type: 'String',
    addedEP: '25',
    added: 'FIX.4.4',
    name: 'AllocClearingFeeIndicator',
    id: 1136,
    abbrName: 'ClrFeeInd',
    description:
      'ClearingFeeIndicator(635) for Allocation, see ClearingFeeIndicator(635) for permitted values.',
  },
  {
    type: 'ApplVerIDCodeSet',
    addedEP: '16',
    added: 'FIX.4.4',
    name: 'DefaultApplVerID',
    id: 1137,
    abbrName: 'DefApplVerID',
    description:
      'Specifies the service pack release being applied, by default, to message at the session level. Enumerated field with values assigned at time of service pack release. Uses same values as ApplVerID',
  },
  {
    type: 'Qty',
    addedEP: '22',
    added: 'FIX.4.4',
    name: 'DisplayQty',
    id: 1138,
    abbrName: 'DisplayQty',
    description:
      'The quantity to be displayed . Required for reserve orders. On orders specifies the qty to be displayed, on execution reports the currently displayed quantity.',
  },
  {
    updated: 'FIX.5.0SP1',
    type: 'String',
    addedEP: '29',
    updatedEP: '95',
    added: 'FIX.4.4',
    name: 'ExchangeSpecialInstructions',
    id: 1139,
    abbrName: 'ExchSpeclInstr',
    description: 'Free format text string related to exchange.',
  },
  {
    type: 'TZTimeOnly',
    addedEP: '41',
    added: 'FIX.5.0',
    name: 'UnderlyingMaturityTime',
    id: 1213,
    abbrName: 'MatTm',
    description:
      "Time of security's maturity expressed in local time with offset to UTC specified",
  },
  {
    type: 'TZTimeOnly',
    addedEP: '41',
    added: 'FIX.5.0',
    name: 'LegMaturityTime',
    id: 1212,
    abbrName: 'MatTm',
    description:
      "Time of security's maturity expressed in local time with offset to UTC specified",
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'Qty',
    addedEP: '42',
    updatedEP: '130',
    added: 'FIX.5.0',
    name: 'MaxTradeVol',
    id: 1140,
    abbrName: 'MaxTrdVol',
    description:
      'The maximum order quantity (as expressed by TradeVolType(1786)) that can be submitted for a security.',
  },
  {
    type: 'NumInGroup',
    addedEP: '42',
    added: 'FIX.5.0',
    name: 'NoMDFeedTypes',
    id: 1141,
    abbrName: 'NoMDFeedTypes',
    description:
      'The number of feed types and corresponding book depths associated with a security',
  },
  {
    type: 'String',
    addedEP: '42',
    added: 'FIX.5.0',
    name: 'MatchAlgorithm',
    id: 1142,
    abbrName: 'MtchAlgo',
    description:
      'The types of algorithm used to match orders in a specific security. Possilbe value types are FIFO, Allocation, Pro-rata, Lead Market Maker, Currency Calender.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'float',
    addedEP: '42',
    updatedEP: '195',
    added: 'FIX.5.0',
    name: 'MaxPriceVariation',
    id: 1143,
    abbrName: 'MxPxVar',
    description:
      'The maximum price variation of an execution from one event to the next for a given security. Expressed in absolute price terms.',
  },
  {
    type: 'ImpliedMarketIndicatorCodeSet',
    addedEP: '42',
    added: 'FIX.5.0',
    name: 'ImpliedMarketIndicator',
    id: 1144,
    abbrName: 'ImpldMktInd',
    description:
      'Indicates that an implied market should be created for either the legs of a multi-leg instrument (Implied-in) or for the multi-leg instrument based on the existence of the legs (Implied-out). Determination as to whether implied markets should be created is generally done at the level of the multi-leg instrument. Commonly used in listed derivatives.',
  },
  {
    type: 'UTCTimestamp',
    addedEP: '42',
    added: 'FIX.5.0',
    name: 'EventTime',
    id: 1145,
    abbrName: 'Tm',
    description: 'Specific time of event. To be used in combination with EventDate [866]',
  },
  {
    updated: 'FIX.Latest',
    type: 'Amt',
    addedEP: '42',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'MinPriceIncrementAmount',
    id: 1146,
    abbrName: 'MinPxIncrAmt',
    description:
      'Minimum price increment amount associated with MinPriceIncrement(969). For listed derivatives, the value can be calculated by multiplying MinPriceIncrement(969) with ContractMultiplier(231).',
  },
  {
    type: 'Qty',
    addedEP: '42',
    added: 'FIX.5.0',
    name: 'UnitOfMeasureQty',
    id: 1147,
    abbrName: 'UOMQty',
    description:
      'Used to indicate the quantity of the underlying commodity unit of measure on which the contract is based, such as, 2500 lbs of lean cattle, 1000 barrels of crude oil, 1000 bushels of corn, etc. UnitOfMeasureQty is required for UnitOfMeasure(996) Variable Quantity UOMs enumerations. Refer to the definition of UnitOfMeasure(996) for more information on the use of UnitOfMeasureQty.',
  },
  {
    type: 'Price',
    addedEP: '42',
    added: 'FIX.5.0',
    name: 'LowLimitPrice',
    id: 1148,
    abbrName: 'LowLmtPx',
    description:
      'Allowable low limit price for the trading day. A key parameter in validating order price. Used as the lower band for validating order prices. Orders submitted with prices below the lower limit will be rejected',
  },
  {
    updated: 'FIX.5.0SP1',
    type: 'Price',
    addedEP: '42',
    updatedEP: '76',
    added: 'FIX.5.0',
    name: 'HighLimitPrice',
    id: 1149,
    abbrName: 'HiLmtPx',
    description:
      'Allowable high limit price for the trading day. A key parameter in validating order price. Used as the upper band for validating order prices. Orders submitted with prices above the upper limit will be rejected',
  },
  {
    type: 'Price',
    addedEP: '42',
    added: 'FIX.5.0',
    name: 'TradingReferencePrice',
    id: 1150,
    abbrName: 'TrdgRefPx',
    description:
      'Reference price for the current trading price range usually representing the mid price between the HighLimitPrice and LowLimitPrice. The value may be the settlement price or closing price of the prior trading day.',
  },
  {
    type: 'String',
    addedEP: '42',
    added: 'FIX.5.0',
    name: 'SecurityGroup',
    id: 1151,
    abbrName: 'SecGrp',
    description:
      'An exchange specific name assigned to a group of related securities which may be concurrently affected by market events and actions.',
  },
  {
    type: 'int',
    addedEP: '44',
    added: 'FIX.5.0',
    name: 'LegNumber',
    id: 1152,
    abbrName: 'LegNo',
    description: 'Allow sequencing of Legs for a Strategy to be captured',
  },
  {
    type: 'int',
    addedEP: '44',
    added: 'FIX.5.0',
    name: 'SettlementCycleNo',
    id: 1153,
    abbrName: 'CycleNo',
    description: 'Settlement cycle in which the settlement obligation was generated',
  },
  {
    type: 'Currency',
    addedEP: '44',
    added: 'FIX.5.0',
    name: 'SideCurrency',
    id: 1154,
    abbrName: 'Ccy',
    description: 'Used to identify the trading currency on the Trade Capture Report Side',
  },
  {
    type: 'Currency',
    addedEP: '44',
    added: 'FIX.5.0',
    name: 'SideSettlCurrency',
    id: 1155,
    abbrName: 'SettlCcy',
    description:
      'Used to identify the settlement currency on the Trade Capture Report Side',
  },
  {
    type: 'Amt',
    addedEP: '44',
    added: 'FIX.5.0',
    name: 'CcyAmt',
    id: 1157,
    abbrName: 'CcyAmt',
    description: 'Net flow of Currency 1',
  },
  {
    type: 'NumInGroup',
    addedEP: '44',
    added: 'FIX.5.0',
    name: 'NoSettlDetails',
    id: 1158,
    abbrName: 'NoSettlDetails',
    description: 'Used to group Each Settlement Party',
  },
  {
    type: 'SettlObligModeCodeSet',
    addedEP: '44',
    added: 'FIX.5.0',
    name: 'SettlObligMode',
    id: 1159,
    abbrName: 'SettlMode',
    description:
      'Used to identify the reporting mode of the settlement obligation which is either preliminary or final',
  },
  {
    type: 'String',
    addedEP: '44',
    added: 'FIX.5.0',
    name: 'SettlObligMsgID',
    id: 1160,
    abbrName: 'SettlMsgID',
    description: 'Message identifier for Settlement Obligation Report',
  },
  {
    type: 'String',
    addedEP: '44',
    added: 'FIX.5.0',
    name: 'SettlObligID',
    id: 1161,
    abbrName: 'SettlID',
    description: 'Unique ID for this settlement instruction.',
  },
  {
    type: 'SettlObligTransTypeCodeSet',
    addedEP: '44',
    added: 'FIX.5.0',
    name: 'SettlObligTransType',
    id: 1162,
    abbrName: 'SettlTransTyp',
    description:
      'Transaction Type - required except where SettlInstMode is 5=Reject SSI request',
  },
  {
    type: 'String',
    addedEP: '44',
    added: 'FIX.5.0',
    name: 'SettlObligRefID',
    id: 1163,
    abbrName: 'SettlRefID',
    description: 'Required where SettlInstTransType is Cancel or Replace',
  },
  {
    type: 'SettlObligSourceCodeSet',
    addedEP: '44',
    added: 'FIX.5.0',
    name: 'SettlObligSource',
    id: 1164,
    abbrName: 'SettlSrc',
    description:
      'Used to identify whether these delivery instructions are for the buyside or the sellside.',
  },
  {
    type: 'NumInGroup',
    addedEP: '44',
    added: 'FIX.5.0',
    name: 'NoSettlOblig',
    id: 1165,
    abbrName: 'NoSettlOblig',
    description: 'Number of settlement obligations',
  },
  {
    type: 'String',
    addedEP: '45',
    added: 'FIX.5.0',
    name: 'QuoteMsgID',
    id: 1166,
    abbrName: 'QtMsgID',
    description: 'Unique identifier for a quote message.',
  },
  {
    updated: 'FIX.5.0SP1',
    type: 'QuoteEntryStatusCodeSet',
    addedEP: '45',
    updatedEP: '95',
    added: 'FIX.5.0',
    name: 'QuoteEntryStatus',
    id: 1167,
    abbrName: 'QtEntSts',
    description:
      'Identifies the status of an individual quote. See also QuoteStatus(297) which is used for single Quotes.',
  },
  {
    type: 'int',
    addedEP: '45',
    added: 'FIX.5.0',
    name: 'TotNoCxldQuotes',
    id: 1168,
    abbrName: 'TotNoCxldQts',
    description: 'Specifies the number of canceled quotes',
  },
  {
    type: 'int',
    addedEP: '45',
    added: 'FIX.5.0',
    name: 'TotNoAccQuotes',
    id: 1169,
    abbrName: 'TotNoAccQts',
    description: 'Specifies the number of accepted quotes',
  },
  {
    type: 'int',
    addedEP: '45',
    added: 'FIX.5.0',
    name: 'TotNoRejQuotes',
    id: 1170,
    abbrName: 'TotNoRejQts',
    description: 'Specifies the number of rejected quotes',
  },
  {
    type: 'PrivateQuoteCodeSet',
    addedEP: '46',
    added: 'FIX.5.0',
    name: 'PrivateQuote',
    id: 1171,
    abbrName: 'PrvtQt',
    description:
      'Specifies whether a quote is public, i.e. available to the market, or private, i.e. available to a specified counterparty only.',
  },
  {
    type: 'RespondentTypeCodeSet',
    addedEP: '46',
    added: 'FIX.5.0',
    name: 'RespondentType',
    id: 1172,
    abbrName: 'RspdntTyp',
    description: 'Specifies the type of respondents requested.',
  },
  {
    type: 'int',
    addedEP: '47',
    added: 'FIX.5.0',
    name: 'MDSubBookType',
    id: 1173,
    abbrName: 'MDSubBkTyp',
    description:
      'Describes a class of sub book, e.g. for the separation of various lot types. The Sub Book Type indicates that the following Market Data Entries belong to a non-integrated Sub Book. Whenever provided the Sub Book must be used together with MDPriceLevel and MDEntryPositionNo in order to sort the order properly.\n\nValues are bilaterally agreed.',
  },
  {
    type: 'SecurityTradingEventCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '47',
    added: 'FIX.5.0',
    name: 'SecurityTradingEvent',
    id: 1174,
    abbrName: 'SecTrdEvnt',
    description:
      'Identifies an event related to a SecurityTradingStatus(326). An event occurs and is gone, it is not a state that applies for a period of time.',
  },
  {
    type: 'NumInGroup',
    addedEP: '47',
    added: 'FIX.5.0',
    name: 'NoStatsIndicators',
    id: 1175,
    abbrName: 'NoStatsInds',
    description: 'Number of statistics indicator repeating group entries',
  },
  {
    type: 'StatsTypeCodeSet',
    addedEP: '47',
    added: 'FIX.5.0',
    name: 'StatsType',
    id: 1176,
    abbrName: 'StatsTyp',
    description: 'Type of statistics',
  },
  {
    type: 'NumInGroup',
    addedEP: '47',
    added: 'FIX.5.0',
    name: 'NoOfSecSizes',
    id: 1177,
    abbrName: 'NoSecSzs',
    description: 'The number of secondary sizes specifies in this entry',
  },
  {
    type: 'MDSecSizeTypeCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '47',
    added: 'FIX.5.0',
    name: 'MDSecSizeType',
    id: 1178,
    abbrName: 'MDSecSizeType',
    description: 'Specifies the type of secondary size.',
  },
  {
    type: 'Qty',
    addedEP: '47',
    added: 'FIX.5.0',
    name: 'MDSecSize',
    id: 1179,
    abbrName: 'MDSecSize',
    description:
      'A part of the MDEntrySize(271) that represents secondary interest as specified by MDSecSizeType(1178).',
  },
  {
    type: 'String',
    addedEP: '48',
    added: 'FIX.5.0',
    name: 'ApplID',
    id: 1180,
    abbrName: 'ApplID',
    description:
      'Identifies the application with which a message is associated. Used only if application sequencing is in effect.',
  },
  {
    type: 'SeqNum',
    addedEP: '48',
    added: 'FIX.5.0',
    name: 'ApplSeqNum',
    id: 1181,
    abbrName: 'ApplSeqNum',
    description: 'Data sequence number to be used when FIX session is not in effect',
  },
  {
    type: 'SeqNum',
    addedEP: '48',
    added: 'FIX.5.0',
    name: 'ApplBegSeqNum',
    id: 1182,
    abbrName: 'ApplBegSeqNum',
    description: 'Beginning range of application sequence numbers',
  },
  {
    type: 'SeqNum',
    addedEP: '48',
    added: 'FIX.5.0',
    name: 'ApplEndSeqNum',
    id: 1183,
    abbrName: 'ApplEndSeq',
    description: 'Ending range of application sequence numbers',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'Length',
    addedEP: '49',
    updatedEP: '145',
    added: 'FIX.5.0',
    name: 'SecurityXMLLen',
    id: 1184,
    abbrName: 'SecXMLLen',
    description: 'The length of the SecurityXML(1185) data block.',
  },
  {
    updated: 'FIX.Latest',
    type: 'XMLData',
    addedEP: '49',
    updatedEP: '275',
    added: 'FIX.5.0',
    name: 'SecurityXML',
    id: 1185,
    abbrName: 'SecXML',
    lengthId: '1184',
    description: 'XML definition for the security.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    addedEP: '49',
    updatedEP: '145',
    added: 'FIX.5.0',
    name: 'SecurityXMLSchema',
    id: 1186,
    abbrName: 'Schema',
    description: 'The schema used to validate the contents of SecurityXML(1185).',
  },
  {
    type: 'Boolean',
    addedEP: '50',
    added: 'FIX.5.0',
    name: 'RefreshIndicator',
    id: 1187,
    abbrName: 'RefInd',
    description:
      "Set by the sender to tell the receiver to perform an immediate refresh of the book due to disruptions in the accompanying real-time feed\n\n'Y' - Mandatory refresh by all participants\n\n'N' - Process as required",
  },
  {
    type: 'float',
    addedEP: '51',
    added: 'FIX.5.0',
    name: 'Volatility',
    id: 1188,
    abbrName: 'Vol',
    description: 'Annualized volatility for option model calculations',
  },
  {
    type: 'float',
    addedEP: '51',
    added: 'FIX.5.0',
    name: 'TimeToExpiration',
    id: 1189,
    abbrName: 'TmToExp',
    description:
      'Time to expiration in years calculated as the number of days remaining to expiration divided by 365 days per year.',
  },
  {
    type: 'float',
    addedEP: '51',
    added: 'FIX.5.0',
    name: 'RiskFreeRate',
    id: 1190,
    abbrName: 'RFR',
    description: 'Interest rate. Usually some form of short term rate.',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'PriceUnitOfMeasure',
    id: 1191,
    abbrName: 'PxUOM',
    description:
      'Used to express the UOM of the price if different from the contract. In futures, this can be different for cross-rate products in which the price is quoted in units differently from the contract',
  },
  {
    type: 'Qty',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'PriceUnitOfMeasureQty',
    id: 1192,
    abbrName: 'PxUOMQty',
    description:
      'Used to express the UOM Quantity of the price if different from the contract. In futures, this can be different for physically delivered products in which price is quoted in a unit size different from the contract, i.e. a Cattle Future contract has a UOMQty of 40,000 and a PriceUOMQty of 100.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'SettlMethodCodeSet',
    addedEP: '52',
    updatedEP: '169',
    added: 'FIX.5.0',
    name: 'SettlMethod',
    id: 1193,
    abbrName: 'SettlMeth',
    description:
      'Settlement method for a contract or instrument. Additional values may be used with bilateral agreement.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'ExerciseStyleCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '52',
    updatedEP: '161',
    added: 'FIX.5.0',
    name: 'ExerciseStyle',
    id: 1194,
    abbrName: 'ExerStyle',
    description: 'Type of exercise of a derivatives security',
  },
  {
    type: 'ExerciseStyleCodeSet',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'UnderlyingExerciseStyle',
    id: 1419,
    abbrName: 'ExerStyle',
    description: 'Type of exercise of a derivatives security',
  },
  {
    type: 'ExerciseStyleCodeSet',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'LegExerciseStyle',
    id: 1420,
    abbrName: 'ExerStyle',
    description: 'Type of exercise of a derivatives security',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'Amt',
    addedEP: '52',
    updatedEP: '169',
    added: 'FIX.5.0',
    name: 'OptPayoutAmount',
    id: 1195,
    abbrName: 'OptPayAmt',
    description:
      'Cash amount indicating the pay out associated with an option. For binary options this is a fixed amount.',
  },
  {
    type: 'PriceQuoteMethodCodeSet',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'PriceQuoteMethod',
    id: 1196,
    abbrName: 'PxQteMeth',
    description: 'Method for price quotation',
  },
  {
    updated: 'FIX.5.0SP1',
    type: 'ValuationMethodCodeSet',
    addedEP: '52',
    updatedEP: '83',
    added: 'FIX.5.0',
    name: 'ValuationMethod',
    id: 1197,
    abbrName: 'ValMeth',
    description: 'Specifies the type of valuation method applied.',
  },
  {
    type: 'ListMethodCodeSet',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'ListMethod',
    id: 1198,
    abbrName: 'ListMeth',
    description:
      'Indicates whether instruments are pre-listed only or can also be defined via user request',
  },
  {
    type: 'Price',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'CapPrice',
    id: 1199,
    abbrName: 'CapPx',
    description: 'Used to express the ceiling price of a capped call',
  },
  {
    type: 'Price',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'FloorPrice',
    id: 1200,
    abbrName: 'FlrPx',
    description: 'Used to express the floor price of a capped put',
  },
  {
    type: 'NumInGroup',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'NoStrikeRules',
    id: 1201,
    description:
      'Number of strike rule entries. This block specifies the rules for determining how new strikes should be listed within the stated price range of the underlying instrument',
  },
  {
    type: 'Price',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'StartStrikePxRange',
    id: 1202,
    abbrName: 'StartStrkPxRng',
    description:
      'Starting price for the range to which the StrikeIncrement applies. Price refers to the price of the underlying',
  },
  {
    type: 'Price',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'EndStrikePxRange',
    id: 1203,
    abbrName: 'EndStrkPxRng',
    description:
      'Ending price of the range to which the StrikeIncrement applies. Price refers to the price of the underlying',
  },
  {
    type: 'float',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'StrikeIncrement',
    id: 1204,
    abbrName: 'StrkIncr',
    description:
      'Value by which strike price should be incremented within the specified price range.',
  },
  {
    type: 'NumInGroup',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'NoTickRules',
    id: 1205,
    description:
      'Number of tick rules. This block specifies the rules for determining how a security ticks, i.e. the price increments at which it can be quoted and traded, depending on the current price of the security',
  },
  {
    type: 'Price',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'StartTickPriceRange',
    id: 1206,
    abbrName: 'StartTickPxRng',
    description: 'Starting price range for specified tick increment',
  },
  {
    type: 'Price',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'EndTickPriceRange',
    id: 1207,
    abbrName: 'EndTickPxRng',
    description: 'Ending price range for the specified tick increment',
  },
  {
    type: 'Price',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'TickIncrement',
    id: 1208,
    abbrName: 'TickIncr',
    description:
      'Tick increment for stated price range. Specifies the valid price increments at which a security can be quoted and traded',
  },
  {
    type: 'TickRuleTypeCodeSet',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'TickRuleType',
    id: 1209,
    abbrName: 'TickRuleTyp',
    description: 'Specifies the type of tick rule which is being described',
  },
  {
    type: 'InstrAttribTypeCodeSet',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'NestedInstrAttribType',
    id: 1210,
    abbrName: 'Typ',
    description: 'Code to represent the type of instrument attribute',
  },
  {
    type: 'String',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'NestedInstrAttribValue',
    id: 1211,
    abbrName: 'Val',
    description: 'Attribute value appropriate to the NestedInstrAttribType field',
  },
  {
    updated: 'FIX.Latest',
    type: 'String',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeSymbol',
    id: 1214,
    abbrName: 'Sym',
    description:
      'Ticker symbol. Common, human understood representation of the security.\n\nSee Symbol(55) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'SymbolSfxCodeSet',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeSymbolSfx',
    id: 1215,
    abbrName: 'Sfx',
    description:
      'Additional information about the security (e.g. preferred, warrants, etc.).\n\nSee SymbolSfx(65) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'String',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeSecurityID',
    id: 1216,
    abbrName: 'ID',
    discriminatorId: '1217',
    description:
      'Security identifier value (e.g. CUSIP, SEDOL, ISIN, etc).\n\nRequires DerivativeSecurityIDSource(1217).\n\nSee SecurityID(48) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'SecurityIDSourceCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeSecurityIDSource',
    id: 1217,
    abbrName: 'Src',
    description:
      'Identifies class or source of the DerivativeSecurityID(1217) value.\n\nSee SecurityIDSource(22) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'NumInGroup',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'NoDerivativeSecurityAltID',
    id: 1218,
    abbrName: 'NoDerivativeSecurityAltID',
    description: 'Number of alternate derivative security IDs.',
  },
  {
    updated: 'FIX.Latest',
    type: 'String',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeSecurityAltID',
    id: 1219,
    abbrName: 'ID',
    discriminatorId: '1220',
    description:
      'Alternate derivative security identifier value of DerivativeSecurityAltIDSource(1220) type.\n\nRequires DerivativeSecurityAltIDSource(1220).',
  },
  {
    updated: 'FIX.Latest',
    type: 'SecurityIDSourceCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeSecurityAltIDSource',
    id: 1220,
    abbrName: 'Src',
    description: 'Identifies class or source of the DerivativeSecurityAltID(1219) value.',
  },
  {
    type: 'Price',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'SecondaryLowLimitPrice',
    id: 1221,
    abbrName: 'LowLmtPx',
    description: 'Refer to definition of LowLimitPrice(1148)',
  },
  {
    type: 'Price',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'SecondaryHighLimitPrice',
    id: 1230,
    abbrName: 'HiLmtPx',
    description: 'Refer to definition of HighLimitPrice(1149)',
  },
  {
    type: 'String',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'MaturityRuleID',
    id: 1222,
    abbrName: 'MatRuleID',
    description:
      'Allows maturity rule to be referenced via an identifier so that rules do not need to be explicitly enumerated',
  },
  {
    type: 'String',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'StrikeRuleID',
    id: 1223,
    abbrName: 'StrkRule',
    description:
      'Allows strike rule to be referenced via an identifier so that rules do not need to be explicitly enumerated',
  },
  {
    updated: 'FIX.Latest',
    type: 'Amt',
    addedEP: '52',
    updatedEP: '282',
    added: 'FIX.5.0',
    name: 'DerivativeOptPayoutAmount',
    id: 1225,
    abbrName: 'OptPayAmt',
    description:
      'Cash amount indicating the pay out associated with an option. For binary options this is a fixed amount.\n\nSee OptPayoutAmount(1195) for complete definition.',
  },
  {
    type: 'MonthYear',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'EndMaturityMonthYear',
    id: 1226,
    abbrName: 'EndMMY',
    description: 'Ending maturity month year for an option class',
  },
  {
    type: 'String',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'ProductComplex',
    id: 1227,
    abbrName: 'ProdCmplx',
    description:
      'Identifies an entire suite of products for a given market. In Futures this may be "interest rates", "agricultural", "equity indexes", etc.',
  },
  {
    updated: 'FIX.Latest',
    type: 'String',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeProductComplex',
    id: 1228,
    abbrName: 'ProdCmplx',
    description:
      'Identifies an entire suite of products for a given market.\n\nSee ProductComplex(1227) for complete definition.',
  },
  {
    type: 'int',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'MaturityMonthYearIncrement',
    id: 1229,
    abbrName: 'MMYIncr',
    description: 'Increment between successive maturities for an option class',
  },
  {
    type: 'Qty',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'MinLotSize',
    id: 1231,
    abbrName: 'MinLotSz',
    description: 'Minimum lot size allowed based on lot type specified in LotType(1093)',
  },
  {
    type: 'NumInGroup',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'NoExecInstRules',
    id: 1232,
    abbrName: 'NoExecInstRules',
    description: 'Number of execution instructions',
  },
  {
    type: 'NumInGroup',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'NoLotTypeRules',
    id: 1234,
    abbrName: 'NoLotTypeRules',
    description: 'Number of Lot Type Rules',
  },
  {
    type: 'NumInGroup',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'NoMatchRules',
    id: 1235,
    abbrName: 'NoMatchRules',
    description: 'Number of Match Rules',
  },
  {
    type: 'NumInGroup',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'NoMaturityRules',
    id: 1236,
    abbrName: 'NoMaturityRules',
    description: 'Number of maturity rules in MarurityRules component block',
  },
  {
    type: 'NumInGroup',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'NoOrdTypeRules',
    id: 1237,
    abbrName: 'NoOrdTypeRules',
    description: 'Number of order types',
  },
  {
    type: 'NumInGroup',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'NoTimeInForceRules',
    id: 1239,
    abbrName: 'NoTimeInForceRules',
    description: 'Number of time in force techniques',
  },
  {
    type: 'Price',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'SecondaryTradingReferencePrice',
    id: 1240,
    abbrName: 'TrdgRefPx',
    description: 'Refer to definition for TradingReferencePrice(1150)',
  },
  {
    type: 'MonthYear',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'StartMaturityMonthYear',
    id: 1241,
    abbrName: 'StartMMY',
    description: 'Starting maturity month year for an option class',
  },
  {
    type: 'Boolean',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'FlexProductEligibilityIndicator',
    id: 1242,
    abbrName: 'FlexProdElig',
    description:
      'Used to indicate if a product or group of product supports the creation of flexible securities',
  },
  {
    updated: 'FIX.Latest',
    type: 'Boolean',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivFlexProductEligibilityIndicator',
    id: 1243,
    abbrName: 'FlexProdElig',
    description:
      'Used to indicate if a product or group of product supports the creation of flexible securities.\n\nSee FlexProductEligibilityIndicator(1242) for complete definition.',
  },
  {
    type: 'Boolean',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'FlexibleIndicator',
    id: 1244,
    abbrName: 'FlexInd',
    description:
      'Used to indicate a derivatives security that can be defined using flexible terms. The terms commonly permitted to be defined by market participants are expiration date and strike price. FlexibleIndicator is an alternative CFICode(461) Standard/Non-standard attribute.',
  },
  {
    type: 'Currency',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'TradingCurrency',
    id: 1245,
    abbrName: 'TrdCcy',
    description: 'Used when the trading currency can differ from the price currency',
  },
  {
    updated: 'FIX.Latest',
    type: 'ProductCodeSet',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeProduct',
    id: 1246,
    abbrName: 'Prod',
    description:
      'The type of product the security is associated with.\n\nSee Product(460) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'String',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeSecurityGroup',
    id: 1247,
    abbrName: 'SecGrp',
    description:
      'An exchange specific name assigned to a group of related securities which may be concurrently affected by market events and actions.\n\nSee SecurityGroup(1151) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'String',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeCFICode',
    id: 1248,
    abbrName: 'CFI',
    description:
      'The type of security using ISO 10962 standard, Classification of Financial Instruments (CFI code) values.\n\nSee CFICode(461) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'SecurityTypeCodeSet',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeSecurityType',
    id: 1249,
    abbrName: 'SecTyp',
    description:
      'The type of security.\n\nSee SecurityType(167) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'String',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeSecuritySubType',
    id: 1250,
    abbrName: 'SecSubTyp',
    description:
      'Sub-type qualification/identification of the security type.\n\nSee SecuritySubType(762) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'MonthYear',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeMaturityMonthYear',
    id: 1251,
    abbrName: 'MMY',
    description:
      'Month and Year of the maturity (used for standardized futures and options).\n\nSee MaturityMonthYear(200) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'LocalMktDate',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeMaturityDate',
    id: 1252,
    abbrName: 'MatDt',
    description: 'Date of maturity.\n\nSee MaturityDate(541) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'TZTimeOnly',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeMaturityTime',
    id: 1253,
    abbrName: 'MatTm',
    description:
      "Time of security's maturity expressed in local time with offset to UTC specified.\n\nSee MaturityTime(1079) for complete definition.",
  },
  {
    updated: 'FIX.Latest',
    type: 'String',
    addedEP: '52',
    updatedEP: '282',
    added: 'FIX.5.0',
    name: 'DerivativeSettleOnOpenFlag',
    id: 1254,
    abbrName: 'SettlOnOpenFlag',
    description:
      'Indicator to determine if instrument is settle on open.\n\nSee SettleOnOpenFlag(966) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'InstrmtAssignmentMethodCodeSet',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeInstrmtAssignmentMethod',
    id: 1255,
    abbrName: 'AsgnMeth',
    description:
      'Method under which assignment was conducted.\n\nSee InstrmtAssignmentMethod(1049) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'SecurityStatusCodeSet',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeSecurityStatus',
    id: 1256,
    abbrName: 'Status',
    description:
      'Indicates the current state of the derivative instrument.\n\nSee SecurityStatus(965) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'String',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeInstrRegistry',
    id: 1257,
    abbrName: 'Rgstry',
    description:
      'Values may include BIC for the depository or custodian who maintain ownership records, the ISO country code for the location of the record, or the value ZZ to specify physical ownership of the security (e.g. stock certificate).\n\nSee InstrRegistry(543) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Country',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeCountryOfIssue',
    id: 1258,
    abbrName: 'Ctry',
    description:
      'ISO Country code of instrument issue (e.g. the country portion typically used in ISIN).\n\nSee CountryOfIssue(470) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'String',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeStateOrProvinceOfIssue',
    id: 1259,
    abbrName: 'StPrv',
    description:
      'A two-character state or province abbreviation.\n\nSee StateOrProvinceOfIssue(471) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'String',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeLocaleOfIssue',
    id: 1260,
    abbrName: 'Lcl',
    description:
      'Identifies the locale or region of issue.\n\nSee LocaleOfIssue(472) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Price',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeStrikePrice',
    id: 1261,
    abbrName: 'StrkPx',
    description:
      'Strike price for an option.\n\nSee StrikePrice(202) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Currency',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeStrikeCurrency',
    id: 1262,
    abbrName: 'StrkCcy',
    description:
      'Currency in which the strike price is denominated.\n\nSee StrikeCurrency(947) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'float',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeStrikeMultiplier',
    id: 1263,
    abbrName: 'StrkMult',
    description:
      'Multiplier applied to the strike price for the purpose of calculating the settlement value.\n\nSee StrikeMultiplier(967) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'float',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeStrikeValue',
    id: 1264,
    abbrName: 'StrkValu',
    description:
      'The number of shares/units for the financial instrument involved in the option trade.\n\nSee StrikeValue(968) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'char',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeOptAttribute',
    id: 1265,
    abbrName: 'OptAt',
    description:
      'Provided to support versioning of option contracts as a result of corporate actions or events. Use of this field is defined by counterparty agreement or market conventions.\n\nSee OptAttribute(206) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'float',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeContractMultiplier',
    id: 1266,
    abbrName: 'Mult',
    description:
      'Specifies the ratio or multiply factor to convert from nominal units (e.g. contracts) to total units (e.g. shares) (e.g. 1.0, 100, 1000, etc.).\n\nSee ContractMultiplier(231) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'float',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeMinPriceIncrement',
    id: 1267,
    abbrName: 'MinPxIncr',
    description:
      'Minimum price increase for a given exchange-traded Instrument.\n\nSee MinPriceIncrement(969) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Amt',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeMinPriceIncrementAmount',
    id: 1268,
    abbrName: 'MinPxIncrAmt',
    description:
      'Minimum price increment amount associated with the minimum price increment.\n\nSee MinPriceIncrementAmount(1146) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'UnitOfMeasureCodeSet',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeUnitOfMeasure',
    id: 1269,
    abbrName: 'UOM',
    description:
      'The unit of measure of the underlying commodity upon which the contract is based.\n\nSee UnitOfMeasure(996) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Qty',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeUnitOfMeasureQty',
    id: 1270,
    abbrName: 'UOMQty',
    description:
      'Used to indicate the quantity of the underlying commodity unit of measure on which the contract is based.\n\nSee UnitOfMeasureQty(1147) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'TimeUnitCodeSet',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeTimeUnit',
    id: 1271,
    abbrName: 'TmUnit',
    description:
      'Unit of time associated with the contract.\n\nNOTE: Additional values may be used by mutual agreement of the counterparties.\n\nSee TimeUnit(997) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Exchange',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeSecurityExchange',
    id: 1272,
    abbrName: 'Exch',
    description:
      'Market used to help identify a security.\n\nSee SecurityExchange(207) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'int',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativePositionLimit',
    id: 1273,
    abbrName: 'PosLmt',
    description:
      'Position limit for a given exchange-traded product.\n\nSee PositionLimit(970) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'int',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeNTPositionLimit',
    id: 1274,
    abbrName: 'NTPosLmt',
    description:
      'Position limit in the near-term contract for a given exchange-traded product.\n\nSee NTPositionLimit(971) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'String',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeIssuer',
    id: 1275,
    abbrName: 'Issr',
    description: 'Name of security issuer.\n\nSee Issuer(106) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'LocalMktDate',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeIssueDate',
    id: 1276,
    abbrName: 'IssDt',
    description:
      'The date on which the security is issued.\n\nSee IssueDate(225) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Length',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeEncodedIssuerLen',
    id: 1277,
    abbrName: 'EncIssrLen',
    description:
      'Byte length of encoded (non-ASCII characters) DerivativeEncodedSecurityDesc (1281) field.\n\nSee EncodedIssuerLen(348) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'data',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeEncodedIssuer',
    id: 1278,
    abbrName: 'EncIssr',
    lengthId: '1277',
    description:
      'Encoded (non-ASCII characters) representation of the DerivativeIssuer(1275) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the DerivativeIssuer(1275) field.\n\nSee EncodedIssuer(349) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'String',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeSecurityDesc',
    id: 1279,
    abbrName: 'Desc',
    description:
      'Can be used by the venue or one of the trading parties to provide a non-normative textual description for the financial instrument.\n\nSee SecurityDesc(107) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Length',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeEncodedSecurityDescLen',
    id: 1280,
    abbrName: 'EncSecDescLen',
    description:
      'Byte length of encoded (non-ASCII characters) DerivativeEncodedSecurityDesc (1281) field.\n\nSee EncodedSecurityDescLen(350) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'data',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeEncodedSecurityDesc',
    id: 1281,
    abbrName: 'EncSecDesc',
    lengthId: '1280',
    description:
      'Encoded (non-ASCII characters) representation of the DerivativeSecurityDesc(1279) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the DerivativeSecurityDesc(1279) field.\n\nSee EncodedSecurityDesc(351) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Length',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeSecurityXMLLen',
    id: 1282,
    abbrName: 'SecXMLLen',
    description:
      'The length of the DerivativeSecurityXML(1283) data block.\n\nSee SecurityXMLLen(1184) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'XMLData',
    addedEP: '52',
    updatedEP: '275',
    added: 'FIX.5.0',
    name: 'DerivativeSecurityXML',
    id: 1283,
    abbrName: 'SecXML',
    lengthId: '1282',
    description:
      'XML definition for the security.\n\nSee SecurityXML(1185) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'String',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeSecurityXMLSchema',
    id: 1284,
    abbrName: 'Schema',
    description:
      'The schema used to validate the contents of DerivativeSecurityXML(1283).\n\nSee SecurityXMLSchema(1186) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'MonthYear',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeContractSettlMonth',
    id: 1285,
    abbrName: 'CSetMo',
    description:
      'Specifies when the contract (i.e. MBS/TBA) will settle.\n\nSee ContractSettlMonth(667) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'NumInGroup',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'NoDerivativeEvents',
    id: 1286,
    abbrName: 'NoDerivativeEvents',
    description: 'Number of repeating DerivativeEventType entries.',
  },
  {
    updated: 'FIX.Latest',
    type: 'EventTypeCodeSet',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeEventType',
    id: 1287,
    abbrName: 'EventTyp',
    description:
      'Code to represent the type of event.\n\nSee EventType(865) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'LocalMktDate',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeEventDate',
    id: 1288,
    abbrName: 'Dt',
    description: 'Date of event.\n\nSee EventDate(866) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'UTCTimestamp',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeEventTime',
    id: 1289,
    abbrName: 'Tm',
    description:
      'Specific time of event. To be used in combination with DerivativeEventDate(1288).\n\nSee EventTime(1145) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Price',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeEventPx',
    id: 1290,
    abbrName: 'Px',
    description:
      'Predetermined price of issue at event.\n\nSee EventPx(867) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'String',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeEventText',
    id: 1291,
    abbrName: 'Txt',
    description:
      'Comments related to the event.\n\nSee EventText(868) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'NumInGroup',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'NoDerivativeInstrumentParties',
    id: 1292,
    description: 'Number of repeating derivative instrument party entries.',
  },
  {
    updated: 'FIX.Latest',
    type: 'String',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeInstrumentPartyID',
    id: 1293,
    abbrName: 'ID',
    discriminatorId: '1294',
    description: 'Party identifier/code.\n\nSee PartyID(448) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'PartyIDSourceCodeSet',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeInstrumentPartyIDSource',
    id: 1294,
    abbrName: 'Src',
    description:
      'Identifies class or source of the DerivativeInstrumentPartyID (1293) value.\n\nRequired if DerivativeInstrumentPartyID(1293) is specified.\n\nSee PartyIDSource(447) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'PartyRoleCodeSet',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeInstrumentPartyRole',
    id: 1295,
    abbrName: 'R',
    description:
      'Identifies the type or role of the DerivativeInstrumentPartyID (1293) specified.\n\nSee PartyRole(452) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'NumInGroup',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'NoDerivativeInstrumentPartySubIDs',
    id: 1296,
    description: 'Number of derivative instrument party sub IDs.',
  },
  {
    updated: 'FIX.Latest',
    type: 'String',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeInstrumentPartySubID',
    id: 1297,
    abbrName: 'ID',
    description: 'Party sub-identifier.\n\nSee PartySubID(523) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'PartySubIDTypeCodeSet',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeInstrumentPartySubIDType',
    id: 1298,
    abbrName: 'Typ',
    description:
      'Type of party sub-identifier.\n\nSee PartySubIDType(803) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'ExerciseStyleCodeSet',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeExerciseStyle',
    id: 1299,
    abbrName: 'ExerStyle',
    description: 'Type of exercise.\n\nSee ExerciseStyle(1194) for complete definition.',
  },
  {
    type: 'String',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'MarketSegmentID',
    id: 1300,
    abbrName: 'MktSegID',
    description: 'Identifies the market segment',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'Exchange',
    addedEP: '52',
    updatedEP: '190',
    added: 'FIX.5.0',
    name: 'MarketID',
    id: 1301,
    abbrName: 'MktID',
    description: 'Identifies the market',
  },
  {
    type: 'MaturityMonthYearIncrementUnitsCodeSet',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'MaturityMonthYearIncrementUnits',
    id: 1302,
    abbrName: 'MMYIncrUnits',
    description: 'Unit of measure for the Maturity Month Year Increment',
  },
  {
    type: 'MaturityMonthYearFormatCodeSet',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'MaturityMonthYearFormat',
    id: 1303,
    abbrName: 'MMYFmt',
    description: 'Format used to generate the MaturityMonthYear for each option',
  },
  {
    type: 'ExerciseStyleCodeSet',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'StrikeExerciseStyle',
    id: 1304,
    abbrName: 'StrkExrStyle',
    description: 'Expiration Style for an option class:',
  },
  {
    type: 'PriceLimitTypeCodeSet',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'SecondaryPriceLimitType',
    id: 1305,
    abbrName: 'PxLmtTyp',
    description: 'Describes the how the price limits are expressed',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PriceLimitTypeCodeSet',
    addedEP: '52',
    updatedEP: '204',
    added: 'FIX.5.0',
    name: 'PriceLimitType',
    id: 1306,
    abbrName: 'PxLmtTyp',
    description: 'Describes the how the price limits are expressed.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'ExecInstCodeSet',
    addedEP: '52',
    updatedEP: '208',
    added: 'FIX.5.0',
    name: 'ExecInstValue',
    id: 1308,
    abbrName: 'ExecInstValu',
    description:
      'Indicates execution instructions that are valid for the specified market segment',
  },
  {
    type: 'NumInGroup',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'NoTradingSessionRules',
    id: 1309,
    description: 'Allows trading rules to be expressed by trading session',
  },
  {
    type: 'NumInGroup',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'NoMarketSegments',
    id: 1310,
    description: 'Number of Market Segments on which a security may trade.',
  },
  {
    updated: 'FIX.Latest',
    type: 'NumInGroup',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'NoDerivativeInstrAttrib',
    id: 1311,
    description: 'Number of instrument attributes.',
  },
  {
    type: 'NumInGroup',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'NoNestedInstrAttrib',
    id: 1312,
    description: '',
  },
  {
    updated: 'FIX.Latest',
    type: 'InstrAttribTypeCodeSet',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeInstrAttribType',
    id: 1313,
    abbrName: 'Typ',
    description:
      'Type of instrument attribute.\n\nSee InstrAttribType(871) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'String',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeInstrAttribValue',
    id: 1314,
    abbrName: 'Val',
    description:
      'Attribute value appropriate to the DerivativeInstrAttribValue(1313) field.\n\nSee InstrAttribValue(872) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'UnitOfMeasureCodeSet',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativePriceUnitOfMeasure',
    id: 1315,
    abbrName: 'PxUOM',
    description:
      'Used to express the UOM of the price if different from the contract.\n\nSee PriceUnitOfMeasureQty(1191) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Qty',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativePriceUnitOfMeasureQty',
    id: 1316,
    abbrName: 'PxUOMQty',
    description:
      'Used to express the UOM Quantity of the price if different from the contract.\n\nSee PriceUnitOfMeasureQty(1192) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'SettlMethodCodeSet',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeSettlMethod',
    id: 1317,
    abbrName: 'SettlMeth',
    description:
      'Settlement method for a contract or instrument.\n\nSee SettlMethod(1193) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'PriceQuoteMethodCodeSet',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativePriceQuoteMethod',
    id: 1318,
    abbrName: 'PxQteMeth',
    description:
      'Specifies the method for price quotation.\n\nSee PriceQuoteMethod(1196) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'ValuationMethodCodeSet',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeValuationMethod',
    id: 1319,
    abbrName: 'ValMeth',
    description:
      'Specifies the method for price quotation.\n\nSee ValuationMethod(1197) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'ListMethodCodeSet',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeListMethod',
    id: 1320,
    abbrName: 'ListMeth',
    description:
      'Indicates whether instruments are pre-listed only or can also be defined via user request.\n\nSee ListMethod(1198) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Price',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeCapPrice',
    id: 1321,
    abbrName: 'CapPx',
    description:
      'Used to express the ceiling price of a capped call.\n\nSee CapPrice(1199) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Price',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativeFloorPrice',
    id: 1322,
    abbrName: 'FlrPx',
    description:
      'Used to express the floor price of a capped put.\n\nSee FloorPrice(1200) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'PutOrCallCodeSet',
    addedEP: '52',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'DerivativePutOrCall',
    id: 1323,
    abbrName: 'PutCall',
    description:
      'Indicates whether an option contract is a put, call, chooser or undetermined.\n\nSee PutOrCall(201) for complete definition.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'ListUpdateActionCodeSet',
    addedEP: '52',
    updatedEP: '128',
    added: 'FIX.5.0',
    name: 'ListUpdateAction',
    id: 1324,
    abbrName: 'ListUpdActn',
    description: 'If provided, then Instrument occurrence has explicitly changed',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PutOrCallCodeSet',
    addedEP: '52',
    updatedEP: '238',
    added: 'FIX.5.0',
    name: 'LegPutOrCall',
    id: 1358,
    abbrName: 'PutCall',
    description:
      'Indicates whether a leg option contract is a put, call, chooser or undetermined.',
  },
  {
    type: 'Qty',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'LegUnitOfMeasureQty',
    id: 1224,
    abbrName: 'UOMQty',
    description: 'Refer to definition of UnitOfMeasureQty(1147)',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'LegPriceUnitOfMeasure',
    id: 1421,
    abbrName: 'PxUOM',
    description: 'Refer to definition for PriceUnitOfMeasure(1191)',
  },
  {
    type: 'Qty',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'LegPriceUnitOfMeasureQty',
    id: 1422,
    abbrName: 'PxUOMQty',
    description: 'Refer to definition of PriceUnitOfMeasureQty(1192)',
  },
  {
    type: 'Qty',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'UnderlyingUnitOfMeasureQty',
    id: 1423,
    abbrName: 'UOMQty',
    description: 'Refer to definition of UnitOfMeasureQty(1147)',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'UnderlyingPriceUnitOfMeasure',
    id: 1424,
    abbrName: 'PxUOM',
    description: 'Refer to definition for PriceUnitOfMeasure(1191)',
  },
  {
    type: 'Qty',
    addedEP: '52',
    added: 'FIX.5.0',
    name: 'UnderlyingPriceUnitOfMeasureQty',
    id: 1425,
    abbrName: 'PxUOMQty',
    description: 'Refer to definition of PriceUnitOfMeasureQty(1192)',
  },
  {
    type: 'String',
    addedEP: '53',
    added: 'FIX.5.0',
    name: 'MarketReqID',
    id: 1393,
    abbrName: 'MktReqID',
    description: 'Unique ID of a Market Definition Request message.',
  },
  {
    type: 'String',
    addedEP: '53',
    added: 'FIX.5.0',
    name: 'MarketReportID',
    id: 1394,
    abbrName: 'MktRptID',
    description: 'Market Definition message identifier.',
  },
  {
    type: 'SecurityUpdateActionCodeSet',
    addedEP: '53',
    added: 'FIX.5.0',
    name: 'MarketUpdateAction',
    id: 1395,
    abbrName: 'MktUpdtActn',
    description:
      'Specifies the action taken for the specified MarketID(1301) + MarketSegmentID(1300).',
  },
  {
    type: 'String',
    addedEP: '53',
    added: 'FIX.5.0',
    name: 'MarketSegmentDesc',
    id: 1396,
    abbrName: 'MarketSegmentDesc',
    description: 'Description or name of Market Segment',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'Length',
    addedEP: '53',
    updatedEP: '229',
    added: 'FIX.5.0',
    name: 'EncodedMktSegmDescLen',
    id: 1397,
    abbrName: 'EncodedMktSegmDescLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedMktSegmDesc(1324) field.',
  },
  {
    type: 'data',
    addedEP: '53',
    added: 'FIX.5.0',
    name: 'EncodedMktSegmDesc',
    id: 1398,
    abbrName: 'EncodedMktSegmDesc',
    lengthId: '1397',
    description:
      'Encoded (non-ASCII characters) representation of the MarketSegmDesc(1396) field in the encoded format specified via the MessageEncoding(347) field. If used, the ASCII (English) representation should also be specified in the MarketSegmDesc field.',
  },
  {
    type: 'String',
    addedEP: '53',
    added: 'FIX.5.0',
    name: 'ParentMktSegmID',
    id: 1325,
    abbrName: 'ParentMktSegmID',
    description: 'Reference to a parent Market Segment. See MarketSegmentID(1300)',
  },
  {
    type: 'String',
    addedEP: '53',
    added: 'FIX.5.0',
    name: 'TradingSessionDesc',
    id: 1326,
    abbrName: 'TradingSessionDesc',
    description: 'Trading Session description',
  },
  {
    type: 'SecurityUpdateActionCodeSet',
    addedEP: '53',
    added: 'FIX.5.0',
    name: 'TradSesUpdateAction',
    id: 1327,
    abbrName: 'TradSesUpdtActn',
    description: 'Specifies the action taken for the specified trading sessions.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    addedEP: '55',
    updatedEP: '103',
    added: 'FIX.5.0',
    name: 'RejectText',
    id: 1328,
    abbrName: 'RejTxt',
    description: 'Identifies the reason for rejection.',
  },
  {
    type: 'float',
    addedEP: '55',
    added: 'FIX.5.0',
    name: 'FeeMultiplier',
    id: 1329,
    abbrName: 'FeeMult',
    description:
      'This is a multiplier that Clearing (Fee system) will use to calculate fees and will be sent to the firms on their confirms.',
  },
  {
    deprecatedEP: '187',
    type: 'String',
    deprecated: 'FIX.5.0SP2',
    addedEP: '55',
    added: 'FIX.5.0',
    name: 'UnderlyingLegSymbol',
    id: 1330,
    abbrName: 'Sym',
    description: 'Refer to definition for Symbol(55)',
  },
  {
    deprecatedEP: '187',
    type: 'String',
    deprecated: 'FIX.5.0SP2',
    addedEP: '55',
    added: 'FIX.5.0',
    name: 'UnderlyingLegSymbolSfx',
    id: 1331,
    abbrName: 'Sfx',
    description: 'Refer to definition for SymbolSfx(65)',
  },
  {
    deprecatedEP: '187',
    type: 'String',
    deprecated: 'FIX.5.0SP2',
    addedEP: '55',
    added: 'FIX.5.0',
    name: 'UnderlyingLegSecurityID',
    id: 1332,
    abbrName: 'ID',
    discriminatorId: '1333',
    description: 'Refer to definition for SecurityID(48)',
  },
  {
    deprecatedEP: '187',
    type: 'String',
    deprecated: 'FIX.5.0SP2',
    addedEP: '55',
    added: 'FIX.5.0',
    name: 'UnderlyingLegSecurityIDSource',
    id: 1333,
    abbrName: 'Src',
    description: 'Refer to definition for SecurityIDSource(22)',
  },
  {
    deprecatedEP: '187',
    type: 'NumInGroup',
    deprecated: 'FIX.5.0SP2',
    addedEP: '55',
    added: 'FIX.5.0',
    name: 'NoUnderlyingLegSecurityAltID',
    id: 1334,
    abbrName: 'NoUnderlyingLegSecurityAltID',
    description: 'Refer to definition for NoSecurityAltID(454)',
  },
  {
    deprecatedEP: '187',
    type: 'String',
    deprecated: 'FIX.5.0SP2',
    addedEP: '55',
    added: 'FIX.5.0',
    name: 'UnderlyingLegSecurityAltID',
    id: 1335,
    abbrName: 'AltID',
    discriminatorId: '1336',
    description: 'Refer to definition for SecurityAltID(455)',
  },
  {
    deprecatedEP: '187',
    updated: 'FIX.Latest',
    type: 'String',
    deprecated: 'FIX.5.0SP2',
    unionDataType: 'Reserved100Plus',
    addedEP: '55',
    updatedEP: '271',
    added: 'FIX.5.0',
    name: 'UnderlyingLegSecurityAltIDSource',
    id: 1336,
    abbrName: 'AltIDSrc',
    description: 'Refer to definition for SecurityAltIDSource(456)',
  },
  {
    deprecatedEP: '187',
    type: 'String',
    deprecated: 'FIX.5.0SP2',
    addedEP: '55',
    added: 'FIX.5.0',
    name: 'UnderlyingLegSecurityType',
    id: 1337,
    abbrName: 'SecType',
    description: 'Refer to definition for SecurityType(167)',
  },
  {
    deprecatedEP: '187',
    type: 'String',
    deprecated: 'FIX.5.0SP2',
    addedEP: '55',
    added: 'FIX.5.0',
    name: 'UnderlyingLegSecuritySubType',
    id: 1338,
    abbrName: 'SubType',
    description: 'Refer to definition for SecuritySubType(762)',
  },
  {
    deprecatedEP: '187',
    type: 'MonthYear',
    deprecated: 'FIX.5.0SP2',
    addedEP: '55',
    added: 'FIX.5.0',
    name: 'UnderlyingLegMaturityMonthYear',
    id: 1339,
    abbrName: 'MMY',
    description: 'Refer to definition for MaturityMonthYear(200)',
  },
  {
    deprecatedEP: '187',
    type: 'int',
    deprecated: 'FIX.5.0SP2',
    addedEP: '55',
    added: 'FIX.5.0',
    name: 'UnderlyingLegPutOrCall',
    id: 1343,
    abbrName: 'PutCall',
    description: 'Refer to definition for PutOrCall(201)',
  },
  {
    deprecatedEP: '187',
    type: 'Price',
    deprecated: 'FIX.5.0SP2',
    addedEP: '55',
    added: 'FIX.5.0',
    name: 'UnderlyingLegStrikePrice',
    id: 1340,
    abbrName: 'StrkPx',
    description: 'Refer to definition for StrikePrice(202)',
  },
  {
    deprecatedEP: '187',
    type: 'String',
    deprecated: 'FIX.5.0SP2',
    addedEP: '55',
    added: 'FIX.5.0',
    name: 'UnderlyingLegSecurityExchange',
    id: 1341,
    abbrName: 'Exch',
    description: 'Refer to definition for SecurityExchange(207)',
  },
  {
    deprecatedEP: '187',
    type: 'NumInGroup',
    deprecated: 'FIX.5.0SP2',
    addedEP: '55',
    added: 'FIX.5.0',
    name: 'NoOfLegUnderlyings',
    id: 1342,
    abbrName: 'NoOfLegUnderlyings',
    description: 'Number of Underlyings, Identifies the Underlying of the Leg',
  },
  {
    deprecatedEP: '187',
    type: 'String',
    deprecated: 'FIX.5.0SP2',
    addedEP: '55',
    added: 'FIX.5.0',
    name: 'UnderlyingLegCFICode',
    id: 1344,
    abbrName: 'CFI',
    description: 'Refer to definition for CFICode(461)',
  },
  {
    deprecatedEP: '187',
    type: 'LocalMktDate',
    deprecated: 'FIX.5.0SP2',
    addedEP: '55',
    added: 'FIX.5.0',
    name: 'UnderlyingLegMaturityDate',
    id: 1345,
    abbrName: 'MatDt',
    description: 'Date of maturity.',
  },
  {
    deprecatedEP: '187',
    type: 'TZTimeOnly',
    deprecated: 'FIX.5.0SP2',
    addedEP: '55',
    added: 'FIX.5.0',
    name: 'UnderlyingLegMaturityTime',
    id: 1405,
    abbrName: 'MatTm',
    description:
      "Time of security's maturity expressed in local time with offset to UTC specified",
  },
  {
    deprecatedEP: '187',
    type: 'char',
    deprecated: 'FIX.5.0SP2',
    addedEP: '55',
    added: 'FIX.5.0',
    name: 'UnderlyingLegOptAttribute',
    id: 1391,
    abbrName: 'OptAt',
    description: 'Refer to definition of OptAttribute(206)',
  },
  {
    deprecatedEP: '187',
    type: 'String',
    deprecated: 'FIX.5.0SP2',
    addedEP: '55',
    added: 'FIX.5.0',
    name: 'UnderlyingLegSecurityDesc',
    id: 1392,
    abbrName: 'Desc',
    description: 'Refer to definition of SecurityDesc(107)',
  },
  {
    type: 'int',
    unionDataType: 'Reserved100Plus',
    addedEP: '56',
    added: 'FIX.5.0',
    name: 'EncryptedPasswordMethod',
    id: 1400,
    abbrName: 'EncPwdMethod',
    description:
      'Enumeration defining the encryption method used to encrypt password fields.\n\nAt this time there are no encryption methods defined by FPL.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'Length',
    addedEP: '56',
    updatedEP: '208',
    added: 'FIX.5.0',
    name: 'EncryptedPasswordLen',
    id: 1401,
    abbrName: 'EncPwdLen',
    description: 'Length of the EncryptedPassword(1402) field',
  },
  {
    type: 'data',
    addedEP: '56',
    added: 'FIX.5.0',
    name: 'EncryptedPassword',
    id: 1402,
    abbrName: 'EncPwd',
    lengthId: '1401',
    description:
      'Encrypted password - encrypted via the method specified in the field EncryptedPasswordMethod(1400)',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'Length',
    addedEP: '56',
    updatedEP: '208',
    added: 'FIX.5.0',
    name: 'EncryptedNewPasswordLen',
    id: 1403,
    abbrName: 'EncNewPwdLen',
    description: 'Length of the EncryptedNewPassword(1404) field',
  },
  {
    type: 'data',
    addedEP: '56',
    added: 'FIX.5.0',
    name: 'EncryptedNewPassword',
    id: 1404,
    abbrName: 'EncNewPwd',
    lengthId: '1403',
    description:
      'Encrypted new password - encrypted via the method specified in the field EncryptedPasswordMethod(1400)',
  },
  {
    type: 'int',
    addedEP: '56',
    added: 'FIX.5.0',
    name: 'ApplExtID',
    id: 1156,
    abbrName: 'ApplExtID',
    description: 'The extension pack number associated with an application message.',
  },
  {
    type: 'int',
    addedEP: '56',
    added: 'FIX.5.0',
    name: 'RefApplExtID',
    id: 1406,
    abbrName: 'RefApplExtID',
    description: 'The extension pack number associated with an application message.',
  },
  {
    type: 'int',
    addedEP: '56',
    added: 'FIX.5.0',
    name: 'DefaultApplExtID',
    id: 1407,
    abbrName: 'DfltApplExtID',
    description: 'The extension pack number that is the default for a FIX session.',
  },
  {
    type: 'String',
    addedEP: '56',
    added: 'FIX.5.0',
    name: 'DefaultCstmApplVerID',
    id: 1408,
    abbrName: 'DefaultCstmApplVerID',
    description:
      'The default custom application version ID that is the default for a session.',
  },
  {
    type: 'SessionStatusCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '56',
    added: 'FIX.5.0',
    name: 'SessionStatus',
    id: 1409,
    abbrName: 'SessStat',
    description: 'Status of a FIX session',
  },
  {
    updated: 'FIX.Latest',
    type: 'Boolean',
    addedEP: '56',
    updatedEP: '275',
    added: 'FIX.5.0',
    name: 'DefaultVerIndicator',
    id: 1410,
    abbrName: 'DfltVerInd',
    description:
      'Indicates that the application version identified in the fields RefApplVerID(1130), RefApplExtID(1406), and RefCstmApplVerID(1131) is the default for the message type identified in RefMsgType(372) field.',
  },
  {
    abbrName: 'NoUsers',
    type: 'NumInGroup',
    added: 'FIX.4.4',
    name: 'NoUsernames',
    id: 809,
    description: 'Number of Usernames to which this this response is directed',
  },
  {
    type: 'Currency',
    addedEP: '58',
    added: 'FIX.5.0',
    name: 'LegAllocSettlCurrency',
    id: 1367,
    abbrName: 'AllocSettlCcy',
    description: 'Identifies settlement currency for the leg level allocation.',
  },
  {
    type: 'int',
    addedEP: '58',
    added: 'FIX.5.0',
    name: 'TotNoFills',
    id: 1361,
    abbrName: 'TotNoFills',
    description:
      'Total number of fill entries across all messages. Should be the sum of all NoFills(1362) in each message that has repeating list of fill entries related to the same ExecID(17). Used to support fragmentation.',
  },
  {
    type: 'NumInGroup',
    addedEP: '58',
    added: 'FIX.5.0',
    name: 'NoFills',
    id: 1362,
    abbrName: 'NoFills',
    description: '',
  },
  {
    type: 'String',
    addedEP: '58',
    added: 'FIX.5.0',
    name: 'FillExecID',
    id: 1363,
    abbrName: 'FillExecID',
    description:
      'Refer to ExecID(17). Used when multiple partial fills are reported in single Execution Report. ExecID and FillExecID should not overlap,',
  },
  {
    type: 'Price',
    addedEP: '58',
    added: 'FIX.5.0',
    name: 'FillPx',
    id: 1364,
    abbrName: 'FillPx',
    description: 'Price of Fill. Refer to LastPx(31).',
  },
  {
    type: 'Qty',
    addedEP: '58',
    added: 'FIX.5.0',
    name: 'FillQty',
    id: 1365,
    abbrName: 'FillQty',
    description: 'Quantity of Fill. Refer to LastQty(32).',
  },
  {
    type: 'String',
    addedEP: '58',
    added: 'FIX.5.0',
    name: 'LegAllocID',
    id: 1366,
    abbrName: 'LegAllocID',
    description: 'The AllocID(70) of an individual leg of a multileg order.',
  },
  {
    type: 'TradSesEventCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '58',
    added: 'FIX.5.0',
    name: 'TradSesEvent',
    id: 1368,
    abbrName: 'TradSesEvent',
    description:
      'Identifies an event related to a TradSesStatus(340). An event occurs and is gone, it is not a state that applies for a period of time.',
  },
  {
    type: 'String',
    addedEP: '58',
    added: 'FIX.5.0',
    name: 'MassActionReportID',
    id: 1369,
    abbrName: 'MassActionReportID',
    description:
      'Unique identifier of Order Mass Cancel Report or Order Mass Action Report message as assigned by sell-side (broker, exchange, ECN)',
  },
  {
    type: 'NumInGroup',
    addedEP: '58',
    added: 'FIX.5.0',
    name: 'NoNotAffectedOrders',
    id: 1370,
    abbrName: 'NoNotAffectedOrders',
    description: 'Number of not affected orders in the repeating group of order ids.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    addedEP: '58',
    updatedEP: '131',
    added: 'FIX.5.0',
    name: 'NotAffectedOrderID',
    id: 1371,
    abbrName: 'OrdID',
    description:
      'OrderID(37) of an order not affected by a mass cancel or mass action request.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    addedEP: '58',
    updatedEP: '131',
    added: 'FIX.5.0',
    name: 'NotAffOrigClOrdID',
    id: 1372,
    abbrName: 'OrigClOrdID',
    description:
      'ClOrdID(11) of an order not affected by a mass cancel or mass action request.',
  },
  {
    type: 'MassActionTypeCodeSet',
    addedEP: '58',
    added: 'FIX.5.0',
    name: 'MassActionType',
    id: 1373,
    abbrName: 'MassActionType',
    description: 'Specifies the type of action requested',
  },
  {
    updated: 'FIX.5.0SP1',
    type: 'MassActionScopeCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '58',
    updatedEP: '85',
    added: 'FIX.5.0',
    name: 'MassActionScope',
    id: 1374,
    abbrName: 'MassActionScope',
    description: 'Specifies scope of Order Mass Action Request.',
  },
  {
    type: 'MassActionResponseCodeSet',
    addedEP: '58',
    added: 'FIX.5.0',
    name: 'MassActionResponse',
    id: 1375,
    abbrName: 'MassActionResponse',
    description:
      'Specifies the action taken by counterparty order handling system as a result of the action type indicated in MassActionType of the Order Mass Action Request.',
  },
  {
    type: 'MassActionRejectReasonCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '58',
    added: 'FIX.5.0',
    name: 'MassActionRejectReason',
    id: 1376,
    abbrName: 'MassActionRejectReason',
    description: 'Reason Order Mass Action Request was rejected',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'MultilegModelCodeSet',
    addedEP: '59',
    updatedEP: '195',
    added: 'FIX.5.0',
    name: 'MultilegModel',
    id: 1377,
    abbrName: 'MlegModel',
    description:
      'Specifies the type of multileg order. Defines whether the security is pre-defined or user-defined. Note that MultilegModel(1377)=2(User-defined, Non-Securitized, Multileg) does not apply for Securities.',
  },
  {
    type: 'MultilegPriceMethodCodeSet',
    addedEP: '59',
    added: 'FIX.5.0',
    name: 'MultilegPriceMethod',
    id: 1378,
    abbrName: 'MlegPxMeth',
    description:
      'Code to represent how the multileg price is to be interpreted when applied to the legs.\n\n(See Volume : "Glossary" for further value definitions)',
  },
  {
    type: 'float',
    addedEP: '59',
    added: 'FIX.5.0',
    name: 'LegVolatility',
    id: 1379,
    abbrName: 'LegVolatility',
    description: 'Specifies the volatility of an instrument leg.',
  },
  {
    type: 'Percentage',
    addedEP: '59',
    added: 'FIX.5.0',
    name: 'DividendYield',
    id: 1380,
    abbrName: 'DividendYield',
    description:
      'The continuously-compounded annualized dividend yield of the underlying(s) of an option. Used as a parameter to theoretical option pricing models.',
  },
  {
    type: 'Percentage',
    addedEP: '59',
    added: 'FIX.5.0',
    name: 'LegDividendYield',
    id: 1381,
    abbrName: 'LegDividendYield',
    description: 'Refer to definition for DividendYield(1380).',
  },
  {
    type: 'float',
    addedEP: '59',
    added: 'FIX.5.0',
    name: 'CurrencyRatio',
    id: 1382,
    abbrName: 'CurrencyRatio',
    description:
      'Specifies the currency ratio between the currency used for a multileg price and the currency used by the outright book defined by the leg. Example: Multileg quoted in EUR, outright leg in USD and 1 EUR = 0,7 USD then CurrencyRatio = 0.7',
  },
  {
    type: 'float',
    addedEP: '59',
    added: 'FIX.5.0',
    name: 'LegCurrencyRatio',
    id: 1383,
    abbrName: 'LegCurrencyRatio',
    description:
      'Specifies the currency ratio between the currency used for a multileg price and the currency used by the outright book defined by the leg. Example: Multileg quoted in EUR, outright leg in USD and 1 EUR = 0,7 USD then LegCurrencyRatio = 0.7',
  },
  {
    type: 'ExecInstCodeSet',
    addedEP: '59',
    added: 'FIX.5.0',
    name: 'LegExecInst',
    id: 1384,
    abbrName: 'LegExecInst',
    description: 'Refer to ExecInst(18)\n\nSame values as ExecInst(18)',
  },
  {
    type: 'ContingencyTypeCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '60',
    added: 'FIX.5.0',
    name: 'ContingencyType',
    id: 1385,
    abbrName: 'ContingencyType',
    description: 'Defines the type of contingency.',
  },
  {
    type: 'ListRejectReasonCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '60',
    added: 'FIX.5.0',
    name: 'ListRejectReason',
    id: 1386,
    abbrName: 'ListRejectReason',
    description:
      'Identifies the reason for rejection of a New Order List message. Note that OrdRejReason(103) is used if the rejection is based on properties of an individual order part of the List.',
  },
  {
    type: 'NumInGroup',
    addedEP: '61',
    added: 'FIX.5.0',
    name: 'NoTrdRepIndicators',
    id: 1387,
    abbrName: 'NoTrdRepIndicators',
    description: 'Number of trade reporting indicators',
  },
  {
    type: 'PartyRoleCodeSet',
    addedEP: '61',
    added: 'FIX.5.0',
    name: 'TrdRepPartyRole',
    id: 1388,
    abbrName: 'PtyRole',
    description:
      'Identifies the type of party for trade reporting. Same values as PartyRole(452).',
  },
  {
    type: 'Boolean',
    addedEP: '61',
    added: 'FIX.5.0',
    name: 'TrdRepIndicator',
    id: 1389,
    abbrName: 'TrdRepInd',
    description:
      'Specifies whether the trade should be reported (or not) to parties of the provided TrdRepPartyRole(1388). Used to override standard reporting behavior by the receiver of the trade report and thereby complements the PublTrdIndicator( tag1390).',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'TradePublishIndicatorCodeSet',
    addedEP: '61',
    updatedEP: '229',
    added: 'FIX.5.0',
    name: 'TradePublishIndicator',
    id: 1390,
    abbrName: 'TrdPubInd',
    description:
      'Indicates if a trade should be or has been published via a market publication service. The indicator governs all publication services of the recipient. Replaces PublishTrdIndicator(852).',
  },
  {
    type: 'String',
    addedEP: '63',
    added: 'FIX.5.0',
    name: 'ApplReqID',
    id: 1346,
    abbrName: 'ApplReqID',
    description: 'Unique identifier for request',
  },
  {
    type: 'ApplReqTypeCodeSet',
    addedEP: '63',
    added: 'FIX.5.0',
    name: 'ApplReqType',
    id: 1347,
    abbrName: 'ApplReqTyp',
    description: 'Type of Application Message Request being made.',
  },
  {
    type: 'ApplResponseTypeCodeSet',
    addedEP: '63',
    added: 'FIX.5.0',
    name: 'ApplResponseType',
    id: 1348,
    abbrName: 'ApplRespTyp',
    description: 'Used to indicate the type of acknowledgement being sent.',
  },
  {
    type: 'int',
    addedEP: '63',
    added: 'FIX.5.0',
    name: 'ApplTotalMessageCount',
    id: 1349,
    abbrName: 'ApplTotMsgCnt',
    description: 'Total number of messages included in transmission.',
  },
  {
    type: 'SeqNum',
    addedEP: '63',
    added: 'FIX.5.0',
    name: 'ApplLastSeqNum',
    id: 1350,
    abbrName: 'ApplLastSeqNum',
    description: 'Application sequence number of last message in transmission',
  },
  {
    type: 'NumInGroup',
    addedEP: '63',
    added: 'FIX.5.0',
    name: 'NoApplIDs',
    id: 1351,
    abbrName: 'NoApplIDs',
    description: 'Specifies number of application id occurrences',
  },
  {
    type: 'Boolean',
    addedEP: '63',
    added: 'FIX.5.0',
    name: 'ApplResendFlag',
    id: 1352,
    abbrName: 'ApplResendFlag',
    description:
      "Used to indicate that a message is being sent in response to an Application Message Request. It is possible for both ApplResendFlag and PossDupFlag to be set on the same message if the Sender's cache size is greater than zero and the message is being resent due to a session level resend request",
  },
  {
    type: 'String',
    addedEP: '63',
    added: 'FIX.5.0',
    name: 'ApplResponseID',
    id: 1353,
    abbrName: 'ApplRespID',
    description: 'Identifier for the Applicaton Message Request Ack',
  },
  {
    type: 'ApplResponseErrorCodeSet',
    addedEP: '63',
    added: 'FIX.5.0',
    name: 'ApplResponseError',
    id: 1354,
    abbrName: 'ApplRespErr',
    description:
      'Used to return an error code or text associated with a response to an Application Request.',
  },
  {
    type: 'String',
    addedEP: '63',
    added: 'FIX.5.0',
    name: 'RefApplID',
    id: 1355,
    abbrName: 'RefApplID',
    description:
      'Reference to the unique application identifier which corresponds to ApplID(1180) from the Application Sequence Group component',
  },
  {
    type: 'String',
    addedEP: '63',
    added: 'FIX.5.0',
    name: 'ApplReportID',
    id: 1356,
    abbrName: 'ApplRptID',
    description: 'Identifier for the Application Sequence Reset',
  },
  {
    type: 'SeqNum',
    addedEP: '63',
    added: 'FIX.5.0',
    name: 'RefApplLastSeqNum',
    id: 1357,
    abbrName: 'RefApplLastSeqNum',
    description: 'Application sequence number of last message in transmission.',
  },
  {
    type: 'SeqNum',
    addedEP: '63',
    added: 'FIX.5.0',
    name: 'ApplNewSeqNum',
    id: 1399,
    abbrName: 'ApplNewSeqNum',
    description: 'Used to specify a new application sequence number.',
  },
  {
    abbrName: 'ApplRptTyp',
    type: 'ApplReportTypeCodeSet',
    added: 'FIX.5.0SP2',
    name: 'ApplReportType',
    id: 1426,
    description: 'Type of report',
  },
  {
    type: 'PartySubIDTypeCodeSet',
    addedEP: '69',
    added: 'FIX.5.0',
    name: 'Nested4PartySubIDType',
    id: 1411,
    abbrName: 'Typ',
    description: 'Refer to definition of PartySubIDType(803)',
  },
  {
    type: 'String',
    addedEP: '69',
    added: 'FIX.5.0',
    name: 'Nested4PartySubID',
    id: 1412,
    abbrName: 'ID',
    description: 'Refer to definition of PartySubID(523)',
  },
  {
    updated: 'FIX.Latest',
    type: 'NumInGroup',
    addedEP: '69',
    updatedEP: '275',
    added: 'FIX.5.0',
    name: 'NoNested4PartySubIDs',
    id: 1413,
    abbrName: 'NoNested4PartySubIDs',
    description: 'Refer to definition of NoPartySubIDs(802)',
  },
  {
    updated: 'FIX.Latest',
    type: 'NumInGroup',
    addedEP: '69',
    updatedEP: '275',
    added: 'FIX.5.0',
    name: 'NoNested4PartyIDs',
    id: 1414,
    abbrName: 'NoNested4PartyIDs',
    description: 'Refer to definition of NoPartyIDs(453)',
  },
  {
    type: 'String',
    addedEP: '69',
    added: 'FIX.5.0',
    name: 'Nested4PartyID',
    id: 1415,
    abbrName: 'ID',
    discriminatorId: '1416',
    description: 'Refer to definition of PartyID(448)',
  },
  {
    type: 'PartyIDSourceCodeSet',
    addedEP: '69',
    added: 'FIX.5.0',
    name: 'Nested4PartyIDSource',
    id: 1416,
    abbrName: 'Src',
    description: 'Refer to definition of PartyIDSource(447)',
  },
  {
    type: 'PartyRoleCodeSet',
    addedEP: '69',
    added: 'FIX.5.0',
    name: 'Nested4PartyRole',
    id: 1417,
    abbrName: 'R',
    description: 'Refer to definition of PartyRole(452)',
  },
  {
    type: 'Qty',
    addedEP: '72',
    added: 'FIX.5.0',
    name: 'LegLastQty',
    id: 1418,
    abbrName: 'LastQty',
    description: 'Fill quantity for the leg instrument',
  },
  {
    type: 'String',
    addedEP: '77',
    added: 'FIX.5.0SP1',
    name: 'SideExecID',
    id: 1427,
    abbrName: 'SideExecID',
    description:
      'When reporting trades, used to reference the identifier of the execution (ExecID) being reported if different ExecIDs were assigned to each side of the trade.',
  },
  {
    type: 'int',
    addedEP: '77',
    added: 'FIX.5.0SP1',
    name: 'OrderDelay',
    id: 1428,
    abbrName: 'OrdDelay',
    description:
      'Time lapsed from order entry until match, based on the unit of time specified in OrderDelayUnit. Default is seconds if OrderDelayUnit is not specified. Value = 0, indicates the aggressor (the initiating side of the trade).',
  },
  {
    type: 'OrderDelayUnitCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '77',
    added: 'FIX.5.0SP1',
    name: 'OrderDelayUnit',
    id: 1429,
    abbrName: 'OrdDelayUnit',
    description: 'Time unit in which the OrderDelay(1428) is expressed',
  },
  {
    updated: 'FIX.Latest',
    type: 'VenueTypeCodeSet',
    addedEP: '77',
    updatedEP: '286',
    added: 'FIX.5.0SP1',
    name: 'VenueType',
    id: 1430,
    abbrName: 'VenuTyp',
    description: 'Identifies the type of venue where a trade was executed.',
  },
  {
    type: 'RefOrdIDReasonCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '77',
    added: 'FIX.5.0SP1',
    name: 'RefOrdIDReason',
    id: 1431,
    abbrName: 'RefOrdIDRsn',
    description: 'The reason for updating the RefOrdID',
  },
  {
    type: 'OrigCustOrderCapacityCodeSet',
    addedEP: '77',
    added: 'FIX.5.0SP1',
    name: 'OrigCustOrderCapacity',
    id: 1432,
    abbrName: 'OrigCustOrdCpcty',
    description:
      'The customer capacity for this trade at the time of the order/execution.\n\nPrimarily used by futures exchanges to indicate the CTICode (customer type indicator) as required by the US CFTC (Commodity Futures Trading Commission).',
  },
  {
    type: 'String',
    addedEP: '78',
    added: 'FIX.5.0SP1',
    name: 'RefApplReqID',
    id: 1433,
    abbrName: 'RefID',
    description:
      'Used to reference a previously submitted ApplReqID (1346) from within a subsequent ApplicationMessageRequest(MsgType=BW)',
  },
  {
    type: 'ModelTypeCodeSet',
    addedEP: '79',
    added: 'FIX.5.0SP1',
    name: 'ModelType',
    id: 1434,
    abbrName: 'ModelTyp',
    description: 'Type of pricing model used',
  },
  {
    type: 'ContractMultiplierUnitCodeSet',
    addedEP: '80',
    added: 'FIX.5.0SP1',
    name: 'ContractMultiplierUnit',
    id: 1435,
    abbrName: 'MultTyp',
    description:
      'Indicates the type of multiplier being applied to the contract. Can be optionally used to further define what unit ContractMultiplier(tag 231) is expressed in.',
  },
  {
    updated: 'FIX.Latest',
    type: 'ContractMultiplierUnitCodeSet',
    addedEP: '80',
    updatedEP: '271',
    added: 'FIX.5.0SP1',
    name: 'LegContractMultiplierUnit',
    id: 1436,
    abbrName: 'MultTyp',
    description:
      'Indicates the type of multiplier being applied to the contract. Can be optionally used to further define what unit LegContractMultiplier(614) is expressed in.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'ContractMultiplierUnitCodeSet',
    addedEP: '80',
    updatedEP: '204',
    added: 'FIX.5.0SP1',
    name: 'UnderlyingContractMultiplierUnit',
    id: 1437,
    abbrName: 'MultTyp',
    description:
      'Indicates the type of multiplier being applied to the contract.\n\nCan be optionally used to further define what unit UnderlyingContractMultiplier(436) is expressed in.',
  },
  {
    updated: 'FIX.Latest',
    type: 'ContractMultiplierUnitCodeSet',
    addedEP: '80',
    updatedEP: '271',
    added: 'FIX.5.0SP1',
    name: 'DerivativeContractMultiplierUnit',
    id: 1438,
    abbrName: 'MultTyp',
    description:
      'Indicates the type of multiplier being applied to the contract. Can be optionally used to further define what unit DerivativeContractMultiplier(1266)is expressed in.\n\nSee ContractMultiplierUnit(1435) for complete definition.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'FlowScheduleTypeCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '80',
    updatedEP: '238',
    added: 'FIX.5.0SP1',
    name: 'FlowScheduleType',
    id: 1439,
    abbrName: 'FlowSchedTyp',
    description:
      'The industry standard flow schedule by which electricity or natural gas is traded. Schedules may exist by regions and on-peak and off-peak status, such as "Western Peak".',
  },
  {
    type: 'FlowScheduleTypeCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '80',
    added: 'FIX.5.0SP1',
    name: 'LegFlowScheduleType',
    id: 1440,
    abbrName: 'FlowSchedTyp',
    description:
      'The industry standard flow schedule by which electricity or natural gas is traded. Schedules exist by regions and on-peak and off-peak status, such as "Western Peak".',
  },
  {
    type: 'FlowScheduleTypeCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '80',
    added: 'FIX.5.0SP1',
    name: 'UnderlyingFlowScheduleType',
    id: 1441,
    abbrName: 'FlowSchedTyp',
    description:
      'The industry standard flow schedule by which electricity or natural gas is traded. Schedules exist by regions and on-peak and off-peak status, such as "Western Peak".',
  },
  {
    updated: 'FIX.Latest',
    type: 'FlowScheduleTypeCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '80',
    updatedEP: '271',
    added: 'FIX.5.0SP1',
    name: 'DerivativeFlowScheduleType',
    id: 1442,
    abbrName: 'FlowSchedTyp',
    description:
      'The industry standard flow schedule by which electricity or natural gas is traded. Schedules exist by regions and on-peak and off-peak status, such as "Western Peak".\n\nSee FlowScheduleType(1439) for complete definition.',
  },
  {
    type: 'LastLiquidityIndCodeSet',
    addedEP: '81',
    added: 'FIX.5.0SP1',
    name: 'FillLiquidityInd',
    id: 1443,
    abbrName: 'LqdtyInd',
    description:
      'Indicator to identify whether this fill was a result of a liquidity provider providing or liquidity taker taking the liquidity. Applicable only for OrdStatus of Partial or Filled',
  },
  {
    type: 'LastLiquidityIndCodeSet',
    addedEP: '81',
    added: 'FIX.5.0SP1',
    name: 'SideLiquidityInd',
    id: 1444,
    abbrName: 'LqdtyInd',
    description:
      'Indicator to identify whether this fill was a result of a liquidity provider providing or liquidity taker taking the liquidity. Applicable only for OrdStatus of Partial or Filled.',
  },
  {
    type: 'NumInGroup',
    addedEP: '82',
    added: 'FIX.5.0SP1',
    name: 'NoRateSources',
    id: 1445,
    abbrName: 'NoRtSrc',
    description: 'Number of rate sources being specified.',
  },
  {
    type: 'RateSourceCodeSet',
    addedEP: '82',
    added: 'FIX.5.0SP1',
    name: 'RateSource',
    id: 1446,
    abbrName: 'RtSrc',
    description:
      'Identifies the source of rate information.\n\nFor FX, the reference source to be used for the FX spot rate.',
  },
  {
    type: 'RateSourceTypeCodeSet',
    addedEP: '82',
    added: 'FIX.5.0SP1',
    name: 'RateSourceType',
    id: 1447,
    abbrName: 'RtSrcTyp',
    description:
      'Indicates whether the rate source specified is a primary or secondary source.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    addedEP: '82',
    updatedEP: '161',
    added: 'FIX.5.0SP1',
    name: 'ReferencePage',
    id: 1448,
    abbrName: 'RefPg',
    description:
      'Identifies the reference "page" from the rate source.\n\nFor FX, the reference page to the spot rate to be used for the reference FX spot rate.\n\nWhen RateSource(1446) = 3 (ISDA Settlement Rate Option) this contains the value from the scheme that reflects the terms of the Annex A to the ISDA 1998 FX and Currency Option Definitions. See: http://www.fpml.org/coding-scheme/settlement-rate-option',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'RestructuringTypeCodeSet',
    addedEP: '83',
    updatedEP: '169',
    added: 'FIX.5.0SP1',
    name: 'RestructuringType',
    id: 1449,
    abbrName: 'RestrctTyp',
    description:
      'A category of CDS credit event in which the underlying bond experiences a restructuring.\n\nUsed to define a CDS instrument.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'SeniorityCodeSet',
    addedEP: '83',
    updatedEP: '235',
    added: 'FIX.5.0SP1',
    name: 'Seniority',
    id: 1450,
    abbrName: 'Snrty',
    description:
      'Specifies which issue (underlying bond) will receive payment priority in the event of a default.\n\nUsed to define a CDS instrument.\n\nThe payment priority is this: Senior Secured (SD), Senior (SR), Senior Non-Preferred (SN), Subordinated (SB), Mezzanine (MZ), Junior (JR).',
  },
  {
    type: 'Percentage',
    addedEP: '83',
    added: 'FIX.5.0SP1',
    name: 'NotionalPercentageOutstanding',
    id: 1451,
    abbrName: 'NotlPctOut',
    description:
      'Indicates the notional percentage of the deal that is still outstanding based on the remaining components of the index.\n\nUsed to calculate the true value of a CDS trade or position.',
  },
  {
    type: 'Percentage',
    addedEP: '83',
    added: 'FIX.5.0SP1',
    name: 'OriginalNotionalPercentageOutstanding',
    id: 1452,
    abbrName: 'OrigNotlPctOut',
    description:
      'Used to reflect the Original value prior to the application of a credit event. See NotionalPercentageOutstanding(1451).',
  },
  {
    type: 'RestructuringTypeCodeSet',
    addedEP: '83',
    added: 'FIX.5.0SP1',
    name: 'UnderlyingRestructuringType',
    id: 1453,
    abbrName: 'RestrctTyp',
    description: 'See RestructuringType(1449)',
  },
  {
    type: 'SeniorityCodeSet',
    addedEP: '83',
    added: 'FIX.5.0SP1',
    name: 'UnderlyingSeniority',
    id: 1454,
    abbrName: 'Snrty',
    description: 'See Seniority(1450)',
  },
  {
    type: 'Percentage',
    addedEP: '83',
    added: 'FIX.5.0SP1',
    name: 'UnderlyingNotionalPercentageOutstanding',
    id: 1455,
    abbrName: 'NotlPctOut',
    description: 'See NotionalPercentageOutstanding(1451)',
  },
  {
    type: 'Percentage',
    addedEP: '83',
    added: 'FIX.5.0SP1',
    name: 'UnderlyingOriginalNotionalPercentageOutstanding',
    id: 1456,
    abbrName: 'OrigNotlPctOut',
    description: 'See OriginalNotionalPercentageOutstanding(1452)',
  },
  {
    type: 'Percentage',
    addedEP: '83',
    added: 'FIX.5.0SP1',
    name: 'AttachmentPoint',
    id: 1457,
    abbrName: 'AttchPnt',
    description: 'Lower bound percentage of the loss that the tranche can endure.',
  },
  {
    type: 'Percentage',
    addedEP: '83',
    added: 'FIX.5.0SP1',
    name: 'DetachmentPoint',
    id: 1458,
    abbrName: 'DetchPnt',
    description: 'Upper bound percentage of the loss the tranche can endure.',
  },
  {
    type: 'Percentage',
    addedEP: '83',
    added: 'FIX.5.0SP1',
    name: 'UnderlyingAttachmentPoint',
    id: 1459,
    abbrName: 'AttchPnt',
    description: 'See AttachmentPoint(1457).',
  },
  {
    type: 'Percentage',
    addedEP: '83',
    added: 'FIX.5.0SP1',
    name: 'UnderlyingDetachmentPoint',
    id: 1460,
    abbrName: 'DetchPnt',
    description: 'See DetachmentPoint(1458).',
  },
  {
    type: 'NumInGroup',
    addedEP: '85',
    added: 'FIX.5.0SP1',
    name: 'NoTargetPartyIDs',
    id: 1461,
    description: 'Identifies the number of target parties identified in a mass action.',
  },
  {
    type: 'String',
    addedEP: '85',
    added: 'FIX.5.0SP1',
    name: 'TargetPartyID',
    id: 1462,
    abbrName: 'ID',
    discriminatorId: '1463',
    description: 'PartyID value within an target party repeating group.',
  },
  {
    type: 'PartyIDSourceCodeSet',
    addedEP: '85',
    added: 'FIX.5.0SP1',
    name: 'TargetPartyIDSource',
    id: 1463,
    abbrName: 'Src',
    description:
      'PartyIDSource value within an target party repeating group.\n\nSame values as PartyIDSource (447)',
  },
  {
    type: 'PartyRoleCodeSet',
    addedEP: '85',
    added: 'FIX.5.0SP1',
    name: 'TargetPartyRole',
    id: 1464,
    abbrName: 'R',
    description:
      'PartyRole value within an target party repeating group.\n\nSame values as PartyRole (452)',
  },
  {
    type: 'String',
    addedEP: '87',
    added: 'FIX.5.0SP1',
    name: 'SecurityListID',
    id: 1465,
    abbrName: 'ListID',
    description: 'Specifies an identifier for a Security List',
  },
  {
    type: 'String',
    addedEP: '87',
    added: 'FIX.5.0SP1',
    name: 'SecurityListRefID',
    id: 1466,
    abbrName: 'ListRefID',
    description:
      'Specifies a reference from one Security List to another. Used to support a hierarchy of Security Lists.',
  },
  {
    type: 'String',
    addedEP: '87',
    added: 'FIX.5.0SP1',
    name: 'SecurityListDesc',
    id: 1467,
    abbrName: 'ListDesc',
    description: 'Specifies a description or name of a Security List.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Length',
    addedEP: '87',
    updatedEP: '271',
    added: 'FIX.5.0SP1',
    name: 'EncodedSecurityListDescLen',
    id: 1468,
    abbrName: 'EncListDescLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedSecurityListDesc(1469) field.',
  },
  {
    updated: 'FIX.Latest',
    type: 'data',
    addedEP: '87',
    updatedEP: '271',
    added: 'FIX.5.0SP1',
    name: 'EncodedSecurityListDesc',
    id: 1469,
    abbrName: 'EncListDesc',
    lengthId: '1468',
    description:
      'Encoded (non-ASCII characters) representation of the SecurityListDesc(1467) field in the encoded format specified via the MessageEncoding(347) field. If used, the ASCII (English) representation should also be specified in the SecurityListDesc(1467) field.',
  },
  {
    type: 'SecurityListTypeCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '87',
    added: 'FIX.5.0SP1',
    name: 'SecurityListType',
    id: 1470,
    abbrName: 'ListTyp',
    discriminatorId: '1471',
    description: 'Specifies a type of Security List.',
  },
  {
    type: 'SecurityListTypeSourceCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '87',
    added: 'FIX.5.0SP1',
    name: 'SecurityListTypeSource',
    id: 1471,
    abbrName: 'LstTypSrc',
    description:
      'Specifies a specific source for a SecurityListType. Relevant when a certain type can be provided from various sources.',
  },
  {
    type: 'String',
    addedEP: '90',
    added: 'FIX.5.0SP1',
    name: 'NewsID',
    id: 1472,
    abbrName: 'ID',
    description: 'Unique identifier for a News message',
  },
  {
    updated: 'FIX.Latest',
    type: 'NewsCategoryCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '90',
    updatedEP: '271',
    added: 'FIX.5.0SP1',
    name: 'NewsCategory',
    id: 1473,
    abbrName: 'NewsCatgy',
    description: 'Category of news message.',
  },
  {
    type: 'Language',
    addedEP: '90',
    added: 'FIX.5.0SP1',
    name: 'LanguageCode',
    id: 1474,
    abbrName: 'LangCd',
    description: 'The national language in which the news item is provided.',
  },
  {
    type: 'NumInGroup',
    addedEP: '90',
    added: 'FIX.5.0SP1',
    name: 'NoNewsRefIDs',
    id: 1475,
    description: 'Number of News reference items',
  },
  {
    type: 'String',
    addedEP: '90',
    added: 'FIX.5.0SP1',
    name: 'NewsRefID',
    id: 1476,
    abbrName: 'RefID',
    description: 'Reference to another News message identified by NewsID(1474).',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'NewsRefTypeCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '90',
    updatedEP: '190',
    added: 'FIX.5.0SP1',
    name: 'NewsRefType',
    id: 1477,
    abbrName: 'RefTyp',
    description: 'Type of reference to another News(35=B) message item.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'StrikePriceDeterminationMethodCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '92',
    updatedEP: '169',
    added: 'FIX.5.0SP1',
    name: 'StrikePriceDeterminationMethod',
    id: 1478,
    abbrName: 'StrkPxDtrmnMeth',
    description:
      'Specifies how the strike price is determined at the point of option exercise. The strike may be fixed throughout the life of the option, set at expiration to the value of the underlying, set to the average value of the underlying , or set to the optimal value of the underlying.',
  },
  {
    type: 'StrikePriceBoundaryMethodCodeSet',
    addedEP: '92',
    added: 'FIX.5.0SP1',
    name: 'StrikePriceBoundaryMethod',
    id: 1479,
    abbrName: 'StrkPxBndryMeth',
    description:
      'Specifies the boundary condition to be used for the strike price relative to the underlying price at the point of option exercise.',
  },
  {
    type: 'Percentage',
    addedEP: '92',
    added: 'FIX.5.0SP1',
    name: 'StrikePriceBoundaryPrecision',
    id: 1480,
    abbrName: 'StrkPxBndryPrcsn',
    description:
      'Used in combination with StrikePriceBoundaryMethod to specify the percentage of the strike price in relation to the underlying price. The percentage is generally 100 or greater for puts and 100 or less for calls.',
  },
  {
    type: 'UnderlyingPriceDeterminationMethodCodeSet',
    addedEP: '92',
    added: 'FIX.5.0SP1',
    name: 'UnderlyingPriceDeterminationMethod',
    id: 1481,
    abbrName: 'PxDtrmnMeth',
    description:
      'Specifies how the underlying price is determined at the point of option exercise. The underlying price may be set to the current settlement price, set to a special reference, set to the optimal value of the underlying during the defined period ("Look-back") or set to the average value of the underlying during the defined period ("Asian option").',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'OptPayoutTypeCodeSet',
    addedEP: '92',
    updatedEP: '238',
    added: 'FIX.5.0SP1',
    name: 'OptPayoutType',
    id: 1482,
    abbrName: 'OptPayoutTyp',
    description:
      'Indicates the type of valuation method or payout trigger for an in-the-money option.',
  },
  {
    type: 'NumInGroup',
    addedEP: '92',
    added: 'FIX.5.0SP1',
    name: 'NoComplexEvents',
    id: 1483,
    description: 'Number of complex event occurrences.',
  },
  {
    type: 'ComplexEventTypeCodeSet',
    addedEP: '92',
    added: 'FIX.5.0SP1',
    name: 'ComplexEventType',
    id: 1484,
    abbrName: 'Typ',
    description: 'Identifies the type of complex event.',
  },
  {
    type: 'Amt',
    addedEP: '92',
    added: 'FIX.5.0SP1',
    name: 'ComplexOptPayoutAmount',
    id: 1485,
    abbrName: 'OptPayAmt',
    description:
      'Cash amount indicating the pay out associated with an event. For binary options this is a fixed amount.',
  },
  {
    type: 'Price',
    addedEP: '92',
    added: 'FIX.5.0SP1',
    name: 'ComplexEventPrice',
    id: 1486,
    abbrName: 'Px',
    description:
      'Specifies the price at which the complex event takes effect. Impact of the event price is determined by the ComplexEventType(1484).',
  },
  {
    type: 'ComplexEventPriceBoundaryMethodCodeSet',
    addedEP: '92',
    added: 'FIX.5.0SP1',
    name: 'ComplexEventPriceBoundaryMethod',
    id: 1487,
    abbrName: 'PxBndryMeth',
    description:
      'Specifies the boundary condition to be used for the event price relative to the underlying price at the point the complex event outcome takes effect as determined by the ComplexEventPriceTimeType.',
  },
  {
    type: 'Percentage',
    addedEP: '92',
    added: 'FIX.5.0SP1',
    name: 'ComplexEventPriceBoundaryPrecision',
    id: 1488,
    abbrName: 'PxBndryPrcsn',
    description:
      'Used in combination with ComplexEventPriceBoundaryMethod to specify the percentage of the strike price in relation to the underlying price. The percentage is generally 100 or greater for puts and 100 or less for calls.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'ComplexEventPriceTimeTypeCodeSet',
    addedEP: '92',
    updatedEP: '169',
    added: 'FIX.5.0SP1',
    name: 'ComplexEventPriceTimeType',
    id: 1489,
    abbrName: 'PxTmTyp',
    description:
      'Specifies when the complex event outcome takes effect. The outcome of a complex event is a payout or barrier action as specified by the ComplexEventType(1484).',
  },
  {
    type: 'ComplexEventConditionCodeSet',
    addedEP: '92',
    added: 'FIX.5.0SP1',
    name: 'ComplexEventCondition',
    id: 1490,
    abbrName: 'Cond',
    description:
      'Specifies the condition between complex events when more than one event is specified.\n\nMultiple barrier events would use an "or" condition since only one can be effective at a given time. A set of digital range events would use an "and" condition since both conditions must be in effect for a payout to result.',
  },
  {
    type: 'NumInGroup',
    addedEP: '92',
    added: 'FIX.5.0SP1',
    name: 'NoComplexEventDates',
    id: 1491,
    description: 'Number of complex event date occurrences for a given complex event.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'UTCDateOnly',
    addedEP: '92',
    updatedEP: '195',
    added: 'FIX.5.0SP1',
    name: 'ComplexEventStartDate',
    id: 1492,
    abbrName: 'StartDt',
    description:
      'Specifies the start date of the date range on which a complex event is effective. The start date will be set equal to the end date for single day events such as Bermuda options\n\nComplexEventStartDate must always be less than or equal to ComplexEventEndDate.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'UTCDateOnly',
    addedEP: '92',
    updatedEP: '195',
    added: 'FIX.5.0SP1',
    name: 'ComplexEventEndDate',
    id: 1493,
    abbrName: 'EndDt',
    description:
      'Specifies the end date of the date range on which a complex event is effective. The start date will be set equal to the end date for single day events such as Bermuda options\n\nComplexEventEndDate must always be greater than or equal to ComplexEventStartDate.',
  },
  {
    type: 'NumInGroup',
    addedEP: '92',
    added: 'FIX.5.0SP1',
    name: 'NoComplexEventTimes',
    id: 1494,
    description:
      'Number of complex event time occurrences for a given complex event date\n\nThe default in case of an absence of time fields is 00:00:00-23:59:59.',
  },
  {
    type: 'UTCTimeOnly',
    addedEP: '92',
    added: 'FIX.5.0SP1',
    name: 'ComplexEventStartTime',
    id: 1495,
    abbrName: 'StartTm',
    description:
      'Specifies the start time of the time range on which a complex event date is effective.\n\nComplexEventStartTime must always be less than or equal to ComplexEventEndTime.',
  },
  {
    type: 'UTCTimeOnly',
    addedEP: '92',
    added: 'FIX.5.0SP1',
    name: 'ComplexEventEndTime',
    id: 1496,
    abbrName: 'EndTm',
    description:
      'Specifies the end time of the time range on which a complex event date is effective.\n\nComplexEventEndTime must always be greater than or equal to ComplexEventStartTime.',
  },
  {
    type: 'String',
    addedEP: '93',
    added: 'FIX.5.0SP1',
    name: 'StreamAsgnReqID',
    id: 1497,
    abbrName: 'ReqID',
    description:
      'Unique identifier for the stream assignment request provided by the requester.',
  },
  {
    type: 'StreamAsgnReqTypeCodeSet',
    addedEP: '93',
    added: 'FIX.5.0SP1',
    name: 'StreamAsgnReqType',
    id: 1498,
    abbrName: 'AsgnReqTyp',
    description: 'Type of stream assignment request.',
  },
  {
    type: 'NumInGroup',
    addedEP: '93',
    added: 'FIX.5.0SP1',
    name: 'NoAsgnReqs',
    id: 1499,
    description: 'Number of assignment requests.',
  },
  {
    type: 'String',
    addedEP: '93',
    added: 'FIX.5.0SP1',
    name: 'MDStreamID',
    id: 1500,
    abbrName: 'MDStrmID',
    description: 'The identifier or name of the price stream.',
  },
  {
    type: 'String',
    addedEP: '93',
    added: 'FIX.5.0SP1',
    name: 'StreamAsgnRptID',
    id: 1501,
    abbrName: 'RptID',
    description:
      'Unique identifier of the stream assignment report provided by the respondent.',
  },
  {
    type: 'StreamAsgnRejReasonCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '93',
    added: 'FIX.5.0SP1',
    name: 'StreamAsgnRejReason',
    id: 1502,
    abbrName: 'RejRsn',
    description: 'Reason code for stream assignment request reject.',
  },
  {
    type: 'StreamAsgnAckTypeCodeSet',
    addedEP: '93',
    added: 'FIX.5.0SP1',
    name: 'StreamAsgnAckType',
    id: 1503,
    abbrName: 'ActTyp',
    description: 'Type of acknowledgement.',
  },
  {
    type: 'StreamAsgnTypeCodeSet',
    addedEP: '93',
    added: 'FIX.5.0SP1',
    name: 'StreamAsgnType',
    id: 1617,
    abbrName: 'AsgnTyp',
    description: 'The type of assignment being affected in the Stream Assignment Report.',
  },
  {
    type: 'UTCTimestamp',
    addedEP: '94',
    added: 'FIX.5.0SP1',
    name: 'RelSymTransactTime',
    id: 1504,
    abbrName: 'TxnTm',
    description: 'See TransactTime(60)',
  },
  {
    type: 'String',
    addedEP: '98',
    added: 'FIX.5.0SP2',
    name: 'FillYieldType',
    id: 1622,
    abbrName: 'Typ',
    description: 'Yield Type, using same values as YieldType (235)',
  },
  {
    type: 'Percentage',
    addedEP: '98',
    added: 'FIX.5.0SP2',
    name: 'FillYield',
    id: 1623,
    abbrName: 'Yld',
    description: 'Yield Percentage, using same values as Yield (236)',
  },
  {
    type: 'NumInGroup',
    addedEP: '99',
    added: 'FIX.5.0SP2',
    name: 'NoMatchInst',
    id: 1624,
    description: 'Number of Instructions in the <MatchingInstructions> repeating group.',
  },
  {
    type: 'MatchInstCodeSet',
    addedEP: '99',
    added: 'FIX.5.0SP2',
    name: 'MatchInst',
    id: 1625,
    abbrName: 'Inst',
    description: 'Matching Instruction for the order.',
  },
  {
    type: 'TagNum',
    addedEP: '99',
    added: 'FIX.5.0SP2',
    name: 'MatchAttribTagID',
    id: 1626,
    abbrName: 'ID',
    description:
      'Existing FIX field to be applied as a matching criteria to the instruction, bilaterally agreed between parties.',
  },
  {
    type: 'String',
    addedEP: '99',
    added: 'FIX.5.0SP2',
    name: 'MatchAttribValue',
    id: 1627,
    abbrName: 'Valu',
    description:
      'Value of MatchAttribTagID(1626) on which to apply the matching instruction.',
  },
  {
    type: 'Exchange',
    addedEP: '99',
    added: 'FIX.5.0SP2',
    name: 'MatchInstMarketID',
    id: 1673,
    abbrName: 'MktID',
    description: 'Identifies the market to which the matching instruction applies.',
  },
  {
    type: 'TriggerScopeCodeSet',
    addedEP: '100',
    added: 'FIX.5.0SP2',
    name: 'TriggerScope',
    id: 1628,
    abbrName: 'TrgrScope',
    description:
      'Defines the scope of TriggerAction(1101) when it is set to "cancel" (3).',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '100',
    updatedEP: '159',
    added: 'FIX.5.0SP2',
    name: 'ExposureDuration',
    id: 1629,
    abbrName: 'ExpsreDur',
    description:
      'This is the time in seconds of a "Good for Time" (GFT) TimeInForce.\n\nPositive integer value which represents the time is seconds in which the new order remains active in the market before it is automatically cancelled (e.g. expired).\n\nBi-lateral agreements will dictate the maximum value of this field. It is assumed that most systems will impose a max limit of 86,400 seconds (i.e. 24 hours).\n\nFor Quotes: The period of time a quoted price is tradable(i.e. on-the-wire) before it becomes indicative (i.e. off-the-wire).',
  },
  {
    type: 'NumInGroup',
    addedEP: '100',
    added: 'FIX.5.0SP2',
    name: 'NoLimitAmts',
    id: 1630,
    abbrName: 'NoLmtAmts',
    description: 'The number of limit amount entries.',
  },
  {
    type: 'LimitAmtTypeCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '100',
    added: 'FIX.5.0SP2',
    name: 'LimitAmtType',
    id: 1631,
    abbrName: 'LmtAmtTyp',
    description:
      'Identifies the type of limit amount expressed in LastLimitAmt(1632) and LimitAmtRemaining(1633).',
  },
  {
    type: 'Amt',
    addedEP: '100',
    added: 'FIX.5.0SP2',
    name: 'LastLimitAmt',
    id: 1632,
    abbrName: 'LastLmtAmt',
    description:
      'The amount that has been drawn down against the counterparty for a given trade. The type of limit is specified in LimitAmtType(1631).\n\nBilateral agreements dictate the units and maximum value of this field.',
  },
  {
    type: 'Amt',
    addedEP: '100',
    added: 'FIX.5.0SP2',
    name: 'LimitAmtRemaining',
    id: 1633,
    abbrName: 'LmtAmtRem',
    description:
      'The remaining limit amount available between the counterparties. The type of limit is specified in LimitAmtType(1631).\n\nBilateral agreements dictate the units and maximum value of this field.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Currency',
    addedEP: '100',
    updatedEP: '273',
    added: 'FIX.5.0SP2',
    name: 'LimitAmtCurrency',
    id: 1634,
    abbrName: 'LmtAmtCcy',
    description: 'Indicates the currency that the limit amount is specified in.',
  },
  {
    type: 'String',
    addedEP: '102',
    added: 'FIX.5.0SP2',
    name: 'MarginReqmtInqID',
    id: 1635,
    abbrName: 'ID',
    description: 'Unique identifier of the MarginRequirementInquiry.',
  },
  {
    type: 'NumInGroup',
    addedEP: '102',
    added: 'FIX.5.0SP2',
    name: 'NoMarginReqmtInqQualifier',
    id: 1636,
    description: 'Number of margin requirement inquiry qualifiers.',
  },
  {
    type: 'MarginReqmtInqQualifierCodeSet',
    addedEP: '102',
    added: 'FIX.5.0SP2',
    name: 'MarginReqmtInqQualifier',
    id: 1637,
    abbrName: 'Qual',
    description: 'Qualifier for MarginRequirementInquiry to identify a specific report.',
  },
  {
    type: 'MarginReqmtRptTypeCodeSet',
    addedEP: '102',
    added: 'FIX.5.0SP2',
    name: 'MarginReqmtRptType',
    id: 1638,
    abbrName: 'RptTyp',
    description: 'Type of MarginRequirementReport.',
  },
  {
    type: 'String',
    addedEP: '102',
    added: 'FIX.5.0SP2',
    name: 'MarginClass',
    id: 1639,
    abbrName: 'Clss',
    description: 'Identifier for group of instruments with similar risk profile.',
  },
  {
    type: 'CollInquiryStatusCodeSet',
    addedEP: '102',
    added: 'FIX.5.0SP2',
    name: 'MarginReqmtInqStatus',
    id: 1640,
    abbrName: 'Stat',
    description: 'Status of MarginRequirementInquiry.',
  },
  {
    type: 'MarginReqmtInqResultCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '102',
    added: 'FIX.5.0SP2',
    name: 'MarginReqmtInqResult',
    id: 1641,
    abbrName: 'Rslt',
    description: 'Result returned in response to MarginRequirementInquiry.',
  },
  {
    type: 'String',
    addedEP: '102',
    added: 'FIX.5.0SP2',
    name: 'MarginReqmtRptID',
    id: 1642,
    abbrName: 'RptID',
    description: 'Identifier for the MarginRequirementReport message.',
  },
  {
    type: 'NumInGroup',
    addedEP: '102',
    added: 'FIX.5.0SP2',
    name: 'NoMarginAmt',
    id: 1643,
    description: 'Number of margin requirement amounts.',
  },
  {
    type: 'MarginAmtTypeCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '102',
    added: 'FIX.5.0SP2',
    name: 'MarginAmtType',
    id: 1644,
    abbrName: 'Typ',
    description: 'Type of margin requirement amount being specified.',
  },
  {
    type: 'Amt',
    addedEP: '102',
    added: 'FIX.5.0SP2',
    name: 'MarginAmt',
    id: 1645,
    abbrName: 'Amt',
    description: 'Amount of margin requirement.',
  },
  {
    type: 'Currency',
    addedEP: '102',
    added: 'FIX.5.0SP2',
    name: 'MarginAmtCcy',
    id: 1646,
    abbrName: 'Ccy',
    description: 'Currency of the MarginAmt(1645).',
  },
  {
    type: 'NumInGroup',
    addedEP: '103',
    added: 'FIX.5.0SP2',
    name: 'NoRelatedInstruments',
    id: 1647,
    description: 'Number of related instruments',
  },
  {
    type: 'RelatedInstrumentTypeCodeSet',
    addedEP: '103',
    added: 'FIX.5.0SP2',
    name: 'RelatedInstrumentType',
    id: 1648,
    abbrName: 'InstrmtTyp',
    description: 'The type of instrument relationship',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    addedEP: '103',
    updatedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'RelatedSymbol',
    id: 1649,
    abbrName: 'Sym',
    description:
      'Ticker symbol of the related security. Common "human understood" representation of the security.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    addedEP: '103',
    updatedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'RelatedSecurityID',
    id: 1650,
    abbrName: 'ID',
    discriminatorId: '1651',
    description:
      'Related security identifier value of RelatedSecurityIDSource(1651) type.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'SecurityIDSourceCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '103',
    updatedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'RelatedSecurityIDSource',
    id: 1651,
    abbrName: 'Src',
    description: 'Identifies class or source of the RelatedSecurityID (1650) value.',
  },
  {
    updated: 'FIX.Latest',
    type: 'SecurityTypeCodeSet',
    addedEP: '103',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'RelatedSecurityType',
    id: 1652,
    abbrName: 'SecTyp',
    description: 'Security type of the related instrument.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'MonthYear',
    addedEP: '103',
    updatedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'RelatedMaturityMonthYear',
    id: 1653,
    abbrName: 'MMY',
    description: 'Expiration date for the related instrument contract.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'Qty',
    addedEP: '103',
    updatedEP: '141',
    added: 'FIX.5.0SP2',
    name: 'CoveredQty',
    id: 1654,
    abbrName: 'CvrdQty',
    description:
      'Used to specify the portion of the short contract quantity that is considered covered (e.g. used for short option position).',
  },
  {
    type: 'MarketMakerActivityCodeSet',
    addedEP: '104',
    added: 'FIX.5.0SP2',
    name: 'MarketMakerActivity',
    id: 1655,
    abbrName: 'MktMkrActvty',
    description: 'Indicates market maker participation in security.',
  },
  {
    type: 'String',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'PartyDetailsListRequestID',
    id: 1505,
    abbrName: 'ReqID',
    description: 'Unique identifier for PartyDetailsListRequest.',
  },
  {
    type: 'NumInGroup',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'NoRequestedPartyRoles',
    id: 1508,
    description: 'Number of requested party roles.',
  },
  {
    type: 'PartyRoleCodeSet',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'RequestedPartyRole',
    id: 1509,
    abbrName: 'R',
    description: 'Identifies the type or role of party that has been requested.',
  },
  {
    type: 'String',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'PartyDetailsListReportID',
    id: 1510,
    abbrName: 'RptID',
    description:
      'Identifier for the PartyDetailsListReport and the PartyDetailsListUpdateReport.',
  },
  {
    type: 'RequestResultCodeSet',
    unionDataType: 'Reserved4000Plus',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'RequestResult',
    id: 1511,
    abbrName: 'ReqRslt',
    description: 'Result of a request as identified by the appropriate request ID field',
  },
  {
    type: 'int',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'TotNoParties',
    id: 1512,
    abbrName: 'TotNoPtys',
    description: 'Total number of PartyListGrp returned.',
  },
  {
    type: 'NumInGroup',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'NoPartyRelationships',
    id: 1514,
    description: 'Number of party relationships.',
  },
  {
    type: 'PartyRelationshipCodeSet',
    unionDataType: 'Reserved4000Plus',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'PartyRelationship',
    id: 1515,
    abbrName: 'Rltnshp',
    description: 'Used to specify the type of the party relationship.',
  },
  {
    type: 'NumInGroup',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'NoPartyDetailAltID',
    id: 1516,
    description: 'Number of party alternative identifiers.',
  },
  {
    type: 'String',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'PartyDetailAltID',
    id: 1517,
    abbrName: 'ID',
    discriminatorId: '1518',
    description:
      'An alternate party identifier for the party specified in PartyDetailID(1691)',
  },
  {
    type: 'PartyIDSourceCodeSet',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'PartyDetailAltIDSource',
    id: 1518,
    abbrName: 'Src',
    description: 'Identifies the source of the PartyDetailAltID(1517) value.',
  },
  {
    type: 'NumInGroup',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'NoPartyDetailAltSubIDs',
    id: 1519,
    description: 'Number of party detail alternate sub-identifiers.',
  },
  {
    type: 'String',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'PartyDetailAltSubID',
    id: 1520,
    abbrName: 'ID',
    description: 'Sub-identifier for the party specified in PartyDetailAltID(1517).',
  },
  {
    type: 'PartySubIDTypeCodeSet',
    unionDataType: 'Reserved4000Plus',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'PartyDetailAltSubIDType',
    id: 1521,
    abbrName: 'Typ',
    description: 'Type of PartyDetailAltSubID(1520) value.',
  },
  {
    type: 'NumInGroup',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'NoRiskLimitTypes',
    id: 1529,
    description: 'Number of risk limits with associated warning levels.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'RiskLimitTypeCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '105',
    updatedEP: '204',
    added: 'FIX.5.0SP2',
    name: 'RiskLimitType',
    id: 1530,
    abbrName: 'Typ',
    description:
      'Used to specify the type of risk limit amount or position limit quantity or margin requirement amounts.',
  },
  {
    type: 'Amt',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'RiskLimitAmount',
    id: 1531,
    abbrName: 'Amt',
    description: 'Specifies the risk limit amount.',
  },
  {
    type: 'Currency',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'RiskLimitCurrency',
    id: 1532,
    abbrName: 'Ccy',
    description: 'Used to specify the currency of the risk limit amount.',
  },
  {
    type: 'String',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'RiskLimitPlatform',
    id: 1533,
    abbrName: 'Pltfm',
    description:
      'The area to which risk limit is applicable. This can be a trading platform or an offering.',
  },
  {
    type: 'NumInGroup',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'NoRiskInstrumentScopes',
    id: 1534,
    description: 'Number of risk instrument scopes.',
  },
  {
    type: 'InstrumentScopeOperatorCodeSet',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'InstrumentScopeOperator',
    id: 1535,
    abbrName: 'Oper',
    description: 'Operator to perform on the instrument(s) specified',
  },
  {
    type: 'String',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'InstrumentScopeSymbol',
    id: 1536,
    abbrName: 'Sym',
    description:
      'Used to limit instrument scope to specified symbol.\n\nSee Symbol(55) field for description.',
  },
  {
    updated: 'FIX.Latest',
    type: 'SymbolSfxCodeSet',
    addedEP: '105',
    updatedEP: '282',
    added: 'FIX.5.0SP2',
    name: 'InstrumentScopeSymbolSfx',
    id: 1537,
    abbrName: 'Sfx',
    description:
      'Used to limit instrument scope to specified symbol suffix.\n\nSee SymbolSfx(65) field for description.',
  },
  {
    type: 'String',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'InstrumentScopeSecurityID',
    id: 1538,
    abbrName: 'ID',
    discriminatorId: '1539',
    description:
      'Used to limit instrument scope to specified security identifier.\n\nSee SecurityID(48) field for description.',
  },
  {
    updated: 'FIX.Latest',
    type: 'SecurityIDSourceCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '105',
    updatedEP: '265',
    added: 'FIX.5.0SP2',
    name: 'InstrumentScopeSecurityIDSource',
    id: 1539,
    abbrName: 'Src',
    description:
      'Used to limit instrument scope to specified security identifier source.\n\nSee SecurityIDSource(22) field for description.',
  },
  {
    type: 'NumInGroup',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'NoInstrumentScopeSecurityAltID',
    id: 1540,
    description:
      'Number of alternate security identifier for the specified InstrumentScopeSecurityID(1538).',
  },
  {
    type: 'String',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'InstrumentScopeSecurityAltID',
    id: 1541,
    abbrName: 'AltID',
    discriminatorId: '1542',
    description:
      'Used to limit instrument scope to specified security alternate identifier.\n\nSee SecurityAltID(455) field for description.',
  },
  {
    updated: 'FIX.Latest',
    type: 'SecurityIDSourceCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '105',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'InstrumentScopeSecurityAltIDSource',
    id: 1542,
    abbrName: 'AltIDSrc',
    description:
      'Used to limit instrument scope to specified security alternate identifier source.\n\nSee SecurityAltIDSource(456) field for complete definition.',
  },
  {
    type: 'ProductCodeSet',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'InstrumentScopeProduct',
    id: 1543,
    abbrName: 'Prod',
    description:
      'Used to limit instrument scope to specified instrument product category.\n\nSee Product (460) field for description.',
  },
  {
    type: 'String',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'InstrumentScopeProductComplex',
    id: 1544,
    abbrName: 'ProdCmplx',
    description:
      'Used to limit instrument scope to specified product complex.\n\nSee ProductComplex(1227) field for description.',
  },
  {
    type: 'String',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'InstrumentScopeSecurityGroup',
    id: 1545,
    abbrName: 'SecGrp',
    description:
      'Used to limit instrument scope to specified security group.\n\nSee SecurityGroup(1151) field for description.',
  },
  {
    type: 'String',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'InstrumentScopeCFICode',
    id: 1546,
    abbrName: 'CFI',
    description:
      'Used to limit instrument scope to specified CFICode.\n\nSee CFICode(461) field for description.',
  },
  {
    type: 'SecurityTypeCodeSet',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'InstrumentScopeSecurityType',
    id: 1547,
    abbrName: 'SecTyp',
    description:
      'Used to limit instrument scope to specified security type.\n\nSee SecurityType(167) field for description).',
  },
  {
    type: 'String',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'InstrumentScopeSecuritySubType',
    id: 1548,
    abbrName: 'SecSubTyp',
    description:
      'Used to limit instrument scope to specified security sub-type.\n\nSee SecuritySubType(762) field for description.',
  },
  {
    type: 'MonthYear',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'InstrumentScopeMaturityMonthYear',
    id: 1549,
    abbrName: 'MMY',
    description:
      'Used to limit instrument scope to specified maturity month and year.\n\nSee MaturityMonthYear(200) field for description.',
  },
  {
    type: 'TZTimeOnly',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'InstrumentScopeMaturityTime',
    id: 1550,
    abbrName: 'MatTm',
    description:
      'Used to limit instrument scope to specified maturity time.\n\nSee MaturityTime(1079) field for description.',
  },
  {
    type: 'String',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'InstrumentScopeRestructuringType',
    id: 1551,
    abbrName: 'RstrctTyp',
    description:
      'Used to limit instrument scope to specified restructuring type.\n\nSee RestructuringType(1449) field for description.',
  },
  {
    type: 'String',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'InstrumentScopeSeniority',
    id: 1552,
    abbrName: 'Snrty',
    description:
      'Used to limit instrument scope to specified seniority type.\n\nSee Seniority(1450) field for description.',
  },
  {
    type: 'PutOrCallCodeSet',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'InstrumentScopePutOrCall',
    id: 1553,
    abbrName: 'PutCall',
    description:
      'Used to limit instrument scope to puts or calls.\n\nSee PutOrCall(201) field for description.',
  },
  {
    type: 'Boolean',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'InstrumentScopeFlexibleIndicator',
    id: 1554,
    abbrName: 'FlexInd',
    description:
      'Used to limit instrument scope to securities that can be defined using flexible terms or not.\n\nSee FlexibleIndicator(1244) field for description.',
  },
  {
    type: 'Percentage',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'InstrumentScopeCouponRate',
    id: 1555,
    abbrName: 'CpnRt',
    description:
      'Used to limit instrument scope to specified coupon rate.\n\nSee CouponRate(223) field for description.',
  },
  {
    type: 'String',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'InstrumentScopeSecurityDesc',
    id: 1556,
    abbrName: 'Desc',
    description:
      'Used to limit instrument scope to specified security description.\n\nSee SecurityDesc(107) field for description.',
  },
  {
    type: 'SettlTypeCodeSet',
    unionDataType: 'Tenor',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'InstrumentScopeSettlType',
    id: 1557,
    abbrName: 'SettlTyp',
    description:
      'Used to limit instrument scope to specified settlement type.\n\nSee SettlType(63) field for description.',
  },
  {
    type: 'float',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'RiskInstrumentMultiplier',
    id: 1558,
    abbrName: 'Mult',
    description:
      'Multiplier applied to the transaction amount for comparison with risk limits. Default if not specified is 1.0.',
  },
  {
    type: 'NumInGroup',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'NoRiskWarningLevels',
    id: 1559,
    description: 'Number of risk warning levels.',
  },
];

const batch3: ISpecFields[] = [
  {
    type: 'Percentage',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'RiskWarningLevelPercent',
    id: 1560,
    abbrName: 'Pct',
    description: 'Percent of risk limit at which a warning is issued.',
  },
  {
    type: 'String',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'RiskWarningLevelName',
    id: 1561,
    abbrName: 'Nme',
    description: 'Name or error message associated with the risk warning level.',
  },
  {
    type: 'NumInGroup',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'NoRelatedPartyDetailID',
    id: 1562,
    description: 'Number of related party detail identifiers.',
  },
  {
    type: 'String',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'RelatedPartyDetailID',
    id: 1563,
    abbrName: 'ID',
    discriminatorId: '1564',
    description:
      'Party identifier for the party related to the party specified in PartyDetailID(1691).',
  },
  {
    type: 'PartyIDSourceCodeSet',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'RelatedPartyDetailIDSource',
    id: 1564,
    abbrName: 'Src',
    description: 'Identifies the source of the RelatedPartyDetailID(1563).',
  },
  {
    type: 'PartyRoleCodeSet',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'RelatedPartyDetailRole',
    id: 1565,
    abbrName: 'R',
    description:
      'Identifies the type or role of the RelatedPartyDetailID(1563) specified.',
  },
  {
    type: 'NumInGroup',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'NoRelatedPartyDetailSubIDs',
    id: 1566,
    description: 'Number of related party detail sub-identifiers.',
  },
  {
    type: 'String',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'RelatedPartyDetailSubID',
    id: 1567,
    abbrName: 'ID',
    description: 'Sub-identifier for the party specified in RelatedPartyID(1563).',
  },
  {
    type: 'PartySubIDTypeCodeSet',
    unionDataType: 'Reserved4000Plus',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'RelatedPartyDetailSubIDType',
    id: 1568,
    abbrName: 'Typ',
    description: 'Type of RelatedPartyDetailSubID(1567) value.',
  },
  {
    type: 'NumInGroup',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'NoRelatedPartyDetailAltID',
    id: 1569,
    description: 'Number of related party detail alternate identifiers.',
  },
  {
    type: 'String',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'RelatedPartyDetailAltID',
    id: 1570,
    abbrName: 'ID',
    discriminatorId: '1571',
    description:
      'An alternate party identifier for the party specified in RelatedPartyID(1563).',
  },
  {
    type: 'PartyIDSourceCodeSet',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'RelatedPartyDetailAltIDSource',
    id: 1571,
    abbrName: 'Src',
    description: 'Identifies the source of the RelatedPartyDetailAltID(1570) value.',
  },
  {
    type: 'NumInGroup',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'NoRelatedPartyDetailAltSubIDs',
    id: 1572,
    description: 'Number of related party detail alternate sub-identifiers.',
  },
  {
    type: 'String',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'RelatedPartyDetailAltSubID',
    id: 1573,
    abbrName: 'ID',
    description:
      'Sub-identifier for the party specified in RelatedPartyDetailAltID(1570).',
  },
  {
    type: 'PartySubIDTypeCodeSet',
    unionDataType: 'Reserved4000Plus',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'RelatedPartyDetailAltSubIDType',
    id: 1574,
    abbrName: 'Typ',
    description: 'Type of RelatedPartyDetailAltSubID(1573) value.',
  },
  {
    type: 'Exchange',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'InstrumentScopeSecurityExchange',
    id: 1616,
    abbrName: 'Exch',
    description:
      'Used to limit instrument scope to specified security exchange.\n\nSee SecurityExchange(207) field for description.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Length',
    addedEP: '105',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'InstrumentScopeEncodedSecurityDescLen',
    id: 1620,
    abbrName: 'EncDescLen',
    description:
      'Byte length of encoded (non-ASCII characters) InstrumentScopeEncodedSecurityDesc (1621) field',
  },
  {
    updated: 'FIX.Latest',
    type: 'data',
    addedEP: '105',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'InstrumentScopeEncodedSecurityDesc',
    id: 1621,
    abbrName: 'EncDesc',
    lengthId: '1620',
    description:
      'Encoded (non-ASCII characters) representation of the InstrumentScopeSecurityDesc(1556) field in the encoded format specified via the MessageEncoding(347) field. If used, the ASCII (English) representation should also be specified in the InstrumentScopeSecurityDesc(1556) field.',
  },
  {
    type: 'NumInGroup',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'NoInstrumentScopes',
    id: 1656,
    description: 'Number of instrument scopes.',
  },
  {
    type: 'NumInGroup',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'NoRequestingPartyIDs',
    id: 1657,
    description: 'Number of requesting party identifiers.',
  },
  {
    type: 'String',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'RequestingPartyID',
    id: 1658,
    abbrName: 'ID',
    discriminatorId: '1659',
    description: 'Party identifier for the requesting party.',
  },
  {
    type: 'PartyIDSourceCodeSet',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'RequestingPartyIDSource',
    id: 1659,
    abbrName: 'Src',
    description: 'Identifies the source of the RequestingPartyID(1658) value.',
  },
  {
    type: 'PartyRoleCodeSet',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'RequestingPartyRole',
    id: 1660,
    abbrName: 'R',
    description: 'Identifies the type or role of the RequestingPartyID(1658) specified.',
  },
  {
    type: 'NumInGroup',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'NoRequestingPartySubIDs',
    id: 1661,
    description: 'Number of requesting party sub-identifiers.',
  },
  {
    type: 'String',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'RequestingPartySubID',
    id: 1662,
    abbrName: 'ID',
    description: 'Sub-identifier for the party specified in RequestingPartyID(1658).',
  },
  {
    type: 'PartySubIDTypeCodeSet',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'RequestingPartySubIDType',
    id: 1663,
    abbrName: 'Typ',
    description: 'Type of RequestingPartySubID(1662) value.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'Length',
    addedEP: '105',
    updatedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'EncodedRejectTextLen',
    id: 1664,
    abbrName: 'EncRejTxtLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedRejectText(1665) field.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'data',
    addedEP: '105',
    updatedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'EncodedRejectText',
    id: 1665,
    abbrName: 'EncRejTxt',
    lengthId: '1664',
    description:
      'Encoded (non-ASCII characters) representation of the RejectText(1328) field in the encoded format specified via the MessageEncoding(347) field. If used, the ASCII (English) representation should also be specified in the RejectText(1328) field.',
  },
  {
    type: 'String',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'RiskLimitRequestID',
    id: 1666,
    abbrName: 'ReqID',
    description: 'Unique identifier for the PartyRiskLimitsRequest',
  },
  {
    type: 'String',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'RiskLimitReportID',
    id: 1667,
    abbrName: 'RptID',
    description: 'Identifier for the PartyRiskLimitsReport',
  },
  {
    type: 'NumInGroup',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'NoRequestedRiskLimitType',
    id: 1668,
    description: 'Number of risk limit types requested.',
  },
  {
    type: 'NumInGroup',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'NoRiskLimits',
    id: 1669,
    description: 'Number of risk limits for different instrument scopes.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    baseCategoryAbbrName: 'ID',
    baseCategory: 'PartiesReferenceData',
    addedEP: '105',
    updatedEP: '171',
    added: 'FIX.5.0SP2',
    name: 'RiskLimitID',
    id: 1670,
    abbrName: 'RiskLmtID',
    description:
      'Unique reference identifier for a specific risk limit defined for the specified party.',
  },
  {
    type: 'NumInGroup',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'NoPartyDetails',
    id: 1671,
    description: 'Number of party details.',
  },
  {
    type: 'PartyDetailStatusCodeSet',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'PartyDetailStatus',
    id: 1672,
    abbrName: 'Stat',
    description: 'Indicates the status of the party identified with PartyDetailID(1691).',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PartyDetailRoleQualifierCodeSet',
    addedEP: '105',
    updatedEP: '223',
    added: 'FIX.5.0SP2',
    name: 'PartyDetailRoleQualifier',
    id: 1674,
    abbrName: 'Qual',
    description: 'Qualifies the value of PartyDetailRole(1693).',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PartyDetailRoleQualifierCodeSet',
    addedEP: '105',
    updatedEP: '173',
    added: 'FIX.5.0SP2',
    name: 'RelatedPartyDetailRoleQualifier',
    id: 1675,
    abbrName: 'Qual',
    description: 'Qualifies the value of RelatedPartyRole(1565)',
  },
  {
    type: 'NumInGroup',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'NoPartyUpdates',
    id: 1676,
    description: 'Number of party updates.',
  },
  {
    type: 'NumInGroup',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'NoPartyRiskLimits',
    id: 1677,
    description: 'Number of party risk limits.',
  },
  {
    type: 'String',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'PartyDetailID',
    id: 1691,
    abbrName: 'ID',
    discriminatorId: '1692',
    description: 'Party identifier within Parties Reference Data messages.',
  },
  {
    type: 'PartyIDSourceCodeSet',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'PartyDetailIDSource',
    id: 1692,
    abbrName: 'Src',
    description: 'Source of the identifier of the PartyDetailID(1691) specified.',
  },
  {
    type: 'PartyRoleCodeSet',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'PartyDetailRole',
    id: 1693,
    abbrName: 'R',
    description: 'Identifies the type or role of PartyDetailID(1691) specified.',
  },
  {
    type: 'NumInGroup',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'NoPartyDetailSubIDs',
    id: 1694,
    description: 'Number of party detail sub-identifiers.',
  },
  {
    type: 'String',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'PartyDetailSubID',
    id: 1695,
    abbrName: 'ID',
    description: 'Sub-identifier for the party specified in PartyDetailID(1691).',
  },
  {
    type: 'PartySubIDTypeCodeSet',
    addedEP: '105',
    added: 'FIX.5.0SP2',
    name: 'PartyDetailSubIDType',
    id: 1696,
    abbrName: 'Typ',
    description: 'Type of PartyDetailSubID(1695) value.',
  },
  {
    type: 'SecurityTradingStatusCodeSet',
    addedEP: '106',
    added: 'FIX.5.0SP2',
    name: 'SecurityMassTradingStatus',
    id: 1679,
    abbrName: 'TrdgStat',
    description: 'Identifies the trading status applicable to a group of instruments.',
  },
  {
    type: 'SecurityTradingEventCodeSet',
    addedEP: '106',
    added: 'FIX.5.0SP2',
    name: 'SecurityMassTradingEvent',
    id: 1680,
    abbrName: 'SecTrdEvnt',
    description: 'Identifies an event related to the mass trading status.',
  },
  {
    type: 'HaltReasonCodeSet',
    addedEP: '106',
    added: 'FIX.5.0SP2',
    name: 'MassHaltReason',
    id: 1681,
    abbrName: 'HaltRsn',
    description:
      'Denotes the reason for the Opening Delay or Trading halt of a group of securities.',
  },
  {
    type: 'SecurityTradingStatusCodeSet',
    addedEP: '106',
    added: 'FIX.5.0SP2',
    name: 'MDSecurityTradingStatus',
    id: 1682,
    abbrName: 'TrdgStat',
    description:
      'Identifies the trading status applicable to the instrument in the market data message.',
  },
  {
    type: 'String',
    addedEP: '106',
    added: 'FIX.5.0SP2',
    name: 'MDSubFeedType',
    id: 1683,
    abbrName: 'MDSubFeedTyp',
    description:
      'Describes a sub-class for a given class of service defined by MDFeedType (1022)',
  },
  {
    type: 'HaltReasonCodeSet',
    addedEP: '106',
    added: 'FIX.5.0SP2',
    name: 'MDHaltReason',
    id: 1684,
    abbrName: 'HaltRsn',
    description: 'Denotes the reason for the Opening Delay or Trading Halt.',
  },
  {
    type: 'String',
    addedEP: '107',
    added: 'FIX.5.0SP2',
    name: 'SideTradeID',
    id: 1506,
    abbrName: 'TrdID',
    description:
      'Used to represent the trade ID for each side of the trade assigned by an intermediary.',
  },
  {
    type: 'String',
    addedEP: '107',
    added: 'FIX.5.0SP2',
    name: 'SideOrigTradeID',
    id: 1507,
    abbrName: 'OrigTrdID',
    description:
      'Used to capture the original trade id for each side of a trade undergoing novation to a standardized model.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PriceOffset',
    addedEP: '107',
    updatedEP: '217',
    added: 'FIX.5.0SP2',
    name: 'DifferentialPrice',
    id: 1522,
    abbrName: 'DiffPx',
    description:
      'Used to specify the differential price when reporting the individual leg of a spread trade. Both leg price and differential price may be provided on such a report. Note that MultiLegReportingType(442) will be set to 2 (Individual leg of a multi-leg security) in this case.\n\nAlso used in pricing Trade at Settlement (TAS) and Trade At Marker (TAM) contracts for which the value is the negotiated currency offset either at settlement (TAS) or at time specified in the product definition (TAM). The final contract price is specified in LastPx(31).',
  },
  {
    type: 'TrdAckStatusCodeSet',
    addedEP: '107',
    added: 'FIX.5.0SP2',
    name: 'TrdAckStatus',
    id: 1523,
    abbrName: 'TrdAckStat',
    description:
      'Used to indicate the status of the trade submission (not the trade report)',
  },
  {
    type: 'Currency',
    addedEP: '107',
    added: 'FIX.5.0SP2',
    name: 'PriceQuoteCurrency',
    id: 1524,
    abbrName: 'PxQteCcy',
    description:
      'Default currency in which the price is quoted. Defined at the instrument level. Used in place of Currency (tag 15) to express the currency of a product when the former is implemented as the FX dealt currency.',
  },
  {
    type: 'Currency',
    addedEP: '107',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPriceQuoteCurrency',
    id: 1526,
    abbrName: 'PxQteCcy',
    description:
      'Default currency in which the price is quoted. Defined at the instrument level. Used in place of Currency (tag 15) to express the currency of a product when the former is implemented as the FX dealt currency.',
  },
  {
    type: 'Currency',
    addedEP: '107',
    added: 'FIX.5.0SP2',
    name: 'LegPriceQuoteCurrency',
    id: 1528,
    abbrName: 'PxQteCcy',
    description:
      'Default currency in which the price is quoted. Defined at the instrument level. Used in place of Currency (tag 15) to express the currency of a product when the former is implemented as the FX dealt currency.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Currency',
    addedEP: '107',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'DerivativePriceQuoteCurrency',
    id: 1576,
    abbrName: 'PxQteCcy',
    description:
      'Default currency in which the price is quoted. Defined at the instrument level. Used in place of Currency(tag 15) to express the currency of a product when the former is implemented as the FX dealt currency.\n\nSee PriceQuoteCurrency(1524) for complete definition.',
  },
  {
    type: 'NumInGroup',
    addedEP: '107',
    added: 'FIX.5.0SP2',
    name: 'NoSecurityClassifications',
    id: 1582,
    description: 'Number of Security Classifications.',
  },
  {
    type: 'SecurityClassificationReasonCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '107',
    added: 'FIX.5.0SP2',
    name: 'SecurityClassificationReason',
    id: 1583,
    abbrName: 'Rsn',
    description:
      'Allows classification of instruments according to a set of high level reasons. Classification reasons describe the classes in which the instrument participates.',
  },
  {
    type: 'String',
    addedEP: '107',
    added: 'FIX.5.0SP2',
    name: 'SecurityClassificationValue',
    id: 1584,
    abbrName: 'Val',
    description:
      'Specifies the product classification value which further details the manner in which the instrument participates in the class.',
  },
  {
    type: 'PosAmtReasonCodeSet',
    unionDataType: 'Reserved1000Plus',
    addedEP: '107',
    added: 'FIX.5.0SP2',
    name: 'PosAmtReason',
    id: 1585,
    abbrName: 'Rsn',
    description:
      'Specifies the reason for an amount type when reported on a position. Useful when multiple instances of the same amount type are reported.',
  },
  {
    type: 'NumInGroup',
    addedEP: '107',
    added: 'FIX.5.0SP2',
    name: 'NoLegPosAmt',
    id: 1586,
    description: 'Number of TrdInstrmtLegPosAmt values.',
  },
  {
    type: 'Amt',
    addedEP: '107',
    added: 'FIX.5.0SP2',
    name: 'LegPosAmt',
    id: 1587,
    abbrName: 'Amt',
    description: 'Leg position amount.',
  },
  {
    type: 'PosAmtTypeCodeSet',
    addedEP: '107',
    added: 'FIX.5.0SP2',
    name: 'LegPosAmtType',
    id: 1588,
    abbrName: 'Typ',
    description: 'Type of leg position amount.',
  },
  {
    type: 'Currency',
    addedEP: '107',
    added: 'FIX.5.0SP2',
    name: 'LegPosCurrency',
    id: 1589,
    abbrName: 'Ccy',
    description: 'Leg position currency.',
  },
  {
    type: 'PosAmtReasonCodeSet',
    unionDataType: 'Reserved1000Plus',
    addedEP: '107',
    added: 'FIX.5.0SP2',
    name: 'LegPosAmtReason',
    id: 1590,
    abbrName: 'Rsn',
    description:
      'Specifies the reason for an amount type when reported on a position. Useful when multiple instances of the same amount type are reported.',
  },
  {
    type: 'QtyTypeCodeSet',
    addedEP: '107',
    added: 'FIX.5.0SP2',
    name: 'LegQtyType',
    id: 1591,
    abbrName: 'QtyTyp',
    description:
      'Type of quantity specified in LegQty field. LegContractMultiplier (614) is required when LegQtyType = 1 (Contracts). LegUnitOfMeasure (tag 999) and LegTimeUnit (tag 1001) are required when LegQtyType = 2 (Units of Measure per Time Unit). LegQtyType can be different for each leg.',
  },
  {
    type: 'float',
    addedEP: '107',
    added: 'FIX.5.0SP2',
    name: 'DiscountFactor',
    id: 1592,
    abbrName: 'DiscFctr',
    description:
      'Used to calculate the present value of an amount to be paid in the future.',
  },
  {
    type: 'String',
    addedEP: '107',
    added: 'FIX.5.0SP2',
    name: 'ParentAllocID',
    id: 1593,
    abbrName: 'ParentAllocID',
    description:
      'Contains the IndividualAllocId (tag 467) value of the allocation that is being offset as a result of a new allocation. This would be an optional field that would only be populated in the case of an allocation of an allocation (as well as any subsequent allocations). This wouldn’t be populated for an initial allocation since an allocation id is not supplied on default (initial) allocations.',
  },
  {
    type: 'String',
    addedEP: '107',
    added: 'FIX.5.0SP2',
    name: 'LegSecurityGroup',
    id: 1594,
    abbrName: 'SecGrp',
    description:
      'Represents the product group of a leg.This is useful in conveying multi-leg instruments where the legs may participate in separate security groups.',
  },
  {
    type: 'Price',
    addedEP: '109',
    added: 'FIX.5.0SP2',
    name: 'PositionContingentPrice',
    id: 1595,
    abbrName: 'CntgPx',
    description: 'Risk adjusted price used to calculate variation margin on a position.',
  },
  {
    type: 'Price',
    addedEP: '111',
    added: 'FIX.5.0SP2',
    name: 'ClearingTradePrice',
    id: 1596,
    abbrName: 'ClrTrdPx',
    description: 'Alternate clearing price',
  },
  {
    type: 'Price',
    addedEP: '111',
    added: 'FIX.5.0SP2',
    name: 'SideClearingTradePrice',
    id: 1597,
    abbrName: 'ClrTrdPx',
    description: 'Alternate clearing price for the side being reported.',
  },
  {
    type: 'SideClearingTradePriceTypeCodeSet',
    addedEP: '111',
    added: 'FIX.5.0SP2',
    name: 'SideClearingTradePriceType',
    id: 1598,
    abbrName: 'ClrTrdPxType',
    description:
      'Indicates to recipient whether trade is clearing at execution prices LastPx(tag 31) or alternate clearing prices SideClearingTradePrice(tag 1597).',
  },
  {
    type: 'Price',
    addedEP: '111',
    added: 'FIX.5.0SP2',
    name: 'SidePriceDifferential',
    id: 1599,
    abbrName: 'SidePxDiff',
    description:
      'Price Differential between the front and back leg of a spread or complex instrument.',
  },
  {
    type: 'String',
    addedEP: '113',
    added: 'FIX.5.0SP2',
    name: 'FIXEngineName',
    id: 1600,
    description:
      'Provides the name of the infrastructure component being used for session level communication. Normally this would be the FIX Engine or FIX Gateway product name.',
  },
  {
    type: 'String',
    addedEP: '113',
    added: 'FIX.5.0SP2',
    name: 'FIXEngineVersion',
    id: 1601,
    description: 'Provides the version of the infrastructure component.',
  },
  {
    type: 'String',
    addedEP: '113',
    added: 'FIX.5.0SP2',
    name: 'FIXEngineVendor',
    id: 1602,
    description:
      'Provides the name of the vendor providing the infrastructure component.',
  },
  {
    type: 'String',
    addedEP: '113',
    added: 'FIX.5.0SP2',
    name: 'ApplicationSystemName',
    id: 1603,
    description:
      'Provides the name of the application system being used to generate FIX application messages. This will normally be a trading system, OMS, or EMS.',
  },
  {
    type: 'String',
    addedEP: '113',
    added: 'FIX.5.0SP2',
    name: 'ApplicationSystemVersion',
    id: 1604,
    description:
      'Provides the version of the application system being used to initiate FIX application messages.',
  },
  {
    type: 'String',
    addedEP: '113',
    added: 'FIX.5.0SP2',
    name: 'ApplicationSystemVendor',
    id: 1605,
    description: 'Provides the vendor of the application system.',
  },
  {
    type: 'int',
    addedEP: '114',
    added: 'FIX.5.0SP2',
    name: 'NumOfSimpleInstruments',
    id: 1606,
    abbrName: 'NumSimplInstrmt',
    description:
      'Represents the total number of simple instruments that make up a multi-legged security. Complex spread instruments may be constructed of legs which themselves are multi-leg instruments.',
  },
  {
    type: 'SecurityRejectReasonCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '114',
    added: 'FIX.5.0SP2',
    name: 'SecurityRejectReason',
    id: 1607,
    abbrName: 'SecRejRsn',
    description: 'Identifies the reason a security definition request is being rejected.',
  },
  {
    type: 'Qty',
    addedEP: '115',
    added: 'FIX.5.0SP2',
    name: 'InitialDisplayQty',
    id: 1608,
    abbrName: 'InitDsplyQty',
    description:
      'Used to convey the initially requested display quantity specified in DisplayQty(1138) on order entry and modification messages in ExecutionReport message. Applicable only in ExecutionReport message where DisplayQty(1138) is the currently displayed quantity and the requested display quantity of the order also needs to be conveyed. The values of the two fields are different as soon as the order is partially filled and also after a refresh of the order whenever DisplayMethod(1084) is not 1=Initial.',
  },
  {
    type: 'ThrottleStatusCodeSet',
    addedEP: '116',
    added: 'FIX.5.0SP2',
    name: 'ThrottleStatus',
    id: 1609,
    abbrName: 'ThrttlStat',
    description: 'Indicates whether a message was queued as a result of throttling.',
  },
  {
    type: 'NumInGroup',
    addedEP: '116',
    added: 'FIX.5.0SP2',
    name: 'NoThrottles',
    id: 1610,
    description: 'Indicates number of repeating groups to follow.',
  },
  {
    type: 'ThrottleActionCodeSet',
    addedEP: '116',
    added: 'FIX.5.0SP2',
    name: 'ThrottleAction',
    id: 1611,
    abbrName: 'Actn',
    description: 'Action to take should throttle limit be exceeded.',
  },
  {
    type: 'ThrottleTypeCodeSet',
    addedEP: '116',
    added: 'FIX.5.0SP2',
    name: 'ThrottleType',
    id: 1612,
    abbrName: 'Typ',
    description: 'Type of throttle.',
  },
  {
    type: 'int',
    addedEP: '116',
    added: 'FIX.5.0SP2',
    name: 'ThrottleNoMsgs',
    id: 1613,
    abbrName: 'NoMsgs',
    description:
      'Maximum number of messages allowed by the throttle. May be a rate limit or a limit on the number of outstanding requests.',
  },
  {
    type: 'int',
    addedEP: '116',
    added: 'FIX.5.0SP2',
    name: 'ThrottleTimeInterval',
    id: 1614,
    abbrName: 'TmIntvl',
    description: 'Value of the time interval in which the rate throttle is applied.',
  },
  {
    type: 'OrderDelayUnitCodeSet',
    addedEP: '116',
    added: 'FIX.5.0SP2',
    name: 'ThrottleTimeUnit',
    id: 1615,
    abbrName: 'TmUnit',
    description:
      'Units in which ThrottleTimeInterval is expressed. Uses same enumerations as OrderDelayUnit(1429).',
  },
  {
    type: 'NumInGroup',
    addedEP: '116',
    added: 'FIX.5.0SP2',
    name: 'NoThrottleMsgType',
    id: 1618,
    description: 'Number of ThrottleMsgType fields.',
  },
  {
    type: 'MsgTypeCodeSet',
    addedEP: '116',
    added: 'FIX.5.0SP2',
    name: 'ThrottleMsgType',
    id: 1619,
    abbrName: 'MsgTyp',
    description: 'The MsgType (35) of the FIX message being referenced.',
  },
  {
    type: 'ThrottleInstCodeSet',
    addedEP: '116',
    added: 'FIX.5.0SP2',
    name: 'ThrottleInst',
    id: 1685,
    abbrName: 'ThrttlInst',
    description:
      'Describes action recipient should take if a throttle limit were exceeded.',
  },
  {
    type: 'ThrottleCountIndicatorCodeSet',
    addedEP: '116',
    added: 'FIX.5.0SP2',
    name: 'ThrottleCountIndicator',
    id: 1686,
    abbrName: 'ThrttlCntInd',
    description:
      'Indicates whether a message decrements the number of outstanding requests, e.g. one where ThrottleType = Outstanding Requests.',
  },
  {
    type: 'String',
    addedEP: '117',
    added: 'FIX.5.0SP2',
    name: 'AccountSummaryReportID',
    id: 1699,
    abbrName: 'RptID',
    description: 'Unique identifier for the AccountSummaryReport(35=CQ).',
  },
  {
    type: 'NumInGroup',
    addedEP: '117',
    added: 'FIX.5.0SP2',
    name: 'NoSettlementAmounts',
    id: 1700,
    description: 'Number of settlement amount entries.',
  },
  {
    type: 'Amt',
    addedEP: '117',
    added: 'FIX.5.0SP2',
    name: 'SettlementAmount',
    id: 1701,
    abbrName: 'Amt',
    description: 'The amount of settlement.',
  },
  {
    type: 'Currency',
    addedEP: '117',
    added: 'FIX.5.0SP2',
    name: 'SettlementAmountCurrency',
    id: 1702,
    abbrName: 'Ccy',
    description: 'The currency of the reported settlement amount.',
  },
  {
    type: 'NumInGroup',
    addedEP: '117',
    added: 'FIX.5.0SP2',
    name: 'NoCollateralAmounts',
    id: 1703,
    description: 'Number of collateral amount entries.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'Amt',
    addedEP: '117',
    updatedEP: '227',
    added: 'FIX.5.0SP2',
    name: 'CurrentCollateralAmount',
    id: 1704,
    abbrName: 'Amt',
    description: 'Currency value currently attributed to the collateral.',
  },
  {
    type: 'Currency',
    addedEP: '117',
    added: 'FIX.5.0SP2',
    name: 'CollateralCurrency',
    id: 1705,
    abbrName: 'Ccy',
    description:
      'Currency of the collateral; optional, defaults to the Settlement Currency if not specified.',
  },
  {
    type: 'String',
    addedEP: '117',
    added: 'FIX.5.0SP2',
    name: 'CollateralType',
    id: 1706,
    abbrName: 'Typ',
    description: 'Type of collateral on deposit being reported.',
  },
  {
    type: 'NumInGroup',
    addedEP: '117',
    added: 'FIX.5.0SP2',
    name: 'NoPayCollects',
    id: 1707,
    description: 'Number of pay collect entries.',
  },
  {
    type: 'Amt',
    addedEP: '117',
    added: 'FIX.5.0SP2',
    name: 'PayAmount',
    id: 1710,
    abbrName: 'PayAmt',
    description: 'Amount to be paid by the clearinghouse to the clearing firm.',
  },
  {
    type: 'Amt',
    addedEP: '117',
    added: 'FIX.5.0SP2',
    name: 'CollectAmount',
    id: 1711,
    abbrName: 'ColAmt',
    description: 'Amount to be collected by the clearinghouse from the clearing firm.',
  },
  {
    type: 'String',
    addedEP: '117',
    added: 'FIX.5.0SP2',
    name: 'PayCollectType',
    id: 1708,
    abbrName: 'Typ',
    description:
      'Category describing the reason for funds paid to, or the funds collected from the clearing firm.',
  },
  {
    type: 'Currency',
    addedEP: '117',
    added: 'FIX.5.0SP2',
    name: 'PayCollectCurrency',
    id: 1709,
    abbrName: 'Ccy',
    description:
      'Currency denomination of value in PayAmount(1710) and CollectAmount(1711). If not specified, default to currency specified in SettlementAmountCurrency(1702).',
  },
  {
    type: 'String',
    addedEP: '117',
    added: 'FIX.5.0SP2',
    name: 'PayCollectMarketSegmentID',
    id: 1712,
    abbrName: 'MktSegID',
    description: 'Market segment associated with the pay collect amount.',
  },
  {
    type: 'String',
    addedEP: '117',
    added: 'FIX.5.0SP2',
    name: 'PayCollectMarketID',
    id: 1713,
    abbrName: 'MktID',
    description: 'Market associated with the pay collect amount.',
  },
  {
    type: 'String',
    addedEP: '117',
    added: 'FIX.5.0SP2',
    name: 'MarginAmountMarketSegmentID',
    id: 1714,
    abbrName: 'MktSegID',
    description: 'Market segment associated with the margin amount.',
  },
  {
    type: 'String',
    addedEP: '117',
    added: 'FIX.5.0SP2',
    name: 'MarginAmountMarketID',
    id: 1715,
    abbrName: 'MktID',
    description: 'Market associated with the margin amount',
  },
  {
    type: 'String',
    addedEP: '118',
    added: 'FIX.5.0SP2',
    name: 'FirmGroupID',
    id: 1728,
    abbrName: 'FirmGrpID',
    description: 'Firm assigned group allocation entity identifier.',
  },
  {
    type: 'String',
    addedEP: '118',
    added: 'FIX.5.0SP2',
    name: 'FirmMnemonic',
    id: 1729,
    abbrName: 'FirmMnem',
    description:
      'Allocation identifier assigned by the Firm submitting the allocation for an individual allocation instruction (as opposed to the overall message level identifier).',
  },
  {
    type: 'String',
    addedEP: '118',
    added: 'FIX.5.0SP2',
    name: 'AllocGroupID',
    id: 1730,
    abbrName: 'GrpID',
    description:
      'Intended to be used by a central counterparty to assign an identifier to allocations of trades for the same instrument traded at the same price.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    addedEP: '118',
    updatedEP: '141',
    added: 'FIX.5.0SP2',
    name: 'AvgPxGroupID',
    id: 1731,
    abbrName: 'AvgPxGrpID',
    description:
      'Used by submitting firm to group trades being allocated into an average price group. The trades in average price group will be used to calculate an average price for the group.',
  },
  {
    type: 'String',
    addedEP: '118',
    added: 'FIX.5.0SP2',
    name: 'FirmAllocText',
    id: 1732,
    abbrName: 'FirmTxt',
    description:
      'Firm reference information, usually internal information, that is part of the initial message. The information would not be carried forward (e.g to Take-up Firm) and preserved with the transaction.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Length',
    addedEP: '118',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'EncodedFirmAllocTextLen',
    id: 1733,
    abbrName: 'EncFirmTxtLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedFirmAllocText(1734) field.',
  },
  {
    updated: 'FIX.Latest',
    type: 'data',
    addedEP: '118',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'EncodedFirmAllocText',
    id: 1734,
    abbrName: 'EncFirmTxt',
    lengthId: '1733',
    description:
      'Encoded (non-ASCII characters) representation of the FirmAllocText(1732) field in the encoded format specified via the MessageEncoding(347) field. If used, the ASCII (English) represention should also be specified in FirmAllocText(1732) field.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'AllocationRollupInstructionCodeSet',
    addedEP: '118',
    updatedEP: '141',
    added: 'FIX.5.0SP2',
    name: 'AllocationRollupInstruction',
    id: 1735,
    abbrName: 'AllocRollupInst',
    description:
      'An indicator to override the normal procedure to roll up allocations for the same take-up firm.',
  },
  {
    type: 'Qty',
    addedEP: '118',
    added: 'FIX.5.0SP2',
    name: 'AllocGroupQuantity',
    id: 1736,
    abbrName: 'GrpQty',
    description:
      'Indicates the total quantity of an allocation group. Includes any allocated quantity.',
  },
  {
    type: 'Qty',
    addedEP: '118',
    added: 'FIX.5.0SP2',
    name: 'AllocGroupRemainingQuantity',
    id: 1737,
    abbrName: 'RemQty',
    description:
      'Indicates the remaining quantity of an allocation group that has not yet been allocated.',
  },
  {
    type: 'AllocReversalStatusCodeSet',
    addedEP: '118',
    added: 'FIX.5.0SP2',
    name: 'AllocReversalStatus',
    id: 1738,
    abbrName: 'RvrslStat',
    description: 'Identifies the status of a reversal transaction.',
  },
  {
    type: 'ObligationTypeCodeSet',
    addedEP: '119',
    added: 'FIX.5.0SP2',
    name: 'ObligationType',
    id: 1739,
    abbrName: 'ObligTyp',
    description: 'Type of reference obligation for credit derivatives contracts.',
  },
  {
    type: 'TradePriceNegotiationMethodCodeSet',
    addedEP: '119',
    added: 'FIX.5.0SP2',
    name: 'TradePriceNegotiationMethod',
    id: 1740,
    abbrName: 'TrdPxNegottnMeth',
    description: 'Method used for negotiation of contract price.',
  },
  {
    type: 'UpfrontPriceTypeCodeSet',
    addedEP: '119',
    added: 'FIX.5.0SP2',
    name: 'UpfrontPriceType',
    id: 1741,
    abbrName: 'UpfrontPxTyp',
    description: 'Type of price used to determine upfront payment for swaps contracts.',
  },
  {
    type: 'Price',
    addedEP: '119',
    added: 'FIX.5.0SP2',
    name: 'UpfrontPrice',
    id: 1742,
    abbrName: 'UpfrontPx',
    description: 'Price used to determine upfront payment for swaps contracts.',
  },
  {
    type: 'Price',
    addedEP: '119',
    added: 'FIX.5.0SP2',
    name: 'LastUpfrontPrice',
    id: 1743,
    abbrName: 'LastUpfrontPx',
    description:
      'Price used to determine upfront payment for swaps contracts reported for a deal (trade).',
  },
  {
    type: 'ShortSaleRestrictionCodeSet',
    addedEP: '120',
    added: 'FIX.5.0SP2',
    name: 'ShortSaleRestriction',
    id: 1687,
    abbrName: 'ShrtRstctn',
    description: 'Indicates whether a restriction applies to short selling a security.',
  },
  {
    type: 'ShortSaleExemptionReasonCodeSet',
    addedEP: '121',
    added: 'FIX.5.0SP2',
    name: 'ShortSaleExemptionReason',
    id: 1688,
    abbrName: 'ShrtSaleExmptnRsn',
    description:
      'Indicates the reason a short sale order is exempted from applicable regulation (e.g. Reg SHO addendum (b)(1) in the U.S.).',
  },
  {
    type: 'ShortSaleExemptionReasonCodeSet',
    addedEP: '121',
    added: 'FIX.5.0SP2',
    name: 'LegShortSaleExemptionReason',
    id: 1689,
    abbrName: 'ShrtSaleExmptnRsn',
    description:
      'Indicates the reason a short sale is exempted from applicable regulation (e.g. Reg SHO addendum (b)(1) in the U.S.)',
  },
  {
    type: 'ShortSaleExemptionReasonCodeSet',
    addedEP: '121',
    added: 'FIX.5.0SP2',
    name: 'SideShortSaleExemptionReason',
    id: 1690,
    abbrName: 'ShrtSaleExmptnRsn',
    description:
      'Indicates the reason a short sale is exempted from applicable regulation (e.g. Reg SHO addendum (b)(1) in the U.S.)',
  },
  {
    type: 'Currency',
    addedEP: '122',
    added: 'FIX.5.0SP2',
    name: 'UnitOfMeasureCurrency',
    id: 1716,
    abbrName: 'UOMCcy',
    description:
      'Indicates the currency of the unit of measure. Conditionally required when UnitOfMeasure(996) = Ccy',
  },
  {
    type: 'Currency',
    addedEP: '122',
    added: 'FIX.5.0SP2',
    name: 'PriceUnitOfMeasureCurrency',
    id: 1717,
    abbrName: 'PxUOMCcy',
    description:
      'Indicates the currency of the price unit of measure. Conditionally required when PriceUnitOfMeasure(1191) = Ccy',
  },
  {
    type: 'Currency',
    addedEP: '122',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingUnitOfMeasureCurrency',
    id: 1718,
    abbrName: 'UOMCcy',
    description:
      'Indicates the currency of the underlying unit of measure. Conditionally required when UnderlyingUnitOfMeasure(998) = Ccy',
  },
  {
    type: 'Currency',
    addedEP: '122',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPriceUnitOfMeasureCurrency',
    id: 1719,
    abbrName: 'PxUOMCcy',
    description:
      'Indicates the currency of the underlying price unit of measure. Conditionally required when UnderlyingPriceUnitOfMeasure(1424) = Ccy',
  },
  {
    type: 'Currency',
    addedEP: '122',
    added: 'FIX.5.0SP2',
    name: 'LegUnitOfMeasureCurrency',
    id: 1720,
    abbrName: 'UOMCcy',
    description:
      'Indicates the currency of the unit of measure. Conditionally required when LegUnitOfMeasure(999) = Ccy',
  },
  {
    type: 'Currency',
    addedEP: '122',
    added: 'FIX.5.0SP2',
    name: 'LegPriceUnitOfMeasureCurrency',
    id: 1721,
    abbrName: 'PxUOMCcy',
    description:
      'Indicates the currency of the price unit of measure. Conditionally required when LegPriceUnitOfMeasure(1421) = Ccy',
  },
  {
    updated: 'FIX.Latest',
    type: 'Currency',
    addedEP: '122',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'DerivativeUnitOfMeasureCurrency',
    id: 1722,
    abbrName: 'UOMCcy',
    description:
      'Indicates the currency of the unit of measure.\n\nConditionally required when DerivativeUnitOfMeasure(1269) = Ccy.\n\nSee UnitOfMeasureCurrency(1716) for complete definition.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Currency',
    addedEP: '122',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'DerivativePriceUnitOfMeasureCurrency',
    id: 1723,
    abbrName: 'PxUOMCcy',
    description:
      'Indicates the currency of the price unit of measure.\n\nConditionally required when DerivativePriceUnitOfMeasure(1315) = Ccy.\n\nSee PriceUnitOfMeasureCurrency(1717) for complete definition.',
  },
  {
    type: 'ApplLevelRecoveryIndicatorCodeSet',
    addedEP: '124',
    added: 'FIX.5.0SP2',
    name: 'ApplLevelRecoveryIndicator',
    id: 1744,
    description: 'Indicates whether application level recovery is needed.',
  },
  {
    type: 'String',
    addedEP: '125',
    added: 'FIX.5.0SP2',
    name: 'BidMDEntryID',
    id: 1745,
    abbrName: 'BidMDID',
    description: 'The market data entry identifier of the bid side of a quote',
  },
  {
    type: 'String',
    addedEP: '125',
    added: 'FIX.5.0SP2',
    name: 'OfferMDEntryID',
    id: 1746,
    abbrName: 'OfrMDID',
    description: 'The market data entry identifier of the offer side of a quote.',
  },
  {
    type: 'String',
    addedEP: '125',
    added: 'FIX.5.0SP2',
    name: 'BidQuoteID',
    id: 1747,
    abbrName: 'BidQID',
    description:
      'Marketplace assigned quote identifier for the bid side. Can be used to indicate priority.',
  },
  {
    type: 'String',
    addedEP: '125',
    added: 'FIX.5.0SP2',
    name: 'OfferQuoteID',
    id: 1748,
    abbrName: 'OfrQID',
    description:
      'Marketplace assigned quote identifier for the offer side. Can be used to indicate priority.',
  },
  {
    type: 'Qty',
    addedEP: '126',
    added: 'FIX.5.0SP2',
    name: 'TotalBidSize',
    id: 1749,
    abbrName: 'TotBidSz',
    description: 'Specifies the total bid size.',
  },
  {
    type: 'Qty',
    addedEP: '126',
    added: 'FIX.5.0SP2',
    name: 'TotalOfferSize',
    id: 1750,
    abbrName: 'TotOfrSz',
    description: 'Specifies the total offer size.',
  },
  {
    type: 'String',
    addedEP: '126',
    added: 'FIX.5.0SP2',
    name: 'SecondaryQuoteID',
    id: 1751,
    abbrName: 'QID2',
    description:
      'Assigned by the party which accepts the quote. Can be used to provide the quote identifier assigned by an exchange, marketplace or executing system.',
  },
  {
    type: 'String',
    addedEP: '127',
    added: 'FIX.5.0SP2',
    name: 'CustodialLotID',
    id: 1752,
    abbrName: 'CstdlLotID',
    description:
      'An opaque identifier used to communicate the custodian’s identifier for the lot. It is expected that this information would be provided by the custodian as part of a reconciliation process that occurs before trading.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '127',
    added: 'FIX.5.0SP2',
    name: 'VersusPurchaseDate',
    id: 1753,
    abbrName: 'VSPDt',
    description:
      'The effective acquisition date of the lot that would be used for gain-loss trade lot reporting. The versus purchase date used to identify the lot in situations where a custodial lot identifier is not available.',
  },
  {
    type: 'Price',
    addedEP: '127',
    added: 'FIX.5.0SP2',
    name: 'VersusPurchasePrice',
    id: 1754,
    abbrName: 'VSPPx',
    description:
      'The versus purchase price used to identify the lot in situations where a custodial lot identifier is not available. The value should be calculated based on current cost basis / quantity held.',
  },
  {
    type: 'Amt',
    addedEP: '127',
    added: 'FIX.5.0SP2',
    name: 'CurrentCostBasis',
    id: 1755,
    abbrName: 'CurCostBasis',
    description:
      'The amount that the current shares are worth. If this lot was liquidated, the total gain/loss for a trade is equal to the trade amount minus the current cost basis.',
  },
  {
    type: 'String',
    addedEP: '127',
    added: 'FIX.5.0SP2',
    name: 'LegCustodialLotID',
    id: 1756,
    abbrName: 'CstdlLotID',
    description:
      'An opaque identifier used to communicate the custodian’s identifier for the lot. It is expected that this information would be provided by the custodian as part of a reconciliation process that occurs before trading.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '127',
    added: 'FIX.5.0SP2',
    name: 'LegVersusPurchaseDate',
    id: 1757,
    abbrName: 'VSPDt',
    description:
      'The effective acquisition date of the lot that would be used for gain-loss trade lot reporting. The versus purchase date used to identify the lot in situations where a custodial lot identifier is not available.',
  },
  {
    type: 'Price',
    addedEP: '127',
    added: 'FIX.5.0SP2',
    name: 'LegVersusPurchasePrice',
    id: 1758,
    abbrName: 'VSPPx',
    description:
      'The versus purchase price used to identify the lot in situations where a custodial lot identifier is not available.The value should be calculated based on current cost basis / quantity held.',
  },
  {
    type: 'Amt',
    addedEP: '127',
    added: 'FIX.5.0SP2',
    name: 'LegCurrentCostBasis',
    id: 1759,
    abbrName: 'CurCostBasis',
    description:
      'The amount that the current shares are worth. If this lot was liquidated, the total gain/loss for a trade is equal to the trade amount minus the current cost basis.',
  },
  {
    type: 'RiskLimitRequestTypeCodeSet',
    addedEP: '128',
    added: 'FIX.5.0SP2',
    name: 'RiskLimitRequestType',
    id: 1760,
    abbrName: 'ReqTyp',
    description: 'Type of risk limit information.',
  },
  {
    type: 'RiskLimitRequestResultCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '128',
    added: 'FIX.5.0SP2',
    name: 'RiskLimitRequestResult',
    id: 1761,
    abbrName: 'ReqRslt',
    description: 'Result of risk limit definition request.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PartyDetailRequestStatusCodeSet',
    addedEP: '128',
    updatedEP: '146',
    added: 'FIX.5.0SP2',
    name: 'RiskLimitRequestStatus',
    id: 1762,
    abbrName: 'ReqStat',
    description: 'Status of risk limit definition request.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PartyDetailDefinitionStatusCodeSet',
    addedEP: '128',
    updatedEP: '146',
    added: 'FIX.5.0SP2',
    name: 'RiskLimitStatus',
    id: 1763,
    abbrName: 'Stat',
    description: 'Status of risk limit definition for one party.',
  },
  {
    type: 'RiskLimitRequestResultCodeSet',
    addedEP: '128',
    added: 'FIX.5.0SP2',
    name: 'RiskLimitResult',
    id: 1764,
    abbrName: 'Rslt',
    description: 'Result of risk limit definition for one party.',
  },
  {
    type: 'Percentage',
    addedEP: '128',
    added: 'FIX.5.0SP2',
    name: 'RiskLimitUtilizationPercent',
    id: 1765,
    abbrName: 'UtilztnPct',
    description: "Percentage of utilization of a party's set risk limit.",
  },
  {
    type: 'Amt',
    addedEP: '128',
    added: 'FIX.5.0SP2',
    name: 'RiskLimitUtilizationAmount',
    id: 1766,
    abbrName: 'UtilztnAmt',
    description: "Absolute amount of utilization of a party's set risk limit.",
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'RiskLimitActionCodeSet',
    addedEP: '128',
    updatedEP: '171',
    added: 'FIX.5.0SP2',
    name: 'RiskLimitAction',
    id: 1767,
    abbrName: 'Actn',
    description:
      'Identifies the action to take or risk model to assume should risk limit be exceeded or breached for the specified party.',
  },
  {
    type: 'int',
    addedEP: '128',
    added: 'FIX.5.0SP2',
    name: 'RiskWarningLevelAmount',
    id: 1768,
    abbrName: 'Amt',
    description: 'Amount at which a warning is issued.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'RiskLimitActionCodeSet',
    addedEP: '128',
    updatedEP: '171',
    added: 'FIX.5.0SP2',
    name: 'RiskWarningLevelAction',
    id: 1769,
    abbrName: 'Actn',
    description: 'Action to take should warning level be exceeded.',
  },
  {
    type: 'String',
    addedEP: '129',
    added: 'FIX.5.0SP2',
    name: 'EntitlementRequestID',
    id: 1770,
    abbrName: 'ReqID',
    description: 'Unique identifier for PartyEntitlementsRequest(35=CU).',
  },
  {
    type: 'String',
    addedEP: '129',
    added: 'FIX.5.0SP2',
    name: 'EntitlementReportID',
    id: 1771,
    abbrName: 'RptID',
    description: 'Identifier for the PartyEntitlementsReport(35=CV).',
  },
  {
    type: 'NumInGroup',
    addedEP: '129',
    added: 'FIX.5.0SP2',
    name: 'NoPartyEntitlements',
    id: 1772,
    description: 'Number of party entitlement values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '129',
    added: 'FIX.5.0SP2',
    name: 'NoEntitlements',
    id: 1773,
    description: 'Number of entitlement values.',
  },
  {
    type: 'Boolean',
    addedEP: '129',
    added: 'FIX.5.0SP2',
    name: 'EntitlementIndicator',
    id: 1774,
    abbrName: 'Ind',
    description:
      'Used to indicate if a party is entitled to an entitlement type specified in the EntitlementType(1775) field.',
  },
  {
    type: 'EntitlementTypeCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '129',
    added: 'FIX.5.0SP2',
    name: 'EntitlementType',
    id: 1775,
    abbrName: 'Typ',
    description: 'Type of entitlement.',
  },
  {
    type: 'String',
    addedEP: '129',
    added: 'FIX.5.0SP2',
    name: 'EntitlementID',
    id: 1776,
    abbrName: 'ID',
    description:
      'Unique identifier for a specific NoEntitlements(1773) repeating group instance.',
  },
  {
    updated: 'FIX.Latest',
    type: 'NumInGroup',
    addedEP: '129',
    updatedEP: '275',
    added: 'FIX.5.0SP2',
    name: 'NoEntitlementAttrib',
    id: 1777,
    description: 'Number of entitlement attributes.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved4000Plus',
    addedEP: '129',
    added: 'FIX.5.0SP2',
    name: 'EntitlementAttribType',
    id: 1778,
    abbrName: 'Typ',
    description:
      'Name of the entitlement attribute type. A code list of allowed values will be maintained on the FIX Protocol website.\n\nValues "4000" and above are reserved for bilaterally agreed upon user defined enumerations.',
  },
  {
    type: 'EntitlementAttribDatatypeCodeSet',
    addedEP: '129',
    added: 'FIX.5.0SP2',
    name: 'EntitlementAttribDatatype',
    id: 1779,
    abbrName: 'Datatyp',
    description: 'Datatype of the entitlement attribute.',
  },
  {
    type: 'String',
    addedEP: '129',
    added: 'FIX.5.0SP2',
    name: 'EntitlementAttribValue',
    id: 1780,
    abbrName: 'Value',
    description: 'Value of the entitlement attribute.',
  },
  {
    type: 'Currency',
    addedEP: '129',
    added: 'FIX.5.0SP2',
    name: 'EntitlementAttribCurrency',
    id: 1781,
    abbrName: 'Ccy',
    description:
      'Currency for EntitlementAttribValue(1780). Can be used if these fields represent a price, price offset, or amount.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '129',
    added: 'FIX.5.0SP2',
    name: 'EntitlementStartDate',
    id: 1782,
    abbrName: 'StartDt',
    description: 'Indicates the starting date of the entitlement.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'LocalMktDate',
    addedEP: '129',
    updatedEP: '204',
    added: 'FIX.5.0SP2',
    name: 'EntitlementEndDate',
    id: 1783,
    abbrName: 'EndDt',
    description: 'Indicates the ending date of the entitlement.',
  },
  {
    type: 'String',
    addedEP: '129',
    added: 'FIX.5.0SP2',
    name: 'EntitlementPlatform',
    id: 1784,
    abbrName: 'Pltfm',
    description:
      'The area to which the entitlement is applicable. This can be a trading platform or an offering.',
  },
  {
    type: 'TradSesControlCodeSet',
    addedEP: '130',
    added: 'FIX.5.0SP2',
    name: 'TradSesControl',
    id: 1785,
    abbrName: 'TrdgSesCtrl',
    description:
      'Indicates how control of trading session and subsession transitions are performed.',
  },
  {
    type: 'TradeVolTypeCodeSet',
    addedEP: '130',
    added: 'FIX.5.0SP2',
    name: 'TradeVolType',
    id: 1786,
    abbrName: 'TrdVolTyp',
    description:
      'Define the type of trade volume applicable for the MinTradeVol(562) and MaxTradeVol(1140)',
  },
  {
    type: 'int',
    addedEP: '130',
    added: 'FIX.5.0SP2',
    name: 'RefTickTableID',
    id: 1787,
    abbrName: 'RefTickTblID',
    description: 'Spread table code referred by the security or symbol.',
  },
  {
    type: 'String',
    addedEP: '131',
    added: 'FIX.5.0SP2',
    name: 'LegID',
    id: 1788,
    abbrName: 'LegID',
    description:
      'Unique identifier for the leg within the context of a message (the scope of uniqueness to be defined by counterparty agreement). The LegID(1788) can be referenced using LegRefID(654).',
  },
  {
    type: 'NumInGroup',
    addedEP: '131',
    added: 'FIX.5.0SP2',
    name: 'NoTargetMarketSegments',
    id: 1789,
    description: 'Number of market segments upon which a mass action is to be taken.',
  },
  {
    type: 'String',
    addedEP: '131',
    added: 'FIX.5.0SP2',
    name: 'TargetMarketSegmentID',
    id: 1790,
    abbrName: 'MktSegID',
    description: 'Market segment within a target market segment repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '131',
    added: 'FIX.5.0SP2',
    name: 'NoAffectedMarketSegments',
    id: 1791,
    description: 'Number of market segments affected by a mass action.',
  },
  {
    type: 'String',
    addedEP: '131',
    added: 'FIX.5.0SP2',
    name: 'AffectedMarketSegmentID',
    id: 1792,
    abbrName: 'MktSegID',
    description: 'Market segment within an affected market repeating segment group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '131',
    added: 'FIX.5.0SP2',
    name: 'NoNotAffectedMarketSegments',
    id: 1793,
    description: 'Number of market segments left unaffected by a mass action.',
  },
  {
    type: 'String',
    addedEP: '131',
    added: 'FIX.5.0SP2',
    name: 'NotAffectedMarketSegmentID',
    id: 1794,
    abbrName: 'MktSegID',
    description: 'Market segment within an unaffected market repeating segment group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '131',
    added: 'FIX.5.0SP2',
    name: 'NoOrderEvents',
    id: 1795,
    description: 'Number of order events.',
  },
  {
    type: 'OrderEventTypeCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '131',
    added: 'FIX.5.0SP2',
    name: 'OrderEventType',
    id: 1796,
    abbrName: 'Typ',
    description:
      'The type of event affecting an order. The last event type within the OrderEventGrp component indicates the ExecType(150) value resulting from the series of events (ExecType(150) values are shown in brackets).',
  },
  {
    type: 'String',
    addedEP: '131',
    added: 'FIX.5.0SP2',
    name: 'OrderEventExecID',
    id: 1797,
    abbrName: 'ID',
    description:
      'Refer to ExecID(17). Used when multiple different events are reported in single Execution Report. ExecID(17) and OrderEventExecID(1797) values should not overlap.',
  },
  {
    type: 'OrderEventReasonCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '131',
    added: 'FIX.5.0SP2',
    name: 'OrderEventReason',
    id: 1798,
    abbrName: 'Rsn',
    description: 'Action that caused the event to occur.',
  },
  {
    type: 'Price',
    addedEP: '131',
    added: 'FIX.5.0SP2',
    name: 'OrderEventPx',
    id: 1799,
    abbrName: 'Px',
    description: 'Price associated with the event.',
  },
  {
    type: 'Qty',
    addedEP: '131',
    added: 'FIX.5.0SP2',
    name: 'OrderEventQty',
    id: 1800,
    abbrName: 'Qty',
    description: 'Quantity associated with the event.',
  },
  {
    type: 'LastLiquidityIndCodeSet',
    addedEP: '131',
    added: 'FIX.5.0SP2',
    name: 'OrderEventLiquidityIndicator',
    id: 1801,
    abbrName: 'LqdtyInd',
    description:
      'Indicator to identify whether this fill was a result of a liquidity provider providing or liquidity taker taking the liquidity. Applicable only for OrderEventType(1796) values of 4(Partially Filled) or 5(Filled).',
  },
  {
    type: 'String',
    addedEP: '131',
    added: 'FIX.5.0SP2',
    name: 'OrderEventText',
    id: 1802,
    abbrName: 'Txt',
    description: 'Additional information about the event.',
  },
  {
    type: 'AuctionTypeCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '131',
    added: 'FIX.5.0SP2',
    name: 'AuctionType',
    id: 1803,
    abbrName: 'AuctTyp',
    description: 'Type of auction order.',
  },
  {
    type: 'Percentage',
    addedEP: '131',
    added: 'FIX.5.0SP2',
    name: 'AuctionAllocationPct',
    id: 1804,
    abbrName: 'AuctPct',
    description:
      'Percentage of matched quantity to be allocated to the submitter of the response to an auction order.',
  },
  {
    type: 'AuctionInstructionCodeSet',
    addedEP: '131',
    added: 'FIX.5.0SP2',
    name: 'AuctionInstruction',
    id: 1805,
    abbrName: 'AuctInst',
    description:
      'Instruction related to system generated auctions, e.g. flash order auctions.',
  },
  {
    type: 'String',
    addedEP: '131',
    added: 'FIX.5.0SP2',
    name: 'RefClOrdID',
    id: 1806,
    abbrName: 'RefClOrdID',
    description: 'Used to reference an order via ClOrdID(11).',
  },
  {
    type: 'LockTypeCodeSet',
    addedEP: '131',
    added: 'FIX.5.0SP2',
    name: 'LockType',
    id: 1807,
    abbrName: 'LckTyp',
    description: 'Indicates whether an order is locked and for what reason.',
  },
  {
    type: 'Qty',
    addedEP: '131',
    added: 'FIX.5.0SP2',
    name: 'LockedQty',
    id: 1808,
    abbrName: 'LckQty',
    description: 'Locked order quantity.',
  },
  {
    type: 'Qty',
    addedEP: '131',
    added: 'FIX.5.0SP2',
    name: 'SecondaryLockedQty',
    id: 1809,
    abbrName: 'LckQty2',
    description:
      'Locked order quantity in addition to LockedQty (1808), e.g. to distinguish total locked quantity from currently locked quantity.',
  },
  {
    type: 'ReleaseInstructionCodeSet',
    addedEP: '131',
    added: 'FIX.5.0SP2',
    name: 'ReleaseInstruction',
    id: 1810,
    abbrName: 'RlsInst',
    description:
      'Instruction to define conditions under which to release a locked order or parts of it.',
  },
  {
    type: 'Qty',
    addedEP: '131',
    added: 'FIX.5.0SP2',
    name: 'ReleaseQty',
    id: 1811,
    abbrName: 'RlsQty',
    description: 'Quantity to be made available, i.e. released from a lock.',
  },
  {
    type: 'NumInGroup',
    addedEP: '131',
    added: 'FIX.5.0SP2',
    name: 'NoDisclosureInstructions',
    id: 1812,
    description: 'Number of disclosure instructions.',
  },
  {
    type: 'DisclosureTypeCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '131',
    added: 'FIX.5.0SP2',
    name: 'DisclosureType',
    id: 1813,
    abbrName: 'Typ',
    description: 'Information subject to disclosure.',
  },
  {
    type: 'DisclosureInstructionCodeSet',
    addedEP: '131',
    added: 'FIX.5.0SP2',
    name: 'DisclosureInstruction',
    id: 1814,
    abbrName: 'Inst',
    description:
      'Instruction to disclose information or to use default value of the receiver.',
  },
  {
    type: 'TradingCapacityCodeSet',
    addedEP: '131',
    added: 'FIX.5.0SP2',
    name: 'TradingCapacity',
    id: 1815,
    abbrName: 'TrdgCpcty',
    description:
      'Designates the capacity in which the order is submitted for trading by the market participant.',
  },
  {
    type: 'ClearingAccountTypeCodeSet',
    addedEP: '131',
    added: 'FIX.5.0SP2',
    name: 'ClearingAccountType',
    id: 1816,
    abbrName: 'ClrAcctTyp',
    description:
      'Designates the account type to be used for the order when submitted to clearing.',
  },
  {
    type: 'ClearingAccountTypeCodeSet',
    addedEP: '131',
    added: 'FIX.5.0SP2',
    name: 'LegClearingAccountType',
    id: 1817,
    abbrName: 'ClrAcctTyp',
    description:
      'Designates the capacity in which the order will be submitted to clearing.',
  },
  {
    type: 'PartyDetailRoleQualifierCodeSet',
    addedEP: '131',
    added: 'FIX.5.0SP2',
    name: 'TargetPartyRoleQualifier',
    id: 1818,
    abbrName: 'Qual',
    description: 'Qualifies the value of TargetPartyRole (1464).',
  },
  {
    type: 'Price',
    addedEP: '131',
    added: 'FIX.5.0SP2',
    name: 'RelatedHighPrice',
    id: 1819,
    abbrName: 'ReltdHiPx',
    description:
      'Upper boundary for the price of a related entity, e.g. price of the underlying instrument in an Underlying Price Contingency (UPC) order.',
  },
  {
    type: 'Price',
    addedEP: '131',
    added: 'FIX.5.0SP2',
    name: 'RelatedLowPrice',
    id: 1820,
    abbrName: 'ReltdLowPx',
    description:
      'Lower boundary for the price of a related entity, e.g. price of the underlying instrument in an Underlying Price Contingency (UPC) order.',
  },
  {
    type: 'RelatedPriceSourceCodeSet',
    addedEP: '131',
    added: 'FIX.5.0SP2',
    name: 'RelatedPriceSource',
    id: 1821,
    abbrName: 'ReltdPxSrc',
    description:
      'Source for the price of a related entity, e.g. price of the underlying instrument in an Underlying Price Contingency (UPC) order. Can be used together with RelatedHighPrice (1819) and/or RelatedLowPrice (1820).',
  },
  {
    type: 'MinQtyMethodCodeSet',
    addedEP: '131',
    added: 'FIX.5.0SP2',
    name: 'MinQtyMethod',
    id: 1822,
    abbrName: 'MinQtyMeth',
    description:
      'Indicates how the minimum quantity should be applied when executing the order.',
  },
  {
    type: 'TriggeredCodeSet',
    addedEP: '131',
    added: 'FIX.5.0SP2',
    name: 'Triggered',
    id: 1823,
    abbrName: 'Trgrd',
    description:
      'Indicates whether order has been triggered during its lifetime. Applies to cases where original information, e.g. OrdType(40), is modified when the order is triggered.',
  },
  {
    type: 'String',
    addedEP: '131',
    added: 'FIX.5.0SP2',
    name: 'AffectedOrigClOrdID',
    id: 1824,
    abbrName: 'OrigClOrdID',
    description:
      'OrigClOrdID(41) of an order affected by a mass cancel or mass action request.',
  },
  {
    type: 'String',
    addedEP: '131',
    added: 'FIX.5.0SP2',
    name: 'NotAffSecondaryOrderID',
    id: 1825,
    abbrName: 'OrdID2',
    description:
      'SecondaryOrderID (198) of an order not affected by a mass cancel or mass action request.',
  },
  {
    type: 'NumInGroup',
    addedEP: '131',
    added: 'FIX.5.0SP2',
    name: 'NoCrossLegs',
    id: 1829,
    description: 'Number of legs in the side of a cross order.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '132',
    updatedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'EventTimePeriod',
    id: 1826,
    abbrName: 'TmPeriod',
    description: 'Time unit multiplier for the event.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'EventTimeUnitCodeSet',
    addedEP: '132',
    updatedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'EventTimeUnit',
    id: 1827,
    abbrName: 'TmUnit',
    description: 'Time unit associated with the event.',
  },
  {
    type: 'Qty',
    addedEP: '132',
    added: 'FIX.5.0SP2',
    name: 'LastQtyVariance',
    id: 1828,
    abbrName: 'LastQtyVarnc',
    description:
      'When LastQty is an estimated value, e.g. for a Repo “circled” trade, LastQtyVariance specifies the absolute amount that the size may vary up or down when finalized. Omitted when LastQty(32) is already final.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'OrderOriginationCodeSet',
    addedEP: '135',
    updatedEP: '222',
    added: 'FIX.5.0SP2',
    name: 'OrderOrigination',
    id: 1724,
    abbrName: 'OrdOrigntn',
    description: 'Identifies the origin of the order.',
  },
  {
    type: 'String',
    addedEP: '135',
    added: 'FIX.5.0SP2',
    name: 'OriginatingDeptID',
    id: 1725,
    abbrName: 'OrigntngDeptID',
    description:
      'An identifier representing the department or desk within the firm that originated the order.',
  },
  {
    type: 'String',
    addedEP: '135',
    added: 'FIX.5.0SP2',
    name: 'ReceivingDeptID',
    id: 1726,
    abbrName: 'RcvgDeptID',
    description:
      'An identifier representing the department or desk within the firm that received the order.',
  },
  {
    type: 'String',
    addedEP: '135',
    added: 'FIX.5.0SP2',
    name: 'InformationBarrierID',
    id: 1727,
    abbrName: 'InfoBrrID',
    description:
      'The identifier of the information barrier in place for a trading unit that will meet the criteria of the "no-knowledge" exception in FINRA Rule 5320.02.',
  },
  {
    type: 'Price',
    addedEP: '138',
    added: 'FIX.5.0SP2',
    name: 'SettlPriceIncrement',
    id: 1830,
    abbrName: 'SettlPxIncr',
    description: 'Settlement price increment for stated price range.',
  },
  {
    type: 'Price',
    addedEP: '138',
    added: 'FIX.5.0SP2',
    name: 'SettlPriceSecondaryIncrement',
    id: 1831,
    abbrName: 'SettlPxIncr2',
    description:
      'Secondary settlement price increment for stated price range. The meaning of secondary is left to bilateral agreement, e.g. it may refer to final settlement for a contract.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'ClearedIndicatorCodeSet',
    addedEP: '140',
    updatedEP: '196',
    added: 'FIX.5.0SP2',
    name: 'ClearedIndicator',
    id: 1832,
    abbrName: 'Clrd',
    description:
      'Indicates whether the trade or position being reported was cleared through a clearing organization.',
  },
  {
    type: 'ContractRefPosTypeCodeSet',
    addedEP: '140',
    added: 'FIX.5.0SP2',
    name: 'ContractRefPosType',
    id: 1833,
    abbrName: 'ConRefPosTyp',
    description:
      'Additional information related to the pricing of a commodity swaps position, specifically an indicator referring to the position type.',
  },
  {
    type: 'PositionCapacityCodeSet',
    addedEP: '140',
    added: 'FIX.5.0SP2',
    name: 'PositionCapacity',
    id: 1834,
    abbrName: 'PosCpcty',
    description: 'Used to describe the ownership of the position.',
  },
  {
    type: 'Currency',
    addedEP: '140',
    added: 'FIX.5.0SP2',
    name: 'PosQtyUnitOfMeasureCurrency',
    id: 1835,
    abbrName: 'UOMCcy',
    description:
      'Indicates the currency of the unit of measure if position quantity is expressed in valuation rather than contracts. Conditionally required when PosQtyUnitOfMeasure(1836)=Ccy.',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '140',
    added: 'FIX.5.0SP2',
    name: 'PosQtyUnitOfMeasure',
    id: 1836,
    abbrName: 'UOM',
    description:
      'Indicates the unit of measure of the position quantity when not expressed in contracts.',
  },
  {
    type: 'MonthYear',
    addedEP: '140',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingContractPriceRefMonth',
    id: 1837,
    abbrName: 'PxRefMo',
    description:
      'Reference month if there is no applicable UnderlyingMaturityMonth(313) value for the contract or security.',
  },
  {
    updated: 'FIX.Latest',
    type: 'NumInGroup',
    addedEP: '141',
    updatedEP: '275',
    added: 'FIX.5.0SP2',
    name: 'NoTradePriceConditions',
    id: 1838,
    description: 'Number of trade price conditions.',
  },
  {
    type: 'TradePriceConditionCodeSet',
    addedEP: '141',
    added: 'FIX.5.0SP2',
    name: 'TradePriceCondition',
    id: 1839,
    abbrName: 'TrdPxCond',
    description:
      'Price conditions in effect at the time of the trade. Multiple price conditions can be in effect at the same time. Price conditions are usually required to be reported in markets that have regulations on price execution at a market or national best bid or offer, and the trade price differs from the best bid or offer.',
  },
  {
    type: 'TradeAllocStatusCodeSet',
    addedEP: '141',
    added: 'FIX.5.0SP2',
    name: 'TradeAllocStatus',
    id: 1840,
    abbrName: 'Stat',
    description:
      'Identifies the status of an allocation when using a pre-clear workflow.\n\nNote: This is different from the give-up process where a trade is cleared and then given up and goes through the allocation flow.',
  },
  {
    updated: 'FIX.Latest',
    type: 'NumInGroup',
    addedEP: '141',
    updatedEP: '275',
    added: 'FIX.5.0SP2',
    name: 'NoTradeQtys',
    id: 1841,
    description: 'Number of trade quantities.',
  },
  {
    type: 'TradeQtyTypeCodeSet',
    addedEP: '141',
    added: 'FIX.5.0SP2',
    name: 'TradeQtyType',
    id: 1842,
    abbrName: 'Typ',
    description: 'Indicates the type of trade quantity in TradeQty(1843).',
  },
  {
    type: 'Qty',
    addedEP: '141',
    added: 'FIX.5.0SP2',
    name: 'TradeQty',
    id: 1843,
    abbrName: 'Qty',
    description: 'Trade quantity.',
  },
  {
    updated: 'FIX.Latest',
    type: 'NumInGroup',
    addedEP: '141',
    updatedEP: '275',
    added: 'FIX.5.0SP2',
    name: 'NoTradeAllocAmts',
    id: 1844,
    description: 'Number of trade allocation amount entries.',
  },
  {
    type: 'PosAmtTypeCodeSet',
    addedEP: '141',
    added: 'FIX.5.0SP2',
    name: 'TradeAllocAmtType',
    id: 1845,
    abbrName: 'Typ',
    description: 'Type of the amount associated with a trade allocation.',
  },
  {
    type: 'Amt',
    addedEP: '141',
    added: 'FIX.5.0SP2',
    name: 'TradeAllocAmt',
    id: 1846,
    abbrName: 'Amt',
    description: 'The amount associated with a trade allocation.',
  },
  {
    type: 'Currency',
    addedEP: '141',
    added: 'FIX.5.0SP2',
    name: 'TradeAllocCurrency',
    id: 1847,
    abbrName: 'Ccy',
    description: 'Currency denomination of the trade allocation amount.',
  },
  {
    type: 'TradeAllocGroupInstructionCodeSet',
    addedEP: '141',
    added: 'FIX.5.0SP2',
    name: 'TradeAllocGroupInstruction',
    id: 1848,
    abbrName: 'AllocGrpInst',
    description:
      'Instruction on how to add a trade to an allocation group when it is being given-up.',
  },
  {
    type: 'OffsetInstructionCodeSet',
    addedEP: '141',
    added: 'FIX.5.0SP2',
    name: 'OffsetInstruction',
    id: 1849,
    abbrName: 'OfstInst',
    description: 'Indicates the trade is a result of an offset or onset.',
  },
  {
    type: 'PosAmtReasonCodeSet',
    unionDataType: 'Reserved1000Plus',
    addedEP: '141',
    added: 'FIX.5.0SP2',
    name: 'TradeAllocAmtReason',
    id: 1850,
    abbrName: 'Rsn',
    description:
      'Specifies the reason for an amount type when reported on an allocation. Useful when multiple instances of the same amount type are reported.',
  },
  {
    type: 'String',
    addedEP: '141',
    added: 'FIX.5.0SP2',
    name: 'StrategyLinkID',
    id: 1851,
    abbrName: 'StrategyLinkID',
    description:
      'Identifies the multileg strategy (e.g. spread) to which the trade belongs. This links together trade legs executed as part of a strategy during a single match event.',
  },
  {
    type: 'Price',
    addedEP: '141',
    added: 'FIX.5.0SP2',
    name: 'SideAvgPx',
    id: 1852,
    abbrName: 'AvgPx',
    description: 'Calculated average price for this side of the trade.',
  },
  {
    updated: 'FIX.Latest',
    type: 'AvgPxIndicatorCodeSet',
    addedEP: '141',
    updatedEP: '282',
    added: 'FIX.5.0SP2',
    name: 'SideAvgPxIndicator',
    id: 1853,
    abbrName: 'AvgPxInd',
    description:
      'Used to indicate whether a trade or a sub-allocation should be allocated at the trade price (e.g. no average pricing), or whether it should be grouped with other trades/sub-allocations and allocated at the average price of the group.',
  },
  {
    type: 'String',
    addedEP: '141',
    added: 'FIX.5.0SP2',
    name: 'SideAvgPxGroupID',
    id: 1854,
    abbrName: 'AvgPxGrpID',
    description:
      'The identifier for the average price group for the trade side. See also AvgPxGroupID(1731).',
  },
  {
    updated: 'FIX.Latest',
    type: 'NumInGroup',
    addedEP: '142',
    updatedEP: '275',
    added: 'FIX.5.0SP2',
    name: 'NoRelatedTrades',
    id: 1855,
    description: 'Number of related trades.',
  },
  {
    type: 'String',
    addedEP: '142',
    added: 'FIX.5.0SP2',
    name: 'RelatedTradeID',
    id: 1856,
    abbrName: 'ID',
    discriminatorId: '1857',
    description: 'Identifier of a related trade.',
  },
  {
    type: 'RelatedTradeIDSourceCodeSet',
    addedEP: '142',
    added: 'FIX.5.0SP2',
    name: 'RelatedTradeIDSource',
    id: 1857,
    abbrName: 'Src',
    description:
      'Describes the source of the identifier that RelatedTradeID(1856) represents.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '142',
    added: 'FIX.5.0SP2',
    name: 'RelatedTradeDate',
    id: 1858,
    abbrName: 'Dt',
    description: 'Date of a related trade.',
  },
  {
    type: 'Exchange',
    addedEP: '142',
    added: 'FIX.5.0SP2',
    name: 'RelatedTradeMarketID',
    id: 1859,
    abbrName: 'MktID',
    description: 'Market of execution of related trade.',
  },
  {
    type: 'Qty',
    addedEP: '142',
    added: 'FIX.5.0SP2',
    name: 'RelatedTradeQuantity',
    id: 1860,
    abbrName: 'Qty',
    description:
      'Quantity of the related trade which can be less than or equal to the actual quantity of the related trade. For example, when one trade offsets another across asset classes.',
  },
  {
    updated: 'FIX.Latest',
    type: 'NumInGroup',
    addedEP: '142',
    updatedEP: '275',
    added: 'FIX.5.0SP2',
    name: 'NoRelatedPositions',
    id: 1861,
    description: 'Number of related positions.',
  },
  {
    type: 'String',
    addedEP: '142',
    added: 'FIX.5.0SP2',
    name: 'RelatedPositionID',
    id: 1862,
    abbrName: 'ID',
    discriminatorId: '1863',
    description: 'Identifier of a related position.',
  },
  {
    type: 'RelatedPositionIDSourceCodeSet',
    addedEP: '142',
    added: 'FIX.5.0SP2',
    name: 'RelatedPositionIDSource',
    id: 1863,
    abbrName: 'Src',
    description:
      'Describes the source of the identifier that RelatedPositionID(1862) represents.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '142',
    added: 'FIX.5.0SP2',
    name: 'RelatedPositionDate',
    id: 1864,
    abbrName: 'Dt',
    description:
      'Used to help identify the position when RelatedPositionID(1862) is not unique across multiple days. This date is generally the creation date of the identifier.',
  },
  {
    type: 'QuoteAckStatusCodeSet',
    addedEP: '143',
    added: 'FIX.5.0SP2',
    name: 'QuoteAckStatus',
    id: 1865,
    abbrName: 'QtAckStat',
    description:
      'Acknowledgement status of a Quote(35=S) or QuoteCancel(35=Z) message submission.',
  },
  {
    type: 'String',
    addedEP: '144',
    added: 'FIX.5.0SP2',
    name: 'OfferID',
    id: 1867,
    abbrName: 'OfrID',
    description:
      'Unique identifier for the ask side of the quote assigned by the quote issuer.',
  },
  {
    updated: 'FIX.Latest',
    type: 'NumInGroup',
    addedEP: '144',
    updatedEP: '275',
    added: 'FIX.5.0SP2',
    name: 'NoValueChecks',
    id: 1868,
    description: 'Number of value check entries.',
  },
  {
    type: 'ValueCheckTypeCodeSet',
    addedEP: '144',
    added: 'FIX.5.0SP2',
    name: 'ValueCheckType',
    id: 1869,
    abbrName: 'Typ',
    description: 'Type of value to be checked.',
  },
  {
    type: 'ValueCheckActionCodeSet',
    addedEP: '144',
    added: 'FIX.5.0SP2',
    name: 'ValueCheckAction',
    id: 1870,
    abbrName: 'Actn',
    description: 'Action to be taken for the ValueCheckType(1869).',
  },
  {
    type: 'Length',
    addedEP: '145',
    added: 'FIX.5.0SP2',
    name: 'LegSecurityXMLLen',
    id: 1871,
    description: 'The length of the LegSecurityXML(1872) data block.',
  },
  {
    updated: 'FIX.Latest',
    type: 'XMLData',
    addedEP: '145',
    updatedEP: '275',
    added: 'FIX.5.0SP2',
    name: 'LegSecurityXML',
    id: 1872,
    abbrName: 'SecXML',
    lengthId: '1871',
    description: 'XML definition for the leg security.',
  },
  {
    type: 'String',
    addedEP: '145',
    added: 'FIX.5.0SP2',
    name: 'LegSecurityXMLSchema',
    id: 1873,
    abbrName: 'Schema',
    description: 'The schema used to validate the contents of LegSecurityXML(1872).',
  },
  {
    type: 'Length',
    addedEP: '145',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingSecurityXMLLen',
    id: 1874,
    description: 'The length of the UnderlyingSecurityXML(1875) data block.',
  },
  {
    updated: 'FIX.Latest',
    type: 'XMLData',
    addedEP: '145',
    updatedEP: '275',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingSecurityXML',
    id: 1875,
    abbrName: 'SecXML',
    lengthId: '1874',
    description: 'XML definition for the underlying security.',
  },
  {
    type: 'String',
    addedEP: '145',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingSecurityXMLSchema',
    id: 1876,
    abbrName: 'Schema',
    description:
      'The schema used to validate the contents of UnderlyingSecurityXML(1875).',
  },
  {
    type: 'PartyDetailRequestResultCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '146',
    added: 'FIX.5.0SP2',
    name: 'PartyDetailRequestResult',
    id: 1877,
    abbrName: 'ReqRslt',
    description: 'Result party detail definition request.',
  },
  {
    type: 'PartyDetailRequestStatusCodeSet',
    addedEP: '146',
    added: 'FIX.5.0SP2',
    name: 'PartyDetailRequestStatus',
    id: 1878,
    abbrName: 'ReqStat',
    description: 'Status of party details definition request.',
  },
  {
    type: 'PartyDetailDefinitionStatusCodeSet',
    addedEP: '146',
    added: 'FIX.5.0SP2',
    name: 'PartyDetailDefinitionStatus',
    id: 1879,
    abbrName: 'Stat',
    description: 'Status of party detail definition for one party.',
  },
  {
    type: 'PartyDetailRequestResultCodeSet',
    addedEP: '146',
    added: 'FIX.5.0SP2',
    name: 'PartyDetailDefinitionResult',
    id: 1880,
    abbrName: 'Rslt',
    description: 'Result of party detail definition for one party.',
  },
  {
    type: 'EntitlementRequestResultCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '146',
    added: 'FIX.5.0SP2',
    name: 'EntitlementRequestResult',
    id: 1881,
    abbrName: 'ReqRslt',
    description: 'Result of risk limit definition request.',
  },
  {
    type: 'PartyDetailRequestStatusCodeSet',
    addedEP: '146',
    added: 'FIX.5.0SP2',
    name: 'EntitlementRequestStatus',
    id: 1882,
    abbrName: 'ReqStat',
    description: 'Status of party entitlements definition request.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'EntitlementStatusCodeSet',
    addedEP: '146',
    updatedEP: '173',
    added: 'FIX.5.0SP2',
    name: 'EntitlementStatus',
    id: 1883,
    abbrName: 'Stat',
    description: 'Status of entitlement definition for one party.',
  },
  {
    type: 'EntitlementRequestResultCodeSet',
    addedEP: '146',
    added: 'FIX.5.0SP2',
    name: 'EntitlementResult',
    id: 1884,
    abbrName: 'Rslt',
    description: 'Result of entitlement definition for one party.',
  },
  {
    type: 'String',
    addedEP: '146',
    added: 'FIX.5.0SP2',
    name: 'EntitlementRefID',
    id: 1885,
    abbrName: 'RefID',
    description:
      'Reference to an EntitlementID(1776). Used for modification or deletion of an entitlement.',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '147',
    added: 'FIX.5.0SP2',
    name: 'SettlPriceUnitOfMeasure',
    id: 1886,
    abbrName: 'SetPxUOM',
    description:
      'Used to express the unit of measure of the settlement price if different from the contract.',
  },
  {
    type: 'Currency',
    addedEP: '147',
    added: 'FIX.5.0SP2',
    name: 'SettlPriceUnitOfMeasureCurrency',
    id: 1887,
    abbrName: 'SetPxUOMCcy',
    description:
      'Indicates the currency of the settlement price unit of measure if expressed in another currency than the base currency.\n\nConditionally required when SettlPriceUnitOfMeasure(1886)=Ccy.',
  },
  {
    type: 'UTCTimestamp',
    addedEP: '150',
    added: 'FIX.5.0SP2',
    name: 'TradeMatchTimestamp',
    id: 1888,
    abbrName: 'MtchTS',
    description:
      'Timestamp of the match event. For off-exchange trades the time at which the deal was matched by the exchange.\n\nThis timestamp will be the same on all the trades and will not change when a trade is modified.',
  },
  {
    updated: 'FIX.Latest',
    type: 'NumInGroup',
    addedEP: '150',
    updatedEP: '275',
    added: 'FIX.5.0SP2',
    name: 'NoInstrmtMatchSides',
    id: 1889,
    description: 'Number of instrument match sides.',
  },
  {
    updated: 'FIX.Latest',
    type: 'NumInGroup',
    addedEP: '150',
    updatedEP: '275',
    added: 'FIX.5.0SP2',
    name: 'NoTrdMatchSides',
    id: 1890,
    description: 'Number of trade match sides.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    addedEP: '150',
    updatedEP: '215',
    added: 'FIX.5.0SP2',
    name: 'TrdMatchSubID',
    id: 1891,
    abbrName: 'MtchSubID',
    description:
      'Used to identify each price level, step or clip within a match event.\n\nThe identifier may represent a grouping of matched resting orders at a given price level that was matched by an aggressor order. For example, an aggressive order sweeping through 2 price levels that included 3 resting orders would have two different TrdMatchSubID(1891) values.',
  },
  {
    updated: 'FIX.Latest',
    type: 'NumInGroup',
    addedEP: '150',
    updatedEP: '275',
    added: 'FIX.5.0SP2',
    name: 'NoLegExecs',
    id: 1892,
    description: 'Number of instrument leg executions.',
  },
  {
    type: 'String',
    addedEP: '150',
    added: 'FIX.5.0SP2',
    name: 'LegExecID',
    id: 1893,
    abbrName: 'ExecID',
    description: 'The ExecID(17) value corresponding to a trade leg.',
  },
  {
    type: 'String',
    addedEP: '150',
    added: 'FIX.5.0SP2',
    name: 'LegTradeID',
    id: 1894,
    abbrName: 'TrdID',
    description: 'The TradeID(1003) value corresponding to a trade leg.',
  },
  {
    type: 'String',
    addedEP: '150',
    added: 'FIX.5.0SP2',
    name: 'LegTradeReportID',
    id: 1895,
    abbrName: 'RptID',
    description: 'The TradeReportID(571) value corresponding to a trade leg.',
  },
  {
    type: 'TradeMatchAckStatusCodeSet',
    addedEP: '150',
    added: 'FIX.5.0SP2',
    name: 'TradeMatchAckStatus',
    id: 1896,
    abbrName: 'MtchAckStat',
    description: 'Used to indicate the status of the trade match report submission.',
  },
  {
    type: 'TradeMatchRejectReasonCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '150',
    added: 'FIX.5.0SP2',
    name: 'TradeMatchRejectReason',
    id: 1897,
    abbrName: 'RejRsn',
    description: 'Reason the trade match report submission was rejected.',
  },
  {
    type: 'String',
    addedEP: '150',
    added: 'FIX.5.0SP2',
    name: 'SideMarketSegmentID',
    id: 1898,
    abbrName: 'MktSegID',
    description: 'Identifies the market segment of the side.',
  },
  {
    type: 'VenueTypeCodeSet',
    addedEP: '150',
    added: 'FIX.5.0SP2',
    name: 'SideVenueType',
    id: 1899,
    abbrName: 'VenuTyp',
    description:
      'Identifies the type of venue where the trade was executed for the side.',
  },
  {
    type: 'String',
    addedEP: '150',
    added: 'FIX.5.0SP2',
    name: 'SideExecRefID',
    id: 1900,
    abbrName: 'ExecRefID',
    description: 'Used to reference the value from SideExecID(1427).',
  },
  {
    type: 'String',
    addedEP: '150',
    added: 'FIX.5.0SP2',
    name: 'LegExecRefID',
    id: 1901,
    abbrName: 'ExecRefID',
    description: 'Used to reference the value from LegExecID(1893).',
  },
  {
    type: 'Boolean',
    addedEP: '157',
    added: 'FIX.5.0SP2',
    name: 'HaircutIndicator',
    id: 1902,
    abbrName: 'HrctInd',
    description:
      'Indicates, if "Y", that a stated valuation includes a haircut, e.g. that the stated value reflects the subtraction of the haircut. Note that a value of "N" does not imply a haircut is not applicable, only that the haircut (if any) is not reflected in the stated valuation.',
  },
  {
    type: 'int',
    addedEP: '159',
    added: 'FIX.5.0SP2',
    name: 'NumOfCompetitors',
    id: 1913,
    abbrName: 'NumCmptors',
    description:
      'The number of competing Respondents (e.g. dealers) to receive a quote request (either via the QuoteRequest(35=R) or via other means).',
  },
  {
    type: 'UTCTimestamp',
    addedEP: '159',
    added: 'FIX.5.0SP2',
    name: 'ResponseTime',
    id: 1914,
    abbrName: 'RspTm',
    description:
      'The time by which a meaningful response should arrive back (always expressed in UTC (Universal Time Coordinated, also known as "GMT").\n\nThe meaning of the response time is specific to the context where the field is used.\n\nFor a QuoteRequest(35=R) message, this is the time by which the Quote(35=S) message should arrive to the initiator of the QuoteRequest(35=R) message.',
  },
  {
    type: 'UTCTimestamp',
    addedEP: '159',
    added: 'FIX.5.0SP2',
    name: 'QuoteDisplayTime',
    id: 1915,
    abbrName: 'QuotDsplyTm',
    description:
      'Time by which the quote will be displayed.\n\nFor example, the time the execution venue will display dealer(s) submitted quotes to market participant(s).',
  },
  {
    type: 'OrderDelayUnitCodeSet',
    addedEP: '159',
    added: 'FIX.5.0SP2',
    name: 'ExposureDurationUnit',
    id: 1916,
    abbrName: 'ExpsreDurUnit',
    description: 'Time unit in which the ExposureDuration(1629) is expressed.',
  },
  {
    type: 'Price',
    addedEP: '159',
    added: 'FIX.5.0SP2',
    name: 'CoverPrice',
    id: 1917,
    abbrName: 'CoverPx',
    description: 'The best quoted price received among those not traded.',
  },
  {
    type: 'NumInGroup',
    addedEP: '160',
    added: 'FIX.5.0SP2',
    name: 'NoClearingAccountTypes',
    id: 1918,
    description: 'Number of clearing account type entries.',
  },
  {
    type: 'NumInGroup',
    addedEP: '160',
    added: 'FIX.5.0SP2',
    name: 'NoPriceMovements',
    id: 1919,
    description: 'Number of price movement entries.',
  },
  {
    type: 'NumInGroup',
    addedEP: '160',
    added: 'FIX.5.0SP2',
    name: 'NoPriceMovementValues',
    id: 1920,
    description: 'Number of price movement value entries.',
  },
  {
    type: 'float',
    addedEP: '160',
    added: 'FIX.5.0SP2',
    name: 'PriceMovementValue',
    id: 1921,
    abbrName: 'Valu',
    description: 'Value at specific price movement point.',
  },
  {
    type: 'int',
    addedEP: '160',
    added: 'FIX.5.0SP2',
    name: 'PriceMovementPoint',
    id: 1922,
    abbrName: 'Pnt',
    description:
      'Price movement point up (positive integer) or down (negative integer) relative to the underlying price of the instrument.',
  },
  {
    type: 'PriceMovementTypeCodeSet',
    addedEP: '160',
    added: 'FIX.5.0SP2',
    name: 'PriceMovementType',
    id: 1923,
    abbrName: 'Typ',
    description: 'Describes the format of the PriceMovementValue(1921).',
  },
  {
    type: 'Length',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'EncodedEventTextLen',
    id: 1578,
    abbrName: 'EncTxtLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedEventText(868) fied.',
  },
  {
    type: 'data',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'EncodedEventText',
    id: 1579,
    abbrName: 'EncTxt',
    lengthId: '1578',
    description:
      'Encoded (non-ASCII characters) representation of the EventText(868) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the EventText(868) field.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'RegulatoryTradeID',
    id: 1903,
    abbrName: 'ID',
    discriminatorId: '1905',
    description:
      'Trade identifier required by government regulators or other regulatory organizations for regulatory reporting purposes. For example, unique swap identifer (USI) as required by the U.S. Commodity Futures Trading Commission.',
  },
  {
    type: 'RegulatoryTradeIDEventCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'RegulatoryTradeIDEvent',
    id: 1904,
    abbrName: 'Evnt',
    description:
      'Identifies the event which caused origination of the identifier in RegulatoryTradeID(1903). When more than one event is the cause, use the higher enumeration value. For example, if the identifier is originated due to an allocated trade which was cleared and reported, use the enumeration value 2 (Clearing).',
  },
  {
    updated: 'FIX.Latest',
    type: 'RegulatoryTradeIDSourceCodeSet',
    addedEP: '161',
    updatedEP: '275',
    added: 'FIX.5.0SP2',
    name: 'RegulatoryTradeIDSource',
    id: 1905,
    abbrName: 'Src',
    description:
      'Identifies the reporting entity that originated the value in RegulatoryTradeID(1903). The reporting entity identifier may be assigned by a regulator or from a supported standard identifier source scheme.\n\nIn the context of CFTC usage for Unique Swap Identifier (USI), this field is required to convey the namespace of the entity creating the USI, in accordance to the USI Data Standard (https://www.cftc.gov/sites/default/files/idc/groups/public/@swaps/documents/dfsubmission/usidatastandards100112.pdf). For standardized identifier source schemes, such as the Unique Transaction Identifier (UTI), the source scheme is identified using supported code values.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'RegulatoryTradeIDTypeCodeSet',
    addedEP: '161',
    updatedEP: '222',
    added: 'FIX.5.0SP2',
    name: 'RegulatoryTradeIDType',
    id: 1906,
    abbrName: 'Typ',
    description:
      'Specifies the type of trade identifier provided in RegulatoryTradeID(1903).\n\nContextual hierarchy of events for the same trade or transaction maybe captured through use of the different RegulatoryTradeIDType(1906) values using multiple instances of the repeating group as needed for regulatory reporting.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoRegulatoryTradeIDs',
    id: 1907,
    description: 'Number of regulatory IDs in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoAllocRegulatoryTradeIDs',
    id: 1908,
    description: 'Number of regulatory IDs in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'AllocRegulatoryTradeID',
    id: 1909,
    abbrName: 'ID',
    discriminatorId: '1910',
    description:
      'Trade identifier required by government regulators or other regulatory organizations for regulatory reporting purposes. For example, unique swap identifer (USI) as required by the U.S. Commodity Futures Trading Commission.',
  },
  {
    updated: 'FIX.Latest',
    type: 'RegulatoryTradeIDSourceCodeSet',
    addedEP: '161',
    updatedEP: '275',
    added: 'FIX.5.0SP2',
    name: 'AllocRegulatoryTradeIDSource',
    id: 1910,
    abbrName: 'Src',
    description:
      'Identifies the reporting entity that originated the value in RegulatoryTradeID(1903). The reporting entity identifier may be assigned by a regulator or from a supported standard identifier source scheme.\n\nIn the context of CFTC usage for Unique Swap Identifier (USI), this field is required to convey the namespace of the entity creating the USI, in accordance to the USI Data Standard (https://www.cftc.gov/sites/default/files/idc/groups/public/@swaps/documents/dfsubmission/usidatastandards100112.pdf). For standardized identifier source schemes, such as the Unique Transaction Identifier (UTI), the source scheme is identified using supported code values.',
  },
  {
    type: 'RegulatoryTradeIDEventCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'AllocRegulatoryTradeIDEvent',
    id: 1911,
    abbrName: 'Evnt',
    description:
      'Identifies the event which caused the origination of the identifier in AllocRegulatoryTradeID(1909). When more than one event is the cause, use the higher enumeration value. For example, if the identifier is originated due to an allocated trade which was cleared and reported, use the enumeration value 2(Clearing).',
  },
  {
    type: 'RegulatoryTradeIDTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'AllocRegulatoryTradeIDType',
    id: 1912,
    abbrName: 'Typ',
    description:
      'Specifies the type of trade identifier provided in AllocRegulatoryTradeID(1909), within the context of the hierarchy of trade events.',
  },
  {
    type: 'ClearingIntentionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ClearingIntention',
    id: 1924,
    abbrName: 'ClrIntn',
    description: "Specifies the party's or parties' intention to clear the trade.",
  },
  {
    type: 'ClearingInstructionCodeSet',
    unionDataType: 'Reserved4000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'TradeClearingInstruction',
    id: 1925,
    abbrName: 'ClrngInstrctn',
    description:
      'Specifies the eligibility of this trade for clearing and central counterparty processing.',
  },
  {
    type: 'Boolean',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'BackloadedTradeIndicator',
    id: 1926,
    abbrName: 'BackTrdInd',
    description:
      'Indicates that the trade being reported occurred in the past and is still in effect or active.',
  },
  {
    type: 'ConfirmationMethodCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ConfirmationMethod',
    id: 1927,
    abbrName: 'CnfmMeth',
    description: 'Specifies how a trade was confirmed.',
  },
  {
    type: 'Boolean',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'MandatoryClearingIndicator',
    id: 1928,
    abbrName: 'MandClrInd',
    description: 'An indication that the trade is flagged for mandatory clearing.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'Boolean',
    addedEP: '161',
    updatedEP: '193',
    added: 'FIX.5.0SP2',
    name: 'MixedSwapIndicator',
    id: 1929,
    abbrName: 'MixedSwapInd',
    description:
      'An indication that the trade is a mixed swap.\n\nIn the context of CFTC , a "Mixed swap" is defined in the Commodity Exchange Act (CEA) section 1a(47)(D) as an instrument that is in part a swap subject to the jurisdiction of the CFTC, and in part a security-based swap subject to the jurisdiction of the SEC. When reporting the additional Swap Data Repositories must be identified in the appropriate Parties component with PartyRole(452) = 102 (Data repository), PartyRoleQualifier(2376) = 12 (Additional domestic trade repository) and PartySub-IDType(803) = 70 (Location or jurisdiction).',
  },
  {
    type: 'Boolean',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'OffMarketPriceIndicator',
    id: 1930,
    abbrName: 'OffMktPxInd',
    description: 'An indication that the price is off-market.',
  },
  {
    type: 'VerificationMethodCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'VerificationMethod',
    id: 1931,
    abbrName: 'VerfctnMeth',
    description: 'Indication of how a trade was verified.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'ClearingRequirementExceptionCodeSet',
    addedEP: '161',
    updatedEP: '177',
    added: 'FIX.5.0SP2',
    name: 'ClearingRequirementException',
    id: 1932,
    abbrName: 'ClrReqmtExcptn',
    description:
      "Specifies whether a party to a swap is using an exception to a clearing requirement. In the US, one such clearing requirement is CFTC's rule pursuant to CEA Section 2(h)(1).",
  },
  {
    type: 'IRSDirectionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'IRSDirection',
    id: 1933,
    abbrName: 'IRSDirctn',
    description:
      'Used to specify whether the principal is paying or receiving the fixed rate in an interest rate swap.',
  },
  {
    type: 'RegulatoryReportTypeCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'RegulatoryReportType',
    id: 1934,
    abbrName: 'RegRptTyp',
    description: 'Type of regulatory report.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'Boolean',
    addedEP: '161',
    updatedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'VoluntaryRegulatoryReport',
    id: 1935,
    abbrName: 'VolntyRegRpt',
    description:
      'Used in conjunction with RegulatoryReportType(1934) to indicate whether the trade report is a voluntary regulatory report. If not specified, the default for a regulatory report is "N".\n\nWhen VoluntaryRegulatoryReport(1935)=Y it is recommended that one of the parties to the trade be identified as the voluntary reporting party through PartySubIDType(803) = 63 (Voluntary reporting entity).',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'TradeCollateralizationCodeSet',
    addedEP: '161',
    updatedEP: '254',
    added: 'FIX.5.0SP2',
    name: 'TradeCollateralization',
    id: 1936,
    abbrName: 'TrdCollztn',
    description:
      'Specifies how the trade is collateralized.\n\nIn the context of Dodd-Frank, all values shown except for 4 (Net exposure) apply.\n\nIn the context of ESMA EU SFTR reporting only the values 1 (Uncollateralized), 3 (Fully collateralized) and 4 (Net exposure) apply.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'TradeContinuationCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '161',
    updatedEP: '179',
    added: 'FIX.5.0SP2',
    name: 'TradeContinuation',
    id: 1937,
    abbrName: 'TrdContntn',
    description:
      'Specifies the post-execution trade continuation or lifecycle event. Additional values may be used by mutual agreement of the counterparties.',
  },
  {
    type: 'AssetClassCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'AssetClass',
    id: 1938,
    abbrName: 'AssetClss',
    description: 'The broad asset category for assessing risk exposure.',
  },
  {
    type: 'AssetSubClassCodeSet',
    unionDataType: 'Reserved4000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'AssetSubClass',
    id: 1939,
    abbrName: 'AssetSubClss',
    description: 'The subcategory description of the asset class.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    addedEP: '161',
    updatedEP: '235',
    added: 'FIX.5.0SP2',
    name: 'AssetType',
    id: 1940,
    abbrName: 'AssetTyp',
    description:
      "Used to provide more specific description of the asset specified in AssetSubClass(1939).\n\nSee https://www.fixtrading.org/codelists/AssetType for code list of applicable values. ISO 4721 Currency Code values are to be used when specific currency as an asset type is to be expressed.\n\nOther values may be used by mutual agreement of the counterparties.\n\nIn the context of MiFID II's this may indicate the value needed in ESMA RTS 2 Annex IV Table 2 Field 16, or ESMA RTS 23 Annex I Table 2 'Sub product' field.",
  },
  {
    type: 'SwapClassCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'SwapClass',
    id: 1941,
    abbrName: 'SwapClss',
    description:
      'The classification or type of swap. Additional values may be used by mutual agreement of the counterparties.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NthToDefault',
    id: 1942,
    abbrName: 'NthDflt',
    description:
      'The Nth reference obligation to default in a CDS reference basket. If specified without MthToDefault(1943) the default will trigger a CDS payout. If MthToDefault(1943) is also present then payout occurs between the Nth and Mth obligations to default.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'MthToDefault',
    id: 1943,
    abbrName: 'MthDflt',
    description:
      'The Mth reference obligation to default in a CDS reference basket. When NthToDefault(1942) and MthToDefault(1943) are represented then the CDS payout occurs between the Nth and Mth obligations to default.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'SettledEntityMatrixSource',
    id: 1944,
    abbrName: 'SettldMtrxSrc',
    description: 'Relevant settled entity matrix source.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'SettledEntityMatrixPublicationDate',
    id: 1945,
    abbrName: 'SettldMtrxDt',
    description:
      'The publication date of the applicable version of the matrix. If not specified, the Standard Terms Supplement defines rules for which version of the matrix is applicable.',
  },
  {
    type: 'CouponTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'CouponType',
    id: 1946,
    abbrName: 'CpnTyp',
    description: 'Coupon type of the bond.',
  },
  {
    type: 'Amt',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'TotalIssuedAmount',
    id: 1947,
    abbrName: 'TotIssuedAmt',
    description:
      'Specifies the total amount of the issue. Corresponds to the par value multiplied by the number of issued securities.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'CouponFrequencyPeriod',
    id: 1948,
    abbrName: 'CpnPeriod',
    description: "Time unit multiplier for the frequency of the bond's coupon payment.",
  },
  {
    type: 'CouponFrequencyUnitCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'CouponFrequencyUnit',
    id: 1949,
    abbrName: 'CpnUnit',
    description: "Time unit associated with the frequency of the bond's coupon payment.",
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'CouponDayCountCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '161',
    updatedEP: '200',
    added: 'FIX.5.0SP2',
    name: 'CouponDayCount',
    id: 1950,
    abbrName: 'CpnDayCnt',
    description:
      'The day count convention used in interest calculations for a bond or an interest bearing security. Absence of this field for a bond or an interest bearing security transaction implies a "flat" trade, i.e. no accrued interest determined at time of the transaction.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ConvertibleBondEquityID',
    id: 1951,
    abbrName: 'CnvrtBondEqtyID',
    discriminatorId: '1952',
    description: 'Identifies the equity in which a convertible bond can be converted to.',
  },
  {
    type: 'SecurityIDSourceCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ConvertibleBondEquityIDSource',
    id: 1952,
    abbrName: 'CnvrtBondEqtyIDSrc',
    description:
      'Identifies class or source of the ConvertibleBondEquityID(1951) value.\n\n100+ are reserved for private security.',
  },
  {
    type: 'MonthYear',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ContractPriceRefMonth',
    id: 1953,
    abbrName: 'PxRefMo',
    description:
      'Reference month if there is no applicable MaturityMonthYear(200) value for the contract or security.',
  },
  {
    type: 'LienSeniorityCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LienSeniority',
    id: 1954,
    abbrName: 'LienSnrty',
    description: 'Indicates the seniority level of the lien in a loan.',
  },
  {
    type: 'LoanFacilityCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LoanFacility',
    id: 1955,
    abbrName: 'LoanFclty',
    description:
      "Specifies the type of loan when the credit default swap's reference obligation is a loan.",
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'ReferenceEntityTypeCodeSet',
    addedEP: '161',
    updatedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'ReferenceEntityType',
    id: 1956,
    abbrName: 'RefEntityTyp',
    description:
      'Specifies the type of reference entity for first-to-default CDS basket contracts.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'IndexSeries',
    id: 1957,
    abbrName: 'NdxSeries',
    description: 'The series identifier of a credit default swap index.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'IndexAnnexVersion',
    id: 1958,
    abbrName: 'NdxAnxVer',
    description: 'The version of a credit default swap index annex.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'IndexAnnexDate',
    id: 1959,
    abbrName: 'NdxAnxDt',
    description: 'The date of a credit default swap index series annex.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'IndexAnnexSource',
    id: 1960,
    abbrName: 'NdxAnxSrc',
    description: 'The source of a credit default swap series annex.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'AgreementVersion',
    id: 1961,
    abbrName: 'AgmtVer',
    description: 'The version of the master agreement',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'MasterConfirmationDesc',
    id: 1962,
    abbrName: 'CnfmDesc',
    description:
      'The type of master confirmation executed between the parties.\n\nSee http://www.fpml.org/coding-scheme/master-confirmation-type for values.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'MasterConfirmationDate',
    id: 1963,
    abbrName: 'CnfmDt',
    description:
      'Alternative to broker confirmation. The date of the confirmation executed between the parties and intended to govern all relevant transactions between those parties.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'MasterConfirmationAnnexDesc',
    id: 1964,
    abbrName: 'CnfmAnxDesc',
    description:
      'The type of master confirmation annex executed between the parties.\n\nSee http://www.fpml.org/coding-scheme/master-confirmation-annex-type for values.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'MasterConfirmationAnnexDate',
    id: 1965,
    abbrName: 'CnfmAnxDt',
    description:
      'The date that an annex to the master confirmation was executed between the parties.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'BrokerConfirmationDesc',
    id: 1966,
    abbrName: 'BrkrCnfmDesc',
    description:
      'Describes the type of broker confirmation executed between the parites. Can be used as an alterative to MasterConfirmationDesc(1962). See http://www.fpml.org/coding-scheme/broker-confirmation-type for values.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'CreditSupportAgreementDesc',
    id: 1967,
    abbrName: 'CrdSuprtDesc',
    description:
      'The type of ISDA Credit Support Agreement. See http://www.fpml.org/coding-scheme/credit-support-agreement-type for values.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'CreditSupportAgreementDate',
    id: 1968,
    abbrName: 'CrdSuprtDt',
    description:
      'The date of the ISDA Credit Support Agreement executed between the parties and intended to govern collateral arrangements for all OTC derivatives transactions between those parties.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'CreditSupportAgreementID',
    id: 1969,
    abbrName: 'CrdSuprtID',
    description:
      'A common reference or unique identifier to identify the ISDA Credit Support Agreement executed between the parties.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'GoverningLaw',
    id: 1970,
    abbrName: 'Law',
    description:
      'Identification of the law governing the transaction. See http://www.fpml.org/coding-scheme/governing-law for values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoSideRegulatoryTradeIDs',
    id: 1971,
    description: 'Number of regulatory IDs in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'SideRegulatoryTradeID',
    id: 1972,
    abbrName: 'ID',
    discriminatorId: '1973',
    description:
      'Trade identifier required by government regulators or other regulatory organziations for regulatory reporting purposes. For example, unique swap identifier (USI) as required by the U.S. Commodity Futures Trading Commission.',
  },
  {
    updated: 'FIX.Latest',
    type: 'RegulatoryTradeIDSourceCodeSet',
    addedEP: '161',
    updatedEP: '275',
    added: 'FIX.5.0SP2',
    name: 'SideRegulatoryTradeIDSource',
    id: 1973,
    abbrName: 'Src',
    description:
      'Identifies the reporting entity that originated the value in RegulatoryTradeID(1903). The reporting entity identifier may be assigned by a regulator or from a supported standard identifier source scheme.\n\nIn the context of CFTC usage for Unique Swap Identifier (USI), this field is required to convey the namespace of the entity creating the USI, in accordance to the USI Data Standard (https://www.cftc.gov/sites/default/files/idc/groups/public/@swaps/documents/dfsubmission/usidatastandards100112.pdf). For standardized identifier source schemes, such as the Unique Transaction Identifier (UTI), the source scheme is identified using supported code values.',
  },
  {
    type: 'RegulatoryTradeIDEventCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'SideRegulatoryTradeIDEvent',
    id: 1974,
    abbrName: 'Evnt',
    description:
      'Identifies the event which caused origination of the identifier in SideRegulatoryTradeID(1972). When more than one event is the cause, use the higher enumeration value. For example, if the identifier is originated due to an allocated trade which was cleared and reported, use the enumeration value 2 (Clearing).',
  },
  {
    type: 'RegulatoryTradeIDTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'SideRegulatoryTradeIDType',
    id: 1975,
    abbrName: 'Typ',
    description:
      'Specifies the type of trade identifier provided in SideRegulatoryTradeID(1972), within the context of the hierarchy of trade events.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoSecondaryAssetClasses',
    id: 1976,
    description: 'Number of secondary asset classes in the repeating group.',
  },
  {
    type: 'AssetClassCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'SecondaryAssetClass',
    id: 1977,
    abbrName: 'Clss',
    description:
      'The broad asset category for assessing risk exposure for a multi-asset trade.',
  },
  {
    type: 'AssetSubClassCodeSet',
    unionDataType: 'Reserved4000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'SecondaryAssetSubClass',
    id: 1978,
    abbrName: 'SubClss',
    description: 'An indication of the general description of the asset class.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    addedEP: '161',
    updatedEP: '235',
    added: 'FIX.5.0SP2',
    name: 'SecondaryAssetType',
    id: 1979,
    abbrName: 'Typ',
    description:
      "Used to provide more specific description of the asset specified in SecondaryAssetSubClass(1978).\n\nSee https://www.fixtrading.org/codelists/AssetType for code list of applicable values. ISO 4721 Currency Code values are to be used when specific currency as an asset type is to be expressed.\n\nOther values may be used by mutual agreement of the counterparties.\n\nIn the context of MiFID II's this may indicate the value needed in ESMA RTS 2 Annex IV Table 2 Field 16, or ESMA RTS 23 Annex I Table 2 'Sub product' field.",
  },
  {
    type: 'BlockTrdAllocIndicatorCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'BlockTrdAllocIndicator',
    id: 1980,
    abbrName: 'BlckTrdAllocInd',
    description: 'Indication that a block trade will be allocated.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingEvents',
    id: 1981,
    description: 'Number of events in the repeating group.',
  },
  {
    type: 'EventTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingEventType',
    id: 1982,
    abbrName: 'Typ',
    description: 'Code to represent the type of event.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingEventDate',
    id: 1983,
    abbrName: 'Dt',
    description: 'The date of the event.',
  },
  {
    type: 'UTCTimestamp',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingEventTime',
    id: 1984,
    abbrName: 'Tm',
    description:
      'The time of the event. To be used in combination with UnderlyingEventDate(1983).',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingEventTimeUnit',
    id: 1985,
    abbrName: 'TmUnit',
    description: 'Time unit associated with the event.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingEventTimePeriod',
    id: 1986,
    abbrName: 'TmPeriod',
    description: 'Time unit multiplier for the event.',
  },
  {
    type: 'Price',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingEventPx',
    id: 1987,
    abbrName: 'Px',
    description: 'Predetermined price of issue at event, if applicable.',
  },
  {
    type: 'float',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingConstituentWeight',
    id: 1988,
    abbrName: 'ConstuentWt',
    description:
      'For a basket, or pool, describes the weight of each of the constituents within the basket. If not provided, it is assumed to be equal weighted.',
  },
  {
    type: 'CouponTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingCouponType',
    id: 1989,
    abbrName: 'CpnTyp',
    description: 'Specifies the coupon type of the underlying bond.',
  },
  {
    type: 'Amt',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingTotalIssuedAmount',
    id: 1990,
    abbrName: 'TotIssuedAmt',
    description:
      'Specifies the total amount of the issue. Corresponds to the par value multiplied by the number of issued security.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingCouponFrequencyPeriod',
    id: 1991,
    abbrName: 'CpnPeriod',
    description: "Time unit multiplier for the frequency of the bond's coupon payment.",
  },
  {
    type: 'CouponFrequencyUnitCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingCouponFrequencyUnit',
    id: 1992,
    abbrName: 'CpnUnit',
    description: "Time unit associated with the frequency of the bond's coupon payment.",
  },
  {
    type: 'CouponDayCountCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingCouponDayCount',
    id: 1993,
    abbrName: 'CpnDayCnt',
    description:
      'The day count convention used in interest calculations for a bond or an interest bearing security.',
  },
  {
    updated: 'FIX.Latest',
    type: 'String',
    addedEP: '161',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingObligationID',
    id: 1994,
    abbrName: 'ObligID',
    discriminatorId: '1995',
    description:
      'For a CDS basket or pool identifies the reference obligation.\n\nUnderlyingObligationID(1994) is reserved for the reference entity for baskets or pools. In a CDS single name the reference entity is identified in instrument ID and the obligations are identified in UnderlyingObligationID(1994).',
  },
  {
    type: 'SecurityIDSourceCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingObligationIDSource',
    id: 1995,
    abbrName: 'ObligIDSrc',
    description: 'Identifies the source scheme of the UnderlyingObligationID(1994).',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingEquityID',
    id: 1996,
    abbrName: 'EqtyID',
    discriminatorId: '1997',
    description: 'Specifies the equity in which a convertible bond can be converted.',
  },
  {
    type: 'SecurityIDSourceCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingEquityIDSource',
    id: 1997,
    abbrName: 'EqtyIDSrc',
    description: 'Identifies the source of the UnderlyingEquityID(1996).',
  },
  {
    type: 'LienSeniorityCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingLienSeniority',
    id: 1998,
    abbrName: 'LienSnrty',
    description: 'Indicates the seniority level of the lien in a loan.',
  },
  {
    type: 'LoanFacilityCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingLoanFacility',
    id: 1999,
    abbrName: 'LoanFclty',
    description:
      "Specifies the type of loan when the credit default swap's reference obligation is a loan.",
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'ReferenceEntityTypeCodeSet',
    addedEP: '161',
    updatedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReferenceEntityType',
    id: 2000,
    abbrName: 'RefEntityTyp',
    description:
      'Specifies the type of reference entity for first-to-default CDS basket contracts.',
  },
  {
    type: 'XIDREF',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProtectionTermXIDRef',
    id: 41314,
    abbrName: 'ProtctnXIDRef',
    description:
      'Reference to the protection terms applicable to this entity or obligation. Contains the same XID named string value of the instance in the ProtectionTerms repeating group that applies to this Underlying.',
  },
  {
    type: 'XIDREF',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingSettlTermXIDRef',
    id: 41315,
    abbrName: 'SettlXIDRef',
    description:
      'Reference to the cash or physical settlement terms applicable to this entity or obligation. Contains the same XID named string value of the instance in the appropriate repeating group that applies to this Underlying.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingIndexSeries',
    id: 2003,
    abbrName: 'NdxSeries',
    description: 'The series identifier of a credit default swap index.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingIndexAnnexVersion',
    id: 2004,
    abbrName: 'NdxAnxVer',
    description: 'The version identifier of a credit default swap index annex.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingIndexAnnexDate',
    id: 2005,
    abbrName: 'NdxAnxDt',
    description: 'The date of a credit default swap index series annex.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingIndexAnnexSource',
    id: 2006,
    abbrName: 'NdxAnxSrc',
    description: 'The source of a credit default swap index series annex.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProductComplex',
    id: 2007,
    abbrName: 'ProdCmplx',
    description:
      'Identifies an entire suite of products for a given market. In Futures this may be "interest rates", "agricultural", "equity indexes", etc',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingSecurityGroup',
    id: 2008,
    abbrName: 'SecGrp',
    description:
      'An exchange specific name assigned to a group of related securities which may be concurrently affected by market events and actions.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingSettleOnOpenFlag',
    id: 2009,
    abbrName: 'SettlOnOpenFlag',
    description: 'Indicator to determine if Instrument is Settle on Open.',
  },
  {
    type: 'InstrmtAssignmentMethodCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingAssignmentMethod',
    id: 2010,
    abbrName: 'AsgnMeth',
    description: 'Method under which assignment was conducted',
  },
  {
    updated: 'FIX.Latest',
    type: 'SecurityStatusCodeSet',
    addedEP: '161',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingSecurityStatus',
    id: 2011,
    abbrName: 'Status',
    description: 'Indicates the current state of the underlying instrument.',
  },
  {
    type: 'UnderlyingObligationTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingObligationType',
    id: 2012,
    abbrName: 'ObligTyp',
    description: 'Type of reference obligation for credit derivatives contracts.',
  },
  {
    type: 'AssetClassCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingAssetClass',
    id: 2013,
    abbrName: 'AssetClss',
    description: 'The broad asset category for assessing risk exposure.',
  },
  {
    type: 'AssetSubClassCodeSet',
    unionDataType: 'Reserved4000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingAssetSubClass',
    id: 2014,
    abbrName: 'AssetSubClss',
    description: 'An indication of the general description of the asset class.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    addedEP: '161',
    updatedEP: '235',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingAssetType',
    id: 2015,
    abbrName: 'AssetTyp',
    description:
      "Used to provide more specific description of the asset specified in UnderlyingAssetSubClass(2082).\n\nSee https://www.fixtrading.org/codelists/AssetType for code list of applicable values. ISO 4721 Currency Code values are to be used when specific currency as an asset type is to be expressed.\n\nOther values may be used by mutual agreement of the counterparties.\n\nIn the context of MiFID II's this may indicate the value needed in ESMA RTS 2 Annex IV Table 2 Field 16, or ESMA RTS 23 Annex I Table 2 'Sub product' field.",
  },
  {
    type: 'SwapClassCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingSwapClass',
    id: 2016,
    abbrName: 'SwapClss',
    description:
      'The type or classification of swap. Additional values may be used by mutual agreement of the counterparties.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingNthToDefault',
    id: 2017,
    abbrName: 'NthDflt',
    description:
      'The Nth reference obligation to default in a CDS reference basket. If specified without UnderlyingMthToDefault(2018) the default will trigger a CDS payout. If UnderlyingMthToDefault(2018) is also present then payout occurs between the Nth and Mth obligations to default.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingMthToDefault',
    id: 2018,
    abbrName: 'MthDflt',
    description:
      'The Mth reference obligation to default in a CDS reference basket. When UnderlyingNthToDefault(2017) and UnderlyingMthToDefault(2018) are represented then the CDS payout occurs between the Nth and Mth obligations to default.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingSettledEntityMatrixSource',
    id: 2019,
    abbrName: 'SettldMtrxSrc',
    description: 'Relevant settled entity matrix source.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingSettledEntityMatrixPublicationDate',
    id: 2020,
    abbrName: 'SettldMtrxDt',
    description:
      'Specifies the publication date of the applicable version of the matrix. If not specified, the Standard Terms Supplement defines rules for which version of the matrix is applicable.',
  },
  {
    type: 'float',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStrikeMultiplier',
    id: 2021,
    abbrName: 'StrkMult',
    description:
      'Used for derivatives. Multiplier applied to the strike price for the purpose of calculating the settlement value.',
  },
  {
    type: 'float',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStrikeValue',
    id: 2022,
    abbrName: 'StrkValu',
    description:
      'Used for derivatives. The number of shares/units for the financial instrument involved in the option trade.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'StrikePriceDeterminationMethodCodeSet',
    addedEP: '161',
    updatedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStrikePriceDeterminationMethod',
    id: 2023,
    abbrName: 'StrkPxDtrmnMeth',
    description:
      'Specifies how the strike price is determined at the point of option exercise. The strike may be fixed throughout the life of the option, set at expiration to the value of the underlying, set to the average value of the underlying , or set to the optimal value of the underlying.',
  },
  {
    type: 'StrikePriceBoundaryMethodCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStrikePriceBoundaryMethod',
    id: 2024,
    abbrName: 'StrkPxBndryMeth',
    description:
      'Specifies the boundary condition to be used for the strike price relative to the underlying price at the point of option exercise.',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStrikePriceBoundaryPrecision',
    id: 2025,
    abbrName: 'StrkPxBndryPrcsn',
    description:
      'Used in combination with StrikePriceBoundaryMethod(1479) to specify the percentage of the strike price in relation to the underlying price. The percentage is generally 100 or greater for puts and 100 or less for calls.',
  },
  {
    type: 'float',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingMinPriceIncrement',
    id: 2026,
    abbrName: 'MinPxIncr',
    description:
      'Minimum price increment for the instrument. Could also be used to represent tick value.',
  },
  {
    type: 'Amt',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingMinPriceIncrementAmount',
    id: 2027,
    abbrName: 'MinPxIncrAmt',
    description:
      'Minimum price increment amount associated with the UnderlyingMinPriceIncrement(2026). For listed derivatives, the value can be calculated by multiplying UnderlyingMinPriceIncrement(2026) by UnderlyingContractMultiplier(436).',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'OptPayoutTypeCodeSet',
    addedEP: '161',
    updatedEP: '238',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingOptPayoutType',
    id: 2028,
    abbrName: 'OptPayoutTyp',
    description:
      'Indicates the type of valuation method or payout trigger for an in-the-money option.',
  },
  {
    type: 'Amt',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingOptPayoutAmount',
    id: 2029,
    abbrName: 'OptPayAmt',
    description:
      'Cash amount indicating the pay out associated with an option. For binary options this is a fixed amount.',
  },
  {
    type: 'PriceQuoteMethodCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPriceQuoteMethod',
    id: 2030,
    abbrName: 'PxQteMeth',
    description: 'Method for price quotation.',
  },
  {
    type: 'ValuationMethodCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingValuationMethod',
    id: 2031,
    abbrName: 'ValMeth',
    description: 'Indicates type of valuation method used.',
  },
  {
    type: 'ListMethodCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingListMethod',
    id: 2032,
    abbrName: 'ListMeth',
    description:
      'Indicates whether the instruments are pre-listed only or can also be defined via user request.',
  },
  {
    type: 'Price',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingCapPrice',
    id: 2033,
    abbrName: 'CapPx',
    description: 'Used to express the ceiling price of a capped call.',
  },
  {
    type: 'Price',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingFloorPrice',
    id: 2034,
    abbrName: 'FlrPx',
    description: 'Used to express the floor price of a capped put.',
  },
  {
    type: 'Boolean',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingFlexibleIndicator',
    id: 2035,
    abbrName: 'FlexInd',
    description:
      'Used to indicate if a security has been defined as flexible according to "non-standard" means. Analog to CFICode Standard/Non-standard indicator.',
  },
  {
    type: 'Boolean',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingFlexProductEligibilityIndicator',
    id: 2036,
    abbrName: 'FlexProdElig',
    description:
      'Used to indicate if a product or group of product supports the creation of flexible securities.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPositionLimit',
    id: 2037,
    abbrName: 'PosLmt',
    description: 'Position limit for the instrument.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingNTPositionLimit',
    id: 2038,
    abbrName: 'NTPosLmt',
    description:
      'Position Limit in the near-term contract for a given exchange-traded product.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPool',
    id: 2039,
    abbrName: 'Pool',
    description:
      'Identifies the mortgage backed security (MBS) / asset backed security (ABS) pool.',
  },
  {
    type: 'MonthYear',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingContractSettlMonth',
    id: 2040,
    abbrName: 'CSetMo',
    description:
      'Specifies when the contract (i.e. MBS/TBA) will settle. Must be present for MBS/TBA.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDatedDate',
    id: 2041,
    abbrName: 'Dated',
    description: 'If different from IssueDate()',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingInterestAccrualDate',
    id: 2042,
    abbrName: 'IntAcrl',
    description: 'If different from IssueDate and DatedDate',
  },
  {
    type: 'ShortSaleRestrictionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingShortSaleRestriction',
    id: 2043,
    abbrName: 'ShrtRstctn',
    description: 'Indicates whether a restriction applies to short selling a security.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingRefTickTableID',
    id: 2044,
    abbrName: 'RefTickTblID',
    description: 'Spread table code referred by the security or symbol.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingComplexEvents',
    id: 2045,
    description: 'Number of complex events in the repeating group.',
  },
  {
    type: 'ComplexEventTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventType',
    id: 2046,
    abbrName: 'Typ',
    description: 'Identifies the type of complex event.',
  },
  {
    type: 'Amt',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexOptPayoutAmount',
    id: 2047,
    abbrName: 'OptPayAmt',
    description:
      'Cash amount indicating the pay out associated with an event. For binary options this is a fixed amount.',
  },
  {
    type: 'Price',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventPrice',
    id: 2048,
    abbrName: 'Px',
    description:
      'Specifies the price at which the complex event takes effect. Impact of the event price is determined by the UnderlyingComplexEventType(2046).',
  },
  {
    type: 'ComplexEventPriceBoundaryMethodCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventPriceBoundaryMethod',
    id: 2049,
    abbrName: 'PxBndryMeth',
    description:
      'Specifies the boundary condition to be used for the event price relative to the UnderlyingComplexEventPrice(2048) at the point the complex event outcome takes effect as determined by the UnderlyingComplexEventPriceTimeType(2051).',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventPriceBoundaryPrecision',
    id: 2050,
    abbrName: 'PxBndryPrcsn',
    description:
      'Used in combination with UnderlyingComplexEventPriceBoundaryMethod(2049) to specify the percentage of the strike price in relation to the underlying price. The percentage is generally 100 or greater for puts and 100 or less for calls.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'ComplexEventPriceTimeTypeCodeSet',
    addedEP: '161',
    updatedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventPriceTimeType',
    id: 2051,
    abbrName: 'PxTmTyp',
    description:
      'Specifies when the complex event outcome takes effect. The outcome of a complex event is a payout or barrier action as specified by the UnderlyingComplexEventType(2046).',
  },
  {
    type: 'ComplexEventConditionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventCondition',
    id: 2052,
    abbrName: 'Cond',
    description:
      'Specifies the condition between complex events when more than one event is specified.\n\nMultiple barrier events would use an "or" condition since only one can be effective at a given time. A set of digital range events would use an "and" condition since both conditions must be in effect for a payout to result.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingComplexEventDates',
    id: 2053,
    description: 'Number of underlying complex event dates in the repeating group.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'UTCDateOnly',
    addedEP: '161',
    updatedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventStartDate',
    id: 2054,
    abbrName: 'StartDt',
    description:
      'The start date of the date range on which a complex event is effective. The start date will be set equal to the end date for single day events such as Bermuda options.\n\nThe start date must always be less than or equal to end date.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'UTCDateOnly',
    addedEP: '161',
    updatedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventEndDate',
    id: 2055,
    abbrName: 'EndDt',
    description:
      'The end date of the date range on which a complex event is effective. The start date will be set equal to the end date for single day events such as Bermuda options.\n\nUnderlyingComplexEventEndDate(2056) must always be greater than or equal to UnderlyingComplexEventStartDate(2055).',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingComplexEventTimes',
    id: 2056,
    description: 'Number of complex event times in the repeating group.',
  },
  {
    type: 'UTCTimeOnly',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventStartTime',
    id: 2057,
    abbrName: 'StartTm',
    description:
      'The start time of the time range on which a complex event date is effective.\n\nUnderlyingComplexEventStartTime(2057) must always be less than or equal to UndelryingComplexEventEndTime(2058).',
  },
  {
    type: 'UTCTimeOnly',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventEndTime',
    id: 2058,
    abbrName: 'EndTm',
    description:
      'The end time of the time range on which a complex event date is effective.\n\nUnderlyingComplexEventEndTime(2058) must always be greater than or equal to UnderlyingComplexEventStartTime(2057).',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoLegEvents',
    id: 2059,
    description: 'Number of events in the repeating group',
  },
  {
    type: 'EventTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegEventType',
    id: 2060,
    abbrName: 'Typ',
    description: 'Code to represent the type of event.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegEventDate',
    id: 2061,
    abbrName: 'Dt',
    description: 'The date of the event.',
  },
  {
    type: 'UTCTimestamp',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegEventTime',
    id: 2062,
    abbrName: 'Tm',
    description:
      'Specific time of event. To be used in combination with LegEventDate(2061).',
  },
  {
    type: 'EventTimeUnitCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegEventTimeUnit',
    id: 2063,
    abbrName: 'TmUnit',
    description: 'Time unit associated with the event.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegEventTimePeriod',
    id: 2064,
    abbrName: 'TmPeriod',
    description: 'Time unit multiplier for the event.',
  },
  {
    type: 'Price',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegEventPx',
    id: 2065,
    abbrName: 'Px',
    description: 'Predetermined price of issue at event, if applicable.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegEventText',
    id: 2066,
    abbrName: 'Txt',
    description:
      'Free form text to specify additional information or enumeration description when a standard value does not apply.',
  },
  {
    type: 'AssetClassCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegAssetClass',
    id: 2067,
    abbrName: 'AssetClss',
    description: 'The broad asset category for assessing risk exposure.',
  },
  {
    type: 'AssetSubClassCodeSet',
    unionDataType: 'Reserved4000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegAssetSubClass',
    id: 2068,
    abbrName: 'AssetSubClss',
    description: 'The general subcategory description of the asset class.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    addedEP: '161',
    updatedEP: '235',
    added: 'FIX.5.0SP2',
    name: 'LegAssetType',
    id: 2069,
    abbrName: 'AssetTyp',
    description:
      "Used to provide more specific description of the asset specified in LegAssetSubClass(2068).\n\nSee https://www.fixtrading.org/codelists/AssetType for code list of applicable values. ISO 4721 Currency Code values are to be used when specific currency as an asset type is to be expressed.\n\nOther values may be used by mutual agreement of the counterparties.\n\nIn the context of MiFID II's this may indicate the value needed in ESMA RTS 2 Annex IV Table 2 Field 16, or ESMA RTS 23 Annex I Table 2 'Sub product' field.",
  },
  {
    type: 'SwapClassCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegSwapClass',
    id: 2070,
    abbrName: 'SwapClss',
    description: 'Swap type.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingEventText',
    id: 2071,
    abbrName: 'Txt',
    description: 'Free form text to specify comments related to the event.',
  },
  {
    type: 'Length',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'EncodedUnderlyingEventTextLen',
    id: 2072,
    abbrName: 'EncTxtLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedUnderlyingEventText(2073) field.',
  },
  {
    type: 'data',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'EncodedUnderlyingEventText',
    id: 2073,
    abbrName: 'EncTxt',
    lengthId: '2072',
    description:
      'Encoded (non-ASCII characters) representation of the UnderlyingEventText(2071) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the UnderlyingEventText(2071) field.',
  },
  {
    type: 'Length',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'EncodedLegEventTextLen',
    id: 2074,
    abbrName: 'EncTxtLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedLegEventText(2075) field.',
  },
  {
    type: 'data',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'EncodedLegEventText',
    id: 2075,
    abbrName: 'EncTxt',
    lengthId: '2074',
    description:
      'Encoded (non-ASCII characters) representation of the LegEventText(2066) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the LegEventText(2066) field.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoLegSecondaryAssetClasses',
    id: 2076,
    description: 'Number of secondary asset classes in the repeating group.',
  },
  {
    type: 'AssetClassCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegSecondaryAssetClass',
    id: 2077,
    abbrName: 'Clss',
    description:
      'The broad asset category for assessing risk exposure for a multi-asset trade.',
  },
  {
    type: 'AssetSubClassCodeSet',
    unionDataType: 'Reserved4000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegSecondaryAssetSubClass',
    id: 2078,
    abbrName: 'SubClss',
    description: 'An indication of the general description of the asset class.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    addedEP: '161',
    updatedEP: '235',
    added: 'FIX.5.0SP2',
    name: 'LegSecondaryAssetType',
    id: 2079,
    abbrName: 'Typ',
    description:
      "Used to provide more specific description of the asset specified in LegSecondaryAssetSubClass(2078).\n\nSee https://www.fixtrading.org/codelists/AssetType for code list of applicable values. ISO 4721 Currency Code values are to be used when specific currency as an asset type is to be expressed.\n\nOther values may be used by mutual agreement of the counterparties.\n\nIn the context of MiFID II's this may indicate the value needed in ESMA RTS 2 Annex IV Table 2 Field 16, or ESMA RTS 23 Annex I Table 2 'Sub product' field.",
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingSecondaryAssetClasses',
    id: 2080,
    description: 'Number of secondary asset classes in the repeating group.',
  },
  {
    type: 'AssetClassCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingSecondaryAssetClass',
    id: 2081,
    abbrName: 'Clss',
    description:
      'The broad asset category for assessing risk exposure for a multi-asset trade.',
  },
  {
    type: 'AssetSubClassCodeSet',
    unionDataType: 'Reserved4000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingSecondaryAssetSubClass',
    id: 2082,
    abbrName: 'SubClss',
    description: 'An indication of the general description of the asset class.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    addedEP: '161',
    updatedEP: '235',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingSecondaryAssetType',
    id: 2083,
    abbrName: 'Typ',
    description:
      "Used to provide more specific description of the asset specified in UnderlyingSecondaryAssetSubClass(2082).\n\nSee https://www.fixtrading.org/codelists/AssetType for code list of applicable values. ISO 4721 Currency Code values are to be used when specific currency as an asset type is to be expressed.\n\nOther values may be used by mutual agreement of the counterparties.\n\nIn the context of MiFID II's this may indicate the value needed in ESMA RTS 2 Annex IV Table 2 Field 16, or ESMA RTS 23 Annex I Table 2 'Sub product' field.",
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoAdditionalTermBondRefs',
    id: 40000,
    description: 'Number of bonds in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'AdditionalTermBondSecurityID',
    id: 40001,
    abbrName: 'ID',
    discriminatorId: '40002',
    description: 'Security identifier of the bond.',
  },
  {
    type: 'SecurityIDSourceCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'AdditionalTermBondSecurityIDSource',
    id: 40002,
    abbrName: 'Src',
    description:
      'Identifies the source scheme of the AdditionalTermBondSecurityID(40001) value.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'AdditionalTermBondDesc',
    id: 40003,
    abbrName: 'Desc',
    description: 'Description of the bond.',
  },
  {
    type: 'Length',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'EncodedAdditionalTermBondDescLen',
    id: 40004,
    abbrName: 'EncDescLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedAdditionalTermBondDesc(40005) field.',
  },
  {
    type: 'data',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'EncodedAdditionalTermBondDesc',
    id: 40005,
    abbrName: 'EncDesc',
    lengthId: '40004',
    description:
      'Encoded (non-ASCII characters) representation of the AdditionalTermBondDesc(40003) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the AdditionalTermBondDesc(40003) field.',
  },
  {
    type: 'Currency',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'AdditionalTermBondCurrency',
    id: 40006,
    abbrName: 'Ccy',
    description:
      'Specifies the currency the bond value is denominated in. Uses ISO 4217 currency codes.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'AdditionalTermBondIssuer',
    id: 40007,
    abbrName: 'Issr',
    description: 'Issuer of the bond.',
  },
  {
    type: 'Length',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'EncodedAdditionalTermBondIssuerLen',
    id: 40008,
    abbrName: 'EncIssrLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedAdditionalTermBondIssuer(40009) field.',
  },
  {
    type: 'data',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'EncodedAdditionalTermBondIssuer',
    id: 40009,
    abbrName: 'EncIssr',
    lengthId: '40008',
    description:
      'Encoded (non-ASCII characters) representation of the AdditionalTermBondIssuer(40007) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the AdditionalTermBondIssuer(40007) field.',
  },
  {
    type: 'SeniorityCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'AdditionalTermBondSeniority',
    id: 40010,
    abbrName: 'Snrty',
    description: "Specifies the bond's payment priority in the event of a default.",
  },
  {
    type: 'CouponTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'AdditionalTermBondCouponType',
    id: 40011,
    abbrName: 'CpnTyp',
    description: 'Coupon type of the bond.',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'AdditionalTermBondCouponRate',
    id: 40012,
    abbrName: 'CpnRt',
    description: 'Coupon rate of the bond. See also CouponRate(223).',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'AdditionalTermBondMaturityDate',
    id: 40013,
    abbrName: 'MatDt',
    description: 'The maturity date of the bond.',
  },
  {
    type: 'Amt',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'AdditionalTermBondParValue',
    id: 40014,
    abbrName: 'Par',
    description: 'The par value of the bond.',
  },
  {
    type: 'Amt',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'AdditionalTermBondCurrentTotalIssuedAmount',
    id: 40015,
    abbrName: 'CurTotAmt',
    description: 'Total issued amount of the bond.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'AdditionalTermBondCouponFrequencyPeriod',
    id: 40016,
    abbrName: 'CpnPeriod',
    description: "Time unit multiplier for the frequency of the bond's coupon payment.",
  },
  {
    type: 'CouponFrequencyUnitCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'AdditionalTermBondCouponFrequencyUnit',
    id: 40017,
    abbrName: 'CpnUnit',
    description: "Time unit associated with the frequency of the bond's coupon payment.",
  },
  {
    type: 'CouponDayCountCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'AdditionalTermBondDayCount',
    id: 40018,
    abbrName: 'DayCnt',
    description:
      'The day count convention used in interest calculations for a bond or an interest bearing security.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoAdditionalTerms',
    id: 40019,
    description: 'Number of additional terms in the repeating group.',
  },
  {
    type: 'Boolean',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'AdditionalTermConditionPrecedentBondIndicator',
    id: 40020,
    abbrName: 'PrcdntInd',
    description:
      'Indicates whether the condition precedent bond is applicable. The swap contract is only valid if the bond is issued and if there is any dispute over the terms of fixed stream then the bond terms would be used.',
  },
  {
    type: 'Boolean',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'AdditionalTermDiscrepancyClauseIndicator',
    id: 40021,
    abbrName: 'DscrpncyInd',
    description: 'Indicates whether the discrepancy clause is applicable.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoCashSettlTerms',
    id: 40022,
    description: 'Number of elements in the repeating group.',
  },
  {
    type: 'Currency',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'CashSettlCurrency',
    id: 40023,
    abbrName: 'Ccy',
    description:
      'Specifies the currency the CashSettlAmount(40034) is denominated in. Uses ISO 4217 currency codes.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'CashSettlValuationFirstBusinessDayOffset',
    id: 40024,
    abbrName: 'BizDayOfst',
    description:
      'The number of business days after settlement conditions have been satisfied, when the calculation agent is to obtain a price quotation on the reference obligation for the purpose of cash settlement.\n\nAssociated with ISDA 2003 Term: Valuation Date.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'CashSettlValuationSubsequentBusinessDaysOffset',
    id: 40916,
    abbrName: 'SbsqntBizDayOfst',
    description:
      'The number of business days between successive valuation dates when multiple valuation dates are applicable for cash settlement.\n\nAssociated with ISDA 2003 Term: Valuation Date',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'CashSettlNumOfValuationDates',
    id: 40917,
    abbrName: 'NumValDts',
    description:
      'Where multiple valuation dates are specified as being applicable for cash settlement, this specifies the number of applicable valuation dates.\n\nAssociated with ISDA 2003 Term: Valuation Date',
  },
  {
    type: 'LocalMktTime',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'CashSettlValuationTime',
    id: 40025,
    abbrName: 'ValTm',
    description: 'The time of valuation.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'CashSettlBusinessCenter',
    id: 40026,
    abbrName: 'BizCtr',
    description:
      'Identifies the business center calendar used at valuation time for cash settlement purposes e.g. "GBLO". See http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'CashSettlQuoteMethodCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'CashSettlQuoteMethod',
    id: 40027,
    abbrName: 'QteMeth',
    description: 'The type of quote used to determine the cash settlement price.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Amt',
    addedEP: '161',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'CashSettlQuoteAmount',
    id: 40028,
    abbrName: 'QteAmt',
    description:
      'When determining the cash settlement amount, if weighted average price quotes are to be obtained for the reference obligation, this is the upper limit to the outstanding principal balance of the reference obligation for which the quote should be obtained. If not specified, the ISDA definitions provide for a fallback amount equal to floating rate payer calculation amount.\n\nISDA 2003 Term: Quotation Amount.',
  },
  {
    type: 'Currency',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'CashSettlQuoteCurrency',
    id: 40029,
    abbrName: 'QteCcy',
    description:
      'Specifies the currency the CashSettlQuoteAmount(40028) is denominated in. Uses ISO 4217 Currency Code.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Amt',
    addedEP: '161',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'CashSettlMinimumQuoteAmount',
    id: 40030,
    abbrName: 'MinQteAmt',
    description:
      'When determining the cash settlement amount, if weighted average price quotes are to be obtained for the reference obligation, this is the minimum intended threshold amount of outstanding principal balance of the reference obligation for which the quote should be obtained. If not specified, the ISDA definitions provide for a fallback amount of the lower of either USD1,000,000 (or its equivalent in the relevant obligation currency) or the (minimum) quoted amount.\n\nISDA 2003 Term: Minimum Quotation Amount.',
  },
  {
    type: 'Currency',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'CashSettlMinimumQuoteCurrency',
    id: 40031,
    abbrName: 'MinQteCcy',
    description:
      'Specifies the currency the CashSettlMinimumQuoteAmount(40030) is denominated in. Uses ISO 4217 Currency Code.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'CashSettlDealer',
    id: 40032,
    abbrName: 'Dlr',
    description:
      'Identifies the dealer from whom price quotations for the reference obligation are obtained for the purpose of cash settlement valuation calculation.\n\nISDA 2003 Term: Dealer.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'CashSettlBusinessDays',
    id: 40033,
    abbrName: 'BizDays',
    description:
      'The number of business days used in the determination of the cash settlement payment date.\n\nIf a cash settlement amount is specified, the cash settlement payment date will be this number of business days following the calculation of the final price. If a cash settlement amount is not specified, the cash settlement payment date will be this number of business days after all conditions to settlement are satisfied.\n\nISDA 2003 Term: Cash Settlement Date.',
  },
  {
    type: 'Amt',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'CashSettlAmount',
    id: 40034,
    abbrName: 'Amt',
    description:
      'The amount paid between the trade parties, seller to the buyer, for cash settlement on the cash settlement date.\n\nIf not specified this is not to be included in the message and the parties to the trade are expected to calculate the value. The value is the greater of (a) floating rate payer calculation amount x (reference price - final price) or (b) zero. Price values are all expressed as a percentage. ISDA 2003 Term: Cash Settlement Amount',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'float',
    addedEP: '161',
    updatedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'CashSettlRecoveryFactor',
    id: 40035,
    abbrName: 'RcvryFctr',
    description:
      'Used for fixed recovery, this specifies the recovery level as determined at contract inception, to be applied in the event of a default. The factor is used to calculate the amount paid by the seller to the buyer for cash settlement on the cash settlement date. The amount calculated is (1 - CashSettlRecoveryFactor(40035)) x floating rate payer calculation amount. The currency is derived from the floating rate payer calculation amount.',
  },
  {
    type: 'Boolean',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'CashSettlFixedTermIndicator',
    id: 40036,
    abbrName: 'FixedInd',
    description:
      'Indicates whether fixed settlement is applicable or not applicable in a recovery lock.',
  },
  {
    type: 'Boolean',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'CashSettlAccruedInterestIndicator',
    id: 40037,
    abbrName: 'AcrdIntInd',
    description:
      'Indicates whether accrued interest is included or not in the value provided in CashSettlAmount(40034). For cash settlement this specifies whether quotations should be obtained inclusive or not of accrued interest.\n\nFor physical settlement this specifies whether the buyer should deliver the obligation with an outstanding principal balance that includes or excludes accrued interest.\n\nISDA 2003 Term: Include/Exclude Accrued Interest.',
  },
  {
    type: 'CashSettlValuationMethodCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'CashSettlValuationMethod',
    id: 40038,
    abbrName: 'ValMeth',
    description:
      'The ISDA defined methodology for determining the final price of the reference obligation for purposes of cash settlement.\n\nISDA 2003 Term: Valuation Method',
  },
  {
    type: 'XID',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'CashSettlTermXID',
    id: 40039,
    abbrName: 'XID',
    description: 'A named string value referenced by UnderlyingSettlTermXIDRef(41315).',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoContractualDefinitions',
    id: 40040,
    description: 'Number of financing definitions in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ContractualDefinition',
    id: 40041,
    abbrName: 'Def',
    description:
      'Specifies which contract definition, such as those published by ISDA, will apply for the terms of the trade. See http://www.fpml.org/coding-scheme/contractual-definitions for values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoContractualMatrices',
    id: 40042,
    description: 'Number of contractual matrices in the repeating group.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    addedEP: '161',
    updatedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'ContractualMatrixSource',
    id: 40043,
    abbrName: 'Src',
    description:
      'Identifies the applicable contract matrix. See http://www.fpml.org/coding-scheme/matrix-type-1-0.xml for values.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ContractualMatrixDate',
    id: 40044,
    abbrName: 'Dt',
    description:
      'The publication date of the applicable version of the contract matrix. If not specified, the ISDA Standard Terms Supplement defines rules for which version of the matrix is applicable.',
  },
  {
    updated: 'FIX.Latest',
    type: 'String',
    addedEP: '161',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'ContractualMatrixTerm',
    id: 40045,
    abbrName: 'Trm',
    description:
      'Specifies the applicable key into the relevant contract matrix. In the case of 2000 ISDA Definitions Settlement Matrix for Early Termination and Swaptions, the ContractualMatrixTerm(40045) is not applicable and is to be omitted.\n\nSee http://www.fpml.org/coding-scheme/credit-matrix-transaction-type for values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoFinancingTermSupplements',
    id: 40046,
    description: 'Number of financing terms supplements in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'FinancingTermSupplementDesc',
    id: 40047,
    abbrName: 'Desc',
    description:
      'Identifies the applicable contractual supplement. See http://www.fpml.org/coding-scheme/contractual-supplement for values.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'FinancingTermSupplementDate',
    id: 40048,
    abbrName: 'Dt',
    description:
      'The publication date of the applicable version of the contractual supplement.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoStreams',
    id: 40049,
    description: 'Number of swap streams in the repeating group.',
  },
  {
    type: 'StreamTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'StreamType',
    id: 40050,
    abbrName: 'Typ',
    description: 'Type of swap stream.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'StreamDesc',
    id: 40051,
    abbrName: 'Desc',
    description:
      'A short descriptive name given to the payment stream. Eg. CDS, Fixed, Float, Float2, GBP. The description has no intrinsic meaning but should be arbitrarily chosen by the remitter as reference.',
  },
  {
    type: 'PaymentPaySideCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'StreamPaySide',
    id: 40052,
    abbrName: 'PaySide',
    description: 'The side of the party paying the stream.',
  },
  {
    type: 'PaymentPaySideCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'StreamReceiveSide',
    id: 40053,
    abbrName: 'RcvSide',
    description: 'The side of the party receiving the stream.',
  },
  {
    type: 'Amt',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'StreamNotional',
    id: 40054,
    abbrName: 'Notl',
    description:
      'Notional, or initial notional value for the payment stream. Use the PaymentScheduleGrp component to specify the rate steps.',
  },
  {
    type: 'Currency',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'StreamCurrency',
    id: 40055,
    abbrName: 'Ccy',
    description:
      'Specifies the currency the StreamNotional(40054) is denominated in. Uses ISO 4217 currency codes.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'StreamText',
    id: 40056,
    abbrName: 'Txt',
    description:
      'Free form text to specify additional information or enumeration description when a standard value does not apply.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamEffectiveDateUnadjusted',
    id: 40057,
    abbrName: 'DtUnadj',
    description: 'The unadjusted effective date.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamEffectiveDateBusinessDayConvention',
    id: 40058,
    abbrName: 'BizDayCnvtn',
    description:
      "The business day convention used to adjust the underlying instrument's stream's effective, or relative effective, date. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamEffectiveDateBusinessCenter',
    id: 40059,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the underlying instrument\'s stream\'s effective, or relative effective, date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamEffectiveDateRelativeTo',
    id: 40060,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the effective date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamEffectiveDateOffsetPeriod',
    id: 40061,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative effective date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamEffectiveDateOffsetUnit',
    id: 40062,
    abbrName: 'OfstUnit',
    description: 'Time unit associated with the relative effective date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamEffectiveDateOffsetDayType',
    id: 40063,
    abbrName: 'OfstDayTyp',
    description: 'Specifies the day type of the relative effective date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamEffectiveDateAdjusted',
    id: 40064,
    abbrName: 'Dt',
    description: 'The adjusted effective date.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'StreamTerminationDateUnadjusted',
    id: 40065,
    abbrName: 'DtUnadj',
    description: 'The unadjusted termination date.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'StreamTerminationDateBusinessDayConvention',
    id: 40066,
    abbrName: 'BizDayCnvtn',
    description:
      "The business day convention used to adjust the instrument's stream's termination, or relative termination, date. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'StreamTerminationDateBusinessCenter',
    id: 40067,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the instrument\'s stream\'s termination, or relative termination, date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'StreamTerminationDateRelativeTo',
    id: 40068,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the termination date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'StreamTerminationDateOffsetPeriod',
    id: 40069,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative termination date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'StreamTerminationDateOffsetUnit',
    id: 40070,
    abbrName: 'OfstUnit',
    description: 'Time unit associated with the relative termination date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'StreamTerminationDateOffsetDayType',
    id: 40071,
    abbrName: 'OfstDayTyp',
    description: 'Specifies the day type of the relative termination date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'StreamTerminationDateAdjusted',
    id: 40072,
    abbrName: 'Dt',
    description: 'The adjusted termination date.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'StreamCalculationPeriodBusinessDayConvention',
    id: 40073,
    abbrName: 'BizDayCnvtn',
    description:
      'The business day convention used to adjust calculation periods. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'StreamCalculationPeriodBusinessCenter',
    id: 40074,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust calculation periods, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'StreamFirstPeriodStartDateUnadjusted',
    id: 40075,
    abbrName: 'FirstStartDtUnadj',
    description:
      'The unadjusted first calculation period start date if before the effective date.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'StreamFirstPeriodStartDateBusinessDayConvention',
    id: 40076,
    abbrName: 'FirstStartDtBizDayCnvtn',
    description:
      "The business day convention used to adjust the instrument's stream's first calculation period start date. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'StreamFirstPeriodStartDateBusinessCenter',
    id: 40077,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the instrument\'s stream\'s first calculation period start date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'StreamFirstPeriodStartDateAdjusted',
    id: 40078,
    abbrName: 'FirstStartDt',
    description:
      'The adjusted first calculation period start date, if it is before the effective date.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'StreamFirstRegularPeriodStartDateUnadjusted',
    id: 40079,
    abbrName: 'FirstReglrStartDtUnadj',
    description:
      'The unadjusted first start date of the regular calculation period, if there is an initial stub period.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'StreamFirstCompoundingPeriodEndDateUnadjusted',
    id: 40080,
    abbrName: 'FirstCmpndgEndDtUnadj',
    description: 'The unadjusted end date of the initial compounding period.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'StreamLastRegularPeriodEndDateUnadjusted',
    id: 40081,
    abbrName: 'LastReglrEndDtUnadj',
    description:
      'The unadjusted last regular period end date if there is a final stub period.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'StreamCalculationFrequencyPeriod',
    id: 40082,
    abbrName: 'FreqPeriod',
    description:
      'Time unit multiplier for the frequency at which calculation period end dates occur.',
  },
  {
    type: 'CouponFrequencyUnitCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'StreamCalculationFrequencyUnit',
    id: 40083,
    abbrName: 'FreqUnit',
    description:
      'Time unit associated with the frequency at which calculation period end dates occur.',
  },
  {
    type: 'DateRollConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'StreamCalculationRollConvention',
    id: 40084,
    abbrName: 'Roll',
    description:
      'The convention for determining the sequence of end dates. It is used in conjunction with a specified frequency. Used only to override the roll convention specified in the DateAdjustment component within the Instrument component.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoSettlRateFallbacks',
    id: 40085,
    description: 'Number of settlement rate fallbacks in the repeating group',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'SettlRatePostponementMaximumDays',
    id: 40086,
    abbrName: 'MaxDays',
    description:
      'The maximum number of days to wait for a quote from the disrupted settlement rate option before proceding to this method.',
  },
  {
    type: 'RateSourceCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamNonDeliverableSettlRateSource',
    id: 40087,
    abbrName: 'RtSrc',
    description: 'Identifies the source of the rate information.',
  },
  {
    type: 'Boolean',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'SettlRatePostponementSurvey',
    id: 40088,
    abbrName: 'Survey',
    description: 'Indicates whether to request a settlement rate quote from the market.',
  },
  {
    type: 'ProvisionCalculationAgentCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'SettlRatePostponementCalculationAgent',
    id: 40089,
    abbrName: 'CalcAgent',
    description: 'Used to identify the settlement rate postponement calculation agent.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoProvisions',
    id: 40090,
    description: 'Number of provisions in the repeating group.',
  },
  {
    type: 'ProvisionTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionType',
    id: 40091,
    abbrName: 'Typ',
    description: 'Type of provisions.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionDateUnadjusted',
    id: 40092,
    abbrName: 'DtUnadj',
    description: 'The unadjusted date of the provision.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionDateBusinessDayConvention',
    id: 40093,
    abbrName: 'BizDayCnvtn',
    description:
      "The business day convention used to adjust the instrument's provision's dates. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionDateBusinessCenter',
    id: 40094,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the instrument\'s provision\'s dates, e.g. "GBLO". See http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionDateAdjusted',
    id: 40095,
    abbrName: 'Dt',
    description: 'The adjusted date of the provision.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionDateTenorPeriod',
    id: 40096,
    abbrName: 'TenorPeriod',
    description: "Time unit multiplier for the provision's tenor period.",
  },
  {
    type: 'ProvisionDateTenorUnitCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionDateTenorUnit',
    id: 40097,
    abbrName: 'TenorUnit',
    description: "Time unit associated with the provision's tenor period.",
  },
  {
    type: 'ProvisionCalculationAgentCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionCalculationAgent',
    id: 40098,
    abbrName: 'CalcAgent',
    description:
      'Used to identify the calculation agent. The calculation agent may be identified in ProvisionCalculationAgent(40098) or in the ProvisionParties component.',
  },
  {
    type: 'ProvisionOptionSinglePartyBuyerSideCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionSinglePartyBuyerSide',
    id: 40099,
    abbrName: 'BuyerSide',
    description:
      'If optional early termination is not available to both parties then this component identifies the buyer of the option through its side of the trade.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'ProvisionOptionSinglePartyBuyerSideCodeSet',
    addedEP: '161',
    updatedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionSinglePartySellerSide',
    id: 40100,
    abbrName: 'SellerSide',
    description:
      'If optional early termination is not available to both parties then this component identifies the seller of the option through its side of the trade.',
  },
  {
    type: 'ExerciseStyleCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionExerciseStyle',
    id: 40101,
    abbrName: 'ExerStyle',
    description: 'The instrument provision option’s exercise style.',
  },
  {
    type: 'Amt',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionExerciseMultipleNotional',
    id: 40102,
    abbrName: 'MultplNotl',
    description:
      'A notional amount which restricts the amount of notional that can be exercised when partial exercise or multiple exercise is applicable. The integral multiple amount defines a lower limit of notional that can be exercised and also defines a unit multiple of notional that can be exercised, i.e. only integer multiples of this amount can be exercised.',
  },
  {
    type: 'Amt',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionExerciseMinimumNotional',
    id: 40103,
    abbrName: 'MinNotl',
    description:
      'The minimum notional amount that can be exercised on a given exercise date.',
  },
  {
    type: 'Amt',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionExerciseMaximumNotional',
    id: 40104,
    abbrName: 'MaxNotl',
    description:
      'The maximum notional amount that can be exercised on a given exercise date.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionMinimumNumber',
    id: 40105,
    abbrName: 'MinNum',
    description:
      'The minimum number of options that can be exercised on a given exercise date.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionMaximumNumber',
    id: 40106,
    abbrName: 'MaxNum',
    description:
      'The maximum number of options that can be exercised on a given exercise date. If the number is not specified, it means that the maximum number of options corresponds to the remaining unexercised options.',
  },
  {
    type: 'Boolean',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionExerciseConfirmation',
    id: 40107,
    abbrName: 'ExerCnfm',
    description:
      "Used to indicate whether follow-up confirmation of exercise (written or electronic) is required following telephonic notice by the buyer to the seller or seller's agent.",
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'ProvisionCashSettlMethodCodeSet',
    addedEP: '161',
    updatedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ProvisionCashSettlMethod',
    id: 40108,
    abbrName: 'SettlMeth',
    description:
      'An ISDA defined cash settlement method used for the determination of the applicable cash settlement amount. The method is defined in the 2006 ISDA Definitions, Section 18.3. Cash Settlement Methods, paragraph (e).',
  },
  {
    type: 'Currency',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionCashSettlCurrency',
    id: 40109,
    abbrName: 'SettlCcy',
    description: 'Specifies the currency of settlement. Uses ISO 4217 currency codes.',
  },
  {
    type: 'Currency',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionCashSettlCurrency2',
    id: 40110,
    abbrName: 'SettlCcy2',
    description:
      'Specifies the currency of settlement for a cross-currency provision. Uses ISO 4217 currency codes.',
  },
  {
    type: 'ProvisionCashSettlQuoteTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionCashSettlQuoteType',
    id: 40111,
    abbrName: 'SettlQteTyp',
    description: 'Identifies the type of quote to be used.',
  },
  {
    type: 'PaymentStreamRateIndexSourceCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionCashSettlQuoteSource',
    id: 40112,
    abbrName: 'SettlQteSrc',
    description: 'Identifies the source of quote information.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionText',
    id: 40113,
    abbrName: 'Txt',
    description:
      'Free form text to specify additional information or enumeration description when a standard value does not apply.',
  },
  {
    type: 'LocalMktTime',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionCashSettlValueTime',
    id: 40114,
    abbrName: 'Tm',
    description:
      'A time specified in 24-hour format, e.g. 11am would be represented as 11:00:00. The time of the cash settlement valuation date when the cash settlement amount will be determined according to the cash settlement method if the parties have not otherwise been able to agree to the cash settlement amount.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionCashSettlValueTimeBusinessCenter',
    id: 40115,
    abbrName: 'TmBizCtr',
    description:
      "Identifies the business center calendar used with the provision's cash settlement valuation time. See http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.",
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    updatedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'ProvisionCashSettlValueDateBusinessDayConvention',
    id: 40116,
    abbrName: 'BizDayCnvtn',
    description:
      'The cash settlement valuation date adjustment business day convention. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionCashSettlValueDateBusinessCenter',
    id: 40117,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the provision\'s cash settlement valuation date, e.g. "GBLO". See http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionCashSettlValueDateRelativeTo',
    id: 40118,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the cash settlement value date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ProvisionCashSettlValueDateOffsetPeriod',
    id: 40119,
    abbrName: 'OfstPeriod',
    description:
      'Time unit multiplier for the relative cash settlement value date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ProvisionCashSettlValueDateOffsetUnit',
    id: 40120,
    abbrName: 'OfstUnit',
    description:
      'Time unit associated with the relative cash settlement value date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ProvisionCashSettlValueDateOffsetDayType',
    id: 40121,
    abbrName: 'OfstDayTyp',
    description:
      "Specifies the day type of the provision's relative cash settlement value date offset.",
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionCashSettlValueDateAdjusted',
    id: 40122,
    abbrName: 'Dt',
    description: 'The adjusted cash settlement value date.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionExerciseBusinessDayConvention',
    id: 40123,
    abbrName: 'BizDayCnvtn',
    description:
      "The business day convention used to adjust the instrument's provision's option exercise date. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionExerciseBusinessCenter',
    id: 40124,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the instrument\'s provision\'s option exercise date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionExerciseEarliestDateOffsetPeriod',
    id: 40125,
    abbrName: 'ErlstOfstPeriod',
    description:
      'Time unit multiplier for the interval to the first (and possibly only) exercise date in the exercise period.',
  },
  {
    type: 'ProvisionOptionExerciseEarliestDateOffsetUnitCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionExerciseEarliestDateOffsetUnit',
    id: 40126,
    abbrName: 'ErlstOfstUnit',
    description:
      'Time unit associated with the interval to the first (and possibly only) exercise date in the exercise period.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionExerciseFrequencyPeriod',
    id: 40127,
    abbrName: 'FreqPeriod',
    description:
      'Time unit multiplier for the frequency of subsequent exercise dates in the exercise period following the earliest exercise date. An interval of 1 day should be used to indicate an American style exercise period.',
  },
  {
    type: 'CouponFrequencyUnitCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionExerciseFrequencyUnit',
    id: 40128,
    abbrName: 'FreqUnit',
    description:
      'Time unit associated with the frequency of subsequent exercise dates in the exercise period following the earliest exercise date.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionExerciseStartDateUnadjusted',
    id: 40129,
    abbrName: 'StartDtUnadj',
    description:
      'The unadjusted first day of the exercise period for an American style option.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionExerciseStartDateRelativeTo',
    id: 40130,
    abbrName: 'StartDtReltv',
    description:
      'Specifies the anchor date when the option exercise start date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionExerciseStartDateOffsetPeriod',
    id: 40131,
    abbrName: 'StartDtOfstPeriod',
    description:
      'Time unit multiplier for the relative option exercise start date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionExerciseStartDateOffsetUnit',
    id: 40132,
    abbrName: 'StartDtOfstUnit',
    description:
      'Time unit associated with the relative option exercise start date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionExerciseStartDateOffsetDayType',
    id: 40133,
    abbrName: 'StartDtOfstDayTyp',
    description:
      "Specifies the day type of the provision's relative option exercise start date offset.",
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionExerciseStartDateAdjusted',
    id: 40134,
    abbrName: 'StartDt',
    description:
      'The adjusted first day of the exercise period for an American style option.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionExercisePeriodSkip',
    id: 40135,
    abbrName: 'Skip',
    description:
      'The number of periods in the referenced date schedule that are between each date in the relative date schedule. Thus a skip of 2 would mean that dates are relative to every second date in the referenced schedule. If present this should have a value greater than 1.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionExerciseBoundsFirstDateUnadjusted',
    id: 40136,
    abbrName: 'FirstDtUnadj',
    description:
      'The unadjusted first date of a schedule. This can be used to restrict the range of exercise dates when they are relative.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionExerciseBoundsLastDateUnadjusted',
    id: 40137,
    abbrName: 'LastDtUnadj',
    description:
      'The unadjusted last date of a schedule. This can be used to restrict the range of exercise dates when they are relative.',
  },
  {
    type: 'LocalMktTime',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionExerciseEarliestTime',
    id: 40138,
    abbrName: 'ErlstTm',
    description:
      "The earliest time at which notice of exercise can be given by the buyer to the seller (or seller's agent) i) on the expriation date, in the case of a European style option, (ii) on each bermuda option exercise date and the expiration date, in the case of a Bermuda style option the commencement date to, and including, the expiration date, in the case of an American option.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionExerciseEarliestTimeBusinessCenter',
    id: 40139,
    abbrName: 'ErlstTmBizCtr',
    description:
      "Identifies the business center calendar used with the provision's earliest time for notice of exercise.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.",
  },
  {
    type: 'LocalMktTime',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionExerciseLatestTime',
    id: 40140,
    abbrName: 'LtstTm',
    description:
      "For a Bermuda or American style option, the latest time on an exercise business day (excluding the expiration date) within the exercise period that notice can be given by the buyer to the seller or seller's agent. Notice of exercise given after this time will be deemed to have been given on the next exercise business day.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionExerciseLatestTimeBusinessCenter',
    id: 40141,
    abbrName: 'LtstTmBizCtr',
    description:
      "Identifies the business center calendar used with the provision's latest time for notice of exercise.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.",
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoProvisionOptionExerciseFixedDates',
    id: 40142,
    description:
      'Number of provision option exercise fixed dates in the repeating group.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionExerciseFixedDate',
    id: 40143,
    abbrName: 'Dt',
    description:
      'A predetermined option exercise date, unadjusted or adjusted depending on ProvisionOptionExerciseFixedDateType(40144).',
  },
  {
    type: 'ProvisionOptionExerciseFixedDateTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionExerciseFixedDateType',
    id: 40144,
    abbrName: 'Typ',
    description: 'Specifies the type of date (e.g. adjusted for holidays).',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionExpirationDateUnadjusted',
    id: 40145,
    abbrName: 'DtUnadj',
    description:
      'The unadjusted last day within an exercise period for an American style option. For a European style option it is the only day within the exercise period.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionExpirationDateBusinessDayConvention',
    id: 40146,
    abbrName: 'BizDayCnvtn',
    description:
      "The business day convention used to adjust the instrument's provision's option expiration date. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionExpirationDateBusinessCenter',
    id: 40147,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the instrument\'s provision\'s option expiration date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionExpirationDateRelativeTo',
    id: 40148,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the option expiration date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionExpirationDateOffsetPeriod',
    id: 40149,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative option expiration date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionExpirationDateOffsetUnit',
    id: 40150,
    abbrName: 'OfstUnit',
    description: 'Time unit associated with the relative option expiration date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionExpirationDateOffsetDayType',
    id: 40151,
    abbrName: 'OfstDayTyp',
    description:
      "Specifies the day type of the provision's relative option expiration date offset.",
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionExpirationDateAdjusted',
    id: 40152,
    abbrName: 'Dt',
    description:
      'The adjusted last date within an exercise period for an American style option. For a European style option it is the only date within the exercise period.',
  },
  {
    type: 'LocalMktTime',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionExpirationTime',
    id: 40153,
    abbrName: 'ExpTm',
    description: 'The latest time for exercise on the expiration date.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionExpirationTimeBusinessCenter',
    id: 40154,
    abbrName: 'ExpTmBizCtr',
    description:
      "Identifies the business center calendar used with the provision's latest exercise time on expiration date.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.",
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionRelevantUnderlyingDateUnadjusted',
    id: 40155,
    abbrName: 'DtUnadj',
    description:
      'The unadjusted date on the underlying set by the exercise of an option. What this date is depends on the option (e.g. in a swaption it is the swap effective date, in an extendible/cancelable provision it is the swap termination date).',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionRelevantUnderlyingDateBusinessDayConvention',
    id: 40156,
    abbrName: 'BizDayCnvtn',
    description:
      "The business day convention used to adjust the instrument's provision's option underlying date. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionRelevantUnderlyingDateBusinessCenter',
    id: 40157,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the instrument\'s provision\'s option underlying date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionRelevantUnderlyingDateRelativeTo',
    id: 40158,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the date relevant to the underlying trade on exercise is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionRelevantUnderlyingDateOffsetPeriod',
    id: 40159,
    abbrName: 'OfstPeriod',
    description:
      'Time unit multiplier for the relative option relevant underlying date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionRelevantUnderlyingDateOffsetUnit',
    id: 40160,
    abbrName: 'OfstUnit',
    description:
      'Time unit associated with the relative option relevant underlying date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionRelevantUnderlyingDateOffsetDayType',
    id: 40161,
    abbrName: 'OfstDayTyp',
    description:
      "Specifies the day type of the provision's relative option relevant underlying date offset.",
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionOptionRelevantUnderlyingDateAdjusted',
    id: 40162,
    abbrName: 'Dt',
    description:
      'The adjusted date on the underlying set by the exercise of an option. What this date is depends on the option (e.g. in a swaption it is the swap effective date, in an extendible/cancelable provision it is the swap termination date).',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionCashSettlPaymentDateBusinessDayConvention',
    id: 40163,
    abbrName: 'BizDayCnvtn',
    description:
      "The business day convention used to adjust the provisional cash settlement payment's termination or relative termination date. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionCashSettlPaymentDateBusinessCenter',
    id: 40164,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the provisional cash settlement payment\'s termination or relative termination date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionCashSettlPaymentDateRelativeTo',
    id: 40165,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the cash settlement payment date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ProvisionCashSettlPaymentDateOffsetPeriod',
    id: 40166,
    abbrName: 'OfstPeriod',
    description:
      'Time unit multiplier for the relative cash settlement payment date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ProvisionCashSettlPaymentDateOffsetUnit',
    id: 40167,
    abbrName: 'OfstUnit',
    description:
      'Time unit associated with the relative cash settlement payment date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ProvisionCashSettlPaymentDateOffsetDayType',
    id: 40168,
    abbrName: 'OfstDayTyp',
    description:
      "Specifies the day type of the provision's relative cash settlement payment date offset.",
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionCashSettlPaymentDateRangeFirst',
    id: 40169,
    abbrName: 'DtFirst',
    description: 'First date in range when a settlement date range is provided.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionCashSettlPaymentDateRangeLast',
    id: 40170,
    abbrName: 'DtLast',
    description: 'The last date in range when a settlement date range is provided.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoProvisionCashSettlPaymentDates',
    id: 40171,
    description:
      'Number of provision cash settlement payment dates in the repeating group.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionCashSettlPaymentDate',
    id: 40172,
    abbrName: 'Dt',
    description:
      'The cash settlement payment date, unadjusted or adjusted depending on ProvisionCashSettlPaymentDateType(40173).',
  },
  {
    type: 'ProvisionCashSettlPaymentDateTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionCashSettlPaymentDateType',
    id: 40173,
    abbrName: 'Typ',
    description: 'Specifies the type of date (e.g. adjusted for holidays).',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoProvisionPartyIDs',
    id: 40174,
    description: 'Number of parties identified in the contract provision.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionPartyID',
    id: 40175,
    abbrName: 'ID',
    discriminatorId: '40176',
    description: 'The party identifier/code for the payment settlement party.',
  },
  {
    type: 'PartyIDSourceCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionPartyIDSource',
    id: 40176,
    abbrName: 'Src',
    description: 'Identifies class or source of the ProvisionPartyID(40175) value.',
  },
  {
    type: 'PartyRoleCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionPartyRole',
    id: 40177,
    abbrName: 'R',
    description: 'Identifies the type or role of ProvisionPartyID(40175) specified.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoProvisionPartySubIDs',
    id: 40178,
    description: 'Number of sub-party IDs to be reported for the party.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionPartySubID',
    id: 40179,
    abbrName: 'ID',
    description: 'Party sub-identifier, if applicable, for ProvisionPartyID(40175).',
  },
  {
    type: 'PartySubIDTypeCodeSet',
    unionDataType: 'Reserved4000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionPartySubIDType',
    id: 40180,
    abbrName: 'Typ',
    description: 'The type of ProvisionPartySubID(40179).',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoProtectionTerms',
    id: 40181,
    description: 'Number of protection terms in the repeating group.',
  },
  {
    type: 'Amt',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProtectionTermNotional',
    id: 40182,
    abbrName: 'Notl',
    description:
      'The notional amount of protection coverage.\n\nISDA 2003 Term: Floating Rate Payer Calculation Amount.',
  },
  {
    type: 'Currency',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProtectionTermCurrency',
    id: 40183,
    abbrName: 'Ccy',
    description:
      'The currency of ProtectionTermNotional(40182). Uses ISO 4217 currency codes.',
  },
  {
    type: 'Boolean',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProtectionTermSellerNotifies',
    id: 40184,
    abbrName: 'Seller',
    description:
      'The notifying party is the party that notifies the other party when a credit event has occurred by means of a credit event notice. If more than one party is referenced as being the notifying party then either party may notify the other of a credit event occurring.\n\nProtectionTermSellerNotifies(40184)=Y indicates that the seller notifies.\n\nISDA 2003 Term: Notifying Party.',
  },
  {
    type: 'Boolean',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProtectionTermBuyerNotifies',
    id: 40185,
    abbrName: 'Buyer',
    description:
      'The notifying party is the party that notifies the other party when a credit event has occurred by means of a credit event notice. If more than one party is referenced as being the notifying party then either party may notify the other of a credit event occurring.\n\nProtectionTermBuyerNotifies(40185)=Y indicates that the buyer notifies.\n\nISDA 2003 Term: Notifying Party.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProtectionTermEventBusinessCenter',
    id: 40186,
    abbrName: 'BizCtr',
    description:
      'When used, the business center indicates the local time of the business center that replaces the Greenwich Mean Time in Section 3.3 of the 2003 ISDA Credit Derivatives Definitions. See http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'Boolean',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProtectionTermStandardSources',
    id: 40187,
    abbrName: 'StdSrcs',
    description:
      'Indicates whether ISDA defined Standard Public Sources are applicable (ProtectionTermStandardSources(40187)=Y) or not.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProtectionTermEventMinimumSources',
    id: 40188,
    abbrName: 'MinSrcs',
    description:
      'The minimum number of the specified public information sources that must publish information that reasonably confirms that a credit event has occurred. The market convention is two.\n\nISDA 2003 Term: Specified Number.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProtectionTermEventNewsSource',
    id: 40189,
    abbrName: 'Src',
    description:
      'Newspaper or electronic news service or source that may publish relevant information used in the determination of whether or not a credit event has occurred.',
  },
  {
    type: 'XID',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProtectionTermXID',
    id: 40190,
    abbrName: 'XID',
    description:
      'A named string value referenced by UnderlyingProtectionTermXIDRef(41314).',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoProtectionTermEvents',
    id: 40191,
    description: 'Number of protection term events in the repeating group.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    addedEP: '161',
    updatedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'ProtectionTermEventType',
    id: 40192,
    abbrName: 'Typ',
    description:
      'Specifies the type of credit event applicable to the protection terms.\n\nSee http://www.fixtradingcommunity.org/codelists#Protection_Term_Event_Types for code list of applicable event types.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    addedEP: '161',
    updatedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'ProtectionTermEventValue',
    id: 40193,
    abbrName: 'Val',
    description:
      'Protection term event value appropriate to ProtectionTermEvenType(40192).\n\nSee http://www.fixtradingcommunity.org/codelists#Protection_Term_Event_Types for applicable event type values.',
  },
  {
    type: 'Currency',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProtectionTermEventCurrency',
    id: 40194,
    abbrName: 'Ccy',
    description:
      'Applicable currency if ProtectionTermEventValue(40193) is an amount. Uses ISO 4217 currency codes.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProtectionTermEventPeriod',
    id: 40195,
    abbrName: 'Period',
    description: 'Time unit multiplier for protection term events.',
  },
  {
    type: 'ProtectionTermEventUnitCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProtectionTermEventUnit',
    id: 40196,
    abbrName: 'Unit',
    description: 'Time unit associated with protection term events.',
  },
  {
    updated: 'FIX.Latest',
    type: 'ProtectionTermEventDayTypeCodeSet',
    addedEP: '161',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'ProtectionTermEventDayType',
    id: 40197,
    abbrName: 'DayTyp',
    description: 'Day type for events that specify a period and unit.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProtectionTermEventRateSource',
    id: 40198,
    abbrName: 'RtSrc',
    description:
      'Rate source for events that specify a rate source, e.g. Floating rate interest shortfall.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoProtectionTermEventQualifiers',
    id: 40199,
    description: 'Number of qualifiers in the repeating group.',
  },
  {
    type: 'ProtectionTermEventQualifierCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProtectionTermEventQualifier',
    id: 40200,
    abbrName: 'Qual',
    description:
      'Protection term event qualifier. Used to further qualify ProtectionTermEventType(40192).',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoProtectionTermObligations',
    id: 40201,
    description: 'Number of obligations in the repeating group.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    addedEP: '161',
    updatedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'ProtectionTermObligationType',
    id: 40202,
    abbrName: 'Typ',
    description:
      'Specifies the type of obligation applicable to the protection terms.\n\nSee http://www.fixtradingcommunity.org/codelists#Protection_Term_Obligation_Types for code list of applicable obligation types.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    addedEP: '161',
    updatedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'ProtectionTermObligationValue',
    id: 40203,
    abbrName: 'Val',
    description:
      'Protection term obligation value appropriate to ProtectionTermObligationType(40202).\n\nSee http://www.fixtradingcommunity.org/codelists#Protection_Term_Obligation_Types for applicable obligation type values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoPhysicalSettlTerms',
    id: 40204,
    description: 'Number of entries in the repeating group.',
  },
  {
    type: 'Currency',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PhysicalSettlCurrency',
    id: 40205,
    abbrName: 'Ccy',
    description:
      'Specifies the currency of physical settlement. Uses ISO 4217 currency codes.',
  },
  {
    updated: 'FIX.Latest',
    type: 'int',
    addedEP: '161',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'PhysicalSettlBusinessDays',
    id: 40206,
    abbrName: 'BizDays',
    description:
      'The number of business days used in the determination of physical settlement. Its precise meaning depends on the context in which this element is used.\n\nISDA 2003 Term: Business Day.',
  },
  {
    updated: 'FIX.Latest',
    type: 'int',
    addedEP: '161',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'PhysicalSettlMaximumBusinessDays',
    id: 40207,
    abbrName: 'MaxBizDays',
    description:
      'A maximum number of business days. Its precise meaning depends on the context in which this element is used. Intended to be used to limit a particular ISDA fallback provision.',
  },
  {
    type: 'XID',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PhysicalSettlTermXID',
    id: 40208,
    abbrName: 'XID',
    description: 'A named string value referenced by UnderlyingSettlTermXIDRef(41315).',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoPhysicalSettlDeliverableObligations',
    id: 40209,
    description: 'Number of entries in the repeating group.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    addedEP: '161',
    updatedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PhysicalSettlDeliverableObligationType',
    id: 40210,
    abbrName: 'Typ',
    description:
      'Specifies the type of deliverable obligation applicable for physical settlement. See http://www.fixtradingcommunity.org/codelists#Deliverable_Obligation_Types for code list for applicable deliverable obligation types.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    addedEP: '161',
    updatedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PhysicalSettlDeliverableObligationValue',
    id: 40211,
    abbrName: 'Val',
    description:
      'Physical settlement deliverable obligation value appropriate to PhysicalSettlDeliverableObligationType(40210). See http://www.fixtradingcommunity.org/codelists#Deliverable_Obligation_Types for applicable obligation type values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoPayments',
    id: 40212,
    description: 'Number of additional settlement or bullet payments.',
  },
  {
    type: 'PaymentTypeCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentType',
    id: 40213,
    abbrName: 'Typ',
    description: 'Type of payment.',
  },
  {
    type: 'PaymentPaySideCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentPaySide',
    id: 40214,
    abbrName: 'PaySide',
    description: 'The side of the party paying the payment.',
  },
  {
    type: 'PaymentPaySideCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentReceiveSide',
    id: 40215,
    abbrName: 'RcvSide',
    description: 'The side of the party receiving the payment.',
  },
  {
    type: 'Currency',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentCurrency',
    id: 40216,
    abbrName: 'Ccy',
    description:
      'Specifies the currency in which PaymentAmount(40217) is denominated. Uses ISO 4271 currency codes.',
  },
  {
    type: 'Amt',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentAmount',
    id: 40217,
    abbrName: 'Amt',
    description: 'The total payment amount.',
  },
  {
    type: 'Price',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentPrice',
    id: 40218,
    abbrName: 'Px',
    description:
      'The price determining the payment amount expressed in terms specified in PaymentPriceType(40919) and expressed in market format.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentDateUnadjusted',
    id: 40219,
    abbrName: 'DtUnadj',
    description: 'The unadjusted payment date.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentBusinessDayConvention',
    id: 40220,
    abbrName: 'BizDayCnvtn',
    description:
      'The business day convention used to adjust the payment date. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentBusinessCenter',
    id: 40221,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the payment date, e.g. "GBLO". See http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentDateAdjusted',
    id: 40222,
    abbrName: 'Dt',
    description: 'The adjusted payment date.',
  },
  {
    type: 'float',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentDiscountFactor',
    id: 40224,
    abbrName: 'DiscFctr',
    description:
      'The value representing the discount factor used to calculate the present value of the cash flow.',
  },
  {
    type: 'Amt',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentPresentValueAmount',
    id: 40225,
    abbrName: 'PVAmt',
    description: 'The amount representing the present value of the forecast payment.',
  },
  {
    type: 'Currency',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentPresentValueCurrency',
    id: 40226,
    abbrName: 'PVCcy',
    description:
      'Specifies the currency the PaymentPresentValueAmount(40225) is denominated in. Uses ISO 4217 currency codes.',
  },
  {
    type: 'PaymentSettlStyleCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentSettlStyle',
    id: 40227,
    abbrName: 'SettlStyle',
    description: 'Payment settlement style.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamNonDeliverableSettlReferencePage',
    id: 40228,
    abbrName: 'RefPg',
    description:
      'Identifies the reference "page" from the rate source.\n\nWhen LegPaymentStreamNonDeliverableSettlRateSource(40087) = 3 (ISDA Settlement Rate Option) this contains a value from the scheme that reflects the terms of the Annex A to the ISDA 1998 FX and Currency Option Definitions. See: http://www.fpml.org/coding-scheme/settlement-rate-option',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentText',
    id: 40229,
    abbrName: 'Txt',
    description:
      'Free form text to specify additional information or enumeration description when a sdtandard value does not apply. Identifies the payment type when PaymentType(40213) = 99 (Other).',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoPaymentSettls',
    id: 40230,
    description: 'Number of additional settlements or bullet payments.',
  },
  {
    type: 'Amt',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentSettlAmount',
    id: 40231,
    abbrName: 'Amt',
    description: 'The payment settlement amount.',
  },
  {
    type: 'Currency',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentSettlCurrency',
    id: 40232,
    abbrName: 'Ccy',
    description:
      'Specifies the currency the PaymentSettlAmount(40231) is denominated in. Uses ISO 4217 currency codes.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoPaymentSettlPartyIDs',
    id: 40233,
    description:
      'Number of parties identified in the additional settlement or bullet payment.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentSettlPartyID',
    id: 40234,
    abbrName: 'ID',
    discriminatorId: '40235',
    description: 'The payment settlement party identifier.',
  },
  {
    type: 'PartyIDSourceCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentSettlPartyIDSource',
    id: 40235,
    abbrName: 'Src',
    description:
      'Identifies the class or source of PaymentSettlPartyID(40234) value (e.g. BIC).',
  },
  {
    type: 'PartyRoleCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentSettlPartyRole',
    id: 40236,
    abbrName: 'R',
    description:
      "Identifies the role of PaymentSettlPartyID(40234) (e.g. the beneficiary's bank or depository institution).",
  },
  {
    type: 'PartyDetailRoleQualifierCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentSettlPartyRoleQualifier',
    id: 40237,
    abbrName: 'Qual',
    description: 'Qualifies the value of PaymentSettlPartyRole(40236).',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoPaymentSettlPartySubIDs',
    id: 40238,
    description: 'Number of sub-party IDs to be reported for the party.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentSettlPartySubID',
    id: 40239,
    abbrName: 'ID',
    description: 'Party sub-identifier, if applicable, for PaymentSettlPartyRole(40236).',
  },
  {
    type: 'PartySubIDTypeCodeSet',
    unionDataType: 'Reserved4000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentSettlPartySubIDType',
    id: 40240,
    abbrName: 'Typ',
    description: 'The type of PaymentSettlPartySubID(40239) value.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoLegStreams',
    id: 40241,
    description: 'Number of swap streams in the repeating group.',
  },
  {
    type: 'StreamTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegStreamType',
    id: 40242,
    abbrName: 'Typ',
    description: 'Type of swap stream.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegStreamDesc',
    id: 40243,
    abbrName: 'Desc',
    description:
      'A short descriptive name given to the payment stream, e.g. CDS, Fixed, Float, Float2, GBP. The description has no intrinsic meaning but should be arbitrarily chosen by the remitter as a reference.',
  },
  {
    type: 'PaymentPaySideCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegStreamPaySide',
    id: 40244,
    abbrName: 'PaySide',
    description: 'The side of the party paying the stream.',
  },
  {
    type: 'PaymentPaySideCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegStreamReceiveSide',
    id: 40245,
    abbrName: 'RcvSide',
    description: 'The side of the party receiving the stream.',
  },
  {
    type: 'Amt',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegStreamNotional',
    id: 40246,
    abbrName: 'Notl',
    description:
      'Notional, or initial notional value for the payment stream. The LegPaymentSchedule component should be used for specifying the steps.',
  },
  {
    type: 'Currency',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCurrency',
    id: 40247,
    abbrName: 'Ccy',
    description:
      'Specifies the currency the LegStreamNotional(40246) is denominated in. Uses ISO 4217 currency codes.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegStreamText',
    id: 40248,
    abbrName: 'Txt',
    description:
      'Free form text to specify additional information or enumeration description when a standard value does not apply.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegStreamEffectiveDateUnadjusted',
    id: 40249,
    abbrName: 'DtUnadj',
    description: 'The unadjusted effective date.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegStreamEffectiveDateBusinessDayConvention',
    id: 40250,
    abbrName: 'BizDayCnvtn',
    description:
      "The business day convention used to adjust the instrument leg's stream's effective date or relative effective date. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegStreamEffectiveDateBusinessCenter',
    id: 40251,
    abbrName: 'BizCtr',
    description:
      'The business center calendar used to adjust the instrument leg\'s stream\'s effective date or relative effective date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegStreamEffectiveDateRelativeTo',
    id: 40252,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the effective date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegStreamEffectiveDateOffsetPeriod',
    id: 40253,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative effective date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegStreamEffectiveDateOffsetUnit',
    id: 40254,
    abbrName: 'OfstUnit',
    description: 'Time unit associated with the relative effective date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegStreamEffectiveDateOffsetDayType',
    id: 40255,
    abbrName: 'OfstDayTyp',
    description: 'Specifies the day type of the relative effective date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegStreamEffectiveDateAdjusted',
    id: 40256,
    abbrName: 'Dt',
    description: 'The adjusted effective date.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegStreamTerminationDateUnadjusted',
    id: 40257,
    abbrName: 'DtUnadj',
    description: 'The unadjusted termination date.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegStreamTerminationDateBusinessDayConvention',
    id: 40258,
    abbrName: 'BizDayCnvtn',
    description:
      "The business day convention used to adjust the instrument leg's stream's termination, or relative termination, date. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegStreamTerminationDateBusinessCenter',
    id: 40259,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the instrument leg\'s stream\'s termination, or relative termination, date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegStreamTerminationDateRelativeTo',
    id: 40260,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the termination date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegStreamTerminationDateOffsetPeriod',
    id: 40261,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative termination date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegStreamTerminationDateOffsetUnit',
    id: 40262,
    abbrName: 'OfstUnit',
    description: 'Time unit associated with the relative termination date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegStreamTerminationDateOffsetDayType',
    id: 40263,
    abbrName: 'OfstDayTyp',
    description: 'Specifies the day type of the relative termination date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegStreamTerminationDateAdjusted',
    id: 40264,
    abbrName: 'Dt',
    description: 'The adjusted termination date.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCalculationPeriodBusinessDayConvention',
    id: 40265,
    abbrName: 'BizDayCnvtn',
    description:
      'The business day convention used to adjust calculation periods. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCalculationPeriodBusinessCenter',
    id: 40266,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust calculation periods, e.g. "GLBO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegStreamFirstPeriodStartDateUnadjusted',
    id: 40267,
    abbrName: 'FirstStartDtUnadj',
    description:
      'The unadjusted first calculation period start date if before the effective date.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegStreamFirstPeriodStartDateBusinessDayConvention',
    id: 40268,
    abbrName: 'FirstStartDtBizDayCnvtn',
    description:
      "The business day convention used to adjust the instrument leg's stream's first calculation period start date. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegStreamFirstPeriodStartDateBusinessCenter',
    id: 40269,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the instrument leg\'s stream\'s first calculation period start date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegStreamFirstPeriodStartDateAdjusted',
    id: 40270,
    abbrName: 'FirstStartDt',
    description:
      'The adjusted first calculation period start date, if it is before the effective date.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegStreamFirstRegularPeriodStartDateUnadjusted',
    id: 40271,
    abbrName: 'FirstReglrStartDtUnadj',
    description:
      'The unadjusted first start date of the regular calculation period, if there is an initial stub period.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegStreamFirstCompoundingPeriodEndDateUnadjusted',
    id: 40272,
    abbrName: 'FirstCmpndgEndDtUnadj',
    description: 'The unadjusted end date of the initial compounding period.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegStreamLastRegularPeriodEndDateUnadjusted',
    id: 40273,
    abbrName: 'LastReglrEndDtUnadj',
    description:
      'The unadjusted last regular period end date if there is a final stub period.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCalculationFrequencyPeriod',
    id: 40274,
    abbrName: 'FreqPeriod',
    description:
      'Time unit multiplier for the frequency at which calculation period end dates occur.',
  },
  {
    type: 'CouponFrequencyUnitCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCalculationFrequencyUnit',
    id: 40275,
    abbrName: 'FreqUnit',
    description:
      'Time unit associated with the frequency at which calculation period end dates occur.',
  },
  {
    type: 'DateRollConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCalculationRollConvention',
    id: 40276,
    abbrName: 'Roll',
    description:
      'The convention for determining the sequence of end dates. It is used in conjunction with a specified frequency. Used only to override the roll convention specified in the LegDateAdjustment component within the InstrumentLeg component.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoCashSettlDealers',
    id: 40277,
    description: 'Number of dealers in the repeating group.',
  },
];

const batch4: ISpecFields[] = [
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoBusinessCenters',
    id: 40278,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'PaymentStreamTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamType',
    id: 40279,
    abbrName: 'Typ',
    description:
      'Identifies the type of payment stream applicable to the swap stream associated with the instrument leg.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamMarketRate',
    id: 40280,
    abbrName: 'MktRt',
    description:
      'Used only for credit index trade. This contains the credit spread ("fair value") at which the trade was executed. The market rate varies over the life of the index depending on market conditions. This is the price of the index as quoted by trading desks.',
  },
  {
    type: 'Boolean',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamDelayIndicator',
    id: 40281,
    abbrName: 'DelayInd',
    description:
      'Applicable to credit default swaps on mortgage backed securities to specify whether payment delays are applicable to the fixed amount.\n\nResidential mortgage backed securities typically have a payment delay of 5 days between the coupon date of the reference obligation and the payment date of the synthetic swap.\n\nCommercial mortage backed securities do not typically have a payment delay, with both payment dates (the coupon date of the reference obligation and the payment date of the synthetic swap) being on the 25th of each month.',
  },
  {
    type: 'Currency',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamSettlCurrency',
    id: 40282,
    abbrName: 'SettlCcy',
    description:
      'Specifies the currency that the stream settles in (to support swaps that settle in a currency different from the notional currency). Uses ISO 4217 currency codes.',
  },
  {
    type: 'CouponDayCountCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamDayCount',
    id: 40283,
    abbrName: 'DayCnt',
    description: 'The day count convention used in the payment stream calculations.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamAccrualDays',
    id: 40284,
    abbrName: 'AcrlDays',
    description:
      'The number of days from the adjusted calculation period start date to the adjusted value date, calculated in accordance with the applicable day count fraction.',
  },
  {
    type: 'PaymentStreamDiscountTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamDiscountType',
    id: 40285,
    abbrName: 'DiscTyp',
    description: 'The method of calculating discounted payment amounts.',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamDiscountRate',
    id: 40286,
    abbrName: 'Disc',
    description:
      'Discount rate. The rate is expressed in decimal, e.g. 5% is expressed as 0.05.',
  },
  {
    type: 'CouponDayCountCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamDiscountRateDayCount',
    id: 40287,
    abbrName: 'DiscDayCnt',
    description:
      'The day count convention applied to the LegPaymentStreamDiscountRate(40286).',
  },
  {
    type: 'PaymentStreamCompoundingMethodCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingMethod',
    id: 40288,
    abbrName: 'CmpndgMeth',
    description: 'Compounding method.',
  },
  {
    type: 'Boolean',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamInitialPrincipalExchangeIndicator',
    id: 40289,
    abbrName: 'InitPrncplExchInd',
    description:
      'Indicates whether there is an initial exchange of principal on the effective date.',
  },
  {
    type: 'Boolean',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamInterimPrincipalExchangeIndicator',
    id: 40290,
    abbrName: 'IntrmPrncplExchInd',
    description:
      'Indicates whether there are intermediate or interim exchanges of principal during the term of the swap.',
  },
  {
    type: 'Boolean',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFinalPrincipalExchangeIndicator',
    id: 40291,
    abbrName: 'FnlPrncplExchInd',
    description:
      'Indicates whether there is a final exchange of principal on the termination date.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamPaymentDateBusinessDayConvention',
    id: 40292,
    abbrName: 'BizDayCnvtn',
    description:
      "The business day convention used to adjust the payment stream's payment date. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamPaymentDateBusinessCenter',
    id: 40293,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the payment stream\'s payment date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamPaymentFrequencyPeriod',
    id: 40294,
    abbrName: 'FreqPeriod',
    description: 'Time unit multiplier for the frequency of payments.',
  },
  {
    type: 'PaymentStreamPaymentFrequencyUnitCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamPaymentFrequencyUnit',
    id: 40295,
    abbrName: 'FreqUnit',
    description: 'Time unit associated with the frequency of payments.',
  },
  {
    type: 'DateRollConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamPaymentRollConvention',
    id: 40296,
    abbrName: 'Roll',
    description:
      'The convention for determining the sequence of end dates. It is used in conjunction with a specified frequency. Used only to override the roll convention specified in the LegDateAdjustment component within the InstrumentLeg component.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFirstPaymentDateUnadjusted',
    id: 40297,
    abbrName: 'FirstDtUnadj',
    description: 'The unadjusted first payment date.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamLastRegularPaymentDateUnadjusted',
    id: 40298,
    abbrName: 'LastReglrDtUnadj',
    description: 'The unadjusted last regular payment date.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamPaymentDateRelativeTo',
    id: 40299,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when payment dates are relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamPaymentDateOffsetPeriod',
    id: 40300,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative payment date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamPaymentDateOffsetUnit',
    id: 40301,
    abbrName: 'OfstUnit',
    description: 'Time unit associated with the relative payment date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamPaymentDateOffsetDayType',
    id: 40302,
    abbrName: 'OfstDayTyp',
    description: 'Specifies the day type of the relative payment date offset.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamResetDateRelativeTo',
    id: 40303,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the reset dates are relative to an anchor date.\n\nIf the reset frequency is specified as daily this element must not be included.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamResetDateBusinessDayConvention',
    id: 40304,
    abbrName: 'BizDayCnvtn',
    description:
      "The business day convention used to adjust the payment stream's reset date. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamResetDateBusinessCenter',
    id: 40305,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the payment stream\'s reset date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamResetFrequencyPeriod',
    id: 40306,
    abbrName: 'FreqPeriod',
    description: 'Time unit multiplier for frequency of resets.',
  },
  {
    type: 'CouponFrequencyUnitCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamResetFrequencyUnit',
    id: 40307,
    abbrName: 'FreqUnit',
    description: 'Time unit associated with frequency of resets.',
  },
  {
    type: 'PaymentStreamResetWeeklyRollConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamResetWeeklyRollConvention',
    id: 40308,
    abbrName: 'WklyRoll',
    description:
      'Used to specify the day of the week in which the reset occurs for payments that reset on a weekly basis.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamInitialFixingDateRelativeTo',
    id: 40309,
    abbrName: 'InitReltv',
    description:
      'Specifies the anchor date when the initial fixing date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamInitialFixingDateBusinessDayConvention',
    id: 40310,
    abbrName: 'InitBizDayCnvtn',
    description:
      "The business day convention used to adjust the payment stream's initial fixing date. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamInitialFixingDateBusinessCenter',
    id: 40311,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the payment stream\'s initial fixing date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamInitialFixingDateOffsetPeriod',
    id: 40312,
    abbrName: 'InitPeriod',
    description: 'Time unit multiplier for the relative initial fixing date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamInitialFixingDateOffsetUnit',
    id: 40313,
    abbrName: 'InitUnit',
    description: 'Time unit associated with the relative initial fixing date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamInitialFixingDateOffsetDayType',
    id: 40314,
    abbrName: 'InitDayTyp',
    description: 'Specifies the day type of the relative initial fixing date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamInitialFixingDateAdjusted',
    id: 40315,
    abbrName: 'InitDt',
    description: 'The adjusted initial fixing date.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFixingDateRelativeTo',
    id: 40316,
    abbrName: 'FixngReltv',
    description:
      'Specifies the anchor date when the fixing date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFixingDateBusinessDayConvention',
    id: 40317,
    abbrName: 'FixngBizDayCnvtn',
    description:
      "The business day convention used to adjust the payment stream's fixing date. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFixingDateBusinessCenter',
    id: 40318,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the payment stream\'s fixing date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFixingDateOffsetPeriod',
    id: 40319,
    abbrName: 'FixngPeriod',
    description: 'Time unit multiplier for the relative fixing date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFixingDateOffsetUnit',
    id: 40320,
    abbrName: 'FixngUnit',
    description: 'Time unit associated with the relative fixing date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFixingDateOffsetDayType',
    id: 40321,
    abbrName: 'FixngDayTyp',
    description: 'Specifies the day type of the relative fixing date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFixingDateAdjusted',
    id: 40322,
    abbrName: 'FixngDt',
    description: 'The adjusted fixing date.',
  },
  {
    updated: 'FIX.Latest',
    type: 'int',
    addedEP: '161',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamRateCutoffDateOffsetPeriod',
    id: 40323,
    abbrName: 'CutoffPeriod',
    description:
      'Time unit multiplier for the relative rate cut-off date offset.\n\nThis is generally the number of days preceding the period end date or termination date, as appropriate, for the specified floating rate index.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamRateCutoffDateOffsetUnit',
    id: 40324,
    abbrName: 'CutoffUnit',
    description: 'Time unit associated with the relative rate cut-off date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamRateCutoffDateOffsetDayType',
    id: 40325,
    abbrName: 'CutoffDayTyp',
    description: 'Specifies the day type of the relative rate cut-off date offset.',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamRate',
    id: 40326,
    abbrName: 'Rt',
    description: 'The rate applicable to the fixed rate payment stream.',
  },
  {
    type: 'Amt',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFixedAmount',
    id: 40327,
    abbrName: 'Amt',
    description:
      "The leg instrument payment stream's fixed payment amount. In a CDS, this can be an alternative to LegPaymentStreamRate(40326).",
  },
  {
    type: 'Currency',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamRateOrAmountCurrency',
    id: 40328,
    abbrName: 'Ccy',
    description:
      'Specifies the currency in which LegPaymentStreamFixedAmount(40327) or LegPaymentStreamRate(40326) is denominated. Uses ISO 4217 currency codes.',
  },
  {
    type: 'Amt',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFutureValueNotional',
    id: 40329,
    abbrName: 'FutValNotl',
    description:
      'The future value notional is normally only required for certain non-deliverable interest rate swaps (e.g. Brazillian Real (BRL) vs. CETIP Interbank Deposit Rate (CDI)). The value is calculated as follows: Future Value Notional = Notional Amount * (1 + Fixed Rate) ^ (Fixed Rate Day Count Fraction). The currency is the same as the stream notional.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFutureValueDateAdjusted',
    id: 40330,
    abbrName: 'FutValDt',
    description: 'The adjusted value date of the future value amount.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamRateIndex',
    id: 40331,
    abbrName: 'Ndx',
    discriminatorId: '40332',
    description: 'The payment stream floating rate index.',
  },
  {
    type: 'PaymentStreamRateIndexSourceCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamRateIndexSource',
    id: 40332,
    abbrName: 'NdxSrc',
    description: 'The source of the payment stream floating rate index.',
  },
  {
    type: 'PaymentStreamRateIndexCurveUnitCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamRateIndexCurveUnit',
    id: 40333,
    abbrName: 'NdxUnit',
    description:
      "Time unit associated with the payment stream's floating rate index curve period.",
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamRateIndexCurvePeriod',
    id: 40334,
    abbrName: 'NdxPeriod',
    description:
      "Time unit multiplier for the payment stream's floating rate index curve period.",
  },
  {
    type: 'float',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamRateMultiplier',
    id: 40335,
    abbrName: 'RtMult',
    description:
      'A rate multiplier to apply to the floating rate. The multiplier can be less than or greater than 1 (one). This element should only be included if the multiplier is not equal to 1 (one) for the term of the stream.',
  },
  {
    type: 'PriceOffset',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamRateSpread',
    id: 40336,
    abbrName: 'Spread',
    description:
      'The basis points spread from the index specified in LegPaymentStreamRateIndex(40331).',
  },
  {
    type: 'PaymentStreamRateSpreadPositionTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamRateSpreadPositionType',
    id: 40337,
    abbrName: 'SpreadPosTyp',
    description:
      'Identifies whether the rate spread is applied to a long or short position.',
  },
  {
    type: 'PaymentStreamRateTreatmentCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamRateTreatment',
    id: 40338,
    abbrName: 'RtTrtmt',
    description: 'Specifies the yield calculation treatment for the index.',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCapRate',
    id: 40339,
    abbrName: 'CapRt',
    description:
      'The cap rate, if any, which applies to the floating rate. It is only required where the floating rate on a swap stream is capped at a certain level The cap rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A cap rate of 5% would be represented as 0.05.',
  },
  {
    type: 'PaymentStreamCapRateBuySideCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCapRateBuySide',
    id: 40340,
    abbrName: 'CapRtBuy',
    description: 'Reference to the buyer of the cap rate option through its trade side.',
  },
  {
    type: 'PaymentStreamCapRateBuySideCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCapRateSellSide',
    id: 40341,
    abbrName: 'CapRtSell',
    description: 'Reference to the seller of the cap rate option through its trade side.',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFloorRate',
    id: 40342,
    abbrName: 'FlrRt',
    description:
      'The floor rate, if any, which applies to the floating rate. The floor rate (strike) is only required where the floating rate on a swap stream is floored at a certain strike level The floor rate is assumed to be exclusive of any spread and is a per annum rate. The rate is expressed as a decimal, e.g. 5% is represented as 0.05.',
  },
  {
    type: 'PaymentStreamFloorRateBuySideCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFloorRateBuySide',
    id: 40343,
    abbrName: 'FlrRtBuy',
    description:
      'Reference to the buyer of the floor rate option through its trade side.',
  },
  {
    type: 'PaymentStreamFloorRateBuySideCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFloorRateSellSide',
    id: 40344,
    abbrName: 'FlrRtSell',
    description:
      'Reference to the seller of the floor rate option through its trade side.',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamInitialRate',
    id: 40345,
    abbrName: 'InitRt',
    description:
      'The initial floating rate reset agreed between the principal parties involved in the trade. This is assumed to be the first required reset rate for the first regular calculation period. It should only be included when the rate is not equal to the rate published on the source implied by the floating rate index. The initial rate is expressed in decimal form, e.g. 5% is represented as 0.05.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'RoundingDirectionCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFinalRateRoundingDirection',
    id: 40346,
    abbrName: 'FnlRtRndDirctn',
    description: 'Specifies the rounding direction.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFinalRatePrecision',
    id: 40347,
    abbrName: 'FnlRtPrcsn',
    description:
      'Specifies the rounding precision in terms of a number of decimal places. Note how a percentage rate rounding of 5 decimal places is expressed as a rounding precision of 7.',
  },
  {
    type: 'PaymentStreamAveragingMethodCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamAveragingMethod',
    id: 40348,
    abbrName: 'AvgngMeth',
    description:
      'When averaging is applicable, used to specify whether a weighted or unweighted average method of calculation is to be used.',
  },
  {
    type: 'PaymentStreamNegativeRateTreatmentCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamNegativeRateTreatment',
    id: 40349,
    abbrName: 'NegtvRtTrtmt',
    description:
      'The specification of any provisions for calculating payment obligations when a floating rate is negative (either due to a quoted negative floating rate or by operation of a spread that is subtracted from the floating rate).',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamInflationLagPeriod',
    id: 40350,
    abbrName: 'LagPeriod',
    description:
      'Time unit multiplier for the inflation lag period. The lag period is the offsetting period from the payment date which determineds the reference period for which the inflation index is observed.',
  },
  {
    type: 'PaymentStreamInflationLagUnitCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamInflationLagUnit',
    id: 40351,
    abbrName: 'LagUnit',
    description: 'Time unit associated with the inflation lag period.',
  },
  {
    type: 'PaymentStreamInflationLagDayTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamInflationLagDayType',
    id: 40352,
    abbrName: 'LagDayTyp',
    description: 'The inflation lag period day type.',
  },
  {
    type: 'PaymentStreamInflationInterpolationMethodCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamInflationInterpolationMethod',
    id: 40353,
    abbrName: 'IntrpltnMeth',
    description:
      'The method used when calculating the inflation index level from multiple points. The most common is linear method.',
  },
  {
    type: 'PaymentStreamRateIndexSourceCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamInflationIndexSource',
    id: 40354,
    abbrName: 'InfltnNdxSrc',
    description: 'The inflation index reference source.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamInflationPublicationSource',
    id: 40355,
    abbrName: 'PublctnSrc',
    description:
      'The publication source, such as relevant web site, news publication or a government body, where inflation information is obtained.',
  },
  {
    type: 'float',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamInflationInitialIndexLevel',
    id: 40356,
    abbrName: 'InitLvl',
    description: 'Initial known index level for the first calculation period.',
  },
  {
    type: 'Boolean',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamInflationFallbackBondApplicable',
    id: 40357,
    abbrName: 'FallbckBond',
    description:
      'Indicates whether a fallback bond as defined in the 2006 ISDA Inflation Derivatives Definitions, sections 1.3 and 1.8, is applicable or not. If not specified, the default value is "Y" (True/Yes).',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamFRADiscountingCodeSet',
    addedEP: '161',
    updatedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFRADiscounting',
    id: 40358,
    abbrName: 'FRADisc',
    description:
      'The method of Forward Rate Agreement (FRA) discounting, if any, that will apply.',
  },
  {
    type: 'Currency',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamNonDeliverableRefCurrency',
    id: 40359,
    abbrName: 'Ccy',
    description:
      'Non-deliverable settlement reference currency. Uses ISO 4217 currency codes.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamNonDeliverableFixingDatesBusinessDayConvention',
    id: 40360,
    abbrName: 'BizDayCnvtn',
    description:
      "The business day convention used to adjust the payment stream's fixing date for the non-deliverable settlement terms. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamNonDeliverableFixingDatesBusinessCenter',
    id: 40361,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the payment stream\'s fixing date for the non-deliverable terms, e.g. "GBLO". See http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamNonDeliverableFixingDatesRelativeTo',
    id: 40362,
    abbrName: 'FixngReltv',
    description:
      'Specifies the anchor date when the non-deliverable fixing dates are relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamNonDeliverableFixingDatesOffsetPeriod',
    id: 40363,
    abbrName: 'FixngPeriod',
    description:
      'Time unit multiplier for the relative non-deliverable fixing date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamNonDeliverableFixingDatesOffsetUnit',
    id: 40364,
    abbrName: 'FixngUnit',
    description:
      'Time unit associated with the relative non-deliverable fixing date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamNonDeliverableFixingDatesOffsetDayType',
    id: 40365,
    abbrName: 'FixngDayTyp',
    description:
      'Specifies the day type of the relative non-deliverable fixing date offset.',
  },
  {
    type: 'RateSourceCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegSettlRateFallbackRateSource',
    id: 40366,
    abbrName: 'RtSrc',
    description: 'Identifies the source of rate information.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoLegNonDeliverableFixingDates',
    id: 40367,
    description: 'Number of fixing dates in the repeating group.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegNonDeliverableFixingDate',
    id: 40368,
    abbrName: 'Dt',
    description:
      'The non-deliverable fixing date. Type of date is specified in LegNonDeliverableFixingDateType(40369).',
  },
  {
    type: 'NonDeliverableFixingDateTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegNonDeliverableFixingDateType',
    id: 40369,
    abbrName: 'Typ',
    description: 'Specifies the type of date (e.g. adjusted for holidays).',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegSettlRateFallbackReferencePage',
    id: 40370,
    abbrName: 'RefPg',
    description:
      'Identifies the reference "page" from the rate source.\n\nWhen LegSettlRateFallbackRateSource(40366) = 3(ISDA Settlement Rate Option) this contains the value from the scheme that reflects the terms of the Annex A to the ISDA 1998 FX and Currency Option Definitions. See: http://www.fpml.org/coding-scheme/settlement-rate-option',
  },
  {
    type: 'RateSourceCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamNonDeliverableSettlRateSource',
    id: 40371,
    abbrName: 'RtSrc',
    description: 'Identifies the source of rate information.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamNonDeliverableSettlReferencePage',
    id: 40372,
    abbrName: 'RefPg',
    description:
      'Identifies the reference "page" from the rate source.\n\nWhen PaymentStreamNonDeliverableSettlRateSource(40371) = 3(ISDA Settlement Rate Option) this contains the value from the scheme that reflects the terms of the Annex A to the ISDA 1998 FX and Currency Option Definitions. See: http://www.fpml.org/coding-scheme/settlement-rate-option',
  },
  {
    type: 'RateSourceCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'SettlRateFallbackRateSource',
    id: 40373,
    abbrName: 'RtSrc',
    description: 'Identifies the source of rate information.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoLegPaymentSchedules',
    id: 40374,
    description: 'Number of swap schedules in the repeating group',
  },
  {
    type: 'PaymentScheduleTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleType',
    id: 40375,
    abbrName: 'Typ',
    description: 'Specifies the type of schedule.',
  },
  {
    type: 'PaymentStubTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleStubType',
    id: 40376,
    abbrName: 'StubTyp',
    description: 'Indicates to which stub this schedule applies.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleStartDateUnadjusted',
    id: 40377,
    abbrName: 'StartDtUnadj',
    description:
      'The unadjusted date on which the value is adjusted, or calculated if a future value notional for certain non-deliverable interest rate swaps (e.g. Brazillian Real (BRL) vs. CETIP Interbank Deposit Rate (CDI)), or the start date of a cashflow payment.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleEndDateUnadjusted',
    id: 40378,
    abbrName: 'EndDtUnadj',
    description: 'The unadjusted end date of a cashflow payment.',
  },
  {
    type: 'PaymentPaySideCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentSchedulePaySide',
    id: 40379,
    abbrName: 'PaySide',
    description: 'The side of the party paying the step schedule.',
  },
  {
    type: 'PaymentPaySideCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleReceiveSide',
    id: 40380,
    abbrName: 'RcvSide',
    description: 'The side of the party receiving the step schedule.',
  },
  {
    type: 'Amt',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleNotional',
    id: 40381,
    abbrName: 'Notl',
    description:
      'The notional value for this step schedule, or amount of a cashflow payment.',
  },
  {
    type: 'Currency',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleCurrency',
    id: 40382,
    abbrName: 'Ccy',
    description: 'The currency for this step schedule. Uses ISO 4217 currency codes.',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleRate',
    id: 40383,
    abbrName: 'Rt',
    discriminatorId: '40415',
    description: 'The rate value for this step schedule.',
  },
  {
    type: 'float',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleRateMultiplier',
    id: 40384,
    abbrName: 'RtMult',
    description:
      'A rate multiplier to apply to the floating rate. The multiplier can be less than or greater than 1 (one). This element should only be included if the multiplier is not equal to 1 (one) for the term of the stream.',
  },
  {
    type: 'PriceOffset',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleRateSpread',
    id: 40385,
    abbrName: 'Spread',
    description: 'The spread value for this step schedule.',
  },
  {
    type: 'PaymentStreamRateSpreadPositionTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleRateSpreadPositionType',
    id: 40386,
    abbrName: 'SpreadPosTyp',
    description:
      'Identifies whether the rate spread is applied to a long or a short position.',
  },
  {
    type: 'PaymentStreamRateTreatmentCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleRateTreatment',
    id: 40387,
    abbrName: 'RtTrtmt',
    description: 'Specifies the yield calculation treatment for the step schedule.',
  },
  {
    type: 'Amt',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleFixedAmount',
    id: 40388,
    abbrName: 'FixedAmt',
    description: 'The explicit payment amount for this step schedule.',
  },
  {
    type: 'Currency',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleFixedCurrency',
    id: 40389,
    abbrName: 'FixedCcy',
    description: 'The currency of the fixed amount. Uses ISO 4217 currency codes.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleStepFrequencyPeriod',
    id: 40390,
    abbrName: 'StepPeriod',
    description: 'Time unit multiplier for the step frequency.',
  },
  {
    type: 'CouponFrequencyUnitCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleStepFrequencyUnit',
    id: 40391,
    abbrName: 'StepUnit',
    description: 'Time unit associated with the step frequency.',
  },
  {
    type: 'Amt',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleStepOffsetValue',
    id: 40392,
    abbrName: 'StepVal',
    description:
      'The explicit amount that the notional changes on each step date. This can be a positive or negative amount.',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleStepRate',
    id: 40393,
    abbrName: 'StepRt',
    description:
      'The percentage by which the notional changes on each step date. The percentage is either a percentage applied to the initial notional amount or the previous outstanding notional, depending on the value specified in LegPaymentScheduleStepRelativeTo(40395). The percentage can be either positive or negative.',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleStepOffsetRate',
    id: 40394,
    abbrName: 'StepOfstRt',
    description:
      'The explicit amount that the rate changes on each step date. This can be a positive or negative value.',
  },
  {
    type: 'PaymentScheduleStepRelativeToCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleStepRelativeTo',
    id: 40395,
    abbrName: 'StepReltv',
    description:
      'Specifies whether the LegPaymentScheduleStepRate(40393) or LegPaymentScheduleStepOffsetValue(40392) should be applied to the initial notional or the previous notional in order to calculate the notional step change amount.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleFixingDateUnadjusted',
    id: 40396,
    abbrName: 'FixngDtUnadj',
    description: 'The unadjusted fixing date.',
  },
  {
    type: 'float',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleWeight',
    id: 40397,
    abbrName: 'Wt',
    description: 'Floating rate observation weight for cashflow payment.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleFixingDateRelativeTo',
    id: 40398,
    abbrName: 'FixngReltv',
    description:
      'Specifies the anchor date when the fixing date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleFixingDateBusinessDayConvention',
    id: 40399,
    abbrName: 'FixngBizDayCnvtn',
    description:
      "The business day convention used to adjust the payment schedule's fixing date. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleFixingDateBusinessCenter',
    id: 40400,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the payment schedule\'s fixing date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleFixingDateOffsetPeriod',
    id: 40401,
    abbrName: 'FixngPeriod',
    description: 'Time unit multiplier for the relative fixing date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleFixingDateOffsetUnit',
    id: 40402,
    abbrName: 'FixngUnit',
    description: 'Time unit associated with the relative fixing date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleFixingDateOffsetDayType',
    id: 40403,
    abbrName: 'FixngDayTyp',
    description: 'Specifies the day type of the relative fixing date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleFixingDateAdjusted',
    id: 40404,
    abbrName: 'FixngDt',
    description: 'The adjusted fixing date.',
  },
  {
    type: 'LocalMktTime',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleFixingTime',
    id: 40405,
    abbrName: 'FixngTm',
    description: 'The fxing time associated with the step schedule.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleFixingTimeBusinessCenter',
    id: 40406,
    abbrName: 'FixngTmBizCtr',
    description:
      'Business center for determining fixing time.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleInterimExchangePaymentDateRelativeTo',
    id: 40407,
    abbrName: 'IntrmExchDtReltv',
    description:
      'Specifies the anchor date when the interim exchange payment date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleInterimExchangeDatesBusinessDayConvention',
    id: 40408,
    abbrName: 'IntrmExchDtBizDayCnvtn',
    description:
      "The business day convention used to adjust the payment schedule's interim exchange date. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleInterimExchangeDatesBusinessCenter',
    id: 40409,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the payment schedule\'s interim exchange date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleInterimExchangeDatesOffsetPeriod',
    id: 40410,
    abbrName: 'IntrmExchDtPeriod',
    description: 'Time unit multiplier for the relative interim exchange date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleInterimExchangeDatesOffsetUnit',
    id: 40411,
    abbrName: 'IntrmExchDtUnit',
    description: 'Time unit associated with the relative interim exchange date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleInterimExchangeDatesOffsetDayType',
    id: 40412,
    abbrName: 'IntrmExchDayTyp',
    description: 'Specifies the day type of the relative interim exchange date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleInterimExchangeDateAdjusted',
    id: 40413,
    abbrName: 'IntrmExchDt',
    description: 'The adjusted interim exchange date.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoLegPaymentScheduleRateSources',
    id: 40414,
    description: 'Number of rate sources in the repeating group',
  },
  {
    type: 'RateSourceCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleRateSource',
    id: 40415,
    abbrName: 'Src',
    description: 'Identifies the source of rate information.',
  },
  {
    type: 'RateSourceTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleRateSourceType',
    id: 40416,
    abbrName: 'Typ',
    description: 'Rate source type.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleReferencePage',
    id: 40417,
    abbrName: 'RefPg',
    description:
      'Identifies the reference "page" from the rate source.\n\nFor FX, the reference page to the spot rate to be used for the reference FX spot rate.\n\nWhen RateSource(1446) = 3 (ISDA Settlement Rate Option) this contains the value from the scheme that reflects the terms of the Annex A to the ISDA 1998 FX and Currency Option Definitions. See: http://www.fpml.org/coding-scheme/settlement-rate-option',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoLegPaymentStubs',
    id: 40418,
    description: 'Number of stubs in the repeating group',
  },
  {
    type: 'PaymentStubTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubType',
    id: 40419,
    abbrName: 'Typ',
    description: 'Stub type.',
  },
  {
    type: 'PaymentStubLengthCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubLength',
    id: 40420,
    abbrName: 'Lngth',
    description:
      'Optional indication whether stub is shorter or longer than the regular swap period.',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubRate',
    id: 40421,
    abbrName: 'Rt',
    description: 'The agreed upon fixed rate for this stub.',
  },
  {
    type: 'Amt',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubFixedAmount',
    id: 40422,
    abbrName: 'FixedAmt',
    description: 'A fixed payment amount for the stub.',
  },
  {
    type: 'Currency',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubFixedCurrency',
    id: 40423,
    abbrName: 'FixedCcy',
    description:
      'The currency of the fixed payment amount. Uses ISO 4217 currency codes.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubIndex',
    id: 40424,
    abbrName: 'Ndx',
    discriminatorId: '40425',
    description: 'The stub floating rate index.',
  },
  {
    type: 'PaymentStreamRateIndexSourceCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubIndexSource',
    id: 40425,
    abbrName: 'NdxSrc',
    description: 'The source for the stub floating rate index.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubIndexCurvePeriod',
    id: 40426,
    abbrName: 'NdxPeriod',
    description: 'Time unit multiplier for the floating rate index.',
  },
  {
    type: 'PaymentStreamRateIndexCurveUnitCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubIndexCurveUnit',
    id: 40427,
    abbrName: 'NdxUnit',
    description: 'Time unit associated with the floating rate index.',
  },
  {
    type: 'float',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubIndexRateMultiplier',
    id: 40428,
    abbrName: 'RtMult',
    description:
      'A rate multiplier to apply to the floating rate. The multiplier can be less than or greater than 1 (one). This element should only be included if the multiplier is not equal to 1 (one) for the term of the stream.',
  },
  {
    type: 'PriceOffset',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubIndexRateSpread',
    id: 40429,
    abbrName: 'Spread',
    description: 'Spread from floating rate index.',
  },
  {
    type: 'PaymentStreamRateSpreadPositionTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubIndexRateSpreadPositionType',
    id: 40430,
    abbrName: 'SpreadPosTyp',
    description:
      'Identifies whether the rate spread is applied to a long or a short position.',
  },
  {
    type: 'PaymentStreamRateTreatmentCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubIndexRateTreatment',
    id: 40431,
    abbrName: 'RtTrtmt',
    description: 'Specifies the yield calculation treatment for the stub index.',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubIndexCapRate',
    id: 40432,
    abbrName: 'CapRt',
    description:
      'The cap rate, if any, which applies to the floating rate. The cap rate (strike) is only required where the floating rate on a swap stream is capped at a certain level. The cap rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A cap rate of 5% would be represented as 0.05.',
  },
  {
    type: 'PaymentStreamCapRateBuySideCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubIndexCapRateBuySide',
    id: 40433,
    abbrName: 'CapRtBuy',
    description: 'Reference to the buyer of the cap rate option through its trade side.',
  },
  {
    type: 'PaymentStreamCapRateBuySideCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubIndexCapRateSellSide',
    id: 40434,
    abbrName: 'CapRtSell',
    description: 'Reference to the seller of the cap rate option through its trade side.',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubIndexFloorRate',
    id: 40435,
    abbrName: 'FlrRt',
    description:
      'The floor rate, if any, which applies to the floating rate. The floor rate (strike) is only required where the floating rate on a swap stream is floored at a certain strike level. The floor rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A floor rate of 5% would be represented as 0.05.',
  },
  {
    type: 'PaymentStreamFloorRateBuySideCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubIndexFloorRateBuySide',
    id: 40436,
    abbrName: 'FlrRtBuy',
    description:
      'Reference to the buyer of the floor rate option through its trade side.',
  },
  {
    type: 'PaymentStreamFloorRateBuySideCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubIndexFloorRateSellSide',
    id: 40437,
    abbrName: 'FlrRtSell',
    description:
      'Reference to the seller of the floor rate option through its trade side.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubIndex2',
    id: 40438,
    abbrName: 'Ndx2',
    discriminatorId: '40439',
    description: 'The second stub floating rate index.',
  },
  {
    type: 'PaymentStreamRateIndexSourceCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubIndex2Source',
    id: 40439,
    abbrName: 'Ndx2Src',
    description: 'The source for the second stub floating rate index.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubIndex2CurvePeriod',
    id: 40440,
    abbrName: 'Ndx2Period',
    description: 'Secondary time unit multiplier for the stub floating rate index curve.',
  },
  {
    type: 'PaymentStreamRateIndexCurveUnitCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubIndex2CurveUnit',
    id: 40441,
    abbrName: 'Ndx2Unit',
    description:
      'Secondary time unit associated with the stub floating rate index curve.',
  },
  {
    type: 'float',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubIndex2RateMultiplier',
    id: 40442,
    abbrName: 'RtMult2',
    description:
      'A rate multiplier to apply to the second floating rate. The multiplier can be less than or greater than 1 (one). This element should only be included if the multiplier is not equal to 1 (one) for the term of the stream.',
  },
  {
    type: 'PriceOffset',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubIndex2RateSpread',
    id: 40443,
    abbrName: 'Spread2',
    description: 'Spread from the second floating rate index.',
  },
  {
    type: 'PaymentStreamRateSpreadPositionTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubIndex2RateSpreadPositionType',
    id: 40444,
    abbrName: 'Spread2PosTyp',
    description:
      'Identifies whether the rate spread is applied to a long or a short position.',
  },
  {
    type: 'PaymentStreamRateTreatmentCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubIndex2RateTreatment',
    id: 40445,
    abbrName: 'RtTrtmt2',
    description: 'Specifies the yield calculation treatment for the second stub index.',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubIndex2CapRate',
    id: 40446,
    abbrName: 'CapRt2',
    description:
      'The cap rate, if any, which applies to the second floating rate. The cap rate (strike) is only required where the floating rate on a swap stream is capped at a certain level. The cap rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A cap rate of 5% would be represented as 0.05.',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubIndex2FloorRate',
    id: 40447,
    abbrName: 'FlrRt2',
    description:
      'The floor rate, if any, which applies to the second floating rate. The floor rate (strike) is only required where the floating rate on a swap stream is floored at a certain strike level. The floor rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A floor rate of 5% would be represented as 0.05.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoLegProvisions',
    id: 40448,
    description: 'Number of provisions in the repeating group.',
  },
  {
    type: 'ProvisionTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionType',
    id: 40449,
    abbrName: 'Typ',
    description: 'Type of provisions.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionDateUnadjusted',
    id: 40450,
    abbrName: 'DtUnadj',
    description: 'The unadjusted date of the provision.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionDateBusinessDayConvention',
    id: 40451,
    abbrName: 'BizDayCnvtn',
    description:
      "The business day convention used to adjust the instrument leg's provision's date. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionDateBusinessCenter',
    id: 40452,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the instrument leg\'s provision\'s date, e.g. "GBLO". See http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionDateAdjusted',
    id: 40453,
    abbrName: 'Dt',
    description: 'The adjusted date of the provision.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionDateTenorPeriod',
    id: 40454,
    abbrName: 'TenorPeriod',
    description: "Time unit multiplier for the leg provision's tenor period.",
  },
  {
    type: 'ProvisionDateTenorUnitCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionDateTenorUnit',
    id: 40455,
    abbrName: 'TenorUnit',
    description: "Time unit associated with the leg provision's tenor period.",
  },
  {
    type: 'ProvisionCalculationAgentCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionCalculationAgent',
    id: 40456,
    abbrName: 'CalcAgent',
    description:
      'Used to identify the calculation agent. The calculation agent may be identified in LegProvisionCalculationAgent(40456) or in the ProvisionParties component.',
  },
  {
    type: 'ProvisionOptionSinglePartyBuyerSideCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionSinglePartyBuyerSide',
    id: 40457,
    abbrName: 'BuyerSide',
    description:
      'If optional early termination is not available to both parties then this component identifies the buyer of the option through its side of the trade.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'ProvisionOptionSinglePartyBuyerSideCodeSet',
    addedEP: '161',
    updatedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionSinglePartySellerSide',
    id: 40458,
    abbrName: 'SellerSide',
    description:
      'If optional early termination is not available to both parties then this component identifies the seller of the option through its side of the trade.',
  },
  {
    type: 'ExerciseStyleCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionExerciseStyle',
    id: 40459,
    abbrName: 'ExerStyle',
    description: 'The instrument provision option exercise style.',
  },
  {
    type: 'Amt',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionExerciseMultipleNotional',
    id: 40460,
    abbrName: 'MultplNotl',
    description:
      'A notional amount which restricts the amount of notional that can be exercised when partial exercise or multiple exercise is applicable. The integral multiple amount defines a lower limit of notional that can be exercised and also defines a unit multiple of notional that can be exercised, i.e. only integer multiples of this amount can be exercised.',
  },
  {
    type: 'Amt',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionExerciseMinimumNotional',
    id: 40461,
    abbrName: 'MinNotl',
    description:
      'The minimum notional amount that can be exercised on a given exercise date.',
  },
  {
    type: 'Amt',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionExerciseMaximumNotional',
    id: 40462,
    abbrName: 'MaxNotl',
    description:
      'The maximum notional amount that can be exercised on a given exercise date.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionMinimumNumber',
    id: 40463,
    abbrName: 'MinNum',
    description:
      'The minimum number of options that can be exercised on a given exercise date.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionMaximumNumber',
    id: 40464,
    abbrName: 'MaxNum',
    description:
      'The maximum number of options that can be exercised on a given exercise date. If the number is not specified, it means that the maximum number of options corresponds to the remaining unexercised options.',
  },
  {
    type: 'Boolean',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionExerciseConfirmation',
    id: 40465,
    abbrName: 'ExerCnfm',
    description:
      "Used to indicate whether follow-up confirmation of exercise (written or electronic) is required following telephonic notice by the buyer to the seller or seller's agent.",
  },
  {
    type: 'ProvisionCashSettlMethodCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionCashSettlMethod',
    id: 40466,
    abbrName: 'SettlMeth',
    description:
      'An ISDA defined cash settlement method used for the determination of the applicable cash settlement amount. The method is defined in the 2006 ISDA Definitions, Section 18.3. Cash Settlement Methods, paragraph (e).',
  },
  {
    type: 'Currency',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionCashSettlCurrency',
    id: 40467,
    abbrName: 'SettlCcy',
    description: 'Specifies the currency of settlement. Uses ISO 4217 currency codes.',
  },
  {
    type: 'Currency',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionCashSettlCurrency2',
    id: 40468,
    abbrName: 'SettlCcy2',
    description:
      'Specifies the currency of settlement for a cross-currency provision. Uses ISO 4217 currency codes.',
  },
  {
    type: 'ProvisionCashSettlQuoteTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionCashSettlQuoteType',
    id: 40469,
    abbrName: 'SettlQteTyp',
    description: 'Identifies the type of quote to be used.',
  },
  {
    type: 'PaymentStreamRateIndexSourceCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionCashSettlQuoteSource',
    id: 40470,
    abbrName: 'SettlQteSrc',
    description: 'Identifies the source of quote information.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'BusinessCenter',
    id: 40471,
    abbrName: 'Ctr',
    description:
      'A business center whose calendar is used for date adjustment, e.g. "GBLO". See http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionText',
    id: 40472,
    abbrName: 'Txt',
    description:
      'Free form text to specify additional information or enumeration description when a standard value does not apply.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoLegProvisionCashSettlPaymentDates',
    id: 40473,
    description:
      'Number of provision cash settlement payment dates in the repeating group.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionCashSettlPaymentDate',
    id: 40474,
    abbrName: 'Dt',
    description:
      'The cash settlement payment date, unadjusted or adjusted depending on LegProvisionCashSettlPaymentDateType(40521).',
  },
  {
    type: 'ProvisionCashSettlPaymentDateTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionCashSettlPaymentDateType',
    id: 40475,
    abbrName: 'Typ',
    description: 'Specifies the type of date (e.g. adjusted for holidays).',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionExerciseBusinessDayConvention',
    id: 40476,
    abbrName: 'BizDayCnvtn',
    description:
      "The business day convention used to adjust the instrument leg's provision's option exercise date. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionExerciseBusinessCenter',
    id: 40477,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the instrument leg\'s provision\'s option exercise date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionExerciseEarliestDateOffsetPeriod',
    id: 40478,
    abbrName: 'ErlstOfstPeriod',
    description:
      'Time unit multiplier for the interval to the first (and possibly only) exercise date in the exercise period.',
  },
  {
    type: 'ProvisionOptionExerciseEarliestDateOffsetUnitCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionExerciseEarliestDateOffsetUnit',
    id: 40479,
    abbrName: 'ErlstOfstUnit',
    description:
      'Time unit associated with the interval to the first (and possibly only) exercise date in the exercise period.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionExerciseFrequencyPeriod',
    id: 40480,
    abbrName: 'FreqPeriod',
    description:
      'Time unit multiplier for subsequent exercise dates in the exercise period following the earliest exercise date. An interval of 1 day should be used to indicate an American style exercise period.',
  },
  {
    type: 'CouponFrequencyUnitCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionExerciseFrequencyUnit',
    id: 40481,
    abbrName: 'FreqUnit',
    description:
      'Time unit associated with subsequent exercise dates in the exercise period following the earliest exercise date.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionExerciseStartDateUnadjusted',
    id: 40482,
    abbrName: 'StartDtUnadj',
    description:
      'The unadjusted first day of the exercise period for an American style option.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionExerciseStartDateRelativeTo',
    id: 40483,
    abbrName: 'StartDtReltv',
    description:
      'Specifies the anchor date when the option exercise start date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionExerciseStartDateOffsetPeriod',
    id: 40484,
    abbrName: 'StartDtOfstPeriod',
    description:
      'Time unit multiplier for the relative option exercise start date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionExerciseStartDateOffsetUnit',
    id: 40485,
    abbrName: 'StartDtOfstUnit',
    description:
      'Time unit associated with the relative option exercise start date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionExerciseStartDateOffsetDayType',
    id: 40486,
    abbrName: 'StartDtOfstDayTyp',
    description:
      "Specifies the day type of the provision's relative option exercise start date offset.",
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionExerciseStartDateAdjusted',
    id: 40487,
    abbrName: 'StartDt',
    description:
      'The adjusted first day of the exercise period for an American style option.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionExercisePeriodSkip',
    id: 40488,
    abbrName: 'Skip',
    description:
      'The number of periods in the referenced date schedule that are between each date in the relative date schedule. Thus a skip of 2 would mean that dates are relative to every second date in the referenced schedule. If present this should have a value greater than 1.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionExerciseBoundsFirstDateUnadjusted',
    id: 40489,
    abbrName: 'FirstDtUnadj',
    description:
      'The unadjusted first date of a schedule. This can be used to restrict the range of exercise dates when they are relative.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionExerciseBoundsLastDateUnadjusted',
    id: 40490,
    abbrName: 'LastDtUnadj',
    description:
      'The unadjusted last date of a schedule. This can be used to restrict the range of exercise dates when they are relative.',
  },
  {
    type: 'LocalMktTime',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionExerciseEarliestTime',
    id: 40491,
    abbrName: 'ErlstTm',
    description:
      "The earliest time at which notice of exercise can be given by the buyer to the seller (or seller's agent) (i) on the expriation date, in the case of a European style option, (ii) on each bermuda option exercise date and the expiration date, in the case of a Bermuda style option the commencement date to, and including, the expiration date, in the case of an American option.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionExerciseEarliestTimeBusinessCenter',
    id: 40492,
    abbrName: 'ErlstTmBizCtr',
    description:
      "Identifies the business center calendar used with the provision's earliest time for notice of exercise.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.",
  },
  {
    type: 'LocalMktTime',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionExerciseLatestTime',
    id: 40493,
    abbrName: 'LtstTm',
    description:
      "For a Bermuda or American style option, the latest time on an exercise business day (excluding the expiration date) within the exercise period that notice can be given by the buyer to the seller or seller's agent. Notice of exercise given after this time will be deemed to have been given on the next exercise business day.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionExerciseLatestTimeBusinessCenter',
    id: 40494,
    abbrName: 'LtstTmBizCtr',
    description:
      "Identifies the business center calendar used with the provision's latest time for notice of exercise.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.",
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoLegProvisionOptionExerciseFixedDates',
    id: 40495,
    description:
      'Number of provision option exercise fixed dates in the repeating group.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionExerciseFixedDate',
    id: 40496,
    abbrName: 'Dt',
    description:
      'A predetermined option exercise date unadjusted or adjusted depending on LegProvisionOptionExerciseFixedDateType(40497).',
  },
  {
    type: 'ProvisionOptionExerciseFixedDateTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionExerciseFixedDateType',
    id: 40497,
    abbrName: 'Typ',
    description: 'Specifies the type of date (e.g. adjusted for holidays).',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionExpirationDateUnadjusted',
    id: 40498,
    abbrName: 'DtUnadj',
    description:
      'The unadjusted last day within an exercise period for an American style option. For a European style option it is the only day within the exercise period.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionExpirationDateBusinessDayConvention',
    id: 40499,
    abbrName: 'BizDayCnvtn',
    description:
      "The business day convention used to adjust the instrument leg's provision's option expiration date. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionExpirationDateBusinessCenter',
    id: 40500,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the instrument leg\'s provision\'s option expiration date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionExpirationDateRelativeTo',
    id: 40501,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the option expiration date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionExpirationDateOffsetPeriod',
    id: 40502,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative option expiration date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionExpirationDateOffsetUnit',
    id: 40503,
    abbrName: 'OfstUnit',
    description: 'Time unit associated with the relative option expiration date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionExpirationDateOffsetDayType',
    id: 40504,
    abbrName: 'OfstDayTyp',
    description:
      "Specifies the day type of the provision's relative option expiration date offset.",
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionExpirationDateAdjusted',
    id: 40505,
    abbrName: 'Dt',
    description:
      'The adjusted last date within an exercise period for an American style option. For a European style option it is the only date within the exercise period.',
  },
  {
    type: 'LocalMktTime',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionExpirationTime',
    id: 40506,
    abbrName: 'ExpTm',
    description: 'The latest time for exercise on the expiration date.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionExpirationTimeBusinessCenter',
    id: 40507,
    abbrName: 'ExpTmBizCtr',
    description:
      "Identifies the business center calendar used with the provision's latest exercise time on expiration date.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.",
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionRelevantUnderlyingDateUnadjusted',
    id: 40508,
    abbrName: 'DtUnadj',
    description:
      'The unadjusted date on the underlying set by the exercise of an option. What this date is depends on the option (e.g. in a swaption it is the swap effective date, in an extendible/cancelable provision it is the swap termination date).',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionRelevantUnderlyingDateBusinessDayConvention',
    id: 40509,
    abbrName: 'BizDayCnvtn',
    description:
      "The business day convention used to adjust the instrument leg's provision's option relevant underlying date. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionRelevantUnderlyingDateBusinessCenter',
    id: 40510,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the instrument leg\'s provision\'s option underlying date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionRelevantUnderlyingDateRelativeTo',
    id: 40511,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the date relevant to the underlying trade on exercise is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionRelevantUnderlyingDateOffsetPeriod',
    id: 40512,
    abbrName: 'OfstPeriod',
    description:
      'Time unit multiplier for the relative option relevant underlying date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionRelevantUnderlyingDateOffsetUnit',
    id: 40513,
    abbrName: 'OfstUnit',
    description:
      'Time unit associated with the relative option relevant underlying date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionRelevantUnderlyingDateOffsetDayType',
    id: 40514,
    abbrName: 'OfstDayTyp',
    description:
      "Specifies the day type of the provision's relative option relevant underlying date offset.",
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionOptionRelevantUnderlyingDateAdjusted',
    id: 40515,
    abbrName: 'Dt',
    description:
      'The adjusted date on the underlying set by the exercise of an option. What this date is depends on the option (e.g. in a swaption it is the swap effective date, in an extendible/cancelable provision it is the swap termination date).',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionCashSettlPaymentDateBusinessDayConvention',
    id: 40516,
    abbrName: 'BizDayCnvtn',
    description:
      "The business day convention used to adjust the provisional cash settlement payment's termination, or relative termination, date. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionCashSettlPaymentDateBusinessCenter',
    id: 40517,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the provisional cash settlement payment\'s termination, or relative termination, date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionCashSettlPaymentDateRelativeTo',
    id: 40518,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the cash settlement payment date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionCashSettlPaymentDateOffsetPeriod',
    id: 40519,
    abbrName: 'OfstPeriod',
    description:
      'Time unit multiplier for the relative cash settlement payment date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionCashSettlPaymentDateOffsetUnit',
    id: 40520,
    abbrName: 'OfstUnit',
    description:
      'Time unit associated with the relative cash settlement payment date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionCashSettlPaymentDateOffsetDayType',
    id: 40521,
    abbrName: 'OfstDayTyp',
    description:
      "Specifies the day type of the provision's relative cash settlement payment date offset.",
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionCashSettlPaymentDateRangeFirst',
    id: 40522,
    abbrName: 'DtFirst',
    description: 'The first date in range when a settlement date range is provided.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionCashSettlPaymentDateRangeLast',
    id: 40523,
    abbrName: 'DtLast',
    description: 'The last date in range when a settlement date range is provided.',
  },
  {
    type: 'LocalMktTime',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionCashSettlValueTime',
    id: 40524,
    abbrName: 'Tm',
    description:
      'A time specified in 24-hour format, e.g. 11am would be represented as 11:00:00. The time of the cash settlement valuation date when the cash settlement amount will be determined according to the cash settlement method if the parties have not otherwise been able to agree to the cash settlement amount.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionCashSettlValueTimeBusinessCenter',
    id: 40525,
    abbrName: 'TmBizCtr',
    description:
      "Identifies the business center calendar used with the provision's cash settlement valuation time.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.",
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionCashSettlValueDateBusinessDayConvention',
    id: 40526,
    abbrName: 'BizDayCnvtn',
    description:
      "The business day convention used to adjust the provision's cash settlement valuation date. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionCashSettlValueDateBusinessCenter',
    id: 40527,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the provision\'s cash settlement valuation date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionCashSettlValueDateRelativeTo',
    id: 40528,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the cash settlement value date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionCashSettlValueDateOffsetPeriod',
    id: 40529,
    abbrName: 'OfstPeriod',
    description:
      'Time unit multiplier for the relative cash settlement value date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionCashSettlValueDateOffsetUnit',
    id: 40530,
    abbrName: 'OfstUnit',
    description:
      'Time unit associated with the relative cash settlement value date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionCashSettlValueDateOffsetDayType',
    id: 40531,
    abbrName: 'OfstDayTyp',
    description:
      "Specifies the day type of the provision's relative cash settlement value date offset.",
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionCashSettlValueDateAdjusted',
    id: 40532,
    abbrName: 'Dt',
    description: 'The adjusted cash settlement value date.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoLegProvisionPartyIDs',
    id: 40533,
    description: 'Number of parties identified in the contract provision.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionPartyID',
    id: 40534,
    abbrName: 'ID',
    discriminatorId: '40535',
    description: 'The party identifier/code for the payment settlement party.',
  },
  {
    updated: 'FIX.Latest',
    type: 'PartyIDSourceCodeSet',
    addedEP: '161',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionPartyIDSource',
    id: 40535,
    abbrName: 'Src',
    description: 'Identifies the class or source of LegProvisionPartyID(40534).',
  },
  {
    type: 'PartyRoleCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionPartyRole',
    id: 40536,
    abbrName: 'R',
    description: 'Identifies the type or role of LegProvisionPartyID(40534) specified.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoLegProvisionPartySubIDs',
    id: 40537,
    description: 'Number of sub-party IDs to be reported for the party.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionPartySubID',
    id: 40538,
    abbrName: 'ID',
    description: 'Party sub-identifier, if applicable, for LegProvisionPartyRole(40536).',
  },
  {
    type: 'PartySubIDTypeCodeSet',
    unionDataType: 'Reserved4000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionPartySubIDType',
    id: 40539,
    abbrName: 'Typ',
    description: 'The type of LegProvisionPartySubID(40538) value.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingStreams',
    id: 40540,
    description: 'Number of swap streams in the repeating group.',
  },
  {
    type: 'StreamTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamType',
    id: 40541,
    abbrName: 'Typ',
    description: 'Type of swap stream.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamDesc',
    id: 40542,
    abbrName: 'Desc',
    description:
      'A short descriptive name given to payment stream. Eg. CDS, Fixed, Float, Float2, GBP. The description has no intrinsic meaning but should be arbitrarily chosen by the remitter as a reference.',
  },
  {
    type: 'PaymentPaySideCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamPaySide',
    id: 40543,
    abbrName: 'PaySide',
    description: 'The side of the party paying the stream.',
  },
  {
    type: 'PaymentPaySideCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamReceiveSide',
    id: 40544,
    abbrName: 'RcvSide',
    description: 'The side of the party receiving the stream.',
  },
  {
    type: 'Amt',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamNotional',
    id: 40545,
    abbrName: 'Notl',
    description:
      'Notional, or initial notional value for the payment stream. Use SwapSchedule for steps.',
  },
  {
    type: 'Currency',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCurrency',
    id: 40546,
    abbrName: 'Ccy',
    description:
      'Specifies the currency the UnderlyingStreamNotional(40545) is denominated in. Uses ISO 4217 currency codes.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamText',
    id: 40547,
    abbrName: 'Txt',
    description:
      'Free form text to specify additional information or enumeration description when a standard value does not apply.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamTerminationDateUnadjusted',
    id: 40548,
    abbrName: 'DtUnadj',
    description: 'The unadjusted termination date.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamTerminationDateBusinessDayConvention',
    id: 40549,
    abbrName: 'BizDayCnvtn',
    description:
      "The business day convention used to adjust the underlying instrument's stream's termination, or relative termination, date. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamTerminationDateBusinessCenter',
    id: 40550,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the underlying instrument\'s stream\'s termination, or relative termination, date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamTerminationDateRelativeTo',
    id: 40551,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the termination date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamTerminationDateOffsetPeriod',
    id: 40552,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative termination date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamTerminationDateOffsetUnit',
    id: 40553,
    abbrName: 'OfstUnit',
    description: 'Time unit associated with the relative termination date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamTerminationDateOffsetDayType',
    id: 40554,
    abbrName: 'OfstDayTyp',
    description: 'Specifies the day type of the relative termination date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamTerminationDateAdjusted',
    id: 40555,
    abbrName: 'Dt',
    description: 'The adjusted termination date.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCalculationPeriodBusinessDayConvention',
    id: 40556,
    abbrName: 'BizDayCnvtn',
    description:
      'The business day convention used to adjust the calculation periods. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCalculationPeriodBusinessCenter',
    id: 40557,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the calculation periods, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamFirstPeriodStartDateUnadjusted',
    id: 40558,
    abbrName: 'FirstStartDtUnadj',
    description:
      'The unadjusted first calculation period start date if before the effective date.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamFirstPeriodStartDateBusinessDayConvention',
    id: 40559,
    abbrName: 'FirstStartDtBizDayCnvtn',
    description:
      "The business day convention used to adjust the underlying instrument's stream's first calculation period start date. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamFirstPeriodStartDateBusinessCenter',
    id: 40560,
    abbrName: 'FirstStartDtBizCtr',
    description:
      'The business center calendar used to adjust the underlying instrument\'s stream\'s first calculation period start date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamFirstPeriodStartDateAdjusted',
    id: 40561,
    abbrName: 'FirstStartDt',
    description:
      'The adjusted first calculation period start date, if it is before the effective date.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamFirstRegularPeriodStartDateUnadjusted',
    id: 40562,
    abbrName: 'FirstReglrStartDtUnadj',
    description:
      'The unadjusted first start date of the regular calculation period, if there is an initial stub period.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamFirstCompoundingPeriodEndDateUnadjusted',
    id: 40563,
    abbrName: 'FirstCmpndgEndDtUnadj',
    description: 'The unadjusted end date of the initial compounding period.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamLastRegularPeriodEndDateUnadjusted',
    id: 40564,
    abbrName: 'LastReglrEndDtUnadj',
    description:
      'The unadjusted last regular period end date if there is a final stub period.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCalculationFrequencyPeriod',
    id: 40565,
    abbrName: 'FreqPeriod',
    description:
      'Time unit multiplier for the frequency at which calculation period end dates occur.',
  },
  {
    type: 'CouponFrequencyUnitCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCalculationFrequencyUnit',
    id: 40566,
    abbrName: 'FreqUnit',
    description:
      'Time unit associated with the frequency at which calculation period end dates occur.',
  },
  {
    type: 'DateRollConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCalculationRollConvention',
    id: 40567,
    abbrName: 'Roll',
    description:
      'The convention for determining the sequence of end dates. It is used in conjunction with a specified frequency. Used only to override the roll convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.',
  },
  {
    type: 'PaymentStreamTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamType',
    id: 40568,
    abbrName: 'Typ',
    description:
      'Identifies the type of payment stream applicable to the swap stream associated with the underlying instrument.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamMarketRate',
    id: 40569,
    abbrName: 'MktRt',
    description:
      'Used only for credit index trade. This contains the credit spread ("fair value") at which the trade was executed. The market rate varies over the life of the index depending on market conditions. This is the price of the index as quoted by trading desks.',
  },
  {
    type: 'Boolean',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamDelayIndicator',
    id: 40570,
    abbrName: 'DelayInd',
    description:
      'Applicable to credit default swaps on mortgage backed securities to specify whether payment delays are applicable to the fixed amount.\n\nResidential mortgage backed securities typically have a payment delay of 5 days between the coupon date of the reference obligation and the payment date of the synthetic swap.\n\nCommercial mortage backed securities do not typically have a payment delay, with both payment dates (the coupon date of the reference obligation and the payment date of the synthetic swap) being on the 25th of each month.',
  },
  {
    type: 'Currency',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamSettlCurrency',
    id: 40571,
    abbrName: 'SettlCcy',
    description:
      'Specifies the currency that the stream settles in (to support swaps that settle in a currency different from the notional currency). Uses ISO 4217 currency codes.',
  },
  {
    type: 'CouponDayCountCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamDayCount',
    id: 40572,
    abbrName: 'DayCnt',
    description: 'The day count convention used in the payment stream calculations.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamAccrualDays',
    id: 40573,
    abbrName: 'AcrlDays',
    description:
      'The number of days from the adjusted calculation period start date to the adjusted value date, calculated in accordance with the applicable day count fraction.',
  },
  {
    type: 'PaymentStreamDiscountTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamDiscountType',
    id: 40574,
    abbrName: 'DiscTyp',
    description: 'The method of calculating discounted payment amounts',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamDiscountRate',
    id: 40575,
    abbrName: 'Disc',
    description:
      'Discount rate. The rate is expressed in decimal, e.g. 5% is expressed as 0.05.',
  },
  {
    type: 'CouponDayCountCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamDiscountRateDayCount',
    id: 40576,
    abbrName: 'DiscDayCnt',
    description:
      'The day count convention applied to the UnderlyingPaymentStreamDiscountRate(40575).',
  },
  {
    type: 'PaymentStreamCompoundingMethodCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingMethod',
    id: 40577,
    abbrName: 'CmpndgMeth',
    description: 'Compounding Method.',
  },
  {
    type: 'Boolean',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamInitialPrincipalExchangeIndicator',
    id: 40578,
    abbrName: 'InitPrncplExchInd',
    description:
      'Indicates whether there is an initial exchange of principal on the effective date.',
  },
  {
    type: 'Boolean',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamInterimPrincipalExchangeIndicator',
    id: 40579,
    abbrName: 'IntrmPrncplExchInd',
    description:
      'Indicates whether there are intermediate or interim exchanges of principal during the term of the swap.',
  },
  {
    type: 'Boolean',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFinalPrincipalExchangeIndicator',
    id: 40580,
    abbrName: 'FnlPrncplExchInd',
    description:
      'Indicates whether there is a final exchange of principal on the termination date.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamPaymentDateBusinessDayConvention',
    id: 40581,
    abbrName: 'BizDayCnvtn',
    description:
      "The business day convention used to adjust the payment stream's payment date. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamPaymentDateBusinessCenter',
    id: 40582,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the payment stream\'s payment date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamPaymentFrequencyPeriod',
    id: 40583,
    abbrName: 'FreqPeriod',
    description: 'Time unit multiplier for the frequency of payments.',
  },
  {
    type: 'PaymentStreamPaymentFrequencyUnitCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamPaymentFrequencyUnit',
    id: 40584,
    abbrName: 'FreqUnit',
    description: 'Time unit associated with the frequency of payments.',
  },
  {
    type: 'DateRollConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamPaymentRollConvention',
    id: 40585,
    abbrName: 'Roll',
    description:
      'The convention for determining the sequence of end dates. It is used in conjunction with a specified frequency. Used only to override the roll convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFirstPaymentDateUnadjusted',
    id: 40586,
    abbrName: 'FirstDtUnadj',
    description: 'The unadjusted first payment date.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamLastRegularPaymentDateUnadjusted',
    id: 40587,
    abbrName: 'LastReglrDtUnadj',
    description: 'The unadjusted last regular payment date.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamPaymentDateRelativeTo',
    id: 40588,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when payment dates are relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamPaymentDateOffsetPeriod',
    id: 40589,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative payment date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamPaymentDateOffsetUnit',
    id: 40590,
    abbrName: 'OfstUnit',
    description: 'Time unit associated with the relative payment date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamPaymentDateOffsetDayType',
    id: 40591,
    abbrName: 'OfstDayTyp',
    description: 'Specifies the day type of the relative payment date offset.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamResetDateRelativeTo',
    id: 40592,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the reset dates are relative to an anchor date.\n\nIf the reset frequency is specified as daily this element must not be included.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamResetDateBusinessDayConvention',
    id: 40593,
    abbrName: 'BizDayCnvtn',
    description:
      "The business day convention used to adjust the payment stream's reset date. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamResetDateBusinessCenter',
    id: 40594,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the payment stream\'s reset date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamResetFrequencyPeriod',
    id: 40595,
    abbrName: 'FreqPeriod',
    description: 'Time unit multiplier for frequency of resets.',
  },
  {
    type: 'CouponFrequencyUnitCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamResetFrequencyUnit',
    id: 40596,
    abbrName: 'FreqUnit',
    description: 'Time unit associated with frequency of resets.',
  },
  {
    type: 'PaymentStreamResetWeeklyRollConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamResetWeeklyRollConvention',
    id: 40597,
    abbrName: 'WklyRoll',
    description:
      'Used to specify the day of the week in which the reset occurs for payments that reset on a weekly basis.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamInitialFixingDateRelativeTo',
    id: 40598,
    abbrName: 'InitReltv',
    description:
      'Specifies the anchor date when the initial fixing date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamInitialFixingDateBusinessDayConvention',
    id: 40599,
    abbrName: 'InitBizDayCnvtn',
    description:
      "The business day convention used to adjust the payment stream's initial fixing date. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamInitialFixingDateBusinessCenter',
    id: 40600,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the payment stream\'s initial fixing date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamInitialFixingDateOffsetPeriod',
    id: 40601,
    abbrName: 'InitPeriod',
    description: 'Time unit multiplier for the relative initial fixing date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamInitialFixingDateOffsetUnit',
    id: 40602,
    abbrName: 'InitUnit',
    description: 'Time unit associated with the relative initial fixing date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamInitialFixingDateOffsetDayType',
    id: 40603,
    abbrName: 'InitDayTyp',
    description: 'Specifies the day type of the relative initial fixing date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamInitialFixingDateAdjusted',
    id: 40604,
    abbrName: 'InitDt',
    description: 'The adjusted initial fixing date.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFixingDateRelativeTo',
    id: 40605,
    abbrName: 'FixngReltv',
    description:
      'Specifies the anchor date when the fixing date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFixingDateBusinessDayConvention',
    id: 40606,
    abbrName: 'FixngBizDayCnvtn',
    description:
      "The business day convention used to adjust the payment stream's fixing date. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFixingDateBusinessCenter',
    id: 40607,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the payment stream\'s fixing date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFixingDateOffsetPeriod',
    id: 40608,
    abbrName: 'FixngPeriod',
    description: 'Time unit multiplier for the relative fixing date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFixingDateOffsetUnit',
    id: 40609,
    abbrName: 'FixngUnit',
    description: 'Time unit associated with the relative fixing date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFixingDateOffsetDayType',
    id: 40610,
    abbrName: 'FixngDayTyp',
    description: 'Specifies the day type of the relative fixing date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFixingDateAdjusted',
    id: 40611,
    abbrName: 'FixngDt',
    description: 'The adjusted fixing date.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamRateCutoffDateOffsetPeriod',
    id: 40612,
    abbrName: 'CutoffPeriod',
    description: 'Time unit multiplier for the relative rate cut-off date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamRateCutoffDateOffsetUnit',
    id: 40613,
    abbrName: 'CutoffUnit',
    description: 'Time unit associated with the relative rate cut-off date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamRateCutoffDateOffsetDayType',
    id: 40614,
    abbrName: 'CutoffDayTyp',
    description: 'Specifies the day type of the relative rate cut-off date offset.',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamRate',
    id: 40615,
    abbrName: 'Rt',
    description: 'The rate applicable to the fixed rate payment stream.',
  },
  {
    type: 'Amt',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFixedAmount',
    id: 40616,
    abbrName: 'Amt',
    description:
      "The underlying payment stream's fixed payment amount. In CDS an alternative to UnderlyingPaymentStreamRate(40615).",
  },
  {
    type: 'Currency',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamRateOrAmountCurrency',
    id: 40617,
    abbrName: 'Ccy',
    description:
      'Specifies the currency in which UnderlyingPaymentStreamFixedAmount(40616) or UnderlyingPaymentStreamRate(40615) is denominated. Users ISO 4271 currency codes.',
  },
  {
    type: 'Amt',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFutureValueNotional',
    id: 40618,
    abbrName: 'FutValNotl',
    description:
      'The future value notional is normally only required for certain non-deliverable interest rate swaps (e.g. Brazillian Real (BRL) vs. CETIP Interbank Deposit Rate (CDI)). The value is calculated as follows: Future Value Notional = Notional Amount * (1 + Fixed Rate) ^ (Fixed Rate Day Count Fraction). The currency is the same as the stream notional.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFutureValueDateAdjusted',
    id: 40619,
    abbrName: 'FutValDt',
    description: 'The adjusted value date of the future value amount.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamRateIndex',
    id: 40620,
    abbrName: 'Ndx',
    discriminatorId: '40621',
    description: "The payment stream's floating rate index.",
  },
  {
    type: 'PaymentStreamRateIndexSourceCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamRateIndexSource',
    id: 40621,
    abbrName: 'NdxSrc',
    description: 'The source of the payment stream floating rate index.',
  },
  {
    type: 'PaymentStreamRateIndexCurveUnitCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamRateIndexCurveUnit',
    id: 40622,
    abbrName: 'NdxUnit',
    description:
      'Time unit associated with the underlying instrument’s floating rate index.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamRateIndexCurvePeriod',
    id: 40623,
    abbrName: 'NdxPeriod',
    description:
      'Time unit multiplier for the underlying instrument’s floating rate index.',
  },
  {
    type: 'float',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamRateMultiplier',
    id: 40624,
    abbrName: 'RtMult',
    description:
      'A rate multiplier to apply to the floating rate. A multiplier schedule is expressed as explicit multipliers and dates. In the case of a schedule, the step dates may be subject to adjustment in accordance with any adjustments specified in the calculationPeriodDatesAdjustments. The multiplier can be less than or greater than 1 (one). This element should only be included if the multiplier is not equal to 1 (one) for the term of the stream.',
  },
  {
    type: 'PriceOffset',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamRateSpread',
    id: 40625,
    abbrName: 'Spread',
    description: 'Spread from floating rate index.',
  },
  {
    type: 'PaymentStreamRateSpreadPositionTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamRateSpreadPositionType',
    id: 40626,
    abbrName: 'SpreadPosTyp',
    description: 'Identifies a short or long spread value.',
  },
  {
    type: 'PaymentStreamRateTreatmentCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamRateTreatment',
    id: 40627,
    abbrName: 'RtTrtmt',
    description: 'Specifies the yield calculation treatment for the index.',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCapRate',
    id: 40628,
    abbrName: 'CapRt',
    description:
      'The cap rate, if any, which applies to the floating rate. The cap rate (strike) is only required where the floating rate on a swap stream is capped at a certain level. The cap rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A cap rate of 5% would be represented as 0.05.',
  },
  {
    type: 'PaymentStreamCapRateBuySideCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCapRateBuySide',
    id: 40629,
    abbrName: 'CapRtBuy',
    description: 'Reference to the buyer of the cap rate option through its trade side.',
  },
  {
    type: 'PaymentStreamCapRateBuySideCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCapRateSellSide',
    id: 40630,
    abbrName: 'CapRtSell',
    description: 'Reference to the seller of the cap rate option through its trade side.',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFloorRate',
    id: 40631,
    abbrName: 'FlrRt',
    description:
      'The floor rate, if any, which applies to the floating rate. The floor rate (strike) is only required where the floating rate on a swap stream is floored at a certain strike level. The floor rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A floor rate of 5% would be represented as 0.05.',
  },
  {
    type: 'PaymentStreamFloorRateBuySideCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFloorRateBuySide',
    id: 40632,
    abbrName: 'FlrRtBuy',
    description:
      'Reference to the buyer of the floor rate option through its trade side.',
  },
  {
    type: 'PaymentStreamFloorRateBuySideCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFloorRateSellSide',
    id: 40633,
    abbrName: 'FlrRtSell',
    description:
      'Reference to the seller of the floor rate option through its trade side.',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamInitialRate',
    id: 40634,
    abbrName: 'InitRt',
    description:
      'The initial floating rate reset agreed between the principal parties involved in the trade. This is assumed to be the first required reset rate for the first regular calculation period. It should only be included when the rate is not equal to the rate published on the source implied by the floating rate index. An initial rate of 5% would be represented as 0.05.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'RoundingDirectionCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFinalRateRoundingDirection',
    id: 40635,
    abbrName: 'FnlRtRndDirctn',
    description: 'Specifies the rounding direction.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFinalRatePrecision',
    id: 40636,
    abbrName: 'FnlRtPrcsn',
    description:
      'Specifies the rounding precision in terms of a number of decimal places. Note how a percentage rate rounding of 5 decimal places is expressed as a rounding precision of 7.',
  },
  {
    type: 'PaymentStreamAveragingMethodCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamAveragingMethod',
    id: 40637,
    abbrName: 'AvgngMeth',
    description:
      'When rate averaging is applicable, used to specify whether a weighted or unweighted average calculation method is to be used.',
  },
  {
    type: 'PaymentStreamNegativeRateTreatmentCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamNegativeRateTreatment',
    id: 40638,
    abbrName: 'NegtvRtTrtmt',
    description:
      'The specification of any provisions for calculating payment obligations when a floating rate is negative (either due to a quoted negative floating rate or by operation of a spread that is subtracted from the floating rate).',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamInflationLagPeriod',
    id: 40639,
    abbrName: 'LagPeriod',
    description:
      'Time unit multiplier for the inflation lag period. The lag period is the offsetting period from the payment date which determines the reference period for which the inflation index is observed.',
  },
  {
    type: 'PaymentStreamInflationLagUnitCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamInflationLagUnit',
    id: 40640,
    abbrName: 'LagUnit',
    description: 'Time unit associated with the inflation lag period.',
  },
  {
    type: 'PaymentStreamInflationLagDayTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamInflationLagDayType',
    id: 40641,
    abbrName: 'LagDayTyp',
    description: 'The inflation lag period day type.',
  },
  {
    type: 'PaymentStreamInflationInterpolationMethodCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamInflationInterpolationMethod',
    id: 40642,
    abbrName: 'IntrpltnMeth',
    description:
      'The method used when calculating the Inflation Index Level from multiple points - the most common is Linear.',
  },
  {
    type: 'PaymentStreamRateIndexSourceCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamInflationIndexSource',
    id: 40643,
    abbrName: 'InfltnNdxSrc',
    description: 'The inflation index reference source.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamInflationPublicationSource',
    id: 40644,
    abbrName: 'PublctnSrc',
    description:
      'The current main publication source such as relevant web site or a government body.',
  },
  {
    type: 'float',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamInflationInitialIndexLevel',
    id: 40645,
    abbrName: 'InitLvl',
    description: 'Initial known index level for the first calculation period.',
  },
  {
    type: 'Boolean',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamInflationFallbackBondApplicable',
    id: 40646,
    abbrName: 'FallbckBond',
    description:
      'Indicates whether a fallback bond as defined in the 2006 ISDA Inflation Derivatives Definitions, sections 1.3 and 1.8, is applicable or not. If not specified, the default value is "Y" (True/Yes).',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamFRADiscountingCodeSet',
    addedEP: '161',
    updatedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFRADiscounting',
    id: 40647,
    abbrName: 'FRADisc',
    description:
      'The method of Forward Rate Agreement (FRA) discounting, if any, that will apply.',
  },
  {
    type: 'Currency',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamNonDeliverableRefCurrency',
    id: 40648,
    abbrName: 'Ccy',
    description:
      'The non-deliverable settlement reference currency. Uses ISO 4217 currency codes.',
  },
  {
    updated: 'FIX.Latest',
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamNonDeliverableFixingDatesBizDayConvention',
    id: 40649,
    abbrName: 'BizDayCnvtn',
    description:
      "The business day convention used to adjust the payment stream's fixing date for the non-deliverable terms. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamNonDeliverableFixingDatesBusinessCenter',
    id: 40650,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the payment stream\'s fixing date for the non-deliverable terms, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamNonDeliverableFixingDatesRelativeTo',
    id: 40651,
    abbrName: 'FixngReltv',
    description:
      'Specifies the anchor date when the non-deliverable fixing dates are relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamNonDeliverableFixingDatesOffsetPeriod',
    id: 40652,
    abbrName: 'FixngPeriod',
    description:
      'Time unit multiplier for the relative non-deliverable fixing date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamNonDeliverableFixingDatesOffsetUnit',
    id: 40653,
    abbrName: 'FixngUnit',
    description:
      'Time unit associated with the relative non-deliverable fixing date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamNonDeliverableFixingDatesOffsetDayType',
    id: 40654,
    abbrName: 'FixngDayTyp',
    description:
      'Specifies the day type of the relative non-deliverable fixing date offset.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'SettlRateFallbackReferencePage',
    id: 40655,
    abbrName: 'RefPg',
    description:
      'Identifies the reference "page" from the rate source.\n\nWhen SettlRateFallbackRateSource(40373) = 3 (ISDA Settlement Rate Option) this contains the value from the scheme that reflects the terms of the Annex A to the ISDA 1998 FX and Currency Option Definitions. See: http://www.fpml.org/coding-scheme/settlement-rate-option',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingNonDeliverableFixingDates',
    id: 40656,
    description: 'Number of Fixing dates in the repeating group',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingNonDeliverableFixingDate',
    id: 40657,
    abbrName: 'Dt',
    description:
      'The non-deliverable fixing date unadjusted or adjusted depending on UnderlyingNonDeliverableFixingDateType(40658).',
  },
  {
    type: 'NonDeliverableFixingDateTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingNonDeliverableFixingDateType',
    id: 40658,
    abbrName: 'Typ',
    description: 'Specifies the type of date (e.g. adjusted for holidays).',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingSettlRateFallbacks',
    id: 40659,
    description: 'Number of settlement rate fallbacks in the repeating group',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingSettlRatePostponementMaximumDays',
    id: 40660,
    abbrName: 'MaxDays',
    description:
      'The maximum number of days to wait for a quote from the disrupted settlement rate option before proceding to this method.',
  },
  {
    type: 'RateSourceCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamNonDeliverableSettlRateSource',
    id: 40661,
    abbrName: 'RtSrc',
    description: 'Identifies the source of rate information.',
  },
  {
    type: 'Boolean',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingSettlRatePostponementSurvey',
    id: 40662,
    abbrName: 'Survey',
    description: 'Indicates whether to request a settlement rate quote from the market.',
  },
  {
    type: 'ProvisionCalculationAgentCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingSettlRatePostponementCalculationAgent',
    id: 40663,
    abbrName: 'CalcAgent',
    description: 'Used to identify the settlement rate postponement calculation agent.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingPaymentSchedules',
    id: 40664,
    description: 'Number of swap schedules in the repeating group',
  },
  {
    type: 'PaymentScheduleTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleType',
    id: 40665,
    abbrName: 'Typ',
    description: 'Type of schedule.',
  },
  {
    type: 'PaymentStubTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleStubType',
    id: 40666,
    abbrName: 'StubTyp',
    description: 'Indicates to which stub this schedule applies.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleStartDateUnadjusted',
    id: 40667,
    abbrName: 'StartDtUnadj',
    description:
      'The unadjusted date on which the value is adjusted, or calculated if a future value notional for certain non-deliverable interest rate swaps (e.g. Brazillian Real (BRL) vs. CETIP Interbank Deposit Rate (CDI)), or the start date of a cashflow payment.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleEndDateUnadjusted',
    id: 40668,
    abbrName: 'EndDtUnadj',
    description: 'The unadjusted end date of a cashflow payment.',
  },
  {
    type: 'PaymentPaySideCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentSchedulePaySide',
    id: 40669,
    abbrName: 'PaySide',
    description: 'The side of the party paying the step schedule.',
  },
  {
    type: 'PaymentPaySideCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleReceiveSide',
    id: 40670,
    abbrName: 'RcvSide',
    description: 'The side of the party receiving the step schedule.',
  },
  {
    type: 'Amt',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleNotional',
    id: 40671,
    abbrName: 'Notl',
    description: 'The notional value for this step, or amount of a cashflow payment.',
  },
  {
    type: 'Currency',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleCurrency',
    id: 40672,
    abbrName: 'Ccy',
    description: 'The currency for this step. Uses ISO 4217 currency codes.',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleRate',
    id: 40673,
    abbrName: 'Rt',
    discriminatorId: '40705',
    description: 'The rate value for this step.',
  },
  {
    type: 'float',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleRateMultiplier',
    id: 40674,
    abbrName: 'RtMult',
    description:
      'A rate multiplier to apply to the floating rate. The multiplier can be less than or greater than 1 (one). This element should only be included if the multiplier is not equal to 1 (one) for the term of the stream.',
  },
  {
    type: 'PriceOffset',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleRateSpread',
    id: 40675,
    abbrName: 'Spread',
    description: 'The spread value for this step.',
  },
  {
    type: 'PaymentStreamRateSpreadPositionTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleRateSpreadPositionType',
    id: 40676,
    abbrName: 'SpreadPosTyp',
    description:
      'Identifies whether the rate spread is applied to a long or short position.',
  },
  {
    type: 'PaymentStreamRateTreatmentCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleRateTreatment',
    id: 40677,
    abbrName: 'RtTrtmt',
    description: 'Specifies the yield calculation treatment for the step schedule.',
  },
  {
    type: 'Amt',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleFixedAmount',
    id: 40678,
    abbrName: 'FixedAmt',
    description: 'The explicit payment amount for this step.',
  },
  {
    type: 'Currency',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleFixedCurrency',
    id: 40679,
    abbrName: 'FixedCcy',
    description: 'The currency of the fixed amount. Uses ISO 4217 currency codes.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleStepFrequencyPeriod',
    id: 40680,
    abbrName: 'StepPeriod',
    description: 'Time unit multiplier for the step frequency.',
  },
  {
    type: 'CouponFrequencyUnitCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleStepFrequencyUnit',
    id: 40681,
    abbrName: 'StepUnit',
    description: 'Time unit associated with the step frequency.',
  },
  {
    type: 'Amt',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleStepOffsetValue',
    id: 40682,
    abbrName: 'StepVal',
    description:
      'The explicit amount that the notional changes on each step date. This can be a positive or negative amount.',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleStepRate',
    id: 40683,
    abbrName: 'StepRt',
    description:
      'The percentage by which the notional changes on each step date. The percentage is either a percentage applied to the initial notional amount or the previous outstanding notional, depending on the value specified in UnderlyingPaymentScheduleStepRelativeTo(40685). The percentage can be either positive or negative.',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleStepOffsetRate',
    id: 40684,
    abbrName: 'StepOfstRt',
    description:
      'The explicit amount that the rate changes on each step date. This can be a positive or negative value.',
  },
  {
    type: 'PaymentScheduleStepRelativeToCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleStepRelativeTo',
    id: 40685,
    abbrName: 'StepReltv',
    description:
      'Specifies whether the UnderlyingPaymentScheduleStepRate(40683) or UnderlyingPaymentScheduleStepOffsetValue(40682) should be applied to the initial notional or the previous notional in order to calculate the notional step change amount.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleFixingDateUnadjusted',
    id: 40686,
    abbrName: 'FixngDtUnadj',
    description: 'The unadjusted fixing date.',
  },
  {
    type: 'float',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleWeight',
    id: 40687,
    abbrName: 'Wt',
    description: 'Floating rate observation weight for cashflow payment.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleFixingDateRelativeTo',
    id: 40688,
    abbrName: 'FixngReltv',
    description:
      'Specifies the anchor date when the fixing date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleFixingDateBusinessDayCnvtn',
    id: 40689,
    abbrName: 'FixngBizDayCnvtn',
    description:
      "The business day convention used to adjust the payment schedule's fixing date. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleFixingDateBusinessCenter',
    id: 40690,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the payment schedule\'s fixing date, e.g. "GBLO". See http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleFixingDateOffsetPeriod',
    id: 40691,
    abbrName: 'FixngPeriod',
    description: 'Time unit multiplier for the relative fixing date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleFixingDateOffsetUnit',
    id: 40692,
    abbrName: 'FixngUnit',
    description: 'Time unit associated with the relative fixing date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleFixingDateOffsetDayType',
    id: 40693,
    abbrName: 'FixngDayTyp',
    description: 'Specifies the day type of the relative fixing date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleFixingDateAdjusted',
    id: 40694,
    abbrName: 'FixngDt',
    description: 'The adjusted fixing date.',
  },
  {
    type: 'LocalMktTime',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleFixingTime',
    id: 40695,
    abbrName: 'FixngTm',
    description: 'The fixing time.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleFixingTimeBusinessCenter',
    id: 40696,
    abbrName: 'FixngTmBizCtr',
    description:
      'Business center for determining fixing time. See http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleInterimExchangePaymentDateRelativeTo',
    id: 40697,
    abbrName: 'IntrmExchDtReltv',
    description:
      'Specifies the anchor date when the interim exchange payment date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    updated: 'FIX.Latest',
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleInterimExchangeDatesBizDayConvention',
    id: 40698,
    abbrName: 'IntrmExchDtBizDayCnvtn',
    description:
      "The business day convention used to adjust the payment schedule's interim exchange date. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleInterimExchangeDatesBusinessCenter',
    id: 40699,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the payment schedule\'s interim exchange date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleInterimExchangeDatesOffsetPeriod',
    id: 40700,
    abbrName: 'IntrmExchDtPeriod',
    description: 'Time unit multiplier for the relative interim exchange date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleInterimExchangeDatesOffsetUnit',
    id: 40701,
    abbrName: 'IntrmExchDtUnit',
    description: 'Time unit associated with the relative interim exchange date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleInterimExchangeDatesOffsetDayType',
    id: 40702,
    abbrName: 'IntrmExchDayTyp',
    description: 'Specifies the day type of the relative interim exchange date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleInterimExchangeDateAdjusted',
    id: 40703,
    abbrName: 'IntrmExchDt',
    description: 'The adjusted interim exchange date.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingPaymentScheduleRateSources',
    id: 40704,
    description: 'Number of rate sources in the repeating group',
  },
  {
    type: 'RateSourceCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleRateSource',
    id: 40705,
    abbrName: 'Src',
    description: 'Identifies the source of rate information.',
  },
  {
    type: 'RateSourceTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleRateSourceType',
    id: 40706,
    abbrName: 'Typ',
    description: 'Rate source type.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleReferencePage',
    id: 40707,
    abbrName: 'RefPg',
    description:
      'Identifies the reference “page” from the rate source.\n\nFor FX, the reference page to the spot rate to be used for the reference FX spot rate.\n\nWhen RateSource(1446) = 3 (ISDA Settlement Rate Option) this contains the value from the scheme that reflects the terms of the Annex A to the ISDA 1998 FX and Currency Option Definitions. See: http://www.fpml.org/coding-scheme/settlement-rate-option',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingPaymentStubs',
    id: 40708,
    description: 'Number of stubs in the repeating group',
  },
  {
    type: 'PaymentStubTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubType',
    id: 40709,
    abbrName: 'Typ',
    description: 'Stub type.',
  },
  {
    type: 'PaymentStubLengthCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubLength',
    id: 40710,
    abbrName: 'Lngth',
    description:
      'Optional indication whether stub is shorter or longer than the regular swap period.',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubRate',
    id: 40711,
    abbrName: 'Rt',
    description: 'The agreed upon fixed rate for this stub.',
  },
  {
    type: 'Amt',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubFixedAmount',
    id: 40712,
    abbrName: 'FixedAmt',
    description: 'A fixed payment amount for the stub.',
  },
  {
    type: 'Currency',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubFixedCurrency',
    id: 40713,
    abbrName: 'FixedCcy',
    description:
      'The currency of the fixed payment amount. Uses ISO 4217 currency codes.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubIndex',
    id: 40714,
    abbrName: 'Ndx',
    discriminatorId: '40715',
    description: 'The stub floating rate index.',
  },
  {
    type: 'PaymentStreamRateIndexSourceCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubIndexSource',
    id: 40715,
    abbrName: 'NdxSrc',
    description: 'The source for the underlying payment stub floating rate index.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubIndexCurvePeriod',
    id: 40716,
    abbrName: 'NdxPeriod',
    description:
      'Time unit multiplier for the underlying payment stub floating rate index.',
  },
  {
    type: 'PaymentStreamRateIndexCurveUnitCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubIndexCurveUnit',
    id: 40717,
    abbrName: 'NdxUnit',
    description:
      'Time unit associated with the underlying payment stub floating rate index.',
  },
  {
    type: 'float',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubIndexRateMultiplier',
    id: 40718,
    abbrName: 'RtMult',
    description:
      'A rate multiplier to apply to the floating rate. The multiplier can be less than or greater than 1 (one). This element should only be included if the multiplier is not equal to 1 (one) for the term of the stream.',
  },
  {
    type: 'PriceOffset',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubIndexRateSpread',
    id: 40719,
    abbrName: 'Spread',
    description: 'Spread from floating rate index.',
  },
  {
    type: 'PaymentStreamRateSpreadPositionTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubIndexRateSpreadPositionType',
    id: 40720,
    abbrName: 'SpreadPosTyp',
    description:
      'Identifies whether the rate spread is applied to a long or short position.',
  },
  {
    type: 'PaymentStreamRateTreatmentCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubIndexRateTreatment',
    id: 40721,
    abbrName: 'RtTrtmt',
    description: 'Specifies the yield calculation treatment for the stub index.',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubIndexCapRate',
    id: 40722,
    abbrName: 'CapRt',
    description:
      'The cap rate, if any, which applies to the floating rate. The cap rate (strike) is only required where the floating rate on a swap stream is capped at a certain level. The cap rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A cap rate of 5% would be represented as 0.05.',
  },
  {
    type: 'PaymentStreamCapRateBuySideCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubIndexCapRateBuySide',
    id: 40723,
    abbrName: 'CapRtBuy',
    description: 'Reference to the buyer of the cap rate option through its trade side.',
  },
  {
    type: 'PaymentStreamCapRateBuySideCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubIndexCapRateSellSide',
    id: 40724,
    abbrName: 'CapRtSell',
    description: 'Reference to the seller of the cap rate option through its trade side.',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubIndexFloorRate',
    id: 40725,
    abbrName: 'FlrRt',
    description:
      'The floor rate, if any, which applies to the floating rate. The floor rate (strike) is only required where the floating rate on a swap stream is floored at a certain strike level. The floor rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A floor rate of 5% would be represented as 0.05.',
  },
  {
    type: 'PaymentStreamFloorRateBuySideCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubIndexFloorRateBuySide',
    id: 40726,
    abbrName: 'FlrRtBuy',
    description:
      'Reference to the buyer of the floor rate option through its trade side.',
  },
  {
    type: 'PaymentStreamFloorRateBuySideCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubIndexFloorRateSellSide',
    id: 40727,
    abbrName: 'FlrRtSell',
    description:
      'Reference to the seller of the floor rate option through its trade side.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubIndex2',
    id: 40728,
    abbrName: 'Ndx2',
    discriminatorId: '40729',
    description: 'The second stub floating rate index.',
  },
  {
    type: 'PaymentStreamRateIndexSourceCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubIndex2Source',
    id: 40729,
    abbrName: 'Ndx2Src',
    description: 'The source of the second stub floating rate index.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubIndex2CurvePeriod',
    id: 40730,
    abbrName: 'Ndx2Period',
    description: 'Secondary time unit multiplier for the stub floating rate index curve.',
  },
  {
    type: 'PaymentStreamRateIndexCurveUnitCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubIndex2CurveUnit',
    id: 40731,
    abbrName: 'Ndx2Unit',
    description:
      'Secondary time unit associated with the stub floating rate index curve.',
  },
  {
    type: 'float',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubIndex2RateMultiplier',
    id: 40732,
    abbrName: 'RtMult2',
    description:
      'A rate multiplier to apply to the second floating rate. The multiplier can be less than or greater than 1 (one). This element should only be included if the multiplier is not equal to 1 (one) for the term of the stream.',
  },
  {
    type: 'PriceOffset',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubIndex2RateSpread',
    id: 40733,
    abbrName: 'Spread2',
    description: 'Spread from the second floating rate index.',
  },
  {
    type: 'PaymentStreamRateSpreadPositionTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubIndex2RateSpreadPositionType',
    id: 40734,
    abbrName: 'Spread2PosTyp',
    description:
      'Identifies whether the rate spread is applied to a long or short position.',
  },
  {
    type: 'PaymentStreamRateTreatmentCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubIndex2RateTreatment',
    id: 40735,
    abbrName: 'RtTrtmt2',
    description: 'Specifies the yield calculation treatment for the second stub index.',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubIndex2CapRate',
    id: 40736,
    abbrName: 'CapRt2',
    description:
      'The cap rate, if any, which applies to the second floating rate. The cap rate (strike) is only required where the floating rate on a swap stream is capped at a certain level. The cap rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A cap rate of 5% would be represented as 0.05.',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubIndex2FloorRate',
    id: 40737,
    abbrName: 'FlrRt2',
    description:
      'The floor rate, if any, which applies to the second floating rate. The floor rate (strike) is only required where the floating rate on a swap stream is floored at a certain strike level. The floor rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A floor rate of 5% would be represented as 0.05.',
  },
  {
    type: 'PaymentStreamTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamType',
    id: 40738,
    abbrName: 'Typ',
    description: 'Identifies the type of payment stream associated with the swap.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamMarketRate',
    id: 40739,
    abbrName: 'MktRt',
    description:
      'Used only for credit index trade. This contains the credit spread ("fair value") at which the trade was executed. The market rate varies over the life of the index depending on market conditions. This is the price of the index as quoted by trading desks.',
  },
  {
    type: 'Boolean',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamDelayIndicator',
    id: 40740,
    abbrName: 'DelayInd',
    description:
      'Applicable to credit default swaps on mortgage backed securities to specify whether payment delays are applicable to the fixed amount.\n\nResidential mortgage backed securities typically have a payment delay of 5 days between the coupon date of the reference obligation and the payment date of the synthetic swap.\n\nCommercial mortgage backed securities do not typically have a payment delay, with both payment dates (the coupon date of the reference obligation and the payment date of the synthetic swap) being on the 25th of each month.',
  },
  {
    type: 'Currency',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamSettlCurrency',
    id: 40741,
    abbrName: 'SettlCcy',
    description:
      'Specifies the currency that the stream settles in (to support swaps that settle in a currency different from the notional currency). Uses ISO 4217 currency codes.',
  },
  {
    type: 'CouponDayCountCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamDayCount',
    id: 40742,
    abbrName: 'DayCnt',
    description: 'The day count convention used in the payment stream calculations.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamAccrualDays',
    id: 40743,
    abbrName: 'AcrlDays',
    description:
      'The number of days from the adjusted calculation period start date to the adjusted value date, calculated in accordance with the applicable day count fraction.',
  },
  {
    type: 'PaymentStreamDiscountTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamDiscountType',
    id: 40744,
    abbrName: 'DiscTyp',
    description: 'The method of calculating discounted payment amounts',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamDiscountRate',
    id: 40745,
    abbrName: 'Disc',
    description:
      'Discount rate. The rate is expressed in decimal, e.g. 5% is expressed as 0.05.',
  },
  {
    type: 'CouponDayCountCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamDiscountRateDayCount',
    id: 40746,
    abbrName: 'DiscDayCnt',
    description:
      'The day count convention applied to the PaymentStreamDiscountRate(40745).',
  },
  {
    type: 'PaymentStreamCompoundingMethodCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingMethod',
    id: 40747,
    abbrName: 'CmpndgMeth',
    description: 'Compounding method.',
  },
  {
    type: 'Boolean',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamInitialPrincipalExchangeIndicator',
    id: 40748,
    abbrName: 'InitPrncplExchInd',
    description:
      'Indicates whether there is an initial exchange of principal on the effective date.',
  },
  {
    type: 'Boolean',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamInterimPrincipalExchangeIndicator',
    id: 40749,
    abbrName: 'IntrmPrncplExchInd',
    description:
      'Indicates whether there are intermediate or interim exchanges of principal during the term of the swap.',
  },
  {
    type: 'Boolean',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFinalPrincipalExchangeIndicator',
    id: 40750,
    abbrName: 'FnlPrncplExchInd',
    description:
      'Indicates whether there is a final exchange of principal on the termination date.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamPaymentDateBusinessDayConvention',
    id: 40751,
    abbrName: 'BizDayCnvtn',
    description:
      "The business day convention used to adjust the payment stream's payment date. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamPaymentDateBusinessCenter',
    id: 40752,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the payment stream\'s payment date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamPaymentFrequencyPeriod',
    id: 40753,
    abbrName: 'FreqPeriod',
    description: 'Time unit multiplier for the frequency of payments.',
  },
  {
    type: 'PaymentStreamPaymentFrequencyUnitCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamPaymentFrequencyUnit',
    id: 40754,
    abbrName: 'FreqUnit',
    description: 'Time unit associated with the frequency of payments.',
  },
  {
    type: 'DateRollConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamPaymentRollConvention',
    id: 40755,
    abbrName: 'Roll',
    description:
      'The convention for determining the sequence of end dates. It is used in conjunction with a specified frequency. Used only to override the roll convention specified in the DateAdjustment component within the Instrument component.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFirstPaymentDateUnadjusted',
    id: 40756,
    abbrName: 'FirstDtUnadj',
    description: 'The unadjusted first payment date.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamLastRegularPaymentDateUnadjusted',
    id: 40757,
    abbrName: 'LastReglrDtUnadj',
    description: 'The unadjusted last regular payment date.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamPaymentDateRelativeTo',
    id: 40758,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when payment dates are relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamPaymentDateOffsetPeriod',
    id: 40759,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative payment date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamPaymentDateOffsetUnit',
    id: 40760,
    abbrName: 'OfstUnit',
    description: 'Time unit multiplier for the relative initial fixing date offset.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamResetDateRelativeTo',
    id: 40761,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the reset dates are relative to an anchor date.\n\nIf the reset frequency is specified as daily this element must not be included.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamResetDateBusinessDayConvention',
    id: 40762,
    abbrName: 'BizDayCnvtn',
    description:
      "The business day convention used to adjust the payment stream's reset date. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamResetDateBusinessCenter',
    id: 40763,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the payment stream\'s reset date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamResetFrequencyPeriod',
    id: 40764,
    abbrName: 'FreqPeriod',
    description: 'Time unit multiplier for the frequency of resets.',
  },
  {
    type: 'CouponFrequencyUnitCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamResetFrequencyUnit',
    id: 40765,
    abbrName: 'FreqUnit',
    description: 'Time unit associated with the frequency of resets.',
  },
  {
    type: 'PaymentStreamResetWeeklyRollConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamResetWeeklyRollConvention',
    id: 40766,
    abbrName: 'WklyRoll',
    description:
      'Used to specify the day of the week in which the reset occurs for payments that reset on a weekly basis.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamInitialFixingDateRelativeTo',
    id: 40767,
    abbrName: 'InitReltv',
    description:
      'Specifies the anchor date when the initial fixing date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamInitialFixingDateBusinessDayConvention',
    id: 40768,
    abbrName: 'InitBizDayCnvtn',
    description:
      "The business day convention used to adjust the payment stream's initial fixing date. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamInitialFixingDateBusinessCenter',
    id: 40769,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the payment stream\'s initial fixing date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamInitialFixingDateOffsetPeriod',
    id: 40770,
    abbrName: 'InitPeriod',
    description: 'Time unit multiplier for the relative initial fixing date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamInitialFixingDateOffsetUnit',
    id: 40771,
    abbrName: 'InitUnit',
    description: 'Time unit associated with the relative initial fixing date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamInitialFixingDateOffsetDayType',
    id: 40772,
    abbrName: 'InitDayTyp',
    description: 'Specifies the day type of the relative initial fixing date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamInitialFixingDateAdjusted',
    id: 40773,
    abbrName: 'InitDt',
    description: 'The adjusted initial fixing date.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFixingDateRelativeTo',
    id: 40774,
    abbrName: 'FixngReltv',
    description:
      'Specifies the anchor date when the fixing date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFixingDateBusinessDayConvention',
    id: 40775,
    abbrName: 'FixngBizDayCnvtn',
    description:
      "The business day convention used to adjust the payment stream's fixing date. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFixingDateBusinessCenter',
    id: 40776,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the payment stream\'s fixing date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFixingDateOffsetPeriod',
    id: 40777,
    abbrName: 'FixngPeriod',
    description: 'Time unit multiplier for the relative fixing date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFixingDateOffsetUnit',
    id: 40778,
    abbrName: 'FixngUnit',
    description: 'Time unit associated with the relative fixing date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFixingDateOffsetDayType',
    id: 40779,
    abbrName: 'FixngDayTyp',
    description: 'Specifies the day type of the relative fixing date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFixingDateAdjusted',
    id: 40780,
    abbrName: 'FixngDt',
    description: 'The adjusted fixing date.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamRateCutoffDateOffsetPeriod',
    id: 40781,
    abbrName: 'CutoffPeriod',
    description: 'Time unit multiplier for the relative rate cut-off date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamRateCutoffDateOffsetUnit',
    id: 40782,
    abbrName: 'CutoffUnit',
    description: 'Time unit associated with the relative rate cut-off date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamRateCutoffDateOffsetDayType',
    id: 40783,
    abbrName: 'CutoffDayTyp',
    description: 'Specifies the day type of the relative rate cut-off date offset.',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamRate',
    id: 40784,
    abbrName: 'Rt',
    description: 'The rate applicable to the fixed rate payment stream.',
  },
  {
    type: 'Amt',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFixedAmount',
    id: 40785,
    abbrName: 'Amt',
    description:
      "The payment stream's fixed payment amount. In CDS an alternative to PaymentStreamRate(40784).",
  },
  {
    type: 'Currency',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamRateOrAmountCurrency',
    id: 40786,
    abbrName: 'Ccy',
    description:
      'Specifies the currency in which PaymentStreamFixedAmount(40785) or PaymentStreamRate(40784) is denominated. Uses ISO 4271 currency codes.',
  },
  {
    type: 'Amt',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFutureValueNotional',
    id: 40787,
    abbrName: 'FutValNotl',
    description:
      'The future value notional is normally only required for certain non-deliverable interest rate swaps (e.g. Brazillian Real (BRL) vs. CETIP Interbank Deposit Rate (CDI)). The value is calculated as follows: Future Value Notional = Notional Amount * (1 + Fixed Rate) ^ (Fixed Rate Day Count Fraction). The currency is the same as the stream notional.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFutureValueDateAdjusted',
    id: 40788,
    abbrName: 'FutValDt',
    description: 'The adjusted value date of the future value amount.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamRateIndex',
    id: 40789,
    abbrName: 'Ndx',
    discriminatorId: '40790',
    description: 'The payment stream floating rate index.',
  },
  {
    type: 'PaymentStreamRateIndexSourceCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamRateIndexSource',
    id: 40790,
    abbrName: 'NdxSrc',
    description: 'The source of the payment stream floating rate index.',
  },
  {
    type: 'PaymentStreamRateIndexCurveUnitCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamRateIndexCurveUnit',
    id: 40791,
    abbrName: 'NdxUnit',
    description: 'Time unit associated with the floating rate index.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamRateIndexCurvePeriod',
    id: 40792,
    abbrName: 'NdxPeriod',
    description: 'Time unit multiplier for the floating rate index.',
  },
  {
    type: 'float',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamRateMultiplier',
    id: 40793,
    abbrName: 'RtMult',
    description:
      'A rate multiplier to apply to the floating rate. A multiplier schedule is expressed as explicit multipliers and dates. In the case of a schedule, the step dates may be subject to adjustment in accordance with any adjustments specified in the calculationPeriodDatesAdjustments. The multiplier can be less than or greater than 1 (one). This element should only be included if the multiplier is not equal to 1 (one) for the term of the stream.',
  },
  {
    type: 'PriceOffset',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamRateSpread',
    id: 40794,
    abbrName: 'Spread',
    description: 'Spread from floating rate index.',
  },
  {
    type: 'PaymentStreamRateSpreadPositionTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamRateSpreadPositionType',
    id: 40795,
    abbrName: 'SpreadPosTyp',
    description:
      'Identifies whether the rate spread is applied to a long or short position.',
  },
  {
    type: 'PaymentStreamRateTreatmentCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamRateTreatment',
    id: 40796,
    abbrName: 'RtTrtmt',
    description: 'Specifies the yield calculation treatment for the index.',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCapRate',
    id: 40797,
    abbrName: 'CapRt',
    description:
      'The cap rate, if any, which applies to the floating rate. The cap rate (strike) is only required where the floating rate on a swap stream is capped at a certain level. The cap rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A cap rate of 5% would be represented as 0.05.',
  },
  {
    type: 'PaymentStreamCapRateBuySideCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCapRateBuySide',
    id: 40798,
    abbrName: 'CapRtBuy',
    description: 'Reference to the buyer of the cap rate option through its trade side.',
  },
  {
    type: 'PaymentStreamCapRateBuySideCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCapRateSellSide',
    id: 40799,
    abbrName: 'CapRtSell',
    description: 'Reference to the seller of the cap rate option through its trade side.',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFloorRate',
    id: 40800,
    abbrName: 'FlrRt',
    description:
      'The floor rate, if any, which applies to the floating rate. The floor rate (strike) is only required where the floating rate on a swap stream is floored at a certain strike level. The floor rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A floor rate of 5% would be represented as 0.05.',
  },
  {
    type: 'PaymentStreamFloorRateBuySideCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFloorRateBuySide',
    id: 40801,
    abbrName: 'FlrRtBuy',
    description:
      'Reference to the buyer of the floor rate option through its trade side.',
  },
  {
    type: 'PaymentStreamFloorRateBuySideCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFloorRateSellSide',
    id: 40802,
    abbrName: 'FlrRtSell',
    description:
      'Reference to the seller of the floor rate option through its trade side.',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamInitialRate',
    id: 40803,
    abbrName: 'InitRt',
    description:
      'The initial floating rate reset agreed between the principal parties involved in the trade. This is assumed to be the first required reset rate for the first regular calculation period. It should only be included when the rate is not equal to the rate published on the source implied by the floating rate index. An initial rate of 5% would be represented as 0.05.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'RoundingDirectionCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFinalRateRoundingDirection',
    id: 40804,
    abbrName: 'FnlRtRndDirctn',
    description: 'Specifies the rounding direction.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFinalRatePrecision',
    id: 40805,
    abbrName: 'FnlRtPrcsn',
    description:
      'Specifies the rounding precision in terms of a number of decimal places. Note how a percentage rate rounding of 5 decimal places is expressed as a rounding precision of 7.',
  },
  {
    type: 'PaymentStreamAveragingMethodCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamAveragingMethod',
    id: 40806,
    abbrName: 'AvgngMeth',
    description:
      'When rate averaging is applicable, used to specify whether a weighted or unweighted average calculation method is to be used.',
  },
  {
    type: 'PaymentStreamNegativeRateTreatmentCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamNegativeRateTreatment',
    id: 40807,
    abbrName: 'NegtvRtTrtmt',
    description:
      'The specification of any provisions for calculating payment obligations when a floating rate is negative (either due to a quoted negative floating rate or by operation of a spread that is subtracted from the floating rate).',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamInflationLagPeriod',
    id: 40808,
    abbrName: 'LagPeriod',
    description:
      'Time unit multiplier for the inflation lag period. The lag period is the offsetting period from the payment date which determines the reference period for which the inflation index is observed.',
  },
  {
    type: 'PaymentStreamInflationLagUnitCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamInflationLagUnit',
    id: 40809,
    abbrName: 'LagUnit',
    description: 'Time unit associated with the inflation lag period.',
  },
  {
    type: 'PaymentStreamInflationLagDayTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamInflationLagDayType',
    id: 40810,
    abbrName: 'LagDayTyp',
    description: 'The inflation lag period day type.',
  },
  {
    type: 'PaymentStreamInflationInterpolationMethodCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamInflationInterpolationMethod',
    id: 40811,
    abbrName: 'IntrpltnMeth',
    description:
      'The method used when calculating the Inflation Index Level from multiple points - the most common is Linear.',
  },
  {
    type: 'PaymentStreamRateIndexSourceCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamInflationIndexSource',
    id: 40812,
    abbrName: 'InfltnNdxSrc',
    description: 'The inflation index reference source.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamInflationPublicationSource',
    id: 40813,
    abbrName: 'PublctnSrc',
    description:
      'The current main publication source such as relevant web site or a government body.',
  },
  {
    type: 'float',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamInflationInitialIndexLevel',
    id: 40814,
    abbrName: 'InitLvl',
    description: 'Initial known index level for the first calculation period.',
  },
  {
    type: 'Boolean',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamInflationFallbackBondApplicable',
    id: 40815,
    abbrName: 'FallbckBond',
    description:
      'Indicates whether a fallback bond as defined in the 2006 ISDA Inflation Derivatives Definitions, sections 1.3 and 1.8, is applicable or not. If not specified, the default value is "Y" (True/Yes).',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamFRADiscountingCodeSet',
    addedEP: '161',
    updatedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFRADiscounting',
    id: 40816,
    abbrName: 'FRADisc',
    description:
      'The method of Forward Rate Agreement (FRA) discounting, if any, that will apply.',
  },
  {
    type: 'Currency',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamNonDeliverableRefCurrency',
    id: 40817,
    abbrName: 'Ccy',
    description:
      'The non-deliverable settlement reference currency. Uses ISO 4217 currency codes.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamNonDeliverableFixingDatesBusinessDayConvention',
    id: 40818,
    abbrName: 'BizDayCnvtn',
    description:
      "The business day convention used to adjust the payment stream's fixing date for the non-deliverable settlement terms. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamNonDeliverableFixingDatesBusinessCenter',
    id: 40819,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the payment stream\'s fixing date for the non-deliverable terms, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamNonDeliverableFixingDatesRelativeTo',
    id: 40820,
    abbrName: 'FixngReltv',
    description:
      'Specifies the anchor date when the non-deliverable fixing dates are relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamNonDeliverableFixingDatesOffsetPeriod',
    id: 40821,
    abbrName: 'FixngPeriod',
    description:
      'Time unit multiplier for the relative non-deliverable fixing date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamNonDeliverableFixingDatesOffsetUnit',
    id: 40822,
    abbrName: 'FixngUnit',
    description:
      'Time unit associated with the relative non-deliverable fixing date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamNonDeliverableFixingDatesOffsetDayType',
    id: 40823,
    abbrName: 'FixngDayTyp',
    description:
      'Specifies the day type of the relative non-deliverable fixing date offset.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamNonDeliverableSettlReferencePage',
    id: 40824,
    abbrName: 'RefPg',
    description:
      'Identifies the reference "page" from the rate source.\n\nWhen UnderlyingPaymentStreamNonDeliverableSettlRateSource(40661) = 3(ISDA Settlement Rate Option) this contains the value from the scheme that reflects the terms of the Annex A to the ISDA 1998 FX and Currency Option Definitions. See: http://www.fpml.org/coding-scheme/settlement-rate-option',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoNonDeliverableFixingDates',
    id: 40825,
    description: 'Number of Fixing dates in the repeating group',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NonDeliverableFixingDate',
    id: 40826,
    abbrName: 'Dt',
    description:
      'Non-deliverable fixing date unadjusted or adjusted depending on NonDeliverableFixingDateType(40827).',
  },
  {
    type: 'NonDeliverableFixingDateTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NonDeliverableFixingDateType',
    id: 40827,
    abbrName: 'Typ',
    description: 'Specifies the type of date (e.g. adjusted for holidays).',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoPaymentSchedules',
    id: 40828,
    description: 'Number of swap schedules in the repeating group',
  },
  {
    type: 'PaymentScheduleTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleType',
    id: 40829,
    abbrName: 'Typ',
    description: 'Type of schedule.',
  },
  {
    type: 'PaymentStubTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleStubType',
    id: 40830,
    abbrName: 'StubTyp',
    description: 'Indicates to which stub this schedule applies.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleStartDateUnadjusted',
    id: 40831,
    abbrName: 'StartDtUnadj',
    description:
      'The date on which the value is adjusted, or calculated if a future value notional for certain non-deliverable interest rate swaps (e.g. Brazillian Real (BRL) vs. CETIP Interbank Deposit Rate (CDI)), or the start date of a cashflow payment.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleEndDateUnadjusted',
    id: 40832,
    abbrName: 'EndDtUnadj',
    description: 'The unadjusted end date of a cash flow payment.',
  },
  {
    type: 'PaymentPaySideCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentSchedulePaySide',
    id: 40833,
    abbrName: 'PaySide',
    description: 'The side of the party paying the step schedule.',
  },
  {
    type: 'PaymentPaySideCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleReceiveSide',
    id: 40834,
    abbrName: 'RcvSide',
    description: 'The side of the party receiving the stepf schedule.',
  },
  {
    type: 'Amt',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleNotional',
    id: 40835,
    abbrName: 'Notl',
    description: 'The notional value for this step, or amount of a cashflow payment.',
  },
  {
    type: 'Currency',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleCurrency',
    id: 40836,
    abbrName: 'Ccy',
    description: 'The currency for this step. Uses ISO 4217 currency codes.',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleRate',
    id: 40837,
    abbrName: 'Rt',
    discriminatorId: '40869',
    description: 'The rate value for this step schedule.',
  },
  {
    type: 'float',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleRateMultiplier',
    id: 40838,
    abbrName: 'RtMult',
    description:
      'A rate multiplier to apply to the floating rate. The multiplier can be less than or greater than 1 (one). This element should only be included if the multiplier is not equal to 1 (one) for the term of the stream.',
  },
  {
    type: 'PriceOffset',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleRateSpread',
    id: 40839,
    abbrName: 'Spread',
    description: 'The spread value for this step schedule.',
  },
  {
    type: 'PaymentStreamRateSpreadPositionTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleRateSpreadPositionType',
    id: 40840,
    abbrName: 'SpreadPosTyp',
    description:
      'Identifies whether the rate spread is applied to a long or short position.',
  },
  {
    type: 'PaymentStreamRateTreatmentCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleRateTreatment',
    id: 40841,
    abbrName: 'RtTrtmt',
    description: 'Specifies the yield calculation treatment for the step schedule.',
  },
  {
    type: 'Amt',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleFixedAmount',
    id: 40842,
    abbrName: 'FixedAmt',
    description: 'The explicit payment amount for this step schedule.',
  },
  {
    type: 'Currency',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleFixedCurrency',
    id: 40843,
    abbrName: 'FixedCcy',
    description: 'The currency of the fixed amount. Uses ISO 4217 currency codes.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleStepFrequencyPeriod',
    id: 40844,
    abbrName: 'StepPeriod',
    description: 'Time unit multiplier for the step frequency.',
  },
  {
    type: 'CouponFrequencyUnitCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleStepFrequencyUnit',
    id: 40845,
    abbrName: 'StepUnit',
    description: 'Time unit associated with the step frequency.',
  },
  {
    type: 'Amt',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleStepOffsetValue',
    id: 40846,
    abbrName: 'StepVal',
    description:
      'The explicit amount that the notional changes on each step date. This can be a positive or negative amount.',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleStepRate',
    id: 40847,
    abbrName: 'StepRt',
    description:
      'The percentage by which the notional changes on each step date. The percentage is either a percentage applied to the initial notional amount or the previous outstanding notional, depending on the value specified in PaymentScheduleStepRelativeTo(40849). The percentage can be either positive or negative.',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleStepOffsetRate',
    id: 40848,
    abbrName: 'StepOfstRt',
    description:
      'The explicit amount that the rate changes on each step date. This can be a positive or negative value.',
  },
  {
    type: 'PaymentScheduleStepRelativeToCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleStepRelativeTo',
    id: 40849,
    abbrName: 'StepReltv',
    description:
      'Specifies whether the PaymentScheduleStepRate(40847) or PaymentScheduleStepOffsetValue(40846) should be applied to the initial notional or the previous notional in order to calculate the notional step change amount.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleFixingDateUnadjusted',
    id: 40850,
    abbrName: 'FixngDtUnadj',
    description: 'The unadjusted fixing date.',
  },
  {
    type: 'float',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleWeight',
    id: 40851,
    abbrName: 'Wt',
    description: 'Floating rate observation weight for cashflow payment.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleFixingDateRelativeTo',
    id: 40852,
    abbrName: 'FixngReltv',
    description:
      'Specifies the anchor date when the fixing date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleFixingDateBusinessDayConvention',
    id: 40853,
    abbrName: 'FixngBizDayCnvtn',
    description:
      "The business day convention used to adjust the payment schedule's fixing date. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleFixingDateBusinessCenter',
    id: 40854,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the payment schedule\'s fixing date, e.g. "GBLO". See http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleFixingDateOffsetPeriod',
    id: 40855,
    abbrName: 'FixngPeriod',
    description: 'Time unit multiplier for the relative fixing date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleFixingDateOffsetUnit',
    id: 40856,
    abbrName: 'FixngUnit',
    description: 'Time unit associated with the relative fixing date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleFixingDateOffsetDayType',
    id: 40857,
    abbrName: 'FixngDayTyp',
    description: 'Specifies the day type of the relative fixing date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleFixingDateAdjusted',
    id: 40858,
    abbrName: 'FixngDt',
    description: 'The adjusted fixing date.',
  },
  {
    type: 'LocalMktTime',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleFixingTime',
    id: 40859,
    abbrName: 'FixngTm',
    description: 'The fixing time associated with the step schedule.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleFixingTimeBusinessCenter',
    id: 40860,
    abbrName: 'FixngTmBizCtr',
    description:
      'Business center for determining fixing time.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleInterimExchangePaymentDateRelativeTo',
    id: 40861,
    abbrName: 'IntrmExchDtReltv',
    description:
      'Specifies the anchor date when the interim exchange payment date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleInterimExchangeDatesBusinessDayConvention',
    id: 40862,
    abbrName: 'IntrmExchDtBizDayCnvtn',
    description:
      "The business day convention used to adjust the payment schedule's interim exchange date. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleInterimExchangeDatesBusinessCenter',
    id: 40863,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the payment schedule\'s interim exchange date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleInterimExchangeDatesOffsetPeriod',
    id: 40864,
    abbrName: 'IntrmExchDtPeriod',
    description: 'Time unit multiplier for the relative interim exchange date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleInterimExchangeDatesOffsetUnit',
    id: 40865,
    abbrName: 'IntrmExchDtUnit',
    description: 'Time unit associated with the relative interim exchange date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleInterimExchangeDatesOffsetDayType',
    id: 40866,
    abbrName: 'IntrmExchDayTyp',
    description: 'Specifies the day type of the relative interim exchange date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleInterimExchangeDateAdjusted',
    id: 40867,
    abbrName: 'IntrmExchDt',
    description: 'The adjusted interim exchange date.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoPaymentScheduleRateSources',
    id: 40868,
    description: 'Number of swap schedule rate sources.',
  },
  {
    type: 'RateSourceCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleRateSource',
    id: 40869,
    abbrName: 'Src',
    description: 'Identifies the source of rate information.',
  },
  {
    type: 'RateSourceTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleRateSourceType',
    id: 40870,
    abbrName: 'Typ',
    description: 'Rate source type.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleReferencePage',
    id: 40871,
    abbrName: 'RefPg',
    description:
      'Identifies the reference “page” from the rate source.\n\nFor FX, the reference page to the spot rate to be used for the reference FX spot rate.\n\nWhen RateSource(1446) = 3 (ISDA Settlement Rate Option) this contains the value from the scheme that reflects the terms of the Annex A to the ISDA 1998 FX and Currency Option Definitions. See: http://www.fpml.org/coding-scheme/settlement-rate-option',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoPaymentStubs',
    id: 40872,
    description: 'Number of stubs in the repeating group',
  },
  {
    type: 'PaymentStubTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubType',
    id: 40873,
    abbrName: 'Typ',
    description: 'Stub type.',
  },
  {
    type: 'PaymentStubLengthCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubLength',
    id: 40874,
    abbrName: 'Lngth',
    description:
      'Optional indication whether stub is shorter or longer than the regular swap period.',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubRate',
    id: 40875,
    abbrName: 'Rt',
    description: 'The agreed upon fixed rate for this stub.',
  },
  {
    type: 'Amt',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubFixedAmount',
    id: 40876,
    abbrName: 'FixedAmt',
    description: 'A fixed payment amount for the stub.',
  },
  {
    type: 'Currency',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubFixedCurrency',
    id: 40877,
    abbrName: 'FixedCcy',
    description:
      'The currency of the fixed payment amount. Uses ISO 4217 currency codes.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubIndex',
    id: 40878,
    abbrName: 'Ndx',
    discriminatorId: '40879',
    description: 'The stub floating rate index.',
  },
  {
    type: 'PaymentStreamRateIndexSourceCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubIndexSource',
    id: 40879,
    abbrName: 'NdxSrc',
    description: 'The source of the stub floating rate index.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubIndexCurvePeriod',
    id: 40880,
    abbrName: 'NdxPeriod',
    description: 'Time unit multiplier for the stub floating rate index.',
  },
  {
    type: 'PaymentStreamRateIndexCurveUnitCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubIndexCurveUnit',
    id: 40881,
    abbrName: 'NdxUnit',
    description: 'Time unit associated with the stub floating rate index.',
  },
  {
    type: 'float',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubIndexRateMultiplier',
    id: 40882,
    abbrName: 'RtMult',
    description:
      'A rate multiplier to apply to the floating rate. The multiplier can be less than or greater than 1 (one). This element should only be included if the multiplier is not equal to 1 (one) for the term of the stream.',
  },
  {
    type: 'PriceOffset',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubIndexRateSpread',
    id: 40883,
    abbrName: 'Spread',
    description: 'Spread from floating rate index.',
  },
  {
    type: 'PaymentStreamRateSpreadPositionTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubIndexRateSpreadPositionType',
    id: 40884,
    abbrName: 'SpreadPosTyp',
    description:
      'Identifies whether the rate spread is applied to a long or short position.',
  },
  {
    type: 'PaymentStreamRateTreatmentCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubIndexRateTreatment',
    id: 40885,
    abbrName: 'RtTrtmt',
    description: 'Specifies the yield calculation treatment for the payment stub index.',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubIndexCapRate',
    id: 40886,
    abbrName: 'CapRt',
    description:
      'The cap rate, if any, which applies to the floating rate. The cap rate (strike) is only required where the floating rate on a swap stream is capped at a certain level. The cap rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A cap rate of 5% would be represented as 0.05.',
  },
  {
    type: 'PaymentStreamCapRateBuySideCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubIndexCapRateBuySide',
    id: 40887,
    abbrName: 'CapRtBuy',
    description: 'Reference to the buyer of the cap rate option through its trade side.',
  },
  {
    type: 'PaymentStreamCapRateBuySideCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubIndexCapRateSellSide',
    id: 40888,
    abbrName: 'CapRtSell',
    description: 'Reference to the seller of the cap rate option through its trade side.',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubIndexFloorRate',
    id: 40889,
    abbrName: 'FlrRt',
    description:
      'The floor rate, if any, which applies to the floating rate. The floor rate (strike) is only required where the floating rate on a swap stream is floored at a certain strike level. The floor rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A floor rate of 5% would be represented as 0.05.',
  },
  {
    type: 'PaymentStreamFloorRateBuySideCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubIndexFloorRateBuySide',
    id: 40890,
    abbrName: 'FlrRtBuy',
    description:
      'Reference to the buyer of the floor rate option through its trade side.',
  },
  {
    type: 'PaymentStreamFloorRateBuySideCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubIndexFloorRateSellSide',
    id: 40891,
    abbrName: 'FlrRtSell',
    description:
      'Reference to the seller of the floor rate option through its trade side.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubIndex2',
    id: 40892,
    abbrName: 'Ndx2',
    discriminatorId: '40893',
    description: 'The second stub floating rate index.',
  },
  {
    type: 'PaymentStreamRateIndexSourceCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubIndex2Source',
    id: 40893,
    abbrName: 'Ndx2Src',
    description: 'The source of the second stub floating rate index.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubIndex2CurvePeriod',
    id: 40894,
    abbrName: 'Ndx2Period',
    description: 'Secondary time unit multiplier for the stub floating rate index curve.',
  },
  {
    type: 'PaymentStreamRateIndexCurveUnitCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubIndex2CurveUnit',
    id: 40895,
    abbrName: 'Ndx2Unit',
    description:
      'Secondary time unit associated with the stub floating rate index curve.',
  },
  {
    type: 'float',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubIndex2RateMultiplier',
    id: 40896,
    abbrName: 'RtMult2',
    description:
      'A rate multiplier to apply to the second floating rate. The multiplier can be less than or greater than 1 (one). This element should only be included if the multiplier is not equal to 1 (one) for the term of the stream.',
  },
  {
    type: 'PriceOffset',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubIndex2RateSpread',
    id: 40897,
    abbrName: 'Spread2',
    description: 'Spread from the second floating rate index.',
  },
  {
    type: 'PaymentStreamRateSpreadPositionTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubIndex2RateSpreadPositionType',
    id: 40898,
    abbrName: 'Spread2PosTyp',
    description:
      'Identifies whether the rate spread is applied to a long or short position.',
  },
  {
    type: 'PaymentStreamRateTreatmentCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubIndex2RateTreatment',
    id: 40899,
    abbrName: 'RtTrtmt2',
    description: 'Specifies the yield calculation treatment for the second stub index.',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubIndex2CapRate',
    id: 40900,
    abbrName: 'CapRt2',
    description:
      'The cap rate, if any, which applies to the second floating rate. The cap rate (strike) is only required where the floating rate on a swap stream is capped at a certain level. The cap rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A cap rate of 5% would be represented as 0.05.',
  },
  {
    type: 'Percentage',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubIndex2FloorRate',
    id: 40901,
    abbrName: 'FlrRt2',
    description:
      'The floor rate, if any, which applies to the second floating rate. The floor rate (strike) is only required where the floating rate on a swap stream is floored at a certain strike level. The floor rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A floor rate of 5% would be represented as 0.05.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoLegSettlRateFallbacks',
    id: 40902,
    description: 'Number of settlement rate fallbacks in the repeating group',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegSettlRatePostponementMaximumDays',
    id: 40903,
    abbrName: 'MaxDays',
    description:
      'The maximum number of days to wait for a quote from the disrupted settlement rate option before proceding to this method.',
  },
  {
    type: 'RateSourceCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingSettlRateFallbackRateSource',
    id: 40904,
    abbrName: 'RtSrc',
    description: 'Identifies the source of rate information.',
  },
  {
    type: 'Boolean',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegSettlRatePostponementSurvey',
    id: 40905,
    abbrName: 'Survey',
    description: 'Indicates whether to request a settlement rate quote from the market.',
  },
  {
    type: 'ProvisionCalculationAgentCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegSettlRatePostponementCalculationAgent',
    id: 40906,
    abbrName: 'CalcAgent',
    description: 'Used to identify the settlement rate postponement calculation agent.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'StreamEffectiveDateUnadjusted',
    id: 40907,
    abbrName: 'DtUnadj',
    description: 'The unadjusted effective date.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'StreamEffectiveDateBusinessDayConvention',
    id: 40908,
    abbrName: 'BizDayCnvtn',
    description:
      "The business day convention used to adjust the instrument's stream's effective, or relative effective, date. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.",
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'StreamEffectiveDateBusinessCenter',
    id: 40909,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the instrument\'s stream\'s effective, or relative effective, date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'StreamEffectiveDateRelativeTo',
    id: 40910,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the effective date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'StreamEffectiveDateOffsetPeriod',
    id: 40911,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative effective date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'StreamEffectiveDateOffsetUnit',
    id: 40912,
    abbrName: 'OfstUnit',
    description: 'Time unit associated with the relative effective date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'StreamEffectiveDateOffsetDayType',
    id: 40913,
    abbrName: 'OfstDayTyp',
    description: 'Specifies the day type of the relative effective date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'StreamEffectiveDateAdjusted',
    id: 40914,
    abbrName: 'Dt',
    description: 'The adjusted effective date.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingSettlRateFallbackReferencePage',
    id: 40915,
    abbrName: 'RefPg',
    description:
      'Identifies the reference "page" from the rate source.\n\nWhen UnderlyingSettlRateFallbackRateSource(40904) = 3(ISDA Settlement Rate Option) this contains the value from the scheme that reflects the terms of the Annex A to the ISDA 1998 FX and Currency Option Definitions. See: http://www.fpml.org/coding-scheme/settlement-rate-option',
  },
  {
    type: 'PriceTypeCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'PaymentPriceType',
    id: 40919,
    abbrName: 'PxTyp',
    description: 'Specifies the type of price for PaymentPrice(40218).',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '161',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamPaymentDateOffsetDayType',
    id: 40920,
    abbrName: 'OfstDayTyp',
    description: 'Specifies the day type of the relative payment date offset.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'BusinessDayConvention',
    id: 40921,
    abbrName: 'BizDayCnvtn',
    description:
      'The business day convention used for adjusting dates. The value defined here applies to all adjustable dates in the instrument unless specifically overridden.',
  },
  {
    type: 'DateRollConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'DateRollConvention',
    id: 40922,
    abbrName: 'Roll',
    description:
      'The convention for determining a sequence of dates. It is used in conjunction with a specified frequency. The value defined here applies to all adjustable dates in the instrument unless specifically overridden. Additional values may be used by mutual agreement of the counterparties.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoLegBusinessCenters',
    id: 40923,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegBusinessCenter',
    id: 40924,
    abbrName: 'Ctr',
    description:
      'A business center whose calendar is used for date adjustment, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegBusinessDayConvention',
    id: 40925,
    abbrName: 'BizDayCnvtn',
    description:
      'The business day convention used for adjusting dates. The value defined here applies to all adjustable dates in the instrument leg unless specifically overridden.',
  },
  {
    type: 'DateRollConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegDateRollConvention',
    id: 40926,
    abbrName: 'Roll',
    description:
      'The convention for determining a sequence of dates. It is used in conjunction with a specified frequency. The value defined here applies to all adjustable dates in the instrument leg unless specifically overridden.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoLegPaymentScheduleFixingDateBusinessCenters',
    id: 40927,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoLegPaymentScheduleInterimExchangeDateBusinessCenters',
    id: 40928,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoLegPaymentStreamNonDeliverableFixingDateBusinessCenters',
    id: 40929,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoLegPaymentStreamPaymentDateBusinessCenters',
    id: 40930,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoLegPaymentStreamResetDateBusinessCenters',
    id: 40931,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoLegPaymentStreamInitialFixingDateBusinessCenters',
    id: 40932,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoLegPaymentStreamFixingDateBusinessCenters',
    id: 40933,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoLegProvisionCashSettlPaymentDateBusinessCenters',
    id: 40934,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoLegProvisionCashSettlValueDateBusinessCenters',
    id: 40935,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoLegProvisionOptionExerciseBusinessCenters',
    id: 40936,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoLegProvisionOptionExpirationDateBusinessCenters',
    id: 40937,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoLegProvisionOptionRelevantUnderlyingDateBusinessCenters',
    id: 40938,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoLegProvisionDateBusinessCenters',
    id: 40939,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoLegStreamCalculationPeriodBusinessCenters',
    id: 40940,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoLegStreamFirstPeriodStartDateBusinessCenters',
    id: 40941,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoLegStreamEffectiveDateBusinessCenters',
    id: 40942,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoLegStreamTerminationDateBusinessCenters',
    id: 40943,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoPaymentBusinessCenters',
    id: 40944,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoPaymentScheduleInterimExchangeDateBusinessCenters',
    id: 40945,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoPaymentStreamNonDeliverableFixingDatesBusinessCenters',
    id: 40946,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoPaymentStreamPaymentDateBusinessCenters',
    id: 40947,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoPaymentStreamResetDateBusinessCenters',
    id: 40948,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoPaymentStreamInitialFixingDateBusinessCenters',
    id: 40949,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoPaymentStreamFixingDateBusinessCenters',
    id: 40950,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoProtectionTermEventNewsSources',
    id: 40951,
    description: 'Number of event news sources in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoProvisionCashSettlPaymentDateBusinessCenters',
    id: 40952,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoProvisionCashSettlValueDateBusinessCenters',
    id: 40953,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoProvisionOptionExerciseBusinessCenters',
    id: 40954,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoProvisionOptionExpirationDateBusinessCenters',
    id: 40955,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoProvisionOptionRelevantUnderlyingDateBusinessCenters',
    id: 40956,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoProvisionDateBusinessCenters',
    id: 40957,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoStreamCalculationPeriodBusinessCenters',
    id: 40958,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoStreamFirstPeriodStartDateBusinessCenters',
    id: 40959,
    description: 'Number of business centers in the repeating group.',
  },
  {
    updated: 'FIX.Latest',
    type: 'NumInGroup',
    addedEP: '161',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'NoStreamEffectiveDateBusinessCenters',
    id: 40960,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoStreamTerminationDateBusinessCenters',
    id: 40961,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingBusinessCenters',
    id: 40962,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingBusinessCenter',
    id: 40963,
    abbrName: 'Ctr',
    description:
      'A business center whose calendar is used for date adjustment, e.g. "GBLO". See http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingBusinessDayConvention',
    id: 40964,
    abbrName: 'BizDayCnvtn',
    description:
      'The business day convention used for adjusting dates. The value defined here applies to all adjustable dates in the underlying instrument unless specifically overridden.',
  },
  {
    type: 'DateRollConventionCodeSet',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDateRollConvention',
    id: 40965,
    abbrName: 'Roll',
    description:
      'The convention for determining a sequence of dates. It is used in conjunction with a specified frequency. The value defined here applies to all adjustable dates in the underlying instrument unless specifically overridden.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingPaymentScheduleFixingDateBusinessCenters',
    id: 40966,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingPaymentScheduleInterimExchangeDateBusinessCenters',
    id: 40967,
    description: 'Number of business centers in the repeating group.',
  },
  {
    updated: 'FIX.Latest',
    type: 'NumInGroup',
    addedEP: '161',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingPaymentStreamNonDeliverableFixingDatesBizCenters',
    id: 40968,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingPaymentStreamPaymentDateBusinessCenters',
    id: 40969,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingPaymentStreamResetDateBusinessCenters',
    id: 40970,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingPaymentStreamInitialFixingDateBusinessCenters',
    id: 40971,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingPaymentStreamFixingDateBusinessCenters',
    id: 40972,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingStreamCalculationPeriodBusinessCenters',
    id: 40973,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingStreamFirstPeriodStartDateBusinessCenters',
    id: 40974,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingStreamEffectiveDateBusinessCenters',
    id: 40975,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingStreamTerminationDateBusinessCenters',
    id: 40976,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'NoPaymentScheduleFixingDateBusinessCenters',
    id: 40977,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'Length',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'EncodedLegStreamTextLen',
    id: 40978,
    abbrName: 'EncTxtLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedLegStreamText(40979) field.',
  },
  {
    type: 'data',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'EncodedLegStreamText',
    id: 40979,
    abbrName: 'EncTxt',
    lengthId: '40978',
    description:
      'Encoded (non-ASCII characters) representation of the LegStreamText(40248) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the LegStreamText(40248) field.',
  },
  {
    type: 'Length',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'EncodedLegProvisionTextLen',
    id: 40980,
    abbrName: 'EncTxtLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedLegProvisionText(40472) field.',
  },
  {
    type: 'data',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'EncodedLegProvisionText',
    id: 40981,
    abbrName: 'EncTxt',
    lengthId: '40980',
    description:
      'Encoded (non-ASCII characters) representation of the LegProvisionText(40472) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the LegProvisionText(40472) field.',
  },
  {
    type: 'Length',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'EncodedStreamTextLen',
    id: 40982,
    abbrName: 'EncTxtLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedStreamText(40983) field.',
  },
  {
    type: 'data',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'EncodedStreamText',
    id: 40983,
    abbrName: 'EncTxt',
    lengthId: '40982',
    description:
      'Encoded (non-ASCII characters) representation of the StreamText(40056) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the StreamText(40056) field.',
  },
  {
    type: 'Length',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'EncodedPaymentTextLen',
    id: 40984,
    abbrName: 'EncTxtLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedPaymentText(40985) field.',
  },
  {
    type: 'data',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'EncodedPaymentText',
    id: 40985,
    abbrName: 'EncTxt',
    lengthId: '40984',
    description:
      'Encoded (non-ASCII characters) representation of the PaymentText(40229) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the PaymentText(40229) field.',
  },
  {
    type: 'Length',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'EncodedProvisionTextLen',
    id: 40986,
    abbrName: 'EncTxtLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedProvisionText(40987) field.',
  },
  {
    type: 'data',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'EncodedProvisionText',
    id: 40987,
    abbrName: 'EncTxt',
    lengthId: '40986',
    description:
      'Encoded (non-ASCII characters) representation of the ProvisionText(40113) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the ProvisionText(40113) field.',
  },
  {
    type: 'Length',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'EncodedUnderlyingStreamTextLen',
    id: 40988,
    abbrName: 'EncTxtLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedUnderlyingStreamText(40989) field.',
  },
  {
    type: 'data',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'EncodedUnderlyingStreamText',
    id: 40989,
    abbrName: 'EncTxt',
    lengthId: '40988',
    description:
      'Encoded (non-ASCII characters) representation of the UnderlyingStreamText(40547) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the UnderlyingStreamText(40547) field.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'ProvisionCashSettlQuoteReferencePage',
    id: 41406,
    abbrName: 'RefPg',
    description: 'Identifies the reference "page" from the quote source.',
  },
  {
    type: 'String',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionCashSettlQuoteReferencePage',
    id: 41407,
    abbrName: 'RefPg',
    description: 'Identifies the reference "page" from the quote source.',
  },
  {
    type: 'MonthYear',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'EventMonthYear',
    id: 2340,
    abbrName: 'MoYr',
    description:
      'Used with derivatives when an event is express as a month-year with optional day or month or week of month.\n\nFormat:\n\nYYYYMM (e.g. 199903)\n\nYYYYMMDD (e.g. 20030323)\n\nYYYYMMwN (e.g. 200303w2) for week\n\nA specific date can be appended to the month-year. For instance, if multiple event types exist in the same Year and Month, but actually at a different time, a value can be appended, such as "w" or "w2" to indicate week. Likewise, the day of monty (0-31) can be appended to indicate a specific event date.',
  },
  {
    type: 'MonthYear',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'LegEventMonthYear',
    id: 2341,
    abbrName: 'MoYr',
    description:
      'Used with derivatives when an event is express as a month-year with optional day or month or week of month.\n\nFormat:\n\nYYYYMM (e.g. 199903)\n\nYYYYMMDD (e.g. 20030323)\n\nYYYYMMwN (e.g. 200303w2) for week\n\nA specific date can be appended to the month-year. For instance, if multiple event types exist in the same Year and Month, but actually at a different time, a value can be appended, such as "w" or "w2" to indicate week. Likewise, the day of monty (0-31) can be appended to indicate a specific event date.',
  },
  {
    type: 'MonthYear',
    addedEP: '161',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingEventMonthYear',
    id: 2342,
    abbrName: 'MoYr',
    description:
      'Used with derivatives when an event is express as a month-year with optional day or month or week of month.\n\nFormat:\n\nYYYYMM (e.g. 199903)\n\nYYYYMMDD (e.g. 20030323)\n\nYYYYMMwN (e.g. 200303w2) for week\n\nA specific date can be appended to the month-year. For instance, if multiple event types exist in the same Year and Month, but actually at a different time, a value can be appended, such as "w" or "w2" to indicate week. Likewise, the day of monty (0-31) can be appended to indicate a specific event date.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '162',
    added: 'FIX.5.0SP2',
    name: 'PreviousClearingBusinessDate',
    id: 2084,
    abbrName: 'PrevBizDt',
    description: 'The date of the previous clearing business day.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'LocalMktDate',
    addedEP: '162',
    updatedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ValuationDate',
    id: 2085,
    abbrName: 'ValDt',
    description: 'The valuation date of the trade.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'LocalMktTime',
    addedEP: '162',
    updatedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ValuationTime',
    id: 2086,
    abbrName: 'ValTm',
    description: 'The valuation time of the trade.',
  },
  {
    updated: 'FIX.Latest',
    type: 'String',
    addedEP: '162',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'ValuationBusinessCenter',
    id: 2087,
    abbrName: 'ValBizCtr',
    description:
      'Identifies the business center whose calendar is used for valuation, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'float',
    addedEP: '162',
    added: 'FIX.5.0SP2',
    name: 'MarginAmtFXRate',
    id: 2088,
    abbrName: 'FxRt',
    description:
      'Foreign exchange rate used to compute the MarginAmt(1645) from the MarginAmtCcy(1646) and the Currency(15).',
  },
  {
    type: 'UnderlyingFXRateCalcCodeSet',
    addedEP: '162',
    added: 'FIX.5.0SP2',
    name: 'MarginAmtFXRateCalc',
    id: 2089,
    abbrName: 'FxRtCalc',
    description:
      'Specifies whether or not MarginAmtFXRate(2088) should be multipled or divided.',
  },
  {
    type: 'float',
    addedEP: '162',
    added: 'FIX.5.0SP2',
    name: 'CollateralFXRate',
    id: 2090,
    abbrName: 'FxRt',
    description:
      'Foreign exchange rate used to compute the CurrentCollateralAmount(1704) from the CollateralCurrency(1646) and the Currency(15).',
  },
  {
    type: 'UnderlyingFXRateCalcCodeSet',
    addedEP: '162',
    added: 'FIX.5.0SP2',
    name: 'CollateralFXRateCalc',
    id: 2091,
    abbrName: 'FxRtCalc',
    description:
      'Specifies whether or not CollateralFXRate(2090) should be multipled or divided.',
  },
  {
    type: 'String',
    addedEP: '162',
    added: 'FIX.5.0SP2',
    name: 'CollateralAmountMarketSegmentID',
    id: 2092,
    abbrName: 'MktSegID',
    description: 'Market segment associated with the collateral amount.',
  },
  {
    type: 'String',
    addedEP: '162',
    added: 'FIX.5.0SP2',
    name: 'CollateralAmountMarketID',
    id: 2093,
    abbrName: 'MktID',
    description: 'Market associated with the collateral amount.',
  },
  {
    type: 'float',
    addedEP: '162',
    added: 'FIX.5.0SP2',
    name: 'PayCollectFXRate',
    id: 2094,
    abbrName: 'FxRt',
    description:
      'Foreign exchange rate used to compute the PayAmount(1710) or CollectAmount(1711) from the PayCollectCurrency(1709) and the Currency(15).',
  },
  {
    type: 'UnderlyingFXRateCalcCodeSet',
    addedEP: '162',
    added: 'FIX.5.0SP2',
    name: 'PayCollectFXRateCalc',
    id: 2095,
    abbrName: 'FxRtCalc',
    description:
      'Specifies whether or not PayCollectFXRate(2094) should be multipled or divided.',
  },
  {
    type: 'String',
    addedEP: '162',
    added: 'FIX.5.0SP2',
    name: 'PosAmtStreamDesc',
    id: 2096,
    abbrName: 'StrmDesc',
    description:
      'Corresponds to the value in StreamDesc(40051) in the StreamGrp component.',
  },
  {
    type: 'float',
    addedEP: '162',
    added: 'FIX.5.0SP2',
    name: 'PositionFXRate',
    id: 2097,
    abbrName: 'FxRt',
    description:
      'Foreign exchange rate used to compute the PosAmt(708) from the PositionCurrency(1055) and the Currency (15).',
  },
  {
    type: 'UnderlyingFXRateCalcCodeSet',
    addedEP: '162',
    added: 'FIX.5.0SP2',
    name: 'PositionFXRateCalc',
    id: 2098,
    abbrName: 'FxRtCalc',
    description:
      'Specifies whether or not PositionFXRate(2097) should be multipled or divided.',
  },
  {
    type: 'String',
    addedEP: '162',
    added: 'FIX.5.0SP2',
    name: 'PosAmtMarketSegmentID',
    id: 2099,
    abbrName: 'MktSegID',
    description: 'Market segment associated with the position amount.',
  },
  {
    type: 'String',
    addedEP: '162',
    added: 'FIX.5.0SP2',
    name: 'PosAmtMarketID',
    id: 2100,
    abbrName: 'MktID',
    description: 'Market associated with the position amount.',
  },
  {
    type: 'Boolean',
    addedEP: '162',
    added: 'FIX.5.0SP2',
    name: 'TerminatedIndicator',
    id: 2101,
    abbrName: 'TrmtdInd',
    description: 'Indicates if the position has been terminated.',
  },
  {
    type: 'Boolean',
    addedEP: '164',
    added: 'FIX.5.0SP2',
    name: 'ShortMarkingExemptIndicator',
    id: 2102,
    abbrName: 'SMEInd',
    description:
      'Indicates whether the originating account is exempt (Y) from marking orders as short or not (N). This designation may be used on both buy and sell orders.',
  },
  {
    type: 'String',
    addedEP: '165',
    added: 'FIX.5.0SP2',
    name: 'RelatedRegulatoryTradeIDSource',
    id: 2103,
    abbrName: 'RegSrc',
    description:
      'Specifies the identifier of the reporting entity as assigned by regulatory agency.',
  },
  {
    type: 'NumInGroup',
    addedEP: '167',
    added: 'FIX.5.0SP2',
    name: 'NoAttachments',
    id: 2104,
    description: 'The number of attached files.',
  },
  {
    type: 'String',
    addedEP: '167',
    added: 'FIX.5.0SP2',
    name: 'AttachmentName',
    id: 2105,
    abbrName: 'Name',
    description: 'Specifies the file name of the attachment.',
  },
  {
    type: 'String',
    addedEP: '167',
    added: 'FIX.5.0SP2',
    name: 'AttachmentMediaType',
    id: 2106,
    abbrName: 'MediaTyp',
    description:
      'The MIME media type (and optional subtype) of the attachment. The values used are those assigned, listed and maintained by IANA (www.iana.org) [RFC2046]. See http://www.iana.org/assignments/media-types/index.html for available types.\n\nExamples values (RFC number provided for reference here only):\n\n"application/pdf" (see [RFC3778])\n\n"application/msword" (for .doc files)\n\n"multipart/signed" (see [RFC1847])\n\n"application/vnd.openxmlformats-officedocument.wordprocessingml.document" (for .docx files)',
  },
  {
    type: 'String',
    addedEP: '167',
    added: 'FIX.5.0SP2',
    name: 'AttachmentClassification',
    id: 2107,
    abbrName: 'Clsfn',
    description:
      'Specifies semantically the type of the attached document from a business perspective. The default classification scheme reuses the FIX standard classification scheme of a high level section (pretrade, trade, posttrade, etc.) and a category, then a specific application or document type. The expression follows {"section/category/application type"}.\n\nThe goal here is to map the attachment into the sections and categories of the FIX business messages if possible. The classification scheme can be expanded or replaced by counterparty agreement. This approach permits the introduction and reference to other business ontologies.\n\nExample:\n\nposttrade/confirmation/confirm\n\npretrade//termsheet',
  },
  {
    type: 'String',
    addedEP: '167',
    added: 'FIX.5.0SP2',
    name: 'AttachmentExternalURL',
    id: 2108,
    abbrName: 'URL',
    description: 'Used to specify an external URL where the attachment can be obtained.',
  },
  {
    updated: 'FIX.Latest',
    type: 'AttachmentEncodingTypeCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '167',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'AttachmentEncodingType',
    id: 2109,
    abbrName: 'EncTyp',
    description:
      'The encoding type of the content provided in EncodedAttachment(2112).\n\nThe AttachmentEncodingType(2109) is a distinct and separate concept from MessageEncoding(347) that defines how FIX fields of type data are encoded. The MessageEncoding(347) is used to embed text in another character set (e.g. Unicode or Shift-JIS) within FIX.',
  },
  {
    type: 'int',
    addedEP: '167',
    added: 'FIX.5.0SP2',
    name: 'UnencodedAttachmentLen',
    id: 2110,
    abbrName: 'UnencAttchmntLen',
    description:
      'Unencoded content length in bytes. Can be used to validate successful unencoding.',
  },
  {
    type: 'Length',
    addedEP: '167',
    added: 'FIX.5.0SP2',
    name: 'EncodedAttachmentLen',
    id: 2111,
    abbrName: 'EncAttchmntLen',
    description: 'Byte length of encoded the EncodedAttachment(2112) field.',
  },
  {
    type: 'data',
    addedEP: '167',
    added: 'FIX.5.0SP2',
    name: 'EncodedAttachment',
    id: 2112,
    abbrName: 'EncAttchmnt',
    lengthId: '2111',
    description:
      'The content of the attachment in the encoding format specified in the AttachmentEncodingType(2109) field.',
  },
  {
    type: 'NumInGroup',
    addedEP: '167',
    added: 'FIX.5.0SP2',
    name: 'NoAttachmentKeywords',
    id: 2113,
    description: 'The number of attachment keywords.',
  },
  {
    type: 'String',
    addedEP: '167',
    added: 'FIX.5.0SP2',
    name: 'AttachmentKeyword',
    id: 2114,
    abbrName: 'Keywd',
    description:
      'Can be used to provide data or keyword tagging of the content of the attachment.',
  },
  {
    type: 'NegotiationMethodCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '168',
    added: 'FIX.5.0SP2',
    name: 'NegotiationMethod',
    id: 2115,
    abbrName: 'NegottnMeth',
    description: 'Specifies the negotiation method to be used.',
  },
  {
    type: 'UTCTimestamp',
    addedEP: '168',
    added: 'FIX.5.0SP2',
    name: 'NextAuctionTime',
    id: 2116,
    abbrName: 'NxtAuctTm',
    description: 'The time of the next auction.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoAssetAttributes',
    id: 2304,
    description: 'The number of asset attribute entries in the group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'AssetAttributeType',
    id: 2305,
    abbrName: 'Typ',
    description:
      'Specifies the name of the attribute.\n\nSee http://www.fixtradingcommunity.org/codelists#Asset_Attribute_Types for code list of applicable asset attribute types.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'AssetAttributeValue',
    id: 2306,
    abbrName: 'Val',
    description: 'Specifies the value of the asset attribute.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'AssetAttributeLimit',
    id: 2307,
    abbrName: 'Lmt',
    description: 'Limit or lower acceptable value of the attribute.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'float',
    addedEP: '169',
    updatedEP: '204',
    added: 'FIX.5.0SP2',
    name: 'CommRate',
    id: 1233,
    abbrName: 'Rt',
    description:
      'The commission rate when Commission(12) is based on a percentage of quantity, amount per unit or a factor of "unit of measure". If the rate is a percentage, use the decimalized form, e.g. "0.05" for a 5% commission or "0.005" for 50 basis points.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    updatedEP: '204',
    added: 'FIX.5.0SP2',
    name: 'CommUnitOfMeasure',
    id: 1238,
    abbrName: 'UOM',
    description: 'The commission rate unit of measure.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoComplexEventAveragingObservations',
    id: 40994,
    description: 'The number of averaging observations in the repeating group.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventAveragingObservationNumber',
    id: 40995,
    abbrName: 'ObsvtnNum',
    description:
      'Cross reference to the ordinal observation as specified either in the ComplexEventScheduleGrp or ComplexEventPeriodDateGrp components.',
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventAveragingWeight',
    id: 40996,
    abbrName: 'Wt',
    description: 'The weight factor to be applied to the observation.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoComplexEventCreditEvents',
    id: 40997,
    description: 'The number of credit events specified in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventCreditEventType',
    id: 40998,
    abbrName: 'Typ',
    description:
      'Specifies the type of credit event.\n\nSee http://www.fixtradingcommunity.org/codelists#Credit_Event_Types for code list of applicable event types.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventCreditEventValue',
    id: 40999,
    abbrName: 'Val',
    description:
      'The credit event value appropriate to ComplexEventCreditEventType(40998).\n\nSee http://www.fixtradingcommunity.org/codelists#Credit_Event_Types for applicable event type values.',
  },
  {
    type: 'Currency',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventCreditEventCurrency',
    id: 41000,
    abbrName: 'Ccy',
    description:
      'Specifies the applicable currency when ComplexEventCreditEventValue(40999) is an amount. Uses ISO 4217 currency codes.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventCreditEventPeriod',
    id: 41001,
    abbrName: 'Period',
    description: 'Time unit multiplier for complex credit events.',
  },
  {
    type: 'ProtectionTermEventUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventCreditEventUnit',
    id: 41002,
    abbrName: 'Unit',
    description: 'Time unit associated with complex credit events.',
  },
  {
    type: 'ComplexEventDateOffsetDayTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventCreditEventDayType',
    id: 41003,
    abbrName: 'DayTyp',
    description: 'Specifies the day type for the complex credit events.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventCreditEventRateSource',
    id: 41004,
    abbrName: 'RtSrc',
    description:
      'Identifies the source of rate information used for credit events.\n\nSee http://www.fixtradingcommunity.org/codelists#Credit_Event_Rate_Source for code list of applicable sources.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoComplexEventCreditEventQualifiers',
    id: 41005,
    description: 'The number of qualifiers in the repeating group.',
  },
  {
    type: 'ProtectionTermEventQualifierCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventCreditEventQualifier',
    id: 41006,
    abbrName: 'Qual',
    description:
      'Specifies a complex event qualifier. Used to further qualify ComplexEventCreditEventType(40998).',
  },
];

const batch5: ISpecFields[] = [
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoComplexEventPeriodDateTimes',
    id: 41007,
    description: 'The number of entries in the date-time repeating group.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventPeriodDate',
    id: 41008,
    abbrName: 'Dt',
    description:
      'The averaging date for an Asian option.\n\nThe trigger date for a Barrier or Knock option.',
  },
  {
    type: 'LocalMktTime',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventPeriodTime',
    id: 41009,
    abbrName: 'Tm',
    description: 'The averaging time for an Asian option.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoComplexEventPeriods',
    id: 41010,
    description: 'The number of periods in the repeating group.',
  },
  {
    type: 'ComplexEventPeriodTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventPeriodType',
    id: 41011,
    abbrName: 'Typ',
    description: 'Specifies the period type.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventBusinessCenter',
    id: 41012,
    abbrName: 'BizCtr',
    description:
      'The business center used to determine dates and times in the schedule or date-time group.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoComplexEventRateSources',
    id: 41013,
    description: 'The number of rate sources in the repeating group.',
  },
  {
    type: 'RateSourceCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventRateSource',
    id: 41014,
    abbrName: 'RtSrc',
    description:
      'Identifies the source of rate information.\n\nFor FX, the reference source to be used for the FX spot rate.',
  },
  {
    type: 'RateSourceTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventRateSourceType',
    id: 41015,
    abbrName: 'RtSrcTyp',
    description:
      'Indicates whether the rate source specified is a primary or secondary source.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventReferencePage',
    id: 41016,
    abbrName: 'RefPg',
    description:
      'Identifies the reference page from the rate source.\n\nFor FX, the reference page to the spot rate is to be used for the reference FX spot rate.\n\nWhen ComplexEventRateSource(41014) = 3 (ISDA Settlement Rate Option) this contains the value from the scheme that reflects the terms of the Annex A to the ISDA 1998 FX and Currency Option Definitions. See: http://www.fpml.org/coding-scheme/settlement-rate-option.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventReferencePageHeading',
    id: 41017,
    abbrName: 'RefHdng',
    description: 'Identifies the reference page heading from the rate source.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoComplexEventDateBusinessCenters',
    id: 41018,
    description: 'The number of business centers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventDateBusinessCenter',
    id: 41019,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the complex event date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'LocalMktDate',
    addedEP: '169',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventDateUnadjusted',
    id: 41020,
    abbrName: 'DtUnadj',
    description:
      'The unadjusted complex event date.\n\nFor example the second expiration date for a calendar spread option strategy.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '169',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventDateRelativeTo',
    id: 41021,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the complex event date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventDateOffsetPeriod',
    id: 41022,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventDateOffsetUnit',
    id: 41023,
    abbrName: 'OfstUnit',
    description: 'Time unit associated with the relative date offset.',
  },
  {
    type: 'ComplexEventDateOffsetDayTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventDateOffsetDayType',
    id: 41024,
    abbrName: 'OfstDayTyp',
    description: 'Specifies the day type of the relative date offset.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventDateBusinessDayConvention',
    id: 41025,
    abbrName: 'BizDayCnvtn',
    description:
      'The business day convention used to adjust the complex event date. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventDateAdjusted',
    id: 41026,
    abbrName: 'Dt',
    description: 'The adjusted complex event date.',
  },
  {
    type: 'LocalMktTime',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventFixingTime',
    id: 41027,
    abbrName: 'FixngTm',
    description: 'The local market fixing time.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventFixingTimeBusinessCenter',
    id: 41028,
    abbrName: 'FixngBizCtr',
    description:
      'The business center calendar used to determine the actual fixing times.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoComplexEventCreditEventSources',
    id: 41029,
    description: 'Number of event sources in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventCreditEventSource',
    id: 41030,
    abbrName: 'Src',
    description:
      'A newspaper or electronic news service that may publish relevant information used in the determination of whether or not a credit event has occurred.',
  },
  {
    type: 'PaymentPaySideCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexOptPayoutPaySide',
    id: 2117,
    abbrName: 'OptPay',
    description: 'Trade side of payout payer.',
  },
  {
    type: 'PaymentPaySideCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexOptPayoutReceiveSide',
    id: 2118,
    abbrName: 'OptRcv',
    description: 'Trade side of payout receiver.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexOptPayoutUnderlier',
    id: 2119,
    abbrName: 'OptUndlr',
    description: 'Reference to the underlier whose payments are being passed through.',
  },
  {
    type: 'Percentage',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexOptPayoutPercentage',
    id: 2120,
    abbrName: 'OptPctage',
    description:
      'Percentage of observed price for calculating the payout associated with the event.',
  },
  {
    type: 'ComplexOptPayoutTimeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexOptPayoutTime',
    id: 2121,
    abbrName: 'OptTm',
    description: 'Specifies when the payout is to occur.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Currency',
    addedEP: '169',
    updatedEP: '273',
    added: 'FIX.5.0SP2',
    name: 'ComplexOptPayoutCurrency',
    id: 2122,
    abbrName: 'OptCcy',
    description:
      'Specifies the currency of the payout amount.\n\nComplexOptPayoutCurrencyCodeSource(2941) may be used to disambiguate the code source scheme used, and ISO 4217 is the default scheme if absent.',
  },
  {
    type: 'Percentage',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventPricePercentage',
    id: 2123,
    abbrName: 'PxPctage',
    description:
      'Specifies the price percentage at which the complex event takes effect. Impact of the event price is determined by the ComplexEventType(1484).',
  },
  {
    updated: 'FIX.Latest',
    type: 'Currency',
    addedEP: '169',
    updatedEP: '273',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventCurrencyOne',
    id: 2124,
    abbrName: 'Ccy1',
    description:
      'Specifies the first or only reference currency of the trade.\n\nComplexEventCurrencyOneCodeSource(2942) may be used to disambiguate the code source scheme used, and ISO 4217 is the default scheme if absent.\n\nApplicable for complex FX option strategies.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Currency',
    addedEP: '169',
    updatedEP: '273',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventCurrencyTwo',
    id: 2125,
    abbrName: 'Ccy2',
    description:
      'Specifies the second reference currency of the trade.\n\nComplexEventCurrencyTwoCodeSource(2943) may be used to disambiguate the code source scheme used, and ISO 4217 is the default scheme if absent.\n\nApplicable for complex FX option strategies.',
  },
  {
    type: 'ComplexEventQuoteBasisCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventQuoteBasis',
    id: 2126,
    abbrName: 'QteBasis',
    description: 'For foreign exchange Quanto option feature.',
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventFixedFXRate',
    id: 2127,
    abbrName: 'Rt',
    description: 'Specifies the fixed FX rate alternative for FX Quantro options.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventDeterminationMethod',
    id: 2128,
    abbrName: 'Meth',
    description:
      'Specifies the method according to which an amount or a date is determined.\n\nSee http://www.fpml.org/coding-scheme/determination-method for values.',
  },
  {
    type: 'ProvisionCalculationAgentCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventCalculationAgent',
    id: 2129,
    abbrName: 'CalcAgent',
    description: 'Used to identify the calculation agent.',
  },
  {
    type: 'Price',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventStrikePrice',
    id: 2130,
    abbrName: 'StrkPx',
    description:
      'Upper strike price for Asian option feature. Strike percentage for a Strike Spread.',
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventStrikeFactor',
    id: 2131,
    abbrName: 'StrkFctr',
    description:
      'Strike factor for Asian option feature. Upper strike percentage for a Strike Spread.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventStrikeNumberOfOptions',
    id: 2132,
    abbrName: 'StrkNum',
    description: 'Upper string number of options for a Strike Spread.',
  },
  {
    type: 'XIDREF',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventCreditEventsXIDRef',
    id: 2133,
    abbrName: 'CdtEvntXIDRef',
    description: 'Reference to credit event table elsewhere in the message.',
  },
  {
    type: 'ComplexEventCreditEventNotifyingPartyCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventCreditEventNotifyingParty',
    id: 2134,
    abbrName: 'NotifygPty',
    description:
      'The notifying party is the party that notifies the other party when a credit event has occurred by means of a credit event notice. If more than one party is referenced as being the notifying party then either party may notify the other of a credit event occurring.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventCreditEventBusinessCenter',
    id: 2135,
    abbrName: 'BizCtr',
    description:
      'The local business center for which the credit event is to be determined. The inclusion of this business center implies that Greenwich Mean Time in Section 3.3 of the 2003 ISDA Credit Derivatives Definitions is replaced by the local time of the specified business center.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventCreditEventStandardSources',
    id: 2136,
    abbrName: 'StdSrcs',
    description:
      "When this element is specified and set to 'Y', indicates that ISDA defined Standard Public Sources are applicable.",
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventCreditEventMinimumSources',
    id: 2137,
    abbrName: 'MinSrcs',
    description:
      'The minimum number of the specified public information sources that must publish information that reasonably confirms that a credit event has occurred. The market convention is two.\n\nISDA 2003 Term: Specified Number.',
  },
  {
    type: 'XID',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventXID',
    id: 2138,
    abbrName: 'XID',
    description:
      'Identifier of this complex event for cross referencing elsewhere in the message.',
  },
  {
    type: 'XIDREF',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventXIDRef',
    id: 2139,
    abbrName: 'XIDRef',
    description: 'Reference to a complex event elsewhere in the message.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoComplexEventSchedules',
    id: 41031,
    description: 'Number of schedules in the repeating group.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventScheduleStartDate',
    id: 41032,
    abbrName: 'StartDt',
    description: 'The start date of the schedule.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventScheduleEndDate',
    id: 41033,
    abbrName: 'EndDt',
    description: 'The end date of the schedule.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventScheduleFrequencyPeriod',
    id: 41034,
    abbrName: 'FreqPeriod',
    description: 'Time unit multiplier for the schedule date frequency.',
  },
  {
    type: 'ProtectionTermEventUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventScheduleFrequencyUnit',
    id: 41035,
    abbrName: 'FreqUnit',
    description: 'Time unit associated with the schedule date frequency.',
  },
  {
    type: 'DateRollConventionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventScheduleRollConvention',
    id: 41036,
    abbrName: 'Roll',
    description:
      'The convention for determining the sequence of dates. It is used in conjunction with a specified frequency. Used only to override the roll convention defined in the DateAdjustment component in Instrument.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoDeliverySchedules',
    id: 41037,
    description: 'Number of delivery schedules in the repeating group.',
  },
  {
    type: 'DeliveryScheduleTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryScheduleType',
    id: 41038,
    abbrName: 'Typ',
    description: 'Specifies the type of delivery schedule.',
  },
  {
    type: 'XID',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryScheduleXID',
    id: 41039,
    abbrName: 'XID',
    description:
      'Identifier for this instance of delivery schedule for cross referencing elsewhere in the message.',
  },
  {
    type: 'Qty',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryScheduleNotional',
    id: 41040,
    abbrName: 'Notl',
    description: 'Physical delivery quantity.',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryScheduleNotionalUnitOfMeasure',
    id: 41041,
    abbrName: 'NotlUOM',
    description: 'Specifies the delivery quantity unit of measure (UOM).',
  },
  {
    type: 'StreamNotionalCommodityFrequencyCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryScheduleNotionalCommodityFrequency',
    id: 41042,
    abbrName: 'NotlFreq',
    description: 'The frequency of notional delivery.',
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryScheduleNegativeTolerance',
    id: 41043,
    abbrName: 'NegtvTlrnc',
    description:
      'Specifies the negative tolerance value. The value may be an absolute quantity or a percentage, as specified in DeliveryScheduleToleranceType(41046). Percentage value is to be expressed relative to "1.0" representing 100% (e.g. a value of "0.0575" represents 5.75%).',
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliverySchedulePositiveTolerance',
    id: 41044,
    abbrName: 'PostvTlrnc',
    description:
      'Specifies the positive tolerance value. The value may be an absolute quantity or a percentage, as specified in DeliveryScheduleToleranceType(41046). Value may exceed agreed upon value. Percentage value is to be expressed relative to "1.0" representing 100% (e.g. a value of "0.0575" represents 5.75%).',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryScheduleToleranceUnitOfMeasure',
    id: 41045,
    abbrName: 'TlrncUOM',
    description: "Specifies the tolerance value's unit of measure (UOM).",
  },
  {
    type: 'DeliveryScheduleToleranceTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryScheduleToleranceType',
    id: 41046,
    abbrName: 'TlrncTyp',
    description: 'Specifies the tolerance value type.',
  },
  {
    type: 'Country',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryScheduleSettlCountry',
    id: 41047,
    abbrName: 'Ctry',
    description:
      'Specifies the country where delivery takes place. Uses ISO 3166 2-character country code.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryScheduleSettlTimeZone',
    id: 41048,
    abbrName: 'TZ',
    description:
      'Delivery timezone specified as "prevailing" rather than "standard" or "daylight".\n\nSee http://www.fixtradingcommunity.org/codelists#Prevailing_Timezones for code list of applicable prevailing timezones.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'DeliveryScheduleSettlFlowTypeCodeSet',
    addedEP: '169',
    updatedEP: '179',
    added: 'FIX.5.0SP2',
    name: 'DeliveryScheduleSettlFlowType',
    id: 41049,
    abbrName: 'FlowTyp',
    description: 'Specifies the commodity delivery flow type.',
  },
  {
    type: 'DeliveryScheduleSettlHolidaysProcessingInstructionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryScheduleSettlHolidaysProcessingInstruction',
    id: 41050,
    abbrName: 'Holidays',
    description:
      'Indicates whether holidays are included in the settlement periods. Required for electricity contracts.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoDeliveryScheduleSettlDays',
    id: 41051,
    description: 'Number of delivery schedules in the repeating group.',
  },
  {
    type: 'DeliveryScheduleSettlDayCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryScheduleSettlDay',
    id: 41052,
    abbrName: 'Day',
    description: 'Specifies the day or group of days for delivery.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryScheduleSettlTotalHours',
    id: 41053,
    abbrName: 'TotHrs',
    description:
      'The sum of the total hours specified in the DeliveryScheduleSettlTimeGrp component.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoDeliveryScheduleSettlTimes',
    id: 41054,
    description: 'Number of hour ranges in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryScheduleSettlStart',
    id: 41055,
    abbrName: 'Start',
    description:
      'The scheduled start time for the delivery of the commodity where delivery occurs over specified times. The format of the time value is specified in DeliveryScheduleSettlTimeType(41057).',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryScheduleSettlEnd',
    id: 41056,
    abbrName: 'End',
    description:
      'The scheduled end time for the delivery of the commodity where delivery occurs over specified times. The format of the time value is specified in DeliveryScheduleSettlTimeType(41057).',
  },
  {
    type: 'DeliveryScheduleSettlTimeTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryScheduleSettlTimeType',
    id: 41057,
    abbrName: 'Typ',
    description: 'Specifies the format of the delivery start and end time values.',
  },
  {
    type: 'DeliveryStreamTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryStreamType',
    id: 41058,
    abbrName: 'Typ',
    description: 'Specifies the type of delivery stream.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryStreamPipeline',
    id: 41059,
    abbrName: 'Ppln',
    description: 'The name of the oil delivery pipeline.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryStreamEntryPoint',
    id: 41060,
    abbrName: 'EntryPnt',
    description:
      'The point at which the commodity will enter the delivery mechanism or pipeline.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryStreamWithdrawalPoint',
    id: 41061,
    abbrName: 'WthdrwlPnt',
    description:
      'The point at which the commodity product will be withdrawn prior to delivery.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryStreamDeliveryPoint',
    id: 41062,
    abbrName: 'DlvryPnt',
    discriminatorId: '42192',
    description:
      'The point at which the commodity product will be delivered and received. Value specified should follow market convention appropriate for the commodity product.\n\nFor bullion, see http://www.fpml.org/coding-scheme/bullion-delivery-location for values.',
  },
  {
    type: 'DeliveryStreamDeliveryRestrictionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryStreamDeliveryRestriction',
    id: 41063,
    abbrName: 'DlvryRstctn',
    description:
      'Specifies under what conditions the buyer and seller should be excused of their delivery obligations.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryStreamDeliveryContingency',
    id: 41064,
    abbrName: 'Cntgncy',
    description:
      'Specifies the electricity delivery contingency.\n\nSee http://www.fpml.org/coding-scheme/electricity-transmission-contingency for values.',
  },
  {
    type: 'DeliveryStreamElectingPartySideCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryStreamDeliveryContingentPartySide',
    id: 41065,
    abbrName: 'CntgPty',
    description:
      'The trade side value of the party responsible for electricity delivery contingency.',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryStreamDeliverAtSourceIndicator',
    id: 41066,
    abbrName: 'DlvrAtSrc',
    description:
      "When this element is specified and set to 'Y', delivery of the coal product is to be at its source.",
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryStreamRiskApportionment',
    id: 41067,
    abbrName: 'RiskApprtnmt',
    discriminatorId: '41218',
    description:
      'Specifies how the parties to the trade apportion responsibility for the delivery of the commodity product.\n\nSee http://www.fixtradingcommunity.org/codelists#Risk_Apportionment for the details of the external code list.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryStreamRiskApportionmentSource',
    id: 41218,
    abbrName: 'RiskApprtnmtSrc',
    description:
      'Specifies the source or legal framework for the risk apportionment.\n\nSee http://www.fixtradingcommunity.org/codelists#Risk_Apportionment_Source for the details of the external code list.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryStreamTitleTransferLocation',
    id: 41068,
    abbrName: 'TtlXfer',
    description: 'Specifies the title transfer location.',
  },
  {
    type: 'DeliveryStreamTitleTransferConditionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryStreamTitleTransferCondition',
    id: 41069,
    abbrName: 'TtlXferCond',
    description: 'Specifies the condition of title transfer.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryStreamImporterOfRecord',
    id: 41070,
    abbrName: 'Imprtr',
    description:
      'A party, not necessarily of the trade, who is the Importer of Record for the purposes of paying customs duties and applicable taxes or costs related to importation.',
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryStreamNegativeTolerance',
    id: 41071,
    abbrName: 'NegtvTlrnc',
    description:
      'Specifies the negative tolerance value. The value may be an absolute quantity or a percentage, as specified in DeliveryStreamToleranceType(41074). Percentage value is to be expressed relative to "1.0" representing 100% (e.g. a value of "0.0575" represents 5.75%).',
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryStreamPositiveTolerance',
    id: 41072,
    abbrName: 'PostvTlrnc',
    description:
      'Specifies the positive tolerance value. The value may be an absolute quantity or a percentage, as specified in DeliveryStreamToleranceType(41074). Value may exceed agreed upon value. Percentage value is to be expressed relative to "1.0" representing 100% (e.g. a value of "0.0575" represents 5.75%).',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryStreamToleranceUnitOfMeasure',
    id: 41073,
    abbrName: 'TlrncUOM',
    description: "Specifies the tolerance value's unit of measure (UOM).",
  },
  {
    type: 'DeliveryScheduleToleranceTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryStreamToleranceType',
    id: 41074,
    abbrName: 'TlrncTyp',
    description: 'Specifies the tolerance value type.',
  },
  {
    type: 'DeliveryStreamToleranceOptionSideCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryStreamToleranceOptionSide',
    id: 41075,
    abbrName: 'TlrncOptSide',
    description: "Indicates whether the tolerance is at the seller's or buyer's option.",
  },
  {
    type: 'Percentage',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryStreamTotalPositiveTolerance',
    id: 41076,
    abbrName: 'TotPostvTlrnc',
    description:
      'The positive percent tolerance which applies to the total quantity delivered over all shipment periods.\n\nPercentage value is to be expressed relative to "1.0" representing 100% (e.g. a value of "0.0575" represents 5.75%.).',
  },
  {
    type: 'Percentage',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryStreamTotalNegativeTolerance',
    id: 41077,
    abbrName: 'TotNegtvTlrnc',
    description:
      'The negative percent tolerance which applies to the total quantity delivered over all shipment periods.\n\nPercentage value is to be expressed relative to "1.0" representing 100% (e.g. a value of "0.0575" represents 5.75%.).',
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryStreamNotionalConversionFactor',
    id: 41078,
    abbrName: 'CnvrsnFctr',
    description:
      'If the notional quantity is specified in a unit that does not match the unit in which the commodity reference price is quoted, the scaling or conversion factor used to convert the commodity reference price unit into the notional quantity unit should be stated here. If there is no conversion, this field is not intended to be used.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryStreamTransportEquipment',
    id: 41079,
    abbrName: 'Eqpmt',
    description:
      'The transportation equipment with which the commodity product will be delivered and received.\n\nExamples of transportation equipment or mode are barge, truck, railcar, etc.',
  },
  {
    type: 'DeliveryStreamElectingPartySideCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryStreamElectingPartySide',
    id: 41080,
    abbrName: 'ElctngSide',
    description:
      'A reference to the party able to choose whether the gas is delivered for a particular period as found in a swing or interruptible contract.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoDeliveryStreamCycles',
    id: 41081,
    description: 'Number of delivery cycles in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryStreamCycleDesc',
    id: 41082,
    abbrName: 'Desc',
    description:
      'The delivery cycles during which the oil product will be transported in the pipeline.',
  },
  {
    type: 'Length',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'EncodedDeliveryStreamCycleDescLen',
    id: 41083,
    abbrName: 'EncDescLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedDeliveryStreamCycleDesc(41084) field.',
  },
  {
    type: 'data',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'EncodedDeliveryStreamCycleDesc',
    id: 41084,
    abbrName: 'EncDesc',
    lengthId: '41083',
    description:
      'Encoded (non-ASCII characters) representation of the DeliveryStreamCycleDesc(41082) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the DeliveryStreamCycleDesc(41082) field.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoDeliveryStreamCommoditySources',
    id: 41085,
    description: 'Number of commodity sources in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DeliveryStreamCommoditySource',
    id: 41086,
    abbrName: 'Src',
    description:
      'The SCoTA coal cargo origin, mining region, mine(s), mining complex(es), loadout(s) or river dock(s) or other point(s) of origin that seller and buyer agree are acceptable origins for the coal product. For international coal transactions, this is the origin of the coal product.\n\nSee http://www.fpml.org/coding-scheme/commodity-coal-product-source for values.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'DocumentationText',
    id: 1513,
    abbrName: 'DcmntnTxt',
    description:
      'A sentence or phrase pertenant to the trade, not a reference to an external document. E.g. "To be registered with the U.S. Environmental Protection Agency, Acid Rain Division, SO2 Allowance Tracking System"',
  },
  {
    type: 'Length',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'EncodedDocumentationTextLen',
    id: 1525,
    abbrName: 'EncDcmntnTxtLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedDocumentationText(1527) field.',
  },
  {
    type: 'data',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'EncodedDocumentationText',
    id: 1527,
    abbrName: 'EncDcmntnTxt',
    lengthId: '1525',
    description:
      'Encoded (non-ASCII characters) representation of the DocumentationText(1513) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the DocumentationText(1513) field.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'SwapSubClassCodeSet',
    addedEP: '169',
    updatedEP: '238',
    added: 'FIX.5.0SP2',
    name: 'SwapSubClass',
    id: 1575,
    abbrName: 'SwapSubClss',
    description: 'The sub-classification or notional schedule type of the swap.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'SettlRateIndex',
    id: 1577,
    abbrName: 'SettlNdx',
    description:
      'In an outright or forward commodity trade that is cash settled this is the index used to determine the cash payment.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'SettlRateIndexLocation',
    id: 1580,
    abbrName: 'SettlNdxLctn',
    description:
      'This is an optional qualifying attribute of SettlRateIndex(1577) such as the delivery zone for an electricity contract.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'OptionExpirationDesc',
    id: 1581,
    abbrName: 'ExpDesc',
    description: 'Description of the option expiration.',
  },
  {
    type: 'Length',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'EncodedOptionExpirationDescLen',
    id: 1678,
    abbrName: 'EncExpDescLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedOptionExpirationDesc(1697) field.',
  },
  {
    type: 'data',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'EncodedOptionExpirationDesc',
    id: 1697,
    abbrName: 'EncExpDesc',
    lengthId: '1678',
    description:
      'Encoded (non-ASCII characters) representation of the OptionExpirationDesc(1581) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the OptionExpirationDesc(1581).',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StrikeUnitOfMeasure',
    id: 1698,
    abbrName: 'StrkUOM',
    description:
      'Used to express the unit of measure (UOM) of the price if different from the contract.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StrikeIndex',
    id: 1866,
    abbrName: 'StrkNdx',
    description: 'Specifies the index used to calculate the strike price.',
  },
  {
    type: 'PriceOffset',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StrikeIndexSpread',
    id: 2001,
    abbrName: 'StrkSpread',
    description: 'Specifies the strike price offset from the named index.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ValuationSource',
    id: 2002,
    abbrName: 'ValSrc',
    description: 'Specifies the source of trade valuation data.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ValuationReferenceModel',
    id: 2140,
    abbrName: 'ValRefModel',
    description:
      'Specifies the methodology and/or assumptions used to generate the trade value.',
  },
  {
    type: 'StrategyTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StrategyType',
    id: 2141,
    abbrName: 'StrtTyp',
    description: 'Specifies the type of trade strategy.',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'CommonPricingIndicator',
    id: 2142,
    abbrName: 'CmnPxng',
    description:
      "When this element is specified and set to 'Y', it indicates that common pricing applies. Common pricing may be relevant for a transaction that references more than one commodity reference price.",
  },
  {
    type: 'SettlDisruptionProvisionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'SettlDisruptionProvision',
    id: 2143,
    abbrName: 'SettlDsrptnProv',
    description: 'Specifies the consequences of bullion settlement disruption events.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'RoundingDirectionCodeSet',
    addedEP: '169',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'InstrumentRoundingDirection',
    id: 2144,
    abbrName: 'RndDirctn',
    description: 'Specifies the rounding direction if not overridden elsewhere.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'InstrumentRoundingPrecision',
    id: 2145,
    abbrName: 'RndPrcsn',
    description:
      'Specifies the rounding precision in terms of a number of decimal places. Note how a percentage rate rounding of 5 decimal places is expressed as a rounding precision of 7.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegSettleOnOpenFlag',
    id: 2146,
    abbrName: 'SettlOnOpenFlag',
    description: 'Indicator to determine if the instrument is to settle on open.',
  },
  {
    type: 'InstrmtAssignmentMethodCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegInstrmtAssignmentMethod',
    id: 2147,
    abbrName: 'AsgnMeth',
    description: 'Specifies the method under which assignment was conducted.',
  },
  {
    updated: 'FIX.Latest',
    type: 'SecurityStatusCodeSet',
    addedEP: '169',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'LegSecurityStatus',
    id: 2148,
    abbrName: 'Status',
    description: 'Indicates the current state of the leg instrument.',
  },
  {
    type: 'RestructuringTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegRestructuringType',
    id: 2149,
    abbrName: 'RestrctTyp',
    description:
      'A category of CDS credit event in which the underlying bond experiences a restructuring.\n\nUsed to define a CDS instrument.',
  },
  {
    type: 'SeniorityCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegSeniority',
    id: 2150,
    abbrName: 'Snrty',
    description:
      'Specifies which issue (underlying bond) will receive payment priority in the event of a default.\n\nUsed to define a CDS instrument.',
  },
  {
    type: 'Percentage',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegNotionalPercentageOutstanding',
    id: 2151,
    abbrName: 'NotlPctOut',
    description:
      'Indicates the notional percentage of the deal that is still outstanding based on the remaining components of the index.\n\nUsed to calculate the true value of a CDS trade or position.',
  },
  {
    type: 'Percentage',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegOriginalNotionalPercentageOutstanding',
    id: 2152,
    abbrName: 'OrigNotlPctOut',
    description:
      'Used to reflect the Original value prior to the application of a credit event. See LegNotionalPercentageOutstanding(2151).',
  },
  {
    type: 'Percentage',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegAttachmentPoint',
    id: 2153,
    abbrName: 'AttchPnt',
    description: 'Lower bound percentage of the loss that the tranche can endure.',
  },
  {
    type: 'Percentage',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDetachmentPoint',
    id: 2154,
    abbrName: 'DetchPnt',
    description: 'Upper bound percentage of the loss the tranche can endure.',
  },
  {
    type: 'ObligationTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegObligationType',
    id: 2155,
    abbrName: 'ObligTyp',
    description: 'Type of reference obligation for credit derivatives contracts.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'SwapSubClassCodeSet',
    addedEP: '169',
    updatedEP: '238',
    added: 'FIX.5.0SP2',
    name: 'LegSwapSubClass',
    id: 2156,
    abbrName: 'SwapSubClss',
    description: 'The sub-classification or notional schedule type of the swap.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegNthToDefault',
    id: 2157,
    abbrName: 'NthDflt',
    description:
      'The Nth reference obligation in a CDS reference basket. If specified without LegMthToDefault(2158) the default will trigger a CDS payout. If LegMthToDefault(2158) is also present then payout occurs between the Nth and Mth obligations to default.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegMthToDefault',
    id: 2158,
    abbrName: 'MthDflt',
    description:
      'The Mth reference obligation to default in a CDS reference basket. When an NthToDefault(2157) to MthToDefault(2158) are represented then the CDS payout occurs between the Nth and Mth obligations to default.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegSettledEntityMatrixSource',
    id: 2159,
    abbrName: 'SettldMtrxSrc',
    description: 'Relevant settled entity matrix source.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegSettledEntityMatrixPublicationDate',
    id: 2160,
    abbrName: 'SettldMtrxDt',
    description:
      'The publication date of the applicable version of the matrix. When this element is omitted, the Standard Terms Supplement defines rules for which version of the matrix is applicable.',
  },
  {
    type: 'CouponTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegCouponType',
    id: 2161,
    abbrName: 'CpnTyp',
    description: 'Specifies the coupon type of the bond.',
  },
  {
    type: 'Amt',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegTotalIssuedAmount',
    id: 2162,
    abbrName: 'TotAmt',
    description:
      'Specifies the total amount of the issue. Corresponds to the par value multiplied by the number of issued security.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegCouponFrequencyPeriod',
    id: 2163,
    abbrName: 'CpnPeriod',
    description: "Time unit multiplier for the frequency of the bond's coupon payment.",
  },
  {
    type: 'CouponFrequencyUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegCouponFrequencyUnit',
    id: 2164,
    abbrName: 'CpnUnit',
    description: "Time unit associated with the frequency of the bond's coupon payment.",
  },
  {
    type: 'CouponDayCountCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegCouponDayCount',
    id: 2165,
    abbrName: 'CpnDayCnt',
    description:
      'The day count convention used in interest calculations for a bond or an interest bearing security.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegConvertibleBondEquityID',
    id: 2166,
    abbrName: 'CnvrtBondEqtyID',
    discriminatorId: '2167',
    description: 'Identifies the equity in which a convertible bond can be converted to.',
  },
  {
    type: 'SecurityIDSourceCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegConvertibleBondEquityIDSource',
    id: 2167,
    abbrName: 'CnvrtBondEqtyIDSrc',
    description:
      'Identifies class or source of the LegConvertibleBondEquitySecurityID(2166) value.',
  },
  {
    type: 'MonthYear',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegContractPriceRefMonth',
    id: 2168,
    abbrName: 'PxRefMo',
    description:
      'Reference month if there is no applicable LegMaturityMonthYear(610) value for the contract or security.',
  },
  {
    type: 'LienSeniorityCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegLienSeniority',
    id: 2169,
    abbrName: 'LienSnrty',
    description: 'Indicates the seniority level of the lien in a loan.',
  },
  {
    type: 'LoanFacilityCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegLoanFacility',
    id: 2170,
    abbrName: 'LoanFclty',
    description:
      "Specifies the type of loan when the credit default swap's reference obligation is a loan.",
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'ReferenceEntityTypeCodeSet',
    addedEP: '169',
    updatedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'LegReferenceEntityType',
    id: 2171,
    abbrName: 'RefEntityTyp',
    description:
      'Specifies the type of reference entity for first-to-default CDS basket contracts.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegIndexSeries',
    id: 2172,
    abbrName: 'NdxSeries',
    description: 'The series identifier of a credit default swap index.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegIndexAnnexVersion',
    id: 2173,
    abbrName: 'NdxAnxVer',
    description: 'The version of a credit default swap index annex.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegIndexAnnexDate',
    id: 2174,
    abbrName: 'NdxAnxDt',
    description: 'The date of a credit default swap index series annex.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegIndexAnnexSource',
    id: 2175,
    abbrName: 'NdxAnxSrc',
    description: 'The source of a credit default swap series annex.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegSettlRateIndex',
    id: 2176,
    abbrName: 'SettlNdx',
    description:
      'In an outright or forward commodity trade that is cash settled this is the index used to determine the cash payment.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegSettlRateIndexLocation',
    id: 2177,
    abbrName: 'SettlNdxLctn',
    description:
      'This is an optional qualifying attribute of LegSettlementRateIndex(2176) such as the delivery zone for an electricity contract.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegOptionExpirationDesc',
    id: 2178,
    abbrName: 'ExpDesc',
    description: 'Description of the option expiration.',
  },
  {
    type: 'Length',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'EncodedLegOptionExpirationDescLen',
    id: 2179,
    abbrName: 'EncExpDescLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedLegOptionExpirationDesc(2180) field.',
  },
  {
    type: 'data',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'EncodedLegOptionExpirationDesc',
    id: 2180,
    abbrName: 'EncExpDesc',
    lengthId: '2179',
    description:
      'Encoded (non-ASCII characters) representation of the LegOptionExpirationDesc(2178) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the LegOptionExpirationDesc(2178).',
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStrikeMultiplier',
    id: 2181,
    abbrName: 'StrkMult',
    description:
      'Used for derivatives. Multiplier applied to the strike price for the purpose of calculating the settlement value.',
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStrikeValue',
    id: 2182,
    abbrName: 'StrkValu',
    description:
      'The number of shares/units for the financial instrument involved in the option trade. Used for derivatives.',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStrikeUnitOfMeasure',
    id: 2183,
    abbrName: 'StrkUOM',
    description:
      'Used to express the unit of measure (UOM) of the price if different from the contract.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStrikeIndex',
    id: 2184,
    abbrName: 'StrkNdx',
    description: 'Specifies the index used to calculate the strike price.',
  },
  {
    type: 'PriceOffset',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStrikeIndexSpread',
    id: 2185,
    abbrName: 'StrkSpread',
    description: 'Specifies the strike price offset from the named index.',
  },
  {
    type: 'StrikePriceDeterminationMethodCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStrikePriceDeterminationMethod',
    id: 2186,
    abbrName: 'StrkPxDtrmnMeth',
    description:
      'Specifies how the strike price is determined at the point of option exercise. The strike may be fixed throughout the life of the option, set at expiration to the value of the underlying, set to the average value of the underlying , or set to the optimal value of the underlying.',
  },
  {
    type: 'StrikePriceBoundaryMethodCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStrikePriceBoundaryMethod',
    id: 2187,
    abbrName: 'StrkPxBndryMeth',
    description:
      'Specifies the boundary condition to be used for the strike price relative to the underlying price at the point of option exercise.',
  },
  {
    type: 'Percentage',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStrikePriceBoundaryPrecision',
    id: 2188,
    abbrName: 'StrkPxBndryPrcsn',
    description:
      'Used in combination with StrikePriceBoundaryMethod(2187) to specify the percentage of the strike price in relation to the underlying price. The percentage is generally 100 or greater for puts and 100 or less for calls.',
  },
  {
    type: 'UnderlyingPriceDeterminationMethodCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegUnderlyingPriceDeterminationMethod',
    id: 2189,
    abbrName: 'PxDtrmnMeth',
    description:
      'Specifies how the underlying price is determined at the point of option exercise. The underlying price may be set to the current settlement price, set to a special reference, set to the optimal value of the underlying during the defined period ("Look-back") or set to the average value of the underlying during the defined period ("Asian option").',
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegMinPriceIncrement',
    id: 2190,
    abbrName: 'MinPxIncr',
    description:
      'Minimum price increment for a given exchange-traded instrument. Could also be used to represent tick value.',
  },
  {
    type: 'Amt',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegMinPriceIncrementAmount',
    id: 2191,
    abbrName: 'MinPxIncrAmt',
    description:
      'Minimum price increment amount associated with the LegMinPriceIncrement(2190). For listed derivatives, the value can be calculated by multiplying LegMinPriceIncrement(2190) by LegContractMultiplier(614).',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'SettlMethodCodeSet',
    addedEP: '169',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegSettlMethod',
    id: 2192,
    abbrName: 'SettlMeth',
    description:
      'Settlement method for a contract or instrument. Additional values may be used with bilateral agreement.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'OptPayoutTypeCodeSet',
    addedEP: '169',
    updatedEP: '238',
    added: 'FIX.5.0SP2',
    name: 'LegOptPayoutType',
    id: 2193,
    abbrName: 'OptPayoutTyp',
    description:
      'Indicates the type of valuation method or trigger payout for an in-the-money option.',
  },
  {
    type: 'Amt',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegOptPayoutAmount',
    id: 2194,
    abbrName: 'OptPayAmt',
    description:
      'Cash amount indicating the pay out associated with an option. For binary options this is a fixed amount.',
  },
  {
    type: 'PriceQuoteMethodCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPriceQuoteMethod',
    id: 2195,
    abbrName: 'PxQteMeth',
    description: 'Specifies the method for price quotation.',
  },
  {
    type: 'ValuationMethodCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegValuationMethod',
    id: 2196,
    abbrName: 'ValMeth',
    description: 'Specifies the type of valuation method applied.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegValuationSource',
    id: 2197,
    abbrName: 'ValSrc',
    description: 'Specifies the source of trade valuation data.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegValuationReferenceModel',
    id: 2198,
    abbrName: 'ValRefModel',
    description:
      'Specifies the methodology and/or assumptions used to generate the trade value.',
  },
  {
    type: 'ListMethodCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegListMethod',
    id: 2199,
    abbrName: 'ListMeth',
    description:
      'Indicates whether instruments are pre-listed only or can also be defined via user request.',
  },
  {
    type: 'Price',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegCapPrice',
    id: 2200,
    abbrName: 'CapPx',
    description: 'Used to express the ceiling price of a capped call.',
  },
  {
    type: 'Price',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegFloorPrice',
    id: 2201,
    abbrName: 'FlrPx',
    description: 'Used to express the floor price of a capped put.',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegFlexibleIndicator',
    id: 2202,
    abbrName: 'FlexInd',
    description:
      'Used to indicate a derivatives security that can be defined using flexible terms. The terms commonly permitted to be defined by market participants are expiration date and strike price. FlexibleIndicator is an alternative to LegCFICode(608) Standard/Non-standard attribute.',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegFlexProductEligibilityIndicator',
    id: 2203,
    abbrName: 'FlexProdElig',
    description:
      'Used to indicate if a product or group of product supports the creation of flexible securities.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPositionLimit',
    id: 2205,
    abbrName: 'PosLmt',
    description: 'Position Limit for a given exchange-traded product.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegNTPositionLimit',
    id: 2206,
    abbrName: 'NTPosLmt',
    description:
      'Position limit in the near-term contract for a given exchange-traded product.',
  },
  {
    type: 'CPProgramCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegCPProgram',
    id: 2207,
    abbrName: 'CPPgm',
    description: 'The program under which a commercial paper is issued.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegCPRegType',
    id: 2208,
    abbrName: 'CPRegTyp',
    description: 'The registration type of a commercial paper issuance.',
  },
  {
    type: 'ShortSaleRestrictionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegShortSaleRestriction',
    id: 2209,
    abbrName: 'ShrtRstctn',
    description: 'Indicates whether a restriction applies to short selling a security.',
  },
  {
    type: 'StrategyTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStrategyType',
    id: 2211,
    abbrName: 'StrtTyp',
    description: 'Specifies the type of trade strategy.',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegCommonPricingIndicator',
    id: 2212,
    abbrName: 'CmnPxng',
    description:
      "When this element is specified and set to 'Y', it indicates that common pricing applies. Common pricing may be relevant for a transaction that references more than one commodity reference price.",
  },
  {
    type: 'SettlDisruptionProvisionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegSettlDisruptionProvision',
    id: 2213,
    abbrName: 'SettlDsrptnProv',
    description: 'Specifies the consequences of bullion settlement disruption events.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'RoundingDirectionCodeSet',
    addedEP: '169',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegInstrumentRoundingDirection',
    id: 2214,
    abbrName: 'RndDirctn',
    description:
      'Specifies the rounding direction if not overridden elsewhere.\n\nApplicable for complex FX option strategies.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegInstrumentRoundingPrecision',
    id: 2215,
    abbrName: 'RndPrcsn',
    description:
      'Specifies the rounding precision in terms of a number of decimal places. Note how a percentage rate rounding of 5 decimal places is expressed as a rounding precision of 7.',
  },
  {
    type: 'MarketDisruptionProvisionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'MarketDisruptionProvision',
    id: 41087,
    abbrName: 'Prov',
    description: 'The consequences of market disruption events.',
  },
  {
    type: 'MarketDisruptionFallbackProvisionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'MarketDisruptionFallbackProvision',
    id: 41088,
    abbrName: 'FallbckProv',
    description: 'Specifies the location of the fallback provision documentation.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'MarketDisruptionMaximumDays',
    id: 41089,
    abbrName: 'MaxDays',
    description:
      'Specifies the maximum number of market disruption days (commodity or bullion business days) in a contract or confirmation. If none are specified, the maximum number of market disruption days is five (5).\n\nISDA 2005 Commodity Definition.',
  },
  {
    type: 'Percentage',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'MarketDisruptionMaterialityPercentage',
    id: 41090,
    abbrName: 'MtrltyPctage',
    description:
      'Used when a price materiality percentage applies to the price source disruption event and this event has been specified.\n\nApplicable to 2005 Commodity Definitions only.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'MarketDisruptionMinimumFuturesContracts',
    id: 41091,
    abbrName: 'MinCtrcts',
    description:
      "Specifies the minimum futures contracts level that dictates whether or not a 'De Minimis Trading' event has occurred.\n\nApplicable to 1993 Commodity Definitions only.",
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoMarketDisruptionEvents',
    id: 41092,
    description: 'Number of disruption events in the repeating group.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    addedEP: '169',
    updatedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'MarketDisruptionEvent',
    id: 41093,
    abbrName: 'Evnt',
    description:
      'Specifies the market disruption event.\n\nFor commodities see http://www.fpml.org/coding-scheme/commodity-market-disruption for values.\n\nFor foreign exchange, see http://www.fixtradingcommunity.org/codelists#Market_Disruption_Event for code list of applicable event types.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoMarketDisruptionFallbacks',
    id: 41094,
    description: 'Number of fallbacks in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'MarketDisruptionFallbackType',
    id: 41095,
    abbrName: 'Typ',
    description:
      'Specifies the type of disruption fallback.\n\nSee http://www.fpml.org/coding-scheme/commodity-market-disruption-fallback for values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoMarketDisruptionFallbackReferencePrices',
    id: 41096,
    description: 'Number of fallback reference securities in the repeating group.',
  },
  {
    type: 'MarketDisruptionFallbackUnderlierTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'MarketDisruptionFallbackUnderlierType',
    id: 41097,
    abbrName: 'Typ',
    description: 'The type of reference price underlier.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'MarketDisruptionFallbackUnderlierSecurityID',
    id: 41098,
    abbrName: 'ID',
    discriminatorId: '41099',
    description: 'Specifies the identifier value of the security.',
  },
  {
    updated: 'FIX.Latest',
    type: 'SecurityIDSourceCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '169',
    updatedEP: '265',
    added: 'FIX.5.0SP2',
    name: 'MarketDisruptionFallbackUnderlierSecurityIDSource',
    id: 41099,
    abbrName: 'Src',
    description: 'Specifies the class or source scheme of the security identifier.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'MarketDisruptionFallbackUnderlierSecurityDesc',
    id: 41100,
    abbrName: 'Desc',
    description: 'Specifies the description of the underlying security.',
  },
  {
    type: 'Length',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'EncodedMarketDisruptionFallbackUnderlierSecurityDescLen',
    id: 41101,
    abbrName: 'EncDescLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedMarketDisruptionFallbackUnderlierSecurityDesc(41102) field.',
  },
  {
    type: 'data',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'EncodedMarketDisruptionFallbackUnderlierSecurityDesc',
    id: 41102,
    abbrName: 'EncDesc',
    lengthId: '41101',
    description:
      'Encoded (non-ASCII characters) representation of the MarketDisruptionFallbackUnderlierSecurityDesc(41100) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the MarketDisruptionFallbackUnderlierSecurityDesc(41100) field.',
  },
  {
    type: 'Qty',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'MarketDisruptionFallbackOpenUnits',
    id: 41103,
    abbrName: 'OpnUnits',
    description:
      'If there are multiple underlying assets, this specifies the number of units (index or securities) that constitute the underlier of the swap. In the case of a basket swap, this is used to reference both the number of basket units, and the number of each asset components of the basket when these are expressed in absolute terms.',
  },
  {
    type: 'Currency',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'MarketDisruptionFallbackBasketCurrency',
    id: 41104,
    abbrName: 'Ccy',
    description:
      'Specifies the currency if the underlier is a basket. Uses ISO 4217 currency codes.',
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'MarketDisruptionFallbackBasketDivisor',
    id: 41105,
    abbrName: 'Dvsr',
    description:
      'Specifies the basket divisor amount. This value is normally used to adjust the constituent weight for pricing or to adjust for dividends, or other corporate actions.',
  },
  {
    type: 'Percentage',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'MiscFeeRate',
    id: 2216,
    abbrName: 'Rt',
    description: 'The fee rate when MiscFeeAmt(137) is a percentage of trade quantity.',
  },
  {
    type: 'Amt',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'MiscFeeAmountDue',
    id: 2217,
    abbrName: 'AmtDue',
    description: 'The fee amount due if different from MiscFeeAmt(137).',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ExerciseDesc',
    id: 41106,
    abbrName: 'Desc',
    description: 'A description of the option exercise.',
  },
  {
    type: 'Length',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'EncodedExerciseDescLen',
    id: 41107,
    abbrName: 'EncDescLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedExerciseDesc(41102) field.',
  },
  {
    type: 'data',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'EncodedExerciseDesc',
    id: 41108,
    abbrName: 'EncDesc',
    lengthId: '41107',
    description:
      'Encoded (non-ASCII characters) representation of the ExerciseDesc(41106) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the ExerciseDesc(41106) field.',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'AutomaticExerciseIndicator',
    id: 41109,
    abbrName: 'AutoExerInd',
    description:
      "Indicates (when 'Y') that exercise is automatic when the strike price is crossed or the underlying trade is in the money.",
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'AutomaticExerciseThresholdRate',
    id: 41110,
    abbrName: 'AutoRt',
    description: 'The threshold rate for triggering automatic exercise.',
  },
  {
    type: 'ExerciseConfirmationMethodCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ExerciseConfirmationMethod',
    id: 41111,
    abbrName: 'ExerCnfm',
    description:
      "Indicates whether follow-up confirmation of exercise (written or electronic) is required following telephonic notice by the buyer to the seller or seller's agent.",
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ManualNoticeBusinessCenter',
    id: 41112,
    abbrName: 'ManNtcBizCtr',
    description:
      'Identifies the business center used for adjusting the time for manual exercise notice.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'FallbackExerciseIndicator',
    id: 41113,
    abbrName: 'FallbckExerInd',
    description:
      'Indicates whether the notional amount of the underlying swap, not previously exercised under the option, will be automatically exercised at the expiration time on the expiration date if at such time the buyer is in-the-money, provided that the difference between the settlement rate and the fixed rate under the relevant underlying swap is not less than one tenth of a percentage point (0.10% or 0.001).',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LimitedRightToConfirmIndicator',
    id: 41114,
    abbrName: 'LtdRightCnfmInd',
    description:
      'Indicates whether the Seller may request the Buyer to confirm its intent to exercise if not done on or before the expiration time on the expiration date. If true ("Y") specific rules will apply in relation to the settlement mode.',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'ExerciseSplitTicketIndicator',
    id: 41115,
    abbrName: 'ExerSplitTktInd',
    description:
      'Indicates in physical settlement of bond and convertible bond options whether the party required to deliver the bonds will divide those to be delivered as notifying party desires to facilitate delivery obligations.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoOptionExerciseBusinessCenters',
    id: 41116,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'OptionExerciseBusinessCenter',
    id: 41117,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the option exercise dates, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'OptionExerciseBusinessDayConvention',
    id: 41118,
    abbrName: 'BizDayCnvtn',
    description:
      'The business day convention used to adjust the option exercise dates. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'ComplexEventDateOffsetDayTypeCodeSet',
    addedEP: '169',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'OptionExerciseEarliestDateOffsetDayType',
    id: 41119,
    abbrName: 'ErlstOfstDayTyp',
    description:
      'Specifies the day type of the relative earliest option exercise date offset.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'OptionExerciseEarliestDateOffsetPeriod',
    id: 41120,
    abbrName: 'ErlstOfstPeriod',
    description: 'Time unit multiplier for the relative earliest exercise date offset.',
  },
  {
    type: 'ProvisionOptionExerciseEarliestDateOffsetUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'OptionExerciseEarliestDateOffsetUnit',
    id: 41121,
    abbrName: 'ErlstOfstUnit',
    description: 'Time unit associated with the relative earliest exercise date offset.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'OptionExerciseFrequencyPeriod',
    id: 41122,
    abbrName: 'FreqPeriod',
    description: 'Time unit multiplier for the frequency of exercise dates.',
  },
  {
    type: 'ProtectionTermEventUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'OptionExerciseFrequencyUnit',
    id: 41123,
    abbrName: 'FreqUnit',
    description: 'Time unit associated with the frequency of exercise dates.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'OptionExerciseStartDateUnadjusted',
    id: 41124,
    abbrName: 'StartDtUnadj',
    description: 'The unadjusted start date for calculating periodic exercise dates.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'OptionExerciseStartDateRelativeTo',
    id: 41125,
    abbrName: 'StartDtReltv',
    description:
      'Specifies the anchor date when the option exercise start date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'OptionExerciseStartDateOffsetPeriod',
    id: 41126,
    abbrName: 'StartDtOfstPeriod',
    description: 'Time unit multiplier for the relative exercise start date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'OptionExerciseStartDateOffsetUnit',
    id: 41127,
    abbrName: 'StartDtOfstUnit',
    description: 'Time unit associated with the relative exercise start date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '169',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'OptionExerciseStartDateOffsetDayType',
    id: 41128,
    abbrName: 'StartDtOfstDayTyp',
    description:
      'Specifies the day type of the relative option exercise start date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'OptionExerciseStartDateAdjusted',
    id: 41129,
    abbrName: 'StartDt',
    description: 'The adjusted start date for calculating periodic exercise dates.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'OptionExerciseSkip',
    id: 41130,
    abbrName: 'Skip',
    description:
      'The number of periods in the referenced date schedule that are between each date in the relative date schedule. Thus a skip of 2 would mean that dates are relative to every second date in the referenced schedule. If present this should have a value greater than 1.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'OptionExerciseNominationDeadline',
    id: 41131,
    abbrName: 'NomntnDdln',
    description: 'Last date (adjusted) for establishing the option exercise terms.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'OptionExerciseFirstDateUnadjusted',
    id: 41132,
    abbrName: 'FirstDtUnadj',
    description: 'The unadjusted first exercise date.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'OptionExerciseLastDateUnadjusted',
    id: 41133,
    abbrName: 'LastDtUnadj',
    description: 'The unadjusted last exercise date.',
  },
  {
    type: 'LocalMktTime',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'OptionExerciseEarliestTime',
    id: 41134,
    abbrName: 'ErlstTm',
    description:
      "The earliest time at which notice of exercise can be given by the buyer to the seller (or seller's agent) (i) on the expriation date, in the case of a European style option, (ii) on each Bermuda option exercise date and the expiration date, in the case of a Bermuda style option, (iii) the commencement date to, and including, the expiration date, in the case of an American option.",
  },
  {
    type: 'LocalMktTime',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'OptionExerciseLatestTime',
    id: 41135,
    abbrName: 'LtstTm',
    description: 'The latest exercise time. See also OptionExerciseEarliestTime(41134).',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'OptionExerciseTimeBusinessCenter',
    id: 41136,
    abbrName: 'TmBizCtr',
    description:
      'The business center used to determine the locale for option exercise time, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoOptionExerciseDates',
    id: 41137,
    description: 'Number of dates in the repeating group.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'OptionExerciseDate',
    id: 41138,
    abbrName: 'Dt',
    description:
      'The option exercise fixed date, unadjusted or adjusted depending on OptionExerciseDateType(41139).',
  },
  {
    type: 'OptionExerciseDateTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'OptionExerciseDateType',
    id: 41139,
    abbrName: 'Typ',
    description:
      'Specifies the type of date. When specified it applies not only to the current date but to all subsequent dates in the group until overridden with a new type.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoOptionExerciseExpirationDateBusinessCenters',
    id: 41140,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'OptionExerciseExpirationDateBusinessCenter',
    id: 41141,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the option exercise expiration dates, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'OptionExerciseExpirationDateBusinessDayConvention',
    id: 41142,
    abbrName: 'BizDayCnvtn',
    description:
      'The business day convention used to adjust the option exercise expiration dates. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '169',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'OptionExerciseExpirationDateRelativeTo',
    id: 41143,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the option exercise expiration date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'OptionExerciseExpirationDateOffsetPeriod',
    id: 41144,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative exercise expiration date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'OptionExerciseExpirationDateOffsetUnit',
    id: 41145,
    abbrName: 'OfstUnit',
    description:
      'Time unit associated with the relative exercise expiration date offset.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'OptionExerciseExpirationFrequencyPeriod',
    id: 41146,
    abbrName: 'FreqPeriod',
    description: 'Time unit multiplier for the frequency of exercise expiration dates.',
  },
  {
    type: 'ProtectionTermEventUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'OptionExerciseExpirationFrequencyUnit',
    id: 41147,
    abbrName: 'FreqUnit',
    description: 'Time unit associated with the frequency of exercise expiration dates.',
  },
  {
    type: 'DateRollConventionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'OptionExerciseExpirationRollConvention',
    id: 41148,
    abbrName: 'Roll',
    description:
      'The convention for determining the sequence of exercise expiration dates. It is used in conjunction with a specified frequency. Used only to override the roll convention defined in the DateAdjustment component in Instrument.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '169',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'OptionExerciseExpirationDateOffsetDayType',
    id: 41149,
    abbrName: 'OfstDayTyp',
    description:
      'Specifies the day type of the relative option exercise expiration date offset.',
  },
  {
    type: 'LocalMktTime',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'OptionExerciseExpirationTime',
    id: 41150,
    abbrName: 'Tm',
    description: 'The option exercise expiration time.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'OptionExerciseExpirationTimeBusinessCenter',
    id: 41151,
    abbrName: 'TmBizCtr',
    description:
      'The business center used to determine the locale for option exercise expiration time, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoOptionExerciseExpirationDates',
    id: 41152,
    description: 'Number of fixed exercise expiration dates in the repeating group.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'OptionExerciseExpirationDate',
    id: 41153,
    abbrName: 'Dt',
    description: 'An adjusted or unadjusted fixed option exercise expiration date.',
  },
  {
    type: 'OptionExerciseDateTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'OptionExerciseExpirationDateType',
    id: 41154,
    abbrName: 'Typ',
    description:
      'Specifies the type of option exercise expiration date. When specified it applies not only to the current date but to all subsequent dates in the group until overridden with a new type.',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentUnitOfMeasure',
    id: 41155,
    abbrName: 'UOM',
    description:
      'Used to express the unit of measure (UOM) of the payment amount if not in the currency of the trade.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '169',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentDateRelativeTo',
    id: 41156,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the payment date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentDateOffsetPeriod',
    id: 41157,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative payment date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentDateOffsetUnit',
    id: 41158,
    abbrName: 'OfstUnit',
    description: 'Time unit associated with the relative payment date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentDateOffsetDayTypeCodeSet',
    addedEP: '169',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentDateOffsetDayType',
    id: 41159,
    abbrName: 'OfstDayTyp',
    description: 'Specifies the day type of the relative payment date offset.',
  },
  {
    type: 'PaymentForwardStartTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentForwardStartType',
    id: 41160,
    abbrName: 'FwdStartTyp',
    description: 'Forward start premium type.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoPaymentScheduleFixingDays',
    id: 41161,
    description: 'Number of fixing days in the repeating group.',
  },
  {
    type: 'PaymentStreamPricingDayOfWeekCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleFixingDayOfWeek',
    id: 41162,
    abbrName: 'DayOfWk',
    description: 'The day of the week on which fixing will take place.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleFixingDayNumber',
    id: 41163,
    abbrName: 'DayNum',
    description:
      'The occurrence of the day of week on which fixing takes place.\n\nFor example, a fixing of the 3rd Friday would be DayOfWk=5 DayNum=3. If omitted every day of the week is a fixing day.',
  },
  {
    type: 'XID',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleXID',
    id: 41164,
    abbrName: 'XID',
    description:
      'Identifier of this PaymentSchedule for cross referencing elsewhere in the message.',
  },
  {
    type: 'XIDREF',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleXIDRef',
    id: 41165,
    abbrName: 'XIDRef',
    description: 'Reference to payment schedule elsewhere in the message.',
  },
  {
    type: 'Currency',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleRateCurrency',
    id: 41166,
    abbrName: 'RtCcy',
    description: 'The currency of the schedule rate. Uses ISO 4217 currency codes.',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleRateUnitOfMeasure',
    id: 41167,
    abbrName: 'RtUOM',
    description: 'The schedule rate unit of measure (UOM).',
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleRateConversionFactor',
    id: 41168,
    abbrName: 'RtFctr',
    description:
      'The number to be multiplied by the derived floating rate of the payment schedule in order to arrive at the payment rate. If omitted, the schedule rate conversion factor is 1.',
  },
  {
    type: 'PaymentStreamRateSpreadTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleRateSpreadType',
    id: 41169,
    abbrName: 'SpreadTyp',
    description:
      'Identifies whether the rate spread is an absolute value to be added to the index rate or a percentage of the index rate.',
  },
  {
    type: 'Price',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleSettlPeriodPrice',
    id: 41170,
    abbrName: 'SettlPx',
    description: 'The schedule settlement period price.',
  },
  {
    type: 'Currency',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleSettlPeriodPriceCurrency',
    id: 41171,
    abbrName: 'SettlPxCcy',
    description:
      'Specifies the currency of the schedule settlement period price. Uses ISO 4217 currency codes.',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleSettlPeriodPriceUnitOfMeasure',
    id: 41172,
    abbrName: 'SettlPxUOM',
    description: 'The settlement period price unit of measure (UOM).',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleStepUnitOfMeasure',
    id: 41173,
    abbrName: 'StepUOM',
    description: 'The schedule step unit of measure (UOM).',
  },
  {
    type: 'PaymentStreamPricingDayDistributionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleFixingDayDistribution',
    id: 41174,
    abbrName: 'FixngDayDistrib',
    description: 'The distribution of fixing days.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleFixingDayCount',
    id: 41175,
    abbrName: 'FixngDayCnt',
    description: 'The number of days over which fixing should take place.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleFixingLagPeriod',
    id: 41176,
    abbrName: 'FixngLagPeriod',
    description: 'Time unit multiplier for the fixing lag duration.',
  },
  {
    type: 'PaymentStreamInflationLagUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleFixingLagUnit',
    id: 41177,
    abbrName: 'FixngLagUnit',
    description: 'Time unit associated with the fixing lag duration.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '169',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleFixingFirstObservationDateOffsetPeriod',
    id: 41178,
    abbrName: 'FixngFirstObsvtnPeriod',
    description:
      'Time unit multiplier for the relative first observation date offset.\n\nIf the first observation offset is specified, the observation period will start the specified interval prior to each calculation period - i.e. if the first observation offset is 4 months and the lag duration is 3 months, observations will be taken in months 4, 3 and 2 (but not 1) prior to each calculation period. If no first observation offset is specified, the observation period will end immediately preceding each calculation period.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '169',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentScheduleFixingFirstObservationDateOffsetUnit',
    id: 41179,
    abbrName: 'FixngFirstObsvtnUnit',
    description: 'Time unit associated with the relative first observation date offset.',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFlatRateIndicator',
    id: 41180,
    abbrName: 'FlatRtInd',
    description:
      "When this element is specified and set to 'Y', the Flat Rate is the New Worldwide Tanker Nominal Freight Scale for the Freight Index Route taken at the Trade Date of the transaction “Fixed”. If 'N' it is taken on each Pricing Date “Floating”.",
  },
  {
    type: 'Amt',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFlatRateAmount',
    id: 41181,
    abbrName: 'FlatRtAmt',
    description:
      "Specifies the actual monetary value of the flat rate when PaymentStreamFlatRateIndicator(41180) = 'Y'.",
  },
  {
    type: 'Currency',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFlatRateCurrency',
    id: 41182,
    abbrName: 'FlatRtCcy',
    description:
      'Specifies the currency of the actual flat rate. Uses ISO 4217 currency codes.',
  },
  {
    type: 'Amt',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamMaximumPaymentAmount',
    id: 41183,
    abbrName: 'MaxPmtAmt',
    description: 'Specifies the limit on the total payment amount.',
  },
  {
    type: 'Currency',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamMaximumPaymentCurrency',
    id: 41184,
    abbrName: 'MaxPmtCcy',
    description:
      'Specifies the currency of total payment amount limit. Uses ISO 4217 currency codes.',
  },
  {
    type: 'Amt',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamMaximumTransactionAmount',
    id: 41185,
    abbrName: 'MaxTxnAmt',
    description:
      'Specifies the limit on the payment amount that goes out in any particular calculation period.',
  },
  {
    type: 'Currency',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamMaximumTransactionCurrency',
    id: 41186,
    abbrName: 'MaxTxnCcy',
    description:
      'Specifies the currency of the period payment amount limit. Uses ISO 4217 currency codes.',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFixedAmountUnitOfMeasure',
    id: 41187,
    abbrName: 'FixedAmtUOM',
    description: 'Specifies the fixed payment amount unit of measure (UOM).',
  },
  {
    type: 'Amt',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamTotalFixedAmount',
    id: 41188,
    abbrName: 'FixedAmt',
    description: 'Specifies the total fixed payment amount.',
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamWorldScaleRate',
    id: 41189,
    abbrName: 'WorldScaleRt',
    description:
      'The number of Worldscale points for purposes of the calculation of a fixed amount for a wet voyage charter commodity swap.',
  },
  {
    type: 'Price',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamContractPrice',
    id: 41190,
    abbrName: 'CtrctPx',
    description:
      'The price per relevant unit for purposes of the calculation of a fixed amount for a dry voyage charter or time charter commodity swap.',
  },
  {
    type: 'Currency',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamContractPriceCurrency',
    id: 41191,
    abbrName: 'CtrctPxCcy',
    description:
      'Specifies the currency of PaymentStreamContractPrice(41190). Uses ISO 4217 currency codes.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoPaymentStreamPricingBusinessCenters',
    id: 41192,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamPricingBusinessCenter',
    id: 41193,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the payment stream\'s pricing dates, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamRateIndex2CurvePeriod',
    id: 41194,
    abbrName: 'Ndx2Period',
    description:
      "Secondary time unit multiplier for the payment stream's floating rate index curve.\n\nMay be used for a Forward Rate Agreement (FRA) with an average rate between two curve points.",
  },
  {
    type: 'PaymentStreamRateIndexCurveUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamRateIndex2CurveUnit',
    id: 41195,
    abbrName: 'Ndx2Unit',
    description:
      "Secondary time unit associated with the payment stream's floating rate index curve.",
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamRateIndexLocation',
    id: 41196,
    abbrName: 'NdxLctn',
    description: 'Specifies the location of the floating rate index.',
  },
  {
    type: 'Qty',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamRateIndexLevel',
    id: 41197,
    abbrName: 'NdxLvl',
    description:
      'This is the weather Cooling Degree Days (CDD), Heating Degree Days (HDD) or HDD index level specified as the number of (amount of) weather index units specified by the parties in the related confirmation.',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamRateIndexUnitOfMeasure',
    id: 41198,
    abbrName: 'NdxUOM',
    description: 'The unit of measure (UOM) of the rate index level.',
  },
  {
    type: 'PaymentStreamSettlLevelCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamSettlLevel',
    id: 41199,
    abbrName: 'SettlLvl',
    description: 'Specifies how weather index units are to be calculated.',
  },
  {
    type: 'Qty',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamReferenceLevel',
    id: 41200,
    abbrName: 'RefLvl',
    description:
      'This is the weather Cooling Degree Days (CDD), Heating Degree Days (HDD) or HDD reference level specified as the number of (amount of) weather index units specified by the parties in the related confirmation.',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamReferenceLevelUnitOfMeasure',
    id: 41201,
    abbrName: 'RefUOM',
    description: 'The unit of measure (UOM) of the rate reference level.',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamReferenceLevelEqualsZeroIndicator',
    id: 41202,
    abbrName: 'RefLvlZero',
    description: "When set to 'Y', it indicates the weather reference level equals zero.",
  },
  {
    type: 'Currency',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamRateSpreadCurrency',
    id: 41203,
    abbrName: 'SpreadCcy',
    description:
      'Specifies the currency of the floating rate spread. Uses ISO 4217 currency codes.',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamRateSpreadUnitOfMeasure',
    id: 41204,
    abbrName: 'SpreadUOM',
    description: 'Species the unit of measure (UOM) of the floating rate spread.',
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamRateConversionFactor',
    id: 41205,
    abbrName: 'RtFctr',
    description:
      'The number to be multiplied by the derived floating rate of the payment stream in order to arrive at the payment rate. If omitted, the floating rate conversion factor is 1.',
  },
  {
    type: 'PaymentStreamRateSpreadTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamRateSpreadType',
    id: 41206,
    abbrName: 'SpreadTyp',
    description:
      'Identifies whether the rate spread is an absolute value to be added to the index rate or a percentage of the index rate.',
  },
  {
    type: 'Percentage',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamLastResetRate',
    id: 41207,
    abbrName: 'LastResetRt',
    description:
      'The floating rate determined at the most recent reset. The rate is expressed in decimal form, e.g. 5% is represented as 0.05.',
  },
  {
    type: 'Percentage',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFinalRate',
    id: 41208,
    abbrName: 'FnlRt',
    description:
      'The floating rate determined at the final reset. The rate is expressed in decimal form, e.g. 5% is represented as 0.05.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCalculationLagPeriod',
    id: 41209,
    abbrName: 'CalcLagPeriod',
    description: 'Time unit multiplier for the calculation lag duration.',
  },
  {
    type: 'PaymentStreamInflationLagUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCalculationLagUnit',
    id: 41210,
    abbrName: 'CalcLagUnit',
    description: 'Time unit associated with the calculation lag duration.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '169',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFirstObservationDateOffsetPeriod',
    id: 41211,
    abbrName: 'FirstObsvtnOfstPeriod',
    description:
      'Time unit multiplier for the relative first observation date offset.\n\nIf the first observation offset is specified, the observation period will start the specified interval prior to each calculation period - i.e. if the first observation offset is 4 months and the lag duration is 3 months, observations will be taken in months 4, 3 and 2 (but not 1) prior to each calculation period. If no first observation offset is specified, the observation period will end immediately preceding each calculation period.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '169',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFirstObservationDateOffsetUnit',
    id: 41212,
    abbrName: 'FirstObsvtnOfstUnit',
    description: 'Time unit associated with the relative first observation date offset.',
  },
  {
    type: 'ComplexEventDateOffsetDayTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamPricingDayType',
    id: 41213,
    abbrName: 'PxngDayTyp',
    description: 'Specifies the commodity pricing day type.',
  },
  {
    type: 'PaymentStreamPricingDayDistributionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamPricingDayDistribution',
    id: 41214,
    abbrName: 'PxngDayDistrib',
    description: 'The distribution of pricing days.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamPricingDayCount',
    id: 41215,
    abbrName: 'PxngDayCnt',
    description: 'The number of days over which pricing should take place.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamPricingBusinessCalendar',
    id: 41216,
    abbrName: 'PxngClndr',
    description:
      'Specifies the business calendar to use for pricing.\n\nSee http://www.fpml.org/coding-scheme/commodity-business-calendar for values.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamPricingBusinessDayConvention',
    id: 41217,
    abbrName: 'PxngBizDayCnvtn',
    description:
      "The business day convention used to adjust the payent stream's pricing dates. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.",
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoPaymentStreamPaymentDates',
    id: 41220,
    description: 'Number of payment dates in the repeating group.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamPaymentDate',
    id: 41221,
    abbrName: 'Dt',
    description: 'The adjusted or unadjusted fixed stream payment date.',
  },
  {
    type: 'OptionExerciseDateTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamPaymentDateType',
    id: 41222,
    abbrName: 'Typ',
    description:
      'Specifies the type of payment date. When specified it applies not only to the current date but to all subsequent dates in the group until overridden with a new type.',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamMasterAgreementPaymentDatesIndicator',
    id: 41223,
    abbrName: 'MADts',
    description:
      "When set to 'Y', it indicates that payment dates are specified in the relevant master agreement.",
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoPaymentStreamPricingDates',
    id: 41224,
    description: 'Number of pricing dates in the repeating group.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamPricingDate',
    id: 41225,
    abbrName: 'Dt',
    description: 'The adjusted or unadjusted fixed stream pricing date.',
  },
  {
    type: 'OptionExerciseDateTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamPricingDateType',
    id: 41226,
    abbrName: 'Typ',
    description:
      'Specifies the type of pricing date. When specified it applies not only to the current date but to all subsequent dates in the group until overridden with a new type.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoPaymentStreamPricingDays',
    id: 41227,
    description: 'Number of pricing days in the repeating group.',
  },
  {
    type: 'PaymentStreamPricingDayOfWeekCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamPricingDayOfWeek',
    id: 41228,
    abbrName: 'DayOfWk',
    description: 'The day of the week on which pricing takes place.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamPricingDayNumber',
    id: 41229,
    abbrName: 'DayNum',
    description:
      'The occurrence of the day of week on which pricing takes place.\n\nFor example a pricing day of the 3rd Friday would be DayOfWk=5 DayNum=3.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoPricingDateBusinessCenters',
    id: 41230,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PricingDateBusinessCenter',
    id: 41231,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust pricing or fixing dates, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PricingDateUnadjusted',
    id: 41232,
    abbrName: 'DtUnadj',
    description: 'The unadjusted pricing or fixing date.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PricingDateBusinessDayConvention',
    id: 41233,
    abbrName: 'BizDayCnvtn',
    description:
      'The business day convention used to adjust pricing or fixing dates. Used only to override the business day convention defined in the DateAdjustment component within the Instrument component.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PricingDateAdjusted',
    id: 41234,
    abbrName: 'Dt',
    description: 'The adjusted pricing or fixing date.',
  },
  {
    type: 'LocalMktTime',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PricingTime',
    id: 41235,
    abbrName: 'Tm',
    description: 'Specifies the local market time of the pricing or fixing.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'PricingTimeBusinessCenter',
    id: 41236,
    abbrName: 'TmBizCtr',
    description:
      'Specifies the business center for determining the pricing or fixing time. See http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoStreamAssetAttributes',
    id: 41237,
    description: 'Number of asset attribute entries in the group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamAssetAttributeType',
    id: 41238,
    abbrName: 'Typ',
    description:
      'Specifies the name of the attribute.\n\nSee http://www.fixtradingcommunity.org/codelists#Asset_Attribute_Types for code list of applicable asset attribute types.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamAssetAttributeValue',
    id: 41239,
    abbrName: 'Val',
    description: 'Specifies the value of the attribute.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamAssetAttributeLimit',
    id: 41240,
    abbrName: 'Lmt',
    description: 'Limit or lower acceptable value of the attribute.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoStreamCalculationPeriodDates',
    id: 41241,
    description: 'Number of calculation period dates in the repeating group.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCalculationPeriodDate',
    id: 41242,
    abbrName: 'Dt',
    description: 'The adjusted or unadjusted fixed calculation period date.',
  },
  {
    type: 'OptionExerciseDateTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCalculationPeriodDateType',
    id: 41243,
    abbrName: 'Typ',
    description:
      'Specifies the type of fixed calculation period date. When specified it applies not only to the current date but to all subsequent dates in the group until overridden with a new type.',
  },
  {
    type: 'XID',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCalculationPeriodDatesXID',
    id: 41244,
    abbrName: 'XID',
    description:
      'Identifier of this calculation period for cross referencing elsewhere in the message.',
  },
  {
    type: 'XIDREF',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCalculationPeriodDatesXIDRef',
    id: 41245,
    abbrName: 'XIDRef',
    description:
      'Cross reference to another calculation period for duplicating its properties.',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCalculationBalanceOfFirstPeriod',
    id: 41246,
    abbrName: 'BalFirst',
    description:
      "When specified and set to 'Y', it indicates that the first calculation period should run from the effective date to the end of the calendar period in which the effective date falls (e.g. Jan 15 - Jan 31 if the calculation periods are one month long and effective date is Jan 15.). If 'N' or not specified, it indicates that the first calculation period should run from the effective date for one whole period (e.g. Jan 15 to Feb 14 if the calculation periods are one month long and the effective date is Jan 15.).",
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCalculationCorrectionPeriod',
    id: 41247,
    abbrName: 'CrrctnPeriod',
    description:
      'Time unit multiplier for the length of time after the publication of the data when corrections can be made.',
  },
  {
    type: 'ProtectionTermEventUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCalculationCorrectionUnit',
    id: 41248,
    abbrName: 'CrrctnUnit',
    description:
      'Time unit associated with the length of time after the publication of the data when corrections can be made.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoStreamCommoditySettlBusinessCenters',
    id: 41249,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommoditySettlBusinessCenter',
    id: 41250,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the commodity delivery date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommodityBase',
    id: 41251,
    abbrName: 'Base',
    description:
      'Specifies the general base type of the commodity traded. Where possible, this should follow the naming convention used in the 2005 ISDA Commodity Definitions.\n\nExamples of general commodity base types include: Metal, Bullion, Oil, Natural Gas, Coal, Electricity, Inter-Energy, Grains, Oils Seeds, Dairy, Livestock, Forestry, Softs, Weather, Emissions.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommodityType',
    id: 41252,
    abbrName: 'CmdtyTyp',
    description:
      'Specifies the type of commodity product.\n\nFor coal see http://www.fpml.org/coding-scheme/commodity-coal-product-type for values.\n\nFor metals see http://www.fpml.org/coding-scheme/commodity-metal-product-type for values.\n\nFor bullion see http://www.fixtradingcommunity.org/codelists#Bullion_Types for the external code list of bullion types.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommoditySecurityID',
    id: 41253,
    abbrName: 'ID',
    discriminatorId: '41254',
    description: 'Specifies the market identifier for the commodity.',
  },
  {
    updated: 'FIX.Latest',
    type: 'SecurityIDSourceCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '169',
    updatedEP: '265',
    added: 'FIX.5.0SP2',
    name: 'StreamCommoditySecurityIDSource',
    id: 41254,
    abbrName: 'Src',
    description:
      'Identifies the class or source of the StreamCommoditySecurityIDSource(41253) value.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommodityDesc',
    id: 41255,
    abbrName: 'Desc',
    description: 'Description of the commodity asset.',
  },
  {
    type: 'Length',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'EncodedStreamCommodityDescLen',
    id: 41256,
    abbrName: 'EncDescLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedStreamCommodityDesc(41257) field.',
  },
  {
    type: 'data',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'EncodedStreamCommodityDesc',
    id: 41257,
    abbrName: 'EncDesc',
    lengthId: '41256',
    description:
      'Encoded (non-ASCII characters) representation of the StreamCommodityDesc(41255) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the StreamCommodityDesc(41255) field.',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommodityUnitOfMeasure',
    id: 41258,
    abbrName: 'UOM',
    description: 'The unit of measure (UOM) of the commodity asset.',
  },
  {
    type: 'Currency',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommodityCurrency',
    id: 41259,
    abbrName: 'Ccy',
    description:
      'Identifies the currency of the commodity asset. Uses ISO 4217 currency codes.',
  },
  {
    type: 'Exchange',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommodityExchange',
    id: 41260,
    abbrName: 'Exch',
    description: 'Identifies the exchange where the commodity is traded.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommodityRateSource',
    id: 41261,
    abbrName: 'RtSrc',
    description:
      'Identifies the source of rate information used for commodities.\n\nSee http://www.fixtradingcommunity.org/codelists#Commodity_Rate_Source for code list of applicable sources.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommodityRateReferencePage',
    id: 41262,
    abbrName: 'RefPg',
    description: 'Identifies the reference "page" from the rate source.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommodityRateReferencePageHeading',
    id: 41263,
    abbrName: 'RefHdng',
    description: 'Identifies the page heading from the rate source.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamDataProvider',
    id: 41264,
    abbrName: 'DataPrvdr',
    description:
      'Specifies the commodity data or information provider.\n\nSee http://www.fpml.org/coding-scheme/commodity-information-provider for values.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommodityPricingType',
    id: 41265,
    abbrName: 'PxngTyp',
    description:
      'Specifies how the pricing or rate setting of the trade is to be determined or based upon.\n\nSee http://www.fixtradingcommunity.org/codelists#Commodity_Rate_Pricing_Type for code list of applicable commodity pricing types.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommodityNearbySettlDayPeriod',
    id: 41266,
    abbrName: 'Period',
    description:
      'Time unit multiplier for the nearby settlement day.\n\nWhen the commodity transaction references a futures contract, the delivery or settlement dates are a nearby month or week. For example, for eighth nearby month use Period=8 and Unit=Mo.',
  },
  {
    type: 'StreamCommodityNearbySettlDayUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommodityNearbySettlDayUnit',
    id: 41267,
    abbrName: 'Unit',
    description: 'Time unit associated with the nearby settlement day.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommoditySettlDateUnadjusted',
    id: 41268,
    abbrName: 'DtUnadj',
    description: 'The unadjusted commodity delivery date.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommoditySettlDateBusinessDayConvention',
    id: 41269,
    abbrName: 'BizDayCnvtn',
    description:
      'The business day convention used to adjust the commodity delivery date. Used only to override the business day convention specified in the DateAdjustment component within the Instrument component.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommoditySettlDateAdjusted',
    id: 41270,
    abbrName: 'Dt',
    description: 'The adjusted commodity delivery date.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommoditySettlMonth',
    id: 41271,
    abbrName: 'Mo',
    description:
      'Specifies a fixed single month for commodity delivery.\n\nUse "1" for January, "2" for February, etc.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommoditySettlDateRollPeriod',
    id: 41272,
    abbrName: 'RollPeriod',
    description:
      'Time unit multiplier for the commodity delivery date roll.\n\nFor a commodity transaction that references a listed future via the delivery dates, this is the day offset on which the specified future will roll to the next nearby month when the referenced future expires.',
  },
  {
    type: 'StreamCommoditySettlDateRollUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommoditySettlDateRollUnit',
    id: 41273,
    abbrName: 'RollUnit',
    description: 'Time unit associated with the commodity delivery date roll.',
  },
  {
    type: 'ComplexEventDateOffsetDayTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommoditySettlDayType',
    id: 41274,
    abbrName: 'DayTyp',
    description: 'Specifies the commodity delivery roll day type.',
  },
  {
    type: 'XID',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommodityXID',
    id: 41275,
    abbrName: 'XID',
    description:
      'Identifier of this stream commodity for cross referencing elsewhere in the message.',
  },
  {
    type: 'XIDREF',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommodityXIDRef',
    id: 41276,
    abbrName: 'XIDRef',
    description: 'Reference to a stream commodity elsewhere in the message.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoStreamCommodityAltIDs',
    id: 41277,
    description: 'Number of alternate security identifers.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommodityAltID',
    id: 41278,
    abbrName: 'AltID',
    discriminatorId: '41279',
    description: 'Alternate security identifier value for the commodity.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommodityAltIDSource',
    id: 41279,
    abbrName: 'AltIDSrc',
    description:
      'Identifies the class or source of the alternate commodity security identifier.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoStreamCommodityDataSources',
    id: 41280,
    description:
      'Number of data sources in the repeating group. The order of entry determines priority – first is the main source, second is fallback, third is second fallback.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommodityDataSourceID',
    id: 41281,
    abbrName: 'ID',
    description: 'Data source identifier.',
  },
  {
    type: 'StreamCommodityDataSourceIDTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommodityDataSourceIDType',
    id: 41282,
    abbrName: 'Typ',
    description: 'Type of data source identifier.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoStreamCommoditySettlDays',
    id: 41283,
    description: 'Number of days in the repeating group.',
  },
  {
    type: 'DeliveryScheduleSettlDayCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommoditySettlDay',
    id: 41284,
    abbrName: 'Day',
    description: 'Specifies the day or group of days for delivery.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommoditySettlTotalHours',
    id: 41285,
    abbrName: 'TotHrs',
    description: 'Sum of the hours specified in StreamCommoditySettlTimeGrp.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoStreamCommoditySettlTimes',
    id: 41286,
    description: 'Number of hour ranges in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommoditySettlStart',
    id: 41287,
    abbrName: 'Start',
    description:
      'The start time for commodities settlement where delivery occurs over time. The time format is specified by the settlement time type.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommoditySettlEnd',
    id: 41288,
    abbrName: 'End',
    description:
      'The end time for commodities settlement where delivery occurs over time. The time format is specified by the settlement time type.',
  },
  {
    type: 'DeliveryScheduleSettlTimeTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommoditySettlTimeType',
    id: 41588,
    abbrName: 'Typ',
    description:
      'Specifies the format of the commodities settlement start and end times.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoStreamCommoditySettlPeriods',
    id: 41289,
    description: 'Number of commodity settlement periods in the repeating group.',
  },
  {
    type: 'Country',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommoditySettlCountry',
    id: 41290,
    abbrName: 'Ctry',
    description:
      'Specifies the country where delivery takes place. Uses ISO 3166 2-character country code.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommoditySettlTimeZone',
    id: 41291,
    abbrName: 'TZ',
    description:
      'Commodity delivery timezone specified as "prevailing" rather than "standard" or "daylight".\n\nSee http://www.fixtradingcommunity.org/codelists#Prevailing_Timezones for code list of applicable prevailing timezones.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'DeliveryScheduleSettlFlowTypeCodeSet',
    addedEP: '169',
    updatedEP: '179',
    added: 'FIX.5.0SP2',
    name: 'StreamCommoditySettlFlowType',
    id: 41292,
    abbrName: 'FlowTyp',
    description: 'Specifies the commodity delivery flow type.',
  },
  {
    type: 'Qty',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommoditySettlPeriodNotional',
    id: 41293,
    abbrName: 'Notl',
    description:
      'Specifies the delivery quantity associated with this settlement period.',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommoditySettlPeriodNotionalUnitOfMeasure',
    id: 41294,
    abbrName: 'NotlUOM',
    description:
      'Specifies the unit of measure (UOM) of the delivery quantity associated with this settlement period.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommoditySettlPeriodFrequencyPeriod',
    id: 41295,
    abbrName: 'FreqPeriod',
    description: 'Time unit multiplier for the settlement period frequency.',
  },
  {
    type: 'ProtectionTermEventUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommoditySettlPeriodFrequencyUnit',
    id: 41296,
    abbrName: 'FreqUnit',
    description: 'Time unit associated with the settlement period frequency.',
  },
  {
    type: 'Price',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommoditySettlPeriodPrice',
    id: 41297,
    abbrName: 'Px',
    description: 'The settlement period price.',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommoditySettlPeriodPriceUnitOfMeasure',
    id: 41298,
    abbrName: 'PxUOM',
    description: 'Specifies the settlement period price unit of measure (UOM).',
  },
  {
    type: 'Currency',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommoditySettlPeriodPriceCurrency',
    id: 41299,
    abbrName: 'PxCcy',
    description:
      'The currency of the settlement period price. Uses ISO 4217 currency codes.',
  },
  {
    type: 'DeliveryScheduleSettlHolidaysProcessingInstructionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommoditySettlHolidaysProcessingInstruction',
    id: 41300,
    abbrName: 'Holidays',
    description:
      'Indicates whether holidays are included in the settlement periods. Required for electricity contracts.',
  },
  {
    type: 'XID',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommoditySettlPeriodXID',
    id: 41301,
    abbrName: 'XID',
    description:
      'Identifier of this settlement period for cross referencing elsewhere in the message.',
  },
  {
    type: 'XIDREF',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamCommoditySettlPeriodXIDRef',
    id: 41302,
    abbrName: 'XIDRef',
    description:
      'Cross reference to another settlement period for duplicating its properties.',
  },
  {
    type: 'XID',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamXID',
    id: 41303,
    abbrName: 'XID',
    description:
      'Identifier of this Stream for cross referencing elsewhere in the message.',
  },
  {
    type: 'XIDREF',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamNotionalXIDRef',
    id: 41305,
    abbrName: 'NotlXIDRef',
    description:
      'Cross reference to another Stream notional for duplicating its properties.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamNotionalFrequencyPeriod',
    id: 41306,
    abbrName: 'NotlPeriod',
    description: "Time unit multiplier for the swap stream's notional frequency.",
  },
  {
    type: 'TimeUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamNotionalFrequencyUnit',
    id: 41307,
    abbrName: 'NotlUnit',
    description: "Time unit associated with the swap stream's notional frequency.",
  },
  {
    type: 'StreamNotionalCommodityFrequencyCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamNotionalCommodityFrequency',
    id: 41308,
    abbrName: 'NotlFreq',
    description: "The commodity's notional or quantity delivery frequency.",
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamNotionalUnitOfMeasure',
    id: 41309,
    abbrName: 'NotlUOM',
    description: 'Specifies the delivery stream quantity unit of measure (UOM).',
  },
  {
    type: 'Qty',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamTotalNotional',
    id: 41310,
    abbrName: 'TotNotl',
    description: 'Total notional or delivery quantity over the term of the contract.',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'StreamTotalNotionalUnitOfMeasure',
    id: 41311,
    abbrName: 'TotNotlUOM',
    description:
      'Specifies the unit of measure (UOM) for the total notional or delivery quantity over the term of the contract.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoMandatoryClearingJurisdictions',
    id: 41312,
    description: 'Number of mandatory clearing jurisdictions.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'MandatoryClearingJurisdiction',
    id: 41313,
    abbrName: 'Jrsdctn',
    description:
      'Identifier of the regulatory jurisdiction requiring the trade to be cleared.',
  },
  {
    type: 'Qty',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LastQtyChanged',
    id: 2301,
    abbrName: 'QtyChngd',
    description:
      'The positive or negative change in quantity when this report is a trade correction or continuation.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'TradeVersion',
    id: 2302,
    abbrName: 'TrdVer',
    description:
      'Specifies the version of a trade or contract. This is used by systems or trading platforms in conjunction with TradeID(1003) to uniquely identify the version of a trade or contract. If used the conditions for a change of version are subject to bilateral agreement. It is recommended to change the version only for significant updates to the business entity rather than for minor changes to trade details or systematic distribution of reports. Examples where the version would change are trade quantity modification, customer account assignment or trade novation.',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'HistoricalReportIndicator',
    id: 2303,
    abbrName: 'HistrclRpt',
    description:
      'Indicates that the trade or event being reported occurred in the past and the trade is terminated or no longer active.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegAdditionalTermBondRefs',
    id: 41316,
    description: 'Number of bonds in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegAdditionalTermBondSecurityID',
    id: 41317,
    abbrName: 'ID',
    discriminatorId: '41318',
    description: 'Security identifier of the bond.',
  },
  {
    type: 'SecurityIDSourceCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegAdditionalTermBondSecurityIDSource',
    id: 41318,
    abbrName: 'Src',
    description:
      'Identifies the source scheme of the LegAdditionalTermBondSecurityID(41317) value.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegAdditionalTermBondDesc',
    id: 41319,
    abbrName: 'Desc',
    description: 'Description of the bond.',
  },
  {
    type: 'Length',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'EncodedLegAdditionalTermBondDescLen',
    id: 41320,
    abbrName: 'EncDescLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedLegAdditionalTermBondDesc(41321) field.',
  },
  {
    type: 'data',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'EncodedLegAdditionalTermBondDesc',
    id: 41321,
    abbrName: 'EncDesc',
    lengthId: '41320',
    description:
      'Encoded (non-ASCII characters) representation of the LegAdditionalTermBondDesc(41319) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the LegAdditionalTermBondDesc(41319) field.',
  },
  {
    type: 'Currency',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegAdditionalTermBondCurrency',
    id: 41322,
    abbrName: 'Ccy',
    description:
      'Specifies the currency the bond value is denominated in. Uses ISO 4217 currency codes.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegAdditionalTermBondIssuer',
    id: 41323,
    abbrName: 'Issr',
    description: 'Issuer of the bond.',
  },
  {
    type: 'Length',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'EncodedLegAdditionalTermBondIssuerLen',
    id: 41324,
    abbrName: 'EncIssrLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedLegAdditionalTermBondIssuer(41325) field.',
  },
  {
    type: 'data',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'EncodedLegAdditionalTermBondIssuer',
    id: 41325,
    abbrName: 'EncIssr',
    lengthId: '41324',
    description:
      'Encoded (non-ASCII characters) representation of the LegAdditionalTermBondIssuer(41323) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the LegAdditionalTermBondIssuer(41323) field.',
  },
  {
    type: 'SeniorityCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegAdditionalTermBondSeniority',
    id: 41326,
    abbrName: 'Snrty',
    description: "Specifies the bond's payment priority in the event of a default.",
  },
  {
    type: 'CouponTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegAdditionalTermBondCouponType',
    id: 41327,
    abbrName: 'CpnTyp',
    description: 'Specifies the coupon type of the bond.',
  },
  {
    type: 'Percentage',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegAdditionalTermBondCouponRate',
    id: 41328,
    abbrName: 'CpnRt',
    description: 'Coupon rate of the bond. See also CouponRate(223).',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegAdditionalTermBondMaturityDate',
    id: 41329,
    abbrName: 'MatDt',
    description: 'The maturity date of the bond.',
  },
  {
    type: 'Amt',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegAdditionalTermBondParValue',
    id: 41330,
    abbrName: 'Par',
    description: 'The par value of the bond.',
  },
  {
    type: 'Amt',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegAdditionalTermBondCurrentTotalIssuedAmount',
    id: 41331,
    abbrName: 'CurTotAmt',
    description: 'Total issued amount of the bond.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegAdditionalTermBondCouponFrequencyPeriod',
    id: 41332,
    abbrName: 'CpnPeriod',
    description: "Time unit multiplier for the frequency of the bond's coupon payment.",
  },
  {
    type: 'CouponFrequencyUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegAdditionalTermBondCouponFrequencyUnit',
    id: 41333,
    abbrName: 'CpnUnit',
    description: "Time unit associated with the frequency of the bond's coupon payment.",
  },
  {
    type: 'CouponDayCountCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegAdditionalTermBondDayCount',
    id: 41334,
    abbrName: 'DayCnt',
    description:
      'The day count convention used in interest calculations for a bond or an interest bearing security.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegAdditionalTerms',
    id: 41335,
    description: 'Number of additional terms in the repeating group.',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegAdditionalTermConditionPrecedentBondIndicator',
    id: 41336,
    abbrName: 'PrcdntInd',
    description:
      'Indicates whether the condition precedent bond is applicable. The swap contract is only valid if the bond is issued and if there is any dispute over the terms of fixed stream then the bond terms would be used.',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegAdditionalTermDiscrepancyClauseIndicator',
    id: 41337,
    abbrName: 'DscrpncyInd',
    description: 'Indicates whether the discrepancy clause is applicable.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegAssetAttributes',
    id: 2308,
    description: 'Number of asset attribute entries in the group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegAssetAttributeType',
    id: 2309,
    abbrName: 'Typ',
    description:
      'Specifies the name of the attribute.\n\nSee http://www.fixtradingcommunity.org/codelists#Asset_Attribute_Types for code list of applicable asset attribute types.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegAssetAttributeValue',
    id: 2310,
    abbrName: 'Val',
    description: 'Specifies the value of the attribute.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegAssetAttributeLimit',
    id: 2311,
    abbrName: 'Lmt',
    description: 'Limit or lower acceptable value of the attribute.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegCashSettlDealers',
    id: 41342,
    description: 'Number of dealers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegCashSettlDealer',
    id: 41343,
    abbrName: 'Dlr',
    description:
      'Identifies the dealer from whom price quotations for the reference obligation are obtained for the purpose of cash settlement valuation calculation.\n\nISDA 2003 Term: Dealer',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegCashSettlTerms',
    id: 41344,
    description: 'Number of elements in the repeating group.',
  },
  {
    type: 'Currency',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegCashSettlCurrency',
    id: 41345,
    abbrName: 'Ccy',
    description:
      'Specifies the currency the LegCashSettlAmount(41357) is denominated in. Uses ISO 4217 currency codes.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegCasSettlValuationFirstBusinessDayOffset',
    id: 41346,
    abbrName: 'BizDayOfst',
    description:
      'The number of business days after settlement conditions have been satisfied, when the calculation agent is to obtain a price quotation on the reference obligation for purposes of cash settlement.\n\nAssociated with ISDA 2003 Term: Valuation Date.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegCashSettlValuationSubsequentBusinessDaysOffset',
    id: 41347,
    abbrName: 'SbsqntBizDayOfst',
    description:
      'The number of business days between successive valuation dates when multiple valuation dates are applicable for cash settlement.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegCashSettlNumOfValuationDates',
    id: 41348,
    abbrName: 'NumValDts',
    description:
      'Where multiple valuation dates are specified as being applicable for cash settlement, this element specifies the number of applicable valuation dates.\n\nAssociated with ISDA 2003 Term: Valuation Date',
  },
  {
    type: 'LocalMktTime',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegCashSettlValuationTime',
    id: 41349,
    abbrName: 'ValTm',
    description: 'Time of valuation.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegCashSettlBusinessCenter',
    id: 41350,
    abbrName: 'BizCtr',
    description:
      'Identifies the business center calendar used at valuation time for cash settlement purposes e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'CashSettlQuoteMethodCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegCashSettlQuoteMethod',
    id: 41351,
    abbrName: 'QteMeth',
    description: 'The type of quote used to determine the cash settlement price.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Amt',
    addedEP: '169',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'LegCashSettlQuoteAmount',
    id: 41352,
    abbrName: 'QteAmt',
    description:
      'When determining the cash settlement amount, if weighted average price quotes are to be obtained for the reference obligation, this is the upper limit to the outstanding principal balance of the reference obligation for which the quote should be obtained. If not specified, the ISDA definitions provide for a fallback amount equal to floating rate payer calculation amount.\n\nISDA 2003 Term: Quotation Amount.',
  },
  {
    type: 'Currency',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegCashSettlQuoteCurrency',
    id: 41353,
    abbrName: 'QteCcy',
    description:
      'Specifies the currency the LegCashSettlQuoteAmount(41352) is denominated in. Uses ISO 4217 Currency Code.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Amt',
    addedEP: '169',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'LegCashSettlMinimumQuoteAmount',
    id: 41354,
    abbrName: 'MinQteAmt',
    description:
      'When determining the cash settlement amount, if weighted average price quotes are to be obtained for the reference obligation, this is the minimum intended threshold amount of outstanding principal balance of the reference obligation for which the quote should be obtained. If not specified, the ISDA definitions provide for a fallback amount of the lower of either USD1,000,000 (or its equivalent in the relevant obligation currency) or the (minimum) quoted amount.\n\nISDA 2003 Term: Minimum Quotation Amount.',
  },
  {
    type: 'Currency',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegCashSettlMinimumQuoteCurrency',
    id: 41355,
    abbrName: 'MinQteCcy',
    description:
      'Specifies the currency the LegCashSettlQuoteMinimumAmount(41354) is denominated in. Uses ISO 4217 Currency Code.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegCashSettlBusinessDays',
    id: 41356,
    abbrName: 'BizDays',
    description:
      'The number of business days used in the determination of the cash settlement payment date.\n\nIf a cash settlement amount is specified, the cash settlement payment date will be this number of business days following the calculation of the final price. If a cash settlement amount is not specified, the cash settlement payment date will be this number of business days after all conditions to settlement are satisfied. ISDA 2003 Term: Cash Settlement Date.',
  },
  {
    type: 'Amt',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegCashSettlAmount',
    id: 41357,
    abbrName: 'Amt',
    description:
      'The amount paid between the trade parties, seller to the buyer, for cash settlement on the cash settlement date.\n\nIf not specified this would typically be calculated as ((100 or the reference price) - reference obligation price) x floating rate payer calculation amount. Price values are all expressed as a percentage. ISDA 2003 Term: Cash Settlement Amount.',
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegCashSettlRecoveryFactor',
    id: 41358,
    abbrName: 'RcvryFctr',
    description:
      'Used for fixed recovery, this specifies the recovery level as determined at contract inception, to be applied in the event of a default. The factor is used to calculate the amount paid by the seller to the buyer for cash settlement on the cash settlement date. The amount calculated is (1 - LegCashSettlRecoveryFactor(41358)) x floating rate payer calculation amount. The currency is derived from the floating rate payer calculation amount.',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegCashSettlFixedTermIndicator',
    id: 41359,
    abbrName: 'FixedInd',
    description:
      'Indicates whether fixed settlement is applicable or not applicable in a recovery lock.',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegCashSettlAccruedInterestIndicator',
    id: 41360,
    abbrName: 'AcrdIntInd',
    description:
      'Indicates whether accrued interest is included or not in the value provided in LegCashSettlAmount(41357).\n\nFor cash settlement this specifies whether quotations should be obtained inclusive or not of accrued interest.\n\nFor physical settlement this specifies whether the buyer should deliver the obligation with an outstanding principal balance that includes or excludes accrued interest.\n\nISDA 2003 Term: Include/Exclude Accrued Interest.',
  },
  {
    type: 'CashSettlValuationMethodCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegCashSettlValuationMethod',
    id: 41361,
    abbrName: 'ValMeth',
    description:
      'The ISDA defined methodology for determining the final price of the reference obligation for purposes of cash settlement.\n\nISDA 2003 Term: Valuation Method.',
  },
  {
    type: 'XID',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegCashSettlTermXID',
    id: 41362,
    abbrName: 'XID',
    description: 'A named string value referenced by UnderlyingSettlTermXIDRef(41315).',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegComplexEventAveragingObservations',
    id: 41363,
    description: 'The number of averaging observations in the repeating group.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventAveragingObservationNumber',
    id: 41364,
    abbrName: 'ObsvtnNum',
    description:
      'Cross reference to the ordinal observation as specified either in the LegComplexEventScheduleGrp or LegComplexEventPeriodDateGrp components.',
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventAveragingWeight',
    id: 41365,
    abbrName: 'Wt',
    description: 'The weight factor to be applied to the observation.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegComplexEventCreditEvents',
    id: 41366,
    description: 'The number of credit events specified in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventCreditEventType',
    id: 41367,
    abbrName: 'Typ',
    description:
      'Specifies the type of credit event.\n\nSee http://www.fixtradingcommunity.org/codelists#Credit_Event_Types for code list of applicable event types.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventCreditEventValue',
    id: 41368,
    abbrName: 'Val',
    description:
      'The credit event value appropriate to LegComplexEventCreditEventType(41367).\n\nSee http://www.fixtradingcommunity.org/codelists#Credit_Event_Types for applicable event type values.',
  },
  {
    type: 'Currency',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventCreditEventCurrency',
    id: 41369,
    abbrName: 'Ccy',
    description:
      'Specifies the applicable currency when LegComplexEventCreditEventCurrency(41368) is an amount. Uses ISO 4217 currency codes.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventCreditEventPeriod',
    id: 41370,
    abbrName: 'Period',
    description: 'Time unit multiplier for complex credit events.',
  },
  {
    type: 'ProtectionTermEventUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventCreditEventUnit',
    id: 41371,
    abbrName: 'Unit',
    description: 'Time unit associated with complex credit events.',
  },
  {
    type: 'ComplexEventDateOffsetDayTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventCreditEventDayType',
    id: 41372,
    abbrName: 'DayTyp',
    description: 'Specifies the day type for the complex credit events.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventCreditEventRateSource',
    id: 41373,
    abbrName: 'RtSrc',
    description:
      'Identifies the source of rate information used for credit events.\n\nSee http://www.fixtradingcommunity.org/codelists#Credit_Event_Rate_Source for code list of applicable sources.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegComplexEventCreditEventQualifiers',
    id: 41374,
    description: 'Number of qualifiers in the repeating group.',
  },
  {
    type: 'ProtectionTermEventQualifierCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventCreditEventQualifier',
    id: 41375,
    abbrName: 'Qual',
    description:
      'Specifies a complex event qualifier. Used to further qualify LegComplexEventCreditEventType(41367).',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegComplexEventPeriodDateTimes',
    id: 41376,
    description: 'Number of entries in the date-time repeating group.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventPeriodDate',
    id: 41377,
    abbrName: 'Dt',
    description:
      'Averaging date for an Asian option.\n\nTrigger date for a Barrier or Knock option.',
  },
  {
    type: 'LocalMktTime',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventPeriodTime',
    id: 41378,
    abbrName: 'Tm',
    description: 'Averaging time for an Asian option.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegComplexEventPeriods',
    id: 41379,
    description: 'Number of periods in the repeating group.',
  },
  {
    type: 'ComplexEventPeriodTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventPeriodType',
    id: 41380,
    abbrName: 'Typ',
    description: 'Specifies the period type.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventBusinessCenter',
    id: 41381,
    abbrName: 'BizCtr',
    description:
      'The business center for adjusting dates and times in the schedule or date-time group.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegComplexEventRateSources',
    id: 41382,
    description: 'Number of rate sources in the repeating group.',
  },
  {
    type: 'RateSourceCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventRateSource',
    id: 41383,
    abbrName: 'RtSrc',
    description:
      'Identifies the source of rate information.\n\nFor FX, the reference source to be used for the FX spot rate.',
  },
  {
    type: 'RateSourceTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventRateSourceType',
    id: 41384,
    abbrName: 'RtSrcTyp',
    description:
      'Indicates whether the rate source specified is a primary or secondary source.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventReferencePage',
    id: 41385,
    abbrName: 'RefPg',
    description:
      'Identifies the reference page from the rate source.\n\nFor FX, the reference page to the spot rate is to be used for the reference FX spot rate.\n\nWhen LegComplexEventRateSource(41383) = 3 (ISDA Settlement Rate Option) this contains the value from the scheme that reflects the terms of the Annex A to the ISDA 1998 FX and Currency Option Definitions. See: http://www.fpml.org/coding-scheme/settlement-rate-option.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEvenReferencePageHeading',
    id: 41386,
    abbrName: 'RefHdng',
    description: 'Identifies the reference page heading from the rate source.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegComplexEventDateBusinessCenters',
    id: 41387,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventDateBusinessCenter',
    id: 41388,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the event date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventDateUnadjusted',
    id: 41389,
    abbrName: 'DtUnadj',
    description:
      'The unadjusted complex event date.\n\nFor example the second expiration date for a calendar spread option strategy.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '169',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventDateRelativeTo',
    id: 41390,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the complex event date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventDateOffsetPeriod',
    id: 41391,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventDateOffsetUnit',
    id: 41392,
    abbrName: 'OfstUnit',
    description: 'Time unit associated with the relative date offset.',
  },
  {
    type: 'ComplexEventDateOffsetDayTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventDateOffsetDayType',
    id: 41393,
    abbrName: 'OfstDayTyp',
    description: 'Specifies the day type of the relative date offset.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventDateBusinessDayConvention',
    id: 41394,
    abbrName: 'BizDayCnvtn',
    description:
      'The business day convention used to adjust the event date. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventDateAdjusted',
    id: 41395,
    abbrName: 'Dt',
    description: 'The adjusted complex event date.',
  },
  {
    type: 'LocalMktTime',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventFixingTime',
    id: 41396,
    abbrName: 'FixngTm',
    description: 'The local market fixing time.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventFixingTimeBusinessCenter',
    id: 41397,
    abbrName: 'FixngBizCtr',
    description:
      'The business center for determining the actual fixing times.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegComplexEventCreditEventSources',
    id: 41398,
    description: 'Number of event sources in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventCreditEventSource',
    id: 41399,
    abbrName: 'Src',
    description:
      'A newspaper or electronic news service that may publish relevant information used in the determination of whether or not a credit event has occurred.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegComplexEvents',
    id: 2218,
    description: 'Number of complex events in the repeating group.',
  },
  {
    type: 'ComplexEventTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventType',
    id: 2219,
    abbrName: 'Typ',
    description: 'Identifies the type of complex event.',
  },
  {
    type: 'PaymentPaySideCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexOptPayoutPaySide',
    id: 2220,
    abbrName: 'OptPay',
    description: 'Trade side of payout payer.',
  },
  {
    type: 'PaymentPaySideCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexOptPayoutReceiveSide',
    id: 2221,
    abbrName: 'OptRcv',
    description: 'Trade side of payout receiver.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexOptPayoutUnderlier',
    id: 2222,
    abbrName: 'OptUndlr',
    description: 'Reference to the underlier whose payments are being passed through.',
  },
  {
    type: 'Amt',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexOptPayoutAmount',
    id: 2223,
    abbrName: 'OptPayAmt',
    description:
      'Cash amount indicating the pay out associated with an event. For binary options this is a fixed amount.',
  },
  {
    type: 'Percentage',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexOptPayoutPercentage',
    id: 2224,
    abbrName: 'OptPctage',
    description:
      'Percentage of observed price for calculating the payout associated with the event.',
  },
  {
    type: 'ComplexOptPayoutTimeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexOptPayoutTime',
    id: 2225,
    abbrName: 'OptTm',
    description: 'Specifies when the payout is to occur.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Currency',
    addedEP: '169',
    updatedEP: '273',
    added: 'FIX.5.0SP2',
    name: 'LegComplexOptPayoutCurrency',
    id: 2226,
    abbrName: 'OptCcy',
    description:
      'Specifies the currency of the payout amount.\n\nLegComplexOptPayoutCurrencyCodeSource(2944) may be used to disambiguate the code source scheme used, and ISO 4217 is the default scheme if absent.',
  },
  {
    type: 'Price',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventPrice',
    id: 2227,
    abbrName: 'Px',
    description:
      'Specifies the price at which the complex event takes effect. Impact of the event price is determined by the LegComplexEventType(2219).',
  },
  {
    type: 'Percentage',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventPricePercentage',
    id: 2228,
    abbrName: 'PxPctage',
    description:
      'Specifies the price percentage at which the complex event takes effect. Impact of the event price is determined by the LegComplexEventType(2219).',
  },
  {
    type: 'ComplexEventPriceBoundaryMethodCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventPriceBoundaryMethod',
    id: 2229,
    abbrName: 'PxBndryMeth',
    description:
      'Specifies the boundary condition to be used for the event price relative to the complex event price at the point the complex event outcome takes effect as determined by the LegComplexEventPriceTimeType(2231).',
  },
  {
    type: 'Percentage',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventPriceBoundaryPrecision',
    id: 2230,
    abbrName: 'PxBndryPrcsn',
    description:
      'Used in combination with LegComplexEventPriceBoundaryMethod(2229) to specify the percentage of the strike price in relation to the underlying price. The percentage is generally 100 or greater for puts and 100 or less for calls.',
  },
  {
    type: 'ComplexEventPriceTimeTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventPriceTimeType',
    id: 2231,
    abbrName: 'PxTmTyp',
    description:
      'Specifies when the complex event outcome takes effect. The outcome of a complex event is a payout or barrier action as specified by the LegComplexEventType(2219).',
  },
  {
    type: 'ComplexEventConditionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventCondition',
    id: 2232,
    abbrName: 'Cond',
    description:
      'Specifies the condition between complex events when more than one event is specified.\n\nMultiple barrier events would use an "or" condition since only one can be effective at a given time. A set of digital range events would use an "and" condition since both conditions must be in effect for a payout to result.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Currency',
    addedEP: '169',
    updatedEP: '273',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventCurrencyOne',
    id: 2233,
    abbrName: 'Ccy1',
    description:
      'Specifies the first or only reference currency of the trade.\n\nLegComplexEventCurrencyOneCodeSource(2945) may be used to disambiguate the code source scheme used, and ISO 4217 is the default scheme if absent.\n\nApplicable for complex FX option strategies.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Currency',
    addedEP: '169',
    updatedEP: '273',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventCurrencyTwo',
    id: 2234,
    abbrName: 'Ccy2',
    description:
      'Specifies the second reference currency of the trade.\n\nLegComplexEventCurrencyTwoCodeSource(2946) may be used to disambiguate the code source scheme used, and ISO 4217 is the default scheme if absent.\n\nApplicable for complex FX option strategies.',
  },
  {
    type: 'ComplexEventQuoteBasisCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventQuoteBasis',
    id: 2235,
    abbrName: 'QteBasis',
    description: 'For foreign exchange Quanto option feature.',
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventFixedFXRate',
    id: 2236,
    abbrName: 'Rt',
    description: 'Specifies the fixed FX rate alternative for FX Quantro options.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventDeterminationMethod',
    id: 2237,
    abbrName: 'Meth',
    description:
      'Specifies the method according to which an amount or a date is determined.\n\nSee http://www.fpml.org/coding-scheme/determination-method for values.',
  },
  {
    type: 'ProvisionCalculationAgentCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventCalculationAgent',
    id: 2238,
    abbrName: 'CalcAgent',
    description: 'Used to identify the calculation agent.',
  },
  {
    type: 'Price',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventStrikePrice',
    id: 2239,
    abbrName: 'StrkPx',
    description:
      'Upper strike price for Asian option feature. Strike percentage for a Strike Spread.',
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventStrikeFactor',
    id: 2240,
    abbrName: 'StrkFctr',
    description:
      'Strike factor for Asian option feature. Upper strike percentage for a Strike Spread.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventStrikeNumberOfOptions',
    id: 2241,
    abbrName: 'StrkNum',
    description: 'Upper string number of options for a Strike Spread.',
  },
  {
    type: 'XIDREF',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventCreditEventsXIDRef',
    id: 2242,
    abbrName: 'CdtEvntXIDRef',
    description: 'Reference to credit event table elsewhere in the message.',
  },
  {
    type: 'ComplexEventCreditEventNotifyingPartyCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventCreditEventNotifyingParty',
    id: 2243,
    abbrName: 'NotifygPty',
    description:
      'The notifying party is the party that notifies the other party when a credit event has occurred by means of a credit event notice. If more than one party is referenced as being the notifying party then either party may notify the other of a credit event occurring.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventCreditEventBusinessCenter',
    id: 2244,
    abbrName: 'BizCtr',
    description:
      'Specifies the local business center for which the credit event is to be determined. The inclusion of this business center implies that Greenwich Mean Time in Section 3.3 of the 2003 ISDA Credit Derivatives Definitions is replaced by the local time of the specified business center.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventCreditEventStandardSources',
    id: 2245,
    abbrName: 'StdSrcs',
    description:
      "When this element is specified and set to 'Y', indicates that ISDA defined Standard Public Sources are applicable.",
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventCreditEventMinimumSources',
    id: 2246,
    abbrName: 'MinSrcs',
    description:
      'The minimum number of the specified public information sources that must publish information that reasonably confirms that a credit event has occurred. The market convention is two.\n\nISDA 2003 Term: Specified Number.',
  },
  {
    type: 'XID',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventXID',
    id: 2248,
    abbrName: 'XID',
    description:
      'Identifier of this complex event for cross referencing elsewhere in the message.',
  },
  {
    type: 'XIDREF',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventXIDRef',
    id: 2249,
    abbrName: 'XIDRef',
    description: 'Reference to a complex event elsewhere in the message.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegComplexEventDates',
    id: 2250,
    description: 'Number of complex event dates in the repeating group.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'UTCDateOnly',
    addedEP: '169',
    updatedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventStartDate',
    id: 2251,
    abbrName: 'StartDt',
    description:
      'The start date of the date range on which a complex event is effective. The start date will be set equal to the end date for single day events such as Bermuda options.\n\nThe start date must always be less than or equal to end date.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'UTCDateOnly',
    addedEP: '169',
    updatedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventEndDate',
    id: 2252,
    abbrName: 'EndDt',
    description:
      'The end date of the date range on which a complex event is effective. The start date will be set equal to the end date for single day events such as Bermuda options.\n\nThe end date must always be greater than or equal to start date.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegComplexEventTimes',
    id: 2253,
    description: 'Number of complex event times in the repeating group.',
  },
  {
    type: 'UTCTimeOnly',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventStartTime',
    id: 2204,
    abbrName: 'StartTm',
    description:
      'The start time of the time range on which a complex event date is effective.\n\nThe start time must always be less than or equal to the end time.',
  },
  {
    type: 'UTCTimeOnly',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventEndTime',
    id: 2247,
    abbrName: 'EndTm',
    description:
      'The end time of the time range on which a complex event date is effective.\n\nThe end time must always be greater than or equal to the start time.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegComplexEventSchedules',
    id: 41400,
    description: 'Number of schedules in the repeating group.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventScheduleStartDate',
    id: 41401,
    abbrName: 'StartDt',
    description: 'The start date of the schedule.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventScheduleEndDate',
    id: 41402,
    abbrName: 'EndDt',
    description: 'The end date of the schedule.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventScheduleFrequencyPeriod',
    id: 41403,
    abbrName: 'FreqPeriod',
    description: 'Time unit multiplier for the schedule date frequency.',
  },
  {
    type: 'ProtectionTermEventUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventScheduleFrequencyUnit',
    id: 41404,
    abbrName: 'FreqUnit',
    description: 'Time unit associated with the schedule date frequency.',
  },
  {
    type: 'DateRollConventionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventScheduleRollConvention',
    id: 41405,
    abbrName: 'Roll',
    description:
      'The convention for determining the sequence of dates. It is used in conjunction with a specified frequency. Used only to override the roll convention defined in the LegDateAdjustment component in InstrumentLeg.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegDeliverySchedules',
    id: 41408,
    description: 'Number of delivery schedules in the repeating group.',
  },
  {
    type: 'DeliveryScheduleTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryScheduleType',
    id: 41409,
    abbrName: 'Typ',
    description: 'Specifies the type of delivery schedule.',
  },
  {
    type: 'XID',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryScheduleXID',
    id: 41410,
    abbrName: 'XID',
    description:
      'Identifier for this instance of delivery schedule for cross referencing elsewhere in the message.',
  },
  {
    type: 'Qty',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryScheduleNotional',
    id: 41411,
    abbrName: 'Notl',
    description: 'Physical delivery quantity.',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryScheduleNotionalUnitOfMeasure',
    id: 41412,
    abbrName: 'NotlUOM',
    description: 'Specifies the delivery quantity unit of measure (UOM).',
  },
  {
    type: 'StreamNotionalCommodityFrequencyCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryScheduleNotionalCommodityFrequency',
    id: 41413,
    abbrName: 'NotlFreq',
    description: 'The frequency of notional delivery.',
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryScheduleNegativeTolerance',
    id: 41414,
    abbrName: 'NegtvTlrnc',
    description:
      'Specifies the negative tolerance value. The value may be an absolute quantity or a percentage, as specified in LegDeliveryScheduleToleranceType(41417). Percentage value is to be expressed relative to "1.0" representing 100% (e.g. a value of "0.0575" represents 5.75%).',
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliverySchedulePositiveTolerance',
    id: 41415,
    abbrName: 'PostvTlrnc',
    description:
      'Specifies the positive tolerance value. The value may be an absolute quantity or a percentage, as specified in LegDeliveryScheduleToleranceType(41417). Value may exceed agreed upon value. Percentage value is to be expressed relative to "1.0" representing 100% (e.g. a value of "0.0575" represents 5.75%).',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryScheduleToleranceUnitOfMeasure',
    id: 41416,
    abbrName: 'TlrncUOM',
    description: "Specifies the tolerance value's unit of measure (UOM).",
  },
  {
    type: 'DeliveryScheduleToleranceTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryScheduleToleranceType',
    id: 41417,
    abbrName: 'TlrncTyp',
    description: 'Specifies the tolerance value type.',
  },
  {
    type: 'Country',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryScheduleSettlCountry',
    id: 41418,
    abbrName: 'Ctry',
    description:
      'Specifies the country where delivery takes place. Uses ISO 3166 2-character country code.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryScheduleSettlTimeZone',
    id: 41419,
    abbrName: 'TZ',
    description:
      'Delivery timezone specified as "prevailing" rather than "standard" or "daylight".\n\nSee http://www.fixtradingcommunity.org/codelists#Prevailing_Timezones for code list of applicable prevailing timezones.',
  },
  {
    type: 'DeliveryScheduleSettlFlowTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryScheduleSettlFlowType',
    id: 41420,
    abbrName: 'FlowTyp',
    description: 'Specifies the delivery flow type.',
  },
  {
    type: 'DeliveryScheduleSettlHolidaysProcessingInstructionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryScheduleSettlHolidaysProcessingInstruction',
    id: 41421,
    abbrName: 'Holidays',
    description:
      'Indicates whether holidays are included in the settlement periods. Required for electricity contracts.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegDeliveryScheduleSettlDays',
    id: 41422,
    description: 'Number of delivery schedules in the repeating group.',
  },
  {
    type: 'DeliveryScheduleSettlDayCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryScheduleSettlDay',
    id: 41423,
    abbrName: 'Day',
    description: 'Specifies the day or group of days for delivery.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryScheduleSettlTotalHours',
    id: 41424,
    abbrName: 'TotHrs',
    description:
      'The sum of the total hours specified in the LegDeliveryScheduleSettlTimeGrp component.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegDeliveryScheduleSettlTimes',
    id: 41425,
    description: 'Number of hour ranges in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryScheduleSettlStart',
    id: 41426,
    abbrName: 'Start',
    description:
      'The scheduled start time for the delivery of the commodity where delivery occurs over specified times. The format of the time value is specified in LegDeliveryScheduleSettlTimeType(41428).',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryScheduleSettlEnd',
    id: 41427,
    abbrName: 'End',
    description:
      'The scheduled end time for the delivery of the commodity where delivery occurs over specified times. The format of the time value is specified in LegDeliveryScheduleSettlTimeType(41428).',
  },
  {
    type: 'DeliveryScheduleSettlTimeTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryScheduleSettlTimeType',
    id: 41428,
    abbrName: 'Typ',
    description: 'Specifies the format of the delivery start and end time values.',
  },
  {
    type: 'DeliveryStreamTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryStreamType',
    id: 41429,
    abbrName: 'Typ',
    description: 'Specifies the type of delivery stream.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryStreamPipeline',
    id: 41430,
    abbrName: 'Ppln',
    description: 'The name of the oil delivery pipeline.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryStreamEntryPoint',
    id: 41431,
    abbrName: 'EntryPnt',
    description:
      'The point at which the commodity will enter the delivery mechanism or pipeline.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryStreamWithdrawalPoint',
    id: 41432,
    abbrName: 'WthdrwlPnt',
    description:
      'The point at which the commodity product will be withdrawn prior to delivery.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryStreamDeliveryPoint',
    id: 41433,
    abbrName: 'DlvryPnt',
    discriminatorId: '42194',
    description:
      'The point at which the commodity product will be delivered and received. Value specified should follow market convention appropriate for the commodity product.\n\nFor bullion, see http://www.fpml.org/coding-scheme/bullion-delivery-location for values.',
  },
  {
    type: 'DeliveryStreamDeliveryRestrictionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryStreamDeliveryRestriction',
    id: 41434,
    abbrName: 'DlvryRstctn',
    description:
      'Specifies under what conditions the buyer and seller should be excused of their delivery obligations.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryStreamDeliveryContingency',
    id: 41435,
    abbrName: 'Cntgncy',
    description:
      'Specifies the electricity delivery contingency. See\n\nhttp://www.fpml.org/coding-scheme/electricity-transmission-contingency for values.',
  },
  {
    type: 'DeliveryStreamElectingPartySideCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryStreamDeliveryContingentPartySide',
    id: 41436,
    abbrName: 'CntgPty',
    description:
      'The trade side value of the party responsible for electricity delivery contingency.',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryStreamDeliverAtSourceIndicator',
    id: 41437,
    abbrName: 'DlvrAtSrc',
    description:
      "When this element is specified and set to 'Y', delivery of the coal product is to be at its source.",
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryStreamRiskApportionment',
    id: 41438,
    abbrName: 'RiskApprtnmt',
    discriminatorId: '41219',
    description:
      'Specifies how the parties to the trade apportion responsibility for the delivery of the commodity product.\n\nSee http://www.fixtradingcommunity.org/codelists#Risk_Apportionment for the details of the external code list.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryStreamRiskApportionmentSource',
    id: 41219,
    abbrName: 'RiskApprtnmtSrc',
    description:
      'Specifies the source or legal framework for the risk apportionment.\n\nSee http://www.fixtradingcommunity.org/codelists#Risk_Apportionment_Source for the details of the external code list.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryStreamTitleTransferLocation',
    id: 41439,
    abbrName: 'TtlXfer',
    description: 'Specifies the title transfer location.',
  },
  {
    type: 'DeliveryStreamTitleTransferConditionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryStreamTitleTransferCondition',
    id: 41440,
    abbrName: 'TtlXferCond',
    description: 'Specifies the condition of title transfer.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryStreamImporterOfRecord',
    id: 41441,
    abbrName: 'Imprtr',
    description:
      'A party, not necessarily of the trade, who is the Importer of Record for the purposes of paying customs duties and applicable taxes or costs related to importation.',
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryStreamNegativeTolerance',
    id: 41442,
    abbrName: 'NegtvTlrnc',
    description:
      'Specifies the negative tolerance value. The value may be an absolute quantity or a percentage, as specified in LegDeliveryStreamToleranceType(41445). Percentage value is to be expressed relative to "1.0" representing 100% (e.g. a value of "0.0575" represents 5.75%).',
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryStreamPositiveTolerance',
    id: 41443,
    abbrName: 'PostvTlrnc',
    description:
      'Specifies the positive tolerance value. The value may be an absolute quantity or a percentage, as specified in LegDeliveryStreamToleranceType(41445). Value may exceed agreed upon value. Percentage value is to be expressed relative to "1.0" representing 100% (e.g. a value of "0.0575" represents 5.75%).',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryStreamToleranceUnitOfMeasure',
    id: 41444,
    abbrName: 'TlrncUOM',
    description: "Specifies the tolerance value's unit of measure (UOM).",
  },
  {
    type: 'DeliveryScheduleToleranceTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryStreamToleranceType',
    id: 41445,
    abbrName: 'TlrncTyp',
    description: 'Specifies the tolerance value type.',
  },
  {
    type: 'DeliveryStreamToleranceOptionSideCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryStreamToleranceOptionSide',
    id: 41446,
    abbrName: 'TlrncOptSide',
    description: "Indicates whether the tolerance is at the seller's or buyer's option.",
  },
  {
    type: 'Percentage',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryStreamTotalPositiveTolerance',
    id: 41447,
    abbrName: 'TotPostvTlrnc',
    description:
      'The positive percent tolerance which applies to the total quantity delivered over all shipment periods.\n\nPercentage value is to be expressed relative to "1.0" representing 100% (e.g. a value of "0.0575" represents 5.75%.).',
  },
  {
    type: 'Percentage',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryStreamTotalNegativeTolerance',
    id: 41448,
    abbrName: 'TotNegtvTlrnc',
    description:
      'The negative percent tolerance which applies to the total quantity delivered over all shipment periods.\n\nPercentage value is to be expressed relative to "1.0" representing 100% (e.g. a value of "0.0575" represents 5.75%.).',
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryStreamNotionalConversionFactor',
    id: 41449,
    abbrName: 'CnvrsnFctr',
    description:
      'If the notional quantity is specified in a unit that does not match the unit in which the commodity reference price is quoted, the scaling or conversion factor used to convert the commodity reference price unit into the notional quantity unit should be stated here. If there is no conversion, this field is not intended to be used.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryStreamTransportEquipment',
    id: 41450,
    abbrName: 'Eqpmt',
    description:
      'The transportation equipment with which the commodity product will be delivered and received.\n\nExamples of transportation equipment or mode are barge, truck, railcar, etc.',
  },
  {
    type: 'DeliveryStreamElectingPartySideCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryStreamElectingPartySide',
    id: 41451,
    abbrName: 'ElctngSide',
    description:
      'A reference to the party able to choose whether the gas is delivered for a particular period e.g. a swing or interruptible contract.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegStreamAssetAttributes',
    id: 41452,
    description: 'Number of asset attribute entries in the group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamAssetAttributeType',
    id: 41453,
    abbrName: 'Typ',
    description:
      'Specifies the name of the attribute.\n\nSee http://www.fixtradingcommunity.org/codelists#Asset_Attribute_Types for code list of applicable asset attribute types.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamAssetAttributeValue',
    id: 41454,
    abbrName: 'Val',
    description: 'Specifies the value of the attribute.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamAssetAttributeLimit',
    id: 41455,
    abbrName: 'Lmt',
    description: 'Limit or lower acceptable value of the attribute.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegDeliveryStreamCycles',
    id: 41456,
    description: 'Number of commodity sources in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryStreamCycleDesc',
    id: 41457,
    abbrName: 'Desc',
    description:
      'The delivery cycles during which the oil product will be transported in the pipeline.',
  },
  {
    type: 'Length',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'EncodedLegDeliveryStreamCycleDescLen',
    id: 41458,
    abbrName: 'EncDescLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedLegDeliveryStreamCycleDesc(41459) field.',
  },
  {
    type: 'data',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'EncodedLegDeliveryStreamCycleDesc',
    id: 41459,
    abbrName: 'EncDesc',
    lengthId: '41458',
    description:
      'Encoded (non-ASCII characters) representation of the LegDeliveryStreamCycleDesc(41457) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the LegLeg DeliveryStream(41457) field.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegDeliveryStreamCommoditySources',
    id: 41460,
    description: 'Number of commodity sources in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryStreamCommoditySource',
    id: 41461,
    abbrName: 'Src',
    description:
      'The SCoTA coal cargo origin, mining region, mine(s), mining complex(es), loadout(s) or river dock(s) or other point(s) of origin that seller and buyer agree are acceptable origins for the coal product. For international coal transactions, this is the origin of the coal product.\n\nSee http://www.fpml.org/coding-scheme/commodity-coal-product-source for values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegInstrumentParties',
    id: 2254,
    description: 'Number of parties in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegInstrumentPartyID',
    id: 2255,
    abbrName: 'ID',
    discriminatorId: '2256',
    description: 'Used to identify party id related to instrument.',
  },
  {
    type: 'PartyIDSourceCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegInstrumentPartyIDSource',
    id: 2256,
    abbrName: 'Src',
    description: 'Used to identify source of instrument party id.',
  },
  {
    type: 'PartyRoleCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegInstrumentPartyRole',
    id: 2257,
    abbrName: 'R',
    description: 'Used to identify the role of instrument party id.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegInstrumentPartySubIDs',
    id: 2258,
    description: 'Number of parties sub-IDs in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegInstrumentPartySubID',
    id: 2259,
    abbrName: 'ID',
    description: 'PartySubID value within an instrument party repeating group.',
  },
  {
    type: 'PartySubIDTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegInstrumentPartySubIDType',
    id: 2260,
    abbrName: 'Typ',
    description: 'Type of LegInstrumentPartySubID (2259) value.',
  },
  {
    type: 'MarketDisruptionProvisionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegMarketDisruptionProvision',
    id: 41462,
    abbrName: 'Prov',
    description: 'The consequences of market disruption events.',
  },
  {
    type: 'MarketDisruptionFallbackProvisionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegMarketDisruptionFallbackProvision',
    id: 41463,
    abbrName: 'FallbckProv',
    description: 'Specifies the location of the fallback provision documentation.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegMarketDisruptionMaximumDays',
    id: 41464,
    abbrName: 'MaxDays',
    description:
      'Specifies the maximum number of market disruption days (commodity or bullion business days) in a contract or confirmation. If none are specified, the maximum number of market disruption days is five (5).\n\nISDA 2005 Commodity Definition.',
  },
  {
    type: 'Percentage',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegMarketDisruptionMaterialityPercentage',
    id: 41465,
    abbrName: 'MtrltyPctage',
    description:
      'Used when a price materiality percentage applies to the price source disruption event and this event has been specified.\n\nApplicable to 2005 Commodity Definitions only.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegMarketDisruptionMinimumFuturesContracts',
    id: 41466,
    abbrName: 'MinCtrcts',
    description:
      "Specifies the minimum futures contracts level that dictates whether or not a 'De Minimis Trading' event has occurred.\n\nApplicable to 1993 Commodity Definitions only.",
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegMarketDisruptionEvents',
    id: 41467,
    description: 'Number of disruption events in the repeating group.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    addedEP: '169',
    updatedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'LegMarketDisruptionEvent',
    id: 41468,
    abbrName: 'Evnt',
    description:
      'Specifies the market disruption event.\n\nFor commodities see http://www.fpml.org/coding-scheme/commodity-market-disruption for values.\n\nFor foreign exchange, see http://www.fixtradingcommunity.org/codelists#Market_Disruption_Event for code list of applicable event types.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegMarketDisruptionFallbacks',
    id: 41469,
    description: 'Number of fallbacks in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegMarketDisruptionFallbackType',
    id: 41470,
    abbrName: 'Typ',
    description:
      'Specifies the type of disruption fallback.\n\nSee http://www.fpml.org/coding-scheme/commodity-market-disruption-fallback for values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegMarketDisruptionFallbackReferencePrices',
    id: 41471,
    description: 'Number of fallback reference securities in the repeating group.',
  },
  {
    type: 'MarketDisruptionFallbackUnderlierTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegMarketDisruptionFallbackUnderlierType',
    id: 41472,
    abbrName: 'Typ',
    description: 'The type of reference price underlier.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegMarketDisruptionFallbackUnderlierSecurityID',
    id: 41473,
    abbrName: 'ID',
    discriminatorId: '41474',
    description: 'Specifies the identifier value of the security.',
  },
  {
    updated: 'FIX.Latest',
    type: 'SecurityIDSourceCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '169',
    updatedEP: '265',
    added: 'FIX.5.0SP2',
    name: 'LegMarketDisruptionFallbackUnderlierSecurityIDSource',
    id: 41474,
    abbrName: 'Src',
    description: 'Specifies the class or source scheme of the security identifier.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegMarketDisruptionFallbackUnderlierSecurityDesc',
    id: 41475,
    abbrName: 'Desc',
    description: 'Specifies the description of the underlying security.',
  },
  {
    type: 'Length',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'EncodedLegMarketDisruptionFallbackUnderlierSecurityDescLen',
    id: 41476,
    abbrName: 'EncDescLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedLegMarketDisruptionFallbackUnderlierSecurityDesc (41477) field.',
  },
  {
    type: 'data',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'EncodedLegMarketDisruptionFallbackUnderlierSecurityDesc',
    id: 41477,
    abbrName: 'EncDesc',
    lengthId: '41476',
    description:
      'Encoded (non-ASCII characters) representation of the LegMarketDisruptionFallbackUnderlierSecurityDesc(41475) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the LegMarketDisruptionFallbackUnderlierSecurityDesc(41475) field.',
  },
  {
    type: 'Qty',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegMarketDisruptionFallbackOpenUnits',
    id: 41478,
    abbrName: 'OpnUnits',
    description:
      'If there are multiple underlying assets, this specifies the number of units (index or securities) that constitute the underlier of the swap. In the case of a basket swap, this is used to reference both the number of basket units, and the number of each asset components of the basket when these are expressed in absolute terms.',
  },
  {
    type: 'Currency',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegMarketDisruptionFallbackBasketCurrency',
    id: 41479,
    abbrName: 'Ccy',
    description:
      'Specifies the currency if the underlier is a basket. Uses ISO 4217 currency codes.',
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegMarketDisruptionFallbackBasketDivisor',
    id: 41480,
    abbrName: 'Dvsr',
    description:
      'Specifies the basket divisor amount. This value is normally used to adjust the constituent weight for pricing or to adjust for dividends, or other corporate actions.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegExerciseDesc',
    id: 41481,
    abbrName: 'Desc',
    description: 'A description of the option exercise.',
  },
  {
    type: 'Length',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'EncodedLegExerciseDescLen',
    id: 41482,
    abbrName: 'EncDescLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedLegExerciseDesc(41483) field.',
  },
  {
    type: 'data',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'EncodedLegExerciseDesc',
    id: 41483,
    abbrName: 'EncDesc',
    lengthId: '41482',
    description:
      'Encoded (non-ASCII characters) representation of the LegExerciseDesc(41481) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the LegExerciseDesc(41481) field.',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegAutomaticExerciseIndicator',
    id: 41484,
    abbrName: 'AutoExerInd',
    description:
      "Indicates (when 'Y') that exercise is automatic when the strike price is crossed or the underlying trade is in the money.",
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegAutomaticExerciseThresholdRate',
    id: 41485,
    abbrName: 'AutoRt',
    description: 'The threshold rate for triggering automatic exercise.',
  },
  {
    type: 'ExerciseConfirmationMethodCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegExerciseConfirmationMethod',
    id: 41486,
    abbrName: 'ExerCnfm',
    description:
      "Indicates whether follow-up confirmation of exercise (written or electronic) is required following telephonic notice by the buyer to the seller or seller's agent.",
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegManualNoticeBusinessCenter',
    id: 41487,
    abbrName: 'ManNtcBizCtr',
    description:
      'Identifies the business center used for adjusting the time for manual exercise notice.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegFallbackExerciseIndicator',
    id: 41488,
    abbrName: 'FallbckExerInd',
    description:
      'Indicates whether the notional amount of the underlying swap, not previously exercised under the option, will be automatically exercised at the expiration time on the expiration date if at such time the buyer is in-the-money, provided that the difference between the settlement rate and the fixed rate under the relevant underlying swap is not less than one tenth of a percentage point (0.10% or 0.001).',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegLimitRightToConfirmIndicator',
    id: 41489,
    abbrName: 'LtdRightCnfmInd',
    description:
      'Indicates whether the Seller may request the Buyer to confirm its intent to exercise if not done on or before the expiration time on the expiration date. If true ("Y") specific rules will apply in relation to the settlement mode.',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegExerciseSplitTicketIndicator',
    id: 41490,
    abbrName: 'ExerSplitTktInd',
    description:
      'Indicates in physical settlement of bond and convertible bond options whether the party required to deliver the bonds will divide those to be delivered as notifying party desires to facilitate delivery obligations.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegOptionExerciseBusinessCenters',
    id: 41491,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegOptionExerciseBusinessCenter',
    id: 41492,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the option exercise dates, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegOptionExerciseBusinessDayConvention',
    id: 41493,
    abbrName: 'BizDayCnvtn',
    description:
      'The business day convention used to adjust the option exercise dates. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'ComplexEventDateOffsetDayTypeCodeSet',
    addedEP: '169',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegOptionExerciseEarliestDateOffsetDayType',
    id: 41494,
    abbrName: 'ErlstOfstDayTyp',
    description: 'Specifies the day type of the relative earliest exercise date offset.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegOptionExerciseEarliestDateOffsetPeriod',
    id: 41495,
    abbrName: 'ErlstOfstPeriod',
    description: 'Time unit multiplier for the relative earliest exercise date offset.',
  },
  {
    type: 'ProvisionOptionExerciseEarliestDateOffsetUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegOptionExerciseEarliestDateOffsetUnit',
    id: 41496,
    abbrName: 'ErlstOfstUnit',
    description: 'Time unit associated with the relative earliest exercise date offset.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegOptionExerciseFrequencyPeriod',
    id: 41497,
    abbrName: 'FreqPeriod',
    description: 'Time unit multiplier for the frequency of exercise dates.',
  },
  {
    type: 'ProtectionTermEventUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegOptionExerciseFrequencyUnit',
    id: 41498,
    abbrName: 'FreqUnit',
    description: 'Time unit associated with the frequency of exercise dates.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegOptionExerciseStartDateUnadjusted',
    id: 41499,
    abbrName: 'StartDtUnadj',
    description: 'The unadjusted start date for calculating periodic exercise dates.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegOptionExerciseStartDateRelativeTo',
    id: 41500,
    abbrName: 'StartDtReltv',
    description:
      'Specifies the anchor date when the option exercise start date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegOptionExerciseStartDateOffsetPeriod',
    id: 41501,
    abbrName: 'StartDtOfstPeriod',
    description: 'Time unit multiplier for the relative exercise start date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegOptionExerciseStartDateOffsetUnit',
    id: 41502,
    abbrName: 'StartDtOfstUnit',
    description: 'Time unit associated with the relative exercise start date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '169',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegOptionExerciseStartDateOffsetDayType',
    id: 41503,
    abbrName: 'StartDtOfstDayTyp',
    description:
      'Specifies the day type of the relative option exercise start date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegOptionExerciseStartDateAdjusted',
    id: 41504,
    abbrName: 'StartDt',
    description: 'The adjusted start date for calculating periodic exercise dates.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegOptionExerciseSkip',
    id: 41505,
    abbrName: 'Skip',
    description:
      'The number of periods in the referenced date schedule that are between each date in the relative date schedule. Thus a skip of 2 would mean that dates are relative to every second date in the referenced schedule. If present this should have a value greater than 1.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegOptionExerciseNominationDeadline',
    id: 41506,
    abbrName: 'NomntnDdln',
    description: 'The last date (adjusted) for establishing the option exercise terms.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegOptionExerciseFirstDateUnadjusted',
    id: 41507,
    abbrName: 'FirstDtUnadj',
    description: 'The unadjusted first exercise date.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegOptionExerciseLastDateUnadjusted',
    id: 41508,
    abbrName: 'LastDtUnadj',
    description: 'The unadjusted last exercise date.',
  },
  {
    type: 'LocalMktTime',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegOptionExerciseEarliestTime',
    id: 41509,
    abbrName: 'ErlstTm',
    description:
      "The earliest time at which notice of exercise can be given by the buyer to the seller (or seller's agent) (i) on the expriation date, in the case of a European style option, (ii) on each Bermuda option exercise date and the expiration date, in the case of a Bermuda style option, (iii) the commencement date to, and including, the expiration date, in the case of an American option.",
  },
  {
    type: 'LocalMktTime',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegOptionExerciseLatestTime',
    id: 41510,
    abbrName: 'LtstTm',
    description:
      'The latest exercise time. See also LegOptionExerciseEarliestTime(41509).',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegOptionExerciseTimeBusinessCenter',
    id: 41511,
    abbrName: 'TmBizCtr',
    description:
      'The business center used to determine the locale for option exercise time, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegOptionExerciseDates',
    id: 41512,
    description: 'Number of dates in the repeating group.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegOptionExerciseDate',
    id: 41513,
    abbrName: 'Dt',
    description: 'The adjusted or unadjusted option exercise fixed date.',
  },
  {
    type: 'OptionExerciseDateTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegOptionExerciseDateType',
    id: 41514,
    abbrName: 'Typ',
    description:
      'Specifies the type of option exercise date. When specified it applies not only to the current date but to all subsequent dates in the group until overridden with a new type.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegOptionExerciseExpirationDateBusinessCenters',
    id: 41515,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegOptionExerciseExpirationDateBusinessCenter',
    id: 41516,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the option exercise expiration dates, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegOptionExerciseExpirationDateBusinessDayConvention',
    id: 41517,
    abbrName: 'BizDayCnvtn',
    description:
      'The business day convention used to adjust the option exercise expiration dates. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegOptionExerciseExpirationDateRelativeTo',
    id: 41518,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the option exercise expiration date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegOptionExerciseExpirationDateOffsetPeriod',
    id: 41519,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative exercise expiration date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegOptionExerciseExpirationDateOffsetUnit',
    id: 41520,
    abbrName: 'OfstUnit',
    description:
      'Time unit associated with the relative exercise expiration date offset.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegOptionExerciseExpirationFrequencyPeriod',
    id: 41521,
    abbrName: 'FreqPeriod',
    description: 'Time unit multiplier for the frequency of exercise expiration dates.',
  },
  {
    type: 'ProtectionTermEventUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegOptionExerciseExpirationFrequencyUnit',
    id: 41522,
    abbrName: 'FreqUnit',
    description: 'Time unit associated with the frequency of exercise expiration dates.',
  },
  {
    type: 'DateRollConventionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegOptionExerciseExpirationRollConvention',
    id: 41523,
    abbrName: 'Roll',
    description:
      'The convention for determining the sequence of exercise expiration dates. It is used in conjunction with a specified frequency. Used only to override the roll convention defined in the LegDateAdjustment component in InstrumentLeg.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'ComplexEventDateOffsetDayTypeCodeSet',
    addedEP: '169',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegOptionExerciseExpirationDateOffsetDayType',
    id: 41524,
    abbrName: 'OfstDayTyp',
    description:
      'Specifies the day type of the relative option exercise expiration date offset.',
  },
  {
    type: 'LocalMktTime',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegOptionExerciseExpirationTime',
    id: 41525,
    abbrName: 'Tm',
    description: 'The option exercise expiration time.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegOptionExerciseExpirationTimeBusinessCenter',
    id: 41526,
    abbrName: 'TmBizCtr',
    description:
      'The business center used to determine the locale for option exercise expiration time, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegOptionExerciseExpirationDates',
    id: 41527,
    description: 'Number of fixed exercise expiration dates in the repeating group.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegOptionExerciseExpirationDate',
    id: 41528,
    abbrName: 'Dt',
    description: 'The adjusted or unadjusted option exercise expiration fixed date.',
  },
  {
    type: 'OptionExerciseDateTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegOptionExerciseExpirationDateType',
    id: 41529,
    abbrName: 'Typ',
    description:
      'Specifies the type of option exercise expiration date. When specified it applies not only to the current date but to all subsequent dates in the group until overridden with a new type.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegPaymentScheduleFixingDays',
    id: 41530,
    description: 'Number of fixing days in the repeating group.',
  },
  {
    type: 'PaymentStreamPricingDayOfWeekCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleFixingDayOfWeek',
    id: 41531,
    abbrName: 'DayOfWk',
    description: 'The day of the week on which fixing takes place.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleFixingDayNumber',
    id: 41532,
    abbrName: 'DayNum',
    description:
      'The occurrence of the day of week on which fixing takes place.\n\nFor example, a fixing of the 3rd Friday would be DayOfWk=5 DayNum=3. If omitted every day of the week is a fixing day.',
  },
  {
    type: 'XID',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleXID',
    id: 41533,
    abbrName: 'XID',
    description:
      'Identifier of this LegPaymentSchedule for cross referencing elsewhere in the message.',
  },
  {
    type: 'XIDREF',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleXIDRef',
    id: 41534,
    abbrName: 'XIDRef',
    description: 'Reference to payment schedule elsewhere in the message.',
  },
  {
    type: 'Currency',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleRateCurrency',
    id: 41535,
    abbrName: 'RtCcy',
    description: 'The currency of the schedule rate. Uses ISO 4217 currency codes.',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleRateUnitOfMeasure',
    id: 41536,
    abbrName: 'RtUOM',
    description: 'The schedule rate unit of measure (UOM).',
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleRateConversionFactor',
    id: 41537,
    abbrName: 'RtFctr',
    description:
      "The number multipled by the derived floating rate of the leg's payment schedule in order to arrive at the payment rate. If omitted, the schedule rate conversion factor is 1.",
  },
  {
    type: 'PaymentStreamRateSpreadTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleRateSpreadType',
    id: 41538,
    abbrName: 'SpreadTyp',
    description:
      'Identifies whether the rate spread is an absolute value to be added to the index rate or a percentage of the index rate.',
  },
  {
    type: 'Price',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleSettlPeriodPrice',
    id: 41539,
    abbrName: 'SettlPx',
    description: 'The schedule settlement period price.',
  },
  {
    type: 'Currency',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleSettlPeriodPriceCurrency',
    id: 41540,
    abbrName: 'SettlPxCcy',
    description:
      'The currency of the schedule settlement period price. Uses ISO 4217 currency codes.',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleSettlPeriodPriceUnitOfMeasure',
    id: 41541,
    abbrName: 'SettlPxUOM',
    description: 'The settlement period price unit of measure (UOM).',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleStepUnitOfMeasure',
    id: 41542,
    abbrName: 'StepUOM',
    description: 'The schedule step unit of measure (UOM).',
  },
  {
    type: 'PaymentStreamPricingDayDistributionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleFixingDayDistribution',
    id: 41543,
    abbrName: 'FixngDayDistrib',
    description: 'The distribution of fixing days.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleFixingDayCount',
    id: 41544,
    abbrName: 'FixngDayCnt',
    description: 'The number of days over which fixing should take place.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleFixingLagPeriod',
    id: 41545,
    abbrName: 'FixngLagPeriod',
    description: 'Time unit multiplier for the fixing lag duration.',
  },
  {
    type: 'PaymentStreamInflationLagUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleFixingLagUnit',
    id: 41546,
    abbrName: 'FixngLagUnit',
    description: 'Time unit associated with the fixing lag duration.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '169',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleFixingFirstObservationDateOffsetPeriod',
    id: 41547,
    abbrName: 'FixngFirstObsvtnPeriod',
    description:
      'Time unit multiplier for the relative first observation date offset.\n\nIf the first observation offset is specified, the observation period will start the specified interval prior to each calculation period - i.e. if the first observation offset is 4 months and the lag duration is 3 months, observations will be taken in months 4, 3 and 2 (but not 1) prior to each calculation period. If no first observation offset is specified, the observation period will end immediately preceding each calculation period.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '169',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentScheduleFixingFirstObservationDateOffsetUnit',
    id: 41548,
    abbrName: 'FixngFirstObsvtnUnit',
    description: 'Time unit associated with the relative first observation date offset.',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFlatRateIndicator',
    id: 41549,
    abbrName: 'FlatRtInd',
    description:
      'When this element is specified and set to \'Y\', the Flat Rate is the New Worldwide Tanker Nominal Freight Scale for the Freight Index Route taken at the trade date of the transaction "Fixed". If \'N\' it is taken on each pricing date "Floating".',
  },
  {
    type: 'Amt',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFlatRateAmount',
    id: 41550,
    abbrName: 'FlatRtAmt',
    description:
      "Specifies the actual monetary value of the flat rate when LegPaymentStreamFlatRateIndicator(41549) = 'Y'.",
  },
  {
    type: 'Currency',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFlatRateCurrency',
    id: 41551,
    abbrName: 'FlatRtCcy',
    description:
      'Specifies the currency of the actual flat rate. Uses ISO 4217 currency codes.',
  },
  {
    type: 'Amt',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamMaximumPaymentAmount',
    id: 41552,
    abbrName: 'MaxPmtAmt',
    description: 'Specifies the limit on the total payment amount.',
  },
  {
    type: 'Currency',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamMaximumPaymentCurrency',
    id: 41553,
    abbrName: 'MaxPmtCcy',
    description:
      'Specifies the currency of total payment amount limit. Uses ISO 4217 currency codes.',
  },
  {
    type: 'Amt',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamMaximumTransactionAmount',
    id: 41554,
    abbrName: 'MaxTxnAmt',
    description:
      'Specifies the limit on the payment amount that goes out in any particular calculation period.',
  },
  {
    type: 'Currency',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamMaximumTransactionCurrency',
    id: 41555,
    abbrName: 'MaxTxnCcy',
    description:
      'Specifies the currency of the period payment amount limit. Uses ISO 4217 currency codes.',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFixedAmountUnitOfMeasure',
    id: 41556,
    abbrName: 'FixedAmtUOM',
    description: 'The fixed payment amount unit of measure (UOM).',
  },
  {
    type: 'Amt',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamTotalFixedAmount',
    id: 41557,
    abbrName: 'FixedAmt',
    description: 'Specifies the total fixed payment amount.',
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamWorldScaleRate',
    id: 41558,
    abbrName: 'WorldScaleRt',
    description:
      'The number of Worldscale points for purposes of the calculation of a fixed amount for a wet voyage charter commodity swap.',
  },
  {
    type: 'Price',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamContractPrice',
    id: 41559,
    abbrName: 'CtrctPx',
    description:
      'The price per relevant unit for purposes of the calculation of a fixed amount for a dry voyage charter or time charter commodity swap.',
  },
  {
    type: 'Currency',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamContractPriceCurrency',
    id: 41560,
    abbrName: 'CtrctPxCcy',
    description:
      'Specifies the currency of LegPaymentStreamContractPrice(41559). Uses ISO 4217 currency codes.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegPaymentStreamPricingBusinessCenters',
    id: 41561,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamPricingBusinessCenter',
    id: 41562,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the pricing dates, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'PaymentStreamRateIndexCurveUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamRateIndex2CurveUnit',
    id: 41563,
    abbrName: 'Ndx2Unit',
    description:
      "Secondary time unit associated with the payment stream's floating rate index curve.",
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamRateIndex2CurvePeriod',
    id: 41564,
    abbrName: 'Ndx2Period',
    description:
      "Secondary time unit multiplier for the payment stream's floating rate index curve.\n\nMay be used for a Forward Rate Agreement (FRA) with an average rate between two curve points.",
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamRateIndexLocation',
    id: 41565,
    abbrName: 'NdxLctn',
    description: 'Specifies the location of the floating rate index.',
  },
  {
    type: 'Qty',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamRateIndexLevel',
    id: 41566,
    abbrName: 'NdxLvl',
    description:
      'This is the weather Cooling Degree Days (CDD), Heating Degree Days (HDD) or HDD index level specified as the number of (amount of) weather index units specified by the parties in the related confirmation.',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamRateIndexUnitOfMeasure',
    id: 41567,
    abbrName: 'NdxUOM',
    description: 'The unit of measure (UOM) of the rate index level.',
  },
  {
    type: 'PaymentStreamSettlLevelCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamSettlLevel',
    id: 41568,
    abbrName: 'SettlLvl',
    description: 'Specifies how weather index units are to be calculated.',
  },
  {
    type: 'Qty',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamReferenceLevel',
    id: 41569,
    abbrName: 'RefLvl',
    description:
      'This is the weather Cooling Degree Days (CDD), Heating Degree Days (HDD) or HDD reference level specified as the number of (amount of) weather index units specified by the parties in the related confirmation.',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamReferenceLevelUnitOfMeasure',
    id: 41570,
    abbrName: 'RefUOM',
    description: 'The unit of measure (UOM) of the rate reference level.',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamReferenceLevelEqualsZeroIndicator',
    id: 41571,
    abbrName: 'RefLvlZero',
    description:
      "When set to 'Y', it indicates that the weather reference level equals zero.",
  },
  {
    type: 'Currency',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamRateSpreadCurrency',
    id: 41572,
    abbrName: 'SpreadCcy',
    description:
      'Specifies the currency of the floating rate spread. Uses ISO 4217 currency codes.',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamRateSpreadUnitOfMeasure',
    id: 41573,
    abbrName: 'SpreadUOM',
    description: 'Specifies the unit of measure (UOM) of the floating rate spread.',
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamRateConversionFactor',
    id: 41574,
    abbrName: 'RtFctr',
    description:
      "The number to be multiplied by the derived floating rate of the leg's payment stream in order to arrive at the payment rate. If omitted, the floating rate conversion factor is 1.",
  },
  {
    type: 'PaymentStreamRateSpreadTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamRateSpreadType',
    id: 41575,
    abbrName: 'SpreadTyp',
    description:
      'Identifies whether the rate spread is an absolute value to be added to the index rate or a percentage of the index rate.',
  },
  {
    type: 'Percentage',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamLastResetRate',
    id: 41576,
    abbrName: 'LastResetRt',
    description:
      'The floating rate determined at the most recent reset. The rate is expressed in decimal form, e.g. 5% is represented as 0.05.',
  },
  {
    type: 'Percentage',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFinalRate',
    id: 41577,
    abbrName: 'FnlRt',
    description:
      'The floating rate determined at the final reset. The rate is expressed in decimal form, e.g. 5% is represented as 0.05.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCalculationLagPeriod',
    id: 41578,
    abbrName: 'CalcLagPeriod',
    description: 'Time unit multiplier for the calculation lag duration.',
  },
  {
    type: 'PaymentStreamInflationLagUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCalculationLagUnit',
    id: 41579,
    abbrName: 'CalcLagUnit',
    description: 'Time unit associated with the calculation lag duration.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '169',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFirstObservationDateOffsetPeriod',
    id: 41580,
    abbrName: 'FirstObsvtnOfstPeriod',
    description:
      'Time unit multiplier for the relative first observation date offset.\n\nIf the first observation offset is specified, the observation period will start the specified interval prior to each calculation period - i.e. if the first observation offset is 4 months and the lag duration is 3 months, observations will be taken in months 4, 3 and 2 (but not 1) prior to each calculation period. If no first observation offset is specified, the observation period will end immediately preceding each calculation period.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '169',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFirstObservationDateOffsetUnit',
    id: 41581,
    abbrName: 'FirstObsvtnOfstUnit',
    description: 'Time unit associated with the relative first observation date offset.',
  },
  {
    type: 'ComplexEventDateOffsetDayTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamPricingDayType',
    id: 41582,
    abbrName: 'PxngDayTyp',
    description: 'Specifies the commodity pricing day type.',
  },
  {
    type: 'PaymentStreamPricingDayDistributionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamPricingDayDistribution',
    id: 41583,
    abbrName: 'PxngDayDistrib',
    description: 'The distribution of pricing days.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamPricingDayCount',
    id: 41584,
    abbrName: 'PxngDayCnt',
    description: 'The number of days over which pricing should take place.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamPricingBusinessCalendar',
    id: 41585,
    abbrName: 'PxngClndr',
    description:
      'Specifies the business calendar to use for pricing.\n\nSee http://www.fpml.org/coding-scheme/commodity-business-calendar for values.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamPricingBusinessDayConvention',
    id: 41586,
    abbrName: 'PxngBizDayCnvtn',
    description:
      "The business day convention used to adjust the payment stream's pricing dates. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.",
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegPaymentStreamPaymentDates',
    id: 41589,
    description: 'Number of payment dates in the repeating group.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamPaymentDate',
    id: 41590,
    abbrName: 'Dt',
    description: 'The adjusted or unadjusted fixed stream payment date.',
  },
  {
    type: 'OptionExerciseDateTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamPaymentDateType',
    id: 41591,
    abbrName: 'Typ',
    description:
      'Specifies the type of payment date. When specified it applies not only to the current date but to all subsequent dates in the group until overridden with a new type.',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamMasterAgreementPaymentDatesIndicator',
    id: 41592,
    abbrName: 'MADts',
    description:
      "When set to 'Y', it indicates that payment dates are specified in the relevant master agreement.",
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegPaymentStreamPricingDates',
    id: 41593,
    description: 'Number of pricing dates in the repeating group.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamPricingDate',
    id: 41594,
    abbrName: 'Dt',
    description: 'The adjusted or unadusted fixed stream pricing date.',
  },
  {
    type: 'OptionExerciseDateTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamPricingDateType',
    id: 41595,
    abbrName: 'Typ',
    description:
      'Specifies the type of pricing date. When specified it applies not only to the current date but to all subsequent dates in the group until overridden with a new type.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegPaymentStreamPricingDays',
    id: 41596,
    description: 'Number of pricing days in the repeating group.',
  },
  {
    updated: 'FIX.Latest',
    type: 'PaymentStreamPricingDayOfWeekCodeSet',
    addedEP: '169',
    updatedEP: '282',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamPricingDayOfWeek',
    id: 41597,
    abbrName: 'DayOfWk',
    description: 'The day of the week on which pricing takes place.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamPricingDayNumber',
    id: 41598,
    abbrName: 'DayNum',
    description:
      'The occurrence of the day of week on which pricing takes place.\n\nFor example a pricing day of the 3rd Friday would be DayOfWk=5 DayNum=3.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegPhysicalSettlTerms',
    id: 41599,
    description: 'Number of entries in the repeating group.',
  },
  {
    type: 'XID',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPhysicalSettlTermXID',
    id: 41600,
    abbrName: 'XID',
    description: 'A named string value referenced by UnderlyingSettlTermXIDRef(41315).',
  },
  {
    type: 'Currency',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPhysicalSettlCurency',
    id: 41601,
    abbrName: 'Ccy',
    description:
      'Specifies the currency of physical settlement. Uses ISO 4217 currency codes.',
  },
  {
    updated: 'FIX.Latest',
    type: 'int',
    addedEP: '169',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'LegPhysicalSettlBusinessDays',
    id: 41602,
    abbrName: 'BizDays',
    description:
      'The number of business days used in the determination of physical settlement. Its precise meaning depends on the context in which this is used.\n\nISDA 2003 Term: Business Day.',
  },
  {
    updated: 'FIX.Latest',
    type: 'int',
    addedEP: '169',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'LegPhysicalSettlMaximumBusinessDays',
    id: 41603,
    abbrName: 'MaxBizDays',
    description:
      'A maximum number of business days. Its precise meaning depends on the context in which this element is used. Intended to be used to limit a particular ISDA fallback provision.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegPhysicalSettlDeliverableObligations',
    id: 41604,
    description: 'Number of entries in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPhysicalSettlDeliverableObligationType',
    id: 41605,
    abbrName: 'Typ',
    description:
      'Specifies the type of delivery obligation applicable for physical settlement.\n\nSee http://www.fixptradingcommunity.org/codelists#Deliverable_Obligation_Types for code list for applicable deliverable obligation types.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPhysicalSettlDeliverableObligationValue',
    id: 41606,
    abbrName: 'Val',
    description:
      'Physical settlement delivery obligation value appropriate to LegPhysicalSettlDeliverableObligationType(41605).\n\nSee http://www.fixtradingcommunity.org/codelists#Deliverable_Obligation_Types for code list for applicable deliverable obligation types.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegPricingDateBusinessCenters',
    id: 41607,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPricingDateBusinessCenter',
    id: 41608,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the pricing or fixing date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPricingDateUnadjusted',
    id: 41609,
    abbrName: 'DtUnadj',
    description: 'The unadjusted pricing or fixing date.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPricingDateBusinessDayConvention',
    id: 41610,
    abbrName: 'BizDayCnvtn',
    description:
      'The business day convention used to adjust the pricing or fixing date. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPricingDateAdjusted',
    id: 41611,
    abbrName: 'Dt',
    description: 'The adjusted pricing or fixing date.',
  },
  {
    type: 'LocalMktTime',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPricingTime',
    id: 41612,
    abbrName: 'Tm',
    description: 'The local market pricing or fixing time.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegPricingTimeBusinessCenter',
    id: 41613,
    abbrName: 'TmBizCtr',
    description:
      'Specifies the business center for determining the pricing or fixing time. See http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegProtectionTermEventNewsSources',
    id: 41614,
    description: 'Number of event sources in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegProtectionTermEventNewsSource',
    id: 41615,
    abbrName: 'Src',
    description:
      'A newspaper or electronic news service that may publish relevant information used in the determination of whether or not a credit event has occurred.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegProtectionTerms',
    id: 41616,
    description: 'Number of protection terms in the repeating group.',
  },
  {
    updated: 'FIX.Latest',
    type: 'XID',
    addedEP: '169',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'LegProtectionTermXID',
    id: 41617,
    abbrName: 'XID',
    description:
      'A named string value referenced from UnderlyingProtectionTermXIDRef(41314).',
  },
  {
    type: 'Amt',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegProtectionTermNotional',
    id: 41618,
    abbrName: 'Notl',
    description:
      'The notional amount of protection coverage.\n\nISDA 2003 Term: Floating Rate Payer Calculation Amount.',
  },
  {
    type: 'Currency',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegProtectionTermCurrency',
    id: 41619,
    abbrName: 'Ccy',
    description:
      'The currency of LegProtectionTermNotional(41618). Uses ISO 4217 currency codes.',
  },
];

const batch6: ISpecFields[] = [
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegProtectionTermSellerNotifies',
    id: 41620,
    abbrName: 'Seller',
    description:
      'The notifying party is the party that notifies the other party when a credit event has occurred by means of a credit event notice. If more than one party is referenced as being the notifying party then either party may notify the other of a credit event occurring. LegProtectionTermSellerNotifies(41620)=Y indicates that the seller notifies.\n\nISDA 2003 Term: Notifying Party.',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegProtectionTermBuyerNotifies',
    id: 41621,
    abbrName: 'Buyer',
    description:
      'The notifying party is the party that notifies the other party when a credit event has occurred by means of a credit event notice. If more than one party is referenced as being the notifying party then either party may notify the other of a credit event occurring. LegProtectionTermBuyerNotifies(41621)=Y indicates that the buyer notifies.\n\nISDA 2003 Term: Notifying Party.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegProtectionTermEventBusinessCenter',
    id: 41622,
    abbrName: 'BizCtr',
    description:
      'When used, the business center indicates the local time of the business center that replaces the Greenwich Mean Time in Section 3.3 of the 2003 ISDA Credit Derivatives Definitions.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegProtectionTermStandardSources',
    id: 41623,
    abbrName: 'StdSrcs',
    description:
      'Indicates whether ISDA defined Standard Public Sources are applicable (LegProtectionTermStandardSources(41623)=Y) or not.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegProtectionTermEventMinimumSources',
    id: 41624,
    abbrName: 'MinSrcs',
    description:
      'The minimum number of the specified public information sources that must publish information that reasonably confirms that a credit event has occurred. The market convention is two.\n\nISDA 2003 Term: Specified Number.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegProtectionTermEvents',
    id: 41625,
    description: 'Number of protection term events in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegProtectionTermEventType',
    id: 41626,
    abbrName: 'Typ',
    description:
      'Specifies the type of credit event applicable to the protection terms.\n\nSee http://www.fixtradingcommunity.org/codelists#Protection_Term_Event_Types for code list of applicable event types.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegProtectionTermEventValue',
    id: 41627,
    abbrName: 'Val',
    description:
      'Specifies the protection term event value appropriate to LegProtectionTermEventType(41626). See http:///www.fixtradingcommunity.org/codelists#Protection_Term_Event_Types for applicable event type values.',
  },
  {
    type: 'Currency',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegProtectionTermEventCurrency',
    id: 41628,
    abbrName: 'Ccy',
    description:
      'Applicable currency if the event value is an amount. Uses ISO 4217 currency codes.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegProtectionTermEventPeriod',
    id: 41629,
    abbrName: 'Period',
    description: 'Time unit multiplier for protection term events.',
  },
  {
    type: 'ProtectionTermEventUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegProtectionTermEventUnit',
    id: 41630,
    abbrName: 'Unit',
    description: 'Time unit associated with protection term events.',
  },
  {
    updated: 'FIX.Latest',
    type: 'PaymentStreamInflationLagDayTypeCodeSet',
    addedEP: '169',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'LegProtectionTermEventDayType',
    id: 41631,
    abbrName: 'DayTyp',
    description: 'Day type for events that specify a period and unit.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegProtectionTermEventRateSource',
    id: 41632,
    abbrName: 'RtSrc',
    description:
      'Rate source for events that specify a rate source, e.g. floating rate interest shortfall.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegProtectionTermEventQualifiers',
    id: 41633,
    description: 'Number of qualifiers in the repeating group.',
  },
  {
    type: 'ProtectionTermEventQualifierCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegProtectionTermEventQualifier',
    id: 41634,
    abbrName: 'Qual',
    description:
      'Specifies the protection term event qualifier. Used to further qualify LegProtectionTermEventType(41626).',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegProtectionTermObligations',
    id: 41635,
    description: 'Number of obligations in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegProtectionTermObligationType',
    id: 41636,
    abbrName: 'Typ',
    description:
      'Specifies the type of obligation applicable to the protection terms.\n\nSee http://www.fixtradingcommunity.org/codelists#Protection_Term_Obligation_Types for code list of applicable obligation types.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegProtectionTermObligationValue',
    id: 41637,
    abbrName: 'Val',
    description:
      'The value associated with the protection term obligation specified in LegProtectionTermObligationType(41636). See http://www.fixtradingcommunity.org/codelists#Protection_Term_Obligation_Types for applicable obligation type values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegStreamCalculationPeriodDates',
    id: 41638,
    description: 'Number of calculation period dates in the repeating group.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCalculationPeriodDate',
    id: 41639,
    abbrName: 'Dt',
    description: 'The adjusted or unadjusted fixed calculation period date.',
  },
  {
    type: 'OptionExerciseDateTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCalculationPeriodDateType',
    id: 41640,
    abbrName: 'Typ',
    description:
      'Specifies the type of fixed calculation period date. When specified it applies not only to the current date but to all subsequent dates in the group until overridden with a new type.',
  },
  {
    type: 'XID',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCalculationPeriodDatesXID',
    id: 41641,
    abbrName: 'XID',
    description:
      'Identifier of this calculation period for cross referencing elsewhere in the message.',
  },
  {
    type: 'XIDREF',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCalculationPeriodDatesXIDRef',
    id: 41642,
    abbrName: 'XIDRef',
    description:
      'Cross reference to another calculation period for duplicating its properties.',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCalculationBalanceOfFirstPeriod',
    id: 41643,
    abbrName: 'BalFirst',
    description:
      "When specified and set to 'Y', it indicates that the first calculation period should run from the effective date to the end of the calendar period in which the effective date falls (e.g. Jan 15 - Jan 31 if the calculation periods are one month long and effective date is Jan 15.). If 'N' or not specified, it indicates that the first calculation period should run from the effective date for one whole period (e.g. Jan 15 to Feb 14 if the calculation periods are one month long and the effective date is Jan 15.).",
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCalculationCorrectionPeriod',
    id: 41644,
    abbrName: 'CrrctnPeriod',
    description:
      'Time unit multiplier for the length of time after the publication of the data when corrections can be made.',
  },
  {
    type: 'ProtectionTermEventUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCalculationCorrectionUnit',
    id: 41645,
    abbrName: 'CrrctnUnit',
    description:
      'Time unit associated with the length of time after the publication of the data when corrections can be made.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegStreamCommoditySettlBusinessCenters',
    id: 41646,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommoditySettlBusinessCenter',
    id: 41647,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the commodity delivery date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommodityBase',
    id: 41648,
    abbrName: 'Base',
    description:
      'Specifies the general base type of the commodity traded. Where possible, this should follow the naming convention used in the 2005 ISDA Commodity Definitions.\n\nExamples of general commodity base types include: Metal, Bullion, Oil, Natural Gas, Coal, Electricity, Inter-Energy, Grains, Oils Seeds, Dairy, Livestock, Forestry, Softs, Weather, Emissions.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommodityType',
    id: 41649,
    abbrName: 'CmdtyTyp',
    description:
      'Specifies the type of commodity product.\n\nFor coal see http://www.fpml.org/coding-scheme/commodity-coal-product-type for values.\n\nFor metals see http://www.fpml.org/coding-scheme/commodity-metal-product-type for values.\n\nFor bullion see http://www.fixtradingcommunity.org/codelists#Bullion_Types for the external code list of bullion types.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommoditySecurityID',
    id: 41650,
    abbrName: 'ID',
    discriminatorId: '41651',
    description: 'Specifies the market identifier for the commodity.',
  },
  {
    updated: 'FIX.Latest',
    type: 'SecurityIDSourceCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '169',
    updatedEP: '265',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommoditySecurityIDSource',
    id: 41651,
    abbrName: 'Src',
    description:
      'Identifies the class or source of the LegStreamCommoditySecurityIDSource(41650) value.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommodityDesc',
    id: 41652,
    abbrName: 'Desc',
    description: 'Description of the commodity asset.',
  },
  {
    type: 'Length',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'EncodedLegStreamCommodityDescLen',
    id: 41653,
    abbrName: 'EncDescLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedLegStreamCommodityDesc(41654) field.',
  },
  {
    type: 'data',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'EncodedLegStreamCommodityDesc',
    id: 41654,
    abbrName: 'EncDesc',
    lengthId: '41653',
    description:
      'Encoded (non-ASCII characters) representation of the LegStreamCommodityDesc(41652) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the LegStreamCommodityDesc(41652) field.',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommodityUnitOfMeasure',
    id: 41655,
    abbrName: 'UOM',
    description: 'The unit of measure (UOM) of the commodity asset.',
  },
  {
    type: 'Currency',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommodityCurrency',
    id: 41656,
    abbrName: 'Ccy',
    description:
      'Identifies the currency of the commodity asset. Uses ISO 4217 currency codes.',
  },
  {
    type: 'Exchange',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommodityExchange',
    id: 41657,
    abbrName: 'Exch',
    description: 'Identifies the exchange where the commodity is traded.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommodityRateSource',
    id: 41658,
    abbrName: 'RtSrc',
    description:
      'Identifies the source of rate information used for commodities.\n\nSee http://www.fixtradingcommunity.org/codelists#Commodity_Rate_Source for code list of applicable sources.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommodityRateReferencePage',
    id: 41659,
    abbrName: 'RefPg',
    description: 'Identifies the reference "page" from the rate source.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommodityRateReferencePageHeading',
    id: 41660,
    abbrName: 'RefHdng',
    description: 'Identifies the page heading from the rate source.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamDataProvider',
    id: 41661,
    abbrName: 'DataPrvdr',
    description:
      'Specifies the commodity data or information provider.\n\nSee http://www.fpml.org/coding-scheme/commodity-information-provider for values.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommodityPricingType',
    id: 41662,
    abbrName: 'PxngTyp',
    description:
      'Specifies how the pricing or rate setting of the trade is to be determined or based upon.\n\nSee http://www.fixtradingcommunity.org/codelists#Commodity_Rate_Pricing_Type for code list of applicable commodity pricing types.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommodityNearbySettlDayPeriod',
    id: 41663,
    abbrName: 'Period',
    description:
      'Time unit multiplier for the nearby settlement day.\n\nWhen the commodity transaction references a futures contract, the delivery or settlement dates are a nearby month or week. For example, for eighth nearby month use Period=8 and Unit=Mo.',
  },
  {
    type: 'StreamCommodityNearbySettlDayUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommodityNearbySettlDayUnit',
    id: 41664,
    abbrName: 'Unit',
    description: 'Time unit associated with the nearby settlement day.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommoditySettlDateUnadjusted',
    id: 41665,
    abbrName: 'DtUnadj',
    description: 'The unadjusted commodity delivery date.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommoditySettlDateBusinessDayConvention',
    id: 41666,
    abbrName: 'BizDayCnvtn',
    description:
      'The business day convention used to adjust the commodity delivery date. Used only to override the business day convention specified in the LegDateAdjustment component within the InstrumentLeg component.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommoditySettlDateAdjusted',
    id: 41667,
    abbrName: 'Dt',
    description: 'The adjusted commodity delivery date.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommoditySettlMonth',
    id: 41668,
    abbrName: 'Mo',
    description:
      'Specifies a fixed single month for commodity delivery.\n\nUse "1" for January, "2" for February, etc.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommoditySettlDateRollPeriod',
    id: 41669,
    abbrName: 'RollPeriod',
    description:
      'Time unit multiplier for the commodity delivery date roll.\n\nFor a commodity transaction that references a listed future via the delivery dates, this is the day offset on which the specified future will roll to the next nearby month when the referenced future expires.',
  },
  {
    type: 'StreamCommoditySettlDateRollUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommoditySettlDateRollUnit',
    id: 41670,
    abbrName: 'RollUnit',
    description: 'Time unit associated with the commodity delivery date roll.',
  },
  {
    type: 'ComplexEventDateOffsetDayTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommoditySettlDayType',
    id: 41671,
    abbrName: 'DayTyp',
    description: 'Specifies the commodity delivery roll day type.',
  },
  {
    type: 'XID',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommodityXID',
    id: 41672,
    abbrName: 'XID',
    description:
      'Identifier of this stream commodity for cross referencing elsewhere in the message.',
  },
  {
    type: 'XIDREF',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommodityXIDRef',
    id: 41673,
    abbrName: 'XIDRef',
    description: 'Reference to a stream commodity elsewhere in the message.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegStreamCommodityAltIDs',
    id: 41674,
    description: 'Number of alternate security identifers.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommodityAltID',
    id: 41675,
    abbrName: 'AltID',
    discriminatorId: '41676',
    description: 'Alternate security identifier value for the commodity.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommodityAltIDSource',
    id: 41676,
    abbrName: 'AltIDSrc',
    description:
      'Identifies the class or source of the alternate commodity security identifier.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegStreamCommodityDataSources',
    id: 41677,
    description:
      'Number of data sources in the repeating group. The order of entry determines priority – first is the main source, second is fallback, third is second fallback.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommodityDataSourceID',
    id: 41678,
    abbrName: 'ID',
    description: 'Specifies the data source identifier.',
  },
  {
    type: 'StreamCommodityDataSourceIDTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommodityDataSourceIDType',
    id: 41679,
    abbrName: 'Typ',
    description: 'Specifies the type of data source identifier.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegStreamCommoditySettlDays',
    id: 41680,
    description: 'Number of days in the repeating group.',
  },
  {
    type: 'DeliveryScheduleSettlDayCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommoditySettlDay',
    id: 41681,
    abbrName: 'Day',
    description: 'Specifies the day or group of days for delivery.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommoditySettlTotalHours',
    id: 41682,
    abbrName: 'TotHrs',
    description: 'Sum of the hours specified in LegStreamCommoditySettlTimeGrp.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegStreamCommoditySettlTimes',
    id: 41683,
    description: 'Number of hour ranges in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommoditySettlStart',
    id: 41684,
    abbrName: 'Start',
    description:
      'The start time for commodity settlement where delivery occurs over time. The time format is specified by the settlement time type.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommoditySettlEnd',
    id: 41685,
    abbrName: 'End',
    description:
      'The end time for commodity settlement where delivery occurs over time. The time format is specified by the settlement time type.',
  },
  {
    type: 'DeliveryScheduleSettlTimeTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommoditySettlTimeType',
    id: 41935,
    abbrName: 'Typ',
    description: 'Specifies the format of the commodity settlement start and end times.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoLegStreamCommoditySettlPeriods',
    id: 41686,
    description: 'Number of commodity settlement periods in the repeating group.',
  },
  {
    type: 'Country',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommoditySettlCountry',
    id: 41687,
    abbrName: 'Ctry',
    description:
      'Specifies the country where delivery takes place. Uses ISO 3166 2-character country code.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommoditySettlTimeZone',
    id: 41688,
    abbrName: 'TZ',
    description:
      'Commodity delivery timezone specified as "prevailing" rather than "standard" or "daylight".\n\nSee http://www.fixtradingcommunity.org/codelists#Prevailing_Timezones for code list of applicable prevailing timezones.',
  },
  {
    type: 'DeliveryScheduleSettlFlowTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommoditySettlFlowType',
    id: 41689,
    abbrName: 'FlowTyp',
    description: 'Specifies the commodity delivery flow type.',
  },
  {
    type: 'Qty',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommoditySettlPeriodNotional',
    id: 41690,
    abbrName: 'Notl',
    description: 'Delivery quantity associated with this settlement period.',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommoditySettlPeriodNotionalUnitOfMeasure',
    id: 41691,
    abbrName: 'NotlUOM',
    description:
      'Specifies the unit of measure (UOM) of the delivery quantity associated with this settlement period.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommoditySettlPeriodFrequencyPeriod',
    id: 41692,
    abbrName: 'FreqPeriod',
    description: 'Time unit multiplier for the settlement period frequency.',
  },
  {
    type: 'ProtectionTermEventUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommoditySettlPeriodFrequencyUnit',
    id: 41693,
    abbrName: 'FreqUnit',
    description: 'Time unit associated with the settlement period frequency.',
  },
  {
    type: 'Price',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommoditySettlPeriodPrice',
    id: 41694,
    abbrName: 'Px',
    description: 'The settlement period price.',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommoditySettlPeriodPriceUnitOfMeasure',
    id: 41695,
    abbrName: 'PxUOM',
    description: 'The settlement period price unit of measure (UOM).',
  },
  {
    type: 'Currency',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommoditySettlPeriodPriceCurrency',
    id: 41696,
    abbrName: 'PxCcy',
    description:
      'The currency of the settlement period price. Uses ISO 4217 currency codes.',
  },
  {
    type: 'DeliveryScheduleSettlHolidaysProcessingInstructionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommoditySettlHolidaysProcessingInstruction',
    id: 41697,
    abbrName: 'Holidays',
    description:
      'Indicates whether holidays are included in the settlement periods. Required for electricity contracts.',
  },
  {
    type: 'XID',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommoditySettlPeriodXID',
    id: 41698,
    abbrName: 'XID',
    description:
      'Identifier of this settlement period for cross referencing elsewhere in the message.',
  },
  {
    type: 'XIDREF',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommoditySettlPeriodXIDRef',
    id: 41699,
    abbrName: 'XIDRef',
    description:
      'Cross reference to another settlement period for duplicating its properties.',
  },
  {
    type: 'XID',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamXID',
    id: 41700,
    abbrName: 'XID',
    description:
      'Identifier of this LegStream for cross referencing elsewhere in the message.',
  },
  {
    type: 'XIDREF',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamNotionalXIDRef',
    id: 41702,
    abbrName: 'NotlXIDRef',
    description:
      'Cross reference to another LegStream notional for duplicating its properties.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamNotionalFrequencyPeriod',
    id: 41703,
    abbrName: 'NotlPeriod',
    description: "Time unit multiplier for the swap stream's notional frequency.",
  },
  {
    type: 'TimeUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamNotionalFrequencyUnit',
    id: 41704,
    abbrName: 'NotlUnit',
    description: "Time unit associated with the swap stream's notional frequency.",
  },
  {
    type: 'StreamNotionalCommodityFrequencyCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamNotionalCommodityFrequency',
    id: 41705,
    abbrName: 'NotlFreq',
    description: "The commodity's notional or quantity delivery frequency.",
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamNotionalUnitOfMeasure',
    id: 41706,
    abbrName: 'NotlUOM',
    description: 'Specifies the delivery quantity unit of measure (UOM).',
  },
  {
    type: 'Qty',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamTotalNotional',
    id: 41707,
    abbrName: 'TotNotl',
    description:
      'Specifies the total notional or delivery quantity over the term of the contract.',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'LegStreamTotalNotionalUnitOfMeasure',
    id: 41708,
    abbrName: 'TotNotlUOM',
    description:
      'Specifies the unit of measure (UOM) for the total notional or delivery quantity over the term of the contract.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingAssetAttributes',
    id: 2312,
    description: 'Number of asset attribute entries in the group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingAssetAttributeType',
    id: 2313,
    abbrName: 'Typ',
    description:
      'Specifies the name of the attribute.\n\nSee http://www.fixtradingcommunity.org/codelists#Asset_Attribute_Types for code list of applicable asset attribute types.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingAssetAttributeValue',
    id: 2314,
    abbrName: 'Val',
    description: 'Specifies the value of the attribute.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingAssetAttributeLimit',
    id: 2315,
    abbrName: 'Lmt',
    description: 'Limit or lower acceptable value of the attribute.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingComplexEventAveragingObservations',
    id: 41713,
    description: 'The number of averaging observations in the repeating group.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventAveragingObservationNumber',
    id: 41714,
    abbrName: 'ObsvtnNum',
    description:
      'Cross reference to the ordinal observation as specified either in the UnderlyingComplexEventScheduleGrp or UnderlyingComplexEventPeriodDateGrp components.',
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventAveragingWeight',
    id: 41715,
    abbrName: 'Wt',
    description: 'The weight factor to be applied to the observation.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingComplexEventCreditEvents',
    id: 41716,
    description: 'The number of credit events specified in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventCreditEventType',
    id: 41717,
    abbrName: 'Typ',
    description:
      'Specifies the type of credit event.\n\nSee http://www.fixtradingcommunity.org/codelists#Credit_Event_Types for code list of applicable event types.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventCreditEventValue',
    id: 41718,
    abbrName: 'Val',
    description:
      'The credit event value appropriate to UnderlyingComplexEventCreditEventType(41717).\n\nSee http://www.fixtradingcommunity.org/codelists#Credit_Event_Types for applicable event type values.',
  },
  {
    type: 'Currency',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventCreditEventCurrency',
    id: 41719,
    abbrName: 'Ccy',
    description:
      'Specifies the applicable currency when UnderlyingComplexEventCreditEventValue(41718) is an amount. Uses ISO 4217 currency codes.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventCreditEventPeriod',
    id: 41720,
    abbrName: 'Period',
    description: 'Time unit multiplier for complex credit events.',
  },
  {
    type: 'ProtectionTermEventUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventCreditEventUnit',
    id: 41721,
    abbrName: 'Unit',
    description: 'Time unit associated with complex credit events.',
  },
  {
    type: 'ComplexEventDateOffsetDayTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventCreditEventDayType',
    id: 41722,
    abbrName: 'DayTyp',
    description: 'Specifies the day type for the complex credit events.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventCreditEventRateSource',
    id: 41723,
    abbrName: 'RtSrc',
    description:
      'Identifies the source of rate information used for credit events.\n\nSee http://www.fixtradingcommunity.org/codelists#Credit_Event_Rate_Source for code list of applicable sources.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingComplexEventCreditEventQualifiers',
    id: 41724,
    description: 'Number of qualifiers in the repeating group.',
  },
  {
    type: 'ProtectionTermEventQualifierCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventCreditEventQualifier',
    id: 41725,
    abbrName: 'Qual',
    description:
      'Specifies a complex event qualifier. Used to further qualify UnderlyingComplexEventCreditEventType(41717).',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingComplexEventPeriodDateTimes',
    id: 41726,
    description: 'Number of entries in the date-time repeating group.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventPeriodDate',
    id: 41727,
    abbrName: 'Dt',
    description:
      'The averaging date for an Asian option.\n\nThe trigger date for a Barrier or Knock option.',
  },
  {
    type: 'LocalMktTime',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventPeriodTime',
    id: 41728,
    abbrName: 'Tm',
    description: 'The averaging time for an Asian option.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingComplexEventPeriods',
    id: 41729,
    description: 'Number of periods in the repeating group.',
  },
  {
    type: 'ComplexEventPeriodTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventPeriodType',
    id: 41730,
    abbrName: 'Typ',
    description: 'Specifies the period type.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventBusinessCenter',
    id: 41731,
    abbrName: 'BizCtr',
    description:
      'The business center for adjusting dates and times in the schedule or date-time group.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingComplexEventRateSources',
    id: 41732,
    description: 'Number of rate sources in the repeating group.',
  },
  {
    type: 'RateSourceCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventRateSource',
    id: 41733,
    abbrName: 'RtSrc',
    description:
      'Identifies the source of rate information.\n\nFor FX, the reference source to be used for the FX spot rate.',
  },
  {
    type: 'RateSourceTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventRateSourceType',
    id: 41734,
    abbrName: 'RtSrcTyp',
    description:
      'Indicates whether the rate source specified is a primary or secondary source.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventReferencePage',
    id: 41735,
    abbrName: 'RefPg',
    description:
      'Identifies the reference page from the rate source.\n\nFor FX, the reference page to the spot rate is to be used for the reference FX spot rate.\n\nWhen UnderlyingComplexEventRateSource(41733) = 3 (ISDA Settlement Rate Option) this contains the value from the scheme that reflects the terms of the Annex A to the ISDA 1998 FX and Currency Option Definitions. See: http://www.fpml.org/coding-scheme/settlement-rate-option.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventReferencePageHeading',
    id: 41736,
    abbrName: 'RefHdg',
    description: 'Identifies the reference page heading from the rate source.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingComplexEventDateBusinessCenters',
    id: 41737,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventDateBusinessCenter',
    id: 41738,
    abbrName: 'Ctr',
    description:
      'The business center calendar is used to adjust the event date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventDateUnadjusted',
    id: 41739,
    abbrName: 'DtUnadj',
    description:
      'The unadjusted complex event date.\n\nFor example the second expiration date for a calendar spread option strategy.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '169',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventDateRelativeTo',
    id: 41740,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the complex event date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventDateOffsetPeriod',
    id: 41741,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventDateOffsetUnit',
    id: 41742,
    abbrName: 'OfstUnit',
    description: 'Time unit associated with the relative date offset.',
  },
  {
    type: 'ComplexEventDateOffsetDayTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventDateOffsetDayType',
    id: 41743,
    abbrName: 'OfstDayTyp',
    description: 'Specifies the day type of the relative date offset.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventDateBusinessDayConvention',
    id: 41744,
    abbrName: 'BizDayCnvtn',
    description:
      'The business day convention used to adjust the event date. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventDateAdjusted',
    id: 41745,
    abbrName: 'Dt',
    description: 'The adjusted complex event date.',
  },
  {
    type: 'LocalMktTime',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventFixingTime',
    id: 41746,
    abbrName: 'FixngTm',
    description: 'The local market fixing time.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventFixingTimeBusinessCenter',
    id: 41747,
    abbrName: 'FixngBizCtr',
    description:
      'The business center for determining the actual fixing times.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingComplexEventCreditEventSources',
    id: 41748,
    description: 'Number of event sources in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventCreditEventSource',
    id: 41749,
    abbrName: 'Src',
    description:
      'A newspaper or electronic news service that may publish relevant information used in the determination of whether or not a credit event has occurred.',
  },
  {
    type: 'PaymentPaySideCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexOptPayoutPaySide',
    id: 2261,
    abbrName: 'OptPay',
    description: 'Trade side of payout payer.',
  },
  {
    type: 'PaymentPaySideCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexOptPayoutReceiveSide',
    id: 2262,
    abbrName: 'OptRcv',
    description: 'Trade side of payout receiver.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexOptPayoutUnderlier',
    id: 2263,
    abbrName: 'OptUndlr',
    description: 'Reference to the underlier whose payments are being passed through.',
  },
  {
    type: 'Percentage',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexOptPayoutPercentage',
    id: 2264,
    abbrName: 'OptPctage',
    description:
      'Percentage of observed price for calculating the payout associated with the event.',
  },
  {
    type: 'ComplexOptPayoutTimeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexOptPayoutTime',
    id: 2265,
    abbrName: 'OptTm',
    description: 'The time when the payout is to occur.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Currency',
    addedEP: '169',
    updatedEP: '273',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexOptPayoutCurrency',
    id: 2266,
    abbrName: 'OptCcy',
    description:
      'Specifies the currency of the payout amount.\n\nUnderlyingComplexOptPayoutCurrencyCodeSource(2947) may be used to disambiguate the code source scheme used, and ISO 4217 is the default scheme if absent.',
  },
  {
    type: 'Percentage',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventPricePercentage',
    id: 2267,
    abbrName: 'PxPctage',
    description:
      'Specifies the price percentage at which the complex event takes effect. Impact of the event price is determined by the UnderlyingComplexEventType(2046).',
  },
  {
    updated: 'FIX.Latest',
    type: 'Currency',
    addedEP: '169',
    updatedEP: '273',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventCurrencyOne',
    id: 2268,
    abbrName: 'Ccy1',
    description:
      'Specifies the first or only reference currency of the trade.\n\nUnderlyingComplexEventCurrencyOneCodeSource(2948) may be used to disambiguate the code source scheme used, and ISO 4217 is the default scheme if absent.\n\nApplicable for complex FX option strategies.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Currency',
    addedEP: '169',
    updatedEP: '273',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventCurrencyTwo',
    id: 2269,
    abbrName: 'Ccy2',
    description:
      'Specifies the second reference currency of the trade.\n\nUnderlyingComplexEventCurrencyTwoCodeSource(2949) may be used to disambiguate the code source scheme used, and ISO 4217 is the default scheme if absent.\n\nApplicable for complex FX option strategies.',
  },
  {
    type: 'ComplexEventQuoteBasisCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventQuoteBasis',
    id: 2270,
    abbrName: 'QteBasis',
    description: 'Specifies the currency pairing for the quote.',
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventFixedFXRate',
    id: 2271,
    abbrName: 'Rt',
    description: 'Specifies the fixed FX rate alternative for FX Quantro options.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventDeterminationMethod',
    id: 2272,
    abbrName: 'Meth',
    description:
      'Specifies the method according to which an amount or a date is determined.\n\nSee http://www.fpml.org/coding-scheme/determination-method for values.',
  },
  {
    type: 'ProvisionCalculationAgentCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventCalculationAgent',
    id: 2273,
    abbrName: 'CalcAgent',
    description: 'Used to identify the calculation agent.',
  },
  {
    type: 'Price',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventStrikePrice',
    id: 2274,
    abbrName: 'StrkPx',
    description:
      'Upper strike price for Asian option feature. Strike percentage for a Strike Spread.',
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventStrikeFactor',
    id: 2275,
    abbrName: 'StrkFctr',
    description:
      'Strike factor for Asian option feature. Upper strike percentage for a Strike Spread.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventStrikeNumberOfOptions',
    id: 2276,
    abbrName: 'StrkNum',
    description: 'Upper string number of options for a Strike Spread.',
  },
  {
    type: 'XIDREF',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventCreditEventsXIDRef',
    id: 2277,
    abbrName: 'CdtEvntXIDRef',
    description: 'Reference to credit event table elsewhere in the message.',
  },
  {
    type: 'ComplexEventCreditEventNotifyingPartyCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventCreditEventNotifyingParty',
    id: 2278,
    abbrName: 'NotifygPty',
    description:
      'The notifying party is the party that notifies the other party when a credit event has occurred by means of a credit event notice. If more than one party is referenced as being the notifying party then either party may notify the other of a credit event occurring.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventCreditEventBusinessCenter',
    id: 2279,
    abbrName: 'BizCtr',
    description:
      'Specifies the local business center for which the credit event is to be determined. The inclusion of this business center implies that Greenwich Mean Time in Section 3.3 of the 2003 ISDA Credit Derivatives Definitions is replaced by the local time of the specified business center.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventCreditEventStandardSources',
    id: 2280,
    abbrName: 'StdSrcs',
    description:
      "When this element is specified and set to 'Y', indicates that ISDA defined Standard Public Sources are applicable.",
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventCreditEventMinimumSources',
    id: 2281,
    abbrName: 'MinSrcs',
    description:
      'The minimum number of the specified public information sources that must publish information that reasonably confirms that a credit event has occurred. The market convention is two.\n\nISDA 2003 Term: Specified Number.',
  },
  {
    type: 'XID',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventXID',
    id: 2282,
    abbrName: 'XID',
    description:
      'Identifier of this complex event for cross referencing elsewhere in the message.',
  },
  {
    type: 'XIDREF',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventXIDRef',
    id: 2283,
    abbrName: 'XIDRef',
    description: 'Reference to a complex event elsewhere in the message.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingComplexEventSchedules',
    id: 41750,
    description: 'Number of schedules in the repeating group.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventScheduleStartDate',
    id: 41751,
    abbrName: 'StartDt',
    description: 'The start date of the schedule.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventScheduleEndDate',
    id: 41752,
    abbrName: 'EndDt',
    description: 'The end date of the schedule.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventScheduleFrequencyPeriod',
    id: 41753,
    abbrName: 'FreqPeriod',
    description: 'Time unit multiplier for the schedule date frequency.',
  },
  {
    type: 'ProtectionTermEventUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventScheduleFrequencyUnit',
    id: 41754,
    abbrName: 'FreqUnit',
    description: 'Time unit associated with the schedule date frequency.',
  },
  {
    type: 'DateRollConventionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventScheduleRollConvention',
    id: 41755,
    abbrName: 'Roll',
    description:
      'The convention for determining the sequence of dates. It is used in conjunction with a specified frequency. Used only to override the roll convention defined in the UnderlyingDateAdjustment component in UnderlyingInstrument.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingDeliverySchedules',
    id: 41756,
    description: 'Number of delivery schedules in the repeating group.',
  },
  {
    type: 'DeliveryScheduleTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryScheduleType',
    id: 41757,
    abbrName: 'Typ',
    description: 'Specifies the type of delivery schedule.',
  },
  {
    type: 'XID',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryScheduleXID',
    id: 41758,
    abbrName: 'XID',
    description:
      'Identifier for this instance of delivery schedule for cross referencing elsewhere in the message.',
  },
  {
    type: 'Qty',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryScheduleNotional',
    id: 41759,
    abbrName: 'Notl',
    description: 'Physical delivery quantity.',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryScheduleNotionalUnitOfMeasure',
    id: 41760,
    abbrName: 'NotlUOM',
    description: 'Specifies the delivery quantity unit of measure (UOM).',
  },
  {
    type: 'StreamNotionalCommodityFrequencyCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryScheduleNotionalCommodityFrequency',
    id: 41761,
    abbrName: 'NotlFreq',
    description: 'The frequency of notional delivery.',
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryScheduleNegativeTolerance',
    id: 41762,
    abbrName: 'NegtvTlrnc',
    description:
      'Specifies the negative tolerance value. The value may be an absolute quantity or a percentage, as specified in UnderlyingDeliveryScheduleToleranceType(41765). Percentage value is to be expressed relative to "1.0" representing 100% (e.g. a value of "0.0575" represents 5.75%).',
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliverySchedulePositiveTolerance',
    id: 41763,
    abbrName: 'PostvTlrnc',
    description:
      'Specifies the positive tolerance value. The value may be an absolute quantity or a percentage, as specified in UnderlyingDeliveryScheduleToleranceType(41765). Value may exceed agreed upon value. Percentage value is to be expressed relative to "1.0" representing 100% (e.g. a value of "0.0575" represents 5.75%).',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryScheduleToleranceUnitOfMeasure',
    id: 41764,
    abbrName: 'TlrncUOM',
    description: "Specifies the tolerance value's unit of measure (UOM).",
  },
  {
    type: 'DeliveryScheduleToleranceTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryScheduleToleranceType',
    id: 41765,
    abbrName: 'TlrncTyp',
    description: 'Specifies the tolerance value type.',
  },
  {
    type: 'Country',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryScheduleSettlCountry',
    id: 41766,
    abbrName: 'Ctry',
    description:
      'Specifies the country where delivery takes place. Uses ISO 3166 2-character country code.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryScheduleSettlTimeZone',
    id: 41767,
    abbrName: 'TZ',
    description:
      'Delivery timezone specified as "prevailing" rather than "standard" or "daylight".\n\nSee http://www.fixtradingcommunity.org/codelists#Prevailing_Timezones for code list of applicable prevailing timezones.',
  },
  {
    type: 'DeliveryScheduleSettlFlowTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryScheduleSettlFlowType',
    id: 41768,
    abbrName: 'FlowTyp',
    description: 'Specifies the delivery flow type.',
  },
  {
    type: 'DeliveryScheduleSettlHolidaysProcessingInstructionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryScheduleSettlHolidaysProcessingInstruction',
    id: 41769,
    abbrName: 'Holidays',
    description:
      'Indicates whether holidays are included in the settlement periods. Required for electricity contracts.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingDeliveryScheduleSettlDays',
    id: 41770,
    description: 'Number of delivery schedules in the repeating group.',
  },
  {
    type: 'DeliveryScheduleSettlDayCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryScheduleSettlDay',
    id: 41771,
    abbrName: 'Day',
    description: 'Specifies the day or group of days for delivery.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryScheduleSettlTotalHours',
    id: 41772,
    abbrName: 'TotHrs',
    description:
      'The sum of the total hours specified in the UnderlyingDeliveryScheduleSettlTimeGrp component.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingDeliveryScheduleSettlTimes',
    id: 41773,
    description: 'Number of hour ranges in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryScheduleSettlStart',
    id: 41774,
    abbrName: 'Start',
    description:
      'The scheduled start time for the delivery of the commodity where delivery occurs over specified times. The format of the time value is specified in UnderlyingDeliveryScheduleSettlTimeType(41776).',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryScheduleSettlEnd',
    id: 41775,
    abbrName: 'End',
    description:
      'The scheduled end time for the delivery of the commodity where delivery occurs over specified times. The format of the time value is specified in UnderlyingDeliveryScheduleSettlTimeType(41776).',
  },
  {
    type: 'DeliveryScheduleSettlTimeTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryScheduleSettlTimeType',
    id: 41776,
    abbrName: 'Typ',
    description: 'Specifies the format of the delivery start and end time values.',
  },
  {
    type: 'DeliveryStreamTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryStreamType',
    id: 41777,
    abbrName: 'Typ',
    description: 'Specifies the type of delivery stream.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryStreamPipeline',
    id: 41778,
    abbrName: 'Ppln',
    description: 'The name of the oil delivery pipeline.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryStreamEntryPoint',
    id: 41779,
    abbrName: 'EntryPnt',
    description:
      'The point at which the commodity will enter the delivery mechanism or pipeline.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryStreamWithdrawalPoint',
    id: 41780,
    abbrName: 'WthdrwlPnt',
    description:
      'The point at which the commodity product will be withdrawn prior to delivery.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryStreamDeliveryPoint',
    id: 41781,
    abbrName: 'DlvryPnt',
    discriminatorId: '42196',
    description:
      'The point at which the commodity product will be delivered and received. Value specified should follow market convention appropriate for the commodity product.\n\nFor bullion see http://www.fpml.org/coding-scheme/bullion-delivery-location for values.',
  },
  {
    type: 'DeliveryStreamDeliveryRestrictionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryStreamDeliveryRestriction',
    id: 41782,
    abbrName: 'DlvryRstctn',
    description:
      'Specifies under what conditions the buyer and seller should be excused of their delivery obligations.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryStreamDeliveryContingency',
    id: 41783,
    abbrName: 'Cntgncy',
    description:
      'Specifies the electricity delivery contingency.\n\nSee http://www.fpml.org/coding-scheme/electricity-transmission-contingency for values.',
  },
  {
    type: 'DeliveryStreamElectingPartySideCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryStreamDeliveryContingentPartySide',
    id: 41784,
    abbrName: 'CntgPty',
    description:
      'The trade side value of the party responsible for electricity delivery contingency.',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryStreamDeliverAtSourceIndicator',
    id: 41785,
    abbrName: 'DlvrAtSrc',
    description:
      "When this element is specified and set to 'Y', delivery of the coal product is to be at its source.",
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryStreamRiskApportionment',
    id: 41786,
    abbrName: 'RiskApprtnmt',
    discriminatorId: '41587',
    description:
      'Specifies how the parties to the trade apportion responsibility for the delivery of the commodity product.\n\nSee http://www.fixtradingcommunity.org/codelists#Risk_Apportionment for the details of the external code list.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryStreamRiskApportionmentSource',
    id: 41587,
    abbrName: 'RiskApprtnmtSrc',
    description:
      'Specifies the source or legal framework for the risk apportionment.\n\nSee http://www.fixtradingcommunity.org/codelists#Risk_Apportionment_Source for the details of the external code list.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryStreamTitleTransferLocation',
    id: 41787,
    abbrName: 'TtlXfer',
    description: 'Specifies the title transfer location.',
  },
  {
    type: 'DeliveryStreamTitleTransferConditionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryStreamTitleTransferCondition',
    id: 41788,
    abbrName: 'TltXferCond',
    description: 'Specifies the title transfer condition.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryStreamImporterOfRecord',
    id: 41789,
    abbrName: 'Imprtr',
    description:
      'A party, not necessarily of the trade, who is the Importer of Record for the purposes of paying customs duties and applicable taxes or costs related to importation.',
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryStreamNegativeTolerance',
    id: 41790,
    abbrName: 'NegtvTlrnc',
    description:
      'Specifies the negative tolerance value. The value may be an absolute quantity or a percentage, as specified in UnderlyingDeliveryStreamToleranceType(41793). Percentage value is to be expressed relative to "1.0" representing 100% (e.g. a value of "0.0575" represents 5.75%).',
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryStreamPositiveTolerance',
    id: 41791,
    abbrName: 'PostvTlrnc',
    description:
      'Specifies the positive tolerance value. The value may be an absolute quantity or a percentage, as specified in UnderlyingDeliveryStreamToleranceType(41793). Value may exceed agreed upon value. Percentage value is to be expressed relative to "1.0" representing 100% (e.g. a value of "0.0575" represents 5.75%).',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryStreamToleranceUnitOfMeasure',
    id: 41792,
    abbrName: 'TlrncUOM',
    description: "Specifies the tolerance value's unit of measure (UOM).",
  },
  {
    type: 'DeliveryScheduleToleranceTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryStreamToleranceType',
    id: 41793,
    abbrName: 'TlrncTyp',
    description: 'Specifies the tolerance value type.',
  },
  {
    type: 'DeliveryStreamToleranceOptionSideCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryStreamToleranceOptionSide',
    id: 41794,
    abbrName: 'TlrncOptSide',
    description: "Indicates whether the tolerance is at the seller's or buyer's option.",
  },
  {
    type: 'Percentage',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryStreamTotalPositiveTolerance',
    id: 41795,
    abbrName: 'TotPostvTlrnc',
    description:
      'The positive percent tolerance which applies to the total quantity delivered over all shipment periods.\n\nPercentage value is to be expressed relative to "1.0" representing 100% (e.g. a value of "0.0575" represents 5.75%.).',
  },
  {
    type: 'Percentage',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryStreamTotalNegativeTolerance',
    id: 41796,
    abbrName: 'TotNegtvTlrnc',
    description:
      'The negative percent tolerance which applies to the total quantity delivered over all shipment periods.\n\nPercentage value is to be expressed relative to "1.0" representing 100% (e.g. a value of "0.0575" represents 5.75%.).',
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryStreamNotionalConversionFactor',
    id: 41797,
    abbrName: 'CnvrsnFctr',
    description:
      'If the notional quantity is specified in a unit that does not match the unit in which the commodity reference price is quoted, the scaling or conversion factor used to convert the commodity reference price unit into the notional quantity unit should be stated here. If there is no conversion, this field is not intended to be used.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryStreamTransportEquipment',
    id: 41798,
    abbrName: 'Eqpmt',
    description:
      'The transportation equipment with which the commodity product will be delivered and received.\n\nExamples of transportation equipment or mode are barge, truck, railcar, etc.',
  },
  {
    type: 'DeliveryStreamElectingPartySideCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryStreamElectingPartySide',
    id: 41799,
    abbrName: 'ElctngSide',
    description:
      'A reference to the party able to choose whether the gas is delivered for a particular period e.g. a swing or interruptible contract.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingStreamAssetAttributes',
    id: 41800,
    description: 'Number of asset attribute entries in the group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamAssetAttributeType',
    id: 41801,
    abbrName: 'Typ',
    description:
      'Specifies the name of the attribute.\n\nSee http://www.fixtradingcommunity.org/codelists#Asset_Attribute_Types for code list of applicable asset attribute types.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamAssetAttributeValue',
    id: 41802,
    abbrName: 'Val',
    description: 'Specifies the value of the attribute.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamAssetAttributeLimit',
    id: 41803,
    abbrName: 'Lmt',
    description: 'The limit or lower acceptable value of the attribute.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingDeliveryStreamCycles',
    id: 41804,
    description: 'Number of delivery cycles in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryStreamCycleDesc',
    id: 41805,
    abbrName: 'Desc',
    description:
      'The delivery cycles during which the oil product will be transported in the pipeline.',
  },
  {
    type: 'Length',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'EncodedUnderlyingDeliveryStreamCycleDescLen',
    id: 41806,
    abbrName: 'EncDescLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedUnderlyingDeliveryStreamCycleDesc(41807) field.',
  },
  {
    type: 'data',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'EncodedUnderlyingDeliveryStreamCycleDesc',
    id: 41807,
    abbrName: 'EncDesc',
    lengthId: '41806',
    description:
      'Encoded (non-ASCII characters) representation of the UnderlyingDeliveryStreamCycleDesc(41805) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the UnderlyingDeliveryStreamCycleDesc(41805) field.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingDeliveryStreamCommoditySources',
    id: 41808,
    description: 'Number of commodity sources in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryStreamCommoditySource',
    id: 41809,
    abbrName: 'Src',
    description:
      'The SCoTA coal cargo origin, mining region, mine(s), mining complex(es), loadout(s) or river dock(s) or other point(s) of origin that seller and buyer agree are acceptable origins for the coal product. For international coal transactions, this is the origin of the coal product.\n\nSee http://www.fpml.org/coding-scheme/commodity-coal-product-source for values.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingExerciseDesc',
    id: 41810,
    abbrName: 'Desc',
    description: 'A description of the option exercise.',
  },
  {
    type: 'Length',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'EncodedUnderlyingExerciseDescLen',
    id: 41811,
    abbrName: 'EncDescLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedUnderlyingExerciseDesc(41812) field.',
  },
  {
    type: 'data',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'EncodedUnderlyingExerciseDesc',
    id: 41812,
    abbrName: 'EncDesc',
    lengthId: '41811',
    description:
      'Encoded (non-ASCII characters) representation of the UnderlyingExerciseDesc(41810) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the UnderlyingExerciseDesc(41810) field.',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingAutomaticExerciseIndicator',
    id: 41813,
    abbrName: 'AutoExerInd',
    description:
      "Indicates (when 'Y') that exercise is automatic when the strike price is crossed or the underlying trade is in the money.",
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingAutomaticExerciseThresholdRate',
    id: 41814,
    abbrName: 'AutoRt',
    description: 'The threshold rate for triggering automatic exercise.',
  },
  {
    type: 'ExerciseConfirmationMethodCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingExerciseConfirmationMethod',
    id: 41815,
    abbrName: 'ExerCnfm',
    description:
      "Indicates whether follow-up confirmation of exercise (written or electronic) is required following telephonic notice by the buyer to the seller or seller's agent.",
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingManualNoticeBusinessCenter',
    id: 41816,
    abbrName: 'ManNtcBizCtr',
    description:
      'Identifies the business center used for adjusting the time for manual exercise notice.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingFallbackExerciseIndicator',
    id: 41817,
    abbrName: 'FallbckExerInd',
    description:
      'Indicates whether the notional amount of the underlying swap, not previously exercised under the option, will be automatically exercised at the expiration time on the expiration date if at such time the buyer is in-the-money, provided that the difference between the settlement rate and the fixed rate under the relevant underlying swap is not less than one tenth of a percentage point (0.10% or 0.001).',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingLimitedRightToConfirmIndicator',
    id: 41818,
    abbrName: 'LtdRightCnfmInd',
    description:
      'Indicates whether the Seller may request the Buyer to confirm its intent to exercise if not done on or before the expiration time on the Expiration date. If true ("Y") specific rules will apply in relation to the settlement mode.',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingExerciseSplitTicketIndicator',
    id: 41819,
    abbrName: 'ExerSplitTktInd',
    description:
      'Indicates in physical settlement of bond and convertible bond options whether the party required to deliver the bonds will divide those to be delivered as notifying party desires to facilitate delivery obligations.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingOptionExerciseBusinessCenters',
    id: 41820,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingOptionExerciseBusinessCenter',
    id: 41821,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the option exercise dates, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingOptionExerciseBusinessDayConvention',
    id: 41822,
    abbrName: 'BizDayCnvtn',
    description:
      'The business day convention used to adjust the option exercise dates. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'ComplexEventDateOffsetDayTypeCodeSet',
    addedEP: '169',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingOptionExerciseEarliestDateOffsetDayType',
    id: 41823,
    abbrName: 'ErlstOfstDayTyp',
    description: 'Specifies the day type of the relative earliest exercise date offset.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingOptionExerciseEarliestDateOffsetPeriod',
    id: 41824,
    abbrName: 'ErlstOfstPeriod',
    description: 'Time unit multiplier for the relative earliest exercise date offset.',
  },
  {
    type: 'ProvisionOptionExerciseEarliestDateOffsetUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingOptionExerciseEarliestDateOffsetUnit',
    id: 41825,
    abbrName: 'ErlstOfstUnit',
    description: 'Time unit associated with the relative earliest exercise date offset.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingOptionExerciseFrequencyPeriod',
    id: 41826,
    abbrName: 'FreqPeriod',
    description: 'Time unit multiplier for the frequency of exercise dates.',
  },
  {
    type: 'ProtectionTermEventUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingOptionExerciseFrequencyUnit',
    id: 41827,
    abbrName: 'FreqUnit',
    description: 'Time unit associated with the frequency of exercise dates.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingOptionExerciseStartDateUnadjusted',
    id: 41828,
    abbrName: 'StartDtUnadj',
    description: 'The unadjusted start date for calculating periodic exercise dates.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '169',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingOptionExerciseStartDateRelativeTo',
    id: 41829,
    abbrName: 'StartDtReltv',
    description:
      'Specifies the anchor date when the option exercise start date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingOptionExerciseStartDateOffsetPeriod',
    id: 41830,
    abbrName: 'StartDtOfstPeriod',
    description: 'Time unit multiplier for the relative exercise start date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingOptionExerciseStartDateOffsetUnit',
    id: 41831,
    abbrName: 'StartDtOfstUnit',
    description: 'Time unit associated with the relative exercise start date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '169',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingOptionExerciseStartDateOffsetDayType',
    id: 41832,
    abbrName: 'StartDtOfstDayTyp',
    description:
      'Specifies the day type of the relative option exercise start date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingOptionExerciseStartDateAdjusted',
    id: 41833,
    abbrName: 'StartDt',
    description: 'The adjusted start date for calculating periodic exercise dates.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingOptionExerciseSkip',
    id: 41834,
    abbrName: 'Skip',
    description:
      'The number of periods in the referenced date schedule that are between each date in the relative date schedule. Thus a skip of 2 would mean that dates are relative to every second date in the referenced schedule. If present this should have a value greater than 1.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingOptionExerciseNominationDeadline',
    id: 41835,
    abbrName: 'NomntnDdln',
    description: 'The last date (adjusted) for establishing the option exercise terms.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingOptionExerciseFirstDateUnadjusted',
    id: 41836,
    abbrName: 'FirstDtUnadj',
    description: 'The unadjusted first exercise date.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingOptionExerciseLastDateUnadjusted',
    id: 41837,
    abbrName: 'LastDtUnadj',
    description: 'The unadjusted last exercise date.',
  },
  {
    type: 'LocalMktTime',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingOptionExerciseEarliestTime',
    id: 41838,
    abbrName: 'ErlstTm',
    description:
      "The earliest time at which notice of exercise can be given by the buyer to the seller (or seller's agent) (i) on the expriation date, in the case of a European style option, (ii) on each Bermuda option exercise date and the expiration date, in the case of a Bermuda style option, (iii) the commencement date to, and including, the expiration date, in the case of an American option.",
  },
  {
    type: 'LocalMktTime',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingOptionExerciseLatestTime',
    id: 41839,
    abbrName: 'LtstTm',
    description:
      'Latest exercise time. See also UnderlyingOptionExerciseEarliestTime(41838).',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingOptionExerciseTimeBusinessCenter',
    id: 41840,
    abbrName: 'TmBizCtr',
    description:
      'The business center used to determine the locale for option exercise time, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingOptionExerciseDates',
    id: 41841,
    description: 'Number of dates in the repeating group.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingOptionExerciseDate',
    id: 41842,
    abbrName: 'Dt',
    description: 'The adjusted or unadjusted option exercise fixed date.',
  },
  {
    type: 'OptionExerciseDateTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingOptionExerciseDateType',
    id: 41843,
    abbrName: 'Typ',
    description:
      'Specifies the type of option exercise date. When specified it applies not only to the current date but to all subsequent dates in the group until overridden with a new type.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingOptionExerciseExpirationDateBusinessCenters',
    id: 41844,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingOptionExerciseExpirationDateBusinessCenter',
    id: 41845,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the option exercise expiration dates, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingOptionExerciseExpirationDateBusinessDayConvention',
    id: 41846,
    abbrName: 'BizDayCnvtn',
    description:
      'The business day convention used to adjust the option exercise expiration dates. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '169',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingOptionExerciseExpirationDateRelativeTo',
    id: 41847,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the option exercise expiration date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingOptionExerciseExpirationDateOffsetPeriod',
    id: 41848,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative exercise expiration date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingOptionExerciseExpirationDateOffsetUnit',
    id: 41849,
    abbrName: 'OfstUnit',
    description:
      'Time unit associated with the relative exercise expiration date offset.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingOptionExerciseExpirationFrequencyPeriod',
    id: 41850,
    abbrName: 'FreqPeriod',
    description: 'Time unit multiplier for the frequency of exercise expiration dates.',
  },
  {
    type: 'ProtectionTermEventUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingOptionExerciseExpirationFrequencyUnit',
    id: 41851,
    abbrName: 'FreqUnit',
    description: 'Time unit associated with the frequency of exercise expiration dates.',
  },
  {
    type: 'DateRollConventionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingOptionExerciseExpirationRollConvention',
    id: 41852,
    abbrName: 'Roll',
    description:
      'The convention for determining the sequence of exercise expiration dates. It is used in conjunction with a specified frequency. Used only to override the roll convention defined in the UnderlyingDateAdjustment component in UnderlyingInstrument.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'ComplexEventDateOffsetDayTypeCodeSet',
    addedEP: '169',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingOptionExerciseExpirationDateOffsetDayType',
    id: 41853,
    abbrName: 'OfstDayTyp',
    description:
      'Specifies the day type of the relative option exercise expiration date offset.',
  },
  {
    type: 'LocalMktTime',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingOptionExerciseExpirationTime',
    id: 41854,
    abbrName: 'Tm',
    description: 'The option exercise expiration time.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingOptionExerciseExpirationTimeBusinessCenter',
    id: 41855,
    abbrName: 'TmBizCtr',
    description:
      'The business center used to determine the locale for option exercise expiration time, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingOptionExerciseExpirationDates',
    id: 41856,
    description: 'Number of fixed exercise expiration dates in the repeating group.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingOptionExerciseExpirationDate',
    id: 41857,
    abbrName: 'Dt',
    description: 'The adjusted or unadjusted option exercise expiration fixed date.',
  },
  {
    type: 'OptionExerciseDateTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingOptionExerciseExpirationDateType',
    id: 41858,
    abbrName: 'Typ',
    description:
      'Specifies the type of option exercise expiration date. When specified it applies not only to the current date but to all subsequent dates in the group until overridden with a new type.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingSettlRateIndex',
    id: 2284,
    abbrName: 'SettlNdx',
    description:
      'In an outright or forward commodity trade that is cash settled this is the index used to determine the cash payment.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingSettlRateIndexLocation',
    id: 2285,
    abbrName: 'SettlNdxLctn',
    description:
      'This is an optional qualifying attribute of UnderlyingSettlementRateIndex(2284) such as the delivery zone for an electricity contract.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingOptionExpirationDesc',
    id: 2286,
    abbrName: 'ExpDesc',
    description: 'Description of the option expiration.',
  },
  {
    type: 'Length',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'EncodedUnderlyingOptionExpirationDescLen',
    id: 2287,
    abbrName: 'EncExpDescLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedUnderlyingOptionExpirationDesc(2288) field.',
  },
  {
    type: 'data',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'EncodedUnderlyingOptionExpirationDesc',
    id: 2288,
    abbrName: 'EncExpDesc',
    lengthId: '2287',
    description:
      'Encoded (non-ASCII characters) representation of the UnderlyingOptionExpirationDesc(2286) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the UnderlyingOptionExpirationDesc(2286).',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'SwapSubClassCodeSet',
    addedEP: '169',
    updatedEP: '238',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingSwapSubClass',
    id: 2289,
    abbrName: 'SwapSubClss',
    description: 'The sub-classification or notional schedule type of the swap.',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStrikeUnitOfMeasure',
    id: 2290,
    abbrName: 'StrkUOM',
    description:
      'Used to express the unit of measure (UOM) of the price if different from the contract.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStrikeIndex',
    id: 2291,
    abbrName: 'StrkNdx',
    description: 'Specifies the index used to calculate the strike price.',
  },
  {
    type: 'PriceOffset',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStrikeIndexSpread',
    id: 2292,
    abbrName: 'StrkSpread',
    description: 'Specifies the strike price offset from the named index.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingValuationSource',
    id: 2293,
    abbrName: 'ValSrc',
    description: 'Specifies the source of trade valuation data.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingValuationReferenceModel',
    id: 2294,
    abbrName: 'ValRefModel',
    description:
      'Specifies the methodology and/or assumptions used to generate the trade value.',
  },
  {
    type: 'StrategyTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStrategyType',
    id: 2295,
    abbrName: 'StrtTyp',
    description: 'Specifies the type of trade strategy.',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingCommonPricingIndicator',
    id: 2296,
    abbrName: 'CmnPxng',
    description:
      "When this element is specified and set to 'Y', it indicates that common pricing applies. Common pricing may be relevant for a transaction that references more than one commodity reference price.",
  },
  {
    type: 'SettlDisruptionProvisionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingSettlDisruptionProvision',
    id: 2297,
    abbrName: 'SettlDsrptnProv',
    description: 'Specifies the consequences of settlement disruption events.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'RoundingDirectionCodeSet',
    addedEP: '169',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingInstrumentRoundingDirection',
    id: 2298,
    abbrName: 'RndDirctn',
    description: 'Specifies the rounding direction if not overridden elsewhere.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingInstrumentRoundingPrecision',
    id: 2299,
    abbrName: 'RndPrcsn',
    description:
      'Specifies the rounding precision in terms of a number of decimal places. Note how a percentage rate rounding of 5 decimal places is expressed as a rounding precision of 7.',
  },
  {
    type: 'MarketDisruptionProvisionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingMarketDisruptionProvision',
    id: 41859,
    abbrName: 'Prov',
    description: 'The consequences of market disruption events.',
  },
  {
    type: 'MarketDisruptionFallbackProvisionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingMarketDisruptionFallbackProvision',
    id: 41860,
    abbrName: 'FallbckProv',
    description: 'Specifies the location of the fallback provision documentation.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingMarketDisruptionMaximumDays',
    id: 41861,
    abbrName: 'MaxDays',
    description:
      'Specifies the maximum number of market disruption days (commodity or bullion business days) in a contract or confirmation. If none are specified, the maximum number of market disruption days is five (5).\n\nISDA 2005 Commodity Definition.',
  },
  {
    type: 'Percentage',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingMarketDisruptionMaterialityPercentage',
    id: 41862,
    abbrName: 'MtrltyPctage',
    description:
      'Used when a price materiality percentage applies to the price source disruption event and this event has been specified.\n\nApplicable to 2005 Commodity Definitions only.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingMarketDisruptionMinimumFuturesContracts',
    id: 41863,
    abbrName: 'MinCtrcts',
    description:
      "Specifies the minimum futures contracts level that dictates whether or not a 'De Minimis Trading' event has occurred.\n\nApplicable to 1993 Commodity Definitions only.",
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingMarketDisruptionEvents',
    id: 41864,
    description: 'Number of disruption events in the repeating group.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    addedEP: '169',
    updatedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingMarketDisruptionEvent',
    id: 41865,
    abbrName: 'Evnt',
    description:
      'Specifies the market disruption event.\n\nFor commodities see http://www.fpml.org/coding-scheme/commodity-market-disruption for values.\n\nFor foreign exchange, see http://www.fixtradingcommunity.org/codelists#Market_Disruption_Event for code list of applicable event types.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingMarketDisruptionFallbacks',
    id: 41866,
    description: 'Number of fallbacks in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingMarketDisruptionFallbackType',
    id: 41867,
    abbrName: 'Typ',
    description:
      'Specifies the type of disruption fallback.\n\nSee http://www.fpml.org/coding-scheme/commodity-market-disruption-fallback for values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingMarketDisruptionFallbackReferencePrices',
    id: 41868,
    description: 'Number of fallback reference securities in the repeating group.',
  },
  {
    type: 'MarketDisruptionFallbackUnderlierTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingMarketDisruptionFallbackUnderlierType',
    id: 41869,
    abbrName: 'Typ',
    description: 'The type of reference price underlier.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingMarketDisruptionFallbackUnderlierSecurityID',
    id: 41870,
    abbrName: 'ID',
    discriminatorId: '41871',
    description: 'Specifies the identifier value of the security.',
  },
  {
    updated: 'FIX.Latest',
    type: 'SecurityIDSourceCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '169',
    updatedEP: '265',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingMarketDisruptionFallbackUnderlierSecurityIDSource',
    id: 41871,
    abbrName: 'Src',
    description: 'Specifies the class or source scheme of the security identifier.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingMarketDisruptionFallbackUnderlierSecurityDesc',
    id: 41872,
    abbrName: 'Desc',
    description: 'Specifies the description of underlying security.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Length',
    addedEP: '169',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'EncodedUnderlyingMarketDisruptionFallbackUnderlierSecDescLen',
    id: 41873,
    abbrName: 'EncDescLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedUnderlyingMarketDisruptionFallbackUnderlierSecurityDesc(41874) field.',
  },
  {
    type: 'data',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'EncodedUnderlyingMarketDisruptionFallbackUnderlierSecurityDesc',
    id: 41874,
    abbrName: 'EncDesc',
    lengthId: '41873',
    description:
      'Encoded (non-ASCII characters) representation of the UnderlyingMarketDisruptionFallbackUnderlierSecurityDesc(41872) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the UnderlyingMarketDisruptionFallbackUnderlierSecurityDesc(41872).',
  },
  {
    type: 'Qty',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingMarketDisruptionFallbackOpenUnits',
    id: 41875,
    abbrName: 'OpnUnits',
    description:
      'If there are multiple underlying assets, this specifies the number of units (index or securities) that constitute the underlier of the swap. In the case of a basket swap, this is used to reference both the number of basket units, and the number of each asset components of the basket when these are expressed in absolute terms.',
  },
  {
    type: 'Currency',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingMarketDisruptionFallbackBasketCurrency',
    id: 41876,
    abbrName: 'Ccy',
    description:
      'Specifies the currency if the underlier is a basket. Uses ISO 4217 currency codes.',
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingMarketDisruptionFallbackBasketDivisor',
    id: 41877,
    abbrName: 'Dvsr',
    description:
      'Specifies the basket divisor amount. This value is normally used to adjust the constituent weight for pricing or to adjust for dividends, or other corporate actions.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingPaymentScheduleFixingDays',
    id: 41878,
    description: 'Number of fixing days in the repeating group.',
  },
  {
    type: 'PaymentStreamPricingDayOfWeekCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleFixingDayOfWeek',
    id: 41879,
    abbrName: 'DayOfWk',
    description: 'The day of the week on which fixing takes place.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleFixingDayNumber',
    id: 41880,
    abbrName: 'DayNum',
    description:
      'The occurrence of the day of week on which fixing takes place.\n\nFor example, a fixing of the 3rd Friday would be DayOfWk=5 DayNum=3. If omitted every day of the week is a fixing day.',
  },
  {
    type: 'XID',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleXID',
    id: 41881,
    abbrName: 'XID',
    description:
      'Identifier of this UnderlyingPaymentSchedule for cross referencing elsewhere in the message.',
  },
  {
    type: 'XIDREF',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleXIDRef',
    id: 41882,
    abbrName: 'XIDRef',
    description: 'Reference to payment schedule elsewhere in the message.',
  },
  {
    type: 'Currency',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleRateCurrency',
    id: 41883,
    abbrName: 'RtCcy',
    description:
      'Specifies the currency of the schedule rate. Uses ISO 4217 currency codes.',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleRateUnitOfMeasure',
    id: 41884,
    abbrName: 'RtUOM',
    description: 'The schedule rate unit of measure (UOM).',
  },
  {
    updated: 'FIX.Latest',
    type: 'float',
    addedEP: '169',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleRateConversionFactor',
    id: 41885,
    abbrName: 'RtFctr',
    description:
      "The number to be multiplied by the derived floating rate of the underlying's payment schedule in order to arrive at the payment rate. If omitted, the schedule rate conversion factor is 1.",
  },
  {
    type: 'PaymentStreamRateSpreadTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleRateSpreadType',
    id: 41886,
    abbrName: 'SpreadTyp',
    description:
      'Specifies whether the rate spread is an absolute value to be added to the index rate or a percentage of the index rate.',
  },
  {
    type: 'Price',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleSettlPeriodPrice',
    id: 41887,
    abbrName: 'SettlPx',
    description: 'The schedule settlement period price.',
  },
  {
    type: 'Currency',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleSettlPeriodPriceCurrency',
    id: 41888,
    abbrName: 'SettlPxCcy',
    description:
      'The currency of the schedule settlement period price. Uses ISO 4217 currency codes.',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleSettlPeriodPriceUnitOfMeasure',
    id: 41889,
    abbrName: 'SettlPxUOM',
    description: 'The settlement period price unit of measure (UOM).',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleStepUnitOfMeasure',
    id: 41890,
    abbrName: 'StepUOM',
    description: 'The schedule step unit of measure (UOM).',
  },
  {
    type: 'PaymentStreamPricingDayDistributionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleFixingDayDistribution',
    id: 41891,
    abbrName: 'FixngDayDistrib',
    description: 'The distribution of fixing days.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleFixingDayCount',
    id: 41892,
    abbrName: 'FixngDayCnt',
    description: 'The number of days over which fixing should take place.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleFixingLagPeriod',
    id: 41893,
    abbrName: 'FixngLagPeriod',
    description: 'Time unit multiplier for the fixing lag duration.',
  },
  {
    type: 'PaymentStreamInflationLagUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleFixingLagUnit',
    id: 41894,
    abbrName: 'FixngLagUnit',
    description: 'Time unit associated with the fixing lag duration.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '169',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleFixingFirstObservationDateOffsetPeriod',
    id: 41895,
    abbrName: 'FixngFirstObsvtnPeriod',
    description:
      'Time unit multiplier for the relative first observation date offset.\n\nIf the first observation offset is specified, the observation period will start the specified interval prior to each calculation period - i.e. if the first observation offset is 4 months and the lag duration is 3 months, observations will be taken in months 4, 3 and 2 (but not 1) prior to each calculation period. If no first observation offset is specified, the observation period will end immediately preceding each calculation period.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '169',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentScheduleFixingFirstObservationDateOffsetUnit',
    id: 41896,
    abbrName: 'FixngFirstObsvtnUnit',
    description: 'Time unit associated with the relative first observation date offset.',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFlatRateIndicator',
    id: 41897,
    abbrName: 'FlatRtInd',
    description:
      'When this element is specified and set to \'Y\', the Flat Rate is the New Worldwide Tanker Nominal Freight Scale for the Freight Index Route taken at the Trade Date of the transaction "Fixed". If \'N\' it is taken on each Pricing Date "Floating".',
  },
  {
    type: 'Amt',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFlatRateAmount',
    id: 41898,
    abbrName: 'FlatRtAmt',
    description:
      "Specifies the actual monetary value of the flat rate when UnderlyingPaymentStreamFlatRateIndicator(41897) = 'Y'.",
  },
  {
    type: 'Currency',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFlatRateCurrency',
    id: 41899,
    abbrName: 'FlatRtCcy',
    description:
      'Specifies the currency of the actual flat rate. Uses ISO 4217 currency codes.',
  },
  {
    type: 'Amt',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamMaximumPaymentAmount',
    id: 41900,
    abbrName: 'MaxPmtAmt',
    description: 'Specifies the limit on the total payment amount.',
  },
  {
    type: 'Currency',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamMaximumPaymentCurrency',
    id: 41901,
    abbrName: 'MaxPmtCcy',
    description:
      'Specifies the currency of total payment amount limit. Uses ISO 4217 currency codes.',
  },
  {
    type: 'Amt',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamMaximumTransactionAmount',
    id: 41902,
    abbrName: 'MaxTxnAmt',
    description:
      'Specifies the limit on the payment amount that goes out in any particular calculation period.',
  },
  {
    type: 'Currency',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamMaximumTransactionCurrency',
    id: 41903,
    abbrName: 'MaxTxnCcy',
    description:
      'Specifies the currency of the period payment amount limit. Uses ISO 4217 currency codes.',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFixedAmountUnitOfMeasure',
    id: 41904,
    abbrName: 'FixedAmtUOM',
    description: 'Fixed payment amount unit of measure (UOM).',
  },
  {
    type: 'Amt',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamTotalFixedAmount',
    id: 41905,
    abbrName: 'FixedAmt',
    description: 'Specifies the total fixed payment amount.',
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamWorldScaleRate',
    id: 41906,
    abbrName: 'WorldScaleRt',
    description:
      'The number of Worldscale points for purposes of the calculation of a fixed amount for a wet voyage charter commodity swap.',
  },
  {
    type: 'Price',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamContractPrice',
    id: 41907,
    abbrName: 'CtrctPx',
    description:
      'The price per relevant unit for purposes of the calculation of a fixed amount for a dry voyage charter or time charter commodity swap.',
  },
  {
    type: 'Currency',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamContractPriceCurrency',
    id: 41908,
    abbrName: 'CtrctPxCcy',
    description:
      'Specifies the currency of UnderlyingPaymentStreamContractPrice(41907). Uses ISO 4217 currency codes.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingPaymentStreamPricingBusinessCenters',
    id: 41909,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamPricingBusinessCenter',
    id: 41910,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the payment stream\'s pricing dates, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'PaymentStreamRateIndexCurveUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamRateIndex2CurveUnit',
    id: 41911,
    abbrName: 'Ndx2Unit',
    description:
      'Secondary time unit associated with the payment stream’s floating rate index curve.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamRateIndex2CurvePeriod',
    id: 41912,
    abbrName: 'Ndx2Period',
    description:
      'Secondary time unit multiplier for the payment stream’s floating rate index curve.\n\nMay be used for a Forward Rate Agreement (FRA) with an average rate between two curve points.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamRateIndexLocation',
    id: 41913,
    abbrName: 'NdxLctn',
    description: 'Specifies the location of the floating rate index.',
  },
  {
    type: 'Qty',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamRateIndexLevel',
    id: 41914,
    abbrName: 'NdxLvl',
    description:
      'This is the weather Cooling Degree Days (CDD), Heating Degree Days (HDD) or HDD index level specified as the number of (amount of) weather index units specified by the parties in the related confirmation.',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamRateIndexUnitOfMeasure',
    id: 41915,
    abbrName: 'NdxUOM',
    description: 'The unit of measure (UOM) of the rate index level.',
  },
  {
    type: 'PaymentStreamSettlLevelCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamSettlLevel',
    id: 41916,
    abbrName: 'SettlLvl',
    description: 'Specifies how weather index units are to be calculated.',
  },
  {
    type: 'Qty',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamReferenceLevel',
    id: 41917,
    abbrName: 'RefLvl',
    description:
      'This is the weather Cooling Degree Days (CDD), Heating Degree Days (HDD) or HDD reference level specified as the number of (amount of) weather index units specified by the parties in the related confirmation.',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamReferenceLevelUnitOfMeasure',
    id: 41918,
    abbrName: 'RefUOM',
    description: 'The unit of measure (UOM) of the rate reference level.',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamReferenceLevelEqualsZeroIndicator',
    id: 41919,
    abbrName: 'RefLvlZero',
    description:
      "When set to 'Y', it indicates that the weather reference level equals zero.",
  },
  {
    type: 'Currency',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamRateSpreadCurrency',
    id: 41920,
    abbrName: 'SpreadCcy',
    description:
      'Specifies the currency of the floating rate spread. Uses ISO 4217 currency codes.',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamRateSpreadUnitOfMeasure',
    id: 41921,
    abbrName: 'SpreadUOM',
    description: 'Specifies the unit of measure (UOM) of the floating rate spread.',
  },
  {
    type: 'float',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamRateConversionFactor',
    id: 41922,
    abbrName: 'RtFctr',
    description:
      "The number to be multiplied by the derived floating rate of the underlying's payment stream in order to arrive at the payment rate. If omitted, the floating rate conversion factor is 1.",
  },
  {
    type: 'PaymentStreamRateSpreadTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamRateSpreadType',
    id: 41923,
    abbrName: 'SpreadTyp',
    description:
      'Identifies whether the rate spread is an absolute value to be added to the index rate or a percentage of the index rate.',
  },
  {
    type: 'Percentage',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamLastResetRate',
    id: 41924,
    abbrName: 'LastResetRt',
    description:
      'The floating rate determined at the most recent reset. The rate is expressed in decimal form, e.g. 5% is represented as 0.05.',
  },
  {
    type: 'Percentage',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFinalRate',
    id: 41925,
    abbrName: 'FnlRt',
    description:
      'The floating rate determined at the final reset. The rate is expressed in decimal form, e.g. 5% is represented as 0.05.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCalculationLagPeriod',
    id: 41926,
    abbrName: 'CalcLagPeriod',
    description: 'Time unit multiplier for the calculation lag duration.',
  },
  {
    type: 'PaymentStreamInflationLagUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCalculationLagUnit',
    id: 41927,
    abbrName: 'CalcLagUnit',
    description: 'Time unit associated with the calculation lag duration.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '169',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFirstObservationDateOffsetPeriod',
    id: 41928,
    abbrName: 'FirstObsvtnOfstPeriod',
    description:
      'Time unit multiplier for the relative first observation date offset.\n\nIf the first observation offset is specified, the observation period will start the specified interval prior to each calculation period - i.e. if the first observation offset is 4 months and the lag duration is 3 months, observations will be taken in months 4, 3 and 2 (but not 1) prior to each calculation period. If no first observation offset is specified, the observation period will end immediately preceding each calculation period.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '169',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFirstObservationDateOffsetUnit',
    id: 41929,
    abbrName: 'FirstObsvtnOfstUnit',
    description: 'Time unit associated with the relative first observation date offset.',
  },
  {
    type: 'ComplexEventDateOffsetDayTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamPricingDayType',
    id: 41930,
    abbrName: 'PxngDayTyp',
    description: 'Specifies the commodity pricing day type.',
  },
  {
    type: 'PaymentStreamPricingDayDistributionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamPricingDayDistribution',
    id: 41931,
    abbrName: 'PxngDayDistrib',
    description: 'The distribution of pricing days.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamPricingDayCount',
    id: 41932,
    abbrName: 'PxngDayCnt',
    description: 'The number of days over which pricing should take place.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamPricingBusinessCalendar',
    id: 41933,
    abbrName: 'PxngClndr',
    description:
      'Specifies the business calendar to use for pricing.\n\nSee http://www.fpml.org/coding-scheme/commodity-business-calendar for values.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamPricingBusinessDayConvention',
    id: 41934,
    abbrName: 'PxngBizDayCnvtn',
    description:
      "The business day convention used to adjust the payment stream's pricing dates. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.",
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingPaymentStreamPaymentDates',
    id: 41937,
    description: 'Number of payment dates in the repeating group.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamPaymentDate',
    id: 41938,
    abbrName: 'Dt',
    description: 'The adjusted or unadjusted fixed stream payment date.',
  },
  {
    type: 'OptionExerciseDateTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamPaymentDateType',
    id: 41939,
    abbrName: 'Typ',
    description:
      'Specifies the type of payment date. When specified it applies not only to the current date but to all subsequent dates in the group until overridden with a new type.',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamMasterAgreementPaymentDatesIndicator',
    id: 41940,
    abbrName: 'MADts',
    description:
      "When set to 'Y', it indicates that payment dates are specified in the relevant master agreement.",
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingPaymentStreamPricingDates',
    id: 41941,
    description: 'Number of pricing dates in the repeating group.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamPricingDate',
    id: 41942,
    abbrName: 'Dt',
    description: 'An adjusted or unadjusted fixed pricing date.',
  },
  {
    type: 'OptionExerciseDateTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamPricingDateType',
    id: 41943,
    abbrName: 'Typ',
    description:
      'Specifies the type of pricing date. When specified it applies not only to the current date but to all subsequent dates in the group until overridden with a new type.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingPaymentStreamPricingDays',
    id: 41944,
    description: 'Number of pricing days in the repeating group.',
  },
  {
    type: 'PaymentStreamPricingDayOfWeekCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamPricingDayOfWeek',
    id: 41945,
    abbrName: 'DayOfWk',
    description: 'The day of the week on which pricing takes place.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamPricingDayNumber',
    id: 41946,
    abbrName: 'DayNum',
    description:
      'The occurrence of the day of week on which pricing takes place.\n\nFor example a pricing day of the 3rd Friday would be DayOfWk=5 DayNum=3.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingPricingDateBusinessCenters',
    id: 41947,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPricingDateBusinessCenter',
    id: 41948,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the pricing or fixing date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPricingDateUnadjusted',
    id: 41949,
    abbrName: 'DtUnadj',
    description: 'The unadjusted pricing or fixing date.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPricingDateBusinessDayConvention',
    id: 41950,
    abbrName: 'BizDayCnvtn',
    description:
      'The business day convention used to adjust the pricing or fixing date. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPricingDateAdjusted',
    id: 41951,
    abbrName: 'Dt',
    description: 'The adjusted pricing or fixing date.',
  },
  {
    type: 'LocalMktTime',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPricingTime',
    id: 41952,
    abbrName: 'Tm',
    description: 'The local market pricing or fixing time.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPricingTimeBusinessCenter',
    id: 41953,
    abbrName: 'TmBizCtr',
    description:
      'Specifies the business center for determining the pricing or fixing time. See http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingStreamCalculationPeriodDates',
    id: 41954,
    description: 'Number of calculation period dates in the repeating group.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCalculationPeriodDate',
    id: 41955,
    abbrName: 'Dt',
    description: 'The adjusted or unadjusted fixed calculation period date.',
  },
  {
    type: 'OptionExerciseDateTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCalculationPeriodDateType',
    id: 41956,
    abbrName: 'Typ',
    description:
      'Specifies the type of fixed calculation period date. When specified it applies not only to the current date but to all subsequent dates in the group until overridden with a new type.',
  },
  {
    type: 'XID',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCalculationPeriodDatesXID',
    id: 41957,
    abbrName: 'XID',
    description:
      'Identifier of this calculation period for cross referencing elsewhere in the message.',
  },
  {
    type: 'XIDREF',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCalculationPeriodDatesXIDRef',
    id: 41958,
    abbrName: 'XIDRef',
    description:
      'Cross reference to another calculation period for duplicating its properties.',
  },
  {
    type: 'Boolean',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCalculationBalanceOfFirstPeriod',
    id: 41959,
    abbrName: 'BalFirst',
    description:
      "When specified and set to 'Y', it indicates that the first calculation period should run from the effective date to the end of the calendar period in which the effective date falls (e.g. Jan 15 - Jan 31 if the calculation periods are one month long and effective date is Jan 15.). If 'N' or not specified, it indicates that the first calculation period should run from the effective date for one whole period (e.g. Jan 15 to Feb 14 if the calculation periods are one month long and the effective date is Jan 15.).",
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCalculationCorrectionPeriod',
    id: 41960,
    abbrName: 'CrrctnPeriod',
    description:
      'Time unit multiplier for the length of time after the publication of the data when corrections can be made.',
  },
  {
    type: 'ProtectionTermEventUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCalculationCorrectionUnit',
    id: 41961,
    abbrName: 'CrrctnUnit',
    description:
      'Time unit associated with the length of time after the publication of the data when corrections can be made.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingStreamCommoditySettlBusinessCenters',
    id: 41962,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommoditySettlBusinessCenter',
    id: 41963,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the commodity delivery date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommodityBase',
    id: 41964,
    abbrName: 'Base',
    description:
      'Specifies the general base type of the commodity traded. Where possible, this should follow the naming convention used in the 2005 ISDA Commodity Definitions.\n\nExamples of general commodity base types include:Metal, Bullion, Oil, Natural Gas, Coal, Electricity, Inter-Energy, Grains, Oils Seeds, Dairy, Livestock, Forestry, Softs, Weather, Emissions.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommodityType',
    id: 41965,
    abbrName: 'CmdtyTyp',
    description:
      'Specifies the type of commodity product.\n\nFor coal see http://www.fpml.org/coding-scheme/commodity-coal-product-type for values.\n\nFor metals see http://www.fpml.org/coding-scheme/commodity-metal-product-type for values.\n\nFor bullion see http://www.fixtradingcommunity.org/codelists#Bullion_Types for the external code list of bullion types.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommoditySecurityID',
    id: 41966,
    abbrName: 'ID',
    discriminatorId: '41967',
    description: 'Specifies the market identifier for the commodity.',
  },
  {
    updated: 'FIX.Latest',
    type: 'SecurityIDSourceCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '169',
    updatedEP: '265',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommoditySecurityIDSource',
    id: 41967,
    abbrName: 'Src',
    description:
      'Identifies the class or source of the UnderlyingStreamCommoditySecurityIDSource(41966) value.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommodityDesc',
    id: 41968,
    abbrName: 'Desc',
    description: 'Description of the commodity asset.',
  },
  {
    type: 'Length',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'EncodedUnderlyingStreamCommodityDescLen',
    id: 41969,
    abbrName: 'EncDescLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedUnderlyingStreamCommodityDesc(41970) field.',
  },
  {
    type: 'data',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'EncodedUnderlyingStreamCommodityDesc',
    id: 41970,
    abbrName: 'EncDesc',
    lengthId: '41969',
    description:
      'Encoded (non-ASCII characters) representation of the UnderlyingStreamCommodityDesc(41968) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the UnderlyingStreamCommodityDesc(41968) field.',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommodityUnitOfMeasure',
    id: 41971,
    abbrName: 'UOM',
    description: 'The unit of measure (UOM) of the commodity asset.',
  },
  {
    type: 'Currency',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommodityCurrency',
    id: 41972,
    abbrName: 'Ccy',
    description:
      'Identifies the currency of the commodity asset. Uses ISO 4217 currency codes.',
  },
  {
    type: 'Exchange',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommodityExchange',
    id: 41973,
    abbrName: 'Exch',
    description: 'Identifies the exchange where the commodity is traded.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommodityRateSource',
    id: 41974,
    abbrName: 'RtSrc',
    description:
      'Identifies the source of rate information used for commodities.\n\nSee http://www.fixtradingcommunity.org/codelists#Commodity_Rate_Source for code list of applicable sources.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommodityRateReferencePage',
    id: 41975,
    abbrName: 'RefPg',
    description: 'Identifies the reference "page" from the rate source.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommodityRateReferencePageHeading',
    id: 41976,
    abbrName: 'RefHdng',
    description: 'Identifies the page heading from the rate source.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamDataProvider',
    id: 41977,
    abbrName: 'DataPrvdr',
    description:
      'Specifies the commodity data or information provider.\n\nSee http://www.fpml.org/coding-scheme/commodity-information-provider for values.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommodityPricingType',
    id: 41978,
    abbrName: 'PxngTyp',
    description:
      'Specifies how the pricing or rate setting of the trade is to be determined or based upon.\n\nSee http://www.fixtradingcommunity.org/codelists#Commodity_Rate_Pricing_Type for code list of applicable commodity pricing types.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommodityNearbySettlDayPeriod',
    id: 41979,
    abbrName: 'Period',
    description:
      'Time unit multiplier for the nearby settlement day.\n\nWhen the commodity transaction references a futures contract, the delivery or settlement dates are a nearby month or week. For example, for eighth nearby month use Period=8 and Unit=Mo.',
  },
  {
    type: 'StreamCommodityNearbySettlDayUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommodityNearbySettlDayUnit',
    id: 41980,
    abbrName: 'Unit',
    description: 'Time unit associated with the nearby settlement day.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommoditySettlDateUnadjusted',
    id: 41981,
    abbrName: 'DtUnadj',
    description: 'The unadjusted commodity delivery date.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommoditySettlDateBusinessDayConvention',
    id: 41982,
    abbrName: 'BizDayCnvtn',
    description:
      'The business day convention used to adjust the commodity delivery date. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommoditySettlDateAdjusted',
    id: 41983,
    abbrName: 'Dt',
    description: 'The adjusted commodity delivery date.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommoditySettlMonth',
    id: 41984,
    abbrName: 'Mo',
    description:
      'Specifies a fixed single month for commodity delivery.\n\nUse "1" for January, "2" for February, etc.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommoditySettlDateRollPeriod',
    id: 41985,
    abbrName: 'RollPeriod',
    description:
      'Time unit multiplier for the commodity delivery date roll.\n\nFor a commodity transaction that references a listed future via the delivery dates, this is the day offset on which the specified future will roll to the next nearby month when the referenced future expires.',
  },
  {
    type: 'StreamCommoditySettlDateRollUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommoditySettlDateRollUnit',
    id: 41986,
    abbrName: 'RollUnit',
    description: 'Time unit associated with the commodity delivery date roll.',
  },
  {
    type: 'ComplexEventDateOffsetDayTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommoditySettlDayType',
    id: 41987,
    abbrName: 'DayTyp',
    description: 'Specifies the commodity delivery roll day type.',
  },
  {
    type: 'XID',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommodityXID',
    id: 41988,
    abbrName: 'XID',
    description:
      'Identifier of this stream commodity for cross referencing elsewhere in the message.',
  },
  {
    type: 'XIDREF',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommodityXIDRef',
    id: 41989,
    abbrName: 'XIDRef',
    description: 'Reference to a stream commodity elsewhere in the message.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingStreamCommodityAltIDs',
    id: 41990,
    description: 'Number of alternate security identifers.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommodityAltID',
    id: 41991,
    abbrName: 'AltID',
    discriminatorId: '41992',
    description: 'Alternate security identifier value for the commodity.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommodityAltIDSource',
    id: 41992,
    abbrName: 'AltIDSrc',
    description:
      'Identifies the class or source of the alternate commodity security identifier.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingStreamCommodityDataSources',
    id: 41993,
    description: 'Number of commodity data sources in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommodityDataSourceID',
    id: 41994,
    abbrName: 'ID',
    description: 'Data source identifier.',
  },
  {
    type: 'StreamCommodityDataSourceIDTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommodityDataSourceIDType',
    id: 41995,
    abbrName: 'Typ',
    description: 'Specifies the type of data source identifier.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingStreamCommoditySettlDays',
    id: 41996,
    description: 'Number of days in the repeating group.',
  },
  {
    type: 'DeliveryScheduleSettlDayCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommoditySettlDay',
    id: 41997,
    abbrName: 'Day',
    description: 'Specifies the day or group of days for delivery.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommoditySettlTotalHours',
    id: 41998,
    abbrName: 'TotHrs',
    description: 'Sum of the hours specified in UnderlyingStreamCommoditySettlTimeGrp.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingStreamCommoditySettlTimes',
    id: 41999,
    description: 'Number of hour ranges in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommoditySettlStart',
    id: 42000,
    abbrName: 'Start',
    description:
      'The start time for commodity settlement where delivery occurs over time. The time format is specified by the settlement time type.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommoditySettlEnd',
    id: 42001,
    abbrName: 'End',
    description:
      'The end time for commodity settlement where delivery occurs over time. The time format is specified by the settlement time type.',
  },
  {
    type: 'DeliveryScheduleSettlTimeTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommoditySettlTimeType',
    id: 41936,
    abbrName: 'Typ',
    description: 'Specifies the format of the commodity settlement start and end times.',
  },
  {
    type: 'NumInGroup',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingStreamCommoditySettlPeriods',
    id: 42002,
    description: 'Number of commodity settlement periods in the repeating group.',
  },
  {
    type: 'Country',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommoditySettlCountry',
    id: 42003,
    abbrName: 'Ctry',
    description:
      'Specifies the country where delivery takes place. Uses ISO 3166 2-character country code.',
  },
  {
    type: 'String',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommoditySettlTimeZone',
    id: 42004,
    abbrName: 'TZ',
    description:
      'Commodity delivery timezone specified as "prevailing" rather than "standard" or "daylight".\n\nSee http://www.fixtradingcommunity.org/codelists#Prevailing_Timezones for code list of applicable prevailing timezones.',
  },
  {
    type: 'DeliveryScheduleSettlFlowTypeCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommoditySettlFlowType',
    id: 42005,
    abbrName: 'FlowTyp',
    description: 'Specifies the commodity delivery flow type.',
  },
  {
    type: 'Qty',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommoditySettlPeriodNotional',
    id: 42006,
    abbrName: 'Notl',
    description:
      'Specifies the delivery quantity associated with this settlement period.',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommoditySettlPeriodNotionalUnitOfMeasure',
    id: 42007,
    abbrName: 'NotlUOM',
    description:
      'Specifies the unit of measure (UOM) of the delivery quantity associated with this settlement period.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommoditySettlPeriodFrequencyPeriod',
    id: 42008,
    abbrName: 'FreqPeriod',
    description: 'Time unit multiplier for the settlement period frequency.',
  },
  {
    type: 'ProtectionTermEventUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommoditySettlPeriodFrequencyUnit',
    id: 42009,
    abbrName: 'FreqUnit',
    description: 'Time unit associated with the settlement period frequency.',
  },
  {
    type: 'Price',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommoditySettlPeriodPrice',
    id: 42010,
    abbrName: 'Px',
    description: 'The settlement period price.',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommoditySettlPeriodPriceUnitOfMeasure',
    id: 42011,
    abbrName: 'PxUOM',
    description: 'Specifies the settlement period price unit of measure (UOM).',
  },
  {
    type: 'Currency',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommoditySettlPeriodPriceCurrency',
    id: 42012,
    abbrName: 'PxCcy',
    description:
      'The currency of the settlement period price. Uses ISO 4217 currency codes.',
  },
  {
    type: 'DeliveryScheduleSettlHolidaysProcessingInstructionCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommoditySettlHolidaysProcessingInstruction',
    id: 42013,
    abbrName: 'Holidays',
    description:
      'Indicates whether holidays are included in the settlement periods. Required for electricity contracts.',
  },
  {
    type: 'XID',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommoditySettlPeriodXID',
    id: 42014,
    abbrName: 'XID',
    description:
      'Identifier of this settlement period for cross referencing elsewhere in the message.',
  },
  {
    type: 'XIDREF',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommoditySettlPeriodXIDRef',
    id: 42015,
    abbrName: 'XIDRef',
    description:
      'Cross reference to another settlement period for duplicating its properties.',
  },
  {
    type: 'XID',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamXID',
    id: 42016,
    abbrName: 'XID',
    description:
      'Identifier of this UnderlyingStream for cross referencing elsewhere in the message.',
  },
  {
    type: 'XIDREF',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamNotionalXIDRef',
    id: 42018,
    abbrName: 'NotlXIDRef',
    description:
      'Cross reference to another UnderlyingStream notional for duplicating its properties.',
  },
  {
    type: 'int',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamNotionalFrequencyPeriod',
    id: 42019,
    abbrName: 'NotlPeriod',
    description: "Time unit multiplier for the swap stream's notional frequency.",
  },
  {
    type: 'TimeUnitCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamNotionalFrequencyUnit',
    id: 42020,
    abbrName: 'NotlUnit',
    description: "Time unit associated with the swap stream's notional frequency.",
  },
  {
    type: 'StreamNotionalCommodityFrequencyCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamNotionalCommodityFrequency',
    id: 42021,
    abbrName: 'NotlFreq',
    description: "The commodity's notional or quantity delivery frequency.",
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamNotionalUnitOfMeasure',
    id: 42022,
    abbrName: 'NotlUOM',
    description: 'Specifies the delivery quantity unit of measure (UOM).',
  },
  {
    type: 'Qty',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamTotalNotional',
    id: 42023,
    abbrName: 'TotNotl',
    description:
      'Specifies the total notional or delivery quantity over the term of the contract.',
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '169',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamTotalNotionalUnitOfMeasure',
    id: 42024,
    abbrName: 'TotNotlUOM',
    description:
      'Specifies the unit of measure (UOM) for the total notional or delivery quantity over the term of the contract.',
  },
  {
    type: 'Amt',
    addedEP: '170',
    added: 'FIX.5.0SP2',
    name: 'AllocGrossTradeAmt',
    id: 2300,
    abbrName: 'GrossTrdAmt',
    description:
      'Total amount traded for this account (i.e. quantity * price) expressed in units of currency.',
  },
  {
    type: 'RiskLimitReportStatusCodeSet',
    addedEP: '171',
    added: 'FIX.5.0SP2',
    name: 'RiskLimitReportStatus',
    id: 2316,
    abbrName: 'RptStat',
    description: 'Status of risk limit report.',
  },
  {
    type: 'RiskLimitReportRejectReasonCodeSet',
    addedEP: '171',
    added: 'FIX.5.0SP2',
    name: 'RiskLimitReportRejectReason',
    id: 2317,
    abbrName: 'RejRsn',
    description:
      'The reason for rejecting the PartyRiskLimitsReport(35=CM) or PartyRiskLimitsUpdateReport(35=CR).',
  },
  {
    type: 'String',
    addedEP: '171',
    added: 'FIX.5.0SP2',
    name: 'RiskLimitCheckRequestID',
    id: 2318,
    abbrName: 'ChkReqID',
    description:
      'The unique identifier of the PartyRiskLimitCheckRequest(35=DF) message.',
  },
  {
    type: 'String',
    addedEP: '171',
    added: 'FIX.5.0SP2',
    name: 'RiskLimitCheckID',
    id: 2319,
    abbrName: 'LmtChkID',
    description:
      'The unique and static identifier, at the business entity level, of a risk limit check request.',
  },
  {
    type: 'RiskLimitCheckTransTypeCodeSet',
    addedEP: '171',
    added: 'FIX.5.0SP2',
    name: 'RiskLimitCheckTransType',
    id: 2320,
    abbrName: 'TransTyp',
    description: 'Specifies the transaction type of the risk limit check request.',
  },
  {
    type: 'RiskLimitCheckTypeCodeSet',
    addedEP: '171',
    added: 'FIX.5.0SP2',
    name: 'RiskLimitCheckType',
    id: 2321,
    abbrName: 'ChkTyp',
    description: 'Specifies the type of limit check message.',
  },
  {
    type: 'int',
    addedEP: '171',
    added: 'FIX.5.0SP2',
    name: 'RiskLimitCheckRequestRefID',
    id: 2322,
    abbrName: 'ReqRefID',
    description:
      'Specifies the message reference identifier of the risk limit check request message.',
  },
  {
    type: 'RiskLimitCheckRequestTypeCodeSet',
    addedEP: '171',
    added: 'FIX.5.0SP2',
    name: 'RiskLimitCheckRequestType',
    id: 2323,
    abbrName: 'ChkReqTyp',
    description: 'Specifies the type of limit amount check being requested.',
  },
  {
    type: 'Amt',
    addedEP: '171',
    added: 'FIX.5.0SP2',
    name: 'RiskLimitCheckAmount',
    id: 2324,
    abbrName: 'LmtChkAmt',
    description: 'Specifies the amount being requested for approval.',
  },
  {
    type: 'RiskLimitCheckRequestStatusCodeSet',
    addedEP: '171',
    added: 'FIX.5.0SP2',
    name: 'RiskLimitCheckRequestStatus',
    id: 2325,
    abbrName: 'ReqStat',
    description: 'Indicates the status of the risk limit check request.',
  },
  {
    type: 'RiskLimitCheckRequestResultCodeSet',
    addedEP: '171',
    added: 'FIX.5.0SP2',
    name: 'RiskLimitCheckRequestResult',
    id: 2326,
    abbrName: 'ReqRslt',
    description: 'Result of the credit limit check request.',
  },
  {
    type: 'Amt',
    addedEP: '171',
    added: 'FIX.5.0SP2',
    name: 'RiskLimitApprovedAmount',
    id: 2327,
    abbrName: 'LmtAprvdAmt',
    description: 'The credit/risk limit amount approved.',
  },
  {
    type: 'String',
    addedEP: '171',
    added: 'FIX.5.0SP2',
    name: 'PartyActionRequestID',
    id: 2328,
    abbrName: 'ActnReqID',
    description: 'The unique identifier of the PartyActionRequest(35=DH) message.',
  },
  {
    type: 'PartyActionTypeCodeSet',
    addedEP: '171',
    added: 'FIX.5.0SP2',
    name: 'PartyActionType',
    id: 2329,
    abbrName: 'ActnTyp',
    description: 'Specifies the type of action to take or was taken for a given party.',
  },
  {
    type: 'Boolean',
    addedEP: '171',
    added: 'FIX.5.0SP2',
    name: 'ApplTestMessageIndicator',
    id: 2330,
    abbrName: 'ApplTstMsgInd',
    description:
      'Used to indicate whether the message being sent is to test the receiving application\'s availability to process the message. When set to "Y" the message is a test message. If not specified, the message is by default not a test message.',
  },
  {
    type: 'String',
    addedEP: '171',
    added: 'FIX.5.0SP2',
    name: 'PartyActionReportID',
    id: 2331,
    abbrName: 'ActnRptID',
    description:
      'The unique identifier of the PartyActionReport(35=DI) message as assigned by the message sender.',
  },
  {
    type: 'PartyActionResponseCodeSet',
    addedEP: '171',
    added: 'FIX.5.0SP2',
    name: 'PartyActionResponse',
    id: 2332,
    abbrName: 'ActnRsp',
    description:
      'Specifies the action taken as a result of the PartyActionType(2239) of the PartyActionRequest(35=DH) message.',
  },
  {
    type: 'PartyActionRejectReasonCodeSet',
    addedEP: '171',
    added: 'FIX.5.0SP2',
    name: 'PartyActionRejectReason',
    id: 2333,
    abbrName: 'RejRsn',
    description: 'Specifies the reason the PartyActionRequest(35=DH) was rejected.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    addedEP: '171',
    updatedEP: '180',
    added: 'FIX.5.0SP2',
    name: 'RefRiskLimitCheckID',
    id: 2334,
    abbrName: 'RefRiskLmtChkID',
    description:
      'The reference identifier of the PartyRiskLimitCheckRequest(35=DF) message, or a similar out of band message, that contained the approval for the risk/credit limit check request.',
  },
  {
    type: 'RefRiskLimitCheckIDTypeCodeSet',
    addedEP: '171',
    added: 'FIX.5.0SP2',
    name: 'RefRiskLimitCheckIDType',
    id: 2335,
    abbrName: 'RefRiskLmtChkIDTyp',
    description:
      'Specifies which type of identifier is specified in RefRiskLimitCheckID(2334) field.',
  },
  {
    type: 'int',
    addedEP: '171',
    added: 'FIX.5.0SP2',
    name: 'RiskLimitVelocityPeriod',
    id: 2336,
    abbrName: 'Velcty',
    description:
      'The time interval for which the clip size limit applies. The velocity time unit is expressed in RiskLimitVelocityUnit(2337).',
  },
  {
    type: 'TimeUnitCodeSet',
    addedEP: '171',
    added: 'FIX.5.0SP2',
    name: 'RiskLimitVelocityUnit',
    id: 2337,
    abbrName: 'VelctyUnit',
    description: 'Unit of time in which RiskLimitVelocityPeriod(2336) is expressed.',
  },
  {
    type: 'PartyDetailRoleQualifierCodeSet',
    addedEP: '171',
    added: 'FIX.5.0SP2',
    name: 'RequestingPartyRoleQualifier',
    id: 2338,
    abbrName: 'Qual',
    description: 'Qualifies the value of RequestingPartyRole(1660).',
  },
  {
    type: 'RiskLimitCheckModelTypeCodeSet',
    addedEP: '171',
    added: 'FIX.5.0SP2',
    name: 'RiskLimitCheckModelType',
    id: 2339,
    abbrName: 'ChkModelTyp',
    description:
      'Specifies the type of credit limit check model workflow to apply for the specified party',
  },
  {
    type: 'RiskLimitCheckStatusCodeSet',
    addedEP: '172',
    added: 'FIX.5.0SP2',
    name: 'RiskLimitCheckStatus',
    id: 2343,
    abbrName: 'RiskLmtChkStat',
    description: 'Indicates the status of the risk limit check performed on a trade.',
  },
  {
    type: 'RiskLimitCheckStatusCodeSet',
    addedEP: '172',
    added: 'FIX.5.0SP2',
    name: 'SideRiskLimitCheckStatus',
    id: 2344,
    abbrName: 'RiskLmtChkStat',
    description:
      'Indicates the status of the risk limit check performed on the side of a trade.',
  },
  {
    type: 'NumInGroup',
    addedEP: '173',
    added: 'FIX.5.0SP2',
    name: 'NoEntitlementTypes',
    id: 2345,
    description: 'Number of entitlement types in the repeating group.',
  },
  {
    type: 'Price',
    addedEP: '175',
    added: 'FIX.5.0SP2',
    name: 'LegMidPx',
    id: 2346,
    abbrName: 'MidPx',
    description:
      'Leg Mid price/rate.\n\nFor OTC swaps, this is the mid-market mark (for example, as defined by CFTC).\n\nFor uncleared OTC swaps, LegMidPx(2346) and the MidPx(631) fields are mutually exclusive.',
  },
  {
    type: 'RegulatoryTransactionTypeCodeSet',
    addedEP: '176',
    added: 'FIX.5.0SP2',
    name: 'RegulatoryTransactionType',
    id: 2347,
    abbrName: 'RegTxnTyp',
    description:
      'Specifies the regulatory mandate or rule that the transaction complies with.',
  },
  {
    type: 'String',
    addedEP: '178',
    added: 'FIX.5.0SP2',
    name: 'BatchID',
    id: 50000,
    abbrName: 'ID',
    description: 'Unique Identifier for a batch of messages.',
  },
  {
    type: 'int',
    addedEP: '178',
    added: 'FIX.5.0SP2',
    name: 'BatchTotalMessages',
    id: 50001,
    abbrName: 'TotMsg',
    description: 'Total # of messages contained within batch.',
  },
  {
    type: 'BatchProcessModeCodeSet',
    addedEP: '178',
    added: 'FIX.5.0SP2',
    name: 'BatchProcessMode',
    id: 50002,
    abbrName: 'ProcMode',
    description: 'Indicates the processing mode for a batch of messages.',
  },
  {
    type: 'String',
    addedEP: '179',
    added: 'FIX.5.0SP2',
    name: 'CollateralPortfolioID',
    id: 2350,
    abbrName: 'PrtflioID',
    description:
      'Identifier of the collateral portfolio when reporting on a portfolio basis.',
  },
  {
    type: 'DeliveryStreamDeliveryPointSourceCodeSet',
    addedEP: '179',
    added: 'FIX.5.0SP2',
    name: 'DeliveryStreamDeliveryPointSource',
    id: 42192,
    abbrName: 'DlvryPntSrc',
    description: 'Identifies the class or source of DeliveryStreamDeliveryPoint(41062).',
  },
  {
    type: 'String',
    addedEP: '179',
    added: 'FIX.5.0SP2',
    name: 'DeliveryStreamDeliveryPointDesc',
    id: 42193,
    abbrName: 'DlvryPntDesc',
    description:
      'Description of the delivery point identified in DeliveryStreamDeliveryPoint(41062).',
  },
  {
    type: 'int',
    addedEP: '179',
    added: 'FIX.5.0SP2',
    name: 'TradingUnitPeriodMultiplier',
    id: 2353,
    abbrName: 'TrdgUnitPeriodMult',
    description:
      'Indicates the number of contract periods associated with the minimum trading unit for a given contract duration resulting in the number of total traded contracts.\n\nAs an example, 456 is the number of off-peak periods for a product with a minimum trading unit of 5 MWh resulting in 2280 total traded contracts.',
  },
  {
    type: 'int',
    addedEP: '179',
    added: 'FIX.5.0SP2',
    name: 'LegTradingUnitPeriodMultiplier',
    id: 2354,
    abbrName: 'TrdgUnitPeriodMult',
    description:
      'Indicates the number of contract periods associated with the minimum trading unit for a given contract duration resulting in the number of total traded contracts.\n\nAs an example, 456 is the number of off-peak periods for a product with a minimum trading unit of 5 MWh resulting in 2280 total traded contracts.',
  },
  {
    type: 'String',
    addedEP: '179',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryStreamDeliveryPointDesc',
    id: 42195,
    abbrName: 'DlvryPntDesc',
    description:
      'Description of the delivery point identified in LegDeliveryStreamDeliveryPoint(41433).',
  },
  {
    type: 'DeliveryStreamDeliveryPointSourceCodeSet',
    addedEP: '179',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryStreamDeliveryPointSource',
    id: 42194,
    abbrName: 'DlvryPntSrc',
    description:
      'Identifies the class or source of LegDeliveryStreamDeliveryPoint(41433).',
  },
  {
    type: 'Qty',
    addedEP: '179',
    added: 'FIX.5.0SP2',
    name: 'LegTotalTradeQty',
    id: 2357,
    abbrName: 'TotTrdQty',
    description:
      'Expresses the total quantity traded over the life of the contract when LegLastQty(1418) is to be repeated periodically over the term of the contract. The value is the product of LegLastQty(1418) and LegTradingUnitPeriodMultiplier(2353).',
  },
  {
    type: 'Qty',
    addedEP: '179',
    added: 'FIX.5.0SP2',
    name: 'LegLastMultipliedQty',
    id: 2358,
    abbrName: 'LastMultdQty',
    description:
      'Expresses the quantity bought/sold when LastQty is expressed in contracts. Used in addition to LegLastQty(1418), it is the product of LegLastQty(1418) and LegContractMultiplier(614).',
  },
  {
    type: 'Amt',
    addedEP: '179',
    added: 'FIX.5.0SP2',
    name: 'LegTotalGrossTradeAmt',
    id: 2359,
    abbrName: 'TotGrossTrdAmt',
    description:
      'Expresses the full total monetary value of the traded contract. The value is the product of LegLastPx(637) and LegTotalTradeQty(2357) or LegTotalTradeMultipliedQty(2360), if priced in units instead of contracts.',
  },
  {
    type: 'Qty',
    addedEP: '179',
    added: 'FIX.5.0SP2',
    name: 'LegTotalTradeMultipliedQty',
    id: 2360,
    abbrName: 'TotTrdMultdQty',
    description:
      'Expresses the total trade quantity in units where LegContractMultiplier(614) is not 1. The value is the product of LegTotalTradeQty(2357) and LegContractMultiplier(614).',
  },
  {
    type: 'String',
    addedEP: '179',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryStreamDeliveryPointDesc',
    id: 42197,
    abbrName: 'DlvryPntDesc',
    description:
      'Description of the delivery point identified in UnderlyingDeliveryStreamDeliveryPoint(41781).',
  },
  {
    type: 'DeliveryStreamDeliveryPointSourceCodeSet',
    addedEP: '179',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryStreamDeliveryPointSource',
    id: 42196,
    abbrName: 'DlvryPntSrc',
    description:
      'Identifies the class or source of UnderlyingDeliveryStreamDeliveryPoint(41781).',
  },
  {
    type: 'int',
    addedEP: '179',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingTradingUnitPeriodMultiplier',
    id: 2363,
    abbrName: 'TrdgUnitPeriodMult',
    description:
      'Indicates the number of contract periods associated with the minimum trading unit for a given contract duration resulting in the number of total traded contracts.\n\nAs an example, 456 is the number of off-peak periods for a product with a minimum trading unit of 5 MWh resulting in 2280 total traded contracts.',
  },
  {
    type: 'PosMaintActionCodeSet',
    addedEP: '179',
    added: 'FIX.5.0SP2',
    name: 'PosReportAction',
    id: 2364,
    abbrName: 'Actn',
    description: 'Indicates action that triggered the Position Report.',
  },
  {
    type: 'PriceOffset',
    addedEP: '179',
    added: 'FIX.5.0SP2',
    name: 'SettlForwardPoints',
    id: 2365,
    abbrName: 'SettlFwdPnts',
    description:
      'FX forward points added to SettlPrice(730). The value is expressed in decimal form and may be a negative.\n\nAs an example, 61.99 points is expressed as 0.006199.',
  },
  {
    type: 'SettlCurrFxRateCalcCodeSet',
    addedEP: '179',
    added: 'FIX.5.0SP2',
    name: 'SettlPriceFxRateCalc',
    id: 2366,
    abbrName: 'SettlPxFxRtCalc',
    description:
      'Specifies whether LastPx(31) [TradeCaptureReport] or SettlPrice(730) [PositionReport] should be multiplied or divided.',
  },
  {
    type: 'Qty',
    addedEP: '179',
    added: 'FIX.5.0SP2',
    name: 'TotalTradeQty',
    id: 2367,
    abbrName: 'TotTrdQty',
    description:
      'Expresses the total quantity traded over the life of the contract when LastQty(32) is repeated periodically over the term of the contract. The value is the product of LastQty(32) and TradingUnitPeriodMultiplier(2353).',
  },
  {
    type: 'Qty',
    addedEP: '179',
    added: 'FIX.5.0SP2',
    name: 'LastMultipliedQty',
    id: 2368,
    abbrName: 'LastMultdQty',
    description:
      'Expresses the quantity bought or sold when LastQty(32) is expressed in number of contracts. Used in addition to LastQty(32). It is the product of LastQty(32) and ContractMultiplier(231).',
  },
  {
    type: 'Amt',
    addedEP: '179',
    added: 'FIX.5.0SP2',
    name: 'TotalGrossTradeAmt',
    id: 2369,
    abbrName: 'TotGrossTrdAmt',
    description:
      'Expresses the full total monetary value of the traded contract. The value is the product of LastPx(31) and TotalTradeQty(2367) or TotalTradeMultipliedQty(2370), if priced in units instead of contracts.',
  },
  {
    type: 'Qty',
    addedEP: '179',
    added: 'FIX.5.0SP2',
    name: 'TotalTradeMultipliedQty',
    id: 2370,
    abbrName: 'TotTrdMultdQty',
    description:
      'Expresses the total trade quantity in units where ContractMultiplier(231) is not 1. The value is the product of TotalTradeQty(2367) and ContractMultiplier(231).',
  },
  {
    type: 'data',
    addedEP: '179',
    added: 'FIX.5.0SP2',
    name: 'EncodedTradeContinuationText',
    id: 2371,
    abbrName: 'EncTrdContntnText',
    lengthId: '2372',
    description:
      'Encoded (non-ASCII characters) representation of the TradeContinuationText(2374) field in the encoded format specified via the MessageEncoding(347) field. If used, the ASCII (English) representation should also be specified in the TradeContinuationText(2374) field.',
  },
  {
    type: 'Length',
    addedEP: '179',
    added: 'FIX.5.0SP2',
    name: 'EncodedTradeContinuationTextLen',
    id: 2372,
    abbrName: 'EncTrdContntnTextLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedTradeContinuationText(2371) field.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'Boolean',
    addedEP: '179',
    updatedEP: '193',
    added: 'FIX.5.0SP2',
    name: 'IntraFirmTradeIndicator',
    id: 2373,
    abbrName: 'IntraFirmTrdInd',
    description:
      'Indicates whether the trade or position was entered into as an intra-group transaction, i.e. between two units of the same parent entity having majority ownership interest in both counterparties.\n\nIn the context of EMIR this refers to Regulation (EU) 648/2012 Article 3 "intragroup transactions" section 1 which states: "In relation to a non-financial counterparty, an intragroup transaction is an OTC derivative contract entered into with another counterparty which is part of the same group provided that both counterparties are included in the same consolidation on a full basis and they are subject to an appropriate centralised risk evaluation, measurement and control procedures and that counterparty is established in the Union or, if it is established in a third country, the Commission has adopted an implementing act under Article 13(2) in respect of that third country. Canada\'s similar requirement is under Appendix A to OSC Rule 91-507."',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    addedEP: '179',
    updatedEP: '258',
    added: 'FIX.5.0SP2',
    name: 'TradeContinuationText',
    id: 2374,
    abbrName: 'TrdContntnTxt',
    description:
      'Free form text to specify additional trade continuation information or data.',
  },
  {
    type: 'TaxonomyTypeCodeSet',
    addedEP: '179',
    added: 'FIX.5.0SP2',
    name: 'TaxonomyType',
    id: 2375,
    abbrName: 'TxnmyTyp',
    description: 'The type of identification taxonomy used to identify the security.',
  },
  {
    type: 'PartyDetailRoleQualifierCodeSet',
    addedEP: '179',
    added: 'FIX.5.0SP2',
    name: 'PartyRoleQualifier',
    id: 2376,
    abbrName: 'Qual',
    description: 'Used to further qualify the value of PartyRole(452).',
  },
  {
    updated: 'FIX.Latest',
    type: 'PartyDetailRoleQualifierCodeSet',
    addedEP: '179',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'DerivativeInstrumentPartyRoleQualifier',
    id: 2377,
    abbrName: 'Qual',
    description:
      'Used to further qualify the value of DerivativeInstrumentPartyRole(1295).',
  },
  {
    type: 'PartyDetailRoleQualifierCodeSet',
    addedEP: '179',
    added: 'FIX.5.0SP2',
    name: 'InstrumentPartyRoleQualifier',
    id: 2378,
    abbrName: 'Qual',
    description: 'Used to further qualify the value of InstrumentPartyRole(1051).',
  },
  {
    type: 'PartyDetailRoleQualifierCodeSet',
    addedEP: '179',
    added: 'FIX.5.0SP2',
    name: 'LegInstrumentPartyRoleQualifier',
    id: 2379,
    abbrName: 'Qual',
    description: 'Used to further qualify the value of LegInstrumentPartyRole(2257).',
  },
  {
    type: 'PartyDetailRoleQualifierCodeSet',
    addedEP: '179',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionPartyRoleQualifier',
    id: 2380,
    abbrName: 'Qual',
    description: 'Used to further qualify the value of LegProvisionPartyRole(40536).',
  },
  {
    type: 'PartyDetailRoleQualifierCodeSet',
    addedEP: '179',
    added: 'FIX.5.0SP2',
    name: 'Nested2PartyRoleQualifier',
    id: 2381,
    abbrName: 'Qual',
    description: 'Used to further qualify the value of Nested2PartyRole(759).',
  },
  {
    type: 'PartyDetailRoleQualifierCodeSet',
    addedEP: '179',
    added: 'FIX.5.0SP2',
    name: 'Nested3PartyRoleQualifier',
    id: 2382,
    abbrName: 'Qual',
    description: 'Used to further qualify the value of Nested3PartyRole(951).',
  },
  {
    type: 'PartyDetailRoleQualifierCodeSet',
    addedEP: '179',
    added: 'FIX.5.0SP2',
    name: 'Nested4PartyRoleQualifier',
    id: 2383,
    abbrName: 'Qual',
    description: 'Used to further qualify the value of Nested4PartyRole(1417).',
  },
  {
    type: 'PartyDetailRoleQualifierCodeSet',
    addedEP: '179',
    added: 'FIX.5.0SP2',
    name: 'NestedPartyRoleQualifier',
    id: 2384,
    abbrName: 'Qual',
    description: 'Used to further qualify the value of NestedPartyRole(538).',
  },
  {
    type: 'PartyDetailRoleQualifierCodeSet',
    addedEP: '179',
    added: 'FIX.5.0SP2',
    name: 'ProvisionPartyRoleQualifier',
    id: 2385,
    abbrName: 'Qual',
    description: 'Used to further qualify the value of ProvisionPartyRole(40177).',
  },
  {
    type: 'PartyDetailRoleQualifierCodeSet',
    addedEP: '179',
    added: 'FIX.5.0SP2',
    name: 'RequestedPartyRoleQualifier',
    id: 2386,
    abbrName: 'Qual',
    description: 'Used to further qualify the value of RequestedPartyRole(1509).',
  },
  {
    type: 'PartyDetailRoleQualifierCodeSet',
    addedEP: '179',
    added: 'FIX.5.0SP2',
    name: 'RootPartyRoleQualifier',
    id: 2388,
    abbrName: 'Qual',
    description: 'Used to further qualify the value of RootPartyRole(1119).',
  },
  {
    type: 'PartyDetailRoleQualifierCodeSet',
    addedEP: '179',
    added: 'FIX.5.0SP2',
    name: 'SettlPartyRoleQualifier',
    id: 2389,
    abbrName: 'Qual',
    description: 'Used to further qualify the value of SettlPartyRole(784).',
  },
  {
    type: 'PartyDetailRoleQualifierCodeSet',
    addedEP: '179',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingInstrumentPartyRoleQualifier',
    id: 2391,
    abbrName: 'Qual',
    description:
      'Used to further qualify the value of UnderlyingInstrumentPartyRole(1061).',
  },
  {
    type: 'String',
    addedEP: '180',
    added: 'FIX.5.0SP2',
    name: 'AllocRefRiskLimitCheckID',
    id: 2392,
    abbrName: 'RefRiskLmtChkID',
    description:
      'The reference identifier to the PartyRiskLimitCheckRequest(35=DF), or a similar out of band message, message that contained the approval or rejection for risk/credit limit check for this allocation.',
  },
  {
    type: 'RefRiskLimitCheckIDTypeCodeSet',
    addedEP: '180',
    added: 'FIX.5.0SP2',
    name: 'AllocRefRiskLimitCheckIDType',
    id: 2393,
    abbrName: 'RefRiskLmtChkIDTyp',
    description:
      'Specifies which type of identifier is specified in AllocRefRiskLimitCheckID(2392) field.',
  },
  {
    type: 'Amt',
    addedEP: '180',
    added: 'FIX.5.0SP2',
    name: 'LimitUtilizationAmt',
    id: 2394,
    abbrName: 'LmtUtilztnAmt',
    description:
      'The total amount of the limit that has been drawn down against the counterparty. This includes the amount for prior trades. It may or may not include the amount for the given trade, specified in LastLimitAmt(1632), depending upon whether the given trade is considered pending.',
  },
  {
    type: 'Amt',
    addedEP: '180',
    added: 'FIX.5.0SP2',
    name: 'LimitAmt',
    id: 2395,
    abbrName: 'LmtAmt',
    description:
      'The limit for the counterparty. This represents the total limit amount, independent of any amount already utilized.',
  },
  {
    type: 'PartyRoleCodeSet',
    addedEP: '180',
    added: 'FIX.5.0SP2',
    name: 'LimitRole',
    id: 2396,
    abbrName: 'LmtR',
    description:
      'Indicates the scope of the limit by role.\n\nUsed to indicate whether this is a customer account limit, a clearing firm limit, etc.',
  },
  {
    type: 'RegulatoryTradeIDScopeCodeSet',
    addedEP: '181',
    added: 'FIX.5.0SP2',
    name: 'RegulatoryTradeIDScope',
    id: 2397,
    abbrName: 'Scope',
    description:
      'Specifies the scope to which the RegulatoryTradeID(1903) applies. Used when a trade must be assigned more than one identifier, e.g. one for the clearing member and another for the client on a cleared trade as with the principal model in Europe.',
  },
  {
    type: 'RegulatoryTradeIDScopeCodeSet',
    addedEP: '181',
    added: 'FIX.5.0SP2',
    name: 'SideRegulatoryTradeIDScope',
    id: 2398,
    abbrName: 'Scope',
    description:
      'Specifies the scope to which the SideRegulatoryTradeID(1972) applies. Used when a trade must be assigned more than one identifier, e.g. one for the clearing member and another for the client on a cleared trade as with the principal model in Europe.',
  },
  {
    type: 'RegulatoryTradeIDScopeCodeSet',
    addedEP: '181',
    added: 'FIX.5.0SP2',
    name: 'AllocRegulatoryTradeIDScope',
    id: 2399,
    abbrName: 'Scope',
    description:
      'Specifies the scope to which the AllocRegulatoryTradeID(1909) applies. Used when a trade must be assigned more than one identifier, e.g. one for the clearing member and another for the client on a cleared trade as with the principal model in Europe.',
  },
  {
    type: 'String',
    addedEP: '181',
    added: 'FIX.5.0SP2',
    name: 'AllocRegulatoryLegRefID',
    id: 2406,
    abbrName: 'LegRefID',
    description:
      "Identifies the leg of the trade the entry applies to by referencing the leg's LegID(1788).",
  },
  {
    type: 'String',
    addedEP: '181',
    added: 'FIX.5.0SP2',
    name: 'RegulatoryLegRefID',
    id: 2411,
    abbrName: 'LegRefID',
    description:
      "Identifies the leg of the trade the entry applies to by referencing the leg's LegID(1788).",
  },
  {
    type: 'String',
    addedEP: '181',
    added: 'FIX.5.0SP2',
    name: 'SideRegulatoryLegRefID',
    id: 2416,
    abbrName: 'LegRefID',
    description:
      "Identifies the leg of the trade the entry applies to by referencing the leg's LegID(1788).",
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'LocalMktDate',
    addedEP: '182',
    updatedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'EffectiveBusinessDate',
    id: 2400,
    abbrName: 'EfctvBizDt',
    description:
      'Specifies an explicit business date for associated reference data or transaction. Used when an implicit date is not sufficiently specific.',
  },
  {
    type: 'Boolean',
    addedEP: '182',
    added: 'FIX.5.0SP2',
    name: 'ListManualOrderIndicator',
    id: 2401,
    abbrName: 'ListManOrdInd',
    description:
      'Indicates if the list of orders was initially received manually (as opposed to electronically) or if it was entered manually (as opposed to entered by automated trading software).',
  },
  {
    type: 'EntitlementSubTypeCodeSet',
    unionDataType: 'Reserved1000Plus',
    addedEP: '183',
    added: 'FIX.5.0SP2',
    name: 'EntitlementSubType',
    id: 2402,
    abbrName: 'SubTyp',
    description: 'Subtype of an entitlement specified in EntitlementType(1775).',
  },
  {
    type: 'QuoteModelTypeCodeSet',
    addedEP: '184',
    added: 'FIX.5.0SP2',
    name: 'QuoteModelType',
    id: 2403,
    abbrName: 'QModelTyp',
    description: 'Quote model type',
  },
  {
    type: 'String',
    addedEP: '185',
    added: 'FIX.5.0SP2',
    name: 'ComplianceText',
    id: 2404,
    abbrName: 'ComplianceTxt',
    description:
      'Free text for compliance information required for regulatory reporting.',
  },
  {
    type: 'Length',
    addedEP: '185',
    added: 'FIX.5.0SP2',
    name: 'EncodedComplianceTextLen',
    id: 2351,
    abbrName: 'EncComplianceTxtLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedComplianceText(2352) field.',
  },
  {
    type: 'data',
    addedEP: '185',
    added: 'FIX.5.0SP2',
    name: 'EncodedComplianceText',
    id: 2352,
    abbrName: 'EncComplianceTxt',
    lengthId: '2351',
    description:
      'Encoded (non-ASCII characters) representation of the ComplianceText(2404) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the ComplianceText(2404) field.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'ExecMethodCodeSet',
    addedEP: '186',
    updatedEP: '201',
    added: 'FIX.5.0SP2',
    name: 'ExecMethod',
    id: 2405,
    abbrName: 'ExecMeth',
    description:
      'Specifies how the transaction was executed, e.g. via an automated execution platform or other method.',
  },
  {
    type: 'int',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'PricePrecision',
    id: 2349,
    abbrName: 'PxPrcsn',
    description:
      'Specifies the price decimal precision of the instrument.\n\nFor FX, this specifies the pip size in which forward points are calculated. Point (pip) size varies by currency pair. Major currencies are all traded in points of 0.0001, with the exception of JPY which has a point size of 0.01.',
  },
  {
    type: 'TradeContingencyCodeSet',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'TradeContingency',
    id: 2387,
    abbrName: 'Cntgncy',
    description:
      'Indicates the contingency attribute for a trade in an asset class that may be contingent on the clearing of a corresponding paired trade (for example Exchange for Physical (EFP), Exchange for Swap (EFS), Exchange for Related (EFR) or Exchange for Option (EFO), collectively called EFRPs). Once the paired trade clears or fails to clear, the related trade (the trade which carries this attribute) ceases to exist.',
  },
  {
    type: 'Price',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventSpotRate',
    id: 2407,
    abbrName: 'SpotRt',
    description: 'FX spot rate.',
  },
  {
    type: 'PriceOffset',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventForwardPoints',
    id: 2408,
    abbrName: 'FwdPnts',
    description: 'FX forward points added to spot rate. May be a negative value.',
  },
  {
    type: 'Price',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventSpotRate',
    id: 2409,
    abbrName: 'SpotRt',
    description: 'FX spot rate.',
  },
  {
    type: 'PriceOffset',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventForwardPoints',
    id: 2410,
    abbrName: 'FwdPnts',
    description: 'FX forward points added to spot rate. May be a negative value.',
  },
  {
    type: 'String',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'RateSourceReferemcePageHeading',
    id: 2412,
    abbrName: 'RefHdng',
    description: 'Identifies the page heading from the rate source.',
  },
  {
    type: 'String',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'RelatedToSecurityID',
    id: 2413,
    abbrName: 'ReltdID',
    discriminatorId: '2414',
    description:
      'The security identifier of the instrument, instrument leg or underlying instrument with which the related instrument has correlation.',
  },
  {
    type: 'SecurityIDSourceCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'RelatedToSecurityIDSource',
    id: 2414,
    abbrName: 'ReltdIDSrc',
    description: 'Identifies class or source of the RelatedToSecurityID(2413) value.',
  },
  {
    type: 'XIDREF',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'RelatedToStreamXIDRef',
    id: 2415,
    abbrName: 'ReltdStrmXIDRef',
    description:
      'StreamXID(41303), LegStreamXID(41700) or UnderlyingStreamXID(42016) of the stream with which the related instrument has correlation.',
  },
  {
    type: 'String',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'FirmTradeEventID',
    id: 2418,
    abbrName: 'FirmTrdEvntID',
    description:
      'An identifier created by the trading party for the life cycle event associated with this report.',
  },
  {
    type: 'Price',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventSpotRate',
    id: 2419,
    abbrName: 'SpotRt',
    description: 'FX spot rate.',
  },
  {
    type: 'PriceOffset',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventForwardPoints',
    id: 2420,
    abbrName: 'FwdPnts',
    description: 'FX forward points added to spot rate. May be a negative value.',
  },
  {
    type: 'String',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'LegMarketDisruptionValue',
    id: 40223,
    abbrName: 'Val',
    description: 'Applicable value for LegMarketDisruptionEvent(41468).',
  },
  {
    type: 'String',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'LegMarketDisruptionFallbackValue',
    id: 40990,
    abbrName: 'Val',
    description: 'Applicable value for LegMarketDisruptionFallbackType(41470).',
  },
  {
    type: 'String',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'MarketDisruptionValue',
    id: 40991,
    abbrName: 'Val',
    description: 'Applicable value for MarketDisruptionEvent(41093).',
  },
  {
    type: 'String',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'MarketDisruptionFallbackValue',
    id: 40992,
    abbrName: 'Val',
    description: 'Applicable value for MarketDisruptionFallbackType(41095).',
  },
  {
    type: 'PaymentSubTypeCodeSet',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'PaymentSubType',
    id: 40993,
    abbrName: 'SubTyp',
    description: 'Used to further clarify the value of PaymentType(40213).',
  },
  {
    type: 'String',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'PaymentLegRefID',
    id: 41304,
    abbrName: 'LegRefID',
    description:
      "Identifies the instrument leg in which this payment applies to by referencing the leg's LegID(1788).",
  },
  {
    type: 'String',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingMarketDisruptionValue',
    id: 41338,
    abbrName: 'Val',
    description: 'Applicable value for UnderlyingMarketDisruptionEvent(41865).',
  },
  {
    type: 'String',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingMarketDisruptionFallbackValue',
    id: 41339,
    abbrName: 'Val',
    description: 'Applicable value for UnderlyingMarketDisruptionFallbackType(41867).',
  },
  {
    type: 'NumInGroup',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingAdditionalTermBondRefs',
    id: 41340,
    description: 'Number of bonds in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingAdditionalTermBondSecurityID',
    id: 41341,
    abbrName: 'ID',
    discriminatorId: '41701',
    description: 'Security identifier of the bond.',
  },
  {
    type: 'SecurityIDSourceCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingAdditionalTermBondSecurityIDSource',
    id: 41701,
    abbrName: 'Src',
    description:
      'Identifies the source scheme of the UnderlyingAdditionalTermBondSecurityID(41341) value.',
  },
  {
    type: 'String',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingAdditionalTermBondDesc',
    id: 41709,
    abbrName: 'Desc',
    description: 'Description of the bond.',
  },
  {
    type: 'Length',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'EncodedUnderlyingAdditionalTermBondDescLen',
    id: 41710,
    abbrName: 'EncDescLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedUnderlyingAdditionalTermBondDesc(41711) field.',
  },
  {
    type: 'data',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'EncodedUnderlyingAdditionalTermBondDesc',
    id: 41711,
    abbrName: 'EncDesc',
    lengthId: '41710',
    description:
      'Encoded (non-ASCII characters) representation of the UnderlyingAdditionalTermBondDesc(41709) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the UnderlyingAdditionalTermBondDesc(41709) field.',
  },
  {
    type: 'Currency',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingAdditionalTermBondCurrency',
    id: 41712,
    abbrName: 'Ccy',
    description:
      'Specifies the currency the bond value is denominated in. Uses ISO 4217 currency codes.',
  },
  {
    type: 'String',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingAdditionalTermBondIssuer',
    id: 42017,
    abbrName: 'Issr',
    description: 'Issuer of the bond.',
  },
  {
    type: 'Length',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'EncodedUnderlyingAdditionalTermBondIssuerLen',
    id: 42025,
    abbrName: 'EncIssrLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedUnderlyingAdditionalTermBondIssuer(42026) field.',
  },
  {
    type: 'data',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'EncodedUnderlyingAdditionalTermBondIssuer',
    id: 42026,
    abbrName: 'EncIssr',
    lengthId: '42025',
    description:
      'Encoded (non-ASCII characters) representation of the UnderlyingAdditionalTermBondIssuer(42017) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the UnderlyingAdditionalTermBondIssuer(42017) field.',
  },
  {
    type: 'SeniorityCodeSet',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingAdditionalTermBondSeniority',
    id: 42027,
    abbrName: 'Snrty',
    description: "Specifies the bond's payment priority in the event of a default.",
  },
  {
    type: 'CouponTypeCodeSet',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingAdditionalTermBondCouponType',
    id: 42028,
    abbrName: 'CpnTyp',
    description: 'Coupon type of the bond.',
  },
  {
    type: 'Percentage',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingAdditionalTermBondCouponRate',
    id: 42029,
    abbrName: 'CpnRt',
    description: 'Coupon rate of the bond. See also CouponRate(223).',
  },
  {
    type: 'LocalMktDate',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingAdditionalTermBondMaturityDate',
    id: 42030,
    abbrName: 'MatDt',
    description: 'The maturity date of the bond.',
  },
  {
    type: 'Amt',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingAdditionalTermBondParValue',
    id: 42031,
    abbrName: 'Par',
    description: 'The par value of the bond.',
  },
  {
    type: 'Amt',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingAdditionalTermBondCurrentTotalIssuedAmount',
    id: 42032,
    abbrName: 'CurTotAmt',
    description: 'Total issued amount of the bond.',
  },
  {
    type: 'int',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingAdditionalTermBondCouponFrequencyPeriod',
    id: 42033,
    abbrName: 'CpnPeriod',
    description: "Time unit multiplier for the frequency of the bond's coupon payment.",
  },
  {
    type: 'CouponFrequencyUnitCodeSet',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingAdditionalTermBondCouponFrequencyUnit',
    id: 42034,
    abbrName: 'CpnUnit',
    description: "Time unit associated with the frequency of the bond's coupon payment.",
  },
  {
    type: 'CouponDayCountCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingAdditionalTermBondDayCount',
    id: 42035,
    abbrName: 'DayCnt',
    description:
      'The day count convention used in interest calculations for a bond or an interest bearing security.',
  },
  {
    type: 'NumInGroup',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingAdditionalTerms',
    id: 42036,
    description: 'Number of additional terms in the repeating group.',
  },
  {
    type: 'Boolean',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingAdditionalTermConditionPrecedentBondIndicator',
    id: 42037,
    abbrName: 'PrcdntInd',
    description:
      'Indicates whether the condition precedent bond is applicable. The swap contract is only valid if the bond is issued and if there is any dispute over the terms of fixed stream then the bond terms would be used.',
  },
  {
    type: 'Boolean',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingAdditionalTermDiscrepancyClauseIndicator',
    id: 42038,
    abbrName: 'DscrpncyInd',
    description: 'Indicates whether the discrepancy clause is applicable.',
  },
  {
    type: 'NumInGroup',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingCashSettlDealers',
    id: 42039,
    description: 'Number of dealers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingCashSettlDealer',
    id: 42040,
    abbrName: 'Dlr',
    description:
      'Identifies the dealer from whom price quotations for the reference obligation are obtained for the purpose of cash settlement valuation calculation.\n\nISDA 2003 Term: Dealer',
  },
  {
    type: 'NumInGroup',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingCashSettlTerms',
    id: 42041,
    description: 'Number of elements in the repeating group.',
  },
  {
    type: 'Currency',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingCashSettlCurrency',
    id: 42042,
    abbrName: 'Ccy',
    description:
      'Specifies the currency the UnderlyingCashSettlAmount(42054) is denominated in. Uses ISO 4217 currency codes.',
  },
  {
    type: 'int',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingCashSettlValuationFirstBusinessDayOffset',
    id: 42043,
    abbrName: 'BizDayOfst',
    description:
      'The number of business days after settlement conditions have been satisfied, when the calculation agent is to obtain a price quotation on the reference obligation for purposes of cash settlement.\n\nAssociated with ISDA 2003 Term: Valuation Date.',
  },
  {
    type: 'int',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingCashSettlValuationSubsequentBusinessDaysOffset',
    id: 42044,
    abbrName: 'SbsqntBizDayOfst',
    description:
      'The number of business days between successive valuation dates when multiple valuation dates are applicable for cash settlement.\n\nAssociated with ISDA 2003 Term: Valuation Date.',
  },
  {
    type: 'int',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingCashSettlNumOfValuationDates',
    id: 42045,
    abbrName: 'NumValDts',
    description:
      'Where multiple valuation dates are specified as being applicable for cash settlement, this element specifies the number of applicable valuation dates.\n\nAssociated with ISDA 2003 Term: Valuation Date.',
  },
  {
    type: 'LocalMktTime',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingCashSettlValuationTime',
    id: 42046,
    abbrName: 'ValTm',
    description: 'Time of valuation.',
  },
  {
    type: 'String',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingCashSettlBusinessCenter',
    id: 42047,
    abbrName: 'BizCtr',
    description:
      'Identifies the business center calendar used at valuation time for cash settlement purposes e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'CashSettlQuoteMethodCodeSet',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingCashSettlQuoteMethod',
    id: 42048,
    abbrName: 'QteMeth',
    description: 'The type of quote used to determine the cash settlement price.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Amt',
    addedEP: '187',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingCashSettlQuoteAmount',
    id: 42049,
    abbrName: 'QteAmt',
    description:
      'When determining the cash settlement amount, if weighted average price quotes are to be obtained for the reference obligation, this is the upper limit to the outstanding principal balance of the reference obligation for which the quote should be obtained. If not specified, the ISDA definitions provide for a fallback amount equal to floating rate payer calculation amount.\n\nISDA 2003 Term: Quotation Amount.',
  },
  {
    type: 'Currency',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingCashSettlQuoteCurrency',
    id: 42050,
    abbrName: 'QteCcy',
    description:
      'Specifies the currency the UnderlyingCashSettlQuoteAmount(42049) is denominated in. Uses ISO 4217 currency codes.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Amt',
    addedEP: '187',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingCashSettlMinimumQuoteAmount',
    id: 42051,
    abbrName: 'MinQteAmt',
    description:
      'When determining the cash settlement amount, if weighted average price quotes are to be obtained for the reference obligation, this is the minimum intended threshold amount of outstanding principal balance of the reference obligation for which the quote should be obtained. If not specified, the ISDA definitions provide for a fallback amount of the lower of either USD1,000,000 (or its equivalent in the relevant obligation currency) or the (minimum) quoted amount.\n\nISDA 2003 Term: Minimum Quotation Amount.',
  },
  {
    type: 'Currency',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingCashSettlMinimumQuoteCurrency',
    id: 42052,
    abbrName: 'MinQteCcy',
    description:
      'Specifies the currency the UnderlyingCashSettlQuoteAmount(42049) is denominated in. Uses ISO 4217 currency codes.',
  },
  {
    type: 'int',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingCashSettlBusinessDays',
    id: 42053,
    abbrName: 'BizDays',
    description:
      'The number of business days used in the determination of the cash settlement payment date.\n\nIf a cash settlement amount is specified, the cash settlement payment date will be this number of business days following the calculation of the final price. If a cash settlement amount is not specified, the cash settlement payment date will be this number of business days after all conditions to settlement are satisfied.\n\nISDA 2003 Term: Cash Settlement Date.',
  },
  {
    type: 'Amt',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingCashSettlAmount',
    id: 42054,
    abbrName: 'Amt',
    description:
      'The amount paid between the trade parties, seller to the buyer, for cash settlement on the cash settlement date.\n\nIf not specified this would typically be calculated as ((100 or the reference price) - reference obligation price) x floating rate payer calculation amount. Price values are all expressed as a percentage.\n\nISDA 2003 Term: Cash Settlement Amount.',
  },
  {
    type: 'float',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingCashSettlRecoveryFactor',
    id: 42055,
    abbrName: 'RcvryFctr',
    description:
      'Used for fixed recovery, this specifies the recovery level as determined at contract inception, to be applied in the event of a default. The factor is used to calculate the amount paid by the seller to the buyer for cash settlement on the cash settlement date. The amount is calculated is (1 - UnderlyingCashSettlRecoveryFactor(42055)) x floating rate payer calculation amount. The currency is derived from the floating rate payer calculation amount.',
  },
  {
    type: 'Boolean',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingCashSettlFixedTermIndicator',
    id: 42056,
    abbrName: 'FixedInd',
    description:
      'Indicates whether fixed settlement is applicable or not applicable in a recovery lock.',
  },
  {
    type: 'Boolean',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingCashSettlAccruedInterestIndicator',
    id: 42057,
    abbrName: 'AcrdIntInd',
    description:
      'Indicates whether accrued interest is included or not in the value provided in UnderlyingCashSettlAmount(42054).\n\nFor cash settlement this specifies whether quotations should be obtained inclusive or not of accrued interest.\n\nFor physical settlement this specifies whether the buyer should deliver the obligation with an outstanding principal balance that includes or excludes accrued interest.\n\nISDA 2003 Term: Include/Exclude Accrued Interest.',
  },
  {
    type: 'CashSettlValuationMethodCodeSet',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingCashSettlValuationMethod',
    id: 42058,
    abbrName: 'ValMeth',
    description:
      'The ISDA defined methodology for determining the final price of the reference obligation for purposes of cash settlement.\n\nISDA 2003 Term: Valuation Method',
  },
  {
    type: 'XID',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingCashSettlTermXID',
    id: 42059,
    abbrName: 'XID',
    description: 'Name referenced from UnderlyingSettlementTermXIDRef(41315).',
  },
  {
    type: 'NumInGroup',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingPhysicalSettlTerms',
    id: 42060,
    description: 'Number of entries in the repeating group.',
  },
  {
    type: 'Currency',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPhysicalSettlCurrency',
    id: 42061,
    abbrName: 'Ccy',
    description: 'Currency of physical settlement. Uses ISO 4217 currency codes.',
  },
  {
    type: 'int',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPhysicalSettlBusinessDays',
    id: 42062,
    abbrName: 'BizDays',
    description:
      'A number of business days. Its precise meaning is dependent on the context in which this element is used.\n\nISDA 2003 Term: Business Day.',
  },
  {
    type: 'int',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPhysicalSettlMaximumBusinessDays',
    id: 42063,
    abbrName: 'MaxBizDays',
    description:
      'A maximum number of business days. Its precise meaning is dependent on the context in which this element is used. Intended to be used to limit a particular ISDA fallback provision.',
  },
  {
    updated: 'FIX.Latest',
    type: 'XID',
    addedEP: '187',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPhysicalSettlTermXID',
    id: 42064,
    abbrName: 'XID',
    description: 'A named string value referenced by UnderlyingSettlTermXIDRef(41315).',
  },
  {
    type: 'NumInGroup',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingPhysicalSettlDeliverableObligations',
    id: 42065,
    description: 'Number of entries in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPhysicalSettlDeliverableObligationType',
    id: 42066,
    abbrName: 'Typ',
    description:
      'Specifies the type of delivery obligation applicable for physical settlement.\n\nSee http://www.fixtradingcommunity.org/codelists#Deliverable_Obligation_Types for code list for applicable deliverable obligation types.',
  },
  {
    type: 'String',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPhysicalSettlDeliverableObligationValue',
    id: 42067,
    abbrName: 'Val',
    description:
      'Physical settlement delivery obligation value appropriate to UnderlyingPhysicalSettlDeliverableObligationType(42066).\n\nSee http://www.fixtradingcommunity.org/codelists#Deliverable_Obligation_Types for applicable obligation type values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingProtectionTerms',
    id: 42068,
    description: 'Number of protection terms in the repeating group.',
  },
  {
    type: 'Amt',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProtectionTermNotional',
    id: 42069,
    abbrName: 'Notl',
    description:
      'The notional amount of protection coverage for a floating rate.\n\nISDA 2003 Term: Floating Rate Payer Calculation Amount.',
  },
  {
    type: 'Currency',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProtectionTermCurrency',
    id: 42070,
    abbrName: 'Ccy',
    description:
      'The currency of UnderlyingProtectionTermNotional(42069). Uses ISO 4217 currency codes.',
  },
  {
    type: 'Boolean',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProtectionTermSellerNotifies',
    id: 42071,
    abbrName: 'Seller',
    description:
      'The notifying party is the party that notifies the other party when a credit event has occurred by means of a credit event notice. If more than one party is referenced as being the notifying party then either party may notify the other of a credit event occurring.\n\nUnderlyingProtectionTermSellerNotifies(42071)=Y indicates that the seller notifies.\n\nISDA 2003 Term: Notifying Party.',
  },
  {
    type: 'Boolean',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProtectionTermBuyerNotifies',
    id: 42072,
    abbrName: 'Buyer',
    description:
      'The notifying party is the party that notifies the other party when a credit event has occurred by means of a credit event notice. If more than one party is referenced as being the notifying party then either party may notify the other of a credit event occurring.\n\nUnderlyingProtectionTermBuyerNotifies(42072)=Y indicates that the buyer notifies.\n\nISDA 2003 Term: Notifying Party.',
  },
  {
    type: 'String',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProtectionTermEventBusinessCenter',
    id: 42073,
    abbrName: 'BizCtr',
    description:
      'When used, the business center indicates the local time of the business center that replaces the Greenwich Mean Time in Section 3.3 of the 2003 ISDA Credit Derivatives Definitions.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'Boolean',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProtectionTermStandardSources',
    id: 42074,
    abbrName: 'StdSrcs',
    description:
      'Indicates whether ISDA defined Standard Public Sources are applicable (UnderlyingProtectionTermStandardSources(42074)=Y) or not.',
  },
  {
    type: 'int',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProtectionTermEventMinimumSources',
    id: 42075,
    abbrName: 'MinSrcs',
    description:
      'The minimum number of the specified public information sources that must publish information that reasonably confirms that a credit event has occurred. The market convention is two.\n\nISDA 2003 Term: Specified Number.',
  },
  {
    type: 'XID',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProtectionTermXID',
    id: 42076,
    abbrName: 'XID',
    description:
      'A named string value referenced by UnderlyingProtectionTermXIDRef(41314).',
  },
  {
    type: 'NumInGroup',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingProtectionTermEvents',
    id: 42077,
    description: 'Number of protection term events in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProtectionTermEventType',
    id: 42078,
    abbrName: 'Typ',
    description:
      'Specifies the type of credit event applicable to the protection terms.\n\nSee http://www.fixtradingcommunity.org/codelists#Protection_Term_Event_Types for code list of applicable event types.',
  },
  {
    type: 'String',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProtectionTermEventValue',
    id: 42079,
    abbrName: 'Val',
    description:
      'Protection term event value appropriate to UnderlyingProtectionTermEventType(42078).\n\nSee http://www.fixtradingcommunity.org/codelists#Protection_Term_Event_Types for applicable event type values.',
  },
  {
    type: 'Currency',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProtectionTermEventCurrency',
    id: 42080,
    abbrName: 'Ccy',
    description:
      'Applicable currency if UnderlyingProtectionTermEventValue(42079) is an amount. Uses ISO 4217 currency codes.',
  },
  {
    type: 'int',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProtectionTermEventPeriod',
    id: 42081,
    abbrName: 'Period',
    description: 'Time unit multiplier for protection term events.',
  },
  {
    type: 'ProtectionTermEventUnitCodeSet',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProtectionTermEventUnit',
    id: 42082,
    abbrName: 'Unit',
    description: 'Time unit associated with protection term events.',
  },
  {
    updated: 'FIX.Latest',
    type: 'ProtectionTermEventDayTypeCodeSet',
    addedEP: '187',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProtectionTermEventDayType',
    id: 42083,
    abbrName: 'DayTyp',
    description: 'Day type for events that specify a period and unit.',
  },
  {
    type: 'String',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProtectionTermEventRateSource',
    id: 42084,
    abbrName: 'RtSrc',
    description:
      'Rate source for events that specify a rate source, e.g. Floating rate interest shortfall.',
  },
  {
    type: 'NumInGroup',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingProtectionTermEventQualifiers',
    id: 42085,
    description: 'Number of qualifiers in the repeating group.',
  },
  {
    type: 'ProtectionTermEventQualifierCodeSet',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProtectionTermEventQualifier',
    id: 42086,
    abbrName: 'Qual',
    description:
      'Protection term event qualifier. Used to further qualify UnderlyingProtectionTermEventType(43078).',
  },
  {
    type: 'NumInGroup',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingProtectionTermObligations',
    id: 42087,
    description: 'Number of obligations in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProtectionTermObligationType',
    id: 42088,
    abbrName: 'Typ',
    description:
      'Specifies the type of obligation applicable to the protection terms.\n\nSee http://www.fixtradingcommunity.org/codelists#Protection_Term_Obligation_Types for code list of applicable obligation types.',
  },
  {
    type: 'String',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProtectionTermObligationValue',
    id: 42089,
    abbrName: 'Val',
    description:
      'Protection term obligation value appropriate to UnderlyingProtectionTermObligationType(42088).\n\nSee http://www.fixtradingcommunity.org/codelists#Protection_Term_Obligation_Types for applicable obligation type values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingProtectionTermEventNewsSources',
    id: 42090,
    description: 'Number of event news sources in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProtectionTermEventNewsSource',
    id: 42091,
    abbrName: 'Src',
    description:
      'Newspaper or electronic news service or source that may publish relevant information used in the determination of whether or not a credit event has occurred.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionCashSettlPaymentDateBusinessDayConvention',
    id: 42092,
    abbrName: 'BizDayCnvtn',
    description:
      "The business day convention used to adjust the provisional cash settlement payment's termination, or relative termination, date. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.",
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionCashSettlPaymentDateRelativeTo',
    id: 42093,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the cash settlement payment date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '187',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionCashSettlPaymentDateOffsetPeriod',
    id: 42094,
    abbrName: 'OfstPeriod',
    description:
      'Time unit multiplier for the relative cash settlement payment date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '187',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionCashSettlPaymentDateOffsetUnit',
    id: 42095,
    abbrName: 'OfstUnit',
    description:
      'Time unit associated with the relative cash settlement payment date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '187',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionCashSettlPaymentDateOffsetDayType',
    id: 42096,
    abbrName: 'OfstDayTyp',
    description:
      "Specifies the day type of the provision's relative cash settlement payment date offset.",
  },
  {
    type: 'LocalMktDate',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionCashSettlPaymentDateRangeFirst',
    id: 42097,
    abbrName: 'DtFirst',
    description: 'First date in range when a settlement date range is provided.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionCashSettlPaymentDateRangeLast',
    id: 42098,
    abbrName: 'DtLast',
    description: 'Last date in range when a settlement date range is provided.',
  },
  {
    type: 'NumInGroup',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingProvisionCashSettlPaymentDates',
    id: 42099,
    description:
      'Number of UnderlyingProvision cash settlement payment dates in the repeating group.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionCashSettlPaymentDate',
    id: 42100,
    abbrName: 'Dt',
    description:
      'The cash settlement payment date, unadjusted or adjusted depending on UnderlyingProvisionCashSettlPaymentDateType(42101).',
  },
  {
    type: 'ProvisionCashSettlPaymentDateTypeCodeSet',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionCashSettlPaymentDateType',
    id: 42101,
    abbrName: 'Typ',
    description: 'Specifies the type of date (e.g. adjusted for holidays).',
  },
  {
    type: 'PaymentStreamRateIndexSourceCodeSet',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionCashSettlQuoteSource',
    id: 42102,
    abbrName: 'SettlQteSrc',
    description: 'Identifies the source of quote information.',
  },
  {
    type: 'String',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionCashSettlQuoteReferencePage',
    id: 42103,
    abbrName: 'RefPg',
    description: 'Identifies the reference "page" from the quote source.',
  },
  {
    type: 'LocalMktTime',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionCashSettlValueTime',
    id: 42104,
    abbrName: 'Tm',
    description:
      'A time specified in 24-hour format, e.g. 11am would be represented as 11:00:00. The time of the cash settlement valuation date when the cash settlement amount will be determined according to the cash settlement method if the parties have not otherwise been able to agree to the cash settlement amount.',
  },
  {
    type: 'String',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionCashSettlValueTimeBusinessCenter',
    id: 42105,
    abbrName: 'TmBizCtr',
    description:
      "Identifies the business center calendar used with the provision's cash settlement valuation time.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.",
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionCashSettlValueDateBusinessDayConvention',
    id: 42106,
    abbrName: 'BizDayCnvtn',
    description:
      'The business day convention used to adjust the cash settlement valuation date. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionCashSettlValueDateRelativeTo',
    id: 42107,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the cash settlement value date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '187',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionCashSettlValueDateOffsetPeriod',
    id: 42108,
    abbrName: 'OfstPeriod',
    description:
      'Time unit multiplier for the relative cash settlement value date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '187',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionCashSettlValueDateOffsetUnit',
    id: 42109,
    abbrName: 'OfstUnit',
    description:
      'Time unit associated with the relative cash settlement value date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '187',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionCashSettlValueDateOffsetDayType',
    id: 42110,
    abbrName: 'OfstDayTyp',
    description:
      "Specifies the day type of the provision's relative cash settlement value date offset.",
  },
  {
    type: 'LocalMktDate',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionCashSettlValueDateAdjusted',
    id: 42111,
    abbrName: 'Dt',
    description: 'The adjusted cash settlement value date.',
  },
  {
    type: 'NumInGroup',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingProvisionOptionExerciseFixedDates',
    id: 42112,
    description:
      'Number of UnderlyingProvision option exercise fixed dates in the repeating group.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionExerciseFixedDate',
    id: 42113,
    abbrName: 'Dt',
    description:
      'A predetermined option exercise date, unadjusted or adjusted depending on UnderlyingProvisionOptionExerciseFixedDateType(42114).',
  },
  {
    type: 'ProvisionOptionExerciseFixedDateTypeCodeSet',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionExerciseFixedDateType',
    id: 42114,
    abbrName: 'Typ',
    description: 'Specifies the type of date (e.g. adjusted for holidays).',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionExerciseBusinessDayConvention',
    id: 42115,
    abbrName: 'BizDayCnvtn',
    description:
      "The business day convention used to adjust the underlying instrument's provision's option exercise date. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.",
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '187',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionExerciseEarliestDateOffsetPeriod',
    id: 42116,
    abbrName: 'ErlstOfstPeriod',
    description:
      'Time unit multiplier for the interval to the first (and possibly only) exercise date in the exercise period.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'ProvisionOptionExerciseEarliestDateOffsetUnitCodeSet',
    addedEP: '187',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionExerciseEarliestDateOffsetUnit',
    id: 42117,
    abbrName: 'ErlstOfstUnit',
    description:
      'Time unit associated with the interval to the first (and possibly only) exercise date in the exercise period.',
  },
  {
    type: 'int',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionExerciseFrequencyPeriod',
    id: 42118,
    abbrName: 'FreqPeriod',
    description:
      'Time unit multiplier for the frequency of subsequent exercise dates in the exercise period following the earliest exercise date. An interval of 1 day should be used to indicate an American style exercise frequency.',
  },
  {
    type: 'CouponFrequencyUnitCodeSet',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionExerciseFrequencyUnit',
    id: 42119,
    abbrName: 'FreqUnit',
    description:
      'Time unit associated with the frequency of subsequent exercise dates in the exercise period following the earliest exercise date.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionExerciseStartDateUnadjusted',
    id: 42120,
    abbrName: 'StartDtUnadj',
    description:
      'The unadjusted first day of the exercise period for an American style option.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionExerciseStartDateRelativeTo',
    id: 42121,
    abbrName: 'StartDtReltv',
    description:
      'Specifies the anchor date when the option exercise start date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '187',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionExerciseStartDateOffsetPeriod',
    id: 42122,
    abbrName: 'StartDtOfstPeriod',
    description:
      'Time unit multiplier for the relative option exercise start date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '187',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionExerciseStartDateOffsetUnit',
    id: 42123,
    abbrName: 'StartDtOfstUnit',
    description:
      'Time unit associated with the relative option exercise start date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '187',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionExerciseStartDateOffsetDayType',
    id: 42124,
    abbrName: 'StartDtOfstDayTyp',
    description:
      "Specifies the day type of the provision's relative option exercise start date offset.",
  },
  {
    type: 'LocalMktDate',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionExerciseStartDateAdjusted',
    id: 42125,
    abbrName: 'StartDt',
    description:
      'The adjusted first day of the exercise period for an American style option.',
  },
  {
    type: 'int',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionExercisePeriodSkip',
    id: 42126,
    abbrName: 'Skip',
    description:
      'The number of periods in the referenced date schedule that are between each date in the relative date schedule. Thus a skip of 2 would mean that dates are relative to every second date in the referenced schedule. If present this should have a value greater than 1.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionExerciseBoundsFirstDateUnadjusted',
    id: 42127,
    abbrName: 'FirstDtUnadj',
    description:
      'The unadjusted first date of a schedule. This can be used to restrict the range of exercise dates when they are relative.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionExerciseBoundsLastDateUnadjusted',
    id: 42128,
    abbrName: 'LastDtUnadj',
    description:
      'The unadjusted last date of a schedule. This can be used to restrict the range of exercise dates when they are relative.',
  },
  {
    type: 'LocalMktTime',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionExerciseEarliestTime',
    id: 42129,
    abbrName: 'ErlstTm',
    description:
      "The earliest time at which notice of exercise can be given by the buyer to the seller (or seller's agent) i) on the expriation date, in the case of a European style option, (ii) on each bermuda option exercise date and the expiration date, in the case of a Bermuda style option the commencement date to, and including, the expiration date, in the case of an American option.",
  },
  {
    type: 'String',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionExerciseEarliestTimeBusinessCenter',
    id: 42130,
    abbrName: 'ErlstTmBizCtr',
    description:
      "Identifies the business center calendar used with the provision's earliest time for notice of exercise.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.",
  },
  {
    type: 'LocalMktTime',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionExerciseLatestTime',
    id: 42131,
    abbrName: 'LtstTm',
    description:
      "For a Bermuda or American style option, the latest time on an exercise business day (excluding the expiration date) within the exercise period that notice can be given by the buyer to the seller or seller's agent. Notice of exercise given after this time will be deemed to have been given on the next exercise business day.",
  },
  {
    type: 'String',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionExerciseLatestTimeBusinessCenter',
    id: 42132,
    abbrName: 'LtstTmBizCtr',
    description:
      "Identifies the business center calendar used with the provision's latest time for notice of exercise.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.",
  },
  {
    type: 'LocalMktDate',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionExpirationDateUnadjusted',
    id: 42133,
    abbrName: 'DtUnadj',
    description:
      'The unadjusted last day within an exercise period for an American style option. For a European style option it is the only day within the exercise period.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionExpirationDateBusinessDayConvention',
    id: 42134,
    abbrName: 'BizDayCnvtn',
    description:
      "The business day convention used to adjust the underlying instrument's provision's option expiration date. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.",
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionExpirationDateRelativeTo',
    id: 42135,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the option expiration date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '187',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionExpirationDateOffsetPeriod',
    id: 42136,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative option expiration date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '187',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionExpirationDateOffsetUnit',
    id: 42137,
    abbrName: 'OfstUnit',
    description: 'Time unit associated with the relative option expiration date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '187',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionExpirationDateOffsetDayType',
    id: 42138,
    abbrName: 'OfstDayTyp',
    description:
      "Specifies the day type of the provision's relative option expiration date offset.",
  },
  {
    type: 'LocalMktDate',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionExpirationDateAdjusted',
    id: 42139,
    abbrName: 'Dt',
    description:
      'The adjusted last date within an exercise period for an American style option. For a European style option it is the only date within the exercise period.',
  },
  {
    type: 'LocalMktTime',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionExpirationTime',
    id: 42140,
    abbrName: 'ExpTm',
    description: 'The latest time for exercise on the expiration date.',
  },
  {
    type: 'String',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionExpirationTimeBusinessCenter',
    id: 42141,
    abbrName: 'ExpTmBizCtr',
    description:
      "Identifies the business center calendar used with the provision's latest exercise time on expiration date.\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.",
  },
  {
    type: 'LocalMktDate',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionRelevantUnderlyingDateUnadjusted',
    id: 42142,
    abbrName: 'DtUnadj',
    description:
      'The unadjusted date on the underlying set by the exercise of an option. What this date is depends on the option (e.g. in a swaption it is the swap effective date, in an extendible/cancelable provision it is the swap termination date).',
  },
  {
    updated: 'FIX.Latest',
    type: 'BusinessDayConventionCodeSet',
    addedEP: '187',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionRelevantUnderlyingDateBizDayConvention',
    id: 42143,
    abbrName: 'BizDayCnvtn',
    description:
      "The business day convnetion used to adjust the underlying instrument provision's option underlying date. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.",
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionRelevantUnderlyingDateRelativeTo',
    id: 42144,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the date relevant to the underlying trade on exercise is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'int',
    addedEP: '187',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionRelevantUnderlyingDateOffsetPeriod',
    id: 42145,
    abbrName: 'OfstPeriod',
    description:
      'Time unit multiplier for the relative option relevant underlying date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '187',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionRelevantUnderlyingDateOffsetUnit',
    id: 42146,
    abbrName: 'OfstUnit',
    description:
      'Time unit associated with the relative option relevant underlying date offset.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '187',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionRelevantUnderlyingDateOffsetDayType',
    id: 42147,
    abbrName: 'OfstDayTyp',
    description:
      "Specifies the day type of the provision's relative option relevant underlying date offset.",
  },
  {
    type: 'LocalMktDate',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionRelevantUnderlyingDateAdjusted',
    id: 42148,
    abbrName: 'Dt',
    description:
      'The adjusted date on the underlying set by the exercise of an option. What this date is depends on the option (e.g. in a swaption it is the swap effective date, in an extendible/cancelable provision it is the swap termination date).',
  },
  {
    type: 'NumInGroup',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingProvisions',
    id: 42149,
    description: 'Number of provisions in the repeating group.',
  },
  {
    type: 'ProvisionTypeCodeSet',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionType',
    id: 42150,
    abbrName: 'Typ',
    description: 'Type of provision.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionDateUnadjusted',
    id: 42151,
    abbrName: 'DtUnadj',
    description: 'The unadjusted date of the provision.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionDateBusinessDayConvention',
    id: 42152,
    abbrName: 'BizDayCnvtn',
    description:
      "The business day convention used to adjust the underlying instrument's provision's date. Used only to override the business day convention specified in the UnderlyingDateAdjustment component within the UnderlyingInstrument component.",
  },
  {
    type: 'LocalMktDate',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionDateAdjusted',
    id: 42153,
    abbrName: 'Dt',
    description: 'The adjusted date of the provision.',
  },
  {
    type: 'int',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionDateTenorPeriod',
    id: 42154,
    abbrName: 'TenorPeriod',
    description: "Time unit multiplier for the provision's tenor period.",
  },
  {
    type: 'ProvisionDateTenorUnitCodeSet',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionDateTenorUnit',
    id: 42155,
    abbrName: 'TenorUnit',
    description: "Time unit associated with the provision's tenor period.",
  },
  {
    type: 'ProvisionCalculationAgentCodeSet',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionCalculationAgent',
    id: 42156,
    abbrName: 'CalcAgent',
    description:
      'Used to identify the calculation agent. The calculation agent may be identified in UnderlyingProvisionCalculationAgent(42156) or in the underlying provision parties component.',
  },
  {
    type: 'ProvisionOptionSinglePartyBuyerSideCodeSet',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionSinglePartyBuyerSide',
    id: 42157,
    abbrName: 'BuyerSide',
    description:
      'If optional early termination is not available to both parties then this component identifies the buyer of the option through its side of the trade.',
  },
  {
    type: 'ProvisionOptionSinglePartyBuyerSideCodeSet',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionSinglePartySellerSide',
    id: 42158,
    abbrName: 'SellerSide',
    description:
      'If optional early termination is not available to both parties then this component identifies the seller of the option through its side of the trade.',
  },
  {
    type: 'ExerciseStyleCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionExerciseStyle',
    id: 42159,
    abbrName: 'ExerStyle',
    description: "The instrument provision's exercise style.",
  },
  {
    type: 'Amt',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionExerciseMultipleNotional',
    id: 42160,
    abbrName: 'MultplNotl',
    description:
      'A notional amount which restricts the amount of notional that can be exercised when partial exercise or multiple exercise is applicable. The integral multiple amount defines a lower limit of notional that can be exercised and also defines a unit multiple of notional that can be exercised, i.e. only integer multiples of this amount can be exercised.',
  },
  {
    type: 'Amt',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionExerciseMinimumNotional',
    id: 42161,
    abbrName: 'MinNotl',
    description:
      'The minimum notional amount that can be exercised on a given exercise date.',
  },
  {
    type: 'Amt',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionExerciseMaximumNotional',
    id: 42162,
    abbrName: 'MaxNotl',
    description:
      'The maximum notional amount that can be exercised on a given exercise date.',
  },
  {
    type: 'int',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionMinimumNumber',
    id: 42163,
    abbrName: 'MinNum',
    description:
      'The minimum number of options that can be exercised on a given exercise date.',
  },
  {
    type: 'int',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionMaximumNumber',
    id: 42164,
    abbrName: 'MaxNum',
    description:
      'The maximum number of options that can be exercised on a given exercise date. If the number is not specified, it means that the maximum number of options corresponds to the remaining unexercised options.',
  },
  {
    type: 'Boolean',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionExerciseConfirmation',
    id: 42165,
    abbrName: 'ExerCnfm',
    description:
      "Used to indicate whether follow-up confirmation of exercise (written or electronic) is required following telephonic notice by the buyer to the seller or seller's agent.",
  },
  {
    type: 'ProvisionCashSettlMethodCodeSet',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionCashSettlMethod',
    id: 42166,
    abbrName: 'SettlMeth',
    description:
      'An ISDA defined cash settlement method used for the determination of the applicable cash settlement amount. The method is defined in the 2006 ISDA Definitions, Section 18.3. Cash Settlement Methods, paragraph (e).',
  },
  {
    type: 'Currency',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionCashSettlCurrency',
    id: 42167,
    abbrName: 'SettlCcy',
    description: 'Specifies the currency of settlement. Uses ISO 4217 currency codes.',
  },
  {
    type: 'Currency',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionCashSettlCurrency2',
    id: 42168,
    abbrName: 'SettlCcy2',
    description:
      'Specifies the currency of settlement for a cross-currency provision. Uses ISO 4217 currency codes.',
  },
  {
    type: 'ProvisionCashSettlQuoteTypeCodeSet',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionCashSettlQuoteType',
    id: 42169,
    abbrName: 'SettlQteTyp',
    description: 'Identifies the type of quote to be used.',
  },
  {
    type: 'String',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionText',
    id: 42170,
    abbrName: 'Txt',
    description:
      'Free form text to specify additional information or enumeration description when a standard value does not apply.',
  },
  {
    type: 'Length',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'EncodedUnderlyingProvisionTextLen',
    id: 42171,
    abbrName: 'EncTxtLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedUnderlyingProvisionText(42712) field.',
  },
  {
    type: 'data',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'EncodedUnderlyingProvisionText',
    id: 42172,
    abbrName: 'EncTxt',
    lengthId: '42171',
    description:
      'Encoded (non-ASCII characters) representation of the UnderlyingProvisionText(42170) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the UnderlyingProvisionText(42170) field.',
  },
  {
    type: 'NumInGroup',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingProvisionPartyIDs',
    id: 42173,
    description: 'Number of parties identified in the contract provision.',
  },
  {
    type: 'String',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionPartyID',
    id: 42174,
    abbrName: 'ID',
    discriminatorId: '42175',
    description: 'The party identifier for the payment settlement party.',
  },
  {
    type: 'PartyIDSourceCodeSet',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionPartyIDSource',
    id: 42175,
    abbrName: 'Src',
    description:
      'Identifies the class or source of the UnderlyingProvisionPartyID(42174) value.',
  },
  {
    type: 'PartyRoleCodeSet',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionPartyRole',
    id: 42176,
    abbrName: 'R',
    description:
      'Identifies the type or role of UnderlyingProvisionPartyID(42174) specified.',
  },
  {
    type: 'PartyDetailRoleQualifierCodeSet',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionPartyRoleQualifier',
    id: 40918,
    abbrName: 'Qual',
    description:
      'Used to further qualify the value of UnderlyingProvisionPartyRole(42176).',
  },
  {
    type: 'NumInGroup',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingProvisionPartySubIDs',
    id: 42177,
    description: 'Number of sub-party IDs to be reported for the party.',
  },
  {
    type: 'String',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionPartySubID',
    id: 42178,
    abbrName: 'ID',
    description:
      'Underlying provision party sub-identifier, if applicable for UnderlyingProvisionPartyID(42174).',
  },
  {
    type: 'PartySubIDTypeCodeSet',
    unionDataType: 'Reserved4000Plus',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionPartySubIDType',
    id: 42179,
    abbrName: 'Typ',
    description: 'The type of UnderlyingProvisionPartySubID(42178).',
  },
  {
    type: 'NumInGroup',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingProvisionCashSettlPaymentDateBusinessCenters',
    id: 42180,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionCashSettlPaymentDateBusinessCenter',
    id: 42181,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the provision\'s cash settlement payment\'s termination, or relative termination, date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingProvisionCashSettlValueDateBusinessCenters',
    id: 42182,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionCashSettlValueDateBusinessCenter',
    id: 42183,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the cash settlement valuation date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingProvisionOptionExerciseBusinessCenters',
    id: 42184,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionExerciseBusinessCenter',
    id: 42185,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the underlying instrument\'s provision\'s option exercise date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingProvisionOptionExpirationDateBusinessCenters',
    id: 42186,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionExpirationDateBusinessCenter',
    id: 42187,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the underlying instrument\'s provision\'s option expiration date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingProvisionOptionRelevantUnderlyingDateBusinessCenters',
    id: 42188,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionOptionRelevantUnderlyingDateBusinessCenter',
    id: 42189,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the underlying instrument\'s provision\'s option underlying date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingProvisionDateBusinessCenters',
    id: 42190,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '187',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionDateBusinessCenter',
    id: 42191,
    abbrName: 'Ctr',
    description:
      'The business center calendar used to adjust the underlying instrument\'s provision\'s date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'String',
    addedEP: '188',
    added: 'FIX.5.0SP2',
    name: 'FillRefID',
    id: 2421,
    abbrName: 'FillRefID',
    description:
      'A reference to either the value of the FillExecID(1363) or an implicit position of a fills instance in the FillsGrp component.',
  },
  {
    type: 'int',
    addedEP: '188',
    added: 'FIX.5.0SP2',
    name: 'OrderRequestID',
    id: 2422,
    abbrName: 'OrdReqID',
    description:
      'Unique message identifier for an order request as assigned by the submitter of the request.',
  },
  {
    type: 'String',
    addedEP: '188',
    added: 'FIX.5.0SP2',
    name: 'MassOrderRequestID',
    id: 2423,
    abbrName: 'MassOrdReqID',
    description:
      'Unique message identifier for a mass order request as assigned by the submitter of the orders.',
  },
  {
    updated: 'FIX.Latest',
    type: 'String',
    addedEP: '188',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'MassOrderReportID',
    id: 2424,
    abbrName: 'MassOrdRptID',
    description:
      'Unique message identifier for the response to a mass order request as assigned by the receiver of the orders.',
  },
  {
    type: 'MassOrderRequestStatusCodeSet',
    addedEP: '188',
    added: 'FIX.5.0SP2',
    name: 'MassOrderRequestStatus',
    id: 2425,
    abbrName: 'ReqStat',
    description: 'Status of mass order request.',
  },
  {
    type: 'MassOrderRequestResultCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '188',
    added: 'FIX.5.0SP2',
    name: 'MassOrderRequestResult',
    id: 2426,
    abbrName: 'ReqRslt',
    description: 'Request result of mass order request.',
  },
  {
    type: 'OrderResponseLevelCodeSet',
    addedEP: '188',
    added: 'FIX.5.0SP2',
    name: 'OrderResponseLevel',
    id: 2427,
    abbrName: 'OrdRspLvl',
    description:
      'The level of response requested from receiver of mass order messages. A default value should be bilaterally agreed.',
  },
  {
    type: 'NumInGroup',
    addedEP: '188',
    added: 'FIX.5.0SP2',
    name: 'NoOrderEntries',
    id: 2428,
    description: 'Number of order entries.',
  },
  {
    type: 'OrderEntryActionCodeSet',
    addedEP: '188',
    added: 'FIX.5.0SP2',
    name: 'OrderEntryAction',
    id: 2429,
    abbrName: 'OrdEntryActn',
    description: 'Specifies the action to be taken for the given order.',
  },
  {
    type: 'int',
    addedEP: '188',
    added: 'FIX.5.0SP2',
    name: 'OrderEntryID',
    id: 2430,
    abbrName: 'OrdEntryID',
    description:
      'Unique identifier for an order within a single MassOrder(35=DJ) message that can be used as a reference in the MassOrderAck(35=DK) message.',
  },
  {
    type: 'ExecTypeReasonCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '188',
    added: 'FIX.5.0SP2',
    name: 'ExecTypeReason',
    id: 2431,
    abbrName: 'ExecTypRsn',
    description: 'The initiating event when an ExecutionReport(35=8) is sent.',
  },
  {
    type: 'int',
    addedEP: '188',
    added: 'FIX.5.0SP2',
    name: 'TotNoOrderEntries',
    id: 2432,
    abbrName: 'TotNoOrdEntries',
    description:
      'Totals number of orders for a mass order or its acknowledgment being fragmented across multiple messages.',
  },
  {
    type: 'NumInGroup',
    addedEP: '189',
    added: 'FIX.5.0SP2',
    name: 'NoTargetPartySubIDs',
    id: 2433,
    description: 'Number of target party sub IDs in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '189',
    added: 'FIX.5.0SP2',
    name: 'TargetPartySubID',
    id: 2434,
    abbrName: 'ID',
    description: 'Party sub-identifier value within a target party repeating group.',
  },
  {
    type: 'PartySubIDTypeCodeSet',
    unionDataType: 'Reserved4000Plus',
    addedEP: '189',
    added: 'FIX.5.0SP2',
    name: 'TargetPartySubIDType',
    id: 2435,
    abbrName: 'Typ',
    description: 'Type of TargetPartySubID(2434) value.',
  },
  {
    type: 'String',
    addedEP: '189',
    added: 'FIX.5.0SP2',
    name: 'TransferInstructionID',
    id: 2436,
    abbrName: 'InstID',
    description:
      'Unique identifier for the transfer instruction assigned by the submitter.',
  },
  {
    type: 'String',
    addedEP: '189',
    added: 'FIX.5.0SP2',
    name: 'TransferID',
    id: 2437,
    abbrName: 'XferID',
    description:
      'The unique identifier assigned to the transfer entity once it is received, for example, by the CCP or the party governing the transfer process. Generally this same identifier for the transfer is used by all parties involved.',
  },
  {
    type: 'String',
    addedEP: '189',
    added: 'FIX.5.0SP2',
    name: 'TransferReportID',
    id: 2438,
    abbrName: 'RptID',
    description: 'Unique identifier for the transfer report message.',
  },
  {
    type: 'TransferTransTypeCodeSet',
    addedEP: '189',
    added: 'FIX.5.0SP2',
    name: 'TransferTransType',
    id: 2439,
    abbrName: 'TransTyp',
    description: 'Indicates the type of transfer transaction.',
  },
  {
    type: 'TransferTypeCodeSet',
    addedEP: '189',
    added: 'FIX.5.0SP2',
    name: 'TransferType',
    id: 2440,
    abbrName: 'XferTyp',
    description: 'Indicates the type of transfer request.',
  },
  {
    type: 'TransferScopeCodeSet',
    addedEP: '189',
    added: 'FIX.5.0SP2',
    name: 'TransferScope',
    id: 2441,
    abbrName: 'XferScope',
    description: 'Indicates the type of transfer.',
  },
  {
    type: 'TransferStatusCodeSet',
    addedEP: '189',
    added: 'FIX.5.0SP2',
    name: 'TransferStatus',
    id: 2442,
    abbrName: 'XferStat',
    description: 'Status of the transfer.',
  },
  {
    type: 'TransferRejectReasonCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '189',
    added: 'FIX.5.0SP2',
    name: 'TransferRejectReason',
    id: 2443,
    abbrName: 'RejRsn',
    description: 'Reason the transfer instruction was rejected.',
  },
  {
    type: 'TransferReportTypeCodeSet',
    addedEP: '189',
    added: 'FIX.5.0SP2',
    name: 'TransferReportType',
    id: 2444,
    abbrName: 'RptTyp',
    description: 'Indicates the type of transfer report.',
  },
  {
    type: 'UTCTimestamp',
    addedEP: '190',
    added: 'FIX.5.0SP2',
    name: 'AggressorTime',
    id: 2445,
    abbrName: 'AgrsrTm',
    description: 'Timestamp of aggressive order or quote resulting in match event.',
  },
  {
    type: 'SideCodeSet',
    addedEP: '190',
    added: 'FIX.5.0SP2',
    name: 'AggressorSide',
    id: 2446,
    abbrName: 'AgrsrSide',
    description: 'Side of aggressive order or quote resulting in match event.',
  },
  {
    type: 'Boolean',
    addedEP: '190',
    added: 'FIX.5.0SP2',
    name: 'FastMarketIndicator',
    id: 2447,
    abbrName: 'FastMktInd',
    description:
      'Indicates if the instrument is in "fast market" state.\n\nA "fast market" is a state in which market rules are applied to instrument(s) or entire trading session when market events causes significant price movements due to public information.',
  },
  {
    type: 'Boolean',
    addedEP: '190',
    added: 'FIX.5.0SP2',
    name: 'LinkageHandlingIndicator',
    id: 2448,
    abbrName: 'LnkgHandlInd',
    description:
      'Indicate whether linkage handling is in effect for an instrument or not.',
  },
  {
    type: 'int',
    addedEP: '190',
    added: 'FIX.5.0SP2',
    name: 'NumberOfBuyOrders',
    id: 2449,
    abbrName: 'NumOfBuyOrds',
    description: 'Number of buy orders involved in a trade.',
  },
  {
    type: 'int',
    addedEP: '190',
    added: 'FIX.5.0SP2',
    name: 'NumberOfSellOrders',
    id: 2450,
    abbrName: 'NumOfSellOrds',
    description: 'Number of sell orders involved in a trade.',
  },
  {
    type: 'SettlPriceDeterminationMethodCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '190',
    added: 'FIX.5.0SP2',
    name: 'SettlPriceDeterminationMethod',
    id: 2451,
    abbrName: 'SettlPxDtrmnMeth',
    description: 'Calculation method used to determine settlement price.',
  },
  {
    type: 'String',
    addedEP: '191',
    added: 'FIX.5.0SP2',
    name: 'MDStatisticReqID',
    id: 2452,
    abbrName: 'ReqID',
    description: 'Message identifier for a statistics request.',
  },
  {
    type: 'String',
    addedEP: '191',
    added: 'FIX.5.0SP2',
    name: 'MDStatisticRptID',
    id: 2453,
    abbrName: 'RptID',
    description: 'Message identifier for a statistics report.',
  },
  {
    type: 'String',
    addedEP: '191',
    added: 'FIX.5.0SP2',
    name: 'MDStatisticName',
    id: 2454,
    abbrName: 'StatsNme',
    description: 'The short name or acronym for a set of statistic parameters.',
  },
];

const batch7: ISpecFields[] = [
  {
    type: 'String',
    addedEP: '191',
    added: 'FIX.5.0SP2',
    name: 'MDStatisticDesc',
    id: 2455,
    abbrName: 'Desc',
    description:
      'Can be used to provide an optional textual description for a statistic.',
  },
  {
    type: 'MDStatisticTypeCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '191',
    added: 'FIX.5.0SP2',
    name: 'MDStatisticType',
    id: 2456,
    abbrName: 'Typ',
    description: 'Type of statistic value.',
  },
  {
    type: 'MDStatisticScopeCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '191',
    added: 'FIX.5.0SP2',
    name: 'MDStatisticScope',
    id: 2457,
    abbrName: 'Scope',
    description: 'Entities used as basis for the statistics.',
  },
  {
    type: 'MDStatisticSubScopeCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '191',
    added: 'FIX.5.0SP2',
    name: 'MDStatisticSubScope',
    id: 2458,
    abbrName: 'SubScope',
    description:
      'Sub-scope of the statistics to further reduce the entities used as basis for the statistics.',
  },
  {
    type: 'MDStatisticScopeTypeCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '191',
    added: 'FIX.5.0SP2',
    name: 'MDStatisticScopeType',
    id: 2459,
    abbrName: 'ScopeTyp',
    description:
      'Scope details of the statistics to reduce the number of events being used as basis for the statistics.',
  },
  {
    type: 'int',
    addedEP: '191',
    added: 'FIX.5.0SP2',
    name: 'MDStatisticFrequencyPeriod',
    id: 2460,
    abbrName: 'FreqPeriod',
    description:
      'Dissemination frequency of statistics.\n\nSpecial meaning for a value of zero which represents an event-driven dissemination in real time (e.g. as soon as a new trade occurs).',
  },
  {
    type: 'OrderDelayUnitCodeSet',
    addedEP: '191',
    added: 'FIX.5.0SP2',
    name: 'MDStatisticFrequencyUnit',
    id: 2461,
    abbrName: 'FreqUnit',
    description: 'Time unit for MDStatisticFrequencyPeriod(2460).',
  },
  {
    type: 'int',
    addedEP: '191',
    added: 'FIX.5.0SP2',
    name: 'MDStatisticDelayPeriod',
    id: 2462,
    abbrName: 'DelayPeriod',
    description:
      'Number of time units between the calculation of the statistic and its dissemination. Can be used to defer or delay publication.',
  },
  {
    type: 'OrderDelayUnitCodeSet',
    addedEP: '191',
    added: 'FIX.5.0SP2',
    name: 'MDStatisticDelayUnit',
    id: 2463,
    abbrName: 'DelayUnit',
    description: 'Time unit for MDStatisticDelayPeriod(2462).',
  },
  {
    type: 'MDStatisticIntervalTypeCodeSet',
    addedEP: '191',
    added: 'FIX.5.0SP2',
    name: 'MDStatisticIntervalType',
    id: 2464,
    abbrName: 'IntvlTyp',
    description: 'Type of interval over which statistic is calculated.',
  },
  {
    type: 'TimeUnitCodeSet',
    addedEP: '191',
    added: 'FIX.5.0SP2',
    name: 'MDStatisticIntervalTypeUnit',
    id: 2465,
    abbrName: 'IntvlTypUnit',
    description: 'Time unit for MDStatisticIntervalType(2464).',
  },
  {
    type: 'int',
    addedEP: '191',
    added: 'FIX.5.0SP2',
    name: 'MDStatisticIntervalPeriod',
    id: 2466,
    abbrName: 'IntvlPeriod',
    description:
      'Length of time over which the statistic is calculated. Special meaning for a value of zero to express that there is no aggregation over time. Can be used with other interval types expressing relative date and time ranges to combine them with sliding window peaks, e.g. highest volume across 1 minute intervals of the previous day.',
  },
  {
    type: 'OrderDelayUnitCodeSet',
    addedEP: '191',
    added: 'FIX.5.0SP2',
    name: 'MDStatisticIntervalUnit',
    id: 2467,
    abbrName: 'IntvlUnit',
    description: 'Time unit for MDStatisticIntervalPeriod(2466).',
  },
  {
    type: 'UTCTimestamp',
    addedEP: '191',
    added: 'FIX.5.0SP2',
    name: 'MDStatisticStartDate',
    id: 2468,
    abbrName: 'StartDt',
    description: 'First day of range for which statistical data is collected.',
  },
  {
    type: 'UTCTimestamp',
    addedEP: '191',
    added: 'FIX.5.0SP2',
    name: 'MDStatisticEndDate',
    id: 2469,
    abbrName: 'EndDt',
    description: 'Last day of range for which statistical data is collected.',
  },
  {
    type: 'UTCTimeOnly',
    addedEP: '191',
    added: 'FIX.5.0SP2',
    name: 'MDStatisticStartTime',
    id: 2470,
    abbrName: 'StartTm',
    description: 'Start time of the time range for which statistical data is collected.',
  },
  {
    type: 'UTCTimeOnly',
    addedEP: '191',
    added: 'FIX.5.0SP2',
    name: 'MDStatisticEndTime',
    id: 2471,
    abbrName: 'EndTm',
    description: 'End time of the time range for which statistical data is collected.',
  },
  {
    type: 'MDStatisticRatioTypeCodeSet',
    addedEP: '191',
    added: 'FIX.5.0SP2',
    name: 'MDStatisticRatioType',
    id: 2472,
    abbrName: 'RatioTyp',
    description: 'Ratios between various entities.',
  },
  {
    type: 'MDStatisticRequestResultCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '191',
    added: 'FIX.5.0SP2',
    name: 'MDStatisticRequestResult',
    id: 2473,
    abbrName: 'ReqRslt',
    description: 'Result returned in response to MarketDataStatisticsRequest (35=DO).',
  },
  {
    type: 'NumInGroup',
    addedEP: '191',
    added: 'FIX.5.0SP2',
    name: 'NoMDStatistics',
    id: 2474,
    description: 'Number of market data statistics.',
  },
  {
    type: 'String',
    addedEP: '191',
    added: 'FIX.5.0SP2',
    name: 'MDStatisticID',
    id: 2475,
    abbrName: 'StatsID',
    description: 'Unique identifier for a statistic.',
  },
  {
    type: 'UTCTimestamp',
    addedEP: '191',
    added: 'FIX.5.0SP2',
    name: 'MDStatisticTime',
    id: 2476,
    abbrName: 'Tm',
    description: 'Time of calculation of a statistic.',
  },
  {
    type: 'MDStatisticStatusCodeSet',
    addedEP: '191',
    added: 'FIX.5.0SP2',
    name: 'MDStatisticStatus',
    id: 2477,
    abbrName: 'Stat',
    description: 'Status for a statistic to indicate its availability.',
  },
  {
    type: 'float',
    addedEP: '191',
    added: 'FIX.5.0SP2',
    name: 'MDStatisticValue',
    id: 2478,
    abbrName: 'Val',
    description: 'Statistical value.',
  },
  {
    type: 'MDStatisticValueTypeCodeSet',
    addedEP: '191',
    added: 'FIX.5.0SP2',
    name: 'MDStatisticValueType',
    id: 2479,
    abbrName: 'Typ',
    description: 'Type of statistical value.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'OrderDelayUnitCodeSet',
    addedEP: '191',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'MDStatisticValueUnit',
    id: 2480,
    abbrName: 'ValUnit',
    description: 'Unit of time for statistical value.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'Length',
    addedEP: '191',
    updatedEP: '229',
    added: 'FIX.5.0SP2',
    name: 'EncodedMDStatisticDescLen',
    id: 2481,
    abbrName: 'EncDescLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedMDStatisticDesc(2482) field.',
  },
  {
    type: 'data',
    addedEP: '191',
    added: 'FIX.5.0SP2',
    name: 'EncodedMDStatisticDesc',
    id: 2482,
    abbrName: 'EncDesc',
    lengthId: '2481',
    description:
      'Encoded (non-ASCII characters) representation of the MDStatisticDesc(2455) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the MDStatisticDesc(2455) field.',
  },
  {
    type: 'RiskLimitCheckStatusCodeSet',
    addedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'AllocRiskLimitCheckStatus',
    id: 2483,
    abbrName: 'RiskLmtChkStat',
    description:
      'Indicates the status of the risk limit check performed on a trade for this allocation instance.',
  },
  {
    type: 'AssetGroupCodeSet',
    addedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'AssetGroup',
    id: 2210,
    abbrName: 'AssetGrp',
    description:
      'Indicates the broad product or asset classification. May be used to provide grouping for the product taxonomy (Product(460), SecurityType(167), etc.) and/or the risk taxonomy (AssetClass(1938), AssetSubClass(1939), AssetType(1940), etc.).',
  },
  {
    type: 'AssetGroupCodeSet',
    addedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'LegAssetGroup',
    id: 2348,
    abbrName: 'AssetGrp',
    description:
      'Indicates the broad product or asset classification. May be used to provide grouping for the product taxonomy (Product(460), SecurityType(167), etc.) and/or the risk taxonomy (AssetClass(1938), AssetSubClass(1939), AssetType(1940), etc.).',
  },
  {
    type: 'String',
    addedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'LegContractualDefinition',
    id: 42199,
    abbrName: 'Def',
    description:
      'Specifies which contract definition, such as those published by ISDA, will apply for the terms of the trade. See http://www.fpml.org/coding-scheme/contractual-definitions for values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'NoLegContractualDefinitions',
    id: 42198,
    description: 'Number of financing definitions in the repeating group.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'LegContractualMatrixDate',
    id: 42205,
    abbrName: 'Dt',
    description:
      'Specifies the publication date of the applicable version of the contract matrix. If not specified, the ISDA Standard Terms Supplement defines rules for which version of the matrix is applicable.',
  },
  {
    type: 'String',
    addedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'LegContractualMatrixSource',
    id: 42204,
    abbrName: 'Src',
    description:
      'Identifies the applicable contract matrix. See http://www.fpml.org/coding-scheme/matrix-type-1-0.xml for values.',
  },
  {
    updated: 'FIX.Latest',
    type: 'String',
    addedEP: '192',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'LegContractualMatrixTerm',
    id: 42206,
    abbrName: 'Trm',
    description:
      'Specifies the applicable key into the relevant contract matrix. In the case of 2000 ISDA Definitions Settlement Matrix for Early Termination and Swaptions, the LegContractualMatrixTerm(42206) is not applicable and is to be omitted. See http://www.fpml.org/coding-scheme/credit-matrix-transaction-type for values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'NoLegContractualMatrices',
    id: 42203,
    description: 'Number of contractual matrices in the repeating group.',
  },
  {
    type: 'data',
    addedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'EncodedLegDocumentationText',
    id: 2493,
    abbrName: 'EncDcmntnTxt',
    lengthId: '2494',
    description:
      'Encoded (non-ASCII characters) representation of the LegDocumentationText(2505) field in the encoded format specified via the MessageEncoding(347) field. If used, the ASCII (English) representation should also be specified in the LegDocumentationText(2505) field.',
  },
  {
    type: 'Length',
    addedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'EncodedLegDocumentationTextLen',
    id: 2494,
    abbrName: 'EncDcmntnTxtLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedLegDocumentationText(2493) field.',
  },
  {
    type: 'Currency',
    addedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'LegAgreementCurrency',
    id: 2495,
    abbrName: 'AgmtCcy',
    description:
      'Contractual currency forming the basis of a financing agreement and associated transactions. Usually, but not always, the same as the trade currency.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'LegAgreementDate',
    id: 2496,
    abbrName: 'AgmtDt',
    description:
      'A reference to the date the underlying agreement specified by LegAgreementID(2498) and LegAgreementDesc(2497) was executed.',
  },
  {
    type: 'String',
    addedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'LegAgreementDesc',
    id: 2497,
    abbrName: 'AgmtDesc',
    description:
      'The full name of the base standard agreement, annexes and amendments in place between the principals applicable to a financing transaction. See http://www.fpml.org/coding-scheme/master-agreement-type for derivative values.',
  },
  {
    type: 'String',
    addedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'LegAgreementID',
    id: 2498,
    abbrName: 'AgmtID',
    description:
      'A common reference to the applicable standing agreement between the counterparties to a financing transaction.',
  },
  {
    type: 'String',
    addedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'LegAgreementVersion',
    id: 2499,
    abbrName: 'AgmtVer',
    description: 'The version of the master agreement.',
  },
  {
    type: 'String',
    addedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'LegBrokerConfirmationDesc',
    id: 2500,
    abbrName: 'BrkrCnfmDesc',
    description:
      'Describes the type of broker confirmation executed between the parties. Can be used as an alternative to MasterConfirmationDesc(1962). See http://www.fpml.org/coding-scheme/broker-confirmation-type for values.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'LegCreditSupportAgreementDate',
    id: 2501,
    abbrName: 'CrdSuprtDt',
    description:
      'The date of the ISDA Credit Support Agreement executed between the parties and intended to govern collateral arrangements for all OTC derivatives transactions between those parties.',
  },
  {
    type: 'String',
    addedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'LegCreditSupportAgreementDesc',
    id: 2502,
    abbrName: 'CrdSuprtDesc',
    description:
      'The type of ISDA Credit Support Agreement. See http://www.fpml.org/coding-scheme/credit-support-agreement-type for values.',
  },
  {
    type: 'String',
    addedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'LegCreditSupportAgreementID',
    id: 2503,
    abbrName: 'CrdSuprtID',
    description:
      'A common reference or unique identifier to identify the ISDA Credit Support Agreement executed between the parties.',
  },
  {
    type: 'DeliveryTypeCodeSet',
    addedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryType',
    id: 2504,
    abbrName: 'DlvryTyp',
    description: 'Identifies type of settlement.',
  },
  {
    type: 'String',
    addedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'LegDocumentationText',
    id: 2505,
    abbrName: 'DcmntnTxt',
    description:
      'A sentence or phrase pertinent to the trade, not a reference to an external document. E.g. "To be registered with the U.S. Environmental Protection Agency, Acid Rain Division, SO2 Allowance Tracking System".',
  },
  {
    type: 'LocalMktDate',
    addedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'LegEndDate',
    id: 2506,
    abbrName: 'EndDt',
    description:
      'End date of a financing deal, i.e. the date the seller reimburses the buyer and takes back control of the collateral.',
  },
  {
    type: 'String',
    addedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'LegGoverningLaw',
    id: 2507,
    abbrName: 'Law',
    description:
      'Identification of the law governing the transaction. See http://www.fpml.org/coding-scheme/governing-law for values.',
  },
  {
    type: 'Percentage',
    addedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'LegMarginRatio',
    id: 2508,
    abbrName: 'MgnRatio',
    description:
      'The fraction of the cash consideration that must be collateralized, expressed as a percent. A MarginRatio of 2% indicates that the value of the collateral (after deducting for "haircut") must exceed the cash consideration by 2%.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'LegMasterConfirmationAnnexDate',
    id: 2509,
    abbrName: 'CnfmAnxDt',
    description:
      'The date that an annexation to the master confirmation was executed between the parties.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'LegMasterConfirmationDate',
    id: 2510,
    abbrName: 'CnfmDt',
    description:
      'Alternative to broker confirmation. The date of the confirmation executed between the parties and intended to govern all relevant transactions between those parties.',
  },
  {
    type: 'String',
    addedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'LegMasterConfirmationDesc',
    id: 2511,
    abbrName: 'CnfmDesc',
    description:
      'The type of master confirmation executed between the parties. See http://www.fpml.org/coding-scheme/master-confirmation-type for values.',
  },
  {
    type: 'String',
    addedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'LegMasterConfirmationAnnexDesc',
    id: 2512,
    abbrName: 'CnfmAnxDesc',
    description:
      'The type of master confirmation annexation executed between the parties. See http://www.fpml.org/coding-scheme/master-confirmation-annex-type for values.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'LegStartDate',
    id: 2513,
    abbrName: 'StartDt',
    description:
      'Start date of a financing deal, i.e. the date the buyer pays the seller cash and takes control of the collateral.',
  },
  {
    type: 'TerminationTypeCodeSet',
    addedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'LegTerminationType',
    id: 2514,
    abbrName: 'TrmTyp',
    description: 'Type of financing termination.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'LegFinancingTermSupplementDate',
    id: 42202,
    abbrName: 'Dt',
    description:
      'Specifies the publication date of the applicable version of the contractual supplement.',
  },
  {
    type: 'String',
    addedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'LegFinancingTermSupplementDesc',
    id: 42201,
    abbrName: 'Desc',
    description:
      'Identifies the applicable contractual supplement. See http://www.fpml.org/coding-scheme/contractual-supplement for values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'NoLegFinancingTermSupplements',
    id: 42200,
    description: 'Number of financing terms supplements in the repeating group.',
  },
  {
    type: 'AssetGroupCodeSet',
    addedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingAssetGroup',
    id: 2491,
    abbrName: 'AssetGrp',
    description:
      'Indicates the broad product or asset classification. May be used to provide grouping for the product taxonomy (Product(460), SecurityType(167), etc.) and/or the risk taxonomy (AssetClass(1938), AssetSubClass(1939), AssetType(1940), etc.).',
  },
  {
    type: 'String',
    addedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'FirmTransactionID',
    id: 2484,
    abbrName: 'FirmTxnID',
    description: 'The unique transaction entity identifier assigned by the firm.',
  },
  {
    type: 'String',
    addedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'TransactionID',
    id: 2485,
    abbrName: 'TxnID',
    description: 'The unique transaction entity identifier.',
  },
  {
    type: 'String',
    addedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'WireReference',
    id: 2486,
    abbrName: 'WreRef',
    description:
      'The reference to a wire transfer associated with the transaction. Wire references done via wire services such as Fedwire Output Message Accountabilitty Data "OMAD" or SWIFT Output Sequence Number "OSN".',
  },
  {
    type: 'CollRptRejectReasonCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'CollRptRejectReason',
    id: 2487,
    abbrName: 'RejRsn',
    description: 'Reject reason code for rejecting the collateral report.',
  },
  {
    type: 'CollRptStatusCodeSet',
    addedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'CollRptStatus',
    id: 2488,
    abbrName: 'RptStat',
    description: 'The status of the collateral report.',
  },
  {
    type: 'String',
    addedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'PackageID',
    id: 2489,
    abbrName: 'PackageID',
    description:
      'Identifier assigned to a collection of trades so that they can be analyzed as one atomic unit for risk assessment and clearing.',
  },
  {
    type: 'int',
    addedEP: '192',
    added: 'FIX.5.0SP2',
    name: 'TradeNumber',
    id: 2490,
    abbrName: 'TrdNum',
    description: 'Ordinal number of the trade within a series of related trades.',
  },
  {
    type: 'Qty',
    addedEP: '193',
    added: 'FIX.5.0SP2',
    name: 'AllocCalculatedCcyQty',
    id: 2515,
    abbrName: 'CalcCcyQty',
    description:
      'Used for the calculated quantity of the other side of the currency trade applicable to the allocation instance.',
  },
  {
    type: 'String',
    addedEP: '193',
    added: 'FIX.5.0SP2',
    name: 'CollateralRequestInstruction',
    id: 2516,
    abbrName: 'CollReqInst',
    description: 'An encoded collateral request processing instruction to the receiver.',
  },
  {
    type: 'String',
    addedEP: '193',
    added: 'FIX.5.0SP2',
    name: 'CollateralRequestLinkID',
    id: 2517,
    abbrName: 'CollReqLinkID',
    description: 'A unique identifier to link together a set or group of requests.',
  },
  {
    type: 'int',
    addedEP: '193',
    added: 'FIX.5.0SP2',
    name: 'CollateralRequestNumber',
    id: 2518,
    abbrName: 'CollReqNum',
    description: 'Ordinal number of the request within a set or group of requests.',
  },
  {
    type: 'int',
    addedEP: '193',
    added: 'FIX.5.0SP2',
    name: 'TotNumCollateralRequests',
    id: 2519,
    abbrName: 'TotNumCollReqs',
    description: 'Total number of request messages within a set or group of requests.',
  },
  {
    type: 'String',
    addedEP: '193',
    added: 'FIX.5.0SP2',
    name: 'WarningText',
    id: 2520,
    abbrName: 'WarnTxt',
    description:
      'Communicates the underlying condition when the request response indicates "warning".',
  },
  {
    type: 'data',
    addedEP: '193',
    added: 'FIX.5.0SP2',
    name: 'EncodedWarningText',
    id: 2521,
    abbrName: 'EncWarnTxt',
    lengthId: '2522',
    description:
      'Encoded (non-ASCII characters) representation of the WarningText(2520) field in the encoded format specified via the MessageEncoding(347) field. If used, the ASCII (English) representation should also be specified in the WarningText(2520) field.',
  },
  {
    type: 'Length',
    addedEP: '193',
    added: 'FIX.5.0SP2',
    name: 'EncodedWarningTextLen',
    id: 2522,
    abbrName: 'EncWarnTxtLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedWarningtText(2521) field.',
  },
  {
    type: 'String',
    addedEP: '193',
    added: 'FIX.5.0SP2',
    name: 'LegStreamCommodityDeliveryPricingRegion',
    id: 42588,
    abbrName: 'DlvryPxngRgn',
    description:
      'The delivery or pricing region associated with the commodity swap. See http://www.ecfr.gov/cgi-bin/text-idx?SID=660d6a40f836aa6ddf213cba080c5b22&node=ap17.2.43_17.e&rgn=div9 for the external code list.\n\nIn the context of CFTC Part 43 Appendix E requirement this represents the specific delivery point or pricing point associated with publically reportable commodity swap transactions.',
  },
  {
    type: 'String',
    addedEP: '193',
    added: 'FIX.5.0SP2',
    name: 'StreamCommodityDeliveryPricingRegion',
    id: 42587,
    abbrName: 'DlvryPxngRgn',
    description:
      'The delivery or pricing region associated with the commodity swap. See http://www.ecfr.gov/cgi-bin/text-idx?SID=660d6a40f836aa6ddf213cba080c5b22&node=ap17.2.43_17.e&rgn=div9 for the external code list.\n\nIn the context of CFTC Part 43 Appendix E requirement this represents the specific delivery point or pricing point associated with publicly reportable commodity swap transactions.',
  },
  {
    type: 'Boolean',
    addedEP: '193',
    added: 'FIX.5.0SP2',
    name: 'AffiliatedFirmsTradeIndicator',
    id: 2525,
    abbrName: 'AffltdFirmsTrdInd',
    description:
      'Indicates whether the transaction or position was entered into between two affiliated firms. I.e. one counterparty has an ownership interest in the other counterparty but less than the majority interest.\n\nThis trade attribute was identified under and applies to the Canadian CSA trade reporting regulations.',
  },
  {
    type: 'Boolean',
    addedEP: '193',
    added: 'FIX.5.0SP2',
    name: 'InternationalSwapIndicator',
    id: 2526,
    abbrName: 'IntlSwapInd',
    description:
      'Identifies the swap trade as an "international" transaction.\n\nIn the context of CFTC Regulation 45.3(h), an international swap is required by U.S. law and the law of another jurisdiction to be reported both to a US Swaps Data Repository and to a different trade repository registered within the other jurisdiction. The additional SDRs must be identified in the appropriate Parties component with PartyRole(452) = 102 (Data repository), PartyRoleQualifier(2376) = 11 (Additional international trade repository) and PartySubIDType(803) = 70 (Location or jurisdiction).',
  },
  {
    type: 'Boolean',
    addedEP: '193',
    added: 'FIX.5.0SP2',
    name: 'MultiAssetSwapIndicator',
    id: 2527,
    abbrName: 'MAsstSwapInd',
    description:
      "Indicates a swap that does not have one easily identifiable primary underlying asset, but instead involves multiple underlying assets within one trade repository's jurisdiction that belong to different asset classes.\n\n",
  },
  {
    type: 'String',
    addedEP: '193',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamCommodityDeliveryPricingRegion',
    id: 42589,
    abbrName: 'DlvryPxngRgn',
    description:
      'The delivery or pricing region associated with the commodity swap. See http://www.ecfr.gov/cgi-bin/text-idx?SID=660d6a40f836aa6ddf213cba080c5b22&node=ap17.2.43_17.e&rgn=div9 for the external code list.\n\nIn the context of CFTC Part 43 Appendix E requirement this represents the specific delivery point or pricing point associated with publically reportable commodity swap transactions.',
  },
  {
    type: 'NumInGroup',
    addedEP: '194',
    added: 'FIX.5.0SP2',
    name: 'NoRelativeValues',
    id: 2529,
    description: 'Number of relative value metrics entries in the repeating group.',
  },
  {
    type: 'RelativeValueTypeCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '194',
    added: 'FIX.5.0SP2',
    name: 'RelativeValueType',
    id: 2530,
    abbrName: 'Typ',
    description: 'Indicates the type of relative value measurement being specified.',
  },
  {
    type: 'float',
    addedEP: '194',
    added: 'FIX.5.0SP2',
    name: 'RelativeValue',
    id: 2531,
    abbrName: 'Val',
    description:
      'The valuation of an instrument relative to a base measurement specified in RelativeValueType(2530). This value can be negative.',
  },
  {
    type: 'RelativeValueSideCodeSet',
    addedEP: '194',
    added: 'FIX.5.0SP2',
    name: 'RelativeValueSide',
    id: 2532,
    abbrName: 'Side',
    description: 'Specifies the side of the relative value.',
  },
  {
    type: 'float',
    addedEP: '194',
    added: 'FIX.5.0SP2',
    name: 'BidSpread',
    id: 2533,
    abbrName: 'BidSpread',
    description:
      'Basis points relative to a benchmark curve on the bid side, such as LIBOR, or a known security, such as 10Y US Treasury bond. The benchmark security or curve name is specified in the SpreadOrBenchmarkCurveData component.',
  },
  {
    type: 'float',
    addedEP: '194',
    added: 'FIX.5.0SP2',
    name: 'OfferSpread',
    id: 2534,
    abbrName: 'OfrSpread',
    description:
      'Basis points relative to a benchmark curve on the offer side, such as LIBOR, or a known security, such as 10Y US Treasury bond. The benchmark security or curve name is specified in the SpreadOrBenchmarkCurveData component.',
  },
  {
    type: 'Price',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'ClearingSettlPrice',
    id: 2528,
    abbrName: 'SetPx',
    description: 'Clearing settlement price.',
  },
  {
    type: 'MDReportEventCodeSet',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'MDReportEvent',
    id: 2535,
    abbrName: 'MDRptEvent',
    description: 'Technical event within market data feed.',
  },
  {
    type: 'int',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'MDReportCount',
    id: 2536,
    abbrName: 'MDRptCnt',
    description:
      'Number of reference and market data messages in-between two MarketDataReport(35=DR) messages.',
  },
  {
    type: 'int',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'TotNoMarketSegmentReports',
    id: 2537,
    abbrName: 'TotNoMktSegRpts',
    description: 'Total number of reports related to market segments.',
  },
  {
    type: 'int',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'TotNoInstrumentReports',
    id: 2538,
    abbrName: 'TotNoInstrmtRpts',
    description: 'Total number of reports related to instruments.',
  },
  {
    type: 'int',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'TotNoPartyDetailReports',
    id: 2539,
    abbrName: 'TotNoPtyDetlRpts',
    description: 'Total number of reports related to party detail information.',
  },
  {
    type: 'int',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'TotNoEntitlementReports',
    id: 2540,
    abbrName: 'TotNoEntlmntRpts',
    description: 'Total number of reports related to party entitlement information.',
  },
  {
    type: 'int',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'TotNoRiskLimitReports',
    id: 2541,
    abbrName: 'TotNoRiskLmtRpts',
    description: 'Total number of reports related to party risk limit information.',
  },
  {
    type: 'MarketSegmentStatusCodeSet',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'MarketSegmentStatus',
    id: 2542,
    abbrName: 'MktSegStat',
    description: 'Status of market segment.',
  },
  {
    type: 'MarketSegmentTypeCodeSet',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'MarketSegmentType',
    id: 2543,
    abbrName: 'MktSegTyp',
    description: 'Used to classify the type of market segment.',
  },
  {
    type: 'MarketSegmentSubTypeCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'MarketSegmentSubType',
    id: 2544,
    abbrName: 'MktSegSubTyp',
    description:
      'Used to further categorize market segments within a MarketSegmentType(2543).',
  },
  {
    type: 'NumInGroup',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'NoRelatedMarketSegments',
    id: 2545,
    description: 'Number of related market segments.',
  },
  {
    type: 'String',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'RelatedMarketSegmentID',
    id: 2546,
    abbrName: 'ReltdMktSegID',
    description: 'Identifies a related market segment.',
  },
  {
    type: 'MarketSegmentRelationshipCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'MarketSegmentRelationship',
    id: 2547,
    abbrName: 'MktSegRltnshp',
    description: 'Type of relationship between two or more market segments.',
  },
  {
    type: 'NumInGroup',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'NoAuctionTypeRules',
    id: 2548,
    description: 'Number of auction order types.',
  },
  {
    type: 'String',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'AuctionTypeProductComplex',
    id: 2549,
    abbrName: 'AuctTypProdCmplx',
    description:
      'Identifies an entire suite of products for which the auction order type rule applies.',
  },
  {
    type: 'NumInGroup',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'NoPriceRangeRules',
    id: 2550,
    description: 'Number of rules related to price ranges.',
  },
  {
    type: 'Price',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'StartPriceRange',
    id: 2551,
    abbrName: 'StartPxRng',
    description: 'Lower boundary for price range.',
  },
  {
    type: 'Price',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'EndPriceRange',
    id: 2552,
    abbrName: 'EndPxRng',
    description: 'Upper boundary for price range.',
  },
  {
    type: 'Price',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'PriceRangeValue',
    id: 2553,
    abbrName: 'PxRngValu',
    description: 'Maximum range expressed as absolute value.',
  },
  {
    type: 'Percentage',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'PriceRangePercentage',
    id: 2554,
    abbrName: 'PxRngPctage',
    description: 'Maximum range expressed as percentage.',
  },
  {
    type: 'String',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'PriceRangeProductComplex',
    id: 2555,
    abbrName: 'PxRngProdCmplx',
    description:
      'Identifies an entire suite of products in the context of trading rules related to price ranges.',
  },
  {
    type: 'String',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'PriceRangeRuleID',
    id: 2556,
    abbrName: 'PxRngRuleID',
    description: 'Identifier for a price range rule.',
  },
  {
    type: 'Percentage',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'FastMarketPercentage',
    id: 2557,
    abbrName: 'FastMktPctage',
    description:
      'The percentage factor to be applied to trading rule parameters (e.g. price ranges, size ranges, etc.) when fast market conditions are applicable.',
  },
  {
    type: 'NumInGroup',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'NoQuoteSizeRules',
    id: 2558,
    description: 'Number of rules related to quote sizes.',
  },
  {
    type: 'QuoteSideIndicatorCodeSet',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'QuoteSideIndicator',
    id: 2559,
    abbrName: 'QuotSideInd',
    description: 'Indicates whether single sided quotes are allowed.',
  },
  {
    type: 'NumInGroup',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'NoFlexProductEligibilities',
    id: 2560,
    description:
      'Number of eligibility indicators for the creation of flexible securities.',
  },
  {
    type: 'String',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'FlexProductEligibilityComplex',
    id: 2561,
    abbrName: 'FlexProdEligCmplx',
    description:
      'Identifies an entire suite of products which are eligible for the creation of flexible securities.',
  },
  {
    type: 'int',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'NumOfComplexInstruments',
    id: 2562,
    abbrName: 'NumCmplxInstrmt',
    description:
      'Represents the total number of multileg securities or user defined securities that make up the security.',
  },
  {
    type: 'int',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'MarketDepthTimeInterval',
    id: 2563,
    abbrName: 'MktDepthTmIntvl',
    description:
      'Specifies the time interval used for netting market data in a price depth feed.',
  },
  {
    type: 'OrderDelayUnitCodeSet',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'MarketDepthTimeIntervalUnit',
    id: 2564,
    abbrName: 'MktDepthTmIntvlUnit',
    description:
      'The time unit associated with the time interval of the netting of market data in a price depth feed.',
  },
  {
    type: 'int',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'MDRecoveryTimeInterval',
    id: 2565,
    abbrName: 'MDRcvryTmIntvl',
    description:
      'Specifies the time interval between two repetitions of the same market data for cyclic recovery feeds.',
  },
  {
    type: 'OrderDelayUnitCodeSet',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'MDRecoveryTimeIntervalUnit',
    id: 2566,
    abbrName: 'MDRcvryTmIntvlUnit',
    description:
      'The time unit associated with the time interval between two cycles of the same market data in cyclic data recovery feeds.',
  },
  {
    type: 'String',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'PrimaryServiceLocationID',
    id: 2567,
    abbrName: 'SvcLctnID1',
    description: 'Primary service location identifier.',
  },
  {
    type: 'String',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'SecondaryServiceLocationID',
    id: 2568,
    abbrName: 'SvcLctnID2',
    description: 'Secondary or alternate service location identifier.',
  },
  {
    type: 'String',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'MatchRuleProductComplex',
    id: 2569,
    abbrName: 'MtchRuleProdCmplx',
    description:
      'Identifies an entire suite of products for which the matching rule applies.',
  },
  {
    type: 'CustomerPriorityCodeSet',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'CustomerPriority',
    id: 2570,
    abbrName: 'CustPri',
    description: 'Specifies the kind of priority given to customers.',
  },
  {
    type: 'String',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'TickRuleProductComplex',
    id: 2571,
    abbrName: 'TickRuleProdCmplx',
    description:
      'Identifies an entire suite of products for which the price tick rule applies.',
  },
  {
    type: 'Amt',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'PreviousAdjustedOpenInterest',
    id: 2572,
    abbrName: 'PrevAdjOpenInt',
    description: "Previous day's adjusted open interest.",
  },
  {
    type: 'Amt',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'PreviousUnadjustedOpenInterest',
    id: 2573,
    abbrName: 'PrevUnadjOpenInt',
    description: "Previous day's unadjusted open interest.",
  },
  {
    type: 'Boolean',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'LowExercisePriceOptionIndicator',
    id: 2574,
    abbrName: 'LowExerPxOptInd',
    description:
      'Indicates if a given option instrument permits low exercise prices (LEPO).',
  },
  {
    type: 'Boolean',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'BlockTradeEligibilityIndicator',
    id: 2575,
    abbrName: 'BlckTrdEligInd',
    description: 'Indicates if a given instrument is eligible for block trading.',
  },
  {
    type: 'int',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'InstrumentPricePrecision',
    id: 2576,
    abbrName: 'PxPrcsn',
    description: 'Specifies the number of decimal places for instrument prices.',
  },
  {
    type: 'int',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'StrikePricePrecision',
    id: 2577,
    abbrName: 'StrkPxPrcsn',
    description: 'Specifies the number of decimal places for exercise price.',
  },
  {
    type: 'Price',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'OrigStrikePrice',
    id: 2578,
    abbrName: 'OrigStrkPx',
    description:
      'Original exercise price, e.g. after corporate action requiring changes.',
  },
  {
    type: 'SettlSubMethodCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'SettlSubMethod',
    id: 2579,
    abbrName: 'SettlSubMeth',
    description:
      'Specifies a suitable settlement sub-method for a given settlement method.',
  },
  {
    type: 'NumInGroup',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'NoClearingPriceParameters',
    id: 2580,
    description: 'Number of parameter sets for clearing prices.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'BusinessDayType',
    id: 2581,
    abbrName: 'BizDayTyp',
    description: 'Relative identification of a business day.',
  },
  {
    type: 'PriceOffset',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'ClearingPriceOffset',
    id: 2582,
    abbrName: 'ClrPxOfst',
    description:
      'Constant value required for the calculation of the clearing price, e.g. for variance futures.',
  },
  {
    type: 'float',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'VegaMultiplier',
    id: 2583,
    abbrName: 'VegaMult',
    description:
      'Constant value required for the calculation of the clearing quantity, e.g. for variance futures.',
  },
  {
    type: 'int',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'AnnualTradingBusinessDays',
    id: 2584,
    abbrName: 'AnnlTrdgBizDays',
    description: 'Number of trading business days in a year.',
  },
  {
    type: 'int',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'TotalTradingBusinessDays',
    id: 2585,
    abbrName: 'TotTrdgBizDays',
    description: 'Number of trading business days over the lifetime of an instrument.',
  },
  {
    type: 'int',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'TradingBusinessDays',
    id: 2586,
    abbrName: 'TrdgBizDays',
    description: 'Number of actual trading business days of an instrument.',
  },
  {
    type: 'float',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'RealizedVariance',
    id: 2587,
    abbrName: 'RlzdVarnc',
    description:
      'Actual or realized variance of an instrument used to calculate settlement prices, e.g. for variance futures.',
  },
  {
    type: 'float',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'StandardVariance',
    id: 2588,
    abbrName: 'StdVarnc',
    description:
      'Standard variance (over the lifetime of an instrument) or initial variance used to calculate settlement prices, e.g. for variance futures.',
  },
  {
    type: 'Price',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'RelatedClosePrice',
    id: 2589,
    abbrName: 'ReltdClsPx',
    description:
      'Closing price of the underlying required to calculate the RealizedVariance(2587).',
  },
  {
    type: 'float',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'OvernightInterestRate',
    id: 2590,
    abbrName: 'OvrNiteIntRt',
    description: 'Overnight interest rate.',
  },
  {
    type: 'float',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'AccumulatedReturnModifiedVariationMargin',
    id: 2591,
    abbrName: 'ARMVM',
    description:
      'The economic cost of the variation margin from one trading day to the next.',
  },
  {
    type: 'CalculationMethodCodeSet',
    addedEP: '195',
    added: 'FIX.5.0SP2',
    name: 'CalculationMethod',
    id: 2592,
    abbrName: 'CalcMeth',
    description: 'Specifies how the calculation will be made.',
  },
  {
    type: 'NumInGroup',
    addedEP: '196',
    added: 'FIX.5.0SP2',
    name: 'NoMiscFeeSubTypes',
    id: 2633,
    description: 'Specifies the number of miscellaneous fee sub-types.',
  },
  {
    type: 'String',
    addedEP: '196',
    added: 'FIX.5.0SP2',
    name: 'MiscFeeSubType',
    id: 2634,
    abbrName: 'Typ',
    description:
      'Used to provide more granular fee types related to a value of MiscFeeType(139).\n\nSee http://www.fixtradingcommunity.org/codelists#Misc_Fee_Sub_Types for code list of applicable fees. Other fee sub-types may be used by mutual agreement of the counterparties.\n\nFee sub-types may include market or country specific fee.',
  },
  {
    type: 'Amt',
    addedEP: '196',
    added: 'FIX.5.0SP2',
    name: 'MiscFeeSubTypeAmt',
    id: 2635,
    abbrName: 'Amt',
    description: 'The amount of the specified MiscFeeSubType(2634).',
  },
  {
    type: 'String',
    addedEP: '196',
    added: 'FIX.5.0SP2',
    name: 'MiscFeeSubTypeDesc',
    id: 2636,
    abbrName: 'Desc',
    description:
      'Can be used to provide an optional textual description of the fee sub-type.',
  },
  {
    type: 'Length',
    addedEP: '196',
    added: 'FIX.5.0SP2',
    name: 'EncodedMiscFeeSubTypeDescLen',
    id: 2637,
    abbrName: 'EncDescLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedMiscFeeSubTypeDesc(2638) field.',
  },
  {
    type: 'data',
    addedEP: '196',
    added: 'FIX.5.0SP2',
    name: 'EncodedMiscFeeSubTypeDesc',
    id: 2638,
    abbrName: 'EncDesc',
    lengthId: '2637',
    description:
      'Encoded (non-ASCII characters) representation of the MiscFeeSubTypeDesc(2636) field in the encoded format specified via the MessageEncoding (347) field. If used, the ASCII (English) representation should also be specified in the MiscFeeSubTypeDesc(2636) field.',
  },
  {
    type: 'CollateralAmountTypeCodeSet',
    addedEP: '197',
    added: 'FIX.5.0SP2',
    name: 'CollateralAmountType',
    id: 2632,
    abbrName: 'AmtTyp',
    description: 'The type of value in CurrentCollateralAmount(1704).',
  },
  {
    type: 'String',
    addedEP: '199',
    added: 'FIX.5.0SP2',
    name: 'PositionID',
    id: 2618,
    abbrName: 'PosID',
    description:
      'Unique identifier for a position entity. Refer to PosMaintRptID(721) for a unique identifier of a position report message.',
  },
  {
    type: 'String',
    addedEP: '203',
    added: 'FIX.5.0SP2',
    name: 'PaymentDesc',
    id: 43087,
    abbrName: 'Desc',
    description:
      'A short descriptive name given to the payment, e.g. Premium, Upfront, etc. The description has no intrinsic meaning but should be arbitrarily chosen by the remitter as reference.',
  },
  {
    type: 'NumInGroup',
    addedEP: '204',
    added: 'FIX.5.0SP2',
    name: 'NoCommissions',
    id: 2639,
    description: 'Number of commissions in the repeating group.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'Amt',
    addedEP: '204',
    updatedEP: '223',
    added: 'FIX.5.0SP2',
    name: 'CommissionAmount',
    id: 2640,
    abbrName: 'Amt',
    description: 'The commission amount.',
  },
  {
    type: 'CommissionAmountTypeCodeSet',
    addedEP: '204',
    added: 'FIX.5.0SP2',
    name: 'CommissionAmountType',
    id: 2641,
    abbrName: 'Typ',
    description:
      'Indicates what type of commission is being expressed in CommissionAmount(2640).',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'CommTypeCodeSet',
    addedEP: '204',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'CommissionBasis',
    id: 2642,
    abbrName: 'Basis',
    description: 'Specifies the basis or unit used to calculate the commission.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Currency',
    addedEP: '204',
    updatedEP: '273',
    added: 'FIX.5.0SP2',
    name: 'CommissionCurrency',
    id: 2643,
    abbrName: 'Ccy',
    description:
      "Specifies the currency denomination of the commission amount if different from the trade's currency.\n\nCommissionCurrencyCodeSource(2923) may be used to disambiguate the code source scheme used, and ISO 4217 is the default scheme if absent.",
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'UnitOfMeasureCodeSet',
    addedEP: '204',
    updatedEP: '223',
    added: 'FIX.5.0SP2',
    name: 'CommissionUnitOfMeasure',
    id: 2644,
    abbrName: 'UOM',
    description: 'The commission rate unit of measure.',
  },
  {
    type: 'Currency',
    addedEP: '204',
    added: 'FIX.5.0SP2',
    name: 'CommissionUnitOfMeasureCurrency',
    id: 2645,
    abbrName: 'UOMCcy',
    description:
      'Indicates the currency of the unit of measure. Conditionally required when CommissionUnitOfMeasure(2644) = Ccy (Amount of currency).',
  },
  {
    type: 'float',
    addedEP: '204',
    added: 'FIX.5.0SP2',
    name: 'CommissionRate',
    id: 2646,
    abbrName: 'Rt',
    description:
      'The commission rate when CommissionAmount(2640) is based on a percentage of quantity, amount per unit or a factor of "unit of measure". If the rate is a percentage or expressed in basis points, use the decimalized form, e.g. "0.05" for a 5% commission or "0.005" for 50 basis points.',
  },
  {
    type: 'Boolean',
    addedEP: '204',
    added: 'FIX.5.0SP2',
    name: 'CommissionSharedIndicator',
    id: 2647,
    abbrName: 'SharedInd',
    description:
      'Indicates whether the amount in CommissionAmount(2640) is to be shared with a third party, e.g. as part of a directed brokerage commission sharing arrangement.',
  },
  {
    type: 'Amt',
    addedEP: '204',
    added: 'FIX.5.0SP2',
    name: 'CommissionAmountShared',
    id: 2648,
    abbrName: 'AmtShared',
    description:
      'Commission amount to be shared with a third party, e.g. as part of a directed brokerage commission sharing arrangement. If specified, this amount should not exceed the amount in CommissionAmount(2640).',
  },
  {
    type: 'String',
    addedEP: '204',
    added: 'FIX.5.0SP2',
    name: 'CommissionLegRefID',
    id: 2649,
    abbrName: 'LegRefID',
    description:
      "Identifies the leg of the trade the entry applies to by referencing the leg's LegID(1788).",
  },
  {
    type: 'String',
    addedEP: '204',
    added: 'FIX.5.0SP2',
    name: 'CommissionDesc',
    id: 2650,
    abbrName: 'Desc',
    description: 'Description of the commission.',
  },
  {
    type: 'Length',
    addedEP: '204',
    added: 'FIX.5.0SP2',
    name: 'EncodedCommissionDescLen',
    id: 2651,
    abbrName: 'EncDescLen',
    description:
      'Byte length of the encoded (non-ASCII characters) EncodedCommissionDesc(2652) field.',
  },
  {
    type: 'data',
    addedEP: '204',
    added: 'FIX.5.0SP2',
    name: 'EncodedCommissionDesc',
    id: 2652,
    abbrName: 'EncDesc',
    lengthId: '2651',
    description:
      'Encoded (non-ASCII characters) representation of the CommissionDesc(2650) field in the encoded format specified via the MessageEncoding(347) field. If used, the ASCII (English) representation should also be specified in the CommissionDesc(2650) field.',
  },
  {
    type: 'NumInGroup',
    addedEP: '204',
    added: 'FIX.5.0SP2',
    name: 'NoAllocCommissions',
    id: 2653,
    description: 'Number of commissions in the repeating group.',
  },
  {
    type: 'Amt',
    addedEP: '204',
    added: 'FIX.5.0SP2',
    name: 'AllocCommissionAmount',
    id: 2654,
    abbrName: 'Amt',
    description: 'The commission amount.',
  },
  {
    type: 'CommissionAmountTypeCodeSet',
    addedEP: '204',
    added: 'FIX.5.0SP2',
    name: 'AllocCommissionAmountType',
    id: 2655,
    abbrName: 'Typ',
    description:
      'Indicates what type of commission is being expressed in AllocCommissionAmount(2654).',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'CommTypeCodeSet',
    addedEP: '204',
    updatedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'AllocCommissionBasis',
    id: 2656,
    abbrName: 'Basis',
    description: 'Specifies the basis or unit used to calculate the commission.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Currency',
    addedEP: '204',
    updatedEP: '273',
    added: 'FIX.5.0SP2',
    name: 'AllocCommissionCurrency',
    id: 2657,
    abbrName: 'Ccy',
    description:
      "Specifies the currency denomination of the commission amount if different from the trade's currency.\n\nAllocCommissionCurrencyCodeSource(2925) may be used to disambiguate the code source scheme used, and ISO 4217 is the default scheme if absent.",
  },
  {
    type: 'UnitOfMeasureCodeSet',
    addedEP: '204',
    added: 'FIX.5.0SP2',
    name: 'AllocCommissionUnitOfMeasure',
    id: 2658,
    abbrName: 'UOM',
    description: 'The commission rate unit of measure.',
  },
  {
    type: 'Currency',
    addedEP: '204',
    added: 'FIX.5.0SP2',
    name: 'AllocCommissionUnitOfMeasureCurrency',
    id: 2659,
    abbrName: 'UOMCcy',
    description:
      'Indicates the currency of the unit of measure. Conditionally required when AllocCommissionUnitOfMeasure(2658) = Ccy (Currency).',
  },
  {
    type: 'float',
    addedEP: '204',
    added: 'FIX.5.0SP2',
    name: 'AllocCommissionRate',
    id: 2660,
    abbrName: 'Rt',
    description:
      'The commission rate when AllocCommissionAmount(2654) is based on a percentage of quantity, amount per unit or a factor of "unit of measure". If the rate is a percentage or expressed in basis points, use the decimalized form, e.g. "0.05" for a 5% commission or "0.005" for 50 basis points.',
  },
  {
    type: 'Boolean',
    addedEP: '204',
    added: 'FIX.5.0SP2',
    name: 'AllocCommissionSharedIndicator',
    id: 2661,
    abbrName: 'SharedInd',
    description:
      'Indicates whether the amount in AllocCommissionAmount(2654) is to be shared with a third party, e.g. as part of a directed brokerage commission sharing arrangement.',
  },
  {
    type: 'Amt',
    addedEP: '204',
    added: 'FIX.5.0SP2',
    name: 'AllocCommissionAmountShared',
    id: 2662,
    abbrName: 'AmtShared',
    description:
      'Commission amount to be shared with a third party, e.g. as part of a directed brokerage commission sharing arrangement. If specified, this amount should not exceed the amount in AllocCommissionAmount(2654).',
  },
  {
    type: 'String',
    addedEP: '204',
    added: 'FIX.5.0SP2',
    name: 'AllocCommissionLegRefID',
    id: 2663,
    abbrName: 'LegRefID',
    description:
      "Identifies the leg of the trade the entry applies to by referencing the leg's LegID(1788).",
  },
  {
    type: 'String',
    addedEP: '204',
    added: 'FIX.5.0SP2',
    name: 'AllocCommissionDesc',
    id: 2664,
    abbrName: 'Desc',
    description: 'Description of the commission.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'Length',
    addedEP: '204',
    updatedEP: '229',
    added: 'FIX.5.0SP2',
    name: 'EncodedAllocCommissionDescLen',
    id: 2665,
    abbrName: 'EncDescLen',
    description:
      'Byte length of the encoded (non-ASCII characters) EncodedAllocCommissionDesc(2666) field.',
  },
  {
    type: 'data',
    addedEP: '204',
    added: 'FIX.5.0SP2',
    name: 'EncodedAllocCommissionDesc',
    id: 2666,
    abbrName: 'EncDesc',
    lengthId: '2665',
    description:
      'Encoded (non-ASCII characters) representation of the AllocCommissionDesc(2664) field in the encoded format specified via the MessageEncoding(347) field. If used, the ASCII (English) representation should also be specified in the AllocCommissionDesc(2664) field.',
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DeltaCrossed',
    id: 2596,
    abbrName: 'DeltaCrssd',
    description:
      'Indicates that the party has taken a position on both a put and a call on the same underlying asset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'CashSettlDateUnadjusted',
    id: 42207,
    abbrName: 'DtUnadj',
    description: 'The unadjusted cash settlement date.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'CashSettlDateBusinessDayConvention',
    id: 42208,
    abbrName: 'BizDayCnvtn',
    description:
      "The business day convention used to adjust the cash settlement provision's date. Used only to override the business day convention defined in the Instrument component.",
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'CashSettlDateRelativeTo',
    id: 42209,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the cash settlement date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'CashSettlDateOffsetPeriod',
    id: 42210,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative cash settlement date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'CashSettlDateOffsetUnit',
    id: 42211,
    abbrName: 'OfstUnit',
    description: 'Time unit associated with the relative cash settlement date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'CashSettlDateOffsetDayType',
    id: 42212,
    abbrName: 'OfstDayTyp',
    description: 'Specifies the day type of the relative cash settlement date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'CashSettlDateAdjusted',
    id: 42213,
    abbrName: 'Dt',
    description: 'The adjusted cash settlement date.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoCashSettlDateBusinessCenters',
    id: 42214,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'CashSettlDateBusinessCenter',
    id: 42215,
    abbrName: 'Ctr',
    description:
      'The business center calendar used for date adjustment of the cash settlement unadjusted or relative date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'CashSettlPriceSource',
    id: 42216,
    abbrName: 'PxSrc',
    description:
      'The source from which the settlement price is to be obtained.\n\nSee http://www.fpml.org/coding-scheme/settlement-price-source for values.',
  },
  {
    type: 'CashSettlPriceDefaultCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'CashSettlPriceDefault',
    id: 42217,
    abbrName: 'PxDflt',
    description: 'The default election for determining settlement price.',
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventFuturesPriceValuation',
    id: 2597,
    abbrName: 'FutPxVal',
    description:
      'Indicates whether the official settlement price as announced by the related exchange is applicable, in accordance with the ISDA 2002 definitions. Applicable only to futures contracts.',
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventOptionsPriceValuation',
    id: 2598,
    abbrName: 'OptPxVal',
    description:
      'Indicates whether the official settlement price as announced by the related exchange is applicable, in accordance with the ISDA 2002 definitions. Applicable only to options contracts.',
  },
  {
    type: 'ComplexEventPVFinalPriceElectionFallbackCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ComplexEventPVFinalPriceElectionFallback',
    id: 2599,
    abbrName: 'PVPxFallbck',
    description:
      'Specifies the fallback provisions for the hedging party in the determination of the final settlement price.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendFloatingRateIndex',
    id: 42218,
    abbrName: 'Ndx',
    description: 'The dividend accrual floating rate index.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendFloatingRateIndexCurvePeriod',
    id: 42219,
    abbrName: 'NdxPeriod',
    description:
      'Time unit multiplier for the dividend accrual floating rate index curve.',
  },
  {
    type: 'PaymentStreamRateIndexCurveUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendFloatingRateIndexCurveUnit',
    id: 42220,
    abbrName: 'NdxUnit',
    description:
      'Time unit associated with the dividend accrual floating rate index curve period.',
  },
  {
    type: 'float',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendFloatingRateMultiplier',
    id: 42221,
    abbrName: 'RtMult',
    description:
      'A rate multiplier to apply to the floating rate. The multiplier can be less than or greater than 1 (one). This should only be included if the multiplier is not equal to 1 (one) for the term of the contract.',
  },
  {
    type: 'PriceOffset',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendFloatingRateSpread',
    id: 42222,
    abbrName: 'Spread',
    description:
      'The basis points spread from the index specified in DividendFloatingRateIndex(42218).',
  },
  {
    type: 'PaymentStreamRateSpreadPositionTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendFloatingRateSpreadPositionType',
    id: 42223,
    abbrName: 'SpreadPosTyp',
    description:
      'Identifies whether the rate spread is applied to a long or short position.',
  },
  {
    type: 'PaymentStreamRateTreatmentCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendFloatingRateTreatment',
    id: 42224,
    abbrName: 'RtTrtmt',
    description: 'Specifies the yield calculation treatment for the index.',
  },
  {
    type: 'Percentage',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendCapRate',
    id: 42225,
    abbrName: 'CapRt',
    description:
      'The cap rate, if any, which applies to the floating rate. It is only required where the floating rate is capped at a certain level. The cap rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A cap rate of 5% would be represented as "0.05".',
  },
  {
    type: 'PaymentStreamCapRateBuySideCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendCapRateBuySide',
    id: 42226,
    abbrName: 'CapRtBuy',
    description: 'Reference to the buyer of the cap rate option through its trade side.',
  },
  {
    type: 'PaymentStreamCapRateBuySideCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendCapRateSellSide',
    id: 42227,
    abbrName: 'CapRtSell',
    description: 'Reference to the seller of the cap rate option through its trade side.',
  },
  {
    type: 'Percentage',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendFloorRate',
    id: 42228,
    abbrName: 'FlrRt',
    description:
      'The floor rate, if any, which applies to the floating rate. The floor rate (strike) is only required where the floating rate is floored at a certain strike level. The floor rate is assumed to be exclusive of any spread and is a per annum rate. The rate is expressed as a decimal, e.g. 5% is represented as "0.05".',
  },
  {
    type: 'PaymentStreamFloorRateBuySideCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendFloorRateBuySide',
    id: 42229,
    abbrName: 'FlrRtBuy',
    description:
      'Reference to the buyer of the floor rate option through its trade side.',
  },
  {
    type: 'PaymentStreamFloorRateBuySideCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendFloorRateSellSide',
    id: 42230,
    abbrName: 'FlrRtSell',
    description:
      'Reference to the seller of the floor rate option through its trade side.',
  },
  {
    type: 'Percentage',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendInitialRate',
    id: 42231,
    abbrName: 'InitRt',
    description:
      'The initial floating rate reset agreed between the principal parties involved in the trade. This is assumed to be the first required reset rate for the first regular calculation period. It should only be included when the rate is not equal to the rate published on the source implied by the floating rate index. The initial rate is expressed in decimal form, e.g. 5% is represented as "0.05".',
  },
  {
    type: 'RoundingDirectionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendFinalRateRoundingDirection',
    id: 42232,
    abbrName: 'FnlRtRndDirctn',
    description: 'Specifies the rounding direction of the final rate.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendFinalRatePrecision',
    id: 42233,
    abbrName: 'FnlRtPrcsn',
    description:
      'Specifies the rounding precision of the final rate in terms of a number of decimal places. Note how a percentage rate rounding of 5 decimal places is expressed as a rounding precision of 7.',
  },
  {
    type: 'PaymentStreamAveragingMethodCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendAveragingMethod',
    id: 42234,
    abbrName: 'AvgngMeth',
    description:
      'When averaging is applicable, used to specify whether a weighted or unweighted average method of calculation is to be used.',
  },
  {
    type: 'PaymentStreamNegativeRateTreatmentCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendNegativeRateTreatment',
    id: 42235,
    abbrName: 'NegtvRtTrtmt',
    description:
      'The specification of any provisions for calculating payment obligations when a floating rate is negative (either due to a quoted negative floating rate or by operation of a spread that is subtracted from the floating rate).',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoDividendAccrualPaymentDateBusinessCenters',
    id: 42236,
    description: 'Number of entries in the DividendAccrualPaymentDateBusinessCenterGrp.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendAccrualPaymentDateBusinessCenter',
    id: 42237,
    abbrName: 'Ctr',
    description:
      'The business center calendar used for date adjustment of the instrument\'s dividend accrual payment date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendAccrualPaymentDateRelativeTo',
    id: 42238,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the accrual payment date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendAccrualPaymentDateOffsetPeriod',
    id: 42239,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative accrual payment date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendAccrualPaymentDateOffsetUnit',
    id: 42240,
    abbrName: 'OfstUnit',
    description: 'Time unit associated with the relative accrual payment date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendAccrualPaymentDateOffsetDayType',
    id: 42241,
    abbrName: 'OfstDayTyp',
    description: 'Specifies the day type of the relative accrual payment date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendAccrualPaymentDateUnadjusted',
    id: 42242,
    abbrName: 'DtUnadj',
    description: 'The unadjusted accrual payment date.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendAccrualPaymeentDateBusinessDayConvention',
    id: 42243,
    abbrName: 'BizDayCnvtn',
    description: 'Accrual payment date adjustment business day convention.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendAccrualPaymentDateAdjusted',
    id: 42244,
    abbrName: 'Dt',
    description: 'The adjusted accrual payment date.',
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendReinvestmentIndicator',
    id: 42245,
    abbrName: 'RnvstmntInd',
    description: 'Indicates whether the dividend will be reinvested.',
  },
  {
    type: 'DividendEntitlementEventCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendEntitlementEvent',
    id: 42246,
    abbrName: 'EntlmntEvnt',
    description:
      'Defines the contract event which the receiver of the derivative is entitled to the dividend.',
  },
  {
    type: 'DividendAmountTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendAmountType',
    id: 42247,
    abbrName: 'AmtTyp',
    description: 'Indicates how the gross cash dividend amount per share is determined.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendUnderlierRefID',
    id: 42248,
    abbrName: 'UndlrRefID',
    description:
      "References the dividend underlier through the instrument's UnderlyingSecurityID(309) which must be fully specified in an instance of the UnderlyingInstrument component.",
  },
  {
    type: 'PaymentStreamCapRateBuySideCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ExtraordinaryDividendPartySide',
    id: 42249,
    abbrName: 'ExtrordSide',
    description:
      'Reference to the party through its side in the trade who makes the determination whether dividends are extraordinary in relation to normal levels.',
  },
  {
    type: 'DividendAmountTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ExtraordinaryDividendAmountType',
    id: 42250,
    abbrName: 'ExtrordAmtTyp',
    description:
      'Indicates how the extraordinary gross cash dividend per share is determined.',
  },
  {
    type: 'Currency',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ExtraordinaryDividendCurrency',
    id: 42251,
    abbrName: 'ExtrordCcy',
    description:
      'The currency in which the excess dividend is denominated. Uses ISO 4217 currency codes.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ExtraordinaryDividendDeterminationMethod',
    id: 42252,
    abbrName: 'ExtrordDtrmnMeth',
    description:
      'Specifies the method in which the excess amount is determined.\n\nSee http://www.fpml.org/coding-scheme/determination-method for values.',
  },
  {
    type: 'Percentage',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendAccrualFixedRate',
    id: 42253,
    abbrName: 'AcrlFixedRt',
    description:
      'The dividend accrual fixed rate per annum expressed as a decimal.\n\nA value of 5% would be represented as "0.05".',
  },
  {
    type: 'PaymentStreamCompoundingMethodCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendCompoundingMethod',
    id: 42254,
    abbrName: 'CmpndgMeth',
    description:
      'The compounding method to be used when more than one dividend period contributes to a single payment.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendNumOfIndexUnits',
    id: 42255,
    abbrName: 'NumNdxUnits',
    description: 'The number of index units applicable to dividends.',
  },
  {
    type: 'Percentage',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendCashPercentage',
    id: 42256,
    abbrName: 'CshPctage',
    description:
      'Declared cash dividend percentage.\n\nA value of 5% would be represented as "0.05".',
  },
  {
    type: 'Percentage',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendCashEquivalentPercentage',
    id: 42257,
    abbrName: 'CshEqvlntPctage',
    description:
      'Declared cash-equivalent dividend percentage.\n\nA value of 5% would be represented as "0.05".',
  },
  {
    type: 'NonCashDividendTreatmentCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NonCashDividendTreatment',
    id: 42258,
    abbrName: 'NonCshTrtmt',
    description: 'Defines the treatment of non-cash dividends.',
  },
  {
    type: 'DividendCompositionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendComposition',
    id: 42259,
    abbrName: 'Cmpstn',
    description: 'Defines how the composition of dividends is to be determined.',
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'SpecialDividendsIndicator',
    id: 42260,
    abbrName: 'SpeclDividendInd',
    description: 'Indicates whether special dividends are applicable.',
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'MaterialDividendsIndicator',
    id: 42261,
    abbrName: 'MtrlDividendInd',
    description: 'Indicates whether material non-cash dividends are applicable.',
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'OptionsExchangeDividendsIndicator',
    id: 42262,
    abbrName: 'ExchDividendInd',
    description: 'Indicates whether option exchange dividends are applicable.',
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'AdditionalDividendsIndicator',
    id: 42263,
    abbrName: 'AddtnlDividendInd',
    description: 'Indicates whether additional dividends are applicable.',
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'AllDividendsIndicator',
    id: 42264,
    abbrName: 'AllDividendInd',
    description:
      "Represents the European Master Confirmation value of 'All Dividends' which, when applicable, signifies that, for a given Ex-Date, the daily observed share price for that day is adjusted (reduced) by the cash dividend and/or the cash value of any non-cash dividend per share (including extraordinary dividends) declared by the issuer.",
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendFXTriggerDateRelativeTo',
    id: 42265,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the FX trigger date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendFXTriggerDateOffsetPeriod',
    id: 42266,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative FX trigger date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendFXTriggerDateOffsetUnit',
    id: 42267,
    abbrName: 'OfstUnit',
    description: 'Time unit associated with the relative FX trigger date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendFXTriggerDateOffsetDayType',
    id: 42268,
    abbrName: 'OfstDayTyp',
    description: 'Specifies the day type of the relative FX trigger date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendFXTriggerDateUnadjusted',
    id: 42269,
    abbrName: 'DtUnadj',
    description: 'The unadjusted FX trigger date.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendFXTriggerDateBusinessDayConvention',
    id: 42270,
    abbrName: 'BizDayCnvtn',
    description: 'The business day convention used for the FX trigger date adjustment.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendFXTriggerDateAdjusted',
    id: 42271,
    abbrName: 'Dt',
    description: 'The adjusted FX trigger date.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoDividendFXTriggerDateBusinessCenters',
    id: 42272,
    description: 'Number of entries in the DividendFXTriggerDateBusinessCenterGrp.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendFXTriggerDateBusinessCenter',
    id: 42273,
    abbrName: 'Ctr',
    description:
      'The business center calendar used for date adjustment of the instrument\'s FX trigger date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoDividendPeriods',
    id: 42274,
    description: 'Number of entries in the DividendPeriodGrp component.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendPeriodSequence',
    id: 42275,
    abbrName: 'Seq',
    description:
      'Defines the ordinal dividend period. E.g. 1 = First period, 2 = Second period, etc.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendPeriodStartDateUnadjusted',
    id: 42276,
    abbrName: 'StartDtUnadj',
    description: 'The unadjusted date on which the dividend period will begin.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendPeriodEndDateUnadjusted',
    id: 42277,
    abbrName: 'EndDtUnadj',
    description: 'The unadjusted date on which the dividend period will end.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendPeriodUnderlierRefID',
    id: 42278,
    abbrName: 'UndlrRefID',
    description:
      "References the dividend underlier through the instrument's UnderlyingSecurityID(309) which must be fully specified in an instance of the UnderlyingInstrument component.",
  },
  {
    type: 'Price',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendPeriodStrikePrice',
    id: 42279,
    abbrName: 'StrkPx',
    description: 'Specifies the fixed strike price of the dividend period.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendPeriodBusinessDayConvention',
    id: 42280,
    abbrName: 'BizDayCnvtn',
    description: 'The dividend period dates business day convention.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendPeriodValuationDateUnadjusted',
    id: 42281,
    abbrName: 'ValDtUnadj',
    description: 'The unadjusted dividend period valuation date.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendPeriodValuationDateRelativeTo',
    id: 42282,
    abbrName: 'ValDtReltv',
    description:
      'Specifies the anchor date when the dividend period valuation date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendPeriodValuationDateOffsetPeriod',
    id: 42283,
    abbrName: 'ValDtOfstPeriod',
    description:
      'Time unit multiplier for the relative dividend period valuation date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendPeriodValuationDateOffsetUnit',
    id: 42284,
    abbrName: 'ValDtOfstUnit',
    description:
      'Time unit associated with the relative dividend period valuation date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendPeriodValuationDateOffsetDayType',
    id: 42285,
    abbrName: 'ValDtOfstDayTyp',
    description:
      'Specifies the day type of the relative dividend period valuation date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendPeriodValuationDateAdjusted',
    id: 42286,
    abbrName: 'ValDt',
    description: 'The adjusted dividend period valuation date.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendPeriodPaymentDateUnadjusted',
    id: 42287,
    abbrName: 'PmtDtUnadj',
    description: 'The unadjusted dividend period payment date.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendPeriodPaymentDateRelativeTo',
    id: 42288,
    abbrName: 'PmtDtReltv',
    description:
      'Specifies the anchor date when the dividend period payment date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendPeriodPaymentDateOffsetPeriod',
    id: 42289,
    abbrName: 'PmtDtOfstPeriod',
    description:
      'Time unit multiplier for the relative dividend period payment date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendPeriodPaymentDateOffsetUnit',
    id: 42290,
    abbrName: 'PmtDtOfstUnit',
    description:
      'Time unit associated with the relative dividend period payment date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendPeriodPaymentDateOffsetDayType',
    id: 42291,
    abbrName: 'PmtDtOfstDayTyp',
    description:
      'Specifies the day type of the relative dividend period payment date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendPeriodPaymentDateAdjusted',
    id: 42292,
    abbrName: 'PmtDt',
    description: 'The adjusted dividend period payment date.',
  },
  {
    type: 'XID',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendPeriodXID',
    id: 42293,
    abbrName: 'XID',
    description:
      'Identifier for linking this stream dividend period to an underlier through an instance of RelatedInstrumentGrp.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoDividendPeriodBusinessCenters',
    id: 42294,
    description: 'Number of entries in the DividendPeriodBusinessCenterGrp.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'DividendPeriodBusinessCenter',
    id: 42295,
    abbrName: 'Ctr',
    description:
      'The business center calendar used for date adjustment of the instrument\'s dividend period date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoExtraordinaryEvents',
    id: 42296,
    description: 'Number of extraordinary events in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ExtraordinaryEventType',
    id: 42297,
    abbrName: 'Typ',
    description:
      'Identifies the type of extraordinary or disruptive event applicable to the reference entity.\n\nSee http://www.fixtradingcommunity.org/codelists#Extraordinary_Event_Type for code list of extraordinary event types and values.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ExtraordinaryEventValue',
    id: 42298,
    abbrName: 'Val',
    description:
      'The extraordinary or disruptive event value appropriate to ExtraordinaryEventType(42297).\n\nSee http://www.fixtradingcommunity.org/codelists#Extraordinary_Event_Type for code list of extraordinary event types and values.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'StrikeIndexCurvePoint',
    id: 2600,
    abbrName: 'StrkNdxPnt',
    description:
      'The point on the floating rate index curve. Sample values:\n\nM = combination of a number between 1-12 and an "M" for month, e.g. 3M\n\nY = combination of number between 1-100 and a "Y" for year, e.g. 10Y\n\n10Y-OLD = see above, then add "-OLD" when appropriate\n\nINTERPOLATED = the point is mathematically derived\n\n2/2031 5 3/8 = the point is stated via a combination of maturity month / year and coupon.',
  },
  {
    type: 'StrikeIndexQuoteCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'StrikeIndexQuote',
    id: 2601,
    abbrName: 'StrkNdxQte',
    description: 'The quote side from which the index price is to be determined.',
  },
  {
    type: 'ExtraordinaryEventAdjustmentMethodCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ExtraordinaryEventAdjustmentMethod',
    id: 2602,
    abbrName: 'ExtrordEvntAdjMeth',
    description:
      'Defines how adjustments will be made to the contract should one or more of the extraordinary events occur.',
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ExchangeLookAlike',
    id: 2603,
    abbrName: 'ExchLookAlike',
    description:
      "For a share option trade, indicates whether the instrument is to be treated as an 'exchange look-alike'.\n\nThis designation has significance for how share adjustments (arising from corporate actions) will be determined for the instrument. For an 'exchange look-alike' instrument the relevant share adjustments will follow that for a corresponding designated contract listed on the related exchange (referred to as Options Exchange Adjustment (ISDA defined term)), otherwise the share adjustments will be determined by the calculation agent (referred to as Calculation Agent Adjustment (ISDA defined term)).",
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegStrikeIndexCurvePoint',
    id: 2604,
    abbrName: 'StrkNdxPnt',
    description:
      'The point on the floating rate index curve. Sample values:\n\nM = combination of a number between 1-12 and an "M" for month, e.g. 3M\n\nY = combination of number between 1-100 and a "Y" for year, e.g. 10Y\n\n10Y-OLD = see above, then add "-OLD" when appropriate\n\nINTERPOLATED = the point is mathematically derived\n\n2/2031 5 3/8 = the point is stated via a combination of maturity month / year and coupon.',
  },
  {
    type: 'StrikeIndexQuoteCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegStrikeIndexQuote',
    id: 2605,
    abbrName: 'StrkNdxQte',
    description: 'The quote side from which the index price is to be determined.',
  },
  {
    type: 'ExtraordinaryEventAdjustmentMethodCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegExtraordinaryEventAdjustmentMethod',
    id: 2606,
    abbrName: 'ExtrordEvntAdjMeth',
    description:
      'Defines how adjustments will be made to the contract should one or more of the extraordinary events occur.',
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegExchangeLookAlike',
    id: 2607,
    abbrName: 'ExchLookAlike',
    description:
      "For a share option trade, indicates whether the instrument is to be treated as an 'exchange look-alike'.\n\nThis designation has significance for how share adjustments (arising from corporate actions) will be determined for the instrument. For an 'exchange look-alike' instrument the relevant share adjustments will follow that for a corresponding designated contract listed on the related exchange (referred to as Options Exchange Adjustment (ISDA defined term)), otherwise the share adjustments will be determined by the calculation agent (referred to as Calculation Agent Adjustment (ISDA defined term)).",
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegCashSettlDateUnadjusted',
    id: 42299,
    abbrName: 'DtUnadj',
    description: 'The unadjusted cash settlement date.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegCashSettlDateBusinessDayConvention',
    id: 42300,
    abbrName: 'BizDayCnvtn',
    description:
      "The business day convention used to adjust the cash settlement provision's date. Used only to override the business day convention defined in the InstrumentLeg component.",
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegCashSettlDateRelativeTo',
    id: 42301,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the cash settlement date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegCashSettlDateOffsetPeriod',
    id: 42302,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative cash settlement date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegCashSettlDateOffsetUnit',
    id: 42303,
    abbrName: 'OfstUnit',
    description: 'Time unit associated with the relative cash settlement date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegCashSettlDateOffsetDayType',
    id: 42304,
    abbrName: 'OfstDayTyp',
    description: 'Specifies the day type of the relative cash settlement date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegCashSettlDateAdjusted',
    id: 42305,
    abbrName: 'Dt',
    description: 'The adjusted cash settlement date.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoLegCashSettlDateBusinessCenters',
    id: 42306,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegCashSettlDateBusinessCenter',
    id: 42307,
    abbrName: 'Ctr',
    description:
      'The business center calendar used for date adjustment of the cash settlement unadjusted or relative date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegCashSettlPriceSource',
    id: 42308,
    abbrName: 'PxSrc',
    description:
      'The source from which the settlement price is to be obtained.\n\nSee http://www.fpml.org/coding-scheme/settlement-price-source for values.',
  },
  {
    type: 'CashSettlPriceDefaultCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegCashSettlPriceDefault',
    id: 42309,
    abbrName: 'PxDflt',
    description: 'The default election for determining settlement price.',
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventFuturesPriceValuation',
    id: 2608,
    abbrName: 'FutPxVal',
    description:
      'Indicates whether the official settlement price as announced by the related exchange is applicable, in accordance with the ISDA 2002 definitions. Applicable only to futures contracts.',
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventOptionsPriceValuation',
    id: 2609,
    abbrName: 'OptPxVal',
    description:
      'Indicates whether the official settlement price as announced by the related exchange is applicable, in accordance with the ISDA 2002 definitions. Applicable only to options contracts.',
  },
  {
    type: 'ComplexEventPVFinalPriceElectionFallbackCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegComplexEventPVFinalPriceElectionFallback',
    id: 2610,
    abbrName: 'PVPxFallbck',
    description:
      'Specifies the fallback provisions for the hedging party in the determination of the final settlement price',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoLegDividendAccrualPaymentDateBusinessCenters',
    id: 42310,
    description:
      'Number of entries in the LegDividendAccrualPaymentDateBusinessCenterGrp.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendAccrualPaymentDateBusinessCenter',
    id: 42311,
    abbrName: 'Ctr',
    description:
      'The business center calendar used for date adjustment of the instrument\'s dividend accrual payment date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendFloatingRateIndex',
    id: 42312,
    abbrName: 'Ndx',
    description: 'The dividend accrual floating rate index.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendFloatingRateIndexCurvePeriod',
    id: 42313,
    abbrName: 'NdxPeriod',
    description:
      'Time unit multiplier for the dividend accrual floating rate index curve.',
  },
  {
    type: 'PaymentStreamRateIndexCurveUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendFloatingRateIndexCurveUnit',
    id: 42314,
    abbrName: 'NdxUnit',
    description:
      'Time unit associated with the dividend accrual floating rate index curve period.',
  },
  {
    type: 'float',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendFloatingRateMultiplier',
    id: 42315,
    abbrName: 'RtMult',
    description:
      'A rate multiplier to apply to the floating rate. The multiplier can be less than or greater than 1 (one). This should only be included if the multiplier is not equal to 1 (one) for the term of the contract.',
  },
  {
    type: 'PriceOffset',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendFloatingRateSpread',
    id: 42316,
    abbrName: 'Spread',
    description:
      'The basis points spread from the index specified in LegDividendFloatingRateIndex(42312).',
  },
  {
    type: 'PaymentStreamRateSpreadPositionTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendFloatingRateSpreadPositionType',
    id: 42317,
    abbrName: 'SpreadPosTyp',
    description:
      'Identifies whether the rate spread is applied to a long or short position.',
  },
  {
    type: 'PaymentStreamRateTreatmentCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendFloatingRateTreatment',
    id: 42318,
    abbrName: 'RtTrtmt',
    description: 'Specifies the yield calculation treatment for the index.',
  },
  {
    type: 'Percentage',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendCapRate',
    id: 42319,
    abbrName: 'CapRt',
    description:
      'The cap rate, if any, which applies to the floating rate. It is only required where the floating rate is capped at a certain level. The cap rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A cap rate of 5% would be represented as "0.05".',
  },
  {
    type: 'PaymentStreamCapRateBuySideCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendCapRateBuySide',
    id: 42320,
    abbrName: 'CapRtBuy',
    description: 'Reference to the buyer of the cap rate option through its trade side.',
  },
  {
    type: 'PaymentStreamCapRateBuySideCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendCapRateSellSide',
    id: 42321,
    abbrName: 'CapRtSell',
    description: 'Reference to the seller of the cap rate option through its trade side.',
  },
  {
    type: 'Percentage',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendFloorRate',
    id: 42322,
    abbrName: 'FlrRt',
    description:
      'The floor rate, if any, which applies to the floating rate. The floor rate (strike) is only required where the floating rate is floored at a certain strike level. The floor rate is assumed to be exclusive of any spread and is a per annum rate. The rate is expressed as a decimal, e.g. 5% is represented as "0.05".',
  },
  {
    type: 'PaymentStreamFloorRateBuySideCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendFloorRateBuySide',
    id: 42323,
    abbrName: 'FlrRtBuy',
    description:
      'Reference to the buyer of the floor rate option through its trade side.',
  },
  {
    type: 'PaymentStreamFloorRateBuySideCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendFloorRateSellSide',
    id: 42324,
    abbrName: 'FlrRtSell',
    description:
      'Reference to the seller of the floor rate option through its trade side.',
  },
  {
    type: 'Percentage',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendInitialRate',
    id: 42325,
    abbrName: 'InitRt',
    description:
      'The initial floating rate reset agreed between the principal parties involved in the trade. This is assumed to be the first required reset rate for the first regular calculation period. It should only be included when the rate is not equal to the rate published on the source implied by the floating rate index. The initial rate is expressed in decimal form, e.g. 5% is represented as "0.05".',
  },
  {
    type: 'RoundingDirectionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendFinalRateRoundingDirection',
    id: 42326,
    abbrName: 'FnlRtRndDirctn',
    description: 'Specifies the rounding direction of the final rate.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendFinalRatePrecision',
    id: 42327,
    abbrName: 'FnlRtPrcsn',
    description:
      'Specifies the rounding precision of the final rate in terms of a number of decimal places. Note how a percentage rate rounding of 5 decimal places is expressed as a rounding precision of 7.',
  },
  {
    type: 'PaymentStreamAveragingMethodCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendAveragingMethod',
    id: 42328,
    abbrName: 'AvgngMeth',
    description:
      'When averaging is applicable, used to specify whether a weighted or unweighted average method of calculation is to be used.',
  },
  {
    type: 'PaymentStreamNegativeRateTreatmentCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendNegativeRateTreatment',
    id: 42329,
    abbrName: 'NegtvRtTrtmt',
    description:
      'The specification of any provisions for calculating payment obligations when a floating rate is negative (either due to a quoted negative floating rate or by operation of a spread that is subtracted from the floating rate).',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendAccrualPaymentDateRelativeTo',
    id: 42330,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the accrual payment date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendAccrualPaymentDateOffsetPeriod',
    id: 42331,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative accrual payment date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendAccrualPaymentDateOffsetUnit',
    id: 42332,
    abbrName: 'OfstUnit',
    description: 'Time unit associated with the relative accrual payment date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendAccrualPaymentDateOffsetDayType',
    id: 42333,
    abbrName: 'OfstDayTyp',
    description: 'Specifies the day type of the relative accrual payment date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendAccrualPaymentDateUnadjusted',
    id: 42334,
    abbrName: 'DtUnadj',
    description: 'The unadjusted accrual payment date.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendAccrualPaymentDateBusinessDayConvention',
    id: 42335,
    abbrName: 'BizDayCnvtn',
    description: 'Accrual payment date adjustment business day convention.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendAccrualPaymentDateAdjusted',
    id: 42336,
    abbrName: 'Dt',
    description: 'The adjusted accrual payment date.',
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendReinvestmentIndicator',
    id: 42337,
    abbrName: 'RnvstmntInd',
    description: 'Indicates whether the dividend will be reinvested.',
  },
  {
    type: 'DividendEntitlementEventCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendEntitlementEvent',
    id: 42338,
    abbrName: 'EntlmntEvnt',
    description:
      'Defines the contract event which the receiver of the derivative is entitled to the dividend.',
  },
  {
    type: 'DividendAmountTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendAmountType',
    id: 42339,
    abbrName: 'AmtTyp',
    description: 'Indicates how the gross cash dividend amount per share is determined.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendUnderlierRefID',
    id: 42340,
    abbrName: 'UndlrRefID',
    description:
      "References the dividend underlier through the instrument's UnderlyingSecurityID(309) which must be fully specified in an instance of the UnderlyingInstrument component.",
  },
  {
    type: 'PaymentStreamCapRateBuySideCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegExtraordinaryDividendPartySide',
    id: 42341,
    abbrName: 'ExtrordSide',
    description:
      'Reference to the party through its side in the trade who makes the determination whether dividends are extraordinary in relation to normal levels.',
  },
  {
    type: 'DividendAmountTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegExtraordinaryDividendAmountType',
    id: 42342,
    abbrName: 'ExtrordAmtTyp',
    description:
      'Indicates how the extraordinary gross cash dividend per share is determined.',
  },
  {
    type: 'Currency',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegExtraordinaryDividendCurrency',
    id: 42343,
    abbrName: 'ExtrordCcy',
    description:
      'The currency in which the excess dividend is denominated. Uses ISO 4217 currency codes.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegExtraordinaryDividendDeterminationMethod',
    id: 42344,
    abbrName: 'ExtrordDtrmnMeth',
    description:
      'Specifies the method in which the excess amount is determined.\n\nSee http://www.fpml.org/coding-scheme/determination-method for values.',
  },
  {
    type: 'Percentage',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendAccrualFixedRate',
    id: 42345,
    abbrName: 'AcrlFixedRt',
    description:
      'The dividend accrual fixed rate per annum expressed as a decimal.\n\nA value of 5% would be represented as "0.05".',
  },
  {
    type: 'PaymentStreamCompoundingMethodCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendCompoundingMethod',
    id: 42346,
    abbrName: 'CmpndgMeth',
    description:
      'The compounding method to be used when more than one dividend period contributes to a single payment.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendNumOfIndexUnits',
    id: 42347,
    abbrName: 'NumNdxUnits',
    description: 'The number of index units applicable to dividends.',
  },
  {
    type: 'Percentage',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendCashPercentage',
    id: 42348,
    abbrName: 'CshPctage',
    description:
      'Declared cash dividend percentage.\n\nA value of 5% would be represented as "0.05".',
  },
  {
    type: 'Percentage',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendCashEquivalentPercentage',
    id: 42349,
    abbrName: 'CshEqvlntPctage',
    description:
      'Declared cash-equivalent dividend percentage.\n\nA value of 5% would be represented as "0.05".',
  },
  {
    type: 'NonCashDividendTreatmentCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegNonCashDividendTreatment',
    id: 42350,
    abbrName: 'NonCshTrtmt',
    description: 'Defines the treatment of non-cash dividends.',
  },
  {
    type: 'DividendCompositionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendComposition',
    id: 42351,
    abbrName: 'Cmpstn',
    description: 'Defines how the composition of dividends is to be determined.',
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegSpecialDividendsIndicator',
    id: 42352,
    abbrName: 'SpeclDividendInd',
    description: 'Indicates whether special dividends are applicable.',
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegMaterialDividendsIndicator',
    id: 42353,
    abbrName: 'MtrlDividendInd',
    description: 'Indicates whether material non-cash dividends are applicable.',
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegOptionsExchangeDividendsIndicator',
    id: 42354,
    abbrName: 'ExchDividendInd',
    description: 'Indicates whether option exchange dividends are applicable.',
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegAdditionalDividendsIndicator',
    id: 42355,
    abbrName: 'AddtnlDividendInd',
    description: 'Indicates whether additional dividends are applicable.',
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegAllDividendsIndicator',
    id: 42356,
    abbrName: 'AllDividendInd',
    description:
      "Represents the European Master Confirmation value of 'All Dividends' which, when applicable, signifies that, for a given Ex-Date, the daily observed share price for that day is adjusted (reduced) by the cash dividend and/or the cash value of any non-cash dividend per share (including extraordinary dividends) declared by the issuer.",
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendFXTriggerDateRelativeTo',
    id: 42357,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the FX trigger date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendFXTriggerDateOffsetPeriod',
    id: 42358,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative FX trigger date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendFXTriggerDateOffsetUnit',
    id: 42359,
    abbrName: 'OfstUnit',
    description: 'Time unit associated with the relative FX trigger date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendFXTriggerDateOffsetDayType',
    id: 42360,
    abbrName: 'OfstDayTyp',
    description: 'Specifies the day type of the relative FX trigger date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendFXTriggerDateUnadjusted',
    id: 42361,
    abbrName: 'DtUnadj',
    description: 'The unadjusted FX trigger date.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendFXTriggerDateBusinessDayConvention',
    id: 42362,
    abbrName: 'BizDayCnvtn',
    description: 'The business day convention used for the FX trigger date adjustment.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendFXTriggerDateAdjusted',
    id: 42363,
    abbrName: 'Dt',
    description: 'The adjusted FX trigger date.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoLegDividendFXTriggerDateBusinessCenters',
    id: 42364,
    description: 'Number of entries in the LegDividendFXTriggerDateBusinessCenterGrp.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendFXTriggerDateBusinessCenter',
    id: 42365,
    abbrName: 'Ctr',
    description:
      'The business center calendar used for date adjustment of the instrument\'s FX trigger date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoLegDividendPeriods',
    id: 42366,
    description: 'Number of entries in the LegDividendPeriodGrp component.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendPeriodSequence',
    id: 42367,
    abbrName: 'Seq',
    description:
      'Defines the ordinal dividend period. E.g. 1 = First period, 2 = Second period, etc.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendPeriodStartDateUnadjusted',
    id: 42368,
    abbrName: 'StartDtUnadj',
    description: 'The unadjusted date on which the dividend period will begin.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendPeriodEndDateUnadjusted',
    id: 42369,
    abbrName: 'EndDtUnadj',
    description: 'The unadjusted date on which the dividend period will end.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendPeriodUnderlierRefID',
    id: 42370,
    abbrName: 'UndlrRefID',
    description:
      "References the dividend underlier through the instrument's UnderlyingSecurityID(309) which must be fully specified in an instance of the UnderlyingInstrument component.",
  },
  {
    type: 'Price',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendPeriodStrikePrice',
    id: 42371,
    abbrName: 'StrkPx',
    description: 'Specifies the fixed strike price of the dividend period.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendPeriodBusinessDayConvention',
    id: 42372,
    abbrName: 'BizDayCnvtn',
    description: 'The dividend period dates business day convention.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendPeriodValuationDateUnadjusted',
    id: 42373,
    abbrName: 'ValDtUnadj',
    description: 'The unadjusted dividend period valuation date.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendPeriodValuationDateRelativeTo',
    id: 42374,
    abbrName: 'ValDtReltv',
    description:
      'Specifies the anchor date when the dividend period valuation date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendPeriodValuationDateOffsetPeriod',
    id: 42375,
    abbrName: 'ValDtOfstPeriod',
    description:
      'Time unit multiplier for the relative dividend period valuation date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendPeriodValuationDateOffsetUnit',
    id: 42376,
    abbrName: 'ValDtOfstUnit',
    description:
      'Time unit associated with the relative dividend period valuation date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendPeriodValuationDateOffsetDayType',
    id: 42377,
    abbrName: 'ValDtOfstDayTyp',
    description:
      'Specifies the day type of the relative dividend period valuation date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendPeriodValuationDateAdjusted',
    id: 42378,
    abbrName: 'ValDt',
    description: 'The adjusted dividend period valuation date.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendPeriodPaymentDateUnadjusted',
    id: 42379,
    abbrName: 'PmtDtUnadj',
    description: 'The unadjusted dividend period payment date.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendPeriodPaymentDateRelativeTo',
    id: 42380,
    abbrName: 'PmtDtReltv',
    description:
      'Specifies the anchor date when the dividend period payment date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendPeriodPaymentDateOffsetPeriod',
    id: 42381,
    abbrName: 'PmtDtOfstPeriod',
    description:
      'Time unit multiplier for the relative dividend period payment date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendPeriodPaymentDateOffsetUnit',
    id: 42382,
    abbrName: 'PmtDtOfstUnit',
    description:
      'Time unit associated with the relative dividend period payment date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendPeriodPaymentDateOffsetDayType',
    id: 42383,
    abbrName: 'PmtDtOfstDayTyp',
    description:
      'Specifies the day type of the relative dividend period payment date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendPeriodPaymentDateAdjusted',
    id: 42384,
    abbrName: 'PmtDt',
    description: 'The adjusted dividend period payment date.',
  },
  {
    type: 'XID',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendPeriodXID',
    id: 42385,
    abbrName: 'XID',
    description:
      'Identifier for linking this stream dividend period to an underlier through an instance of RelatedInstrumentGrp.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoLegDividendPeriodBusinessCenters',
    id: 42386,
    description:
      'The number of entries in the LegDividendPeriodBusinessCentersGrp component.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegDividendPeriodBusinessCenter',
    id: 42387,
    abbrName: 'Ctr',
    description:
      'The business center calendar used for date adjustment of the instrument\'s dividend period date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoLegExtraordinaryEvents',
    id: 42388,
    description: 'Number of extraordinary events in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegExtraordinaryEventType',
    id: 42389,
    abbrName: 'Typ',
    description:
      'Identifies the type of extraordinary or disruptive event applicable to the reference entity.\n\nSee http://www.fixtradingcommunity.org/codelists#Extraordinary_Event_Type for code list of extraordinary event types and values.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegExtraordinaryEventValue',
    id: 42390,
    abbrName: 'Val',
    description:
      'The extraordinary or disruptive event value appropriate to LegExtraordinaryEventType(42389).\n\nSee http://www.fixtradingcommunity.org/codelists#Extraordinary_Event_Type for code list of extraordinary event types and values.',
  },
  {
    type: 'PaymentPaySideCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegSettlMethodElectingPartySide',
    id: 42391,
    abbrName: 'SettlMethElctngSide',
    description: 'Side value of the party electing the settlement method.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegMakeWholeDate',
    id: 42392,
    abbrName: 'Dt',
    description: 'The date through which option cannot be exercised without penalty.',
  },
  {
    type: 'Amt',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegMakeWholeAmount',
    id: 42393,
    abbrName: 'Amt',
    description:
      'Amount to be paid by the buyer of the option if the option is exercised prior to the LegMakeWholeDate(42392).',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegMakeWholeBenchmarkCurveName',
    id: 42394,
    abbrName: 'Name',
    description: 'Identifies the benchmark floating rate index.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegMakeWholeBenchmarkCurvePoint',
    id: 42395,
    abbrName: 'Point',
    description:
      'The point on the floating rate index curve.\n\nSample values:\n\nM = combination of a number between 1-12 and an "M" for month, e.g. 3M\n\nY = combination of number between 1-100 and a "Y" for year, e.g. 10Y\n\n10Y-OLD = see above, then add "-OLD" when appropriate\n\nINTERPOLATED = the point is mathematically derived\n\n2/2031 5 3/8 = the point is stated via a combination of maturity month / year and coupon.',
  },
  {
    type: 'PriceOffset',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegMakeWholeRecallSpread',
    id: 42396,
    abbrName: 'Spread',
    description: 'Spread over the floating rate index.',
  },
  {
    type: 'StrikeIndexQuoteCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegMakeWholeBenchmarkQuote',
    id: 42397,
    abbrName: 'Qte',
    description:
      'The quote side of the benchmark to be used for calculating the "make whole" amount.',
  },
  {
    type: 'PaymentStreamInflationInterpolationMethodCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegMakeWholeInterpolationMethod',
    id: 42398,
    abbrName: 'IntrpltnMeth',
    description:
      'The method used when calculating the "make whole" amount. The most common is linear method.',
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCashSettlIndicator',
    id: 42399,
    abbrName: 'CshSettlInd',
    description: 'Indicates whether cash settlement is applicable.',
  },
  {
    type: 'XIDREF',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingXIDRef',
    id: 42400,
    abbrName: 'CmpndgXIDRef',
    description:
      'Reference to the stream which details the compounding fixed or floating rate.',
  },
  {
    type: 'PriceOffset',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingSpread',
    id: 42401,
    abbrName: 'CmpndgSpread',
    description:
      'The spread to be used for compounding. Used in scenarios where the interest payment is based on a compounding formula that uses a compounding spread in addition to the regular spread.',
  },
  {
    type: 'PaymentStreamInflationInterpolationMethodCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamInterpolationMethod',
    id: 42402,
    abbrName: 'IntrpltnMeth',
    description:
      'The method used when calculating the index rate from multiple points on the curve. The most common is linear method.',
  },
  {
    type: 'PaymentStreamInterpolationPeriodCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamInterpolationPeriod',
    id: 42403,
    abbrName: 'IntrpltnPeriod',
    description: 'Defines applicable periods for interpolation.',
  },
  {
    type: 'float',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingFixedRate',
    id: 42404,
    abbrName: 'CmpndgFixedRt',
    description: 'The compounding fixed rate applicable to the payment stream.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoLegPaymentStreamCompoundingDates',
    id: 42405,
    description: 'Number of dates in the repeating group.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingDate',
    id: 42406,
    abbrName: 'Dt',
    description:
      'The compounding date. Type of date is specified in LegPaymentStreamCompoundingDateType(42407).',
  },
  {
    type: 'NonDeliverableFixingDateTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingDateType',
    id: 42407,
    abbrName: 'Typ',
    description:
      'Specifies the type of payment compounding date (e.g. adjusted for holidays).',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingDatesBusinessDayConvention',
    id: 42408,
    abbrName: 'BizDayCnvtn',
    description: 'The compounding dates business day convention.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingDatesRelativeTo',
    id: 42409,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the compounding dates are relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingDatesOffsetPeriod',
    id: 42410,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative compounding date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingDatesOffsetUnit',
    id: 42411,
    abbrName: 'OfstUnit',
    description: 'Time unit associated with the relative compounding date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingDatesOffsetDayType',
    id: 42412,
    abbrName: 'OfstDayTyp',
    description: 'Specifies the day type of the relative compounding date offset.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingPeriodSkip',
    id: 42413,
    abbrName: 'Skip',
    description:
      'The number of periods in the "RelativeTo" schedule that are between each date in the compounding schedule. A skip of 2 would mean that compounding dates are relative to every second date in the "RelativeTo" schedule. If present this should have a value greater than 1.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingFrequencyPeriod',
    id: 42414,
    abbrName: 'FreqPeriod',
    description:
      'Time unit multiplier for the frequency at which compounding dates occur.',
  },
  {
    type: 'CouponFrequencyUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingFrequencyUnit',
    id: 42415,
    abbrName: 'FreqUnit',
    description:
      'Time unit associated with the frequency at which compounding dates occur.',
  },
  {
    type: 'DateRollConventionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingRollConvention',
    id: 42416,
    abbrName: 'Roll',
    description:
      'The convention for determining the sequence of compounding dates. It is used in conjunction with a specified frequency.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamBoundsFirstDateUnadjusted',
    id: 42417,
    abbrName: 'FirstDtUnadj',
    description:
      'The unadjusted first date of the compounding schedule. This can be used to restrict the range of dates when they are relative.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamBoundsLastDateUnadjusted',
    id: 42418,
    abbrName: 'LastDtUnadj',
    description:
      'The unadjusted last date of the compounding schedule. This can be used to restrict the range of dates when they are relative.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoLegPaymentStreamCompoundingDatesBusinessCenters',
    id: 42419,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingDatesBusinessCenter',
    id: 42420,
    abbrName: 'Ctr',
    description:
      'The business center calendar used for date adjustment of the payment stream compounding dates, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingEndDateUnadjusted',
    id: 42421,
    abbrName: 'DtUnadj',
    description: 'The unadjusted compounding end date.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingEndDateRelativeTo',
    id: 42422,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the compounding end date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingEndDateOffsetPeriod',
    id: 42423,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative compounding end date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingEndDateOffsetUnit',
    id: 42424,
    abbrName: 'OfstUnit',
    description: 'Time unit associated with the relative compounding end date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingEndDateOffsetDayType',
    id: 42425,
    abbrName: 'OfstDayTyp',
    description: 'Specifies the day type of the relative compounding end date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingEndDateAdjusted',
    id: 42426,
    abbrName: 'Dt',
    description: 'The adjusted compounding end date.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingRateIndex',
    id: 42427,
    abbrName: 'Ndx',
    description: "The payment stream's compounding floating rate index.",
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingRateIndexCurvePeriod',
    id: 42428,
    abbrName: 'NdxPeriod',
    description:
      "Time unit multiplier for the payment stream's compounding floating rate index curve period.",
  },
  {
    type: 'PaymentStreamRateIndexCurveUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingRateIndexCurveUnit',
    id: 42429,
    abbrName: 'NdxUnit',
    description:
      "Time unit associated with the payment stream's compounding floating rate index curve period.",
  },
  {
    type: 'float',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingRateMultiplier',
    id: 42430,
    abbrName: 'RtMult',
    description:
      'A rate multiplier to apply to the compounding floating rate. The multiplier can be less than or greater than 1 (one). This should only be included if the multiplier is not equal to 1 (one) for the term of the stream.',
  },
  {
    type: 'PriceOffset',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingRateSpread',
    id: 42431,
    abbrName: 'Spread',
    description:
      'The basis points spread from the index specified in LegPaymentStreamCompoundingRateIndex(42427).',
  },
  {
    type: 'PaymentStreamRateSpreadPositionTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingRateSpreadPositionType',
    id: 42432,
    abbrName: 'SpreadPosTyp',
    description:
      'Identifies whether the rate spread is applied to a long or short position.',
  },
  {
    type: 'PaymentStreamRateTreatmentCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingRateTreatment',
    id: 42433,
    abbrName: 'RtTrtmt',
    description: 'Specifies the yield calculation treatment for the index.',
  },
  {
    type: 'Percentage',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingCapRate',
    id: 42434,
    abbrName: 'CapRt',
    description:
      'The cap rate, if any, which applies to the compounding floating rate. It is only required where the compounding floating rate on a swap stream is capped at a certain level. The cap rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A cap rate of 5% would be represented as "0.05".',
  },
  {
    type: 'PaymentStreamCapRateBuySideCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingCapRateBuySide',
    id: 42435,
    abbrName: 'CapRtBuy',
    description:
      'Reference to the buyer of the compounding cap rate option through its trade side.',
  },
  {
    type: 'PaymentStreamCapRateBuySideCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingCapRateSellSide',
    id: 42436,
    abbrName: 'CapRtSell',
    description:
      'Reference to the seller of the compounding cap rate option through its trade side.',
  },
  {
    type: 'Percentage',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingFloorRate',
    id: 42437,
    abbrName: 'FlrRt',
    description:
      'The floor rate, if any, which applies to the compounding floating rate. The floor rate (strike) is only required where the compounding floating rate on a swap stream is floored at a certain strike level. The floor rate is assumed to be exclusive of any spread and is a per annum rate. The rate is expressed as a decimal, e.g. 5% is represented as "0.05".',
  },
  {
    type: 'PaymentStreamFloorRateBuySideCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingFloorRateBuySide',
    id: 42438,
    abbrName: 'FlrRtBuy',
    description:
      'Reference to the buyer of the compounding floor rate option through its trade side.',
  },
  {
    type: 'PaymentStreamFloorRateBuySideCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingFloorRateSellSide',
    id: 42439,
    abbrName: 'FlrRtSell',
    description:
      'Reference to the seller of the floor rate option through its trade side.',
  },
  {
    type: 'Percentage',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingInitialRate',
    id: 42440,
    abbrName: 'InitRt',
    description:
      'The initial compounding floating rate reset agreed between the principal parties involved in the trade. It should only be included when the rate is not equal to the rate published on the source implied by the floating rate index. The initial rate is expressed in decimal form, e.g. 5% is represented as "0.05".',
  },
  {
    type: 'RoundingDirectionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingFinalRateRoundingDirection',
    id: 42441,
    abbrName: 'FnlRtRndDirctn',
    description: 'Specifies the rounding direction for the compounding floating rate.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingFinalRatePrecision',
    id: 42442,
    abbrName: 'FnlRtPrcsn',
    description:
      'Specifies the compounding floating rate rounding precision in terms of a number of decimal places. Note how a percentage rate rounding of 5 decimal places is expressed as a rounding precision of 7.',
  },
  {
    type: 'PaymentStreamAveragingMethodCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingAveragingMethod',
    id: 42443,
    abbrName: 'AvgngMeth',
    description:
      'Specifies the averaging method when compounding floating rate averaging is applicable (e.g. weighted or unweighted).',
  },
  {
    type: 'PaymentStreamNegativeRateTreatmentCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingNegativeRateTreatment',
    id: 42444,
    abbrName: 'NegtvRtTrtmt',
    description:
      'Specifies the method for calculating payment obligations when a compounding floating rate is negative (either due to a quoted negative floating rate or by operation of a spread that is subtracted from the floating rate).',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingStartDateUnadjusted',
    id: 42445,
    abbrName: 'DtUnadj',
    description: 'The unadjusted compounding start date.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingStartDateRelativeTo',
    id: 42446,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the compounding start date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingStartDateOffsetPeriod',
    id: 42447,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative compounding start date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingStartDateOffsetUnit',
    id: 42448,
    abbrName: 'OfstUnit',
    description: 'Time unit associated with the relative compounding start date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingStartDateOffsetDayType',
    id: 42449,
    abbrName: 'OfstDayTyp',
    description: 'Specifies the day type of the relative compounding start date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamCompoundingStartDateAdjusted',
    id: 42450,
    abbrName: 'Dt',
    description: 'The adjusted compounding start date.',
  },
  {
    type: 'Length',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFormulaImageLength',
    id: 42451,
    abbrName: 'FrmlaImgLen',
    description: 'Length in bytes of the LegPaymentStreamFormulaImage(42452) field.',
  },
  {
    type: 'data',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFormulaImage',
    id: 42452,
    abbrName: 'FrmlaImg',
    lengthId: '42451',
    description:
      'Image of the formula image when represented through an encoded clip in base64Binary.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFinalPricePaymentDateUnadjusted',
    id: 42453,
    abbrName: 'DtUnadj',
    description: 'The unadjusted final price payment date.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFinalPricePaymentDateRelativeTo',
    id: 42454,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the final price payment date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFinalPricePaymentDateOffsetPeriod',
    id: 42455,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative final price payment date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFinalPricePaymentDateOffsetUnit',
    id: 42456,
    abbrName: 'OfstUnit',
    description:
      'Time unit associated with the relative final price payment date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFinalPricePaymentDateOffsetDayType',
    id: 42457,
    abbrName: 'OfstDayTyp',
    description:
      'Specifies the day type of the relative final price payment date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFinalPricePaymentDateAdjusted',
    id: 42458,
    abbrName: 'Dt',
    description: 'The adjusted final price payment date.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoLegPaymentStreamFixingDates',
    id: 42459,
    description: 'Number of fixing dates in the repeating group.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFixingDate',
    id: 42460,
    abbrName: 'Dt',
    description:
      'The fixing date. Type of date is specified in LegPaymentStreamFixingDateType(42461).',
  },
  {
    type: 'NonDeliverableFixingDateTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFixingDateType',
    id: 42461,
    abbrName: 'Typ',
    description: 'Specifies the type of fixing date (e.g. adjusted for holidays).',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFirstObservationDateUnadjusted',
    id: 42462,
    abbrName: 'FirstObsvtnDtUnadj',
    description: 'The unadjusted initial price observation date.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFirstObservationDateRelativeTo',
    id: 42463,
    abbrName: 'FirstObsvtnReltv',
    description:
      'Specifies the anchor date when the initial price observation date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFirstObservationDateOffsetDayType',
    id: 42464,
    abbrName: 'FirstObsvtnOfstDayTyp',
    description: 'Specifies the day type of the initial price observation date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFirstObservationDateAdjusted',
    id: 42465,
    abbrName: 'FirstObsvtnDt',
    description: 'The adjusted initial price observation date.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamUnderlierRefID',
    id: 42466,
    abbrName: 'UndlrRefID',
    description:
      "References the dividend underlier through the instrument's UnderlyingSecurityID(309) which must be fully specified in an instance of the UnderlyingInstrument component.",
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateNotionalReset',
    id: 42467,
    abbrName: 'RtnRtNotlReset',
    description:
      'Indicates whether the term "Equity Notional Reset" as defined in the ISDA 2002 Equity Derivatives Definitions is applicable ("Y") or not.',
  },
  {
    type: 'Price',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamLinkInitialLevel',
    id: 42468,
    abbrName: 'LinkInitLvl',
    description:
      'Price level at which the correlation or variance swap contract will strike.',
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamLinkClosingLevelIndicator',
    id: 42469,
    abbrName: 'LinkFClsngLvl',
    description:
      'Indicates whether the correlation or variance swap contract will ("Y") strike off the closing level of the default exchange traded contract or not.',
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamLinkExpiringLevelIndicator',
    id: 42470,
    abbrName: 'LinkExpngLvl',
    description:
      'Indicates whether the correlation or variance swap contract will ("Y") strike off the expiring level of the default exchange traded contract or not.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamLinkEstimatedTradingDays',
    id: 42471,
    abbrName: 'LinkEstTrdgDays',
    description:
      'The expected number of trading days in the variance or correlation swap stream.',
  },
  {
    type: 'Price',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamLinkStrikePrice',
    id: 42472,
    abbrName: 'LinkStrkPx',
    description: 'The strike price of a correlation or variance swap stream.',
  },
  {
    type: 'PaymentStreamLinkStrikePriceTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamLinkStrikePriceType',
    id: 42473,
    abbrName: 'LinkStrkPxTyp',
    description:
      'For a variance swap specifies how LegPaymentStreamLinkStrikePrice(42472) is expressed.',
  },
  {
    type: 'float',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamLinkMaximumBoundary',
    id: 42474,
    abbrName: 'LinkMaxBndry',
    description:
      'Specifies the maximum or upper boundary for variance or strike determination.\n\nFor a variation swap stream all observations above this price level will be excluded from the variance calculation.\n\nFor a correlation swap stream the maximum boundary is a percentage of the strike price.',
  },
  {
    type: 'float',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamLinkMinimumBoundary',
    id: 42475,
    abbrName: 'LinkMinBndry',
    description:
      'Specifies the minimum or lower boundary for variance or strike determination.\n\nFor a variation swap stream all observations below this price level will be excluded from the variance calculation.\n\nFor a correlation swap stream the minimum boundary is a percentage of the strike price.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamLinkNumberOfDataSeries',
    id: 42476,
    abbrName: 'LinkNumDataSeries',
    description:
      'Number of data series for a correlation swap. Normal market practice is that correlation data sets are drawn from geographic market areas, such as America, Europe and Asia Pacific. Each of these geographic areas will have its own data series to avoid contagion.',
  },
  {
    type: 'float',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamVarianceUnadjustedCap',
    id: 42477,
    abbrName: 'VarncCap',
    description:
      'Indicates the scaling factor to be multiplied by the variance strike price thereby making variance cap applicable.',
  },
  {
    type: 'PaymentStreamRealizedVarianceMethodCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamRealizedVarianceMethod',
    id: 42478,
    abbrName: 'RlzdVarncMeth',
    description: 'Indicates which price to use to satisfy the boundary condition.',
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamDaysAdjustmentIndicator',
    id: 42479,
    abbrName: 'DaysAdjmt',
    description:
      'Indicates whether the contract specifies that the notional should be scaled by the number of days in range divided by the estimate trading days or not. The number of "days in range" refers to the number of returns that contribute to the realized volatility.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamNearestExchangeContractRefID',
    id: 42480,
    abbrName: 'ExchCtrctRefID',
    description:
      "References a contract listed on an exchange through the instrument's UnderlyingSecurityID(309) which must be fully specified in an instance of the UnderlyingInstrument component.",
  },
  {
    type: 'float',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamVegaNotionalAmount',
    id: 42481,
    abbrName: 'VegaNotlAmt',
    description:
      'Vega Notional represents the approximate gain/loss at maturity for a 1% difference between RVol (realized volatility) and KVol (strike volatility). It does not necessarily represent the Vega risk of the trade.',
  },
  {
    type: 'Currency',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFormulaCurrency',
    id: 42482,
    abbrName: 'Ccy',
    description:
      'The currency in which the formula amount is denominated. Uses ISO 4217 currency codes.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFormulaCurrencyDeterminationMethod',
    id: 42483,
    abbrName: 'CcyDtrmnMeth',
    description:
      'Specifies the method according to which the formula amount currency is determined.\n\nSee http://www.fpml.org/coding-scheme/determination-method for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFormulaReferenceAmount',
    id: 42484,
    abbrName: 'RefAmt',
    description:
      'Specifies the reference amount when this term either corresponds to the standard ISDA Definition (either the 2002 Equity Definition for the Equity Amount, or the 2000 Definition for the Interest Amount), or refers to a term defined elsewhere in the swap document.\n\nSee http://www.fixtradingcommunity.org/codelists#Payment_Amount_Relative_To for code list of reference amounts.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoLegPaymentStreamFormulas',
    id: 42485,
    description: 'Number of formulas in the repeating group.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'XMLData',
    addedEP: '208',
    updatedEP: '259',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFormula',
    id: 42486,
    abbrName: 'Frmla',
    lengthId: '43110',
    description:
      'Contains an XML representation of the formula. Defined for flexibility in choice of language (MathML, OpenMath or text).',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFormulaDesc',
    id: 42487,
    abbrName: 'Desc',
    description: 'A description of the math formula in LegPaymentStreamFormula(42486).',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubEndDateUnadjusted',
    id: 42488,
    abbrName: 'DtUnadj',
    description: 'The unadjusted stub end date.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubEndDateBusinessDayConvention',
    id: 42489,
    abbrName: 'BizDayCnvtn',
    description: 'The stub end date business day convention.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubEndDateRelativeTo',
    id: 42490,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the stub end date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubEndDateOffsetPeriod',
    id: 42491,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative stub end date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubEndDateOffsetUnit',
    id: 42492,
    abbrName: 'OfstUnit',
    description: 'Time unit associated with the relative stub end date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubEndDateOffsetDayType',
    id: 42493,
    abbrName: 'OfstDayTyp',
    description: 'Specifies the day type of the relative stub end date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubEndDateAdjusted',
    id: 42494,
    abbrName: 'Dt',
    description: 'The adjusted stub end date.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoLegPaymentStubEndDateBusinessCenters',
    id: 42495,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubEndDateBusinessCenter',
    id: 42496,
    abbrName: 'Ctr',
    description:
      'The business center calendar used for date adjustment of the payment stub end date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubStartDateUnadjusted',
    id: 42497,
    abbrName: 'DtUnadj',
    description: 'The unadjusted stub start date.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubStartDateBusinessDayConvention',
    id: 42498,
    abbrName: 'BizDayCnvtn',
    description: 'The stub start date business day convention.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubStartDateRelativeTo',
    id: 42499,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the stub start date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubStartDateOffsetPeriod',
    id: 42500,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative stub start date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubStartDateOffsetUnit',
    id: 42501,
    abbrName: 'OfstUnit',
    description: 'Time unit associated with the relative stub start date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubStartDateOffsetDayType',
    id: 42502,
    abbrName: 'OfstDayTyp',
    description: 'Specifies the day type of the relative stub start date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubStartDateAdjusted',
    id: 42503,
    abbrName: 'Dt',
    description: 'The adjusted stub start date.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoLegPaymentStubStartDateBusinessCenters',
    id: 42504,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStubStartDateBusinessCenter',
    id: 42505,
    abbrName: 'Ctr',
    description:
      'The business center calendar used for date adjustment of the payment stub start date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'ProvisionBreakFeeElectionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionBreakFeeElection',
    id: 42506,
    abbrName: 'BrkFeeElctn',
    description: 'Type of fee elected for the break provision.',
  },
  {
    type: 'Percentage',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegProvisionBreakFeeRate',
    id: 42507,
    abbrName: 'BrkFeeRt',
    description:
      'Break fee election rate when the break fee is proportional to the notional. A fee rate of 5% would be represented as "0.05".',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoLegReturnRateDates',
    id: 42508,
    description: 'Number of iterations in the return rate date repeating group.',
  },
  {
    type: 'ReturnRateDateModeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateDateMode',
    id: 42509,
    abbrName: 'Mode',
    description: 'Specifies the valuation type applicable to the return rate date.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateValuationDateRelativeTo',
    id: 42510,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the return rate valuation dates are relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateValuationDateOffsetPeriod',
    id: 42511,
    abbrName: 'OfstPeriod',
    description:
      'Time unit multiplier for the relative return rate valuation date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateValuationDateOffsetUnit',
    id: 42512,
    abbrName: 'OfstUnit',
    description:
      'Time unit associated with the relative return rate valuation date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateValuationDateOffsetDayType',
    id: 42513,
    abbrName: 'OfstDayTyp',
    description:
      'Specifies the day type of the relative return rate valuation date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateValuationStartDateUnadjusted',
    id: 42514,
    abbrName: 'StartDtUnadj',
    description:
      'The unadjusted start date for return rate valuation. This can be used to restrict the range of dates when they are relative.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateValuationStartDateRelativeTo',
    id: 42515,
    abbrName: 'StartDtReltv',
    description:
      'Specifies the anchor date when the return rate valuation start date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateValuationStartDateOffsetPeriod',
    id: 42516,
    abbrName: 'StartDtOfstPeriod',
    description:
      'Time unit multiplier for the relative return rate valuation start date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateValuationStartDateOffsetUnit',
    id: 42517,
    abbrName: 'StartDtOfstUnit',
    description:
      'Time unit associated with the relative return rate valuation start date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateValuationStartDateOffsetDayType',
    id: 42518,
    abbrName: 'StartDtOfstDayTyp',
    description:
      'Specifies the day type of the relative return rate valuation start date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateValuationStartDateAdjusted',
    id: 42519,
    abbrName: 'StartDt',
    description:
      'The adjusted start date for return rate valuation. This can be used to restrict the range of dates when they are relative.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateValuationEndDateUnadjusted',
    id: 42520,
    abbrName: 'EndDtUnadj',
    description:
      'The unadjusted end date for return rate valuation. This can be used to restrict the range of dates when they are relative.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateValuationEndDateRelativeTo',
    id: 42521,
    abbrName: 'EndDtReltv',
    description:
      'Specifies the anchor date when the return rate valuation end date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateValuationEndDateOffsetPeriod',
    id: 42522,
    abbrName: 'EndDtOfstPeriod',
    description:
      'Time unit multiplier for the relative return rate valuation end date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateValuationEndDateOffsetUnit',
    id: 42523,
    abbrName: 'EndDtOfstUnit',
    description:
      'Time unit associated with the relative return rate valuation end date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateValuationEndDateOffsetDayType',
    id: 42524,
    abbrName: 'EndDtOfstDayTyp',
    description:
      'Specifies the day type of the relative return rate valuation end date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateValuationEndDateAdjusted',
    id: 42525,
    abbrName: 'EndDt',
    description:
      'The adjusted end date for return rate valuation. This can be used to restrict the range of dates when they are relative.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateValuationFrequencyPeriod',
    id: 42526,
    abbrName: 'FreqPeriod',
    description:
      'Time unit multiplier for the frequency at which return rate valuation dates occur.',
  },
  {
    type: 'CouponFrequencyUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateValuationFrequencyUnit',
    id: 42527,
    abbrName: 'FreqUnit',
    description:
      'Time unit associated with the frequency at which return rate valuation dates occur.',
  },
  {
    type: 'DateRollConventionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateValuationFrequencyRollConvention',
    id: 42528,
    abbrName: 'Roll',
    description:
      'The convention for determining the sequence of return rate valuation dates. It is used in conjunction with a specified frequency.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateValuationDateBusinessDayConvention',
    id: 42529,
    abbrName: 'BizDayCnvtn',
    description: 'The return rate valuation dates business day convention.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoLegReturnRateFXConversions',
    id: 42530,
    description: 'Number of iterations in the return rate FX conversion repeating group.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateFXCurrencySymbol',
    id: 42531,
    abbrName: 'CcySym',
    description:
      'Specifies the currency pair for the FX conversion expressed using the CCY1/CCY2 convention. Uses ISO 4217 currency codes.',
  },
  {
    type: 'float',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateFXRate',
    id: 42532,
    abbrName: 'FxRt',
    description:
      'The rate of exchange between the two currencies specified in LegReturnRateFXCurrencySymbol(42531).',
  },
  {
    type: 'SettlCurrFxRateCalcCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateFXRateCalc',
    id: 42533,
    abbrName: 'FxRtCalc',
    description:
      'The rate of exchange between the two currencies specified in LegReturnRateFXCurrencySymbol(42531).',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoLegReturnRates',
    id: 42534,
    description: 'Number of iterations in the return rate repeating group.',
  },
  {
    type: 'ReturnRatePriceSequenceCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRatePriceSequence',
    id: 42535,
    abbrName: 'PxSeq',
    description: 'Specifies the type of price sequence of the return rate.',
  },
  {
    type: 'CommTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateCommissionBasis',
    id: 42536,
    abbrName: 'CommBasis',
    description: 'Specifies the basis or unit used to calculate the commission.',
  },
  {
    type: 'Amt',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateCommissionAmount',
    id: 42537,
    abbrName: 'CommAmt',
    description: 'The commission amount.',
  },
  {
    type: 'Currency',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateCommissionCurrency',
    id: 42538,
    abbrName: 'CommCcy',
    description:
      'Specifies the currency the commission amount is denominated in. Uses ISO 4217 currency codes.',
  },
  {
    type: 'Amt',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateTotalCommissionPerTrade',
    id: 42539,
    abbrName: 'TotCommPerTrd',
    description: 'The total commission per trade.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateDeterminationMethod',
    id: 42540,
    abbrName: 'DtrmnMeth',
    description:
      'Specifies the method by which the underlier prices are determined.\n\nSee http://www.fpml.org/coding-scheme/determination-method for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateAmountRelativeTo',
    id: 42541,
    abbrName: 'AmtReltv',
    description:
      'Specifies the reference amount when the return rate amount is relative to another amount in the trade.\n\nSee http://www.fixtradingcommunity.org/codelists#Amount_Relative_To for code list of relative amounts.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateQuoteMeasureType',
    id: 42542,
    abbrName: 'QteTyp',
    description:
      "Specifies the type of the measure applied to the return rate's asset, e.g. valuation, sensitivity risk. This could be an NPV, a cash flow, a clean price, etc.\n\nSee http://www.fpml.org/coding-scheme/asset-measure for values.",
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateQuoteUnits',
    id: 42543,
    abbrName: 'QteUnit',
    description:
      'Specifies the units that the measure is expressed in. If not specified, the default is a price/value in currency units.\n\nSee http://www.fpml.org/coding-scheme/price-quote-units for values.',
  },
  {
    type: 'CashSettlQuoteMethodCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateQuoteMethod',
    id: 42544,
    abbrName: 'QteMeth',
    description:
      'Specifies the type of quote used to determine the return rate of the swap.',
  },
  {
    type: 'Currency',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateQuoteCurrency',
    id: 42545,
    abbrName: 'QteCcy',
    description:
      'Specifies the currency the return rate quote is denominated in. Uses ISO 4217 Currency Code.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateQuoteCurrencyType',
    id: 42546,
    abbrName: 'QteCcyTyp',
    description:
      'Specifies the type of currency, e.g. settlement currency, base currency, etc., that the quote is reported in.\n\nSee http://www.fpml.org/coding-scheme/reporting-currency-type for values.',
  },
  {
    type: 'ReturnRateQuoteTimeTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateQuoteTimeType',
    id: 42547,
    abbrName: 'QteTmTyp',
    description: 'Specifies how or the timing when the quote is to be obtained.',
  },
  {
    type: 'LocalMktTime',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateQuoteTime',
    id: 42548,
    abbrName: 'QteTm',
    description: 'The time when the quote is to be generated.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateQuoteDate',
    id: 42549,
    abbrName: 'QteDt',
    description: 'The date when the quote is to be generated.',
  },
  {
    type: 'LocalMktTime',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateQuoteExpirationTime',
    id: 42550,
    abbrName: 'QteExpTm',
    description: 'The time when the quote ceases to be valid.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateQuoteBusinessCenter',
    id: 42551,
    abbrName: 'QteBizCtr',
    description:
      'The business center calendar used for adjustments associated with LegReturnRateQuoteTimeType(42547) or LegReturnRateQuoteTime(42548) and LegReturnRateQuoteDate(42549), e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'Exchange',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateQuoteExchange',
    id: 42552,
    abbrName: 'QteExch',
    description:
      'Specifies the exchange (e.g. stock or listed futures/options exchange) from which the quote is obtained.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateQuotePricingModel',
    id: 42553,
    abbrName: 'QteModel',
    description:
      'Specifies the pricing model used to evaluate the underlying asset price.\n\nSee http://www.fpml.org/coding-scheme/pricing-model for values.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateCashFlowType',
    id: 42554,
    abbrName: 'CshFlow',
    description:
      'Specifies the type of cash flows, e.g. coupon payment, premium fee, settlement fee, etc.\n\nSee http://www.fpml.org/coding-scheme/cashflow-type for values.',
  },
  {
    type: 'ReturnRateQuoteTimeTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateValuationTimeType',
    id: 42555,
    abbrName: 'ValTmTyp',
    description:
      'Specifies the timing at which the calculation agent values the underlying.',
  },
  {
    type: 'LocalMktTime',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateValuationTime',
    id: 42556,
    abbrName: 'ValTm',
    description: 'The time at which the calculation agent values the underlying asset.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateValuationTimeBusinessCenter',
    id: 42557,
    abbrName: 'ValTmBizCtr',
    description:
      'The business center calendar used for adjustments associated with LegReturnRateValuationTimeType(42555) or LegReturnRateValuationTime(42556), e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'ReturnRateValuationPriceOptionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateValuationPriceOption',
    id: 42558,
    abbrName: 'ValPxOpt',
    description:
      'Indicates whether an ISDA price option applies, and if applicable which type of price.',
  },
  {
    type: 'ComplexEventPVFinalPriceElectionFallbackCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateFinalPriceFallback',
    id: 42559,
    abbrName: 'FnlPxFallbck',
    description:
      'Specifies the fallback provision for the hedging party in the determination of the final price.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoLegReturnRateInformationSources',
    id: 42560,
    description:
      'Number of iterations in the return rate information source repeating group.',
  },
  {
    type: 'RateSourceCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateInformationSource',
    id: 42561,
    abbrName: 'RtSrc',
    description:
      'Identifies the source of rate information. For FX the references source to be used for the FX spot rate.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateReferencePage',
    id: 42562,
    abbrName: 'RefPg',
    description:
      'Identifies the reference "page" from the rate source.\n\nFor FX, the reference page to the spot rate to be used for the reference FX spot rate.\n\nWhen LegReturnRateInformationSource(42561) = 3 (ISDA Settlement Rate Option) this contains the value from the scheme that reflects the terms of the Annex A to the ISDA 1998 FX and Currency Option Definitions.\n\nSee: http://www.fpml.org/coding-scheme/settlement-rate-option.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateReferencePageHeading',
    id: 42563,
    abbrName: 'RefHdng',
    description: 'Identifies the page heading from the rate source.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoLegReturnRatePrices',
    id: 42564,
    description: 'Number of iterations in the return rate price repeating group.',
  },
  {
    type: 'ReturnRatePriceBasisCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRatePriceBasis',
    id: 42565,
    abbrName: 'PxBasis',
    description: 'The basis of the return price.',
  },
  {
    type: 'Price',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRatePrice',
    id: 42566,
    abbrName: 'Px',
    description: 'Specifies the price of the underlying swap asset.',
  },
  {
    type: 'Currency',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRatePriceCurrency',
    id: 42567,
    abbrName: 'Ccy',
    description:
      'Specifies the currency of the price of the leg swap asset. Uses ISO 4217 currency codes.',
  },
  {
    type: 'ReturnRatePriceTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRatePriceType',
    id: 42568,
    abbrName: 'PxTyp',
    description:
      'Specifies whether the LegReturnRatePrice(42566) is expressed in absolute or relative terms.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoLegReturnRateValuationDateBusinessCenters',
    id: 42569,
    description:
      'Number of iterations in the return rate valuation date business center repeating group.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateValuationDateBusinessCenter',
    id: 42570,
    abbrName: 'Ctr',
    description:
      'The business center calendar used for date adjustment of the return rate valuation unadjusted or relative dates, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoLegReturnRateValuationDates',
    id: 42571,
    description:
      'Number of iterations in the return rate valuation date repeating group.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateValuationDate',
    id: 42572,
    abbrName: 'Dt',
    description:
      'The return rate valuation date. The type of date is specified in LegReturnRateValuationDateType(42573).',
  },
  {
    type: 'NonDeliverableFixingDateTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegReturnRateValuationDateType',
    id: 42573,
    abbrName: 'Typ',
    description:
      'Specifies the type of return rate valuation date (e.g. adjusted for holidays).',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegSettlMethodElectionDateUnadjusted',
    id: 42574,
    abbrName: 'DtUnadj',
    description: 'The unadjusted settlement method election date.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegSettlMethodElectionDateBusinessDayConvention',
    id: 42575,
    abbrName: 'BizDayCnvtn',
    description:
      'The settlement method election date adjustment business day convention.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegSettlMethodElectionDateRelativeTo',
    id: 42576,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the settlement method election date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegSettlMethodElectionDateOffsetPeriod',
    id: 42577,
    abbrName: 'OfstPeriod',
    description:
      'Time unit multiplier for the relative settlement method election date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegSettlMethodElectionDateOffsetUnit',
    id: 42578,
    abbrName: 'OfstUnit',
    description:
      'Time unit associated with the relative settlement method election date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegSettlMethodElectionDateOffsetDayType',
    id: 42579,
    abbrName: 'OfstDayTyp',
    description:
      'Specifies the day type of the relative settlement method election date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegSettlMethodElectionDateAdjusted',
    id: 42580,
    abbrName: 'Dt',
    description: 'The adjusted settlement method election date.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoLegSettlMethodElectionDateBusinessCenters',
    id: 42581,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegSettlMethodElectionDateBusinessCenter',
    id: 42582,
    abbrName: 'Ctr',
    description:
      'The business center calendar used for date adjustment of the settlement method election unadjusted or relative date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegStreamVersion',
    id: 42583,
    abbrName: 'Ver',
    description:
      'The stream version identifier when there have been modifications to the contract over time. Helps signal when there are embedded changes.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegStreamVersionEffectiveDate',
    id: 42584,
    abbrName: 'VerEfctvDt',
    description: 'The effective date of the LegStreamVersion(42583).',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegStreamNotionalDeterminationMethod',
    id: 42585,
    abbrName: 'NotlDtrmnMeth',
    description:
      'Specifies the method for determining the floating notional value for equity swaps.\n\nSee http://www.fpml.org/coding-scheme/determination-method for values.',
  },
  {
    type: 'StreamNotionalAdjustmentsCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'LegStreamNotionalAdjustments',
    id: 42586,
    abbrName: 'NotlAdjmts',
    description:
      'For equity swaps this specifies the conditions that govern the adjustment to the number of units of the swap.',
  },
  {
    type: 'PaymentPaySideCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'SettlMethodElectingPartySide',
    id: 42590,
    abbrName: 'SettlMethElctngSide',
    description: 'Side value of the party electing the settlement method.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'MakeWholeDate',
    id: 42591,
    abbrName: 'Dt',
    description: 'The date through which option cannot be exercised without penalty.',
  },
  {
    type: 'Amt',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'MakeWholeAmount',
    id: 42592,
    abbrName: 'Amt',
    description:
      'Amount to be paid by the buyer of the option if the option is exercised prior to the MakeWholeDate(42591).',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'MakeWholeBenchmarkCurveName',
    id: 42593,
    abbrName: 'Name',
    description: 'Identifies the benchmark floating rate index.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'MakeWholeBenchmarkCurvePoint',
    id: 42594,
    abbrName: 'Point',
    description:
      'The point on the floating rate index curve.\n\nSample values:\n\nM = combination of a number between 1-12 and an "M" for month, e.g. 3M\n\nY = combination of number between 1-100 and a "Y" for year, e.g. 10Y\n\n10Y-OLD = see above, then add "-OLD" when appropriate\n\nINTERPOLATED = the point is mathematically derived\n\n2/2031 5 3/8 = the point is stated via a combination of maturity month / year and coupon.',
  },
  {
    type: 'PriceOffset',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'MakeWholeRecallSpread',
    id: 42595,
    abbrName: 'Spread',
    description: 'Spread over the floating rate index.',
  },
  {
    type: 'StrikeIndexQuoteCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'MakeWholeBenchmarkQuote',
    id: 42596,
    abbrName: 'Qte',
    description:
      'The quote side of the benchmark to be used for calculating the "make whole" amount.',
  },
  {
    type: 'PaymentStreamInflationInterpolationMethodCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'MakeWholeInterpolationMethod',
    id: 42597,
    abbrName: 'IntrpltnMeth',
    description:
      'The method used when calculating the "make whole" amount. The most common is linear method.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentAmountRelativeTo',
    id: 42598,
    abbrName: 'AmtReltv',
    description:
      'Specifies the reference amount when the payment amount is relative to another amount in the message.\n\nSee http://www.fixtradingcommunity.org/codelists#Payment_Amount_Relative_To for code list of relative amounts.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentAmountDeterminationMethod',
    id: 42599,
    abbrName: 'AmtDtrmnMeth',
    description:
      'Specifies the method by which a payment amount is determined.\n\nSee http://www.fpml.org/coding-scheme/determination-method for values.',
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCashSettlIndicator',
    id: 42600,
    abbrName: 'CshSettlInd',
    description: 'Indicates whether cash settlement is applicable.',
  },
  {
    type: 'XIDREF',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingXIDRef',
    id: 42601,
    abbrName: 'CmpndgXIDRef',
    description:
      'Reference to the stream which details the compounding fixed or floating rate.',
  },
  {
    type: 'PriceOffset',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingSpread',
    id: 42602,
    abbrName: 'CmpndgSpread',
    description:
      'The spread to be used for compounding. Used in scenarios where the interest payment is based on a compounding formula that uses a compounding spread in addition to the regular spread.',
  },
  {
    type: 'PaymentStreamInflationInterpolationMethodCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamInterpolationMethod',
    id: 42603,
    abbrName: 'IntrpltnMeth',
    description:
      'The method used when calculating the index rate from multiple points on the curve. The most common is linear method.',
  },
  {
    type: 'PaymentStreamInterpolationPeriodCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamInterpolationPeriod',
    id: 42604,
    abbrName: 'IntrpltnPeriod',
    description: 'Defines applicable periods for interpolation.',
  },
  {
    type: 'float',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingFixedRate',
    id: 42605,
    abbrName: 'CmpndgFixedRt',
    description: 'The compounding fixed rate applicable to the payment stream.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoPaymentStreamCompoundingDates',
    id: 42606,
    description: 'Number of dates in the repeating group.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingDate',
    id: 42607,
    abbrName: 'Dt',
    description:
      'The compounding date. The type of date is specified in PaymentStreamCompoundingDateType(42608).',
  },
  {
    type: 'NonDeliverableFixingDateTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingDateType',
    id: 42608,
    abbrName: 'Typ',
    description:
      'Specifies the type of payment compounding date (e.g. adjusted for holidays).',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingDatesBusinessDayConvention',
    id: 42609,
    abbrName: 'BizDayCnvtn',
    description: 'The compounding dates business day convention.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingDatesRelativeTo',
    id: 42610,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the compounding dates are relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingDatesOffsetPeriod',
    id: 42611,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative compounding date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingDatesOffsetUnit',
    id: 42612,
    abbrName: 'OfstUnit',
    description: 'Time unit associated with the relative compounding date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingDatesOffsetDayType',
    id: 42613,
    abbrName: 'OfstDayTyp',
    description: 'Specifies the day type of the relative compounding date offset.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingPeriodSkip',
    id: 42614,
    abbrName: 'Skip',
    description:
      'The number of periods in the "RelativeTo" schedule that are between each date in the compounding schedule. A skip of 2 would mean that compounding dates are relative to every second date in the "RelativeTo" schedule. If present this should have a value greater than 1.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingFrequencyPeriod',
    id: 42615,
    abbrName: 'FreqPeriod',
    description:
      'Time unit multiplier for the frequency at which compounding dates occur.',
  },
  {
    type: 'CouponFrequencyUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingFrequencyUnit',
    id: 42616,
    abbrName: 'FreqUnit',
    description:
      'Time unit associated with the frequency at which compounding dates occur.',
  },
  {
    type: 'DateRollConventionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingRollConvention',
    id: 42617,
    abbrName: 'Roll',
    description:
      'The convention for determining the sequence of compounding dates. It is used in conjunction with a specified frequency.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamBoundsFirstDateUnadjusted',
    id: 42618,
    abbrName: 'FirstDtUnadj',
    description:
      'The unadjusted first date of the compounding schedule. This can be used to restrict the range of dates when they are relative.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamBoundsLastDateUnadjusted',
    id: 42619,
    abbrName: 'LastDtUnadj',
    description:
      'The unadjusted last date of the compounding schedule. This can be used to restrict the range of dates when they are relative.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoPaymentStreamCompoundingDatesBusinessCenters',
    id: 42620,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingDatesBusinessCenter',
    id: 42621,
    abbrName: 'Ctr',
    description:
      'The business center calendar used for date adjustment of the payment stream compounding dates, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingEndDateUnadjusted',
    id: 42622,
    abbrName: 'DtUnadj',
    description: 'The unadjusted compounding end date.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingEndDateRelativeTo',
    id: 42623,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the compounding end date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingEndDateOffsetPeriod',
    id: 42624,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative compounding end date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingEndDateOffsetUnit',
    id: 42625,
    abbrName: 'OfstUnit',
    description: 'Time unit associated with the relative compounding end date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingEndDateOffsetDayType',
    id: 42626,
    abbrName: 'OfstDayTyp',
    description: 'Specifies the day type of the relative compounding end date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingEndDateAdjusted',
    id: 42627,
    abbrName: 'Dt',
    description: 'The adjusted compounding end date.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingRateIndex',
    id: 42628,
    abbrName: 'Ndx',
    description: "The payment stream's compounding floating rate index.",
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingRateIndexCurvePeriod',
    id: 42629,
    abbrName: 'NdxPeriod',
    description:
      "Time unit multiplier for the payment stream's compounding floating rate index curve period.",
  },
  {
    type: 'PaymentStreamRateIndexCurveUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingRateIndexCurveUnit',
    id: 42630,
    abbrName: 'NdxUnit',
    description:
      "Time unit associated with the payment stream's compounding floating rate index curve period.",
  },
  {
    type: 'float',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingRateMultiplier',
    id: 42631,
    abbrName: 'RtMult',
    description:
      'A rate multiplier to apply to the compounding floating rate. The multiplier can be less than or greater than 1 (one). This should only be included if the multiplier is not equal to 1 (one) for the term of the stream.',
  },
  {
    type: 'PriceOffset',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingRateSpread',
    id: 42632,
    abbrName: 'Spread',
    description:
      'The basis points spread from the index specified in PaymentStreamCompoundingRateIndex(42628).',
  },
  {
    type: 'PaymentStreamRateSpreadPositionTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingRateSpreadPositionType',
    id: 42633,
    abbrName: 'SpreadPosTyp',
    description:
      'Identifies whether the rate spread is applied to a long or short position.',
  },
  {
    type: 'PaymentStreamRateTreatmentCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingRateTreatment',
    id: 42634,
    abbrName: 'RtTrtmt',
    description: 'Specifies the yield calculation treatment for the index.',
  },
  {
    type: 'Percentage',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingCapRate',
    id: 42635,
    abbrName: 'CapRt',
    description:
      'The cap rate, if any, which applies to the compounding floating rate. It is only required where the compounding floating rate on a swap stream is capped at a certain level. The cap rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A cap rate of 5% would be represented as "0.05".',
  },
  {
    type: 'PaymentStreamCapRateBuySideCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingCapRateBuySide',
    id: 42636,
    abbrName: 'CapRtBuy',
    description:
      'Reference to the buyer of the compounding cap rate option through its trade side.',
  },
  {
    type: 'PaymentStreamCapRateBuySideCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingCapRateSellSide',
    id: 42637,
    abbrName: 'CapRtSell',
    description:
      'Reference to the seller of the compounding cap rate option through its trade side.',
  },
  {
    type: 'Percentage',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingFloorRate',
    id: 42638,
    abbrName: 'FlrRt',
    description:
      'The floor rate, if any, which applies to the compounding floating rate. The floor rate (strike) is only required where the compounding floating rate on a swap stream is floored at a certain strike level. The floor rate is assumed to be exclusive of any spread and is a per annum rate. The rate is expressed as a decimal, e.g. 5% is represented as "0.05".',
  },
  {
    type: 'PaymentStreamFloorRateBuySideCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingFloorRateBuySide',
    id: 42639,
    abbrName: 'FlrRtBuy',
    description:
      'Reference to the buyer of the compounding floor rate option through its trade side.',
  },
  {
    type: 'PaymentStreamFloorRateBuySideCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingFloorRateSellSide',
    id: 42640,
    abbrName: 'FlrRtSell',
    description:
      'Reference to the seller of the floor rate option through its trade side.',
  },
  {
    type: 'Percentage',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingInitialRate',
    id: 42641,
    abbrName: 'InitRt',
    description:
      'The initial compounding floating rate reset agreed between the principal parties involved in the trade. It should only be included when the rate is not equal to the rate published on the source implied by the floating rate index. The initial rate is expressed in decimal form, e.g. 5% is represented as "0.05".',
  },
  {
    type: 'RoundingDirectionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingFinalRateRoundingDirection',
    id: 42642,
    abbrName: 'FnlRtRndDirctn',
    description: 'Specifies the rounding direction for the compounding floating rate.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingFinalRatePrecision',
    id: 42643,
    abbrName: 'FnlRtPrcsn',
    description:
      'Specifies the compounding floating rate rounding precision in terms of a number of decimal places. Note how a percentage rate rounding of 5 decimal places is expressed as a rounding precision of 7.',
  },
  {
    type: 'PaymentStreamAveragingMethodCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingAveragingMethod',
    id: 42644,
    abbrName: 'AvgngMeth',
    description:
      'Specifies the averaging method when compounding floating rate averaging is applicable (e.g. weighted or unweighted).',
  },
  {
    type: 'PaymentStreamNegativeRateTreatmentCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingNegativeRateTreatment',
    id: 42645,
    abbrName: 'NegtvRtTrtmt',
    description:
      'Specifies the method for calculating payment obligations when a compounding floating rate is negative (either due to a quoted negative floating rate or by operation of a spread that is subtracted from the floating rate).',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingStartDateUnadjusted',
    id: 42646,
    abbrName: 'DtUnadj',
    description: 'The unadjusted compounding start date.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingStartDateRelativeTo',
    id: 42647,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the compounding start date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingStartDateOffsetPeriod',
    id: 42648,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative compounding start date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingStartDateOffsetUnit',
    id: 42649,
    abbrName: 'OfstUnit',
    description: 'Time unit associated with the relative compounding start date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingStartDateOffsetDayType',
    id: 42650,
    abbrName: 'OfstDayTyp',
    description: 'Specifies the day type of the relative compounding start date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamCompoundingStartDateAdjusted',
    id: 42651,
    abbrName: 'Dt',
    description: 'The adjusted compounding start date.',
  },
  {
    type: 'Length',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFormulaImageLength',
    id: 42652,
    abbrName: 'FrmlaImgLen',
    description: 'Length in bytes of the PaymentStreamFormulaImage(42563) field.',
  },
  {
    type: 'data',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFormulaImage',
    id: 42653,
    abbrName: 'FrmlaImg',
    lengthId: '42652',
    description:
      'Image of the formula image when represented through an encoded clip in base64Binary.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFinalPricePaymentDateUnadjusted',
    id: 42654,
    abbrName: 'DtUnadj',
    description: 'The unadjusted final price payment date.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFinalPricePaymentDateRelativeTo',
    id: 42655,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the final price payment date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFinalPricePaymentDateOffsetfPeriod',
    id: 42656,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative final price payment date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFinalPricePaymentDateOffsetUnit',
    id: 42657,
    abbrName: 'OfstUnit',
    description:
      'Time unit associated with the relative final price payment date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFinalPricePaymentDateOffsetDayType',
    id: 42658,
    abbrName: 'OfstDayTyp',
    description:
      'Specifies the day type of the relative final price payment date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFinalPricePaymentDateAdjusted',
    id: 42659,
    abbrName: 'Dt',
    description: 'The adjusted final price payment date.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoPaymentStreamFixingDates',
    id: 42660,
    description: 'Number of fixing dates in the repeating group.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFixingDate',
    id: 42661,
    abbrName: 'Dt',
    description:
      'The fixing date. The type of date is specified in PaymentStreamFixingDateType(42662).',
  },
  {
    type: 'NonDeliverableFixingDateTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFixingDateType',
    id: 42662,
    abbrName: 'Typ',
    description: 'Specifies the type of fixing date (e.g. adjusted for holidays).',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFirstObservationDateUnadjusted',
    id: 42663,
    abbrName: 'FirstObsvtnDtUnadj',
    description: 'The unadjusted initial price observation date.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFirstObservationDateRelativeTo',
    id: 42664,
    abbrName: 'FirstObsvtnReltv',
    description:
      'Specifies the anchor date when the initial price observation date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFirstObservationDateOffsetDayType',
    id: 42665,
    abbrName: 'FirstObsvtnOfstDayTyp',
    description: 'Specifies the day type of the initial price observation date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFirstObservationDateAdjusted',
    id: 42666,
    abbrName: 'FirstObsvtnDt',
    description: 'The adjusted initial price observation date.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamUnderlierRefID',
    id: 42667,
    abbrName: 'UndlrRefID',
    description:
      "References the dividend underlier through the instrument's UnderlyingSecurityID(309) which must be fully specified in an instance of the UnderlyingInstrument component.",
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateNotionalReset',
    id: 42668,
    abbrName: 'RtnRtNotlReset',
    description:
      'Indicates whether the term "Equity Notional Reset" as defined in the ISDA 2002 Equity Derivatives Definitions is applicable ("Y") or not.',
  },
  {
    type: 'Price',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamLinkInitialLevel',
    id: 42669,
    abbrName: 'LinkInitLvl',
    description:
      'Price level at which the correlation or variance swap contract will strike.',
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamLinkClosingLevelIndicator',
    id: 42670,
    abbrName: 'LinkClsngLvl',
    description:
      'Indicates whether the correlation or variance swap contract will ("Y") strike off the closing level of the default exchange traded contract or not.',
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamLinkExpiringLevelIndicator',
    id: 42671,
    abbrName: 'LinkExpngLvl',
    description:
      'Indicates whether the correlation or variance swap contract will ("Y") strike off the expiring level of the default exchange traded contract or not.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamLinkEstimatedTradingDays',
    id: 42672,
    abbrName: 'LinkEstTrdgDays',
    description:
      'The expected number of trading days in the variance or correlation swap stream.',
  },
  {
    type: 'Price',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamLinkStrikePrice',
    id: 42673,
    abbrName: 'LinkStrkPx',
    description: 'The strike price of a correlation or variance swap stream.',
  },
  {
    type: 'PaymentStreamLinkStrikePriceTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamLinkStrikePriceType',
    id: 42674,
    abbrName: 'LinkStrkPxTyp',
    description:
      'For a variance swap specifies how PaymentStreamLinkStrikePrice(42673) is expressed.',
  },
  {
    type: 'float',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamLinkMaximumBoundary',
    id: 42675,
    abbrName: 'LinkMaxBndry',
    description:
      'Specifies the maximum or upper boundary for variance or strike determination.\n\nFor a variation swap stream all observations above this price level will be excluded from the variance calculation.\n\nFor a correlation swap stream the maximum boundary is a percentage of the strike price.',
  },
  {
    type: 'float',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamLinkMinimumBoundary',
    id: 42676,
    abbrName: 'LinkMinBndry',
    description:
      'Specifies the minimum or lower boundary for variance or strike determination.\n\nFor a variation swap stream all observations below this price level will be excluded from the variance calculation.\n\nFor a correlation swap stream the minimum boundary is a percentage of the strike price.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamLinkNumberOfDataSeries',
    id: 42677,
    abbrName: 'LinkNumDataSeries',
    description:
      'Number of data series for a correlation swap. Normal market practice is that correlation data sets are drawn from geographic market areas, such as America, Europe and Asia Pacific. Each of these geographic areas will have its own data series to avoid contagion.',
  },
  {
    type: 'float',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamVarianceUnadjustedCap',
    id: 42678,
    abbrName: 'VarncCap',
    description:
      'Indicates the scaling factor to be multiplied by the variance strike price thereby making variance cap applicable.',
  },
  {
    type: 'PaymentStreamRealizedVarianceMethodCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamRealizedVarianceMethod',
    id: 42679,
    abbrName: 'RlzdVarncMeth',
    description: 'Indicates which price to use to satisfy the boundary condition.',
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamDaysAdjustmentIndicator',
    id: 42680,
    abbrName: 'DaysAdjmt',
    description:
      'Indicates whether the contract specifies that the notional should be scaled by the number of days in range divided by the estimate trading days or not. The number of "days in range" refers to the number of returns that contribute to the realized volatility.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamNearestExchangeContractRefID',
    id: 42681,
    abbrName: 'ExchCtrctRefID',
    description:
      "References a contract listed on an exchange through the instrument's UnderlyingSecurityID(309) which must be fully specified in an instance of the UnderlyingInstrument component.",
  },
  {
    type: 'float',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamVegaNotionalAmount',
    id: 42682,
    abbrName: 'VegaNotlAmt',
    description:
      '"Vega Notional" represents the approximate gain/loss at maturity for a 1% difference between RVol (realised volatility) and KVol (strike volatility). It does not necessarily represent the Vega risk of the trade.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoPaymentStreamFormulas',
    id: 42683,
    description: 'Number of formulas in the repeating group.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'XMLData',
    addedEP: '208',
    updatedEP: '259',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFormula',
    id: 42684,
    abbrName: 'Frmla',
    lengthId: '43109',
    description:
      'Contains an XML representation of the formula. Defined for flexibility in choice of language (MathML, OpenMath or text).',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFormulaDesc',
    id: 42685,
    abbrName: 'Desc',
    description: 'A description of the math formula in PaymentStreamFormula(42684).',
  },
  {
    type: 'Currency',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFormulaCurrency',
    id: 42686,
    abbrName: 'Ccy',
    description:
      'The currency in which the formula amount is denominated. Uses ISO 4217 currency codes.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFormulaCurrencyDeterminationMethod',
    id: 42687,
    abbrName: 'CcyDtrmnMeth',
    description:
      'Specifies the method according to which the formula amount currency is determined.\n\nSee http://www.fpml.org/coding-scheme/determination-method for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFormulaReferenceAmount',
    id: 42688,
    abbrName: 'RefAmt',
    description:
      'Specifies the reference amount when this term either corresponds to the standard ISDA Definition (either the 2002 Equity Definition for the Equity Amount, or the 2000 Definition for the Interest Amount), or refers to a term defined elsewhere in the swap document.\n\nSee http://www.fixtradingcommunity.org/codelists#Payment_Amount_Relative_To for code list of reference amounts.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubEndDateUnadjusted',
    id: 42689,
    abbrName: 'DtUnadj',
    description: 'The unadjusted stub end date.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubEndDateBusinessDayConvention',
    id: 42690,
    abbrName: 'BizDayCnvtn',
    description: 'The stub end date business day convention.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubEndDateRelativeTo',
    id: 42691,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the stub end date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubEndDateOffsetPeriod',
    id: 42692,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative stub end date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubEndDateOffsetUnit',
    id: 42693,
    abbrName: 'OfstUnit',
    description: 'Time unit associated with the relative stub end date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubEndDateOffsetDayType',
    id: 42694,
    abbrName: 'OfstDayTyp',
    description: 'Specifies the day type of the relative stub end date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubEndDateAdjusted',
    id: 42695,
    abbrName: 'Dt',
    description: 'The adjusted stub end date.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoPaymentStubEndDateBusinessCenters',
    id: 42696,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubEndDateBusinessCenter',
    id: 42697,
    abbrName: 'Ctr',
    description:
      'The business center calendar used for date adjustment of the payment stub end date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubStartDateUnadjusted',
    id: 42698,
    abbrName: 'DtUnadj',
    description: 'The unadjusted stub start date.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubStartDateBusinessDayConvention',
    id: 42699,
    abbrName: 'BizDayCnvtn',
    description: 'The stub start date business day convention.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubStartDateRelativeTo',
    id: 42700,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the stub start date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubStartDateOffsetPeriod',
    id: 42701,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative stub start date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubStartDateOffsetUnit',
    id: 42702,
    abbrName: 'OfstUnit',
    description: 'Time unit associated with the relative stub start date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubStartDateOffsetDayType',
    id: 42703,
    abbrName: 'OfstDayTyp',
    description: 'Specifies the day type of the relative stub start date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubStartDateAdjusted',
    id: 42704,
    abbrName: 'Dt',
    description: 'The adjusted stub start date.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoPaymentStubStartDateBusinessCenters',
    id: 42705,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'PaymentStubStartDateBusinessCenter',
    id: 42706,
    abbrName: 'Ctr',
    description:
      'The business center calendar used for date adjustment of the payment stub start date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'ProvisionBreakFeeElectionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ProvisionBreakFeeElection',
    id: 42707,
    abbrName: 'BrkFeeElctn',
    description: 'Type of fee elected for the break provision.',
  },
  {
    type: 'Percentage',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ProvisionBreakFeeRate',
    id: 42708,
    abbrName: 'BrkFeeRt',
    description:
      'Break fee election rate when the break fee is proportional to the notional. A fee rate of 5% would be represented as "0.05".',
  },
  {
    type: 'XIDREF',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'RelatedToDividendPeriodXIDRef',
    id: 2417,
    abbrName: 'XIDRef',
    description:
      'The DividendPeriodXID(42293) of the stream dividend period with which the related instrument has correlation.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoReturnRateDates',
    id: 42709,
    description: 'Number of iterations in the return rate date repeating group.',
  },
  {
    type: 'ReturnRateDateModeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateDateMode',
    id: 42710,
    abbrName: 'Mode',
    description: 'Specifies the valuation type applicable to the return rate date.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateValuationDateRelativeTo',
    id: 42711,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the return rate valuation dates are relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateValuationDateOffsetPeriod',
    id: 42712,
    abbrName: 'OfstPeriod',
    description:
      'Time unit multiplier for the relative return rate valuation date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateValuationDateOffsetUnit',
    id: 42713,
    abbrName: 'OfstUnit',
    description:
      'Time unit associated with the relative return rate valuation date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateValuationDateOffsetDayType',
    id: 42714,
    abbrName: 'OfstDayTyp',
    description:
      'Specifies the day type of the relative return rate valuation date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateValuationStartDateUnadjusted',
    id: 42715,
    abbrName: 'StartDtUnadj',
    description:
      'The unadjusted start date for return rate valuation. This can be used to restrict the range of dates when they are relative.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateValuationStartDateRelativeTo',
    id: 42716,
    abbrName: 'StartDtReltv',
    description:
      'Specifies the anchor date when the return rate valuation start date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateValuationStartDateOffsetPeriod',
    id: 42717,
    abbrName: 'StartDtOfstPeriod',
    description:
      'Time unit multiplier for the relative return rate valuation start date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateValuationStartDateOffsetUnit',
    id: 42718,
    abbrName: 'StartDtOfstUnit',
    description:
      'Time unit associated with the relative return rate valuation start date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateValuationStartDateOffsetDayType',
    id: 42719,
    abbrName: 'StartDtOfstDayTyp',
    description:
      'Specifies the day type of the relative return rate valuation start date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateValuationStartDateAdjusted',
    id: 42720,
    abbrName: 'StartDt',
    description:
      'The adjusted start date for return rate valuation. This can be used to restrict the range of dates when they are relative.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateValuationEndDateUnadjusted',
    id: 42721,
    abbrName: 'EndDtUnadj',
    description:
      'The unadjusted end date for return rate valuation. This can be used to restrict the range of dates when they are relative.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateValuationEndDateRelativeTo',
    id: 42722,
    abbrName: 'EndDtReltv',
    description:
      'Specifies the anchor date when the return rate valuation end date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateValuationEndDateOffsetPeriod',
    id: 42723,
    abbrName: 'EndDtOfstPeriod',
    description:
      'Time unit multiplier for the relative return rate valuation end date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateValuationEndDateOffsetUnit',
    id: 42724,
    abbrName: 'EndDtOfstUnit',
    description:
      'Time unit associated with the relative return rate valuation end date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateValuationEndDateOffsetDayType',
    id: 42725,
    abbrName: 'EndDtOfstDayTyp',
    description:
      'Specifies the day type of the relative return rate valuation end date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateValuationEndDateAdjusted',
    id: 42726,
    abbrName: 'EndDt',
    description:
      'The adjusted end date for return rate valuation. This can be used to restrict the range of dates when they are relative.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateValuationFrequencyPeriod',
    id: 42727,
    abbrName: 'FreqPeriod',
    description:
      'Time unit multiplier for the frequency at which return rate valuation dates occur.',
  },
  {
    type: 'CouponFrequencyUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateValuationFrequencyUnit',
    id: 42728,
    abbrName: 'FreqUnit',
    description:
      'Time unit associated with the frequency at which return rate valuation dates occur.',
  },
  {
    type: 'DateRollConventionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateValuationFrequencyRollConvention',
    id: 42729,
    abbrName: 'Roll',
    description:
      'The convention for determining the sequence of return rate valuation dates. It is used in conjunction with a specified frequency.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateValuationDateBusinessDayConvention',
    id: 42730,
    abbrName: 'BizDayCnvtn',
    description: 'The return rate valuation dates business day convention.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoReturnRateFXConversions',
    id: 42731,
    description: 'Number of iterations in the return rate FX conversion repeating group.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateFXCurrencySymbol',
    id: 42732,
    abbrName: 'CcySym',
    description:
      'Specifies the currency pair for the FX conversion expressed using the CCY1/CCY2 convention. Uses ISO 4217 currency codes.',
  },
  {
    type: 'float',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateFXRate',
    id: 42733,
    abbrName: 'FxRt',
    description:
      'The rate of exchange between the two currencies specified in ReturnRateFXCurrencySymbol(42732).',
  },
  {
    type: 'SettlCurrFxRateCalcCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateFXRateCalc',
    id: 42734,
    abbrName: 'FxRtCalc',
    description:
      'Specifies whether ReturnRateFXRate(42733) should be multiplied or divided.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoReturnRates',
    id: 42735,
    description: 'Number of iterations in the return rate repeating group.',
  },
  {
    type: 'ReturnRatePriceSequenceCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRatePriceSequence',
    id: 42736,
    abbrName: 'PxSeq',
    description: 'Specifies the type of price sequence of the return rate.',
  },
  {
    type: 'CommTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateCommissionBasis',
    id: 42737,
    abbrName: 'CommBasis',
    description: 'Specifies the basis or unit used to calculate the commission.',
  },
  {
    type: 'Amt',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateCommissionAmount',
    id: 42738,
    abbrName: 'CommAmt',
    description: 'The commission amount.',
  },
  {
    type: 'Currency',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateCommissionCurrency',
    id: 42739,
    abbrName: 'CommCcy',
    description:
      'Specifies the currency the commission amount is denominated in. Uses ISO 4217 currency codes.',
  },
  {
    type: 'Amt',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateTotalCommissionPerTrade',
    id: 42740,
    abbrName: 'TotCommPerTrd',
    description: 'The total commission per trade.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateDeterminationMethod',
    id: 42741,
    abbrName: 'DtrmnMeth',
    description:
      'Specifies the method by which the underlier prices are determined.\n\nSee http://www.fpml.org/coding-scheme/determination-method for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateAmountRelativeTo',
    id: 42742,
    abbrName: 'AmtReltv',
    description:
      'Specifies the reference amount when the return rate amount is relative to another amount in the trade.\n\nSee http://www.fixtradingcommunity.org/codelists#Payment_Amount_Relative_To for code list of relative amounts.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateQuoteMeasureType',
    id: 42743,
    abbrName: 'QteTyp',
    description:
      "Specifies the type of the measure applied to the return rate's asset, e.g. valuation, sensitivity risk. This could be an NPV, a cash flow, a clean price, etc.\n\nSee http://www.fpml.org/coding-scheme/asset-measure for values.",
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateQuoteUnits',
    id: 42744,
    abbrName: 'QteUnit',
    description:
      'Specifies the units that the measure is expressed in. If not specified, the default is a price/value in currency units.\n\nSee http://www.fpml.org/coding-scheme/price-quote-units for values.',
  },
  {
    type: 'CashSettlQuoteMethodCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateQuoteMethod',
    id: 42745,
    abbrName: 'QteMeth',
    description:
      'Specifies the type of quote used to determine the return rate of the swap.',
  },
  {
    type: 'Currency',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateQuoteCurrency',
    id: 42746,
    abbrName: 'QteCcy',
    description:
      'Specifies the currency the return rate quote is denominated in. Uses ISO 4217 Currency Code.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateQuoteCurrencyType',
    id: 42747,
    abbrName: 'QteCcyTyp',
    description:
      'Specifies the type of currency, e.g. settlement currency, base currency, etc., that the quote is reported in.\n\nSee http://www.fpml.org/coding-scheme/reporting-currency-type for values.',
  },
  {
    type: 'ReturnRateQuoteTimeTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateQuoteTimeType',
    id: 42748,
    abbrName: 'QteTmTyp',
    description: 'Specifies how or the timing when the quote is to be obtained.',
  },
  {
    type: 'LocalMktTime',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateQuoteTime',
    id: 42749,
    abbrName: 'QteTm',
    description: 'The time when the quote is to be generated.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateQuoteDate',
    id: 42750,
    abbrName: 'QteDt',
    description: 'The date when the quote is to be generated.',
  },
  {
    type: 'LocalMktTime',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateQuoteExpirationTime',
    id: 42751,
    abbrName: 'QteExpTm',
    description: 'The time when the quote ceases to be valid.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateQuoteBusinessCenter',
    id: 42752,
    abbrName: 'QteBizCtr',
    description:
      'The business center calendar used for adjustments associated with ReturnRateQuoteTimeType(42748) or ReturnRateQuoteTime(42749) and ReturnRateQuoteDate(42750), e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'Exchange',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateQuoteExchange',
    id: 42753,
    abbrName: 'QteExch',
    description:
      'Specifies the exchange (e.g. stock or listed futures/options exchange) from which the quote is obtained.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateQuotePricingModel',
    id: 42754,
    abbrName: 'QteModel',
    description:
      'Specifies the pricing model used to evaluate the underlying asset price.\n\nSee http://www.fpml.org/coding-scheme/pricing-model for values.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateCashFlowType',
    id: 42755,
    abbrName: 'CshFlow',
    description:
      'Specifies the type of cash flows, e.g. coupon payment, premium fee, settlement fee, etc.\n\nSee http://www.fpml.org/coding-scheme/cashflow-type for values.',
  },
  {
    type: 'ReturnRateQuoteTimeTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateValuationTimeType',
    id: 42756,
    abbrName: 'ValTmTyp',
    description:
      'Specifies the timing at which the calculation agent values the underlying.',
  },
  {
    type: 'LocalMktTime',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateValuationTime',
    id: 42757,
    abbrName: 'ValTm',
    description: 'The time at which the calculation agent values the underlying asset.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateValuationTimeBusinessCenter',
    id: 42758,
    abbrName: 'ValTmBizCtr',
    description:
      'The business center calendar used for adjustments associated with ReturnRateValuationTimeType(42756) or ReturnRateValuationTime(42757), e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'ReturnRateValuationPriceOptionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateValuationPriceOption',
    id: 42759,
    abbrName: 'ValPxOpt',
    description:
      'Indicates whether an ISDA price option applies, and if applicable which type of price.',
  },
  {
    type: 'ComplexEventPVFinalPriceElectionFallbackCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateFinalPriceFallback',
    id: 42760,
    abbrName: 'FnlPxFallbck',
    description:
      'Specifies the fallback provision for the hedging party in the determination of the final price.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoReturnRateInformationSources',
    id: 42761,
    description:
      'Number of iterations in the return rate information source repeating group.',
  },
  {
    type: 'RateSourceCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateInformationSource',
    id: 42762,
    abbrName: 'RtSrc',
    description:
      'Identifies the source of rate information. For FX the references source to be used for the FX spot rate.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateReferencePage',
    id: 42763,
    abbrName: 'RefPg',
    description:
      'Identifies the reference "page" from the rate source.\n\nFor FX, the reference page to the spot rate to be used for the reference FX spot rate.\n\nWhen ReturnRateInformationSource(42762) = 3 (ISDA Settlement Rate Option) this contains the value from the scheme that reflects the terms of the Annex A to the ISDA 1998 FX and Currency Option Definitions.\n\nSee: http://www.fpml.org/coding-scheme/settlement-rate-option',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateReferencePageHeading',
    id: 42764,
    abbrName: 'RefHdng',
    description: 'Identifies the page heading from the rate source.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoReturnRatePrices',
    id: 42765,
    description: 'Number of iterations in the return rate price repeating group.',
  },
  {
    type: 'ReturnRatePriceBasisCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRatePriceBasis',
    id: 42766,
    abbrName: 'PxBasis',
    description: 'The basis of the return price.',
  },
  {
    type: 'Price',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRatePrice',
    id: 42767,
    abbrName: 'Px',
    description: 'Specifies the price of the underlying swap asset.',
  },
  {
    type: 'Currency',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRatePriceCurrency',
    id: 42768,
    abbrName: 'Ccy',
    description:
      'Specifies the currency of the price of the underlying swap asset. Uses ISO 4217 currency codes.',
  },
  {
    type: 'ReturnRatePriceTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRatePriceType',
    id: 42769,
    abbrName: 'PxTyp',
    description:
      'Specifies whether the ReturnRatePrice(42767) is expressed in absolute or relative terms.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoReturnRateValuationDateBusinessCenters',
    id: 42770,
    description:
      'Number of iterations in the return rate valuation date business center repeating group.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateValuationDateBusinessCenter',
    id: 42771,
    abbrName: 'Ctr',
    description:
      'The business center calendar used for date adjustment of the return rate valuation unadjusted or relative dates, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoReturnRateValuationDates',
    id: 42772,
    description:
      'Number of iterations in the return rate valuation date repeating group.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateValuationDate',
    id: 42773,
    abbrName: 'Dt',
    description:
      'The return rate valuation date. Type of date is specified in ReturnRateValuationDateType(42774).',
  },
];

const batch8: ISpecFields[] = [
  {
    type: 'NonDeliverableFixingDateTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'ReturnRateValuationDateType',
    id: 42774,
    abbrName: 'Typ',
    description:
      'Specifies the type of return rate valuation date (e.g. adjusted for holidays).',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoSettlMethodElectionDateBusinessCenters',
    id: 42775,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'SettlMethodElectionDateBusinessCenter',
    id: 42776,
    abbrName: 'Ctr',
    description:
      'The business center calendar used for date adjustment of the settlement method election unadjusted or relative date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'SettlMethodElectionDateUnadjusted',
    id: 42777,
    abbrName: 'DtUnadj',
    description: 'The unadjusted settlement method election date.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'SettlMethodElectionDateBusinessDayConvention',
    id: 42778,
    abbrName: 'BizDayCnvtn',
    description:
      'The settlement method election date adjustment business day convention.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'SettlMethodElectionDateRelativeTo',
    id: 42779,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the settlement method election date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'SettlMethodElectionDateOffsetPeriod',
    id: 42780,
    abbrName: 'OfstPeriod',
    description:
      'Time unit multiplier for the relative settlement method election date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'SettlMethodElectionDateOffsetUnit',
    id: 42781,
    abbrName: 'OfstUnit',
    description:
      'Time unit associated with the relative settlement method election date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'SettlMethodElectionDateOffsetDayType',
    id: 42782,
    abbrName: 'OfstDayTyp',
    description:
      'Specifies the day type of the relative settlement method election date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'SettlMethodElectionDateAdjusted',
    id: 42783,
    abbrName: 'Dt',
    description: 'The adjusted settlement method election date.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'StreamVersion',
    id: 42784,
    abbrName: 'Ver',
    description:
      'The stream version identifier when there have been modifications to the contract over time. Helps signal when there are embedded changes.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'StreamVersionEffectiveDate',
    id: 42785,
    abbrName: 'VerEfctvDt',
    description: 'The effective date of the StreamVersion(42784).',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'StreamNotionalDeterminationMethod',
    id: 42786,
    abbrName: 'NotlDtrmnMeth',
    description:
      'Specifies the method for determining the floating notional value for equity swaps.\n\nSee http://www.fpml.org/coding-scheme/determination-method for values.',
  },
  {
    type: 'StreamNotionalAdjustmentsCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'StreamNotionalAdjustments',
    id: 42787,
    abbrName: 'NotlAdjmts',
    description:
      'For equity swaps this specifies the conditions that govern the adjustment to the number of units of the swap.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingCashSettlDateBusinessCenters',
    id: 42788,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingCashSettlDateBusinessCenter',
    id: 42789,
    abbrName: 'Ctr',
    description:
      'The business center calendar used for date adjustment of the cash settlement unadjusted or relative date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingCashSettlDateUnadjusted',
    id: 42790,
    abbrName: 'DtUnadj',
    description: 'The unadjusted cash settlement date.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingCashSettlDateBusinessDayConvention',
    id: 42791,
    abbrName: 'BizDayCnvtn',
    description:
      "The business day convention used to adjust the cash settlement provision's date. Used only to override the business day convention defined in the UnderlyingInstrument component.",
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingCashSettlDateRelativeTo',
    id: 42792,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the cash settlement date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingCashSettlDateOffsetPeriod',
    id: 42793,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative cash settlement date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingCashSettlDateOffsetUnit',
    id: 42794,
    abbrName: 'OfstUnit',
    description: 'Time unit associated with the relative cash settlement date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingCashSettlDateOffsetDayType',
    id: 42795,
    abbrName: 'OfstDayTyp',
    description: 'Specifies the day type of the relative cash settlement date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingCashSettlDateAdjusted',
    id: 42796,
    abbrName: 'Dt',
    description: 'The adjusted cash settlement date.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingCashSettlPriceSource',
    id: 42797,
    abbrName: 'PxSrc',
    description:
      'The source from which the settlement price is to be obtained.\n\nSee http://www.fpml.org/coding-scheme/settlement-price-source for values.',
  },
  {
    type: 'CashSettlPriceDefaultCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingCashSettlPriceDefault',
    id: 42798,
    abbrName: 'PxDflt',
    description: 'The default election for determining settlement price.',
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventFuturesPriceValuation',
    id: 2611,
    abbrName: 'FutPxVal',
    description:
      'Indicates whether the official settlement price as announced by the related exchange is applicable, in accordance with the ISDA 2002 definitions. Applicable only to futures contracts.',
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventOptionsPriceValuation',
    id: 2612,
    abbrName: 'OptPxVal',
    description:
      'Indicates whether the official settlement price as announced by the related exchange is applicable, in accordance with the ISDA 2002 definitions. Applicable only to options contracts.',
  },
  {
    type: 'ComplexEventPVFinalPriceElectionFallbackCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingComplexEventPVFinalPriceElectionFallback',
    id: 2613,
    abbrName: 'PVPxFallbck',
    description:
      'Specifies the fallback provisions for the hedging party in the determination of the final settlement price',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingDividendAccrualPaymentDateBusinessCenters',
    id: 42799,
    description:
      'Number of entries in the UnderlyingDividendAccrualPaymentDateBusinessCenterGrp.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendAccrualPaymentDateBusinessCenter',
    id: 42800,
    abbrName: 'Ctr',
    description:
      'The business center calendar used for date adjustment of the instrument\'s dividend accrual payment date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendFloatingRateIndex',
    id: 42801,
    abbrName: 'Ndx',
    description: 'The dividend accrual floating rate index.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendFloatingRateIndexCurvePeriod',
    id: 42802,
    abbrName: 'NdxPeriod',
    description:
      'Time unit multiplier for the dividend accrual floating rate index curve.',
  },
  {
    type: 'PaymentStreamRateIndexCurveUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendFloatingRateIndexCurveUnit',
    id: 42803,
    abbrName: 'NdxUnit',
    description:
      'Time unit associated with the dividend accrual floating rate index curve period.',
  },
  {
    type: 'float',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendFloatingRateMultiplier',
    id: 42804,
    abbrName: 'RtMult',
    description:
      'A rate multiplier to apply to the floating rate. The multiplier can be less than or greater than 1 (one). This should only be included if the multiplier is not equal to 1 (one) for the term of the contract.',
  },
  {
    type: 'PriceOffset',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendFloatingRateSpread',
    id: 42805,
    abbrName: 'Spread',
    description:
      'The basis points spread from the index specified in UnderlyingDividendFloatingRateIndex(42801).',
  },
  {
    type: 'PaymentStreamRateSpreadPositionTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendFloatingRateSpreadPositionType',
    id: 42806,
    abbrName: 'SpreadPosTyp',
    description:
      'Identifies whether the rate spread is applied to a long or short position.',
  },
  {
    type: 'PaymentStreamRateTreatmentCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendFloatingRateTreatment',
    id: 42807,
    abbrName: 'RtTrtmt',
    description: 'Specifies the yield calculation treatment for the index.',
  },
  {
    type: 'Percentage',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendCapRate',
    id: 42808,
    abbrName: 'CapRt',
    description:
      'The cap rate, if any, which applies to the floating rate. It is only required where the floating rate is capped at a certain level. The cap rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A cap rate of 5% would be represented as "0.05".',
  },
  {
    type: 'PaymentStreamCapRateBuySideCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendCapRateBuySide',
    id: 42809,
    abbrName: 'CapRtBuy',
    description: 'Reference to the buyer of the cap rate option through its trade side.',
  },
  {
    type: 'PaymentStreamCapRateBuySideCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendCapRateSellSide',
    id: 42810,
    abbrName: 'CapRtSell',
    description: 'Reference to the seller of the cap rate option through its trade side.',
  },
  {
    type: 'Percentage',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendFloorRate',
    id: 42811,
    abbrName: 'FlrRt',
    description:
      'The floor rate, if any, which applies to the floating rate. The floor rate (strike) is only required where the floating rate is floored at a certain strike level. The floor rate is assumed to be exclusive of any spread and is a per annum rate. The rate is expressed as a decimal, e.g. 5% is represented as "0.05".',
  },
  {
    type: 'PaymentStreamFloorRateBuySideCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendFloorRateBuySide',
    id: 42812,
    abbrName: 'FlrRtBuy',
    description:
      'Reference to the buyer of the floor rate option through its trade side.',
  },
  {
    type: 'PaymentStreamFloorRateBuySideCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendFloorRateSellSide',
    id: 42813,
    abbrName: 'FlrRtSell',
    description:
      'Reference to the seller of the floor rate option through its trade side.',
  },
  {
    type: 'Percentage',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendInitialRate',
    id: 42814,
    abbrName: 'InitRt',
    description:
      'The initial floating rate reset agreed between the principal parties involved in the trade. This is assumed to be the first required reset rate for the first regular calculation period. It should only be included when the rate is not equal to the rate published on the source implied by the floating rate index. The initial rate is expressed in decimal form, e.g. 5% is represented as "0.05".',
  },
  {
    type: 'RoundingDirectionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendFinalRateRoundingDirection',
    id: 42815,
    abbrName: 'FnlRtRndDirctn',
    description: 'Specifies the rounding direction of the final rate.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendFinalRatePrecision',
    id: 42816,
    abbrName: 'FnlRtPrcsn',
    description:
      'Specifies the rounding precision of the final rate in terms of a number of decimal places. Note how a percentage rate rounding of 5 decimal places is expressed as a rounding precision of 7.',
  },
  {
    type: 'PaymentStreamAveragingMethodCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendAveragingMethod',
    id: 42817,
    abbrName: 'AvgngMeth',
    description:
      'When averaging is applicable, used to specify whether a weighted or unweighted average method of calculation is to be used.',
  },
  {
    type: 'PaymentStreamNegativeRateTreatmentCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendNegativeRateTreatment',
    id: 42818,
    abbrName: 'NegtvRtTrtmt',
    description:
      'The specification of any provisions for calculating payment obligations when a floating rate is negative (either due to a quoted negative floating rate or by operation of a spread that is subtracted from the floating rate).',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendAccrualPaymentDateRelativeTo',
    id: 42819,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the accrual payment date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendAccrualPaymentDateOffsetPeriod',
    id: 42820,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative accrual payment date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendAccrualPaymentDateOffsetUnit',
    id: 42821,
    abbrName: 'OfstUnit',
    description: 'Time unit associated with the relative accrual payment date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendAccrualPaymentDateOffsetDayType',
    id: 42822,
    abbrName: 'OfstDayTyp',
    description: 'Specifies the day type of the relative accrual payment date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendAccrualPaymentDateUnadjusted',
    id: 42823,
    abbrName: 'DtUnadj',
    description: 'The unadjusted accrual payment date.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendAccrualPaymentDateBusinessDayConvention',
    id: 42824,
    abbrName: 'BizDayCnvtn',
    description: 'Accrual payment date adjustment business day convention.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendAccrualPaymentDateAdjusted',
    id: 42825,
    abbrName: 'Dt',
    description: 'The adjusted accrual payment date.',
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendReinvestmentIndicator',
    id: 42826,
    abbrName: 'RnvstmntInd',
    description: 'Indicates whether the dividend will be reinvested.',
  },
  {
    type: 'DividendEntitlementEventCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendEntitlementEvent',
    id: 42827,
    abbrName: 'EntlmntEvnt',
    description:
      'Defines the contract event which the receiver of the derivative is entitled to the dividend.',
  },
  {
    type: 'DividendAmountTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendAmountType',
    id: 42828,
    abbrName: 'AmtTyp',
    description: 'Indicates how the gross cash dividend amount per share is determined.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendUnderlierRefID',
    id: 42829,
    abbrName: 'UndlrRefID',
    description:
      "References the dividend underlier through the instrument's UnderlyingSecurityID(309) which must be fully specified in a separate instance of the UnderlyingInstrument component.",
  },
  {
    type: 'PaymentStreamCapRateBuySideCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingExtraordinaryDividendPartySide',
    id: 42830,
    abbrName: 'ExtrordSide',
    description:
      'Reference to the party through its side in the trade who makes the determination whether dividends are extraordinary in relation to normal levels.',
  },
  {
    type: 'DividendAmountTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingExtraordinaryDividendAmountType',
    id: 42831,
    abbrName: 'ExtrordAmtTyp',
    description:
      'Indicates how the extraordinary gross cash dividend per share is determined.',
  },
  {
    type: 'Currency',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingExtraordinaryDividendCurrency',
    id: 42832,
    abbrName: 'ExtrordCcy',
    description:
      'The currency in which the excess dividend is denominated. Uses ISO 4217 currency codes.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingExtraordinaryDividendDeterminationMethod',
    id: 42833,
    abbrName: 'ExtrordDtrmnMeth',
    description:
      'Specifies the method in which the excess amount is determined.\n\nSee http://www.fpml.org/coding-scheme/determination-method for values.',
  },
  {
    type: 'Percentage',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendAccrualFixedRate',
    id: 42834,
    abbrName: 'AcrlFixedRt',
    description:
      'The dividend accrual fixed rate per annum expressed as a decimal.\n\nA value of 5% would be represented as "0.05".',
  },
  {
    type: 'PaymentStreamCompoundingMethodCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendCompoundingMethod',
    id: 42835,
    abbrName: 'CmpndgMeth',
    description:
      'The compounding method to be used when more than one dividend period contributes to a single payment.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendNumOfIndexUnits',
    id: 42836,
    abbrName: 'NumNdxUnits',
    description: 'The number of index units applicable to dividends.',
  },
  {
    type: 'Percentage',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendCashPercentage',
    id: 42837,
    abbrName: 'CshPctage',
    description:
      'Declared cash dividend percentage.\n\nA value of 5% would be represented as "0.05".',
  },
  {
    type: 'Percentage',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendCashEquivalentPercentage',
    id: 42838,
    abbrName: 'CshEqvlntPctage',
    description:
      'Declared cash-equivalent dividend percentage. A value of 5% would be represented as "0.05".',
  },
  {
    type: 'NonCashDividendTreatmentCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingNonCashDividendTreatment',
    id: 42839,
    abbrName: 'NonCshTrtmt',
    description: 'Defines the treatment of non-cash dividends.',
  },
  {
    type: 'DividendCompositionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendComposition',
    id: 42840,
    abbrName: 'Cmpstn',
    description: 'Defines how the composition of dividends is to be determined.',
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingSpecialDividendsIndicator',
    id: 42841,
    abbrName: 'SpeclDividendInd',
    description: 'Indicates whether special dividends are applicable.',
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingMaterialDividendsIndicator',
    id: 42842,
    abbrName: 'MtrlDividendInd',
    description: 'Indicates whether material non-cash dividends are applicable.',
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingOptionsExchangeDividendsIndicator',
    id: 42843,
    abbrName: 'ExchDividendInd',
    description: 'Indicates whether option exchange dividends are applicable.',
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingAdditionalDividendsIndicator',
    id: 42844,
    abbrName: 'AddtnlDividendInd',
    description: 'Indicates whether additional dividends are applicable.',
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingAllDividendsIndicator',
    id: 42845,
    abbrName: 'AllDividendInd',
    description:
      "Represents the European Master Confirmation value of 'All Dividends' which, when applicable, signifies that, for a given Ex-Date, the daily observed share price for that day is adjusted (reduced) by the cash dividend and/or the cash value of any non-cash dividend per share (including extraordinary dividends) declared by the issuer.",
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendFXTriggerDateRelativeTo',
    id: 42846,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the FX trigger date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendFXTriggerDateOffsetPeriod',
    id: 42847,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative FX trigger date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendFXTriggerDateOffsetUnit',
    id: 42848,
    abbrName: 'OfstUnit',
    description: 'Time unit associated with the relative FX trigger date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendFXTriggerDateOffsetDayType',
    id: 42849,
    abbrName: 'OfstDayTyp',
    description: 'Specifies the day type of the relative FX trigger date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendFXTriggerDateUnadjusted',
    id: 42850,
    abbrName: 'DtUnadj',
    description: 'The unadjusted FX trigger date.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendFXTriggerDateBusinessDayConvention',
    id: 42851,
    abbrName: 'BizDayCnvtn',
    description: 'The business day convention used for the FX trigger date adjustment.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendFXTriggerDateAdjusted',
    id: 42852,
    abbrName: 'Dt',
    description: 'The adjusted FX trigger date.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingDividendFXTriggerDateBusinessCenters',
    id: 42853,
    description:
      'Number of entries in the UnderlyingDividendFXTriggerDateBusinessCenterGrp.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendFXTriggerDateBusinessCenter',
    id: 42854,
    abbrName: 'Ctr',
    description:
      'The business center calendar used for date adjustment of the instrument\'s FX trigger date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingDividendPayments',
    id: 42855,
    description: 'Number of entries in the repeating group.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendPaymentDate',
    id: 42856,
    abbrName: 'Dt',
    description: 'Specifies the date that the dividend or coupon payment is due.',
  },
  {
    type: 'Amt',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendPaymentAmount',
    id: 42857,
    abbrName: 'Amt',
    description: 'The amount of the dividend or coupon payment.',
  },
  {
    type: 'Currency',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendPaymentCurrency',
    id: 42858,
    abbrName: 'Ccy',
    description:
      'Specifies the currency the UnderlyingDividendPaymentAmount(42857) is denominated in. Uses ISO 4217 currency codes.',
  },
  {
    type: 'Amt',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendAccruedInterest',
    id: 42859,
    abbrName: 'AcrdInt',
    description: 'Accrued interest on the dividend or coupon payment.',
  },
  {
    type: 'float',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendPayoutRatio',
    id: 42860,
    abbrName: 'Ratio',
    description:
      'Specifies the actual dividend payout ratio associated with the equity or bond underlier.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendPayoutConditions',
    id: 42861,
    abbrName: 'Conds',
    description:
      'Specifies the dividend payout conditions that will be applied in the case where the actual ratio is not known, typically because of regulatory or legal uncertainties.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingDividendPeriods',
    id: 42862,
    description: 'Number of entries in the UnderlyingDividendPeriodGrp component.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendPeriodSequence',
    id: 42863,
    abbrName: 'Seq',
    description:
      'Defines the ordinal dividend period. E.g. 1 = First period, 2 = Second period, etc.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendPeriodStartDateUnadjusted',
    id: 42864,
    abbrName: 'StartDtUnadj',
    description: 'The unadjusted date on which the dividend period will begin.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendPeriodEndDateUnadjusted',
    id: 42865,
    abbrName: 'EndDtUnadj',
    description: 'The unadjusted date on which the dividend period will end.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendPeriodUnderlierRefID',
    id: 42866,
    abbrName: 'UndlrRefID',
    description:
      "References the dividend underlier through the instrument's UnderlyingSecurityID(309) which must be fully specified in an instance of the UnderlyingInstrument component.",
  },
  {
    type: 'Price',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendPeriodStrikePrice',
    id: 42867,
    abbrName: 'StrkPx',
    description: 'Specifies the fixed strike price of the dividend period.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendPeriodBusinessDayConvention',
    id: 42868,
    abbrName: 'BizDayCnvtn',
    description: 'The dividend period dates business day convention.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendPeriodValuationDateUnadjusted',
    id: 42869,
    abbrName: 'ValDtUnadj',
    description: 'The unadjusted dividend period valuation date.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendPeriodValuationDateRelativeTo',
    id: 42870,
    abbrName: 'ValDtReltv',
    description:
      'Specifies the anchor date when the dividend period valuation date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendPeriodValuationDateOffsetPeriod',
    id: 42871,
    abbrName: 'ValDtOfstPeriod',
    description:
      'Time unit multiplier for the relative dividend period valuation date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendPeriodValuationDateOffsetUnit',
    id: 42872,
    abbrName: 'ValDtOfstUnit',
    description:
      'Time unit associated with the relative dividend period valuation date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendPeriodValuationDateOffsetDayType',
    id: 42873,
    abbrName: 'ValDtOfstDayTyp',
    description:
      'Specifies the day type of the relative dividend period valuation date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendPeriodValuationDateAdjusted',
    id: 42874,
    abbrName: 'ValDt',
    description: 'The adjusted dividend period valuation date.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendPeriodPaymentDateUnadjusted',
    id: 42875,
    abbrName: 'PmtDtUnadj',
    description: 'The unadjusted dividend period payment date.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendPeriodPaymentDateRelativeTo',
    id: 42876,
    abbrName: 'PmtDtReltv',
    description:
      'Specifies the anchor date when the dividend period payment date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendPeriodPaymentDateOffsetPeriod',
    id: 42877,
    abbrName: 'PmtDtOfstPeriod',
    description:
      'Time unit multiplier for the relative dividend period payment date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendPeriodPaymentDateOffsetUnit',
    id: 42878,
    abbrName: 'PmtDtOfstUnit',
    description:
      'Time unit associated with the relative dividend period payment date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendPeriodPaymentDateOffsetDayType',
    id: 42879,
    abbrName: 'PmtDtOfstDayTyp',
    description:
      'Specifies the day type of the relative dividend period payment date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendPeriodPaymentDateAdjusted',
    id: 42880,
    abbrName: 'PmtDt',
    description: 'The adjusted dividend period payment date.',
  },
  {
    type: 'XID',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendPeriodXID',
    id: 42881,
    abbrName: 'XID',
    description:
      'Identifier for linking this stream dividend period to an underlier through an instance of RelatedInstrumentGrp.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingDividendPeriodBusinessCenters',
    id: 42882,
    description: 'Number of entries in UnderlyingDividendPeriodBusinessCenterGrp.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDividendPeriodBusinessCenter',
    id: 42883,
    abbrName: 'Ctr',
    description:
      'The business center calendar used for date adjustment of the instrument\'s dividend period date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingExtraordinaryEvents',
    id: 42884,
    description: 'Number of extraordinary events in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingExtraordinaryEventType',
    id: 42885,
    abbrName: 'Typ',
    description:
      'Identifies the type of extraordinary or disruptive event applicable to UnderlyingExtraordinaryEventType(42885).\n\nSee http://www.fixtradingcommunity.org/codelists#Extraordinary_Event_Type for code list of extraordinary event types and values.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingExtraordinaryEventValue',
    id: 42886,
    abbrName: 'Val',
    description:
      'The extraordinary or disruptive event value appropriate to UnderlyingExtraordinaryEventType(42885).\n\nSee http://www.fixtradingcommunity.org/codelists#Extraordinary_Event_Type for code list of extraordinary event types and values.',
  },
  {
    type: 'Amt',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingNotional',
    id: 2614,
    abbrName: 'Notl',
    description: 'Notional value for the equity or bond underlier.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Currency',
    addedEP: '208',
    updatedEP: '273',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingNotionalCurrency',
    id: 2615,
    abbrName: 'NotlCcy',
    description:
      'Specifies the currency denomination of the notional value.\n\nUnderlyingNotionalCurrencyCodeSource(2921) may be used to disambiguate the code source scheme used, and ISO 4217 is the default scheme if absent.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingNotionalDeterminationMethod',
    id: 2616,
    abbrName: 'NotlDtrmnMeth',
    description:
      'Specifies the method of determining the notional amount.\n\nSee: http://www.fpml.org/coding-scheme/determination-method for values.',
  },
  {
    type: 'UnderlyingNotionalAdjustmentsCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingNotionalAdjustments',
    id: 2617,
    abbrName: 'NotlAdjmts',
    description:
      'Specifies the conditions that govern the adjustment to the number of units of the return swap.',
  },
  {
    type: 'XIDREF',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingNotionalXIDRef',
    id: 2619,
    abbrName: 'NotlXIDRef',
    description:
      'Cross reference to another notional amount for duplicating its properties.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingFutureID',
    id: 2620,
    abbrName: 'FutID',
    discriminatorId: '2621',
    description:
      'In the case of an index underlier specifies the unique identifier for the referenced futures contract.',
  },
  {
    type: 'SecurityIDSourceCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingFutureIDSource',
    id: 2621,
    abbrName: 'FutIDSrc',
    description: 'Identifies the source of the UnderlyingFutureID(2620).',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStrikeIndexCurvePoint',
    id: 2622,
    abbrName: 'StrkNdxPnt',
    description:
      'The point on the floating rate index curve. Sample values:\n\nM = combination of a number between 1-12 and an "M" for month, e.g. 3M\n\nY = combination of number between 1-100 and a "Y" for year, e.g. 10Y\n\n10Y-OLD = see above, then add "-OLD" when appropriate\n\nINTERPOLATED = the point is mathematically derived\n\n2/2031 5 3/8 = the point is stated via a combination of maturity month / year and coupon.',
  },
  {
    type: 'StrikeIndexQuoteCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStrikeIndexQuote',
    id: 2623,
    abbrName: 'StrkNdxQte',
    description: 'The quote side from which the index price is to be determined.',
  },
  {
    type: 'ExtraordinaryEventAdjustmentMethodCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingExtraordinaryEventAdjustmentMethod',
    id: 2624,
    abbrName: 'ExtrordEvntAdjMeth',
    description:
      'Defines how adjustments will be made to the contract should one or more of the extraordinary events occur.',
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingExchangeLookAlike',
    id: 2625,
    abbrName: 'ExchLookAlike',
    description:
      "For a share option trade, indicates whether the instrument is to be treated as an 'exchange look-alike'.\n\nThis designation has significance for how share adjustments (arising from corporate actions) will be determined for the instrument. For an 'exchange look-alike' instrument the relevant share adjustments will follow that for a corresponding designated contract listed on the related exchange (referred to as Options Exchange Adjustment (ISDA defined term)), otherwise the share adjustments will be determined by the calculation agent (referred to as Calculation Agent Adjustment (ISDA defined term)).",
  },
  {
    type: 'Amt',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingAverageVolumeLimitationPercentage',
    id: 2626,
    abbrName: 'AvgLmtPctg',
    description:
      'The limit of average percentage of individual securities traded in a day or a number of days.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingAverageVolumeLimitationPeriodDays',
    id: 2627,
    abbrName: 'AvgLmtDys',
    description:
      'Specifies the limitation period for average daily trading volume in number of days.',
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDepositoryReceiptIndicator',
    id: 2628,
    abbrName: 'DpstryRcptInd',
    description:
      'Indicates whether the underlier is a depository receipt.\n\nA depository receipt is a negotiable certificate issued by a trust company or security depository.',
  },
  {
    type: 'Qty',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingOpenUnits',
    id: 2629,
    abbrName: 'OpnUnits',
    description:
      'The number of units (units of the index or number of securities, par amount of a bond) that constitute the underlier. In the case of a basket swap, this is used to reference both the number of basket units, and the number of each asset components of the basket when these are expressed in absolute terms.',
  },
  {
    type: 'float',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingBasketDivisor',
    id: 2630,
    abbrName: 'BsktDvsr',
    description:
      'Specifies the basket divisor amount. This value is normally used to adjust the constituent weight for pricing or to adjust for dividends, or other corporate actions.',
  },
  {
    type: 'XID',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingInstrumentXID',
    id: 2631,
    abbrName: 'XID',
    description:
      'Identifier for referencing this UnderlyingInstrument from a parent instrument or a convertible instrument.',
  },
  {
    type: 'PaymentPaySideCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingSettlMethodElectingPartySide',
    id: 42887,
    abbrName: 'SettlMethElctngSide',
    description: 'Side value of the party electing the settlement method.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingMakeWholeDate',
    id: 42888,
    abbrName: 'Dt',
    description: 'The date through which the option cannot be exercised without penalty.',
  },
  {
    type: 'Amt',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingMakeWholeAmount',
    id: 42889,
    abbrName: 'Amt',
    description:
      'Amount to be paid by the buyer of the option if the option is exercised prior to the UnderlyingMakeWholeDate(42888).',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingMakeWholeBenchmarkCurveName',
    id: 42890,
    abbrName: 'Name',
    description: 'Identifies the benchmark floating rate index.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingMakeWholeBenchmarkCurvePoint',
    id: 42891,
    abbrName: 'Point',
    description:
      'The point on the floating rate index curve.\n\nSample values:\n\nM = combination of a number between 1-12 and an "M" for month, e.g. 3M\n\nY = combination of number between 1-100 and a "Y" for year, e.g. 10Y\n\n10Y-OLD = see above, then add "-OLD" when appropriate\n\nINTERPOLATED = the point is mathematically derived\n\n2/2031 5 3/8 = the point is stated via a combination of maturity month / year and coupon.',
  },
  {
    type: 'PriceOffset',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingMakeWholeRecallSpread',
    id: 42892,
    abbrName: 'Spread',
    description: 'Spread over the floating rate index.',
  },
  {
    type: 'StrikeIndexQuoteCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingMakeWholeBenchmarkQuote',
    id: 42893,
    abbrName: 'Qte',
    description:
      'The quote side of the benchmark to be used for calculating the "make whole" amount.',
  },
  {
    type: 'PaymentStreamInflationInterpolationMethodCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingMakeWholeInterpolationMethod',
    id: 42894,
    abbrName: 'IntrpltnMeth',
    description:
      'The method used when calculating the "make whole" amount. The most common is linear method.',
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCashSettlIndicator',
    id: 42895,
    abbrName: 'CshSettlInd',
    description: 'Indicates whether cash settlement is applicable.',
  },
  {
    type: 'XIDREF',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingXIDRef',
    id: 42896,
    abbrName: 'CmpndgXIDRef',
    description:
      'Reference to the stream which details the compounding fixed or floating rate.',
  },
  {
    type: 'PriceOffset',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingSpread',
    id: 42897,
    abbrName: 'CmpndgSpread',
    description:
      'The spread to be used for compounding. Used in scenarios where the interest payment is based on a compounding formula that uses a compounding spread in addition to the regular spread.',
  },
  {
    type: 'PaymentStreamInflationInterpolationMethodCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamInterpolationMethod',
    id: 42898,
    abbrName: 'IntrpltnMeth',
    description:
      'The method used when calculating the index rate from multiple points on the curve. The most common is linear method.',
  },
  {
    type: 'PaymentStreamInterpolationPeriodCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamInterpolationPeriod',
    id: 42899,
    abbrName: 'IntrpltnPeriod',
    description: 'Defines applicable periods for interpolation.',
  },
  {
    type: 'float',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingFixedRate',
    id: 42900,
    abbrName: 'CmpndgFixedRt',
    description: 'The compounding fixed rate applicable to the payment stream.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingPaymentStreamCompoundingDates',
    id: 42901,
    description: 'Number of dates in the repeating group.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingDate',
    id: 42902,
    abbrName: 'Dt',
    description:
      'The compounding date. Type of date is specified in UnderlyingPaymentStreamCompoundingDateType(42903).',
  },
  {
    type: 'NonDeliverableFixingDateTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingDateType',
    id: 42903,
    abbrName: 'Typ',
    description:
      'Specifies the type of payment compounding date (e.g. adjusted for holidays).',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingDatesBusinessDayConvention',
    id: 42904,
    abbrName: 'BizDayCnvtn',
    description: 'The compounding dates business day convention.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingDatesRelativeTo',
    id: 42905,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the compounding dates are relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingDatesOffsetPeriod',
    id: 42906,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative compounding date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingDatesOffsetUnit',
    id: 42907,
    abbrName: 'OfstUnit',
    description: 'Time unit associated with the relative compounding date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingDatesOffsetDayType',
    id: 42908,
    abbrName: 'OfstDayTyp',
    description: 'Specifies the day type of the relative compounding date offset.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingPeriodSkip',
    id: 42909,
    abbrName: 'Skip',
    description:
      'The number of periods in the "RelativeTo" schedule that are between each date in the compounding schedule. A skip of 2 would mean that compounding dates are relative to every second date in the "RelativeTo" schedule. If present this should have a value greater than 1.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingFrequencyPeriod',
    id: 42910,
    abbrName: 'FreqPeriod',
    description:
      'Time unit multiplier for the frequency at which compounding dates occur.',
  },
  {
    type: 'CouponFrequencyUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingFrequencyUnit',
    id: 42911,
    abbrName: 'FreqUnit',
    description:
      'Time unit associated with the frequency at which compounding dates occur.',
  },
  {
    type: 'DateRollConventionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingRollConvention',
    id: 42912,
    abbrName: 'Roll',
    description:
      'The convention for determining the sequence of compounding dates. It is used in conjunction with a specified frequency.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamBoundsFirstDateUnadjusted',
    id: 42913,
    abbrName: 'FirstDtUnadj',
    description:
      'The unadjusted first date of the compounding schedule. This can be used to restrict the range of dates when they are relative.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamBoundsLastDateUnadjusted',
    id: 42914,
    abbrName: 'LastDtUnadj',
    description:
      'The unadjusted last date of the compounding schedule. This can be used to restrict the range of dates when they are relative.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingPaymentStreamCompoundingDatesBusinessCenters',
    id: 42915,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingDatesBusinessCenter',
    id: 42916,
    abbrName: 'Ctr',
    description:
      'The business center calendar used for date adjustment of the payment stream compounding dates, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingEndDateUnadjusted',
    id: 42917,
    abbrName: 'DtUnadj',
    description: 'The unadjusted compounding end date.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingEndDateRelativeTo',
    id: 42918,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the compounding end date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingEndDateOffsetPeriod',
    id: 42919,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative compounding end date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingEndDateOffsetUnit',
    id: 42920,
    abbrName: 'OfstUnit',
    description: 'Time unit associated with the relative compounding end date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingEndDateOffsetDayType',
    id: 42921,
    abbrName: 'OfstDayTyp',
    description: 'Specifies the day type of the relative compounding end date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingEndDateAdjusted',
    id: 42922,
    abbrName: 'Dt',
    description: 'The adjusted compounding end date.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingRateIndex',
    id: 42923,
    abbrName: 'Ndx',
    description: "The payment stream's compounding floating rate index.",
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingRateIndexCurvePeriod',
    id: 42924,
    abbrName: 'NdxPeriod',
    description:
      "Time unit multiplier for the payment stream's compounding floating rate index curve period.",
  },
  {
    type: 'PaymentStreamRateIndexCurveUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingRateIndexCurveUnit',
    id: 42925,
    abbrName: 'NdxUnit',
    description:
      "Time unit associated with the payment stream's compounding floating rate index curve period.",
  },
  {
    type: 'float',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingRateMultiplier',
    id: 42926,
    abbrName: 'RtMult',
    description:
      'A rate multiplier to apply to the compounding floating rate. The multiplier can be less than or greater than 1 (one). This should only be included if the multiplier is not equal to 1 (one) for the term of the stream.',
  },
  {
    type: 'PriceOffset',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingRateSpread',
    id: 42927,
    abbrName: 'Spread',
    description:
      'The basis points spread from the index specified in UnderlyingPaymentStreamCompoundingRateIndex(42923).',
  },
  {
    type: 'PaymentStreamRateSpreadPositionTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingRateSpreadPositionType',
    id: 42928,
    abbrName: 'SpreadPosTyp',
    description:
      'Identifies whether the rate spread is applied to a long or short position.',
  },
  {
    type: 'PaymentStreamRateTreatmentCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingRateTreatment',
    id: 42929,
    abbrName: 'RtTrtmt',
    description: 'Specifies the yield calculation treatment for the index.',
  },
  {
    type: 'Percentage',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingCapRate',
    id: 42930,
    abbrName: 'CapRt',
    description:
      'The cap rate, if any, which applies to the compounding floating rate. It is only required where the compounding floating rate on a swap stream is capped at a certain level. The cap rate is assumed to be exclusive of any spread and is a per annum rate, expressed as a decimal. A cap rate of 5% would be represented as "0.05".',
  },
  {
    type: 'PaymentStreamCapRateBuySideCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingCapRateBuySide',
    id: 42931,
    abbrName: 'CapRtBuy',
    description:
      'Reference to the buyer of the compounding cap rate option through its trade side.',
  },
  {
    type: 'PaymentStreamCapRateBuySideCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingCapRateSellSide',
    id: 42932,
    abbrName: 'CapRtSell',
    description:
      'Reference to the seller of the compounding cap rate option through its trade side.',
  },
  {
    type: 'Percentage',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingFloorRate',
    id: 42933,
    abbrName: 'FlrRt',
    description:
      'The floor rate, if any, which applies to the compounding floating rate. The floor rate (strike) is only required where the compounding floating rate on a swap stream is floored at a certain strike level. The floor rate is assumed to be exclusive of any spread and is a per annum rate. The rate is expressed as a decimal, e.g. 5% is represented as "0.05".',
  },
  {
    type: 'PaymentStreamFloorRateBuySideCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingFloorRateBuySide',
    id: 42934,
    abbrName: 'FlrRtBuy',
    description:
      'Reference to the buyer of the compounding floor rate option through its trade side.',
  },
  {
    type: 'PaymentStreamFloorRateBuySideCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingFloorRateSellSide',
    id: 42935,
    abbrName: 'FlrRtSell',
    description:
      'Reference to the seller of the floor rate option through its trade side.',
  },
  {
    type: 'Percentage',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingInitialRate',
    id: 42936,
    abbrName: 'InitRt',
    description:
      'The initial compounding floating rate reset agreed between the principal parties involved in the trade. It should only be included when the rate is not equal to the rate published on the source implied by the floating rate index. The initial rate is expressed in decimal form, e.g. 5% is represented as "0.05".',
  },
  {
    type: 'RoundingDirectionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingFinalRateRoundingDirection',
    id: 42937,
    abbrName: 'FnlRtRndDirctn',
    description: 'Specifies the rounding direction for the compounding floating rate.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingFinalRatePrecision',
    id: 42938,
    abbrName: 'FnlRtPrcsn',
    description:
      'Specifies the compounding floating rate rounding precision in terms of a number of decimal places. Note how a percentage rate rounding of 5 decimal places is expressed as a rounding precision of 7.',
  },
  {
    type: 'PaymentStreamAveragingMethodCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingAveragingMethod',
    id: 42939,
    abbrName: 'AvgngMeth',
    description:
      'Specifies the averaging method when compounding floating rate averaging is applicable (e.g. weighted or unweighted).',
  },
  {
    type: 'PaymentStreamNegativeRateTreatmentCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingNegativeRateTreatment',
    id: 42940,
    abbrName: 'NegtvRtTrtmt',
    description:
      'Specifies the method for calculating payment obligations when a compounding floating rate is negative (either due to a quoted negative floating rate or by operation of a spread that is subtracted from the floating rate).',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingStartDateUnadjusted',
    id: 42941,
    abbrName: 'DtUnadj',
    description: 'The unadjusted compounding start date.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingStartDateRelativeTo',
    id: 42942,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the compounding start date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingStartDateOffsetPeriod',
    id: 42943,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative compounding start date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingStartDateOffsetUnit',
    id: 42944,
    abbrName: 'OfstUnit',
    description: 'Time unit associated with the relative compounding start date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingStartDateOffsetDayType',
    id: 42945,
    abbrName: 'OfstDayTyp',
    description: 'Specifies the day type of the relative compounding start date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamCompoundingStartDateAdjusted',
    id: 42946,
    abbrName: 'Dt',
    description: 'The adjusted compounding start date.',
  },
  {
    type: 'Length',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFormulaImageLength',
    id: 42947,
    abbrName: 'FrmlaImgLen',
    description:
      'Length in bytes of the UnderlyingPaymentStreamFormulaImage(42948) field.',
  },
  {
    type: 'data',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFormulaImage',
    id: 42948,
    abbrName: 'FrmlaImg',
    lengthId: '42947',
    description:
      'Image of the formula image when represented through an encoded clip in base64Binary.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFinalPricePaymentDateUnadjusted',
    id: 42949,
    abbrName: 'DtUnadj',
    description: 'The unadjusted final price payment date.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFinalPricePaymentDateRelativeTo',
    id: 42950,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the final price payment date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFinalPricePaymentDateOffsetPeriod',
    id: 42951,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative final price payment date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFinalPricePaymentDateOffsetUnit',
    id: 42952,
    abbrName: 'OfstUnit',
    description:
      'Time unit associated with the relative final price payment date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFinalPricePaymentDateOffsetDayType',
    id: 42953,
    abbrName: 'OfstDayTyp',
    description:
      'Specifies the day type of the relative final price payment date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFinalPricePaymentDateAdjusted',
    id: 42954,
    abbrName: 'Dt',
    description: 'The adjusted final price payment date.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingPaymentStreamFixingDates',
    id: 42955,
    description: 'Number of fixing dates in the repeating group.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFixingDate',
    id: 42956,
    abbrName: 'Dt',
    description:
      'The fixing date. Type of date is specified in UnderlyingPaymentStreamFixingDateType(42957).',
  },
  {
    type: 'NonDeliverableFixingDateTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFixingDateType',
    id: 42957,
    abbrName: 'Typ',
    description: 'Specifies the type of fixing date (e.g. adjusted for holidays).',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFirstObservationDateUnadjusted',
    id: 42958,
    abbrName: 'FirstObsvtnDtUnadj',
    description: 'The unadjusted initial price observation date.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFirstObservationDateRelativeTo',
    id: 42959,
    abbrName: 'FirstObsvtnReltv',
    description:
      'Specifies the anchor date when the initial price observation date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFirstObservationDateOffsetDayType',
    id: 42960,
    abbrName: 'FirstObsvtnOfstDayTyp',
    description: 'Specifies the day type of the initial price observation date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFirstObservationDateAdjusted',
    id: 42961,
    abbrName: 'FirstObsvtnDt',
    description: 'The adjusted initial price observation date.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamUnderlierRefID',
    id: 42962,
    abbrName: 'UndlrRefID',
    description:
      "References the dividend underlier through the instrument's UnderlyingSecurityID(309) which must be fully specified in an instance of the UnderlyingInstrument component.",
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateNotionalReset',
    id: 42963,
    abbrName: 'RtnRtNotlReset',
    description:
      'Indicates whether the term "Equity Notional Reset" as defined in the ISDA 2002 Equity Derivatives Definitions is applicable ("Y") or not.',
  },
  {
    type: 'Price',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamLinkInitialLevel',
    id: 42964,
    abbrName: 'LinkInitLvl',
    description:
      'Price level at which the correlation or variance swap contract will strike.',
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamLinkClosingLevelIndicator',
    id: 42965,
    abbrName: 'LinkClsngLvl',
    description:
      'Indicates whether the correlation or variance swap contract will ("Y") strike off the closing level of the default exchange traded contract or not.',
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamLinkExpiringLevelIndicator',
    id: 42966,
    abbrName: 'LinkExpngLvl',
    description:
      'Indicates whether the correlation or variance swap contract will ("Y") strike off the expiring level of the default exchange traded contract or not.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamLinkEstimatedTradingDays',
    id: 42967,
    abbrName: 'LinkEstTrdgDays',
    description:
      'The expected number of trading days in the variance or correlation swap stream.',
  },
  {
    type: 'Price',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamLinkStrikePrice',
    id: 42968,
    abbrName: 'LinkStrkPx',
    description: 'The strike price of a correlation or variance swap stream.',
  },
  {
    type: 'PaymentStreamLinkStrikePriceTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamLinkStrikePriceType',
    id: 42969,
    abbrName: 'LinkStrkPxTyp',
    description:
      'For a variance swap specifies how UnderlyingPaymentStreamLinkStrikePrice(42968) is expressed.',
  },
  {
    type: 'float',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamLinkMaximumBoundary',
    id: 42970,
    abbrName: 'LinkMaxBndry',
    description:
      'Specifies the maximum or upper boundary for variance or strike determination.\n\nFor a variation swap stream all observations above this price level will be excluded from the variance calculation.\n\nFor a correlation swap stream the maximum boundary is a percentage of the strike price.',
  },
  {
    type: 'float',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamLinkMinimumBoundary',
    id: 42971,
    abbrName: 'LinkMinBndry',
    description:
      'Specifies the minimum or lower boundary for variance or strike determination.\n\nFor a variation swap stream all observations below this price level will be excluded from the variance calculation.\n\nFor a correlation swap stream the minimum boundary is a percentage of the strike price.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamLinkNumberOfDataSeries',
    id: 42972,
    abbrName: 'LinkNumDataSeries',
    description:
      'Number of data series for a correlation swap. Normal market practice is that correlation data sets are drawn from geographic market areas, such as America, Europe and Asia Pacific. Each of these geographic areas will have its own data series to avoid contagion.',
  },
  {
    type: 'float',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamVarianceUnadjustedCap',
    id: 42973,
    abbrName: 'VarncCap',
    description:
      'Indicates the scaling factor to be multiplied by the variance strike price thereby making variance cap applicable.',
  },
  {
    type: 'PaymentStreamRealizedVarianceMethodCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamRealizedVarianceMethod',
    id: 42974,
    abbrName: 'RlzdVarncMeth',
    description: 'Indicates which price to use to satisfy the boundary condition.',
  },
  {
    type: 'Boolean',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamDaysAdjustmentIndicator',
    id: 42975,
    abbrName: 'DaysAdjmt',
    description:
      'Indicates whether the contract specifies that the notional should be scaled by the number of days in range divided by the estimate trading days or not. The number of "days in range" refers to the number of returns that contribute to the realized volatility.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamNearestExchangeContractRefID',
    id: 42976,
    abbrName: 'ExchCtrctRefID',
    description:
      "References a contract listed on an exchange through the instrument's UnderlyingSecurityID(309) which must be fully specified in an instance of the UnderlyingInstrument component.",
  },
  {
    type: 'float',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamVegaNotionalAmount',
    id: 42977,
    abbrName: 'VegaNotlAmt',
    description:
      'Vega Notional represents the approximate gain/loss at maturity for a 1% difference between RVol (realised volatility) and KVol (strike volatility). It does not necessarily represent the Vega risk of the trade.',
  },
  {
    type: 'Currency',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFormulaCurrency',
    id: 42978,
    abbrName: 'Ccy',
    description:
      'The currency in which the formula amount is denominated. Uses ISO 4217 currency codes.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFormulaCurrencyDeterminationMethod',
    id: 42979,
    abbrName: 'CcyDtrmnMeth',
    description:
      'Specifies the method according to which the formula amount currency is determined.\n\nSee http://www.fpml.org/coding-scheme/determination-method for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFormulaReferenceAmount',
    id: 42980,
    abbrName: 'RefAmt',
    description:
      'Specifies the reference amount when this term either corresponds to the standard ISDA Definition (either the 2002 Equity Definition for the Equity Amount, or the 2000 Definition for the Interest Amount), or refers to a term defined elsewhere in the swap document.\n\nSee http://www.fixtradingcommunity.org/codelists#Payment_Amount_Relative_To for code list of reference amounts.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingPaymentStreamFormulas',
    id: 42981,
    description: 'Number of formulas in the repeating group.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'XMLData',
    addedEP: '208',
    updatedEP: '259',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFormula',
    id: 42982,
    abbrName: 'Frmla',
    lengthId: '43111',
    description:
      'Contains an XML representation of the formula. Defined for flexibility in choice of language (MathML, OpenMath or text).',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFormulaDesc',
    id: 42983,
    abbrName: 'Desc',
    description:
      'A description of the math formula in UnderlyingPaymentStreamFormula(42982).',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubEndDateUnadjusted',
    id: 42984,
    abbrName: 'DtUnadj',
    description: 'The unadjusted stub end date.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubEndDateBusinessDayConvention',
    id: 42985,
    abbrName: 'BizDayCnvtn',
    description: 'The stub end date business day convention.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubEndDateRelativeTo',
    id: 42986,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the stub end date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubEndDateOffsetPeriod',
    id: 42987,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative stub end date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubEndDateOffsetUnit',
    id: 42988,
    abbrName: 'OfstUnit',
    description: 'Time unit associated with the relative stub end date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubEndDateOffsetDayType',
    id: 42989,
    abbrName: 'OfstDayTyp',
    description: 'Specifies the day type of the relative stub end date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubEndDateAdjusted',
    id: 42990,
    abbrName: 'Dt',
    description: 'The adjusted stub end date.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingPaymentStubEndDateBusinessCenters',
    id: 42991,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubEndDateBusinessCenter',
    id: 42992,
    abbrName: 'Ctr',
    description:
      'The business center calendar used for date adjustment of the payment stub end date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubStartDateUnadjusted',
    id: 42993,
    abbrName: 'DtUnadj',
    description: 'The unadjusted stub start date.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubStartDateBusinessDayConvention',
    id: 42994,
    abbrName: 'BizDayCnvtn',
    description: 'The stub start date business day convention.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubStartDateRelativeTo',
    id: 42995,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the stub start date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubStartDateOffsetPeriod',
    id: 42996,
    abbrName: 'OfstPeriod',
    description: 'Time unit multiplier for the relative stub start date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubStartDateOffsetUnit',
    id: 42997,
    abbrName: 'OfstUnit',
    description: 'Time unit associated with the relative stub start date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubStartDateOffsetDayType',
    id: 42998,
    abbrName: 'OfstDayTyp',
    description: 'Specifies the day type of the relative stub start date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubStartDateAdjusted',
    id: 42999,
    abbrName: 'Dt',
    description: 'The adjusted stub start date.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingPaymentStubStartDateBusinessCenters',
    id: 43000,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStubStartDateBusinessCenter',
    id: 43001,
    abbrName: 'Ctr',
    description:
      'The business center calendar used for date adjustment of the payment stub start date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'ProvisionBreakFeeElectionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionBreakFeeElection',
    id: 43002,
    abbrName: 'BrkFeeElctn',
    description: 'Type of fee elected for the break provision.',
  },
  {
    type: 'Percentage',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingProvisionBreakFeeRate',
    id: 43003,
    abbrName: 'BrkFeeRt',
    description:
      'Break fee election rate when the break fee is proportional to the notional. A fee rate of 5% would be represented as "0.05".',
  },
  {
    type: 'float',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingRateSpreadInitialValue',
    id: 43004,
    abbrName: 'InitVal',
    description: 'Specifies the initial rate spread for a basket underlier.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingRateSpreadSteps',
    id: 43005,
    description: 'Number of entries in the repeating group.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingRateSpreadStepDate',
    id: 43006,
    abbrName: 'Dt',
    description: 'The date that the rate spread step takes affect.',
  },
  {
    type: 'float',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingRateSpreadStepValue',
    id: 43007,
    abbrName: 'Val',
    description:
      'The the value of the new rate spread as of the UnderlyingRateSpreadStepDate(43006).',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingReturnRateDates',
    id: 43008,
    description: 'Number of iterations in the return rate date repeating group.',
  },
  {
    type: 'ReturnRateDateModeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateDateMode',
    id: 43009,
    abbrName: 'Mode',
    description: 'Specifies the valuation type applicable to the return rate date.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateValuationDateRelativeTo',
    id: 43010,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the return rate valuation dates are relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateValuationDateOffsetPeriod',
    id: 43011,
    abbrName: 'OfstPeriod',
    description:
      'Time unit multiplier for the relative return rate valuation date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateValuationDateOffsetUnit',
    id: 43012,
    abbrName: 'OfstUnit',
    description:
      'Time unit associated with the relative return rate valuation date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateValuationDateOffsetDayType',
    id: 43013,
    abbrName: 'OfstDayTyp',
    description:
      'Specifies the day type of the relative return rate valuation date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateValuationStartDateUnadjusted',
    id: 43014,
    abbrName: 'StartDtUnadj',
    description:
      'The unadjusted start date for return rate valuation. This can be used to restrict the range of dates when they are relative.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateValuationStartDateRelativeTo',
    id: 43015,
    abbrName: 'StartDtReltv',
    description:
      'Specifies the anchor date when the return rate valuation start date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateValuationStartDateOffsetPeriod',
    id: 43016,
    abbrName: 'StartDtOfstPeriod',
    description:
      'Time unit multiplier for the relative return rate valuation start date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateValuationStartDateOffsetUnit',
    id: 43017,
    abbrName: 'StartDtOfstUnit',
    description:
      'Time unit associated with the relative return rate valuation start date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateValuationStartDateOffsetDayType',
    id: 43018,
    abbrName: 'StartDtOfstDayTyp',
    description:
      'Specifies the day type of the relative return rate valuation start date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateValuationStartDateAdjusted',
    id: 43019,
    abbrName: 'StartDt',
    description:
      'The adjusted start date for return rate valuation. This can be used to restrict the range of dates when they are relative.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateValuationEndDateUnadjusted',
    id: 43020,
    abbrName: 'EndDtUnadj',
    description:
      'The unadjusted end date for return rate valuation. This can be used to restrict the range of dates when they are relative.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateValuationEndDateRelativeTo',
    id: 43021,
    abbrName: 'EndDtReltv',
    description:
      'Specifies the anchor date when the return rate valuation end date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateValuationEndDateOffsetPeriod',
    id: 43022,
    abbrName: 'EndDtOfstPeriod',
    description:
      'Time unit multiplier for the relative return rate valuation end date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateValuationEndDateOffsetUnit',
    id: 43023,
    abbrName: 'EndDtOfstUnit',
    description:
      'Time unit associated with the relative return rate valuation end date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateValuationEndDateOffsetDayType',
    id: 43024,
    abbrName: 'EndDtOfstDayTyp',
    description:
      'Specifies the day type of the relative return rate valuation end date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateValuationEndDateAdjusted',
    id: 43025,
    abbrName: 'EndDt',
    description:
      'The adjusted end date for return rate valuation. This can be used to restrict the range of dates when they are relative.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateValuationFrequencyPeriod',
    id: 43026,
    abbrName: 'FreqPeriod',
    description:
      'Time unit multiplier for the frequency at which return rate valuation dates occur.',
  },
  {
    type: 'CouponFrequencyUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateValuationFrequencyUnit',
    id: 43027,
    abbrName: 'FreqUnit',
    description:
      'Time unit associated with the frequency at which return rate valuation dates occur.',
  },
  {
    type: 'DateRollConventionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateValuationFrequencyRollConvention',
    id: 43028,
    abbrName: 'Roll',
    description:
      'The convention for determining the sequence of return rate valuation dates. It is used in conjunction with a specified frequency.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateValuationDateBusinessDayConvention',
    id: 43029,
    abbrName: 'BizDayCnvtn',
    description: 'The return rate valuation dates business day convention.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingReturnRateFXConversions',
    id: 43030,
    description: 'Number of iterations in the return rate FX conversion repeating group.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateFXCurrencySymbol',
    id: 43031,
    abbrName: 'CcySym',
    description:
      'Specifies the currency pair for the FX conversion expressed using the CCY1/CCY2 convention. Uses ISO 4217 currency codes.',
  },
  {
    type: 'float',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateFXRate',
    id: 43032,
    abbrName: 'FxRt',
    description:
      'The rate of exchange between the two currencies specified in UnderlyingReturnRateFXCurrencySymbol(43031).',
  },
  {
    type: 'SettlCurrFxRateCalcCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateFXRateCalc',
    id: 43033,
    abbrName: 'FxRtCalc',
    description:
      'Specifies whether UnderlyingReturnRateFXRate(43032) should be multiplied or divided.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingReturnRates',
    id: 43034,
    description: 'Number of iterations in the return rate repeating group.',
  },
  {
    type: 'ReturnRatePriceSequenceCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRatePriceSequence',
    id: 43035,
    abbrName: 'PxSeq',
    description: 'Specifies the type of price sequence of the return rate.',
  },
  {
    type: 'CommTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateCommissionBasis',
    id: 43036,
    abbrName: 'CommBasis',
    description: 'Specifies the basis or unit used to calculate the commission.',
  },
  {
    type: 'Amt',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateCommissionAmount',
    id: 43037,
    abbrName: 'CommAmt',
    description: 'The commission amount.',
  },
  {
    type: 'Currency',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateCommissionCurrency',
    id: 43038,
    abbrName: 'CommCcy',
    description:
      'Specifies the currency the commission amount is denominated in. Uses ISO 4217 currency codes.',
  },
  {
    type: 'Amt',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateTotalCommissionPerTrade',
    id: 43039,
    abbrName: 'TotCommPerTrd',
    description: 'The total commission per trade.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateDeterminationMethod',
    id: 43040,
    abbrName: 'DtrmnMeth',
    description:
      'Specifies the method by which the underlier prices are determined.\n\nSee http://www.fpml.org/coding-scheme/determination-method for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateAmountRelativeTo',
    id: 43041,
    abbrName: 'AmtReltv',
    description:
      'Specifies the reference amount when the return rate amount is relative to another amount in the trade.\n\nSee http://www.fixtradingcommunity.org/codelists#Payment_Amount_Relative_To for code list of relative amounts.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateQuoteMeasureType',
    id: 43042,
    abbrName: 'QteTyp',
    description:
      "Specifies the type of the measure applied to the return rate's asset, e.g. valuation, sensitivity risk. This could be an NPV, a cash flow, a clean price, etc.\n\nSee http://www.fpml.org/coding-scheme/asset-measure for values.",
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateQuoteUnits',
    id: 43043,
    abbrName: 'QteUnit',
    description:
      'Specifies the units that the measure is expressed in. If not specified, the default is a price/value in currency units.\n\nSee http://www.fpml.org/coding-scheme/price-quote-units for values.',
  },
  {
    type: 'CashSettlQuoteMethodCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateQuoteMethod',
    id: 43044,
    abbrName: 'QteMeth',
    description:
      'Specifies the type of quote used to determine the return rate of the swap.',
  },
  {
    type: 'Currency',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateQuoteCurrency',
    id: 43045,
    abbrName: 'QteCcy',
    description:
      'Specifies the currency the return rate quote is denominated in. Uses ISO 4217 Currency Code.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateQuoteCurrencyType',
    id: 43046,
    abbrName: 'QteCcyTyp',
    description:
      'Specifies the type of currency, e.g. settlement currency, base currency, etc., that the quote is reported in.\n\nSee http://www.fpml.org/coding-scheme/reporting-currency-type for values.',
  },
  {
    type: 'ReturnRateQuoteTimeTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateQuoteTimeType',
    id: 43047,
    abbrName: 'QteTmTyp',
    description: 'Specifies how or the timing when the quote is to be obtained.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateQuoteTime',
    id: 43048,
    abbrName: 'QteTm',
    description: 'The time when the quote is to be generated.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateQuoteDate',
    id: 43049,
    abbrName: 'QteDt',
    description: 'The date when the quote is to be generated.',
  },
  {
    type: 'LocalMktTime',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateQuoteExpirationTime',
    id: 43050,
    abbrName: 'QteExpTm',
    description: 'The time when the quote ceases to be valid.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateQuoteBusinessCenter',
    id: 43051,
    abbrName: 'QteBizCtr',
    description:
      'The business center calendar used for adjustments associated with UnderlyingReturnRateQuoteTimeType(43047) or UnderlyingReturnRateQuoteTime(43048) and UnderlyingReturnRateQuoteDate(43049), e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'Exchange',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateQuoteExchange',
    id: 43052,
    abbrName: 'QteExch',
    description:
      'Specifies the exchange (e.g. stock or listed futures/options exchange) from which the quote is obtained.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateQuotePricingModel',
    id: 43053,
    abbrName: 'QteModel',
    description:
      'Specifies the pricing model used to evaluate the underlying asset price.\n\nSee http://www.fpml.org/coding-scheme/pricing-model for values.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateCashFlowType',
    id: 43054,
    abbrName: 'CshFlow',
    description:
      'Specifies the type of cash flows, e.g. coupon payment, premium fee, settlement fee, etc.\n\nSee http://www.fpml.org/coding-scheme/cashflow-type for values.',
  },
  {
    type: 'ReturnRateQuoteTimeTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateValuationTimeType',
    id: 43055,
    abbrName: 'ValTmTyp',
    description:
      'Specifies the timing at which the calculation agent values the underlying.',
  },
  {
    type: 'LocalMktTime',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateValuationTime',
    id: 43056,
    abbrName: 'ValTm',
    description: 'The time at which the calculation agent values the underlying asset.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateValuationTimeBusinessCenter',
    id: 43057,
    abbrName: 'ValTmBizCtr',
    description:
      'The business center calendar used for adjustments associated with UnderlyingReturnRateValuationTimeType(43055) or UnderlyingReturnRateValuationTime(43056) , e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'ReturnRateValuationPriceOptionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateValuationPriceOption',
    id: 43058,
    abbrName: 'ValPxOpt',
    description:
      'Indicates whether an ISDA price option applies, and if applicable which type of price.',
  },
  {
    type: 'ComplexEventPVFinalPriceElectionFallbackCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateFinalPriceFallback',
    id: 43059,
    abbrName: 'FnlPxFallbck',
    description:
      'Specifies the fallback provision for the hedging party in the determination of the final price.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingReturnRateInformationSources',
    id: 43060,
    description:
      'Number of iterations in the return rate information source repeating group.',
  },
  {
    type: 'RateSourceCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateInformationSource',
    id: 43061,
    abbrName: 'RtSrc',
    description:
      'Identifies the source of rate information. For FX the references source to be used for the FX spot rate.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateReferencePage',
    id: 43062,
    abbrName: 'RefPg',
    description:
      'Identifies the reference "page" from the rate source.\n\nFor FX, the reference page to the spot rate to be used for the reference FX spot rate.\n\nWhen UnderlyingReturnRateInformationSource(43061) = 3 (ISDA Settlement Rate Option) this contains the value from the scheme that reflects the terms of the Annex A to the ISDA 1998 FX and Currency Option Definitions.\n\nSee: http://www.fpml.org/coding-scheme/settlement-rate-option',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateReferencePageHeading',
    id: 43063,
    abbrName: 'RefHdng',
    description: 'Identifies the page heading from the rate source.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingReturnRatePrices',
    id: 43064,
    description: 'Number of iterations in the return rate price repeating group.',
  },
  {
    type: 'ReturnRatePriceBasisCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRatePriceBasis',
    id: 43065,
    abbrName: 'PxBasis',
    description: 'The basis of the return price.',
  },
  {
    type: 'Price',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRatePrice',
    id: 43066,
    abbrName: 'Px',
    description: 'Specifies the price of the underlying swap asset.',
  },
  {
    type: 'Currency',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRatePriceCurrency',
    id: 43067,
    abbrName: 'Ccy',
    description:
      'Specifies the currency of the price of the underlying swap asset. Uses ISO 4217 currency codes.',
  },
  {
    type: 'ReturnRatePriceTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRatePriceType',
    id: 43068,
    abbrName: 'PxTyp',
    description:
      'Specifies whether the UnderlyingReturnRatePrice(43066) is expressed in absolute or relative terms.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingReturnRateValuationDateBusinessCenters',
    id: 43069,
    description:
      'Number of iterations in the return rate valuation date business center repeating group.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateValuationDateBusinessCenter',
    id: 43070,
    abbrName: 'Ctr',
    description:
      'The business center calendar used for date adjustment of the return rate valuation unadjusted or relative dates, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingReturnRateValuationDates',
    id: 43071,
    description:
      'Number of iterations in the return rate valuation date repeating group.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateValuationDate',
    id: 43072,
    abbrName: 'Dt',
    description:
      'The return rate valuation date. Type of date is specified in UnderlyingReturnRateValuationDateType(43073).',
  },
  {
    type: 'NonDeliverableFixingDateTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnRateValuationDateType',
    id: 43073,
    abbrName: 'Typ',
    description:
      'Specifies the type of return rate valuation date (e.g. adjusted for holidays).',
  },
  {
    type: 'NumInGroup',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'NoUnderlyingSettlMethodElectionDateBusinessCenters',
    id: 43074,
    description: 'Number of business centers in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingSettlMethodElectionDateBusinessCenter',
    id: 43075,
    abbrName: 'Ctr',
    description:
      'The business center calendar used for date adjustment of the settlement method election unadjusted or relative date, e.g. "GBLO".\n\nSee http://www.fpml.org/coding-scheme/business-center for standard 4-character code values.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingSettlMethodElectionDateUnadjusted',
    id: 43076,
    abbrName: 'DtUnadj',
    description: 'The unadjusted settlement method election date.',
  },
  {
    type: 'BusinessDayConventionCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingSettlMethodElectionDateBusinessDayConvention',
    id: 43077,
    abbrName: 'BizDayCnvtn',
    description:
      'The settlement method election date adjustment business day convention.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved1000Plus',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingSettlMethodElectionDateRelativeTo',
    id: 43078,
    abbrName: 'Reltv',
    description:
      'Specifies the anchor date when the settlement method election date is relative to an anchor date.\n\nSee http://www.fixtradingcommunity.org/codelists#Relative_To_Date for values.',
  },
  {
    type: 'int',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingSettlMethodElectionDateOffsetPeriod',
    id: 43079,
    abbrName: 'OfstPeriod',
    description:
      'Time unit multiplier for the relative settlement method election date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetUnitCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingSettlMethodElectionDateOffsetUnit',
    id: 43080,
    abbrName: 'OfstUnit',
    description:
      'Time unit associated with the relative settlement method election date offset.',
  },
  {
    type: 'PaymentStreamPaymentDateOffsetDayTypeCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingSettlMethodElectionDateOffsetDayType',
    id: 43081,
    abbrName: 'OfstDayTyp',
    description:
      'Specifies the day type of the relative settlement method election date offset.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingSettlMethodElectionDateAdjusted',
    id: 43082,
    abbrName: 'Dt',
    description: 'The adjusted settlement method election date.',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamVersion',
    id: 43083,
    abbrName: 'Ver',
    description:
      'The stream version identifier when there have been modifications to the contract over time. Helps signal when there are embedded changes.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamVersionEffectiveDate',
    id: 43084,
    abbrName: 'VerEfctvDt',
    description: 'The effective date of the UnderlyingStreamVersion(43083).',
  },
  {
    type: 'String',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamNotionalDeterminationMethod',
    id: 43085,
    abbrName: 'NotlDtrmnMeth',
    description:
      'Specifies the method for determining the floating notional value for equity swaps.\n\nSee http://www.fpml.org/coding-scheme/determination-method for values.',
  },
  {
    type: 'StreamNotionalAdjustmentsCodeSet',
    addedEP: '208',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingStreamNotionalAdjustments',
    id: 43086,
    abbrName: 'NotlAdjmts',
    description:
      'For equity swaps this specifies the conditions that govern the adjustment to the number of units of the swap.',
  },
  {
    type: 'RemunerationIndicatorCodeSet',
    addedEP: '209',
    added: 'FIX.5.0SP2',
    name: 'RemunerationIndicator',
    id: 2356,
    abbrName: 'RmntnInd',
    description:
      'Indicates whether the trade price was adjusted for compensation (i.e. includes a mark-up, mark-down or commission) in the price paid.\n\nIn the context of MSRB and FINRA TRACE reporting requirements, this is used among firms to indicate trade remuneration.',
  },
  {
    type: 'String',
    addedEP: '211',
    added: 'FIX.5.0SP2',
    name: 'CompressionGroupID',
    id: 2361,
    abbrName: 'CmprsnGrpID',
    description:
      'Use to identify a netting or compression group where trades in the group were netted or compressed. This includes both terminating trades and any remnant trades that result from the operation.',
  },
  {
    type: 'String',
    addedEP: '211',
    added: 'FIX.5.0SP2',
    name: 'SelfMatchPreventionID',
    id: 2362,
    abbrName: 'SlfMtchPrvntnID',
    description:
      'Identifies an order or trade that should not be matched to an opposite order or trade if both buy and sell orders for the same asset contain the same SelfMatchPreventionID(2362) and submitted by the same firm.',
  },
  {
    type: 'PartyRiskLimitStatusCodeSet',
    addedEP: '214',
    added: 'FIX.5.0SP2',
    name: 'PartyRiskLimitStatus',
    id: 2355,
    abbrName: 'PtyRiskLmtStat',
    description: 'The status of risk limits for a party.',
  },
  {
    type: 'String',
    addedEP: '215',
    added: 'FIX.5.0SP2',
    name: 'TradeConfirmationReferenceID',
    id: 2390,
    abbrName: 'TrdCnfmRefID',
    description:
      'A reference or control identifier or number used as a trade confirmation key.\n\nAn example of a control identifier is the DTC ID Control Number.',
  },
  {
    type: 'AlgorithmicTradeIndicatorCodeSet',
    addedEP: '216',
    added: 'FIX.5.0SP2',
    name: 'AlgorithmicTradeIndicator',
    id: 2667,
    abbrName: 'AlgoTrdInd',
    description:
      'Indicates that the order or trade originates from a computer program or algorithm requiring little-to-no human intervention.',
  },
  {
    type: 'NumInGroup',
    addedEP: '216',
    added: 'FIX.5.0SP2',
    name: 'NoTrdRegPublications',
    id: 2668,
    description: 'Number of regulatory publication rules in repeating group.',
  },
  {
    type: 'TrdRegPublicationTypeCodeSet',
    addedEP: '216',
    added: 'FIX.5.0SP2',
    name: 'TrdRegPublicationType',
    id: 2669,
    abbrName: 'Typ',
    description:
      'Specifies the type of regulatory trade publication.\n\nAdditional reasons for the publication type may be specified in TrdRegPublicationReason(2670).',
  },
  {
    updated: 'FIX.Latest',
    type: 'TrdRegPublicationReasonCodeSet',
    addedEP: '216',
    updatedEP: '283',
    added: 'FIX.5.0SP2',
    name: 'TrdRegPublicationReason',
    id: 2670,
    abbrName: 'Rsn',
    description:
      'Additional reason for trade publication type specified in TrdRegPublicationType(2669).\n\nReasons may be specific to regulatory trade publication rules.\n\nFor ESMA RTS 1, RTS 6 and RTS 22 this is the OILQ flag.',
  },
  {
    type: 'PriceOffset',
    addedEP: '217',
    added: 'FIX.5.0SP2',
    name: 'LegDifferentialPrice',
    id: 2492,
    abbrName: 'DiffPx',
    description:
      'Used in pricing a group of individual Trade at Settlement (TAS) and Trade At Marker (TAM) contracts as an atomic unit. The value is the negotiated currency offset either at settlement (TAS) or at the time specified in the product definition (TAM). The final contract price is reported in LegLastPx(637).',
  },
  {
    type: 'CrossedIndicatorCodeSet',
    addedEP: '218',
    added: 'FIX.5.0SP2',
    name: 'CrossedIndicator',
    id: 2523,
    abbrName: 'CrssdInd',
    description:
      'Indicates whether the order or quote was crossed with another order or quote having the same context, e.g. having accounts with a common ownership.',
  },
  {
    type: 'NumInGroup',
    addedEP: '222',
    added: 'FIX.5.0SP2',
    name: 'NoOrderAttributes',
    id: 2593,
    description: 'Number of order attribute entries.',
  },
  {
    type: 'OrderAttributeTypeCodeSet',
    unionDataType: 'Reserved1000Plus',
    addedEP: '222',
    added: 'FIX.5.0SP2',
    name: 'OrderAttributeType',
    id: 2594,
    abbrName: 'Typ',
    description: 'The type of order attribute.',
  },
  {
    type: 'String',
    addedEP: '222',
    added: 'FIX.5.0SP2',
    name: 'OrderAttributeValue',
    id: 2595,
    abbrName: 'Val',
    description:
      'The value associated with the order attribute type specified in OrderAttributeType(2594).',
  },
  {
    updated: 'FIX.Latest',
    type: 'TradeReportingIndicatorCodeSet',
    addedEP: '222',
    updatedEP: '283',
    added: 'FIX.5.0SP2',
    name: 'TradeReportingIndicator',
    id: 2524,
    abbrName: 'TrdRptngInd',
    description:
      'Used between parties to convey trade reporting status.\n\nIn the context of regulatory reporting, this field may be used by the reporting party (e.g. party obligated to report to regulators) to inform their trading counterparty or other interested parties the trade reporting status.\n\nThe term “authorised reporter” represents the appropriate reporting firm under applicable regulation. In the context of ESMA reporting, this is the "Systematic Internaliser". In the context of FCA reporting, this is the "Designated Reporter".',
  },
  {
    type: 'TradeReportingIndicatorCodeSet',
    addedEP: '222',
    added: 'FIX.5.0SP2',
    name: 'SideTradeReportingIndicator',
    id: 2671,
    abbrName: 'TrdRptngInd',
    description:
      'Used between parties to convey trade reporting status.\n\nIn the context of regulatory reporting, this field may be used by the reporting party (e.g. party obligated to report to regulators) to inform their trading counterparty or other interested parties the trade reporting status.',
  },
  {
    type: 'String',
    addedEP: '223',
    added: 'FIX.5.0SP2',
    name: 'CrossRequestID',
    id: 2672,
    abbrName: 'CrssReqID',
    description:
      'Unique message identifier for a cross request as assigned by the submitter of the request.',
  },
  {
    type: 'String',
    addedEP: '223',
    added: 'FIX.5.0SP2',
    name: 'FillMatchID',
    id: 2673,
    abbrName: 'MtchID',
    description:
      'Identifier assigned by a matching system to a match event containing multiple executions.',
  },
  {
    type: 'String',
    addedEP: '223',
    added: 'FIX.5.0SP2',
    name: 'FillMatchSubID',
    id: 2674,
    abbrName: 'MtchSubID',
    description:
      'Identifier assigned by a matching system to a price level (e.g. match step, clip) within a match event containing multiple executions.',
  },
  {
    type: 'MassActionReasonCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '223',
    added: 'FIX.5.0SP2',
    name: 'MassActionReason',
    id: 2675,
    abbrName: 'MassActnRsn',
    description: 'Reason for submission of mass action.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Percentage',
    addedEP: '223',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'MaximumPriceDeviation',
    id: 2676,
    abbrName: 'MaxPxDeviatn',
    description:
      'Maximum deviation, in percentage terms, of an execution price from a reference price, e.g. the initial price of a match event.',
  },
  {
    type: 'NotAffectedReasonCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '223',
    added: 'FIX.5.0SP2',
    name: 'NotAffectedReason',
    id: 2677,
    abbrName: 'Rsn',
    description:
      'Reason for order being unaffected by mass action even though it belongs to the orders covered by MassActionScope(1374).',
  },
  {
    type: 'int',
    addedEP: '223',
    added: 'FIX.5.0SP2',
    name: 'TotalNotAffectedOrders',
    id: 2678,
    abbrName: 'TotNotAffctdOrds',
    description:
      'Total number of orders unaffected by either the OrderMassActionRequest(35=CA) or OrderMassCancelRequest(35=Q).',
  },
  {
    type: 'OrderOwnershipIndicatorCodeSet',
    addedEP: '223',
    added: 'FIX.5.0SP2',
    name: 'OrderOwnershipIndicator',
    id: 2679,
    abbrName: 'OrdOwnershipInd',
    description: 'Change of ownership of an order to a specific party.',
  },
  {
    type: 'String',
    addedEP: '223',
    added: 'FIX.5.0SP2',
    name: 'LegAccount',
    id: 2680,
    abbrName: 'Acct',
    description:
      'Account mnemonic as agreed between buy and sell sides, e.g. broker and institution or investor/intermediary and fund manager.',
  },
  {
    type: 'InTheMoneyConditionCodeSet',
    addedEP: '224',
    added: 'FIX.5.0SP2',
    name: 'InTheMoneyCondition',
    id: 2681,
    abbrName: 'ITMCond',
    description: 'Specifies an option instrument\'s "in the money" condition.',
  },
  {
    type: 'InTheMoneyConditionCodeSet',
    addedEP: '224',
    added: 'FIX.5.0SP2',
    name: 'LegInTheMoneyCondition',
    id: 2682,
    abbrName: 'ITMCond',
    description:
      'Specifies an option instrument\'s "in the money" condition in general terms.',
  },
  {
    type: 'InTheMoneyConditionCodeSet',
    addedEP: '224',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingInTheMoneyCondition',
    id: 2683,
    abbrName: 'ITMCond',
    description:
      'Specifies an option instrument\'s "in the money" condition in general terms.',
  },
  {
    updated: 'FIX.Latest',
    type: 'InTheMoneyConditionCodeSet',
    addedEP: '224',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'DerivativeInTheMoneyCondition',
    id: 2684,
    abbrName: 'ITMCond',
    description:
      'Specifies an option instrument\'s "in the money" condition in general terms.\n\nSee InTheMoneyCondition(2681) for complete definition.',
  },
  {
    type: 'Boolean',
    addedEP: '224',
    added: 'FIX.5.0SP2',
    name: 'ContraryInstructionEligibilityIndicator',
    id: 2685,
    abbrName: 'CntraryInstEligInd',
    description:
      'Identifies whether the option instrument is eligible for contrary instructions at the time of exercise. The contrariness of an instruction will be determined in the context of InTheMoneyCondition(2681). When not specified, the eligibility is undefined or not applicable.',
  },
  {
    type: 'Boolean',
    addedEP: '224',
    added: 'FIX.5.0SP2',
    name: 'LegContraryInstructionEligibilityIndicator',
    id: 2686,
    abbrName: 'CntraryInstEligInd',
    description:
      'Identifies whether the option instrument is eligible for contrary instructions at the time of exercise. The contrariness of an instruction will be determined in the context of LegInTheMoneyCondition(2682). When not specified, the eligibility is undefined or not applicable.',
  },
  {
    type: 'Boolean',
    addedEP: '224',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingContraryInstructionEligibilityIndicator',
    id: 2687,
    abbrName: 'CntraryInstEligInd',
    description:
      'Identifies whether the option instrument is eligible for contrary instructions at the time of exercise. The contrariness of an instruction will be determined in the context of UnderlyingInTheMoneyCondition(2683). When not specified, the eligibility is undefined or not applicable.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Boolean',
    addedEP: '224',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'DerivativeContraryInstructionEligibilityIndicator',
    id: 2688,
    abbrName: 'CntraryInstEligInd',
    description:
      'Identifies whether the option instrument is eligible for contrary instructions at the time of exercise. The contrariness of an instruction will be determined in the context of DerivativeInTheMoneyCondition(2684). When not specified, the eligibility is undefined or not applicable.\n\nSee ContraryInstructionEligibilityIndicator(2685) for complete definition.',
  },
  {
    type: 'Price',
    addedEP: '227',
    added: 'FIX.5.0SP2',
    name: 'CollateralMarketPrice',
    id: 2689,
    abbrName: 'MktPx',
    description:
      'Market price of the collateral, either from market sources or pre-agreed by the counterparties.',
  },
  {
    type: 'Percentage',
    addedEP: '227',
    added: 'FIX.5.0SP2',
    name: 'CollateralPercentOverage',
    id: 2690,
    abbrName: 'PctOvrg',
    description:
      'Percentage of over-collateralization particularly when CollateralAmountType(2632) = 4 (Additional collateral value)',
  },
  {
    type: 'NumInGroup',
    addedEP: '227',
    added: 'FIX.5.0SP2',
    name: 'NoSideCollateralAmounts',
    id: 2691,
    description: 'Number of side collateral amount entries.',
  },
  {
    type: 'String',
    addedEP: '227',
    added: 'FIX.5.0SP2',
    name: 'SideCollateralAmountMarketID',
    id: 2692,
    abbrName: 'MktID',
    description: 'Market associated with the collateral amount.',
  },
  {
    type: 'String',
    addedEP: '227',
    added: 'FIX.5.0SP2',
    name: 'SideCollateralAmountMarketSegmentID',
    id: 2693,
    abbrName: 'MktSegID',
    description: 'Market segment associated with the collateral amount.',
  },
  {
    type: 'CollateralAmountTypeCodeSet',
    addedEP: '227',
    added: 'FIX.5.0SP2',
    name: 'SideCollateralAmountType',
    id: 2694,
    abbrName: 'AmtTyp',
    description: 'The type of value in CurrentCollateralAmount(1704).',
  },
  {
    updated: 'FIX.Latest',
    type: 'Currency',
    addedEP: '227',
    updatedEP: '273',
    added: 'FIX.5.0SP2',
    name: 'SideCollateralCurrency',
    id: 2695,
    abbrName: 'Ccy',
    description:
      'Specifies the currency of the collateral; optional, defaults to settlement currency if not specified.\n\nSideCollateralCurrencyCodeSource(2930) may be used to disambiguate the code source scheme used, and ISO 4217 is the default scheme if absent.',
  },
  {
    type: 'float',
    addedEP: '227',
    added: 'FIX.5.0SP2',
    name: 'SideCollateralFXRate',
    id: 2696,
    abbrName: 'FxRt',
    description:
      'Foreign exchange rate used to compute the SideCurrentCollateralAmount(2702) from the SideCollateralCurrency(2695) and the Currency(15).',
  },
  {
    type: 'UnderlyingFXRateCalcCodeSet',
    addedEP: '227',
    added: 'FIX.5.0SP2',
    name: 'SideCollateralFXRateCalc',
    id: 2697,
    abbrName: 'FxRtCalc',
    description:
      'Specifies whether or not SideCollateralFXRate(2696) should be multiplied or divided.',
  },
  {
    type: 'Price',
    addedEP: '227',
    added: 'FIX.5.0SP2',
    name: 'SideCollateralMarketPrice',
    id: 2698,
    abbrName: 'MktPx',
    description:
      'Market price of the collateral, either from market sources or pre-agreed by the counterparties.',
  },
  {
    type: 'Percentage',
    addedEP: '227',
    added: 'FIX.5.0SP2',
    name: 'SideCollateralPercentOverage',
    id: 2699,
    abbrName: 'PctOvrg',
    description:
      'Percentage of over-collateralization particularly when SideCollateralAmountType(2694) = 4 (Additional collateral value).',
  },
  {
    type: 'String',
    addedEP: '227',
    added: 'FIX.5.0SP2',
    name: 'SideCollateralPortfolioID',
    id: 2700,
    abbrName: 'PrtflioID',
    description:
      'Identifier of the collateral portfolio when reporting on a portfolio basis.',
  },
  {
    type: 'String',
    addedEP: '227',
    added: 'FIX.5.0SP2',
    name: 'SideCollateralType',
    id: 2701,
    abbrName: 'Typ',
    description: 'Type of collateral on deposit being reported.',
  },
  {
    type: 'Amt',
    addedEP: '227',
    added: 'FIX.5.0SP2',
    name: 'SideCurrentCollateralAmount',
    id: 2702,
    abbrName: 'Amt',
    description: 'Currency value currently attributed to the collateral.',
  },
  {
    type: 'Boolean',
    addedEP: '227',
    added: 'FIX.5.0SP2',
    name: 'SideHaircutIndicator',
    id: 2703,
    abbrName: 'HrctInd',
    description:
      'Indicates, if "Y", that a stated valuation includes a haircut, e.g. that the stated value reflects the subtraction of the haircut. Note that a value of "N" does not imply a haircut is not applicable, only that the haircut (if any) is not reflected in the stated valuation.',
  },
  {
    type: 'ExDestinationTypeCodeSet',
    addedEP: '228',
    added: 'FIX.5.0SP2',
    name: 'ExDestinationType',
    id: 2704,
    abbrName: 'ExDestTyp',
    description: 'Identifies the type of execution destination for the order.',
  },
  {
    type: 'MarketConditionCodeSet',
    addedEP: '229',
    added: 'FIX.5.0SP2',
    name: 'MarketCondition',
    id: 2705,
    abbrName: 'MktCond',
    description:
      'Market condition. In the context of ESMA RTS 8 it is important that trading venues communicate the condition of the market, particularly "stressed" and "exceptional", in order to provide incentives for firms contributing to liquidity.',
  },
  {
    type: 'NumInGroup',
    addedEP: '229',
    added: 'FIX.5.0SP2',
    name: 'NoQuoteAttributes',
    id: 2706,
    description: 'Number of quote attributes entries.',
  },
  {
    type: 'QuoteAttributeTypeCodeSet',
    addedEP: '229',
    added: 'FIX.5.0SP2',
    name: 'QuoteAttributeType',
    id: 2707,
    abbrName: 'Typ',
    description: 'The type of attribute for the quote.',
  },
  {
    type: 'String',
    addedEP: '229',
    added: 'FIX.5.0SP2',
    name: 'QuoteAttributeValue',
    id: 2708,
    abbrName: 'Val',
    description:
      'The value associated with the quote attribute type specified in QuoteAttributeType(2707).',
  },
  {
    type: 'NumInGroup',
    addedEP: '230',
    added: 'FIX.5.0SP2',
    name: 'NoPriceQualifiers',
    id: 2709,
    description: 'Number of price qualifiers in the repeating group.',
  },
  {
    type: 'PriceQualifierCodeSet',
    addedEP: '230',
    added: 'FIX.5.0SP2',
    name: 'PriceQualifier',
    id: 2710,
    abbrName: 'Qual',
    description:
      'Qualifier for price. May be used when the price needs to be explicitly qualified.',
  },
  {
    type: 'MDValueTierCodeSet',
    addedEP: '231',
    added: 'FIX.5.0SP2',
    name: 'MDValueTier',
    id: 2711,
    abbrName: 'Tier',
    description:
      'Describes the reporting ranges for executed transactions.\n\nIn context of ESMA RTS 27 Article 9, the execution venue is required to report on transactions within several size ranges (in terms of a value and currency). The thresholds for these ranges are dependent on the type of financial instrument.',
  },
  {
    type: 'MiscFeeQualifierCodeSet',
    addedEP: '231',
    added: 'FIX.5.0SP2',
    name: 'MiscFeeQualifier',
    id: 2712,
    abbrName: 'Qual',
    description:
      'Identifies whether the current entry contributes to the trade or transaction economics, i.e. affects NetMoney(118).',
  },
  {
    type: 'String',
    addedEP: '231',
    added: 'FIX.5.0SP2',
    name: 'MiscFeeDesc',
    id: 2713,
    abbrName: 'Desc',
    description: 'Can be used to provide a textual description of the fee type.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    addedEP: '232',
    updatedEP: '236',
    added: 'FIX.5.0SP2',
    name: 'FinancialInstrumentFullName',
    id: 2714,
    abbrName: 'FullName',
    description:
      'The full normative name of the financial instrument.\n\nIn the context of ESMA reference data, this is used to provide the full name of the instrument as defined by the Derivatives Service Bureau (DSB).',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'Length',
    addedEP: '232',
    updatedEP: '236',
    added: 'FIX.5.0SP2',
    name: 'EncodedFinancialInstrumentFullNameLen',
    id: 2715,
    abbrName: 'EncFullNameLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedFinancialInstrumentFullName(2716) field.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'data',
    addedEP: '232',
    updatedEP: '236',
    added: 'FIX.5.0SP2',
    name: 'EncodedFinancialInstrumentFullName',
    id: 2716,
    abbrName: 'EncFullName',
    lengthId: '2715',
    description:
      'Encoded (non-ASCII characters) representation of the FinancialInstrumentFullName(2714) field in the encoded format specified via the MessageEncoding(347) field. If used, the ASCII (English) representation should also be specified in the FinancialInstrumentFullName(2714) field.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    addedEP: '232',
    updatedEP: '236',
    added: 'FIX.5.0SP2',
    name: 'LegFinancialInstrumentFullName',
    id: 2717,
    abbrName: 'FullName',
    description:
      "The full normative name of the multileg's financial instrument.\n\nIn the context of ESMA reference data, this is used to provide the full name of the instrument as defined by the Derivatives Service Bureau (DSB).",
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'Length',
    addedEP: '232',
    updatedEP: '236',
    added: 'FIX.5.0SP2',
    name: 'EncodedLegFinancialInstrumentFullNameLen',
    id: 2718,
    abbrName: 'EncFullNameLen',
    description:
      "Byte length of encoded (non-ASCII characters) individual multileg instrument's EncodedLegFinancialInstrumentFullName(2719).",
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'data',
    addedEP: '232',
    updatedEP: '236',
    added: 'FIX.5.0SP2',
    name: 'EncodedLegFinancialInstrumentFullName',
    id: 2719,
    abbrName: 'EncFullName',
    lengthId: '2718',
    description:
      'Encoded (non-ASCII characters) representation of the LegFinancialInstrumentFullName(2717) field in the encoded format specified via the MessageEncoding(347) field. If used, the ASCII (English) representation should also be specified in the LegFinancialInstrumentFullName(2717) field.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    addedEP: '232',
    updatedEP: '236',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingFinancialInstrumentFullName',
    id: 2720,
    abbrName: 'FullName',
    description:
      'The full normative name of the underlying financial instrument.\n\nIn the context of ESMA reference data, this is used to provide the full name of the instrument as defined by the Derivatives Service Bureau (DSB).',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'Length',
    addedEP: '232',
    updatedEP: '236',
    added: 'FIX.5.0SP2',
    name: 'EncodedUnderlyingFinancialInstrumentFullNameLen',
    id: 2721,
    abbrName: 'EncFullNameLen',
    description:
      "Byte length of encoded (non-ASCII characters) underlying instrument's EncodedUnderlyingFinancialInstrumentFullName(2722).",
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'data',
    addedEP: '232',
    updatedEP: '236',
    added: 'FIX.5.0SP2',
    name: 'EncodedUnderlyingFinancialInstrumentFullName',
    id: 2722,
    abbrName: 'EncFullName',
    lengthId: '2721',
    description:
      'Encoded (non-ASCII characters) representation of the UnderlyingFinancialInstrumentFullName(2720) field in the encoded format specified via the MessageEncoding(347) field. If used, the ASCII (English) representation should also be specified in the UnderlyingFinancialInstrumentFullName(2720) field.',
  },
  {
    type: 'PaymentStreamRateIndexCurveUnitCodeSet',
    addedEP: '232',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingIndexCurveUnit',
    id: 2723,
    abbrName: 'NdxUnit',
    description: 'Curve time unit associated with the underlying index.',
  },
  {
    type: 'int',
    addedEP: '232',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingIndexCurvePeriod',
    id: 2724,
    abbrName: 'NdxPeriod',
    description: 'Curve time multiplier for the underlying index.',
  },
  {
    type: 'CommissionAmountSubTypeCodeSet',
    addedEP: '233',
    added: 'FIX.5.0SP2',
    name: 'CommissionAmountSubType',
    id: 2725,
    abbrName: 'SubTyp',
    description: 'Further sub classification of the CommissionAmountType(2641).',
  },
  {
    type: 'CommissionAmountSubTypeCodeSet',
    addedEP: '233',
    added: 'FIX.5.0SP2',
    name: 'AllocCommissionAmountSubType',
    id: 2726,
    abbrName: 'SubTyp',
    description: 'Further sub classification of the AllocCommissionAmountType(2655).',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    addedEP: '234',
    updatedEP: '259',
    added: 'FIX.5.0SP2',
    name: 'AllocLegRefID',
    id: 2727,
    abbrName: 'LegRefID',
    description:
      'Unique identifier for a specific leg (uniqueness not defined as part of the FIX specification). AllocLegRefID(2727) references the value from LegID(1788) in the current multileg order or trade message specifying to which leg the allocation instance applies.',
  },
  {
    type: 'int',
    addedEP: '235',
    added: 'FIX.5.0SP2',
    name: 'FloatingRateIndexCurvePeriod',
    id: 2728,
    abbrName: 'Period',
    description:
      'Time unit multiplier for the floating rate index identified in FloatingRateIndexID(2731).',
  },
  {
    type: 'PriceOffset',
    addedEP: '235',
    added: 'FIX.5.0SP2',
    name: 'FloatingRateIndexCurveSpread',
    id: 2729,
    abbrName: 'Spread',
    description: 'Spread from the floating rate index.',
  },
  {
    type: 'PaymentStreamRateIndexCurveUnitCodeSet',
    addedEP: '235',
    added: 'FIX.5.0SP2',
    name: 'FloatingRateIndexCurveUnit',
    id: 2730,
    abbrName: 'Unit',
    description:
      'Time unit associated with the floating rate index identified in FloatingRateIndexID(2731).',
  },
  {
    type: 'String',
    addedEP: '235',
    added: 'FIX.5.0SP2',
    name: 'FloatingRateIndexID',
    id: 2731,
    abbrName: 'ID',
    discriminatorId: '2732',
    description: 'Security identifier of the floating rate index.',
  },
  {
    type: 'SecurityIDSourceCodeSet',
    addedEP: '235',
    added: 'FIX.5.0SP2',
    name: 'FloatingRateIndexIDSource',
    id: 2732,
    abbrName: 'Src',
    description:
      'Source for the floating rate index identified in FloatingRateIndexID(2731).',
  },
  {
    type: 'String',
    addedEP: '235',
    added: 'FIX.5.0SP2',
    name: 'IndexRollMonth',
    id: 2733,
    abbrName: 'Mo',
    description:
      'Month identified in the index roll.\n\nUse "1" for January, "2" for February, etc.',
  },
  {
    type: 'NumInGroup',
    addedEP: '235',
    added: 'FIX.5.0SP2',
    name: 'NoIndexRollMonths',
    id: 2734,
    description: 'Number of instances of the index roll month.',
  },
  {
    type: 'String',
    addedEP: '235',
    added: 'FIX.5.0SP2',
    name: 'AssetSubType',
    id: 2735,
    abbrName: 'AsstSubTyp',
    description:
      "Used to provide a more specific description of the asset specified in AssetType(1940).\n\nSee https://www.fixtrading.org/codelists/AssetSubType for code list of applicable values.\n\nIn the context of MiFID II, ESMA RTS 23 Annex I Table 2, this may indicate the 'Further sub product' or equity 'Parameter' fields.",
  },
  {
    type: 'CommodityFinalPriceTypeCodeSet',
    addedEP: '235',
    added: 'FIX.5.0SP2',
    name: 'CommodityFinalPriceType',
    id: 2736,
    abbrName: 'CmdtyFnlPxTyp',
    description: 'Final price type of the commodity as specified by the trading venue.',
  },
  {
    type: 'String',
    addedEP: '235',
    added: 'FIX.5.0SP2',
    name: 'FinancialInstrumentShortName',
    id: 2737,
    abbrName: 'ShrtName',
    description:
      'Short name of the financial instrument. Uses ISO 18774 (FINS) values.\n\nIn the context of MiFID II this maps to ESMA RTS 23 Annex I Table 3 Field 7 and may be used in other RTS that requires a similar field.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '235',
    added: 'FIX.5.0SP2',
    name: 'NextIndexRollDate',
    id: 2738,
    abbrName: 'NxtNdxRollDt',
    description: 'Next index roll date.',
  },
  {
    type: 'String',
    addedEP: '235',
    added: 'FIX.5.0SP2',
    name: 'LegAssetSubType',
    id: 2739,
    abbrName: 'AsstSubTyp',
    description:
      "Used to provide a more specific description of the asset specified in LegAssetType(2069).\n\nSee https://www.fixtrading.org/codelists/AssetSubType for code list of applicable values.\n\nIn the context of MiFID II, ESMA RTS 23 Annex I Table 2, this may indicate the 'Further sub product' or equity 'Parameter' fields.",
  },
  {
    type: 'String',
    addedEP: '235',
    added: 'FIX.5.0SP2',
    name: 'LegFinancialInstrumentShortName',
    id: 2740,
    abbrName: 'ShrtName',
    description:
      'Short name of the financial instrument. Uses ISO 18774 (FISN) values.\n\nIn the context of MiFID II this maps to ESMA RTS 23 Annex I Table 3 Field 7 and may be used in other RTS that requires a similar field.',
  },
  {
    type: 'String',
    addedEP: '235',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamRateIndexID',
    id: 43088,
    abbrName: 'NdxID',
    discriminatorId: '43089',
    description: 'Security identifier of the floating rate index.',
  },
  {
    type: 'SecurityIDSourceCodeSet',
    addedEP: '235',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamRateIndexIDSource',
    id: 43089,
    abbrName: 'NdxIDSrc',
    description:
      'Source for the floating rate index identified in LegPaymentStreamRateIndexID(43088).',
  },
  {
    type: 'String',
    addedEP: '235',
    added: 'FIX.5.0SP2',
    name: 'LegSecondaryAssetSubType',
    id: 2743,
    abbrName: 'SubTyp',
    description:
      "Used to provide a more specific description of the asset specified in LegSecondaryAssetType(2079).\n\nSee https://www.fixtrading.org/codelists/AssetSubType for code list of applicable values.\n\nIn the context of MiFID II RTS 23 Annex I Table 2, this may indicate the 'Further sub product' or equity 'Parameter' fields.",
  },
  {
    type: 'String',
    addedEP: '235',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamRateIndexID',
    id: 43090,
    abbrName: 'NdxID',
    discriminatorId: '43091',
    description: 'Security identifier of the floating rate index.',
  },
  {
    type: 'SecurityIDSourceCodeSet',
    addedEP: '235',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamRateIndexIDSource',
    id: 43091,
    abbrName: 'NdxIDSrc',
    description:
      'Source for the floating rate index identified in PaymentStreamRateIndexID(43090).',
  },
  {
    type: 'NumInGroup',
    addedEP: '235',
    added: 'FIX.5.0SP2',
    name: 'NoReferenceDataDates',
    id: 2746,
    description: 'Number of instances of reference data dates.',
  },
  {
    type: 'UTCTimestamp',
    addedEP: '235',
    added: 'FIX.5.0SP2',
    name: 'ReferenceDataDate',
    id: 2747,
    abbrName: 'Dt',
    description:
      "Reference data entry's date-time of the type specified in ReferenceDataDateType(2748).",
  },
  {
    type: 'ReferenceDataDateTypeCodeSet',
    addedEP: '235',
    added: 'FIX.5.0SP2',
    name: 'ReferenceDataDateType',
    id: 2748,
    abbrName: 'Typ',
    description: "Reference data entry's date-time type.",
  },
  {
    type: 'String',
    addedEP: '235',
    added: 'FIX.5.0SP2',
    name: 'SecondaryAssetSubType',
    id: 2741,
    abbrName: 'SubTyp',
    description:
      "Used to provide a more specific description of the asset specified in SecondaryAssetType(1979).\n\nSee https://www.fixtrading.org/codelists/AssetSubType for code list of applicable values.\n\nIn the context of MiFID II, ESMA RTS 23 Annex I Table 2, this may indicate the 'Further sub product' or equity 'Parameter' fields.",
  },
  {
    type: 'String',
    addedEP: '235',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingFinancialInstrumentShortName',
    id: 2742,
    abbrName: 'ShrtName',
    description:
      'Short name of the financial instrument. Uses ISO 18774 (FINS) values.\n\nIn the context of MiFID II this maps to ESMA RTS 23 Annex I Table 3 Field 7 and may be used in other RTS that requires a similar field.',
  },
  {
    type: 'String',
    addedEP: '235',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingAssetSubType',
    id: 2744,
    abbrName: 'AsstSubTyp',
    description:
      "Used to provide a more specific description of the asset specified in UnderlyingAssetType(2015).\n\nSee https://www.fixtrading.org/codelists/AssetSubType for code list of applicable values.\n\nIn the context of MiFID II, ESMA RTS 23 Annex I Table 2, this may indicate the 'Further sub product' or equity 'Parameter' fields.",
  },
  {
    type: 'String',
    addedEP: '235',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamRateIndexID',
    id: 43092,
    abbrName: 'NdxID',
    discriminatorId: '43093',
    description: 'Security identifier of the floating rate index.',
  },
  {
    type: 'SecurityIDSourceCodeSet',
    addedEP: '235',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamRateIndexIDSource',
    id: 43093,
    abbrName: 'NdxIDSrc',
    description:
      'Source for the floating rate index identified in UnderlyingPaymentStreamRateIndexID(43092).',
  },
  {
    type: 'String',
    addedEP: '235',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingSecondaryAssetSubType',
    id: 2745,
    abbrName: 'SubTyp',
    description:
      "May be used to provide a more specific description of the asset specified in UnderlyingSecondaryAssetType(2083).\n\nSee https://www.fixtrading.org/codelists/AssetSubType for code list of applicable values.\n\nIn the context of MiFID II, ESMA RTS 23 Annex I Table 2, this may indicate the 'Further sub product' or equity 'Parameter' fields.",
  },
  {
    type: 'String',
    addedEP: '235',
    added: 'FIX.5.0SP2',
    name: 'DeliveryStreamRouteOrCharter',
    id: 43094,
    abbrName: 'RteChrtr',
    description:
      'Specific delivery route or time charter average. Applicable to commodity freight swaps.',
  },
  {
    type: 'String',
    addedEP: '235',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryStreamRouteOrCharter',
    id: 43095,
    abbrName: 'RteChrtr',
    description:
      'Specific delivery route or time charter average. Applicable to commodity freight swaps.',
  },
  {
    type: 'String',
    addedEP: '235',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryStreamRouteOrCharter',
    id: 43096,
    abbrName: 'RteChrtr',
    description:
      'Specific delivery route or time charter average. Applicable to commodity freight swaps.',
  },
  {
    type: 'UTCTimestamp',
    addedEP: '237',
    added: 'FIX.5.0SP2',
    name: 'ExecutionTimestamp',
    id: 2749,
    abbrName: 'ExecTS',
    description: 'Time of the individual execution.',
  },
  {
    type: 'Price',
    addedEP: '237',
    added: 'FIX.5.0SP2',
    name: 'ReportingPx',
    id: 2750,
    abbrName: 'RptngPx',
    description:
      'Represents the reportable price on fill when an instance of the Parties component with PartyRole(452) = 73 (Execution Venue) is present to prevent having to compute running totals.',
  },
  {
    type: 'Qty',
    addedEP: '237',
    added: 'FIX.5.0SP2',
    name: 'ReportingQty',
    id: 2751,
    abbrName: 'RptngQty',
    description:
      'Represents the reportable quantity on fill when an instance of the Parties component with PartyRole(452) = 73 (Execution Venue) is present to prevent having to compute running totals.',
  },
  {
    type: 'String',
    addedEP: '238',
    added: 'FIX.5.0SP2',
    name: 'DeliveryRouteOrCharter',
    id: 2752,
    abbrName: 'RteChrtr',
    description:
      'Specific delivery route or time charter average. Applicable to commodity freight contracts.',
  },
  {
    type: 'ReturnTriggerCodeSet',
    addedEP: '238',
    added: 'FIX.5.0SP2',
    name: 'ReturnTrigger',
    id: 2753,
    abbrName: 'RtnTrgr',
    description:
      'Indicates the type of return or payout trigger for the swap or forward.',
  },
  {
    type: 'String',
    addedEP: '238',
    added: 'FIX.5.0SP2',
    name: 'LegDeliveryRouteOrCharter',
    id: 2754,
    abbrName: 'RteChrtr',
    description:
      'Specific delivery route or time charter average. Applicable to commodity freight contracts.',
  },
  {
    type: 'ReturnTriggerCodeSet',
    addedEP: '238',
    added: 'FIX.5.0SP2',
    name: 'LegReturnTrigger',
    id: 2755,
    abbrName: 'RtnTrgr',
    description:
      'Indicates the type of return or payout trigger for the swap or forward.',
  },
  {
    type: 'String',
    addedEP: '238',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingDeliveryRouteOrCharter',
    id: 2756,
    abbrName: 'RteChrtr',
    description:
      'Specific delivery route or time charter average. Applicable to commodity freight contracts.',
  },
  {
    type: 'ReturnTriggerCodeSet',
    addedEP: '238',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingReturnTrigger',
    id: 2757,
    abbrName: 'RtnTrgr',
    description:
      'Indicates the type of return or payout trigger for the swap or forward.',
  },
  {
    type: 'String',
    addedEP: '239',
    added: 'FIX.5.0SP2',
    name: 'AllocRequestID',
    id: 2758,
    abbrName: 'ReqID',
    description: 'Unique identifier for the request message.',
  },
  {
    type: 'Amt',
    addedEP: '239',
    added: 'FIX.5.0SP2',
    name: 'GroupAmount',
    id: 2759,
    abbrName: 'GrpAmt',
    description:
      "Indicates the total notional units or amount of an allocation group. Includes any allocated units or amount.\n\nWhether notional units or amount is used depends on the type of listed derivative contract and the clearinghouse. A notional unit is (price x quantity) without the derivative's contract value factor.",
  },
  {
    type: 'Amt',
    addedEP: '239',
    added: 'FIX.5.0SP2',
    name: 'GroupRemainingAmount',
    id: 2760,
    abbrName: 'GrpRemAmt',
    description:
      "Indicates the remaining notional units or amount of an allocation group that has not yet been allocated.\n\nWhether notional units or amount is used depends on the type of listed derivative contract and the clearinghouse. A notional unit is (price x quantity) without the derivative's contract value factor.",
  },
  {
    type: 'Amt',
    addedEP: '239',
    added: 'FIX.5.0SP2',
    name: 'AllocGroupAmount',
    id: 2761,
    abbrName: 'GrpAmt',
    description:
      "Indicates the notional units or amount being allocated.\n\nWhether notional units or amount is used depends on the type of listed derivative contract and the clearinghouse. A notional unit is (price x quantity) without the derivative's contract value factor.",
  },
  {
    type: 'PriceOffset',
    addedEP: '240',
    added: 'FIX.5.0SP2',
    name: 'PriceMarkup',
    id: 2762,
    abbrName: 'PxMrkup',
    description:
      'Price offset of the markup denominated in the price type of the trade.\n\nThe field is expressed in a value that can simply be added to or subtracted from the (clean) price to reach the marked- up price. E.g., a percent of par price of 98 marked up to 98.5 should be 0.5, an FX rate of 1.17936 marked up to 1.19 should be 0.01064, a stock price of 22.75 marked up to 22.9 should be 0.15, etc.',
  },
  {
    type: 'AveragePriceTypeCodeSet',
    addedEP: '240',
    added: 'FIX.5.0SP2',
    name: 'AveragePriceType',
    id: 2763,
    abbrName: 'Typ',
    description: 'The average pricing model used for block trades.',
  },
  {
    type: 'UTCTimestamp',
    addedEP: '240',
    added: 'FIX.5.0SP2',
    name: 'AveragePriceStartTime',
    id: 2764,
    abbrName: 'StartTm',
    description: 'Start of the time period during which price averaging occurred.',
  },
  {
    type: 'UTCTimestamp',
    addedEP: '240',
    added: 'FIX.5.0SP2',
    name: 'AveragePriceEndTime',
    id: 2765,
    abbrName: 'EndTm',
    description: 'End of the time period during which price averaging occurred.',
  },
  {
    type: 'Percentage',
    addedEP: '240',
    added: 'FIX.5.0SP2',
    name: 'OrderPercentOfTotalVolume',
    id: 2766,
    abbrName: 'TotVolPct',
    description:
      'For Percent-of-volume (POV) average pricing this is the target percentage this order quantity represents of the total trading volume of an instrument during the specified time period. This provides the data needed to ensure that the average price is fair based on the total sum of grouped POV trades.\n\nFor example, if during the POV time period there are 5 trades including this one with a total volume of 5000 and this trade has a quantity of 1000 then the OrderPercentOfTotalVolume(2766) of this trade is 20 percent expressed as "0.20".',
  },
  {
    type: 'AllocGroupStatusCodeSet',
    addedEP: '240',
    added: 'FIX.5.0SP2',
    name: 'AllocGroupStatus',
    id: 2767,
    abbrName: 'GrpStat',
    description:
      'Status of the trade give-up relative to the group identified in AllocGroupID(1730).',
  },
  {
    type: 'AllocRequestStatusCodeSet',
    addedEP: '241',
    added: 'FIX.5.0SP2',
    name: 'AllocRequestStatus',
    id: 2768,
    abbrName: 'ReqStat',
    description: 'Status of the AllocationInstructionAlertRequest(35=DU).',
  },
  {
    type: 'AvgPxIndicatorCodeSet',
    addedEP: '241',
    added: 'FIX.5.0SP2',
    name: 'AllocAvgPxIndicator',
    id: 2769,
    abbrName: 'AvgPxInd',
    description: 'Average pricing indicator at the allocation level.',
  },
  {
    type: 'String',
    addedEP: '241',
    added: 'FIX.5.0SP2',
    name: 'AllocAvgPxGroupID',
    id: 2770,
    abbrName: 'AvgPxGrpID',
    description:
      'Used by submitting firm to group trades being sub-allocated into an average price group. The trades in the average price group will be used to calculate an average price for the group.',
  },
  {
    type: 'String',
    addedEP: '241',
    added: 'FIX.5.0SP2',
    name: 'PreviousAllocGroupID',
    id: 2771,
    abbrName: 'PrevGrpID',
    description:
      'When reporting a group change by the central counterparty to allocations of trades for the same instrument traded at the same price this identifies the previous group identifier.',
  },
  {
    type: 'NumInGroup',
    addedEP: '246',
    added: 'FIX.5.0SP2',
    name: 'NoMatchExceptions',
    id: 2772,
    description: 'Number of match exceptions in the repeating group.',
  },
  {
    type: 'MatchExceptionTypeCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '246',
    added: 'FIX.5.0SP2',
    name: 'MatchExceptionType',
    id: 2773,
    abbrName: 'Typ',
    description: 'Type of matching exception.',
  },
  {
    type: 'MatchExceptionElementTypeCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '246',
    added: 'FIX.5.0SP2',
    name: 'MatchExceptionElementType',
    id: 2774,
    abbrName: 'ID',
    description:
      'Identifies the data point used in the matching operation which resulted in an exception.',
  },
  {
    type: 'String',
    addedEP: '246',
    added: 'FIX.5.0SP2',
    name: 'MatchExceptionElementName',
    id: 2775,
    abbrName: 'Name',
    description:
      'The matching exception data point name, for example: "Trade currency". This may be used for display purposes, providing a corresponding description for the value in MatchExceptionElementType(2774).',
  },
  {
    type: 'String',
    addedEP: '246',
    added: 'FIX.5.0SP2',
    name: 'MatchExceptionAllocValue',
    id: 2776,
    abbrName: 'AllocVal',
    description: "The allocating party's data value used in the match operation.",
  },
  {
    type: 'String',
    addedEP: '246',
    added: 'FIX.5.0SP2',
    name: 'MatchExceptionConfirmValue',
    id: 2777,
    abbrName: 'CnfmVal',
    description: "The confirming party's data value used in the match operation.",
  },
  {
    type: 'float',
    addedEP: '246',
    added: 'FIX.5.0SP2',
    name: 'MatchExceptionToleranceValue',
    id: 2778,
    abbrName: 'TlrncVal',
    description:
      "The data element's tolerance value. Omitted if no tolerance is allowed or not applicable.",
  },
  {
    type: 'MatchExceptionToleranceValueTypeCodeSet',
    addedEP: '246',
    added: 'FIX.5.0SP2',
    name: 'MatchExceptionToleranceValueType',
    id: 2779,
    abbrName: 'TlrncValTyp',
    description:
      'The type of value in MatchExceptionToleranceValue(2778). Omitted if no tolerance is allowed or not applicable.\n\nFor example, if the tolerance for accrued interest is 0.01% of total accrued interest then MatchExceptionElementType(2774)=1 (Accrued interest), MatchExceptionToleranceValueType(2779)=2 (Percentage) and MatchExcecptionToleranceValue(2778)=0.0001. If tolerance for the exchange rate of an FX trade is "0.001" then MatchExceptionElementType(2774)=2 (Deal pPrice), MatchExceptionToleranceValueType(2779)=1 (Fixed amount) and MatchExcecptionToleranceValue(2778)=0.001.',
  },
  {
    type: 'String',
    addedEP: '246',
    added: 'FIX.5.0SP2',
    name: 'MatchExceptionText',
    id: 2780,
    abbrName: 'Txt',
    description: 'Description of the exception.',
  },
  {
    type: 'NumInGroup',
    addedEP: '246',
    added: 'FIX.5.0SP2',
    name: 'NoMatchingDataPoints',
    id: 2781,
    description: 'Number of matching data points in the repeating group.',
  },
  {
    type: 'MatchingDataPointIndicatorCodeSet',
    addedEP: '246',
    added: 'FIX.5.0SP2',
    name: 'MatchingDataPointIndicator',
    id: 2782,
    abbrName: 'Typ',
    description: "Data point's matching type.",
  },
  {
    type: 'String',
    addedEP: '246',
    added: 'FIX.5.0SP2',
    name: 'MatchingDataPointValue',
    id: 2783,
    abbrName: 'Val',
    description: 'Value of the matching data point.',
  },
  {
    type: 'MatchExceptionElementTypeCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '246',
    added: 'FIX.5.0SP2',
    name: 'MatchingDataPointType',
    id: 2784,
    abbrName: 'ID',
    description:
      'Identifies the data point used in the matching operation.\n\nValues may not have applicable tolerance values, in this case this means the data point was used for matching but did not match.',
  },
  {
    type: 'String',
    addedEP: '246',
    added: 'FIX.5.0SP2',
    name: 'MatchingDataPointName',
    id: 2785,
    abbrName: 'Name',
    description:
      'The matching data point name, for example: "Trade currency". This may be used for display purposes, providing a corresponding description for the value in MatchingDataPointType(2784).',
  },
  {
    type: 'Length',
    addedEP: '246',
    added: 'FIX.5.0SP2',
    name: 'EncodedMatchExceptionTextLen',
    id: 2797,
    abbrName: 'EncTxtLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedMatchExceptionText(2798) field.',
  },
  {
    updated: 'FIX.Latest',
    type: 'data',
    addedEP: '246',
    updatedEP: '271',
    added: 'FIX.5.0SP2',
    name: 'EncodedMatchExceptionText',
    id: 2798,
    abbrName: 'EncTxt',
    lengthId: '2797',
    description:
      'Encoded (non-ASCII characters) representation of the MatchExceptionText(2780) field in the encoded format specified via the MessageEncoding(347) field.\n\nIf used, the ASCII (English) representation should also be specified in the MatchExceptionText(2780) field.',
  },
  {
    type: 'String',
    addedEP: '247',
    added: 'FIX.5.0SP2',
    name: 'TradeAggregationRequestID',
    id: 2786,
    abbrName: 'ReqID',
    description: 'The message identifier for the trade aggregation request.',
  },
  {
    type: 'String',
    addedEP: '247',
    added: 'FIX.5.0SP2',
    name: 'TradeAggregationRequestRefID',
    id: 2787,
    abbrName: 'RefID',
    description:
      'Reference identifier to a previously sent trade aggregation message being cancelled or replaced.',
  },
  {
    type: 'TradeAggregationTransTypeCodeSet',
    addedEP: '247',
    added: 'FIX.5.0SP2',
    name: 'TradeAggregationTransType',
    id: 2788,
    abbrName: 'TransTyp',
    description: 'Identifies the trade aggregation transaction type.',
  },
  {
    type: 'Qty',
    addedEP: '247',
    added: 'FIX.5.0SP2',
    name: 'AggregatedQty',
    id: 2789,
    abbrName: 'AggQty',
    description: 'Total quantity of orders or fills quantity aggregated.',
  },
  {
    type: 'TradeAggregationRequestStatusCodeSet',
    addedEP: '247',
    added: 'FIX.5.0SP2',
    name: 'TradeAggregationRequestStatus',
    id: 2790,
    abbrName: 'ReqStat',
    description: 'Status of the trade aggregation request.',
  },
  {
    type: 'TradeAggregationRejectReasonCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '247',
    added: 'FIX.5.0SP2',
    name: 'TradeAggregationRejectReason',
    id: 2791,
    abbrName: 'RejRsn',
    description: 'Reason for trade aggregation request being rejected.',
  },
  {
    type: 'String',
    addedEP: '247',
    added: 'FIX.5.0SP2',
    name: 'TradeAggregationReportID',
    id: 2792,
    abbrName: 'RptID',
    description: 'Unique identifier for the TradeAggregationReport(35=DX).',
  },
  {
    type: 'Price',
    addedEP: '247',
    added: 'FIX.5.0SP2',
    name: 'AvgSpotRate',
    id: 2793,
    abbrName: 'AvgSpotRt',
    description: 'The average FX spot rate.',
  },
  {
    type: 'PriceOffset',
    addedEP: '247',
    added: 'FIX.5.0SP2',
    name: 'AvgForwardPoints',
    id: 2794,
    abbrName: 'AvgFwdPnts',
    description: 'The average forward points. May be a negative value.',
  },
  {
    type: 'OffshoreIndicatorCodeSet',
    addedEP: '247',
    added: 'FIX.5.0SP2',
    name: 'OffshoreIndicator',
    id: 2795,
    abbrName: 'OffshrInd',
    description:
      'Indicates the type of the currency rate being used. This is relevant for currencies that have offshore rate that different from onshore rate.',
  },
  {
    type: 'String',
    addedEP: '247',
    added: 'FIX.5.0SP2',
    name: 'FXBenchmarkRateFix',
    id: 2796,
    abbrName: 'BnchmkRtFix',
    description:
      'Specifies the foreign exchange benchmark rate fixing to be used in valuing the transaction. For example "London 4 p.m." or "Tokyo 3 p.m."',
  },
  {
    type: 'String',
    addedEP: '249',
    added: 'FIX.5.0SP2',
    name: 'PayReportID',
    id: 2799,
    abbrName: 'RptID',
    description: 'Unique ID of the PayManagementReport(35=EA) message.',
  },
  {
    type: 'int',
    unionDataType: 'Reserved100Plus',
    addedEP: '249',
    added: 'FIX.5.0SP2',
    name: 'PayDisputeReason',
    id: 2800,
    abbrName: 'DsptRsn',
    description:
      'Used to provide the reason for disputing a request or report.\n\nSee https://www.fixtrading.org/packages/PayDisputeReason for the list of applicable values.',
  },
  {
    type: 'data',
    addedEP: '249',
    added: 'FIX.5.0SP2',
    name: 'EncodedReplaceText',
    id: 2801,
    abbrName: 'EncRplcTxt',
    lengthId: '2802',
    description:
      'Encoded (non-ASCII characters) representation of the ReplaceText(2805) field in the encoded format specified via the MessageEncoding(347) field. If used, the ASCII (English) representation should also be specified in the ReplaceText(2805) field.',
  },
  {
    type: 'Length',
    addedEP: '249',
    added: 'FIX.5.0SP2',
    name: 'EncodedReplaceTextLen',
    id: 2802,
    abbrName: 'EncRplcTxtLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedReplaceText(2801) field.',
  },
  {
    type: 'String',
    addedEP: '249',
    added: 'FIX.5.0SP2',
    name: 'PayReportRefID',
    id: 2803,
    abbrName: 'RptRefID',
    description:
      'Reference identifier of the PayManagementReport(35=EA). To be used with PayReportTransType(2804)=1 (Replace).',
  },
  {
    type: 'PayReportTransTypeCodeSet',
    addedEP: '249',
    added: 'FIX.5.0SP2',
    name: 'PayReportTransType',
    id: 2804,
    abbrName: 'TxnTyp',
    description: 'Identifies the message transaction type.',
  },
  {
    type: 'String',
    addedEP: '249',
    added: 'FIX.5.0SP2',
    name: 'ReplaceText',
    id: 2805,
    abbrName: 'RplcTxt',
    description: 'Identifies the reason for amendment.',
  },
  {
    type: 'PayReportStatusCodeSet',
    addedEP: '249',
    added: 'FIX.5.0SP2',
    name: 'PayReportStatus',
    id: 2806,
    abbrName: 'RptStat',
    description: 'Identifies status of the payment report.',
  },
  {
    type: 'String',
    addedEP: '249',
    added: 'FIX.5.0SP2',
    name: 'CancelText',
    id: 2807,
    abbrName: 'CxlTxt',
    description: 'Identifies the reason for cancelation.',
  },
  {
    type: 'data',
    addedEP: '249',
    added: 'FIX.5.0SP2',
    name: 'EncodedCancelText',
    id: 2808,
    abbrName: 'EncCxlTxt',
    lengthId: '2809',
    description:
      'Encoded (non-ASCII characters) representation of the CancelText(2807) field in the encoded format specified via the MessageEncoding(347) field. If used, the ASCII (English) representation should also be specified in the CancelText(2807) field.',
  },
  {
    type: 'Length',
    addedEP: '249',
    added: 'FIX.5.0SP2',
    name: 'EncodedCancelTextLen',
    id: 2809,
    abbrName: 'EncCxlTxtLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedCancelText(2808) field.',
  },
  {
    type: 'String',
    addedEP: '249',
    added: 'FIX.5.0SP2',
    name: 'PayRequestRefID',
    id: 2810,
    abbrName: 'ReqRefID',
    description:
      'Reference identifier of the PayManagementRequest(35=DY). To be used with PayRequestTransType(2811)=1 (Cancel).',
  },
  {
    type: 'PayRequestTransTypeCodeSet',
    addedEP: '249',
    added: 'FIX.5.0SP2',
    name: 'PayRequestTransType',
    id: 2811,
    abbrName: 'TxnTyp',
    description: 'Identifies the message transaction type.',
  },
  {
    type: 'String',
    addedEP: '249',
    added: 'FIX.5.0SP2',
    name: 'PayRequestID',
    id: 2812,
    abbrName: 'ReqID',
    description: 'Unique ID of the PayManagementRequest(35=DY) message.',
  },
  {
    type: 'PayRequestStatusCodeSet',
    addedEP: '249',
    added: 'FIX.5.0SP2',
    name: 'PayRequestStatus',
    id: 2813,
    abbrName: 'ReqStat',
    description: 'Identifies status of the request being responded to.',
  },
  {
    type: 'data',
    addedEP: '249',
    added: 'FIX.5.0SP2',
    name: 'EncodedPostTradePaymentDesc',
    id: 2814,
    abbrName: 'EncDesc',
    lengthId: '2815',
    description:
      'Encoded (non-ASCII characters) representation of the PostTradePaymentDesc(2820) field in the encoded format specified via the MessageEncoding(347) field. If used, the ASCII (English) representation should also be specified in the PostTradePaymentDesc(2820) field.',
  },
  {
    type: 'Length',
    addedEP: '249',
    added: 'FIX.5.0SP2',
    name: 'EncodedPostTradePaymentDescLen',
    id: 2815,
    abbrName: 'EncDescLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedPostTradePaymentDesc(2814) field.',
  },
  {
    type: 'String',
    addedEP: '249',
    added: 'FIX.5.0SP2',
    name: 'PostTradePaymentAccount',
    id: 2816,
    abbrName: 'Acct',
    description:
      'The cash account on the books of the receiver of the request or the sender of the report to be debited or credited.',
  },
  {
    type: 'Amt',
    addedEP: '249',
    added: 'FIX.5.0SP2',
    name: 'PostTradePaymentAmount',
    id: 2817,
    abbrName: 'Amt',
    description: 'The payment amount for the specified PostTradePaymentType(2824).',
  },
  {
    updated: 'FIX.Latest',
    type: 'Currency',
    addedEP: '249',
    updatedEP: '273',
    added: 'FIX.5.0SP2',
    name: 'PostTradePaymentCurrency',
    id: 2818,
    abbrName: 'Ccy',
    description:
      'Specifies the currency in which PostTradePaymentAmount(2817) is denominated.\n\nPostTradePaymentCurrencyCodeSource(2956) may be used to disambiguate the code source scheme used, and ISO 4217 is the default scheme if absent.',
  },
  {
    type: 'PostTradePaymentDebitOrCreditCodeSet',
    addedEP: '249',
    added: 'FIX.5.0SP2',
    name: 'PostTradePaymentDebitOrCredit',
    id: 2819,
    abbrName: 'DbtCrd',
    description:
      "Payment side of this individual payment from the requesting firm's perspective.",
  },
  {
    type: 'String',
    addedEP: '249',
    added: 'FIX.5.0SP2',
    name: 'PostTradePaymentDesc',
    id: 2820,
    abbrName: 'Desc',
    description:
      'A short descriptive name given to the payment, e.g. Premium, Upfront, etc. The description may be used as reference.',
  },
  {
    type: 'String',
    addedEP: '249',
    added: 'FIX.5.0SP2',
    name: 'PostTradePaymentID',
    id: 2821,
    abbrName: 'ID',
    description: 'The identifier for the individual payment.',
  },
  {
    type: 'String',
    addedEP: '249',
    added: 'FIX.5.0SP2',
    name: 'PostTradePaymentLinkID',
    id: 2822,
    abbrName: 'LinkID',
    description:
      'Used to link a group of payments together, e.g. cross-currency payments associated with a swap.',
  },
  {
    type: 'PostTradePaymentStatusCodeSet',
    addedEP: '249',
    added: 'FIX.5.0SP2',
    name: 'PostTradePaymentStatus',
    id: 2823,
    abbrName: 'Stat',
    description: 'Used to indicate the status of a post-trade payment.',
  },
  {
    type: 'String',
    addedEP: '249',
    added: 'FIX.5.0SP2',
    name: 'PostTradePaymentType',
    id: 2824,
    abbrName: 'Typ',
    description:
      'Type of post-trade payment.\n\nSee ISITC "Payments Cash Purpose Codes" for list of payment type codes to use available at https://isitc.org/market-practices/reference-data-and-standards-market-practice and select "ISITC Classification Code List".',
  },
  {
    type: 'LocalMktDate',
    addedEP: '249',
    added: 'FIX.5.0SP2',
    name: 'PostTradePaymentCalculationDate',
    id: 2825,
    abbrName: 'CalcDt',
    description: 'The (actual) date the periodic payments calculations are made.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '249',
    added: 'FIX.5.0SP2',
    name: 'PostTradePaymentValueDate',
    id: 2826,
    abbrName: 'ValuDt',
    description:
      'The adjusted (for holidays and other non-business days) payment date on which the payment is expected to settle.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '249',
    added: 'FIX.5.0SP2',
    name: 'PostTradePaymentFinalValueDate',
    id: 2827,
    abbrName: 'FnlValuDt',
    description: 'The actual or final payment date on which the payment was made.',
  },
  {
    type: 'Price',
    addedEP: '253',
    added: 'FIX.5.0SP2',
    name: 'CurrentDisplayPrice',
    id: 2828,
    abbrName: 'CurDspPx',
    description:
      'Price at which the order is currently displayed to the market. Can be used on order messages, e.g. NewOrderSingle(35=D), to provide the current displayed price of a parent order when splitting it into smaller child orders.\n\nIn the context of US CAT this is used when reporting new child orders.',
  },
  {
    type: 'DuplicateClOrdIDIndicatorCodeSet',
    addedEP: '253',
    added: 'FIX.5.0SP2',
    name: 'DuplicateClOrdIDIndicator',
    id: 2829,
    abbrName: 'DupClOrdIDInd',
    description:
      'Used to indicate that a ClOrdID(11) value is an intentional duplicate of a previously sent value. Allows to avoid the rejection of an order with OrdRejReason(103) = 6 (Duplicate Order).\n\nIn the context of US CAT this can be used when the recipient of a previously routed order requires the same identifier to be re-used for a new route.',
  },
  {
    type: 'EventInitiatorTypeCodeSet',
    addedEP: '253',
    added: 'FIX.5.0SP2',
    name: 'EventInitiatorType',
    id: 2830,
    abbrName: 'EvntInitrTyp',
    description:
      'Indicates the type of entity who initiated an event, e.g. modification or cancellation of an order or quote.',
  },
  {
    type: 'NBBOEntryTypeCodeSet',
    addedEP: '253',
    added: 'FIX.5.0SP2',
    name: 'NBBOEntryType',
    id: 2831,
    abbrName: 'NBBOTyp',
    description: 'Type of NBBO information.',
  },
  {
    type: 'Price',
    addedEP: '253',
    added: 'FIX.5.0SP2',
    name: 'NBBOPrice',
    id: 2832,
    abbrName: 'NBBOPx',
    description:
      'Price related to NBBO. NBBOEntryType(2831) may be used to indicate entry type, e.g. bid or offer.',
  },
  {
    type: 'Qty',
    addedEP: '253',
    added: 'FIX.5.0SP2',
    name: 'NBBOQty',
    id: 2833,
    abbrName: 'NBBOQty',
    description:
      'Quantity related to NBBO. NBBOEntryType(2831) may be used to indicte entry type, e.g. bid or offer.',
  },
  {
    type: 'NBBOSourceCodeSet',
    addedEP: '253',
    added: 'FIX.5.0SP2',
    name: 'NBBOSource',
    id: 2834,
    abbrName: 'NBBOSrc',
    description: 'Source of NBBO information.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'String',
    addedEP: '253',
    updatedEP: '259',
    added: 'FIX.5.0SP2',
    name: 'OrderOriginationFirmID',
    id: 2835,
    abbrName: 'OrigntnFirmID',
    description:
      'Identifier for the original owner of an order as part of the RelatedOrderGrp component. Use the Parties component with PartyRole(452) = 13 (Order Origination Firm) to identify the original owner of an individual order.',
  },
  {
    updated: 'FIX.5.0SP2',
    type: 'UTCTimestamp',
    addedEP: '253',
    updatedEP: '259',
    added: 'FIX.5.0SP2',
    name: 'RelatedOrderTime',
    id: 2836,
    abbrName: 'Tm',
    description: 'Timestamp for the assignment of a (unique) identifier to an order.',
  },
  {
    type: 'SingleQuoteIndicatorCodeSet',
    addedEP: '253',
    added: 'FIX.5.0SP2',
    name: 'SingleQuoteIndicator',
    id: 2837,
    abbrName: 'SnglQteInd',
    description:
      'Used to indicate whether the quoting system allows only one quote to be active at a time for the quote issuer or market maker.',
  },
  {
    type: 'Price',
    addedEP: '253',
    added: 'FIX.5.0SP2',
    name: 'CurrentWorkingPrice',
    id: 2838,
    abbrName: 'CurWrkngPx',
    description:
      'Current working price of the order relative to the state of the order.\n\nIn the context of US CAT this can be used for the current price of the parent order when reporting a split into new (child) orders.',
  },
  {
    type: 'TrdRegTimestampManualIndicatorCodeSet',
    addedEP: '253',
    added: 'FIX.5.0SP2',
    name: 'TrdRegTimestampManualIndicator',
    id: 2839,
    abbrName: 'ManInd',
    description: 'Indicates whether a given timestamp was manually captured.',
  },
  {
    type: 'Percentage',
    addedEP: '254',
    added: 'FIX.5.0SP2',
    name: 'CollateralReinvestmentRate',
    id: 2840,
    abbrName: 'RnvstmntRt',
    description:
      'Interest rate received for collateral reinvestment.\n\nIn the context of EU SFTR this is the reinvestment interest rate received from cash collateral made by the lender. If there are multiple reinvestment types, this is an average rate.',
  },
  {
    type: 'String',
    addedEP: '254',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingRefID',
    id: 2841,
    abbrName: 'UndlyRefID',
    description:
      "Identifies the underlying instrument the entity applies to by referencing the underlying instrument's UnderlyingID(2874).",
  },
  {
    type: 'Amt',
    addedEP: '254',
    added: 'FIX.5.0SP2',
    name: 'CollateralReinvestmentAmount',
    id: 2842,
    abbrName: 'Amt',
    description: 'The cash amount of the specified re-investment type.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Currency',
    addedEP: '254',
    updatedEP: '273',
    added: 'FIX.5.0SP2',
    name: 'CollateralReinvestmentCurrency',
    id: 2843,
    abbrName: 'Ccy',
    description:
      'The currency denomination of the re-invested cash amount.\n\nCollateralReinvestmentCurrencyCodeSource(2931) may be used to disambiguate the code source scheme used, and ISO 4217 is the default scheme if absent.',
  },
  {
    type: 'CollateralReinvestmentTypeCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '254',
    added: 'FIX.5.0SP2',
    name: 'CollateralReinvestmentType',
    id: 2844,
    abbrName: 'Typ',
    description:
      'Indicates the type of investment the cash collateral is re-invested in.',
  },
  {
    type: 'NumInGroup',
    addedEP: '254',
    added: 'FIX.5.0SP2',
    name: 'NoCollateralReinvestments',
    id: 2845,
    description:
      'Number of instances of CollateralReinvestmentType(2844) in the repeating group.',
  },
  {
    type: 'FundingSourceCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '254',
    added: 'FIX.5.0SP2',
    name: 'FundingSource',
    id: 2846,
    abbrName: 'Src',
    description:
      'Specifies the funding source used to finance margin or collateralized loan.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Currency',
    addedEP: '254',
    updatedEP: '273',
    added: 'FIX.5.0SP2',
    name: 'FundingSourceCurrency',
    id: 2847,
    abbrName: 'Ccy',
    description:
      'Currency denomination of the market value of the funding source.\n\nFundingSourceCurrencyCodeSource(2954) may be used to disambiguate the code source scheme used, and ISO 4217 is the default scheme if absent.',
  },
  {
    type: 'Amt',
    addedEP: '254',
    added: 'FIX.5.0SP2',
    name: 'FundingSourceMarketValue',
    id: 2848,
    abbrName: 'MktValu',
    description: 'Market value of the funding source.',
  },
  {
    type: 'NumInGroup',
    addedEP: '254',
    added: 'FIX.5.0SP2',
    name: 'NoFundingSources',
    id: 2849,
    description: 'Number of instances of FundingSource(2846) in the repeating group.',
  },
  {
    type: 'String',
    addedEP: '254',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamOtherDayCount',
    id: 43108,
    abbrName: 'OtherDayCnt',
    description:
      'The industry name of the day count convention not listed in LegPaymentStreamDayCount(40283).',
  },
  {
    type: 'MarginDirectionCodeSet',
    addedEP: '254',
    added: 'FIX.5.0SP2',
    name: 'MarginDirection',
    id: 2851,
    abbrName: 'Dirctn',
    description: 'Indicates whether the margin described is posted or received.',
  },
  {
    type: 'Percentage',
    addedEP: '254',
    added: 'FIX.5.0SP2',
    name: 'PaymentFixedRate',
    id: 43097,
    abbrName: 'Rt',
    description: 'The rate applicable to the fixed rate payment.',
  },
  {
    type: 'String',
    addedEP: '254',
    added: 'FIX.5.0SP2',
    name: 'PaymentFloatingRateIndex',
    id: 43098,
    abbrName: 'Ndx',
    description:
      'The payment floating rate index. See SpreadOrBenchmarkCurveData(221) for suggested values.',
  },
  {
    type: 'int',
    addedEP: '254',
    added: 'FIX.5.0SP2',
    name: 'PaymentFloatingRateIndexCurvePeriod',
    id: 43099,
    abbrName: 'NdxPeriod',
    description: 'Time unit multiplier for the floating rate index.',
  },
  {
    type: 'PaymentStreamRateIndexCurveUnitCodeSet',
    addedEP: '254',
    added: 'FIX.5.0SP2',
    name: 'PaymentFloatingRateIndexCurveUnit',
    id: 43100,
    abbrName: 'NdxUnit',
    description: 'Time unit associated with the floating rate index.',
  },
  {
    type: 'PriceOffset',
    addedEP: '254',
    added: 'FIX.5.0SP2',
    name: 'PaymentFloatingRateSpread',
    id: 43101,
    abbrName: 'Spread',
    description: 'Spread from floating rate index.',
  },
  {
    type: 'int',
    addedEP: '254',
    added: 'FIX.5.0SP2',
    name: 'PaymentFrequencyPeriod',
    id: 43102,
    abbrName: 'FreqPeriod',
    description: 'Time unit multiplier for the payment frequency.',
  },
  {
    type: 'PaymentStreamRateIndexCurveUnitCodeSet',
    addedEP: '254',
    added: 'FIX.5.0SP2',
    name: 'PaymentFrequencyUnit',
    id: 43103,
    abbrName: 'FreqUnit',
    description: 'Time unit associated with the payment frequency.',
  },
  {
    type: 'int',
    addedEP: '254',
    added: 'FIX.5.0SP2',
    name: 'PaymentRateResetFrequencyPeriod',
    id: 43104,
    abbrName: 'ResetFreqPeriod',
    description: 'Time unit multiplier for the floating rate reset frequency.',
  },
  {
    type: 'PaymentStreamRateIndexCurveUnitCodeSet',
    addedEP: '254',
    added: 'FIX.5.0SP2',
    name: 'PaymentRateResetFrequencyUnit',
    id: 43105,
    abbrName: 'ResetFreqUnit',
    description: 'Time unit associated with the floating rate reset frequency.',
  },
  {
    type: 'String',
    addedEP: '254',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamOtherDayCount',
    id: 43106,
    abbrName: 'OtherDayCnt',
    description:
      'The industry name of the day count convention not listed in PaymentStreamDayCount(40742).',
  },
  {
    type: 'Percentage',
    addedEP: '254',
    added: 'FIX.5.0SP2',
    name: 'SideCollateralReinvestmentRate',
    id: 2862,
    abbrName: 'RnvstmntRt',
    description:
      'Interest rate received for collateral reinvestment.\n\nIn the context of EU SFTR this is the reinvestment interest rate received from cash collateral made by the lender. If there are multiple reinvestment types, this is an average rate.',
  },
  {
    type: 'String',
    addedEP: '254',
    added: 'FIX.5.0SP2',
    name: 'SideUnderlyingRefID',
    id: 2863,
    abbrName: 'UndlyRefID',
    description:
      "Identifies the underlying instrument the entity applies to by referencing the underlying instrument's UnderlyingID(2874).",
  },
  {
    type: 'NumInGroup',
    addedEP: '254',
    added: 'FIX.5.0SP2',
    name: 'NoSideCollateralReinvestments',
    id: 2864,
    description:
      'Number of instances of SideCollateralReinvestmentType(2867) in the repeating group.',
  },
  {
    type: 'Amt',
    addedEP: '254',
    added: 'FIX.5.0SP2',
    name: 'SideCollateralReinvestmentAmount',
    id: 2865,
    abbrName: 'Amt',
    description: 'The cash amount of the specified re-investment type.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Currency',
    addedEP: '254',
    updatedEP: '273',
    added: 'FIX.5.0SP2',
    name: 'SideCollateralReinvestmentCurrency',
    id: 2866,
    abbrName: 'Ccy',
    description:
      'The currency denomination of the re-invested cash amount.\n\nSideCollateralReinvestmentCurrencyCodeSource(2932) may be used to disambiguate the code source scheme used, and ISO 4217 is the default scheme if absent.',
  },
  {
    type: 'CollateralReinvestmentTypeCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '254',
    added: 'FIX.5.0SP2',
    name: 'SideCollateralReinvestmentType',
    id: 2867,
    abbrName: 'Typ',
    description:
      'Indicates the type of investment the cash collateral is re-invested in.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '254',
    added: 'FIX.5.0SP2',
    name: 'CollateralizationValueDate',
    id: 2868,
    abbrName: 'CollztnValuDt',
    description: 'Date when the collateral is to be assessed or assigned.',
  },
  {
    type: 'LocalMktDate',
    addedEP: '254',
    added: 'FIX.5.0SP2',
    name: 'RegulatoryReportTypeBusinessDate',
    id: 2869,
    abbrName: 'RegRptTypBizDt',
    description:
      'The business date on which the event identified in RegulatoryReportType(1934) took place.\n\nIn the context of EU SFTR reports with a RegulatoryReportType(1934) value 7 (Post-trade valuation), 31 (Collateral update) or 32 (Margin update), the business date on which the business event took place, which results in the information contained in the report.',
  },
  {
    type: 'String',
    addedEP: '254',
    added: 'FIX.5.0SP2',
    name: 'ClearingPortfolioID',
    id: 2870,
    abbrName: 'ClrPrtflioID',
    description:
      'When the transaction is cleared and included in a portfolio of transactions this identifies the portfolio by its unique identifier.\n\nIn the context of EU SFTR reporting this applies to cleared transactions grouped in a portfolio for which margins are exchanged.',
  },
  {
    type: 'NumInGroup',
    addedEP: '254',
    added: 'FIX.5.0SP2',
    name: 'NoTransactionAttributes',
    id: 2871,
    description:
      'Number of instances of TransactionAttributeType(2872) in the repeating group.',
  },
  {
    type: 'TransactionAttributeTypeCodeSet',
    addedEP: '254',
    added: 'FIX.5.0SP2',
    name: 'TransactionAttributeType',
    id: 2872,
    abbrName: 'Typ',
    description:
      'Type of attribute(s) or characteristic(s) associated with the transaction.',
  },
  {
    type: 'String',
    addedEP: '254',
    added: 'FIX.5.0SP2',
    name: 'TransactionAttributeValue',
    id: 2873,
    abbrName: 'Valu',
    description: 'Value associated with the specificed TransactionAttributeType(2872).',
  },
  {
    type: 'String',
    addedEP: '254',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingID',
    id: 2874,
    abbrName: 'UdlyID',
    description:
      'Unique identifier for the underlying instrument within the context of a message.\n\nThe UnderlyingID(2874) can be referenced by other fields, for example UnderlyingRefID(tbd2841) and SideUnderlyingRefID(2863), from other components . The scope of uniqueness is agreed upon between counterparties.',
  },
  {
    type: 'String',
    addedEP: '254',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamOtherDayCount',
    id: 43107,
    abbrName: 'OtherDayCnt',
    description:
      'The industry name of the day count convention not listed in UnderlyingPaymentStreamDayCount(40572).',
  },
  {
    type: 'Price',
    addedEP: '254',
    added: 'FIX.5.0SP2',
    name: 'PosAmtPrice',
    id: 2876,
    abbrName: 'Px',
    description:
      "The price used to calculate the PosAmt(708).\n\nThis may be used for certain PosAmtType(707) values where the PosAmt(708) is based on the current price of the position's security. In the context of EU SFTR reporting, this is the price used to calculate the loan value for securities loan and borrowing, and buy-sell back. The price may be expressed in units or percentage of the underlying security, yield or an absolute amount that ignores netting. For Buy/Sellback it expresses the initial spot price.",
  },
  {
    type: 'PriceTypeCodeSet',
    addedEP: '254',
    added: 'FIX.5.0SP2',
    name: 'PosAmtPriceType',
    id: 2877,
    abbrName: 'PxTyp',
    description: 'Specifies the type of price for PosAmtPrice(2876).',
  },
  {
    type: 'LocalMktDate',
    addedEP: '254',
    added: 'FIX.5.0SP2',
    name: 'TerminationDate',
    id: 2878,
    abbrName: 'TmntnDt',
    description:
      "The date of a contract's early termination or other post-trade event when the event is prior to the contract natural end or maturity not defined as part of the security's reference data or contractual terms/agreement.",
  },
  {
    type: 'String',
    addedEP: '254',
    added: 'FIX.5.0SP2',
    name: 'CouponOtherDayCount',
    id: 2879,
    abbrName: 'CpnOtherDayCnt',
    description:
      'The industry name of the day count convention not listed in CouponDayCount(1950).',
  },
  {
    type: 'String',
    addedEP: '254',
    added: 'FIX.5.0SP2',
    name: 'LegCouponOtherDayCount',
    id: 2880,
    abbrName: 'CpnOtherDayCnt',
    description:
      'The industry name of the day count convention not listed in LegCouponDayCount(2165).',
  },
  {
    type: 'String',
    addedEP: '254',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingCouponOtherDayCount',
    id: 2881,
    abbrName: 'CpnOtherDayCnt',
    description:
      'The industry name of the day count convention not listed in UnderlyingCouponDayCount(1993).',
  },
  {
    type: 'OrderOriginationCodeSet',
    addedEP: '256',
    added: 'FIX.5.0SP2',
    name: 'ContraOrderOrigination',
    id: 2882,
    abbrName: 'CntraOrdOrigntn',
    description:
      'Identifies the origin of the order from the counterparty of the execution or trade.',
  },
  {
    type: 'RoutingArrangmentIndicatorCodeSet',
    addedEP: '256',
    added: 'FIX.5.0SP2',
    name: 'RoutingArrangmentIndicator',
    id: 2883,
    abbrName: 'RtgArngmntInd',
    description:
      'Indicates whether a routing arrangement is in place, e.g. between two brokers. May be used together with OrderOrigination(1724) to further describe the origin of an order.\n\nAn arrangement under which a participant of a marketplace permits a broker to electronically transmit orders containing the identifier of the participant. This can be either through the systems of the participant for automatic onward transmission to a marketplace or directly to a marketplace without being electronically transmitted through the systems of the participant.',
  },
  {
    type: 'RoutingArrangmentIndicatorCodeSet',
    addedEP: '256',
    added: 'FIX.5.0SP2',
    name: 'ContraRoutingArrangmentIndicator',
    id: 2884,
    abbrName: 'CntraRtgArngmntInd',
    description:
      'Indicates whether a routing arrangement is in place, e.g. between two brokers. May be used together with ContraOrderOrigination(2882) to further describe the origin of an order.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Length',
    addedEP: '257',
    updatedEP: '275',
    added: 'FIX.5.0SP2',
    name: 'PaymentStreamFormulaLength',
    id: 43109,
    abbrName: 'FrmlaLen',
    description:
      'Byte length of encoded (non-ASCII characters) PaymentStreamFormula(42648) field.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Length',
    addedEP: '257',
    updatedEP: '275',
    added: 'FIX.5.0SP2',
    name: 'LegPaymentStreamFormulaLength',
    id: 43110,
    abbrName: 'FrmlaLen',
    description:
      'Byte length of encoded (non-ASCII characters) LegPaymentStreamFormula(42486) field.',
  },
  {
    updated: 'FIX.Latest',
    type: 'Length',
    addedEP: '257',
    updatedEP: '275',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingPaymentStreamFormulaLength',
    id: 43111,
    abbrName: 'FrmlaLen',
    description:
      'Byte length of encoded (non-ASCII characters) UnderlyingPaymentStreamFormula(42982) field.',
  },
  {
    type: 'Amt',
    addedEP: '258',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingAccruedInterestAmt',
    id: 2885,
    abbrName: 'AcrdIntAmt',
    description: 'Amount of accrued interest of underlying security.',
  },
  {
    type: 'int',
    addedEP: '258',
    added: 'FIX.5.0SP2',
    name: 'UnderlyingNumDaysInterest',
    id: 2886,
    abbrName: 'NumDaysInt',
    description: 'Number of days of interest for underlying security.',
  },
  {
    type: 'String',
    addedEP: '259',
    added: 'FIX.5.0SP2',
    name: 'RelatedOrderID',
    id: 2887,
    abbrName: 'ID',
    discriminatorId: '2888',
    description: 'Identifier of a related order.',
  },
  {
    type: 'RelatedOrderIDSourceCodeSet',
    addedEP: '259',
    added: 'FIX.5.0SP2',
    name: 'RelatedOrderIDSource',
    id: 2888,
    abbrName: 'Src',
    description:
      'Describes the source of the identifier that RelatedOrderID(2887) represents.',
  },
  {
    type: 'Qty',
    addedEP: '259',
    added: 'FIX.5.0SP2',
    name: 'RelatedOrderQty',
    id: 2889,
    abbrName: 'Qty',
    description:
      'Quantity of the related order which can be less than its total quantity. For example, when only parts of an order contribute to an aggregated order.',
  },
  {
    type: 'OrderRelationshipCodeSet',
    addedEP: '259',
    added: 'FIX.5.0SP2',
    name: 'OrderRelationship',
    id: 2890,
    abbrName: 'Rltnshp',
    description:
      'Describes the type of relationship between the order identified by RelatedOrderID(2887) and the order outside of the RelatedOrderGrp component.',
  },
  {
    type: 'String',
    addedEP: '266',
    added: 'FIX.Latest',
    name: 'UPICode',
    id: 2891,
    abbrName: 'UPI',
    description:
      'Uniquely identifies the product of a security using ISO 4914 standard, Unique Product Identifier (UPI). The DSB (Derivative Service Bureau Ltd) is acting as designated service provider for UPI System.',
  },
  {
    updated: 'FIX.Latest',
    type: 'String',
    addedEP: '266',
    updatedEP: '271',
    added: 'FIX.Latest',
    name: 'DerivativeUPICode',
    id: 2892,
    abbrName: 'UPI',
    description:
      'Uniquely identifies the product of a derivative instrument using ISO 4914. See UPICode(2891) for complete definition.',
  },
  {
    type: 'String',
    addedEP: '266',
    added: 'FIX.Latest',
    name: 'LegUPICode',
    id: 2893,
    abbrName: 'UPI',
    description:
      'Uniquely identifies the product of a leg instrument using ISO 4914. See UPICode(2891) for further detail.',
  },
  {
    type: 'String',
    addedEP: '266',
    added: 'FIX.Latest',
    name: 'UnderlyingUPICode',
    id: 2894,
    abbrName: 'UPI',
    description:
      'Uniquely identifies the product of an underlying instrument using ISO 4914. See UPICode(2891) for further detail.',
  },
  {
    type: 'String',
    addedEP: '266',
    added: 'FIX.Latest',
    name: 'InstrumentScopeUPICode',
    id: 2895,
    abbrName: 'UPI',
    description:
      'Uniquely identifies the product of a security using ISO 4914 as filter criteria. See UPICode(2891) for further detail.',
  },
  {
    type: 'TrdTypeCodeSet',
    unionDataType: 'Reserved1000Plus',
    addedEP: '268',
    added: 'FIX.Latest',
    name: 'TertiaryTrdType',
    id: 2896,
    abbrName: 'TrdTyp3',
    description:
      'Type of trade assigned to a trade. Used in addition to TrdType(828) and SecondaryTrdType(855). Must not be used when only one additional trade type needs to be assigned.',
  },
  {
    type: 'String',
    addedEP: '271',
    added: 'FIX.Latest',
    name: 'PaymentStreamRateIndex2',
    id: 43112,
    abbrName: 'Ndx2',
    discriminatorId: '43113',
    description: "The payment stream's second floating rate index.",
  },
  {
    type: 'PaymentStreamRateIndexSourceCodeSet',
    addedEP: '271',
    added: 'FIX.Latest',
    name: 'PaymentStreamRateIndex2Source',
    id: 43113,
    abbrName: 'Ndx2Src',
    description: "The source of the payment stream's second floating rate index.",
  },
  {
    type: 'String',
    addedEP: '271',
    added: 'FIX.Latest',
    name: 'PaymentStreamRateIndex2ID',
    id: 43114,
    abbrName: 'Ndx2ID',
    discriminatorId: '43115',
    description: 'Security identifier of the second floating rate index.',
  },
  {
    type: 'SecurityIDSourceCodeSet',
    addedEP: '271',
    added: 'FIX.Latest',
    name: 'PaymentStreamRateIndex2IDSource',
    id: 43115,
    abbrName: 'Ndx2IDSrc',
    description:
      'Source for the second floating rate index identified in PaymentStreamRateIndex2ID(43114).',
  },
  {
    type: 'String',
    addedEP: '271',
    added: 'FIX.Latest',
    name: 'LegPaymentStreamRateIndex2',
    id: 43116,
    abbrName: 'Ndx2',
    discriminatorId: '43117',
    description: "The payment stream's second floating rate index.",
  },
  {
    type: 'PaymentStreamRateIndexSourceCodeSet',
    addedEP: '271',
    added: 'FIX.Latest',
    name: 'LegPaymentStreamRateIndex2Source',
    id: 43117,
    abbrName: 'Ndx2Src',
    description: "The source of the payment stream's second floating rate index.",
  },
  {
    type: 'String',
    addedEP: '271',
    added: 'FIX.Latest',
    name: 'LegPaymentStreamRateIndex2ID',
    id: 43118,
    abbrName: 'Ndx2ID',
    discriminatorId: '43119',
    description: 'Security identifier of the second floating rate index.',
  },
  {
    type: 'SecurityIDSourceCodeSet',
    addedEP: '271',
    added: 'FIX.Latest',
    name: 'LegPaymentStreamRateIndex2IDSource',
    id: 43119,
    abbrName: 'Ndx2IDSrc',
    description:
      'Source for the second floating rate index identified in LegPaymentStreamRateIndex2ID(43118).',
  },
  {
    type: 'String',
    addedEP: '271',
    added: 'FIX.Latest',
    name: 'UnderlyingPaymentStreamRateIndex2',
    id: 43120,
    abbrName: 'Ndx2',
    discriminatorId: '43121',
    description: "The payment stream's second floating rate index.",
  },
  {
    type: 'PaymentStreamRateIndexSourceCodeSet',
    addedEP: '271',
    added: 'FIX.Latest',
    name: 'UnderlyingPaymentStreamRateIndex2Source',
    id: 43121,
    abbrName: 'Ndx2Src',
    description: "The source of the payment stream's second floating rate index.",
  },
  {
    type: 'String',
    addedEP: '271',
    added: 'FIX.Latest',
    name: 'UnderlyingPaymentStreamRateIndex2ID',
    id: 43122,
    abbrName: 'Ndx2ID',
    discriminatorId: '43123',
    description: 'Security identifier of the second floating rate index.',
  },
  {
    type: 'SecurityIDSourceCodeSet',
    addedEP: '271',
    added: 'FIX.Latest',
    name: 'UnderlyingPaymentStreamRateIndex2IDSource',
    id: 43123,
    abbrName: 'Ndx2IDSrc',
    description:
      'Source for the second floating rate index identified in UnderlyingPaymentStreamRateIndex2ID(43122).',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'CurrencyCodeSource',
    id: 2897,
    abbrName: 'CcySrc',
    description: 'Identifies class or source of the Currency(15) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'LegCurrencyCodeSource',
    id: 2898,
    abbrName: 'CcySrc',
    description: 'Identifies class or source of the LegCurrency(556) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'SettlCurrencyCodeSource',
    id: 2899,
    abbrName: 'SettlCcySrc',
    description: 'Identifies class or source of the SettlCurrency(120) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'LegSettlCurrencyCodeSource',
    id: 2900,
    abbrName: 'SettlCcySrc',
    description: 'Identifies class or source of the LegSettlCurrency(675) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'SideCurrencyCodeSource',
    id: 2901,
    abbrName: 'CcySrc',
    description: 'Identifies class or source of the SideCurrency(1154) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'SideSettlCurrencyCodeSource',
    id: 2902,
    abbrName: 'SettlCcySrc',
    description: 'Identifies class or source of the SideSettlCurrency(1155) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'SettlementAmountCurrencyCodeSource',
    id: 2903,
    abbrName: 'CcySrc',
    description:
      'Identifies class or source of the SettlementAmountCurrency(1702) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'StrikeCurrencyCodeSource',
    id: 2904,
    abbrName: 'StrkCcySrc',
    description: 'Identifies class or source of the StrikeCurrency(947) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'UnitOfMeasureCurrencyCodeSource',
    id: 2905,
    abbrName: 'UOMCcySrc',
    description: 'Identifies class or source of the UnitOfMeasureCurrency(1716) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'PriceUnitOfMeasureCurrencyCodeSource',
    id: 2906,
    abbrName: 'PxUOMCcySrc',
    description:
      'Identifies class or source of the PriceUnitOfMeasureCurrency(1717) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'PriceQuoteCurrencyCodeSource',
    id: 2907,
    abbrName: 'PxQteCcySrc',
    description: 'Identifies class or source of the PriceQuoteCurrency(1524) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'LegStrikeCurrencyCodeSource',
    id: 2908,
    abbrName: 'StrkCcySrc',
    description: 'Identifies class or source of the LegStrikeCurrency(942) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'LegUnitOfMeasureCurrencyCodeSource',
    id: 2909,
    abbrName: 'UOMCcySrc',
    description:
      'Identifies class or source of the LegUnitOfMeasureCurrency(1720) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'LegPriceUnitOfMeasureCurrencyCodeSource',
    id: 2910,
    abbrName: 'PxUOMCcySrc',
    description:
      'Identifies class or source of the LegPriceUnitOfMeasureCurrency(1721) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'LegPriceQuoteCurrencyCodeSource',
    id: 2911,
    abbrName: 'PxQteCcySrc',
    description: 'Identifies class or source of the LegPriceQuoteCurrency(1528) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'DerivativeStrikeCurrencyCodeSource',
    id: 2912,
    abbrName: 'StrkCcySrc',
    description:
      'Identifies class or source of the DerivativeStrikeCurrency(1262) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'DerivativeUnitOfMeasureCurrencyCodeSource',
    id: 2913,
    abbrName: 'UOMCcySrc',
    description:
      'Identifies class or source of the DerivativeUnitOfMeasureCurrency(1722) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'DerivativePriceUnitOfMeasureCurrencyCodeSource',
    id: 2914,
    abbrName: 'PxUOMCcySrc',
    description:
      'Identifies class or source of the DerivativePriceUnitOfMeasureCurrency(1723) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'DerivativePriceQuoteCurrencyCodeSource',
    id: 2915,
    abbrName: 'PxQteCcySrc',
    description:
      'Identifies class or source of the DerivativePriceQuoteCurrency(1576) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'UnderlyingCurrencyCodeSource',
    id: 2916,
    abbrName: 'CcySrc',
    description: 'Identifies class or source of the UnderlyingCurrency(318) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'UnderlyingStrikeCurrencyCodeSource',
    id: 2917,
    abbrName: 'StrkCcySrc',
    description: 'Identifies class or source of the UnderlyingStrikeCurrency(941) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'UnderlyingUnitOfMeasureCurrencyCodeSource',
    id: 2918,
    abbrName: 'UOMCcySrc',
    description:
      'Identifies class or source of the UnderlyingUnitOfMeasureCurrency(1718) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'UnderlyingPriceUnitOfMeasureCurrencyCodeSource',
    id: 2919,
    abbrName: 'PxUOMCcySrc',
    description:
      'Identifies class or source of the UnderlyingPriceUnitOfMeasureCurrency(1719) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'UnderlyingPriceQuoteCurrencyCodeSource',
    id: 2920,
    abbrName: 'PxQteCcySrc',
    description:
      'Identifies class or source of the UnderlyingPriceQuoteCurrency(1526) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'UnderlyingNotionalCurrencyCodeSource',
    id: 2921,
    abbrName: 'NotlCcySrc',
    description:
      'Identifies class or source of the UnderlyingNotionalCurrency(2615) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'CommCurrencyCodeSource',
    id: 2922,
    abbrName: 'CcySrc',
    description: 'Identifies class or source of the CommCurrency(479) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'CommissionCurrencyCodeSource',
    id: 2923,
    abbrName: 'CcySrc',
    description: 'Identifies class or source of the CommissionCurrency(2643) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'CommissionUnitOfMeasureCurrencyCodeSource',
    id: 2924,
    abbrName: 'UOMCcySrc',
    description:
      'Identifies class or source of the CommissionUnitOfMeasureCurrency(2645) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'AllocCommissionCurrencyCodeSource',
    id: 2925,
    abbrName: 'CcySrc',
    description: 'Identifies class or source of the AllocCommissionCurrency(2657) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'AllocCommissionUnitOfMeasureCurrencyCodeSource',
    id: 2926,
    abbrName: 'UOMCcySrc',
    description:
      'Identifies class or source of the AllocCommissionUnitOfMeasureCurrency(2659) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'AllocSettlCurrencyCodeSource',
    id: 2927,
    abbrName: 'AllocSettlCcySrc',
    description: 'Identifies class or source of the AllocSettlCurrency(736) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'LegAllocSettlCurrencyCodeSource',
    id: 2928,
    abbrName: 'AllocSettlCcySrc',
    description: 'Identifies class or source of the LegAllocSettlCurrency(1367) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'CollateralCurrencyCodeSource',
    id: 2929,
    abbrName: 'CcySrc',
    description: 'Identifies class or source of the CollateralCurrency(1705) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'SideCollateralCurrencyCodeSource',
    id: 2930,
    abbrName: 'CcySrc',
    description: 'Identifies class or source of the SideCollateralCurrency(2695) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'CollateralReinvestmentCurrencyCodeSource',
    id: 2931,
    abbrName: 'CcySrc',
    description:
      'Identifies class or source of the CollateralReinvestmentCurrency(2843) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'SideCollateralReinvestmentCurrencyCodeSource',
    id: 2932,
    abbrName: 'CcySrc',
    description:
      'Identifies class or source of the SideCollateralReinvestmentCurrency(2866) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'TradeAllocCurrencyCodeSource',
    id: 2933,
    abbrName: 'CcySrc',
    description: 'Identifies class or source of the TradeAllocCurrency(1847) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'TradingCurrencyCodeSource',
    id: 2934,
    abbrName: 'TrdCcySrc',
    description: 'Identifies class or source of the TradingCurrency(1245) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'LimitAmtCurrencyCodeSource',
    id: 2935,
    abbrName: 'LmtAmtCcySrc',
    description: 'Identifies class or source of the LimitAmtCurrency(1634) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'PosQtyUnitOfMeasureCurrencyCodeSource',
    id: 2936,
    abbrName: 'UOMCcySrc',
    description:
      'Identifies class or source of the PosQtyUnitOfMeasureCurrency(1835) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'PositionCurrencyCodeSource',
    id: 2937,
    abbrName: 'CcySrc',
    description: 'Identifies class or source of the PositionCurrency(1055) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'LegPosCurrencyCodeSource',
    id: 2938,
    abbrName: 'CcySrc',
    description: 'Identifies class or source of the LegPosCurrency(1589) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'RiskLimitCurrencyCodeSource',
    id: 2939,
    abbrName: 'CcySrc',
    description: 'Identifies class or source of the RiskLimitCurrency(1532) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'EntitlementAttribCurrencyCodeSource',
    id: 2940,
    abbrName: 'CcySrc',
    description:
      'Identifies class or source of the EntitlementAttribCurrency(1781) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'ComplexOptPayoutCurrencyCodeSource',
    id: 2941,
    abbrName: 'OptCcySrc',
    description:
      'Identifies class or source of the ComplexOptPayoutCurrency(2122) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'ComplexEventCurrencyOneCodeSource',
    id: 2942,
    abbrName: 'Ccy1Src',
    description: 'Identifies class or source of the ComplexEventCurrencyOne(2124) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'ComplexEventCurrencyTwoCodeSource',
    id: 2943,
    abbrName: 'Ccy2Src',
    description: 'Identifies class or source of the ComplexEventCurrencyTwo(2125) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'LegComplexOptPayoutCurrencyCodeSource',
    id: 2944,
    abbrName: 'OptCcySrc',
    description:
      'Identifies class or source of the LegComplexOptPayoutCurrency(2226) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'LegComplexEventCurrencyOneCodeSource',
    id: 2945,
    abbrName: 'Ccy1Src',
    description:
      'Identifies class or source of the LegComplexEventCurrencyOne(2233) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'LegComplexEventCurrencyTwoCodeSource',
    id: 2946,
    abbrName: 'Ccy2Src',
    description:
      'Identifies class or source of the LegComplexEventCurrencyTwo(2234) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'UnderlyingComplexOptPayoutCurrencyCodeSource',
    id: 2947,
    abbrName: 'OptCcySrc',
    description:
      'Identifies class or source of the UnderlyingComplexOptPayoutCurrency(2266) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'UnderlyingComplexEventCurrencyOneCodeSource',
    id: 2948,
    abbrName: 'Ccy1Src',
    description:
      'Identifies class or source of the UnderlyingComplexEventCurrencyOne(2268) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'UnderlyingComplexEventCurrencyTwoCodeSource',
    id: 2949,
    abbrName: 'Ccy2Src',
    description:
      'Identifies class or source of the UnderlyingComplexEventCurrencyTwo(2269) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'BenchmarkCurveCurrencyCodeSource',
    id: 2950,
    abbrName: 'CcySrc',
    description: 'Identifies class or source of the BenchmarkCurveCurrency(220) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'LegBenchmarkCurveCurrencyCodeSource',
    id: 2951,
    abbrName: 'CcySrc',
    description:
      'Identifies class or source of the LegBenchmarkCurveCurrency(676) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'AgreementCurrencyCodeSource',
    id: 2952,
    abbrName: 'AgmtCcySrc',
    description: 'Identifies class or source of the AgreementCurrency(918) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'LegAgreementCurrencyCodeSource',
    id: 2953,
    abbrName: 'AgmtCcySrc',
    description: 'Identifies class or source of the LegAgreementCurrency(2495) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'FundingSourceCurrencyCodeSource',
    id: 2954,
    abbrName: 'CcySrc',
    description: 'Identifies class or source of the FundingSourceCurrency(2847) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'PayCollectCurrencyCodeSource',
    id: 2955,
    abbrName: 'CcySrc',
    description: 'Identifies class or source of the PayCollectCurrency(1709) value.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'PostTradePaymentCurrencyCodeSource',
    id: 2956,
    abbrName: 'CcySrc',
    description:
      'Identifies class or source of the PostTradePaymentCurrency(2818) value.',
  },
  {
    type: 'int',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'SymbolPositionNumber',
    id: 2957,
    abbrName: 'SymPosNum',
    description:
      'Reference to the first or second currency or digital asset in Symbol(55) for FX-style trading.\n\nConditionally required when one or both symbols in Symbol(55) represent a digital asset.',
  },
  {
    type: 'int',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'LegSymbolPositionNumber',
    id: 2958,
    abbrName: 'SymPosNum',
    description:
      'Reference to the first or second currency or digital asset in LegSymbol(600) for FX-style trading.\n\nConditionally required when one or both symbols in LegSymbol(600) represent a digital asset.',
  },
  {
    type: 'int',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'UnderlyingSymbolPositionNumber',
    id: 2959,
    abbrName: 'SymPosNum',
    description:
      'Reference to the first or second currency or digital asset in UnderlyingSymbol(311) for FX-style trading.\n\nConditionally required when one or both symbols in UnderlyingSymbol(311) represent a digital asset.',
  },
  {
    type: 'CurrencyCodeSourceCodeSet',
    addedEP: '273',
    added: 'FIX.Latest',
    name: 'SettlPriceUnitOfMeasureCurrencyCodeSource',
    id: 2960,
    abbrName: 'SetPxUOMCcySrc',
    description:
      'Identifies the class or source of the SettlPriceUnitOfMeasureCurrency(1887) value.',
  },
  {
    type: 'Boolean',
    addedEP: '274',
    added: 'FIX.Latest',
    name: 'AnonymousTradeIndicator',
    id: 2961,
    abbrName: 'AnonymsTrdInd',
    description: 'Indicates whether the trade or transaction was executed anonymously.',
  },
  {
    type: 'String',
    addedEP: '276',
    added: 'FIX.Latest',
    name: 'SecurityReferenceDataSupplement',
    id: 2962,
    abbrName: 'SecRefDataSupplmnt',
    description:
      'May be used to generically assist in disambiguating an instrument where the security identifier and core reference data attributes are not sufficient to uniquely identify the instrument. The values used are bilaterally agreed.\n\nThe data used for disambiguation can be of synthetic nature (e.g. 1, 2, 3,... or A, B, C,...) or based on other characteristic of the instrument. An example of the latter is an energy futures or options contract which may have the same expiration date with different delivery dates that fall on a non-business day; in such a use case the first day of delivery date may be used to disambiguate such contract (date expression used should be bilaterally agreed).',
  },
  {
    type: 'MultiJurisdictionReportingIndicatorCodeSet',
    addedEP: '277',
    added: 'FIX.Latest',
    name: 'MultiJurisdictionReportingIndicator',
    id: 2963,
    abbrName: 'MultiJrsdctnRptInd',
    description:
      'Indicate whether a trade is eligible to be reported to more than one regulatory jurisdictions, e.g. due to overlapping reporting rules that require reporting to different jurisdictions.',
  },
  {
    type: 'SelfMatchPreventionInstructionCodeSet',
    addedEP: '280',
    added: 'FIX.Latest',
    name: 'SelfMatchPreventionInstruction',
    id: 2964,
    abbrName: 'SlfMtchPrvntnInst',
    description:
      'Indicate the instruction for self-match prevention when the incoming (aggressive) order has the same SelfMatchPreventionID(2362) as a resting (passive) order.',
  },
  {
    type: 'String',
    addedEP: '281',
    added: 'FIX.Latest',
    name: 'SettlStatusRequestID',
    id: 2965,
    abbrName: 'ReqID',
    description: 'Unique identifier of the SettlementStatusRequest(35=EC).',
  },
  {
    type: 'SettlStatusRequestStatusCodeSet',
    addedEP: '281',
    added: 'FIX.Latest',
    name: 'SettlStatusRequestStatus',
    id: 2966,
    abbrName: 'ReqStat',
    description:
      'Status of the SettlementStatusRequest(35=EC) message being responded to.',
  },
  {
    type: 'String',
    addedEP: '281',
    added: 'FIX.Latest',
    name: 'SettlStatusReportID',
    id: 2967,
    abbrName: 'RptID',
    description: 'Unique identifier of the SettlementStatusReport(35=EE).',
  },
  {
    type: 'String',
    addedEP: '281',
    added: 'FIX.Latest',
    name: 'SettlStatus',
    id: 2968,
    abbrName: 'SettlStat',
    description:
      'The settlement status of the identified trade.\n\nThis field mirrors MT548 subsequence A2 field 25D Status Code. See https://www.iso20022.org/15022/uhb/mt548-10-field-25d.htm for MT548 code values.',
  },
  {
    type: 'String',
    addedEP: '281',
    added: 'FIX.Latest',
    name: 'SettlStatusReason',
    id: 2969,
    abbrName: 'SettlStatRsn',
    description:
      'Used to provide additional reason or qualify the reason for the settlement status specified in SettlStatus(2968).\n\nThis field mirrors MT548 subsequence A2a field 24B Reason Code. See https://www.iso20022.org/15022/uhb/mt548-12-field-24b.htm for MT548 code values.',
  },
  {
    type: 'String',
    addedEP: '281',
    added: 'FIX.Latest',
    name: 'SettlStatusReasonText',
    id: 2970,
    abbrName: 'SettlStatRsnTxt',
    description:
      'Text description associated with SettlStatusReason(2969).\n\nThis field mirrors MT548 subsequence A2a field 70D Narrative.',
  },
  {
    type: 'Length',
    addedEP: '281',
    added: 'FIX.Latest',
    name: 'EncodedSettlStatusReasonTextLen',
    id: 2971,
    abbrName: 'EncSettlStatRsnTxtLen',
    description:
      'Byte length of encoded (non-ASCII characters) EncodedSettlStatusReasonText(2972) field.',
  },
  {
    type: 'data',
    addedEP: '281',
    added: 'FIX.Latest',
    name: 'EncodedSettlStatusReasonText',
    id: 2972,
    abbrName: 'EncSettlStatRsnTxt',
    lengthId: '2971',
    description:
      'Encoded (non-ASCII characters) representation of the SettlStatusReasonText(2970) field in the encoded format specified via the MessageEncoding(347) field. If used, the ASCII (English) representation should also be specified in the SettlStatusReasonText(2970) field.',
  },
  {
    type: 'SettlStatusReportStatusCodeSet',
    addedEP: '281',
    added: 'FIX.Latest',
    name: 'SettlStatusReportStatus',
    id: 2973,
    abbrName: 'Stat',
    description: 'Status of the report being responded to.',
  },
  {
    type: 'String',
    addedEP: '285',
    added: 'FIX.Latest',
    name: 'AllocGroupSubQtyID',
    id: 2974,
    abbrName: 'GrpSubQtyID',
    description: 'Identifier for quantity subgroup assigned by the clearinghouse.',
  },
  {
    type: 'NumInGroup',
    addedEP: '285',
    added: 'FIX.Latest',
    name: 'NoAllocGroupSubQtys',
    id: 2975,
    description: 'Indicates number of subgroups in an allocation group.',
  },
  {
    type: 'Qty',
    addedEP: '285',
    added: 'FIX.Latest',
    name: 'AllocGroupSubQty',
    id: 2976,
    abbrName: 'Qty',
    description: 'Total quantity in the subgroup of an allocation group.',
  },
  {
    type: 'Qty',
    addedEP: '285',
    added: 'FIX.Latest',
    name: 'AllocGroupSubQtyOffset',
    id: 2977,
    abbrName: 'QtyOfst',
    description: 'Change in quantity in the subgroup of an allocation group.',
  },
  {
    type: 'Qty',
    addedEP: '285',
    added: 'FIX.Latest',
    name: 'AllocGroupRemainingSubQty',
    id: 2978,
    abbrName: 'RemQty',
    description: 'Remaining quantity in the subgroup of an allocation group.',
  },
  {
    type: 'NumInGroup',
    addedEP: '285',
    added: 'FIX.Latest',
    name: 'NoAllocGroupSubQtyAttributes',
    id: 2979,
    description:
      'Indicates number of trade attributes used to define a subgroup in an allocation group.',
  },
  {
    type: 'AllocGroupSubQtyTypeCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '285',
    added: 'FIX.Latest',
    name: 'AllocGroupSubQtyType',
    id: 2980,
    abbrName: 'Typ',
    description: 'Type of trade attribute defining a subgroup in an allocation group.',
  },
  {
    type: 'String',
    addedEP: '285',
    added: 'FIX.Latest',
    name: 'AllocGroupSubQtyValue',
    id: 2981,
    abbrName: 'Val',
    description:
      'Value of the trade attribute defining a subgroup in an allocation group.',
  },
  {
    type: 'TimeUnitCodeSet',
    addedEP: '287',
    added: 'FIX.Latest',
    name: 'MaturityFrequencyUnit',
    id: 2982,
    abbrName: 'MatFreqUnit',
    description:
      'Time unit associated with the minimum frequency of the instrument maturity intervals.\n\nUsage note: When FlexibleIndicator(1244)=Y and the maturity date is user-defined, set MaturityFrequencyUnit(2982)=F (Flexible).',
  },
  {
    type: 'int',
    addedEP: '287',
    added: 'FIX.Latest',
    name: 'MaturityFrequencyPeriod',
    id: 2983,
    abbrName: 'MatFreqPeriod',
    description:
      'Time unit multiplier for the minimum frequency of the instrument maturity intervals.',
  },
  {
    type: 'TimeUnitCodeSet',
    addedEP: '287',
    added: 'FIX.Latest',
    name: 'UnderlyingMaturityFrequencyUnit',
    id: 2984,
    abbrName: 'MatFreqUnit',
    description:
      'Time unit associated with the minimum frequency of the instrument maturity intervals.\n\nUsage note: When UnderlyingFlexibleIndicator(2035)=Y and the underlying maturity is user-defined, set UnderlyingMaturityFrequencyUnit(2984)=F (Flexible).',
  },
  {
    type: 'int',
    addedEP: '287',
    added: 'FIX.Latest',
    name: 'UnderlyingMaturityFrequencyPeriod',
    id: 2985,
    abbrName: 'MatFreqPeriod',
    description:
      'Time unit multiplier for the minimum frequency of the instrument maturity intervals.',
  },
  {
    type: 'TimeUnitCodeSet',
    addedEP: '287',
    added: 'FIX.Latest',
    name: 'LegMaturityFrequencyUnit',
    id: 2986,
    abbrName: 'MatFreqUnit',
    description:
      'Time unit associated with the minimum frequency of the instrument maturity intervals.\n\nUsage note: When LegFlexibleIndicator(2202)=Y and the leg maturity is user-defined, set LegMaturityFrequencyUnit(2986)=F (Flexible).',
  },
  {
    type: 'int',
    addedEP: '287',
    added: 'FIX.Latest',
    name: 'LegMaturityFrequencyPeriod',
    id: 2987,
    abbrName: 'MatFreqPeriod',
    description:
      'Time unit multiplier for the minimum frequency of the instrument maturity intervals.',
  },
  {
    type: 'String',
    addedEP: '288',
    added: 'FIX.Latest',
    name: 'SecurityRiskMetricsReportID',
    id: 2988,
    abbrName: 'RptID',
    description: 'Unique identifier for the SecurityRiskMetricsReport(35=EG) message.',
  },
  {
    type: 'String',
    addedEP: '288',
    added: 'FIX.Latest',
    name: 'RiskMetricsSecurityGroup',
    id: 2989,
    abbrName: 'MtrcsSecGrp',
    description:
      'Describes a group of related instruments for which risk metrics are provided.',
  },
  {
    type: 'String',
    addedEP: '288',
    added: 'FIX.Latest',
    name: 'RiskMetricsSecuritySubGroup',
    id: 2990,
    abbrName: 'MtrcsSecSubGrp',
    description:
      'Describes a sub-group of a group identified by RiskMetricsSecurityGroup(2989).',
  },
  {
    type: 'MetricsCalculationPriceSourceCodeSet',
    addedEP: '288',
    added: 'FIX.Latest',
    name: 'MetricsCalculationPriceSource',
    id: 2993,
    abbrName: 'MtrcsCalcPxSrc',
    description:
      'Specifies the source of the price(s) of the security used in the calculation of the metrics or analytics data.',
  },
  {
    type: 'AssetValuationModelCodeSet',
    addedEP: '288',
    added: 'FIX.Latest',
    name: 'AssetValuationModel',
    id: 2994,
    abbrName: 'AssetValModel',
    description: 'Identifies the model used for asset valuation or pricing calculations.',
  },
  {
    type: 'NumInGroup',
    addedEP: '288',
    added: 'FIX.Latest',
    name: 'NoSecurityRiskMetrics',
    id: 2995,
    description: 'Number of instruments with security risk metrics data.',
  },
  {
    type: 'float',
    addedEP: '288',
    added: 'FIX.Latest',
    name: 'Gamma',
    id: 2996,
    abbrName: 'Gamma',
    description: 'The rate of change of Delta over time.',
  },
  {
    type: 'float',
    addedEP: '288',
    added: 'FIX.Latest',
    name: 'Rho',
    id: 2997,
    abbrName: 'Rho',
    description:
      "The security's value rate of change in response to a 1% change in (risk-free) interest rate. Measures the security's sensitivity to interest rate change.",
  },
  {
    type: 'float',
    addedEP: '288',
    added: 'FIX.Latest',
    name: 'Theta',
    id: 2998,
    abbrName: 'Theta',
    description:
      'The security\'s price rate of change in relation to passage of time. Also known as "time decay".',
  },
  {
    type: 'float',
    addedEP: '288',
    added: 'FIX.Latest',
    name: 'Vega',
    id: 2999,
    abbrName: 'Vega',
    description:
      "The security's price sensitivity to change in volatility of the underlying asset price.",
  },
  {
    type: 'Price',
    addedEP: '288',
    added: 'FIX.Latest',
    name: 'UnderlyingBidPx',
    id: 2991,
    abbrName: 'UndBidPx',
    description: 'Bid price of the underlying instrument.',
  },
  {
    type: 'Price',
    addedEP: '288',
    added: 'FIX.Latest',
    name: 'UnderlyingOfferPx',
    id: 2992,
    abbrName: 'UndOfrPx',
    description: 'Offer price of the underlying instrument.',
  },
  {
    type: 'UTCTimestamp',
    addedEP: '288',
    added: 'FIX.Latest',
    name: 'VolatilityTime',
    id: 3000,
    abbrName: 'VolTS',
    description: 'Time at which volatility was computed.',
  },
  {
    type: 'float',
    addedEP: '288',
    added: 'FIX.Latest',
    name: 'BidVolatility',
    id: 3001,
    abbrName: 'BidVol',
    description: 'Volatility based on bid prices.',
  },
  {
    type: 'float',
    addedEP: '288',
    added: 'FIX.Latest',
    name: 'OfferVolatility',
    id: 3002,
    abbrName: 'OfrVol',
    description: 'Volatility based on offer prices.',
  },
  {
    type: 'float',
    addedEP: '288',
    added: 'FIX.Latest',
    name: 'MidVolatility',
    id: 3003,
    abbrName: 'MidVol',
    description: 'Volatility based on mid prices.',
  },
  {
    type: 'UTCTimestamp',
    addedEP: '288',
    added: 'FIX.Latest',
    name: 'RelativeValueTimestamp',
    id: 3004,
    abbrName: 'TS',
    description:
      'Timestamp at which the relative valuation metric or analytic is calculated or captured.',
  },
  {
    type: 'NumInGroup',
    addedEP: '289',
    added: 'FIX.Latest',
    name: 'NoTradeTypes',
    id: 3005,
    description: 'Number of trade types in repeating group.',
  },
  {
    type: 'TrdTypeCodeSet',
    unionDataType: 'Reserved1000Plus',
    addedEP: '289',
    added: 'FIX.Latest',
    name: 'TradeType',
    id: 3006,
    abbrName: 'TrdTyp',
    description:
      'Type of trade assigned to a trade.\n\nNote: several enumerations of this field duplicate the enumerations in TradePriceCondition(1839) field. These may be deprecated from TradeType(3006) in the future. TradePriceCondition(1839) is preferred in messages that support it.',
  },
  {
    type: 'TrdSubTypeCodeSet',
    unionDataType: 'Reserved1000Plus',
    addedEP: '289',
    added: 'FIX.Latest',
    name: 'TradeSubType',
    id: 3007,
    abbrName: 'TrdSubTyp',
    description: 'Further qualification to the trade type defined in TradeType(3006).',
  },
  {
    type: 'NumInGroup',
    addedEP: '291',
    added: 'FIX.Latest',
    name: 'NoAllocTrdRegTimestamps',
    id: 3008,
    description: 'Number of allocation timestamps.',
  },
  {
    type: 'UTCTimestamp',
    addedEP: '291',
    added: 'FIX.Latest',
    name: 'AllocTrdRegTimestamp',
    id: 3009,
    abbrName: 'TS',
    description:
      'Same as TrdRegTimestamp(769). Used to provide relevant timestamp for the allocation account.',
  },
  {
    type: 'TrdRegTimestampTypeCodeSet',
    addedEP: '291',
    added: 'FIX.Latest',
    name: 'AllocTrdRegTimestampType',
    id: 3010,
    abbrName: 'Typ',
    description:
      'Same as TrdRegTimestampType(770). Used to indicate the timestamp type relevant for the allocation account.',
  },
  {
    type: 'String',
    addedEP: '291',
    added: 'FIX.Latest',
    name: 'AllocTrdRegTimestampSrc',
    id: 3011,
    abbrName: 'Src',
    description:
      'Same as TrdRegTimestampOrigin(771). Used to indicate the "origin" or source of the timestamp relevant for the allocation account.',
  },
  {
    type: 'String',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'AlgoCertificateID',
    id: 3012,
    abbrName: 'CertID',
    description:
      'Unique identifier for a certificate issued by an algorithmic trading firm.',
  },
  {
    type: 'String',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'AlgoCertificateDesc',
    id: 3013,
    abbrName: 'CertDesc',
    description: 'Description of a certificate issued by an algorithmic trading firm.',
  },
  {
    type: 'String',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'AlgoCertificateRequestID',
    id: 3014,
    abbrName: 'CertReqID',
    description: 'Unique identifier of the AlgoCertificateRequest(35=EH).',
  },
  {
    type: 'String',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'AlgoCertificateRequestRefID',
    id: 3015,
    abbrName: 'CertReqRefID',
    description: 'Reference identifier of the AlgoCertificateRequest(35=EH).',
  },
  {
    type: 'AlgoCertificateRequestTransTypeCodeSet',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'AlgoCertificateRequestTransType',
    id: 3016,
    abbrName: 'TxnTyp',
    description: 'Identifies the message transaction type.',
  },
  {
    type: 'AlgoCertificateRequestStatusCodeSet',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'AlgoCertificateRequestStatus',
    id: 3017,
    abbrName: 'ReqStat',
    description:
      'Status of the AlgoCertificateRequest(35=EH) message being responded to.',
  },
  {
    type: 'String',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'AlgoCertificateReportID',
    id: 3018,
    abbrName: 'CertRptID',
    description: 'Unique identifier of the AlgoCertificateReport(35=EJ).',
  },
  {
    type: 'String',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'AlgoCertificateReportRefID',
    id: 3019,
    abbrName: 'CertRptRefID',
    description: 'Reference identifier of the AlgoCertificateReport(35=EJ).',
  },
  {
    type: 'AlgoCertificateReportTransTypeCodeSet',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'AlgoCertificateReportTransType',
    id: 3020,
    abbrName: 'TxnTyp',
    description: 'Identifies the message transaction type.',
  },
  {
    type: 'AlgoCertificateReportStatusCodeSet',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'AlgoCertificateReportStatus',
    id: 3021,
    abbrName: 'RptStat',
    description: 'Status of the report being responded to.',
  },
  {
    type: 'AlgoCertificateStatusCodeSet',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'AlgoCertificateStatus',
    id: 3022,
    abbrName: 'CertStat',
    description: 'Status of the certification as provided by the regulatory authority.',
  },
  {
    type: 'UTCTimestamp',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'ApprovalTime',
    id: 3023,
    abbrName: 'AprvlTm',
    description: 'Date and time the details within the message have been approved.',
  },
  {
    type: 'String',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'AlgoTestDesc',
    id: 3024,
    abbrName: 'TstDesc',
    description: 'Description of means of testing for an algorithm.',
  },
  {
    type: 'NumInGroup',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'NoAlgoSystemModules',
    id: 3025,
    description: 'Number of components making up a system for algorithmic trading.',
  },
  {
    type: 'String',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'AlgoSystemModuleName',
    id: 3026,
    abbrName: 'Name',
    description: 'Name of the component of a system for algorithmic trading.',
  },
  {
    type: 'String',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'AlgoSystemModuleVersion',
    id: 3027,
    abbrName: 'Ver',
    description:
      'Version (e.g. build or commit number) of the component of a system for algorithmic trading.',
  },
  {
    type: 'NumInGroup',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'NoTestScenarios',
    id: 3028,
    description: 'Number of test scenarios for an algorithmic trading system.',
  },
  {
    type: 'String',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'TestScenarioID',
    id: 3029,
    abbrName: 'ID',
    description: 'Unique identifier of a test scenario for a software system.',
  },
  {
    type: 'TestSuiteStatusCodeSet',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'TestScenarioStatus',
    id: 3030,
    abbrName: 'Stat',
    description:
      'Identifies the overall result of a test scenario identified by TestScenarioID(3029).',
  },
  {
    type: 'UTCTimestamp',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'TestScenarioStartTime',
    id: 3031,
    abbrName: 'StartTm',
    description:
      'Starting date and time of test scenario execution for a software system.',
  },
  {
    type: 'UTCTimestamp',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'TestScenarioEndTime',
    id: 3032,
    abbrName: 'EndTm',
    description: 'Ending date and time of test scenario execution for a software system.',
  },
  {
    type: 'String',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'MDOriginDesc',
    id: 3033,
    abbrName: 'MDOrigDesc',
    description: 'Description of the origin of the market data.',
  },
  {
    type: 'UTCDateOnly',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'MDOriginDate',
    id: 3034,
    abbrName: 'MDOrigDt',
    description: 'Date of the market data.',
  },
  {
    type: 'String',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'TestStepGroupID',
    id: 3035,
    abbrName: 'StepGrpID',
    description:
      'Unique identifier for the group of test steps constituting a test scenario.',
  },
  {
    type: 'NumInGroup',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'NoTestSteps',
    id: 3036,
    description: 'Number of test steps.',
  },
  {
    type: 'String',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'TestStepID',
    id: 3037,
    abbrName: 'ID',
    description: 'Unique identifier of a test step.',
  },
  {
    type: 'String',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'TestStepDesc',
    id: 3038,
    abbrName: 'Desc',
    description: 'Description of a test step.',
  },
  {
    type: 'UTCTimestamp',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'TestStepStartTime',
    id: 3039,
    abbrName: 'StartTm',
    description: 'Starting time of a test step.',
  },
  {
    type: 'int',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'TestStepStartOffsetPeriod',
    id: 3040,
    abbrName: 'StartOfstPeriod',
    description:
      'Use for a starting time relative to TestScenarioStartTime(3031), i.e. the starting time of the test scenario. Required when TestStepStartOffsetUnit(3041) is specified.',
  },
  {
    type: 'OrderDelayUnitCodeSet',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'TestStepStartOffsetUnit',
    id: 3041,
    abbrName: 'StartOfstUnit',
    description:
      'Use for a starting time relative to TestScenarioStartTime(3031), i.e. the starting time of the test scenario. Required when TestStepStartOffsetPeriod(3040) is specified.',
  },
  {
    type: 'UTCTimestamp',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'TestStepEndTime',
    id: 3042,
    abbrName: 'EndTm',
    description: 'Ending time of a test step.',
  },
  {
    type: 'int',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'TestStepEndOffsetPeriod',
    id: 3043,
    abbrName: 'EndOfstPeriod',
    description:
      'Use for an ending time relative to TestStepStartTime(3039), i.e. the starting time of this test step. Required when TestStepEndOffsetUnit(3044) is specified.',
  },
  {
    type: 'OrderDelayUnitCodeSet',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'TestStepEndOffsetUnit',
    id: 3044,
    abbrName: 'EndOfstUnit',
    description:
      'Use for an ending time relative to TestStepStartTime(3039), i.e. the starting time of this test step. Required when TestStepEndOffsetPeriod(3043) is specified.',
  },
  {
    type: 'NumInGroup',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'NoTestStepParameters',
    id: 3045,
    description: 'Number of test step parameters.',
  },
  {
    type: 'String',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'TestStepParameterName',
    id: 3046,
    abbrName: 'PrmName',
    description: 'Name of the test step parameter.',
  },
  {
    type: 'StrategyParameterTypeCodeSet',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'TestStepParameterType',
    id: 3047,
    abbrName: 'PrmTyp',
    description: 'Datatype of the test step parameter.',
  },
  {
    type: 'String',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'TestStepParameterValue',
    id: 3048,
    abbrName: 'PrmVal',
    description: 'Value of the test step parameter.',
  },
  {
    type: 'NumInGroup',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'NoTestSystemModules',
    id: 3049,
    description: 'Number of components making up a testing system.',
  },
  {
    type: 'String',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'TestSystemModuleName',
    id: 3050,
    abbrName: 'Name',
    description: 'Name of the component of a testing system.',
  },
  {
    type: 'String',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'TestSystemModuleVersion',
    id: 3051,
    abbrName: 'Ver',
    description:
      'Version (e.g. build or commit number) of the component of a testing system.',
  },
  {
    type: 'NumInGroup',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'NoTestMeasures',
    id: 3052,
    description: 'Number of results for a test scenario.',
  },
  {
    type: 'String',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'TestMeasureName',
    id: 3053,
    abbrName: 'Name',
    description: 'Name of a test measure.',
  },
  {
    type: 'String',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'TestMeasureDesc',
    id: 3054,
    abbrName: 'Desc',
    description: 'Description of a test measure.',
  },
  {
    type: 'StrategyParameterTypeCodeSet',
    unionDataType: 'Reserved100Plus',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'TestMeasureType',
    id: 3055,
    abbrName: 'Typ',
    description: 'Datatype of the metric being used for a test.',
  },
  {
    type: 'int',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'TestMeasurePrecision',
    id: 3056,
    abbrName: 'Prcsn',
    description: 'Number of decimal places for TestMeasureType(3055).',
  },
  {
    type: 'TestSuiteStatusCodeSet',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'TestMeasureResult',
    id: 3057,
    abbrName: 'Rslt',
    description: 'Identifies the result of an individual test based on a measure.',
  },
  {
    type: 'TestThresholdTypeCodeSet',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'TestThresholdType',
    id: 3058,
    abbrName: 'ThresholdTyp',
    description:
      'Identifies whether the value of a measure needs to be over or under a specific threshold to be successful.',
  },
  {
    type: 'float',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'TestWarningLevelValue',
    id: 3059,
    abbrName: 'WarnLvlVal',
    description: 'Value of the measure upon which a warning is issued for the test.',
  },
  {
    type: 'float',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'TestFailLevelValue',
    id: 3060,
    abbrName: 'FailLvlVal',
    description: 'Value of the measure upon which the test is considered to have failed.',
  },
  {
    type: 'float',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'TestPeakLevelValue',
    id: 3061,
    abbrName: 'PeakLvlVal',
    description: 'Peak value of the measure achieved in testing.',
  },
  {
    type: 'String',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'TestSuiteRequestID',
    id: 3062,
    abbrName: 'TstSteReqID',
    description: 'Unique identifier of the TestSuiteDefinitionRequest(35=EL).',
  },
  {
    type: 'String',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'TestSuiteRequestRefID',
    id: 3063,
    abbrName: 'TstSteReqRefID',
    description: 'Reference identifier of the TestSuiteDefinitionRequest(35=EL).',
  },
  {
    type: 'TestSuiteRequestTransTypeCodeSet',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'TestSuiteRequestTransType',
    id: 3064,
    abbrName: 'TxnTyp',
    description: 'Identifies the message transaction type.',
  },
  {
    type: 'TestSuiteRequestStatusCodeSet',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'TestSuiteRequestStatus',
    id: 3065,
    abbrName: 'ReqStat',
    description:
      'Status of the TestSuiteDefinitionRequest(35=EL) message being responded to.',
  },
  {
    type: 'String',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'TestActionRequestID',
    id: 3066,
    abbrName: 'ReqID',
    description: 'Unique identifier of the TestActionRequest(35=EN).',
  },
  {
    type: 'TestActionTypeCodeSet',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'TestActionType',
    id: 3067,
    abbrName: 'ActnTyp',
    description:
      'Specifies the type of action to take or that was taken for a given test suite.',
  },
  {
    type: 'TestActionRequestStatusCodeSet',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'TestActionRequestStatus',
    id: 3068,
    abbrName: 'ReqStat',
    description: 'Status of the TestActionRequest(35=EN) message being responded to.',
  },
  {
    type: 'TestSuiteActivityStateCodeSet',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'TestSuiteActivityState',
    id: 3069,
    abbrName: 'TstSteActvtySt',
    description: 'Specifies the activity state the test suite is in.',
  },
  {
    type: 'TestSuiteStatusCodeSet',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'TestSuiteStatus',
    id: 3070,
    abbrName: 'TstSteStat',
    description:
      'Identifies the overall test result of a group of individual test scenarios.',
  },
  {
    type: 'String',
    addedEP: '292',
    added: 'FIX.Latest',
    name: 'TestActionReportID',
    id: 3071,
    abbrName: 'RptID',
    description: 'Identifier of the test action report.',
  },
];

export const FIELDS: ISpecFields[] = batch1.concat(
  batch2,
  batch3,
  batch4,
  batch5,
  batch6,
  batch7,
  batch8
);
